msgid ""
msgstr ""
"POT-Creation-Date: 2024-06-04 17:25-0300\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: es\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/features/gateAdministration/components/gateMovementBanner/LegacyMovementRow.tsx:26
msgid "!ATENCIÓN! La compuerta <0>{gateName}</0> ha comenzado a moverse"
msgstr "!ATENCIÓN! La compuerta <0>{gateName}</0> ha comenzado a moverse"

#: src/features/debtsAlert/components/DebtsAlertBanner.tsx:49
msgid "¡Acción requerida! Cuenta con saldo pendiente. Favor contactar al equipo comercial <0>aquí.</0>"
msgstr "¡Acción requerida! Cuenta con saldo pendiente. Favor contactar al equipo comercial <0>aquí.</0>"

#: src/features/debtsAlert/components/DebtsAlertBanner.tsx:35
msgid "¡Acción requerida! Esta cuenta en AMARU presenta un saldo pendiente. Para evitar limitaciones en el servicio, favor contáctenos al <0>+56 9 9226 1002</0> o enviar correo a <1>cs@captahydro.com</1>."
msgstr "¡Acción requerida! Esta cuenta en AMARU presenta un saldo pendiente. Para evitar limitaciones en el servicio, favor contáctenos al <0>+56 9 9226 1002</0> o enviar correo a <1>cs@captahydro.com</1>."

#: src/features/dga/components/modals/reports/TableModal.tsx:276
#: src/features/sma/components/TableModal.tsx:287
msgid "¡Comprobante copiado!"
msgstr "¡Comprobante copiado!"

#: src/features/reports2/components/versionSwitch/FormPopup.tsx:66
msgid "¡Gracias por tu opinión!"
msgstr "¡Gracias por tu opinión!"

#: src/features/api/components/dialogs/GeneratedUserApiSummary.tsx:16
msgid "¡La credencial ha sido creado con éxito!"
msgstr "¡La credencial ha sido creado con éxito!"

#: src/features/dgaTicket/components/DgaTicketModal.tsx:288
msgid "¿Cambiar el código del ticket?"
msgstr "¿Cambiar el código del ticket?"

#: src/features/dgaTicket/components/DgaTicketModal.tsx:311
msgid "¿Cerrar el ticket {ticketCode}?"
msgstr "¿Cerrar el ticket {ticketCode}?"

#: src/features/metricsViews/components/MetricsView.tsx:545
msgid "¿Descartar los cambios del tablero?"
msgstr "¿Descartar los cambios del tablero?"

#: src/fsd/pages/dashboards/ui/discard-dialog.tsx:25
msgid "¿Descartar los cambios?"
msgstr "¿Descartar los cambios?"

#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:129
msgid "¿Desea generar la periodicidad de su reporte?"
msgstr "¿Desea generar la periodicidad de su reporte?"

#: src/features/dga/components/modals/MassiveDGARetryModal.tsx:71
msgid "¿Desea iniciar el reintento masivo de todos los registros fallidos?"
msgstr "¿Desea iniciar el reintento masivo de todos los registros fallidos?"

#: src/features/userProfileUpdate/components/DisableUserModal.tsx:63
msgid "¿Deseas deshabilitar el usuario {userId}?"
msgstr "¿Deseas deshabilitar el usuario {userId}?"

#: src/features/reports2/components/DownloadReportTemplateModal.tsx:51
msgid "¿Deseas generar el reporte <0>\"{templateName}\"</0>?"
msgstr "¿Deseas generar el reporte <0>\"{templateName}\"</0>?"

#: src/features/announcements/components/AnnouncementsDeleteModal.tsx:72
msgid "¿Eliminar Anuncio?"
msgstr "¿Eliminar Anuncio?"

#: src/features/notifications/components/NotificationsDeleteModal.tsx:71
msgid "¿Eliminar notificación?"
msgstr "¿Eliminar notificación?"

#: src/features/createDevice/components/form/index.tsx:51
msgid "¿Es un dispositivo de integración?"
msgstr "¿Es un dispositivo de integración?"

#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:83
msgid "¿Está <0>seguro</0> que quiere eliminar la credencial con el nombre de usuario <1>{0}</1> de la API?"
msgstr "¿Está <0>seguro</0> que quiere eliminar la credencial con el nombre de usuario <1>{0}</1> de la API?"

#: src/features/devicesAnalysis/components/DeviceOperationalStateMenu.tsx:75
msgid "¿Está seguro que desea cambiar el estado operacional del dispositivo?"
msgstr "¿Está seguro que desea cambiar el estado operacional del dispositivo?"

#: src/features/dga/components/modals/MassiveDGARetryModal.tsx:81
msgid "¿Está seguro que desea continuar?"
msgstr "¿Está seguro que desea continuar?"

#: src/features/gateAdministration/components/DeleteRequestModal.tsx:24
msgid "¿Está seguro que desea eliminar la solicitud de movimiento?"
msgstr "¿Está seguro que desea eliminar la solicitud de movimiento?"

#: src/features/alertsConfigurationV2/components/DeleteAlertConfirmationDialog.tsx:53
msgid "¿Está seguro que desea eliminar todas las configuraciones de alerta para el dispositivo <0>{deviceName}</0>(ID: {deviceId})?"
msgstr "¿Está seguro que desea eliminar todas las configuraciones de alerta para el dispositivo <0>{deviceName}</0>(ID: {deviceId})?"

#: src/features/reports/components/creationSection/CreateReportDialog.tsx:135
msgid "¿Está seguro que quiere crear un nuevo reporte?"
msgstr "¿Está seguro que quiere crear un nuevo reporte?"

#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:117
msgid "¿Está seguro que quiere eliminar esta programación?"
msgstr "¿Está seguro que quiere eliminar esta programación?"

#: src/features/api/components/dialogs/DisableApiUserDialog.tsx:80
msgid "¿Estás <0>seguro</0> que deseas deshabilitar la credencial con el nombre de usuario <1>{0}</1> de la API?"
msgstr "¿Estás <0>seguro</0> que deseas deshabilitar la credencial con el nombre de usuario <1>{0}</1> de la API?"

#: src/features/api/components/dialogs/SoftDeleteApiUserDialog.tsx:83
msgid "¿Estás <0>seguro</0> que deseas eliminar la credencial con el nombre de usuario <1>{0}</1> de la API?"
msgstr "¿Estás <0>seguro</0> que deseas eliminar la credencial con el nombre de usuario <1>{0}</1> de la API?"

#: src/features/api/components/dialogs/EnableApiUserDialog.tsx:83
msgid "¿Estás <0>seguro</0> que deseas habilitar la credencial del usuario <1>{0}</1> de la API?"
msgstr "¿Estás <0>seguro</0> que deseas habilitar la credencial del usuario <1>{0}</1> de la API?"

#: src/features/standardDesign/components/accessRelationManager/AccessRelationManagerModal.tsx:285
msgid "¿Estás seguro de que deseas cambiar el rol de <0>{0}</0> a <1>{1}</1>?"
msgstr "¿Estás seguro de que deseas cambiar el rol de <0>{0}</0> a <1>{1}</1>?"

#: src/components/modal/ConfirmationModal.tsx:35
msgid "¿Estás seguro de que deseas continuar?"
msgstr "¿Estás seguro de que deseas continuar?"

#: src/features/alertsConfigurationV3/components/AlertSummaryCard.tsx:205
msgid "¿Estás seguro de que deseas eliminar la alerta \"{0}\"? Esta acción no se puede deshacer."
msgstr "¿Estás seguro de que deseas eliminar la alerta \"{0}\"? Esta acción no se puede deshacer."

#: src/features/moveGateModal/components/MoveGateModal.tsx:112
msgid "¿Estás seguro de que deseas mover la compuerta desde <0>{0}</0> a <1>{1}</1>?"
msgstr "¿Estás seguro de que deseas mover la compuerta desde <0>{0}</0> a <1>{1}</1>?"

#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:460
msgid "¿Estás seguro de que deseas mover la compuerta desde <0>{from}</0> a <1>{to}</1>?"
msgstr "¿Estás seguro de que deseas mover la compuerta desde <0>{from}</0> a <1>{to}</1>?"

#: src/features/deviceConfiguration/components/DeleteDeviceConfiguration.tsx:66
msgid "¿Estás seguro de que quieres borrar la configuración de este equipo?"
msgstr "¿Estás seguro de que quieres borrar la configuración de este equipo?"

#: src/features/api/components/dialogs/EditApiUserDialog.tsx:114
msgid "¿Estás seguro que deseas actualizar estos permisos?"
msgstr "¿Estás seguro que deseas actualizar estos permisos?"

#: src/components/modal/ConfirmationModal.tsx:40
msgid "¿Estás seguro que deseas cambiar de pestaña?"
msgstr "¿Estás seguro que deseas cambiar de pestaña?"

#: src/components/modal/ConfirmationModal.tsx:46
msgid "¿Estás seguro que deseas cerrar el formulario?"
msgstr "¿Estás seguro que deseas cerrar el formulario?"

#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:115
msgid "¿Estás seguro que deseas crear un nuevo usuario temporal?"
msgstr "¿Estás seguro que deseas crear un nuevo usuario temporal?"

#: src/features/deviceAlertsModal/components/disableAlertsModal/index.tsx:65
msgid "¿Estás seguro que deseas desactivar las alertas para el dispositivo con id <0><1>{0}</1></0>?"
msgstr "¿Estás seguro que deseas desactivar las alertas para el dispositivo con id <0><1>{0}</1></0>?"

#: src/features/dga/components/modals/DisableDGAConfigurationModal.tsx:28
msgid "¿Estás seguro que deseas desactivar los envíos DGA para el dispositivo {deviceId}?"
msgstr "¿Estás seguro que deseas desactivar los envíos DGA para el dispositivo {deviceId}?"

#: src/features/devicesGraveyard/components/RestoreDeviceModal.tsx:51
msgid "¿Estás seguro que deseas desarchivar el dispositivo?"
msgstr "¿Estás seguro que deseas desarchivar el dispositivo?"

#: src/features/usersGraveyard/components/RestoreUserModal.tsx:61
msgid "¿Estás seguro que deseas desarchivar este usuario?"
msgstr "¿Estás seguro que deseas desarchivar este usuario?"

#: src/features/users/components/modals/DeleteUserModal.tsx:69
msgid "¿Estás seguro que deseas eliminar al usuario con id <0>{userId}</0>?"
msgstr "¿Estás seguro que deseas eliminar al usuario con id <0>{userId}</0>?"

#: src/features/reports2/components/DeleteReportTemplateModal.tsx:49
msgid "¿Estás seguro que deseas eliminar el reporte recurrente <0>\"{templateName}\"</0>?"
msgstr "¿Estás seguro que deseas eliminar el reporte recurrente <0>\"{templateName}\"</0>?"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/DeleteCurveModal.tsx:30
msgid "¿Estás seguro que deseas eliminar esta curva de aforo?"
msgstr "¿Estás seguro que deseas eliminar esta curva de aforo?"

#: src/features/deviceCommands/components/calendar/DeleteScheduleCommandKeyDialog.tsx:60
msgid "¿Estás seguro que deseas eliminar este comando programado para el día {commandDate} a las {commandTime}?"
msgstr "¿Estás seguro que deseas eliminar este comando programado para el día {commandDate} a las {commandTime}?"

#: src/features/collections/components/modals/DeleteCollectionModal.tsx:100
msgid "¿Estás seguro que deseas eliminar la colección <0>{0}</0>? Esta acción no se puede deshacer."
msgstr "¿Estás seguro que deseas eliminar la colección <0>{0}</0>? Esta acción no se puede deshacer."

#: src/features/reports/components/templateSection/DeleteReportTemplateDialog.tsx:55
msgid "¿Estás seguro que deseas eliminar la configuración de reporte <0>\"{0}\"</0>?"
msgstr "¿Estás seguro que deseas eliminar la configuración de reporte <0>\"{0}\"</0>?"

#: src/features/dga/components/modals/DeleteDGAConfigurationModal.tsx:76
msgid "¿Estás seguro que deseas eliminar la configuración DGA para el dispositivo {deviceId}?"
msgstr "¿Estás seguro que deseas eliminar la configuración DGA para el dispositivo {deviceId}?"

#: src/features/deviceObservations/components/modals/DeleteObservationModal.tsx:80
msgid "¿Estás seguro que deseas eliminar la siguiente observación?"
msgstr "¿Estás seguro que deseas eliminar la siguiente observación?"

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:141
msgid "¿Estás seguro que deseas realizar esta acción?"
msgstr "¿Estás seguro que deseas realizar esta acción?"

#: src/features/users/components/modals/SimulateUserModal.tsx:71
msgid "¿Estás seguro que deseas simular al usuario <0>{fullName}</0>?"
msgstr "¿Estás seguro que deseas simular al usuario <0>{fullName}</0>?"

#: src/features/homeAmaru/hooks/useDeleteMyCollection.tsx:44
msgid "¿Estás seguro que quieres eliminar la colección \"{0}\"? Esta acción no se puede deshacer."
msgstr "¿Estás seguro que quieres eliminar la colección \"{0}\"? Esta acción no se puede deshacer."

#: src/features/resendCredentialsModal/components/ResendCredentialsModal.tsx:72
msgid "¿Generar y enviar nuevas credenciales de acceso? La contraseña actual dejará de funcionar inmediatamente."
msgstr "¿Generar y enviar nuevas credenciales de acceso? La contraseña actual dejará de funcionar inmediatamente."

#: src/fsd/pages/dashboards/ui/save-loss-dialog.tsx:56
msgid "¿Guardar los ajustes del layout?"
msgstr "¿Guardar los ajustes del layout?"

#: src/fsd/pages/dashboards/ui/save-loss-dialog.tsx:54
msgid "¿Guardar y descartar lo que no se puede mostrar?"
msgstr "¿Guardar y descartar lo que no se puede mostrar?"

#: src/pages/authentication/index.tsx:102
msgid "¿Olvidaste tu contraseña?"
msgstr "¿Olvidaste tu contraseña?"

#: src/features/users/components/modals/ExtendTemporaryUserModal.tsx:73
msgid "¿Por cuánto tiempo deseas extender la duración del usuario?"
msgstr "¿Por cuánto tiempo deseas extender la duración del usuario?"

#: src/features/reports2/components/versionSwitch/FeedbackDialog.tsx:86
msgid "¿Por qué volviste a la versión anterior?"
msgstr "¿Por qué volviste a la versión anterior?"

#: src/features/controlCenter2/components/versionSwitch/FeedbackDialog.tsx:67
msgid "¿Por qué volviste al clásico?"
msgstr "¿Por qué volviste al clásico?"

#: src/features/deviceCommands/components/standard/DebugModeInformation.tsx:45
msgid "¿Qué significa Debug/Aforo?"
msgstr "¿Qué significa Debug/Aforo?"

#: src/features/metricsViews/components/MetricsView.tsx:533
msgid "¿Salir sin guardar el tablero?"
msgstr "¿Salir sin guardar el tablero?"

#: src/fsd/pages/dashboards/ui/leave-dialog.tsx:27
msgid "¿Salir sin guardar?"
msgstr "¿Salir sin guardar?"

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:59
msgid "«{name}» agregado como copia de «{source}»."
msgstr "«{name}» agregado como copia de «{source}»."

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:48
msgid "«{name}» agregado."
msgstr "«{name}» agregado."

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:80
msgid "«{name}» eliminado."
msgstr "«{name}» eliminado."

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:87
msgid "«{name}» en {where}."
msgstr "«{name}» en {where}."

#: src/fsd/pages/dashboards/ui/size-fix-strip/size-fix-strip.tsx:33
msgid "«{name}» es más chico que el tamaño sugerido para su tipo; el más cercano es {size}."
msgstr "«{name}» es más chico que el tamaño sugerido para su tipo; el más cercano es {size}."

#: src/fsd/pages/dashboards/ui/size-fix-strip/size-fix-strip.tsx:38
msgid "«{name}» es más grande que el tamaño sugerido para su tipo; el más cercano es {size}."
msgstr "«{name}» es más grande que el tamaño sugerido para su tipo; el más cercano es {size}."

#: src/fsd/pages/dashboards/ui/dashboard-editor-page.tsx:460
#: src/fsd/pages/dashboards/ui/keyboard/use-board-keys.ts:153
msgid "«{name}» está fijo: no se puede mover."
msgstr "«{name}» está fijo: no se puede mover."

#: src/fsd/pages/dashboards/ui/keyboard/use-board-keys.ts:154
msgid "«{name}» está fijo: no se puede redimensionar."
msgstr "«{name}» está fijo: no se puede redimensionar."

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:113
msgid "«{name}» fijado en su lugar."
msgstr "«{name}» fijado en su lugar."

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:101
msgid "«{name}» no puede tener ese tamaño."
msgstr "«{name}» no puede tener ese tamaño."

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:97
msgid "«{name}» no se puede mover hacia ahí."
msgstr "«{name}» no se puede mover hacia ahí."

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:60
msgid "«{name}» pedía una unidad que no aplica: usa la de la estación."
msgstr "«{name}» pedía una unidad que no aplica: usa la de la estación."

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:120
msgid "«{name}» se muestra siempre."
msgstr "«{name}» se muestra siempre."

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:119
msgid "«{name}» se muestra solo en escritorio."
msgstr "«{name}» se muestra solo en escritorio."

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:42
msgid "«{name}» seleccionado."
msgstr "«{name}» seleccionado."

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:114
msgid "«{name}» ya no está fijo."
msgstr "«{name}» ya no está fijo."

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:107
msgid "«{name}»: {w} × {h}, fuera del tamaño sugerido."
msgstr "«{name}»: {w} × {h}, fuera del tamaño sugerido."

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:108
msgid "«{name}»: {w} × {h}."
msgstr "«{name}»: {w} × {h}."

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:67
msgid "«{name}»: se omitieron {count} series sin dispositivo o sin métrica."
msgstr "«{name}»: se omitieron {count} series sin dispositivo o sin métrica."

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:66
msgid "«{name}»: se omitió una serie sin dispositivo o sin métrica."
msgstr "«{name}»: se omitió una serie sin dispositivo o sin métrica."

#: src/fsd/app/locale/au-labels.ts:103
msgid "«Hasta» tiene que ser posterior a «Desde»."
msgstr "«Hasta» tiene que ser posterior a «Desde»."

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:193
msgid "«Solo escritorio» lo oculta en pantallas angostas, como la de un teléfono."
msgstr "«Solo escritorio» lo oculta en pantallas angostas, como la de un teléfono."

#: src/features/collectionsAccessInputs/components/CollectionsListItem.tsx:89
msgid "(compartida)"
msgstr "(compartida)"

#: src/features/access/components/devicesTab/DevicesListItem.tsx:111
#: src/features/access/components/organizationsTab/OrganizationsListItem.tsx:52
#: src/features/access/components/usersTab/UsersListItem.tsx:120
#: src/features/collectionsAccessInputs/components/CollectionsListItem.tsx:95
#: src/features/deviceProfile/components/page/Observations.tsx:79
#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:353
msgid "(editado)"
msgstr "(editado)"

#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:89
msgid "(Este paso NO puede ser anulado)"
msgstr "(Este paso NO puede ser anulado)"

#: src/features/metricsViews/components/MetricsViewList.tsx:202
msgid "(maestro)"
msgstr "(maestro)"

#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:167
msgid "{0, plural, one {# cambio} other {# cambios}}"
msgstr "{0, plural, one {# cambio} other {# cambios}}"

#: src/features/controlCenter2/components/legend/RenderLegendItem.tsx:20
msgid "{0, plural, one {# dispositivo} other {# dispositivos}}"
msgstr "{0, plural, one {# dispositivo} other {# dispositivos}}"

#: src/features/reports2/components/createModal/steps/step1/MetricsInput.tsx:281
#: src/features/reports2/components/createModal/steps/step1/MultipleCheckbox.tsx:75
msgid "{0, plural, one {# seleccionado} other {# seleccionados}}"
msgstr "{0, plural, one {# seleccionado} other {# seleccionados}}"

#: src/fsd/pages/dashboards/ui/board-header/board-switcher.tsx:132
msgid "{0, plural, one {# tablero} other {# tableros}}"
msgstr "{0, plural, one {# tablero} other {# tableros}}"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:69
msgid "{0, plural, one {# widget} other {# widgets}}"
msgstr "{0, plural, one {# widget} other {# widgets}}"

#: src/fsd/pages/dashboards/ui/schematic/widget-schematic.tsx:50
msgid "{0, plural, one {+# dispositivo} other {+# dispositivos}}"
msgstr "{0, plural, one {+# dispositivo} other {+# dispositivos}}"

#: src/features/userActivityLogs/components/Heatmap.tsx:67
msgid "{0, plural, one {1 acceso} other {# accesos}}"
msgstr "{0, plural, one {1 acceso} other {# accesos}}"

#: src/features/reports2/components/createModal/steps/step5/ReportSummary.tsx:111
msgid "{0, plural, one {1 destinatario} other {# destinatarios}}"
msgstr "{0, plural, one {1 destinatario} other {# destinatarios}}"

#: src/features/reports2/components/createModal/steps/step5/ReportSummary.tsx:60
msgid "{0, plural, one {1 dispositivo} other {# dispositivos}}"
msgstr "{0, plural, one {1 dispositivo} other {# dispositivos}}"

#: src/features/alertsNotificationsHistory/components/Filters.tsx:167
msgid "{0, plural, one {1 Dispositivo} other {# Dispositivos}}"
msgstr "{0, plural, one {1 Dispositivo} other {# Dispositivos}}"

#: src/features/reports2/components/createModal/steps/step5/ReportSummary.tsx:65
msgid "{0, plural, one {1 métrica} other {# métricas}}"
msgstr "{0, plural, one {1 métrica} other {# métricas}}"

#: src/features/alertsNotificationsHistory/components/Filters.tsx:146
msgid "{0, plural, one {1 Organización} other {# Organizaciones}}"
msgstr "{0, plural, one {1 Organización} other {# Organizaciones}}"

#: src/features/alertsNotificationsHistory/components/Filters.tsx:186
msgid "{0, plural, one {1 Usuario} other {# Usuarios}}"
msgstr "{0, plural, one {1 Usuario} other {# Usuarios}}"

#: src/features/audit/components/AuditLogParagraphDetails.tsx:182
msgid "{0, plural, one {Al <0>usuario de ID {userId} </0>se le cambió el acceso sobre el <1>dispositivo de ID {1}</1>} other {Al <2>usuario de ID {userId} </2>se le cambió el acceso sobre los dispositivos de{2}}}"
msgstr "{0, plural, one {Al <0>usuario de ID {userId} </0>se le cambió el acceso sobre el <1>dispositivo de ID {1}</1>} other {Al <2>usuario de ID {userId} </2>se le cambió el acceso sobre los dispositivos de{2}}}"

#: src/features/audit/components/AuditLogParagraphDetails.tsx:208
msgid "{0, plural, one {Al <0>usuario de ID {userId} </0>se le denegó el acceso sobre el <1>dispositivo de ID {1}</1>} other {Al <2>usuario de ID {userId} </2>se le denegó el acceso sobre los dispositivos de{2}}}"
msgstr "{0, plural, one {Al <0>usuario de ID {userId} </0>se le denegó el acceso sobre el <1>dispositivo de ID {1}</1>} other {Al <2>usuario de ID {userId} </2>se le denegó el acceso sobre los dispositivos de{2}}}"

#: src/features/audit/components/AuditLogParagraphDetails.tsx:234
msgid "{0, plural, one {Al <0>usuario de ID {userId} </0>se le otorgó acceso sobre el <1>dispositivo de ID {1}</1>} other {Al <2>usuario de ID {userId} </2>se le denegó acceso sobre los dispositivos de{2}}}"
msgstr "{0, plural, one {Al <0>usuario de ID {userId} </0>se le otorgó acceso sobre el <1>dispositivo de ID {1}</1>} other {Al <2>usuario de ID {userId} </2>se le denegó acceso sobre los dispositivos de{2}}}"

#: src/fsd/pages/dashboards/ui/dashboard-editor-page.tsx:422
msgid "{0, plural, one {falta subir la imagen de {names}} other {falta subir las imágenes de {names}}}"
msgstr "{0, plural, one {falta subir la imagen de {names}} other {falta subir las imágenes de {names}}}"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:198
msgid "{0, plural, one {Quita # widget respecto del borrador: revisa en el lienzo que no falte ninguno antes de aplicar.} other {Quita # widgets respecto del borrador: revisa en el lienzo que no falte ninguno antes de aplicar.}}"
msgstr "{0, plural, one {Quita # widget respecto del borrador: revisa en el lienzo que no falte ninguno antes de aplicar.} other {Quita # widgets respecto del borrador: revisa en el lienzo que no falte ninguno antes de aplicar.}}"

#: src/features/audit/components/AuditLogParagraphDetails.tsx:72
msgid "{0, plural, one {Se cambió el acceso sobre el <0>dispositivo con ID {deviceId} </0>al usuario de <1>ID {1}</1>} other {Se cambió el acceso sobre el <2>dispositivo con ID {deviceId} </2> a los usuarios de {2}}}"
msgstr "{0, plural, one {Se cambió el acceso sobre el <0>dispositivo con ID {deviceId} </0>al usuario de <1>ID {1}</1>} other {Se cambió el acceso sobre el <2>dispositivo con ID {deviceId} </2> a los usuarios de {2}}}"

#: src/features/audit/components/AuditLogParagraphDetails.tsx:97
msgid "{0, plural, one {Se denegó acceso sobre el <0>dispositivo <1/> ID {deviceId}</0> al usuario de <2>ID {1} </2>} other {Se denegó acceso sobre el <3>dispositivo de ID {deviceId} </3> a los usuarios de {2}}}"
msgstr "{0, plural, one {Se denegó acceso sobre el <0>dispositivo <1/> ID {deviceId}</0> al usuario de <2>ID {1} </2>} other {Se denegó acceso sobre el <3>dispositivo de ID {deviceId} </3> a los usuarios de {2}}}"

#: src/features/audit/components/AuditLogParagraphDetails.tsx:124
msgid "{0, plural, one {Se otorgó acceso sobre el <0>dispositivo de ID {deviceId} </0>al usuario de <1>ID {1} </1>} other {Se otorgó acceso sobre el <2>dispositivo de ID {deviceId} </2> a los usuarios de {2}}}"
msgstr "{0, plural, one {Se otorgó acceso sobre el <0>dispositivo de ID {deviceId} </0>al usuario de <1>ID {1} </1>} other {Se otorgó acceso sobre el <2>dispositivo de ID {deviceId} </2> a los usuarios de {2}}}"

#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:148
msgid "{0, plural, one {Un dispositivo que quitas lo usan widgets del tablero: quita primero esos widgets.} other {Dispositivos que quitas los usan widgets del tablero: quita primero esos widgets.}}"
msgstr "{0, plural, one {Un dispositivo que quitas lo usan widgets del tablero: quita primero esos widgets.} other {Dispositivos que quitas los usan widgets del tablero: quita primero esos widgets.}}"

#: src/features/reports/components/ReportHistory.tsx:185
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:73
#: src/features/reports2/components/reportHistoryModal/ReportHistory.tsx:192
msgid "{0, plural, zero {No hay dispositivos} one {# dispositivo} other {# dispositivos}}"
msgstr "{0, plural, zero {No hay dispositivos} one {# dispositivo} other {# dispositivos}}"

#: src/features/reports/components/ReportHistory.tsx:193
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:81
#: src/features/reports2/components/reportHistoryModal/ReportHistory.tsx:200
msgid "{0, plural, zero {No hay métricas} one {# métrica} other {# métricas}}"
msgstr "{0, plural, zero {No hay métricas} one {# métrica} other {# métricas}}"

#: src/features/integrations/components/groupedIssuesModal/index.tsx:39
#: src/features/metricsViews/components/widgets/gateOperate/CurrentPosition.tsx:35
msgid "{0}"
msgstr "{0}"

#: src/features/metricsViews/components/widgets/activeAlerts/index.tsx:153
msgid "{0} alertas activas en este tablero"
msgstr "{0} alertas activas en este tablero"

#: src/features/alertsConfigurationV3/components/wizard/steps/MetricStep.tsx:128
msgid "{0} alertas configuradas para {label}"
msgstr "{0} alertas configuradas para {label}"

#: src/features/alertsConfigurationV3/components/AlertsConfigurationV3.tsx:92
#: src/features/alertsConfigurationV3/components/AlertsConfigurationV3.tsx:142
#: src/features/metricsViews/components/MetricsViewList.tsx:209
#: src/features/metricsViews/components/MetricsViewToolbar.legacy.tsx:145
#: src/features/metricsViews/components/MetricsViewToolbar.tsx:232
msgid "{0} dispositivos"
msgstr "{0} dispositivos"

#: src/features/audit/components/AuditLogsTimeline.tsx:237
#: src/features/userProfile/components/UserProfileAuditLogs.tsx:86
msgid "{0} en"
msgstr "{0} en"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:80
#: src/features/notifications/components/Notifications.tsx:189
msgid "{0} usuarios"
msgstr "{0} usuarios"

#: src/features/metricsViews/components/AssociateCollectionModal.tsx:260
msgid "{0} widgets quedan fuera de la lista"
msgstr "{0} widgets quedan fuera de la lista"

#: src/features/billing/components/table/DevicesTable.tsx:194
msgid "{0} y {1} más"
msgstr "{0} y {1} más"

#: src/components/TablePaginationActions.tsx:72
#: src/components/TablePaginationActions.tsx:118
msgid "{0}-{1} de {count}"
msgstr "{0}-{1} de {count}"

#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:174
msgid "{0}: {1}"
msgstr "{0}: {1}"

#: src/features/userActivityLogs/components/UserActivityLogsModal.tsx:70
msgid "{accessLast30Days, plural, one {1 acceso} other {# accesos}}"
msgstr "{accessLast30Days, plural, one {1 acceso} other {# accesos}}"

#: src/features/homeAmaru/components/shared/CollectionRow.tsx:79
msgid "{activeAlertCount} alertas activas"
msgstr "{activeAlertCount} alertas activas"

#: src/fsd/pages/dashboards/ui/change-bar/summarize-diff.ts:14
msgid "{added, plural, one {# nuevo} other {# nuevos}}"
msgstr "{added, plural, one {# nuevo} other {# nuevos}}"

#: src/features/changeOperationalState/components/AfterUpdateTasksModal.tsx:190
msgid "{alertsCount, plural, one {Hay # configuración activa} other {Hay # configuraciones activas}}"
msgstr "{alertsCount, plural, one {Hay # configuración activa} other {Hay # configuraciones activas}}"

#: src/fsd/entities/dashboard-widget/ui/format/period-text.ts:13
msgid "{amount, plural, one {Última hora} other {Últimas # h}}"
msgstr "{amount, plural, one {Última hora} other {Últimas # h}}"

#: src/fsd/entities/dashboard-widget/ui/format/period-text.ts:19
msgid "{amount, plural, one {Último año} other {Últimos # años}}"
msgstr "{amount, plural, one {Último año} other {Últimos # años}}"

#: src/fsd/entities/dashboard-widget/ui/format/period-text.ts:15
msgid "{amount, plural, one {Último día} other {Últimos # días}}"
msgstr "{amount, plural, one {Último día} other {Últimos # días}}"

#: src/fsd/entities/dashboard-widget/ui/format/period-text.ts:17
msgid "{amount, plural, one {Último mes} other {Últimos # meses}}"
msgstr "{amount, plural, one {Último mes} other {Últimos # meses}}"

#: src/fsd/entities/dashboard-widget/ui/format/period-text.ts:11
msgid "{amount, plural, one {Último minuto} other {Últimos # min}}"
msgstr "{amount, plural, one {Último minuto} other {Últimos # min}}"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:74
msgid "{changes, plural, one {# cambio} other {# cambios}}"
msgstr "{changes, plural, one {# cambio} other {# cambios}}"

#: src/fsd/pages/dashboards/ui/leave-dialog.tsx:29
msgid "{changes, plural, one {Hay cambios sin guardar en # widget. Si sales, se pierden.} other {Hay cambios sin guardar en # widgets. Si sales, se pierden.}}"
msgstr "{changes, plural, one {Hay cambios sin guardar en # widget. Si sales, se pierden.} other {Hay cambios sin guardar en # widgets. Si sales, se pierden.}}"

#: src/fsd/pages/dashboards/ui/discard-dialog.tsx:27
msgid "{changes, plural, one {Se pierden los cambios de # widget y el tablero vuelve a como está guardado.} other {Se pierden los cambios de # widgets y el tablero vuelve a como está guardado.}}"
msgstr "{changes, plural, one {Se pierden los cambios de # widget y el tablero vuelve a como está guardado.} other {Se pierden los cambios de # widgets y el tablero vuelve a como está guardado.}}"

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:64
msgid "{count, plural, one {# copia agregada.} other {# copias agregadas.}}"
msgstr "{count, plural, one {# copia agregada.} other {# copias agregadas.}}"

#: src/fsd/entities/dashboard-widget/ui/device-select/device-multi-select.tsx:42
msgid "{count, plural, one {# dispositivo elegido} other {# dispositivos elegidos}}"
msgstr "{count, plural, one {# dispositivo elegido} other {# dispositivos elegidos}}"

#: src/features/controlCenter/components/ControlCenterLegend.tsx:106
msgid "{count, plural, one {# dispositivo} other {# dispositivos}}"
msgstr "{count, plural, one {# dispositivo} other {# dispositivos}}"

#: src/fsd/pages/gate-movements/ui/panel/events/movement-events.tsx:122
msgid "{count, plural, one {# mensaje} other {# mensajes}}"
msgstr "{count, plural, one {# mensaje} other {# mensajes}}"

#: src/features/gateOperationModal/components/panelNotification/NotificationCard.tsx:219
#: src/fsd/features/gate-movements/ui/operation/feed/feed-card.tsx:147
#: src/fsd/pages/gate-movements/ui/panel/events/event-card.tsx:158
msgid "{count, plural, one {# reporte} other {# reportes}}"
msgstr "{count, plural, one {# reporte} other {# reportes}}"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-view.tsx:178
msgid "{count, plural, one {# serie sin eje: {units}} other {# series sin eje: {units}}}"
msgstr "{count, plural, one {# serie sin eje: {units}} other {# series sin eje: {units}}}"

#: src/fsd/pages/dashboards/ui/keyboard/use-clipboard.ts:70
msgid "{count, plural, one {# widget copiado.} other {# widgets copiados.}}"
msgstr "{count, plural, one {# widget copiado.} other {# widgets copiados.}}"

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:92
msgid "{count, plural, one {# widget movido.} other {# widgets movidos.}}"
msgstr "{count, plural, one {# widget movido.} other {# widgets movidos.}}"

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:53
msgid "{count, plural, one {# widget pegado.} other {# widgets pegados.}}"
msgstr "{count, plural, one {# widget pegado.} other {# widgets pegados.}}"

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:72
msgid "{count, plural, one {# widget venía sin ubicación: va al final con su tamaño por defecto.} other {# widgets venían sin ubicación: van al final con su tamaño por defecto.}}"
msgstr "{count, plural, one {# widget venía sin ubicación: va al final con su tamaño por defecto.} other {# widgets venían sin ubicación: van al final con su tamaño por defecto.}}"

#: src/features/standardDesign/components/autocomplete/StandardAutocompleteIds.tsx:148
msgid "{count, plural, one {Anuncio} other {Anuncios}}"
msgstr "{count, plural, one {Anuncio} other {Anuncios}}"

#: src/features/standardDesign/components/autocomplete/StandardAutocomplete.tsx:57
#: src/features/standardDesign/components/autocomplete/StandardAutocompleteIds.tsx:99
msgid "{count, plural, one {Dispositivo} other {Dispositivos}}"
msgstr "{count, plural, one {Dispositivo} other {Dispositivos}}"

#: src/fsd/pages/dashboards/ui/layout-warnings/layout-warnings-banner.tsx:39
msgid "{count, plural, one {El layout guardado tiene # diferencia con lo que se muestra} other {El layout guardado tiene # diferencias con lo que se muestra}}"
msgstr "{count, plural, one {El layout guardado tiene # diferencia con lo que se muestra} other {El layout guardado tiene # diferencias con lo que se muestra}}"

#: src/features/standardDesign/components/autocomplete/StandardAutocompleteIds.tsx:155
msgid "{count, plural, one {Integración} other {Integraciones}}"
msgstr "{count, plural, one {Integración} other {Integraciones}}"

#: src/features/standardDesign/components/autocomplete/StandardAutocompleteIds.tsx:134
msgid "{count, plural, one {Moneda} other {Monedas}}"
msgstr "{count, plural, one {Moneda} other {Monedas}}"

#: src/features/standardDesign/components/autocomplete/StandardAutocomplete.tsx:64
#: src/features/standardDesign/components/autocomplete/StandardAutocompleteIds.tsx:106
msgid "{count, plural, one {Organización} other {Organizaciones}}"
msgstr "{count, plural, one {Organización} other {Organizaciones}}"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:256
msgid "{count, plural, one {Propuesta aplicada: # widget. «Deshacer» la revierte.} other {Propuesta aplicada: # widgets. «Deshacer» la revierte.}}"
msgstr "{count, plural, one {Propuesta aplicada: # widget. «Deshacer» la revierte.} other {Propuesta aplicada: # widgets. «Deshacer» la revierte.}}"

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:70
msgid "{count, plural, one {Propuesta aplicada: el tablero queda con # widget.} other {Propuesta aplicada: el tablero queda con # widgets.}}"
msgstr "{count, plural, one {Propuesta aplicada: el tablero queda con # widget.} other {Propuesta aplicada: el tablero queda con # widgets.}}"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:181
msgid "{count, plural, one {Propuesta: # widget} other {Propuesta: # widgets}}"
msgstr "{count, plural, one {Propuesta: # widget} other {Propuesta: # widgets}}"

#: src/features/standardDesign/components/autocomplete/StandardAutocompleteIds.tsx:127
msgid "{count, plural, one {Proyecto} other {Proyectos}}"
msgstr "{count, plural, one {Proyecto} other {Proyectos}}"

#: src/features/standardDesign/components/autocomplete/StandardAutocompleteIds.tsx:113
msgid "{count, plural, one {Red de canales} other {Redes de canales}}"
msgstr "{count, plural, one {Red de canales} other {Redes de canales}}"

#: src/features/standardDesign/components/autocomplete/StandardAutocompleteIds.tsx:141
msgid "{count, plural, one {Servicio} other {Servicios}}"
msgstr "{count, plural, one {Servicio} other {Servicios}}"

#: src/features/standardDesign/components/autocomplete/StandardAutocomplete.tsx:71
#: src/features/standardDesign/components/autocomplete/StandardAutocompleteIds.tsx:120
msgid "{count, plural, one {Usuario} other {Usuarios}}"
msgstr "{count, plural, one {Usuario} other {Usuarios}}"

#: src/fsd/pages/dashboards/ui/assistant/proposal-preview-strip.tsx:11
msgid "{count, plural, one {Vista previa de la propuesta del asistente (# widget): todavía no está en el borrador. Aplícala o descártala desde el panel.} other {Vista previa de la propuesta del asistente (# widgets): todavía no está en el borrador. Aplícala o descártala desde el panel.}}"
msgstr "{count, plural, one {Vista previa de la propuesta del asistente (# widget): todavía no está en el borrador. Aplícala o descártala desde el panel.} other {Vista previa de la propuesta del asistente (# widgets): todavía no está en el borrador. Aplícala o descártala desde el panel.}}"

#: src/features/alertsConfigurationV3/components/ConfigureAlertGrid.tsx:70
msgid "{count} configuraciones para {label}"
msgstr "{count} configuraciones para {label}"

#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:265
msgid "{count} Destinatarios"
msgstr "{count} Destinatarios"

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:82
msgid "{count} widgets eliminados."
msgstr "{count} widgets eliminados."

#: src/fsd/pages/dashboards/ui/panel/multi-scope.tsx:42
msgid "{count} widgets seleccionados"
msgstr "{count} widgets seleccionados"

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:44
msgid "{count} widgets seleccionados."
msgstr "{count} widgets seleccionados."

#: src/fsd/pages/dga-reports/ui/device-row.tsx:164
msgid "{date} — Falló a las {hours}"
msgstr "{date} — Falló a las {hours}"

#: src/fsd/pages/dga-reports/ui/latest-reports.tsx:221
msgid "{date} · Ejecución: {execution}"
msgstr "{date} · Ejecución: {execution}"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:99
#: src/features/deviceProfile/components/page/DGAInfo.tsx:106
msgid "{days} días"
msgstr "{days} días"

#: src/features/changeOperationalState/components/AfterUpdateTasksModal.tsx:107
msgid "{description}"
msgstr "{description}"

#: src/fsd/pages/dashboards/ui/board-header/board-header.tsx:56
msgid "{devices, plural, one {# dispositivo} other {# dispositivos}}"
msgstr "{devices, plural, one {# dispositivo} other {# dispositivos}}"

#: src/utils/devices/formatSourceColor.ts:35
msgid "{deviceSource} del ({deviceSourceInfo})"
msgstr "{deviceSource} del ({deviceSourceInfo})"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:189
msgid "{draftCount, plural, =0 {El borrador está vacío: la propuesta lo llena. El lienzo la muestra antes de aplicar y «Deshacer» la revierte.} one {Reemplaza el widget del borrador. El lienzo la muestra antes de aplicar y «Deshacer» la revierte.} other {Reemplaza los # widgets del borrador. El lienzo la muestra antes de aplicar y «Deshacer» la revierte.}}"
msgstr "{draftCount, plural, =0 {El borrador está vacío: la propuesta lo llena. El lienzo la muestra antes de aplicar y «Deshacer» la revierte.} one {Reemplaza el widget del borrador. El lienzo la muestra antes de aplicar y «Deshacer» la revierte.} other {Reemplaza los # widgets del borrador. El lienzo la muestra antes de aplicar y «Deshacer» la revierte.}}"

#: src/fsd/pages/dashboards/ui/change-bar/summarize-diff.ts:21
msgid "{edited, plural, one {# editado} other {# editados}}"
msgstr "{edited, plural, one {# editado} other {# editados}}"

#: src/fsd/features/gate-movements/ui/history/history-table.tsx:226
msgid "{first}–{last} de {totalCount}"
msgstr "{first}–{last} de {totalCount}"

#: src/fsd/pages/dga-reports/ui/list-pagination.tsx:32
msgid "{from}–{to} de {totalCount}"
msgstr "{from}–{to} de {totalCount}"

#: src/fsd/pages/dashboards/ui/layout-warnings/layout-warnings-banner.tsx:51
msgid "{hidden, plural, one {# entrada guardada no se puede mostrar.} other {# entradas guardadas no se pueden mostrar.}}"
msgstr "{hidden, plural, one {# entrada guardada no se puede mostrar.} other {# entradas guardadas no se pueden mostrar.}}"

#: src/features/integrations/components/devicesList/index.tsx:146
msgid "{label}"
msgstr "{label}"

#: src/features/devices2/components/list/itemPanel/deviceItemInfo/PostProcessedIndicator.tsx:43
msgid "{label} — {0}% de: {ids}"
msgstr "{label} — {0}% de: {ids}"

#: src/features/alertsConfigurationV3/components/ChannelBadge.tsx:86
msgid "{label} — sin destinatarios"
msgstr "{label} — sin destinatarios"

#: src/features/devices2/components/list/itemPanel/deviceItemInfo/PostProcessedIndicator.tsx:41
msgid "{label} basado en: {ids}"
msgstr "{label} basado en: {ids}"

#: src/features/devices2/components/list/itemPanel/deviceItemInfo/PostProcessedIndicator.tsx:38
msgid "{label} calculado — suma de: {ids}"
msgstr "{label} calculado — suma de: {ids}"

#: src/features/devices2/components/list/itemPanel/deviceItemInfo/PostProcessedIndicator.tsx:45
msgid "{label} calculado a partir de: {ids}"
msgstr "{label} calculado a partir de: {ids}"

#: src/fsd/app/locale/au-labels.ts:88
msgid "{label}, seleccionado"
msgstr "{label}, seleccionado"

#: src/features/alertsConfiguration/components/AlertRow.tsx:90
msgid "{line}"
msgstr "{line}"

#: src/features/sma/utils/echartOptions.ts:17
msgid "{marker} {dateString}: <b>En reintento</b>"
msgstr "{marker} {dateString}: <b>En reintento</b>"

#: src/features/sma/utils/echartOptions.ts:15
msgid "{marker} {dateString}: <b>Publicado</>"
msgstr "{marker} {dateString}: <b>Publicado</>"

#: src/fsd/pages/dashboards/ui/change-bar/summarize-diff.ts:16
msgid "{moved, plural, one {# movido} other {# movidos}}"
msgstr "{moved, plural, one {# movido} other {# movidos}}"

#: src/fsd/pages/dashboards/ui/change-bar/view-menu.tsx:80
msgid "{n, plural, one {Se quita # widget del borrador. Se puede deshacer, y nada se guarda hasta que lo confirmes en la barra de cambios.} other {Se quitan los # widgets del borrador. Se puede deshacer, y nada se guarda hasta que lo confirmes en la barra de cambios.}}"
msgstr "{n, plural, one {Se quita # widget del borrador. Se puede deshacer, y nada se guarda hasta que lo confirmes en la barra de cambios.} other {Se quitan los # widgets del borrador. Se puede deshacer, y nada se guarda hasta que lo confirmes en la barra de cambios.}}"

#: src/fsd/pages/dashboards/ui/keyboard/use-board-keys.ts:190
msgid "{name} (copia)"
msgstr "{name} (copia)"

#: src/fsd/pages/dashboards/ui/canvas/canvas.tsx:411
msgid "{name}, editar"
msgstr "{name}, editar"

#: src/fsd/pages/dashboards/ui/canvas/canvas.tsx:409
msgid "{name}, fijo, editar"
msgstr "{name}, fijo, editar"

#: src/fsd/pages/dashboards/ui/canvas/canvas.tsx:408
msgid "{name}, fijo, solo escritorio, editar"
msgstr "{name}, fijo, solo escritorio, editar"

#: src/fsd/pages/dashboards/ui/canvas/canvas.tsx:410
msgid "{name}, solo escritorio, editar"
msgstr "{name}, solo escritorio, editar"

#: src/fsd/pages/dga-reports/ui/reports-heatmap.tsx:255
msgid "{name}: <0>{value}</0>"
msgstr "{name}: <0>{value}</0>"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:115
msgid "{percent}% vs hace {window}"
msgstr "{percent}% vs hace {window}"

#: src/fsd/pages/dashboards/ui/change-bar/summarize-diff.ts:15
msgid "{removed, plural, one {# eliminado} other {# eliminados}}"
msgstr "{removed, plural, one {# eliminado} other {# eliminados}}"

#: src/fsd/pages/dashboards/ui/change-bar/summarize-diff.ts:19
msgid "{resized, plural, one {# redimensionado} other {# redimensionados}}"
msgstr "{resized, plural, one {# redimensionado} other {# redimensionados}}"

#: src/fsd/pages/dashboards/ui/dashboard-editor-page.tsx:560
#: src/fsd/pages/dashboards/ui/dashboard-editor-page.tsx:771
msgid "{source} (copia)"
msgstr "{source} (copia)"

#: src/fsd/entities/dashboard-widget/ui/data/data-view.tsx:116
msgid "{STALE_AFTER_HOURS, plural, one {La última lectura tiene más de # hora.} other {La última lectura tiene más de # horas.}}"
msgstr "{STALE_AFTER_HOURS, plural, one {La última lectura tiene más de # hora.} other {La última lectura tiene más de # horas.}}"

#: src/features/metricsViews/components/widgets/gateOperate/index.tsx:58
msgid "{title}"
msgstr "{title}"

#: src/fsd/pages/dga-reports/ui/device-list-header.tsx:17
msgid "{totalCount, plural, one {# dispositivo} other {# dispositivos}}"
msgstr "{totalCount, plural, one {# dispositivo} other {# dispositivos}}"

#: src/features/alertsConfigurationV3/components/ConfigureAlertGrid.tsx:43
msgid "{unconfiguredCount} parámetros disponibles"
msgstr "{unconfiguredCount} parámetros disponibles"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:445
msgid "{usersNumber, plural, one {El usuario {users} recibió un <0>mensaje</0> por <1>{notificationType}</1>} other {Los usuarios {users} {0, plural, one {} other {y <2># más</2>}} recibieron un <3>mensaje</3> por <4>{notificationType}</4>}}"
msgstr "{usersNumber, plural, one {El usuario {users} recibió un <0>mensaje</0> por <1>{notificationType}</1>} other {Los usuarios {users} {0, plural, one {} other {y <2># más</2>}} recibieron un <3>mensaje</3> por <4>{notificationType}</4>}}"

#: src/fsd/pages/dga-reports/ui/reports-heatmap.tsx:169
msgid "{validated} validados, {awaiting} esperando validación, {pending} pendientes y {failed} fallidos"
msgstr "{validated} validados, {awaiting} esperando validación, {pending} pendientes y {failed} fallidos"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:38
msgid "{value, plural, one {# año} other {# años}}"
msgstr "{value, plural, one {# año} other {# años}}"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:32
msgid "{value, plural, one {# día} other {# días}}"
msgstr "{value, plural, one {# día} other {# días}}"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:30
msgid "{value, plural, one {# hora} other {# horas}}"
msgstr "{value, plural, one {# hora} other {# horas}}"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:36
msgid "{value, plural, one {# mes} other {# meses}}"
msgstr "{value, plural, one {# mes} other {# meses}}"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:28
msgid "{value, plural, one {# minuto} other {# minutos}}"
msgstr "{value, plural, one {# minuto} other {# minutos}}"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:26
msgid "{value, plural, one {# segundo} other {# segundos}}"
msgstr "{value, plural, one {# segundo} other {# segundos}}"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:34
msgid "{value, plural, one {# semana} other {# semanas}}"
msgstr "{value, plural, one {# semana} other {# semanas}}"

#: src/features/deviceProfile/components/page/events/EventsChart.tsx:69
msgid "{value} eventos"
msgstr "{value} eventos"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:75
msgid "{value}a"
msgstr "{value}a"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:69
msgid "{value}d"
msgstr "{value}d"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:67
msgid "{value}h"
msgstr "{value}h"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:73
msgid "{value}mes"
msgstr "{value}mes"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:65
msgid "{value}min"
msgstr "{value}min"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:63
msgid "{value}s"
msgstr "{value}s"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:71
msgid "{value}sem"
msgstr "{value}sem"

#: src/features/billing/components/payments/PaymentSummary.tsx:135
msgid "* Está editando el registro de pago creado por"
msgstr "* Está editando el registro de pago creado por"

#: src/fsd/shared/ui/format/units.ts:190
#: src/utils/units.ts:247
msgid "%"
msgstr "%"

#: src/features/homeAmaru/components/HomeAmaru.tsx:259
msgid "% Cumplimiento DGA"
msgstr "% Cumplimiento DGA"

#: src/features/homeAmaru/components/shared/DgaComplianceSection.tsx:15
msgid "% CUMPLIMIENTO DGA"
msgstr "% CUMPLIMIENTO DGA"

#: src/fsd/shared/ui/format/units.ts:180
#: src/utils/units.ts:237
msgid "°"
msgstr "°"

#: src/fsd/shared/ui/format/units.ts:240
#: src/utils/units.ts:297
msgid "°C"
msgstr "°C"

#: src/fsd/shared/ui/format/units.ts:245
#: src/utils/units.ts:302
msgid "°F"
msgstr "°F"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:234
msgid "← → una columna, ↑ ↓ una fila; + y − solo cambian el ancho"
msgstr "← → una columna, ↑ ↓ una fila; + y − solo cambian el ancho"

#: src/features/reports/components/creationSection/CreateReportsSection.tsx:32
msgid "+ SOLICITAR REPORTE"
msgstr "+ SOLICITAR REPORTE"

#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:172
msgid "<0>¡PRECAUCIÓN!</0> Activar esto causará que los datos del dispositivo se guarden como 0."
msgstr "<0>¡PRECAUCIÓN!</0> Activar esto causará que los datos del dispositivo se guarden como 0."

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts-help.tsx:36
msgid "<0>?</0> abre esta ayuda · <1>Esc</1> la cierra"
msgstr "<0>?</0> abre esta ayuda · <1>Esc</1> la cierra"

#: src/features/access/components/organizationsTab/OrganizationDevicesAndUsersList.tsx:78
msgid "<0>{0}</0> dispositivos con acceso"
msgstr "<0>{0}</0> dispositivos con acceso"

#: src/features/access/components/organizationsTab/OrganizationDevicesAndUsersList.tsx:119
#: src/features/deviceAccessModal/components/allAccessTab/index.tsx:83
msgid "<0>{0}</0> usuarios con acceso"
msgstr "<0>{0}</0> usuarios con acceso"

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:297
msgid "<0>{0}</0> usuarios seleccionados de <1>{1}</1>"
msgstr "<0>{0}</0> usuarios seleccionados de <1>{1}</1>"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:474
msgid "<0>{usersNumber}</0> usuarios recibieron un <1>mensaje</1> por <2>{notificationType}</2>:"
msgstr "<0>{usersNumber}</0> usuarios recibieron un <1>mensaje</1> por <2>{notificationType}</2>:"

#: src/features/devicesAccessInputs/components/UsersAccessForDeviceInput.tsx:171
msgid "<0>{withAccessNumber}</0> usuarios con acceso de <1>{totalNumber}</1>"
msgstr "<0>{withAccessNumber}</0> usuarios con acceso de <1>{totalNumber}</1>"

#: src/features/dga/components/modals/DGAReportsRetryModal.tsx:88
msgid "<0>El envío de datos no se realiza de forma inmediata y puede presentar demoras, dependiendo de la cantidad de envíos pendientes y la disponibilidad del servicio.</0><1>¿Quieres reintentar la publicación de todos los reportes fallidos del </1><2><3>dispositivo con id {deviceId}</3></2>?"
msgstr "<0>El envío de datos no se realiza de forma inmediata y puede presentar demoras, dependiendo de la cantidad de envíos pendientes y la disponibilidad del servicio.</0><1>¿Quieres reintentar la publicación de todos los reportes fallidos del </1><2><3>dispositivo con id {deviceId}</3></2>?"

#: src/features/api/components/APIMainText.tsx:16
msgid "<0>En Capta Hydro tenemos ahora disponible nuestra API para hacer consultas y escrituras a sus dispositivos sin tener que hacer uso de Amaru. Entre las funcionalidades que tiene disponible son:</0><1><2>Chequear sus equipos disponibles</2><3>Consultar datos de sus equipos</3><4>Escribir datos de nivel y/o caudal en dispositivos</4></1><5>Para poder utilizar de manera correcta la API, vaya a la sección de <6>documentacion</6></5>"
msgstr "<0>En Capta Hydro tenemos ahora disponible nuestra API para hacer consultas y escrituras a sus dispositivos sin tener que hacer uso de Amaru. Entre las funcionalidades que tiene disponible son:</0><1><2>Chequear sus equipos disponibles</2><3>Consultar datos de sus equipos</3><4>Escribir datos de nivel y/o caudal en dispositivos</4></1><5>Para poder utilizar de manera correcta la API, vaya a la sección de <6>documentacion</6></5>"

#: src/features/api/components/dialogs/ResendApiCredentialsDialog.tsx:120
msgid "<0>Importante:</0> se genera una contraseña nueva, así que la contraseña actual dejará de funcionar. Cualquier integración que la esté usando se va a cortar hasta que se actualice con la nueva."
msgstr "<0>Importante:</0> se genera una contraseña nueva, así que la contraseña actual dejará de funcionar. Cualquier integración que la esté usando se va a cortar hasta que se actualice con la nueva."

#: src/features/gateCommon/utils/gateMovementState.tsx:221
msgid "<0>Inicio de operación</0> de la compuerta"
msgstr "<0>Inicio de operación</0> de la compuerta"

#: src/features/api/components/dialogs/GenerateApiUserDialog.tsx:103
msgid "<0>Nota:</0> La credencial generada solo va a tener permisos de lectura de dispositivos. Para los permisos de escritura comuniquese con el equipo de Capta Hydro."
msgstr "<0>Nota:</0> La credencial generada solo va a tener permisos de lectura de dispositivos. Para los permisos de escritura comuniquese con el equipo de Capta Hydro."

#: src/features/api/components/mainMenu/MainMenuApiCapta.tsx:46
msgid "<0>Para los clientes, ahora tenemos disponible nuestra API que permite hacer consultas y escrituras a los dispositivos en que son dueños. Entre las funcionalidades que tienen disponibles son:</0><1><2>Chequear sus equipos disponibles</2><3>Consultar datos de sus equipos</3><4>Escribir datos de nivel y/o caudal en dispositivos</4></1><5>En esta sección podrás obtener toda la información para dar soporte al cliente con respecto a la API</5>"
msgstr "<0>Para los clientes, ahora tenemos disponible nuestra API que permite hacer consultas y escrituras a los dispositivos en que son dueños. Entre las funcionalidades que tienen disponibles son:</0><1><2>Chequear sus equipos disponibles</2><3>Consultar datos de sus equipos</3><4>Escribir datos de nivel y/o caudal en dispositivos</4></1><5>En esta sección podrás obtener toda la información para dar soporte al cliente con respecto a la API</5>"

#: src/features/metricsViews/components/widgets/activeAlerts/index.tsx:151
msgid "1 alerta activa en este tablero"
msgstr "1 alerta activa en este tablero"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:33
#: src/features/controlCenter/slices/controlCenterSlice.ts:21
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:49
#: src/features/metricsViews/components/MetricsViewToolbar.legacy.tsx:73
#: src/features/metricsViews/components/MetricsViewToolbar.tsx:133
#: src/features/reports/utils/meanWindowOptions.ts:43
#: src/features/reports2/utils/meanWindowOptions.ts:43
msgid "1 día"
msgstr "1 día"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:13
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarPollingInterval.tsx:31
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:46
#: src/features/metricsViews/components/MetricsViewToolbar.legacy.tsx:61
#: src/features/metricsViews/components/MetricsViewToolbar.tsx:121
#: src/features/reports/utils/meanWindowOptions.ts:31
#: src/features/reports2/utils/meanWindowOptions.ts:31
msgid "1 hora"
msgstr "1 hora"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:53
msgid "1 mes"
msgstr "1 mes"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarPollingInterval.tsx:15
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:41
#: src/features/metricsViews/components/MetricsViewToolbar.legacy.tsx:41
#: src/features/metricsViews/components/MetricsViewToolbar.tsx:101
#: src/features/reports/utils/meanWindowOptions.ts:11
#: src/features/reports2/utils/meanWindowOptions.ts:11
msgid "1 minuto"
msgstr "1 minuto"

#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:43
#: src/features/metricsViews/components/MetricsViewToolbar.legacy.tsx:49
#: src/features/metricsViews/components/MetricsViewToolbar.tsx:109
#: src/features/reports/utils/meanWindowOptions.ts:19
#: src/features/reports2/utils/meanWindowOptions.ts:19
msgid "10 minutos"
msgstr "10 minutos"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:28
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:48
#: src/features/metricsViews/components/MetricsViewToolbar.legacy.tsx:69
#: src/features/metricsViews/components/MetricsViewToolbar.tsx:129
#: src/features/reports/utils/meanWindowOptions.ts:39
#: src/features/reports2/utils/meanWindowOptions.ts:39
#: src/features/userPreferences/components/RegionTab.tsx:254
msgid "12 horas"
msgstr "12 horas"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:48
msgid "15 días"
msgstr "15 días"

#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:44
#: src/features/metricsViews/components/MetricsViewToolbar.legacy.tsx:53
#: src/features/metricsViews/components/MetricsViewToolbar.tsx:113
#: src/features/reports/utils/meanWindowOptions.ts:23
#: src/features/reports2/utils/meanWindowOptions.ts:23
msgid "15 minutos"
msgstr "15 minutos"

#: src/features/userPreferences/components/RegionTab.tsx:278
msgid "2 dígitos"
msgstr "2 dígitos"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarPollingInterval.tsx:19
msgid "2 minutos"
msgstr "2 minutos"

#: src/features/userPreferences/components/RegionTab.tsx:254
msgid "24 horas"
msgstr "24 horas"

#: src/features/users/components/UsersTable.tsx:86
msgid "2FA"
msgstr "2FA"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:38
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:50
#: src/features/metricsViews/components/MetricsViewToolbar.legacy.tsx:77
#: src/features/metricsViews/components/MetricsViewToolbar.tsx:137
#: src/features/reports/utils/meanWindowOptions.ts:47
#: src/features/reports2/utils/meanWindowOptions.ts:47
msgid "3 días"
msgstr "3 días"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:18
msgid "3 horas"
msgstr "3 horas"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarPollingInterval.tsx:27
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:45
#: src/features/metricsViews/components/MetricsViewToolbar.legacy.tsx:57
#: src/features/metricsViews/components/MetricsViewToolbar.tsx:117
#: src/features/reports/utils/meanWindowOptions.ts:27
#: src/features/reports2/utils/meanWindowOptions.ts:27
msgid "30 minutos"
msgstr "30 minutos"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarPollingInterval.tsx:23
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:42
#: src/features/metricsViews/components/MetricsViewToolbar.legacy.tsx:45
#: src/features/metricsViews/components/MetricsViewToolbar.tsx:105
#: src/features/reports/utils/meanWindowOptions.ts:15
#: src/features/reports2/utils/meanWindowOptions.ts:15
msgid "5 minutos"
msgstr "5 minutos"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:23
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:47
#: src/features/metricsViews/components/MetricsViewToolbar.legacy.tsx:65
#: src/features/metricsViews/components/MetricsViewToolbar.tsx:125
#: src/features/reports/utils/meanWindowOptions.ts:35
#: src/features/reports2/utils/meanWindowOptions.ts:35
msgid "6 horas"
msgstr "6 horas"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:43
msgid "7 días"
msgstr "7 días"

#: src/fsd/shared/ui/format/units.ts:195
#: src/utils/units.ts:252
msgid "A"
msgstr "A"

#: src/features/api/components/ApiKeysList.tsx:26
msgid "A continuación se encuentran las API Keys de cada una de nuestros clientes:"
msgstr "A continuación se encuentran las API Keys de cada una de nuestros clientes:"

#: src/features/api/components/CaptaApiUsersList.tsx:79
msgid "A continuación se encuentran las credenciales de API de todas las organizaciones. Usted puede, crear, editar, eliminar, habilitar y deshabilitar, las credenciales de API de cada una de estas."
msgstr "A continuación se encuentran las credenciales de API de todas las organizaciones. Usted puede, crear, editar, eliminar, habilitar y deshabilitar, las credenciales de API de cada una de estas."

#: src/features/api/components/ApiUsersList.tsx:48
msgid "A continuación se encuentran las credenciales de API que su organización ha creado:"
msgstr "A continuación se encuentran las credenciales de API que su organización ha creado:"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:307
msgid "a las"
msgstr "a las"

#: src/fsd/pages/widget-catalog/ui/preview.tsx:105
msgid "A mano"
msgstr "A mano"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:402
#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:74
msgid "Abajo"
msgstr "Abajo"

#: src/features/gateAdministration/components/index.tsx:434
msgid "Abertura compuerta: {0}"
msgstr "Abertura compuerta: {0}"

#: src/features/controlCenter/utils/minicharts.ts:207
#: src/features/devicesAnalysis/components/panel/Chart.tsx:314
#: src/features/gateAdministration/components/GatePositionChart.tsx:133
#: src/features/gates/components/list/GateListItemMetrics.tsx:52
msgid "Abertura de compuerta"
msgstr "Abertura de compuerta"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleFormula.tsx:11
msgid "abertura de la compuerta (en cm)"
msgstr "abertura de la compuerta (en cm)"

#: src/features/gates/components/list/GateListItemLastMovement.tsx:63
msgid "Abertura final"
msgstr "Abertura final"

#: src/features/gates/components/list/GateListItemLastMovement.tsx:59
msgid "Abertura inicial"
msgstr "Abertura inicial"

#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:67
msgid "Abertura máxima"
msgstr "Abertura máxima"

#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:54
msgid "Abertura mínima"
msgstr "Abertura mínima"

#: src/features/gates/components/list/GateListItemLastMovement.tsx:52
msgid "Abertura solicitada"
msgstr "Abertura solicitada"

#: src/fsd/entities/dashboard-widget/ui/dga-tickets/dga-tickets-view.tsx:226
msgid "Abiertos ahora"
msgstr "Abiertos ahora"

#: src/features/deviceConfiguration/components/TriggerConfigUpdateModal.tsx:30
msgid "Abortado"
msgstr "Abortado"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:24
msgid "Abril"
msgstr "Abril"

#: src/fsd/pages/widget-catalog/ui/side-panel.tsx:59
msgid "Abrir el panel: {label}"
msgstr "Abrir el panel: {label}"

#: src/fsd/pages/dashboards/ui/panel/panel.tsx:85
msgid "Abrir el panel: {modeLabel}"
msgstr "Abrir el panel: {modeLabel}"

#: src/features/deviceProfile/components/page/General.tsx:91
msgid "Abrir en Google Maps"
msgstr "Abrir en Google Maps"

#: src/features/notifications/components/NotificationMessageViewModal.tsx:98
msgid "Abrir enlace"
msgstr "Abrir enlace"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:141
msgid "Abrir esta ayuda"
msgstr "Abrir esta ayuda"

#: src/features/controlCenter/components/window/DeviceListItem.tsx:202
#: src/features/controlCenter2/components/devicesList/ListItem.tsx:257
msgid "Abrir gráfico"
msgstr "Abrir gráfico"

#: src/features/gateAdministration/components/index.tsx:538
msgid "Abrir gráfico avanzado"
msgstr "Abrir gráfico avanzado"

#: src/features/gateAdministration/components/MovementHistory.tsx:42
msgid "Abrir historial completo"
msgstr "Abrir historial completo"

#: src/components/SectionTitleWithInfo.tsx:57
msgid "Abrir información de sección"
msgstr "Abrir información de sección"

#: src/fsd/app/locale/au-labels.ts:40
msgid "Abrir lista"
msgstr "Abrir lista"

#: src/features/controlCenter2/components/ControlCenter.tsx:120
msgid "Abrir listado de dispositivos"
msgstr "Abrir listado de dispositivos"

#: src/features/controlCenter/components/window/Window.tsx:266
msgid "Abrir menú de opciones"
msgstr "Abrir menú de opciones"

#: src/components/tooltips/DeviceTooltip.tsx:57
#: src/components/tooltips/UserTooltip.tsx:61
#: src/features/devicesGraveyard/components/DevicesGraveyard.tsx:235
#: src/features/updateMultipleDevicesTags/components/UpdateMultipleDevicesTagsModal.tsx:304
#: src/features/users/components/tableCells/UserPictureCell.tsx:59
msgid "Abrir perfil"
msgstr "Abrir perfil"

#: src/features/collections/components/CollectionsTable.tsx:200
#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:145
#: src/features/homeAmaru/components/shared/CollectionRow.tsx:85
msgid "Abrir tablero"
msgstr "Abrir tablero"

#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:136
msgid "Abrir tablero operacional"
msgstr "Abrir tablero operacional"

#: src/features/dgaTicket/components/DgaTicketModal.tsx:205
msgid "Abrir ticket"
msgstr "Abrir ticket"

#: src/features/controlCenter/components/window/Window.tsx:73
msgid "Abrir ventana de dispositivos"
msgstr "Abrir ventana de dispositivos"

#: src/fsd/shared/ui/format/units.ts:117
#: src/utils/units.ts:174
msgid "ac-ft"
msgstr "ac-ft"

#: src/fsd/shared/ui/format/units.ts:58
#: src/utils/units.ts:115
msgid "ac-ft/s"
msgstr "ac-ft/s"

#: src/fsd/shared/ui/format/units.ts:122
#: src/utils/units.ts:179
msgid "ac-in"
msgstr "ac-in"

#: src/features/users/utils/filterOptions.ts:129
msgid "Accedió los últimos 30 días"
msgstr "Accedió los últimos 30 días"

#: src/features/users/utils/filterOptions.ts:124
msgid "Accedió los últimos 7 días"
msgstr "Accedió los últimos 7 días"

#: src/features/audit/utils/parseProperty.ts:121
msgid "acceso"
msgstr "acceso"

#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:280
msgid "Acceso"
msgstr "Acceso"

#: src/features/access/components/usersTab/UsersTab.tsx:114
msgid "Acceso a dispositivos para usuario {selectedUserId}"
msgstr "Acceso a dispositivos para usuario {selectedUserId}"

#: src/features/dga/components/modals/DgaOrganizationAccessWarning.tsx:33
msgid "Acceso a sección Reportes DGA habilitado para la organización"
msgstr "Acceso a sección Reportes DGA habilitado para la organización"

#: src/features/access/components/devicesTab/DevicesTab.tsx:115
msgid "Acceso de usuarios para <0><1>dispositivo {selectedDeviceId}</1></0>"
msgstr "Acceso de usuarios para <0><1>dispositivo {selectedDeviceId}</1></0>"

#: src/features/deviceAccessModal/components/index.tsx:117
#: src/features/userConfigurationModal/components/index.tsx:116
msgid "Acceso directo"
msgstr "Acceso directo"

#: src/features/deviceAccessModal/components/index.tsx:107
#: src/features/userConfigurationModal/components/index.tsx:106
msgid "Acceso por colección"
msgstr "Acceso por colección"

#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:25
msgid "Acceso rápido"
msgstr "Acceso rápido"

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:189
msgid "Acceso según organización"
msgstr "Acceso según organización"

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:202
msgid "Acceso según usuario"
msgstr "Acceso según usuario"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/AccessorsTable.tsx:31
msgid "Accesor"
msgstr "Accesor"

#: src/features/metricsViews/components/forms/QuickAccessForm.tsx:23
#: src/fsd/entities/dashboard-widget/ui/quick-access/quick-access-editor.tsx:23
#: src/pages/access/index.tsx:9
msgid "Accesos"
msgstr "Accesos"

#: src/features/metricsViews/utils/genericWidgetTypes.ts:78
msgid "Accesos rápidos"
msgstr "Accesos rápidos"

#: src/features/audit/components/AuditLogDetails.tsx:84
#: src/features/audit/components/AuditLogsSidebar.tsx:198
#: src/features/organizationDelete/components/DeleteOrganization.tsx:172
#: src/features/organizationDelete/components/DeleteOrganization.tsx:244
msgid "Acción"
msgstr "Acción"

#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:70
msgid "Acción Inmediata"
msgstr "Acción Inmediata"

#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:126
#: src/features/collections/components/CollectionsTable.tsx:58
#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:344
#: src/features/deviceConfiguration/data/tableColumns.ts:26
#: src/features/homeAmaru/components/HomeAmaru.tsx:261
#: src/features/homeAmaru/components/shared/HomeAmaruSkeleton.tsx:63
#: src/features/metricsViews/components/MetricsViewList.tsx:163
#: src/features/notifications/components/Notifications.tsx:136
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:310
#: src/features/reports2/components/ReportTemplatesTable.tsx:89
msgid "Acciones"
msgstr "Acciones"

#: src/fsd/pages/dashboards/ui/canvas/canvas.tsx:605
msgid "Acciones de {name}"
msgstr "Acciones de {name}"

#: src/fsd/pages/dashboards/ui/change-bar/view-menu.tsx:46
#: src/fsd/pages/dashboards/ui/change-bar/view-menu.tsx:55
msgid "Acciones de la vista"
msgstr "Acciones de la vista"

#: src/fsd/shared/ui/format/units.ts:118
#: src/utils/units.ts:175
msgid "acre-pie"
msgstr "acre-pie"

#: src/fsd/shared/ui/format/units.ts:59
#: src/utils/units.ts:116
msgid "acre-pie por segundo"
msgstr "acre-pie por segundo"

#: src/fsd/shared/ui/format/units.ts:123
#: src/utils/units.ts:180
msgid "acre-pulgada"
msgstr "acre-pulgada"

#: src/features/metricsViews/components/widgets/configuredAlerts/index.tsx:142
msgid "Activa"
msgstr "Activa"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:481
msgid "Activada"
msgstr "Activada"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:152
msgid "Activar"
msgstr "Activar"

#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:366
msgid "Activar autenticación en dos pasos"
msgstr "Activar autenticación en dos pasos"

#: src/features/deviceConfigurationModal/components/publicTab/index.tsx:43
msgid "Activar dispositivo público para la organización <0>{0}</0>"
msgstr "Activar dispositivo público para la organización <0>{0}</0>"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:218
msgid "Activar o desactivar deudor"
msgstr "Activar o desactivar deudor"

#: src/features/organizationsManagement/components/OrganizationSwitchStatus.tsx:14
msgid "Activar o desactivar organización"
msgstr "Activar o desactivar organización"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:207
msgid "Activar o desactivar organización en dos pasos a todos los usuarios de la organización"
msgstr "Activar o desactivar organización en dos pasos a todos los usuarios de la organización"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:49
#: src/pages/activate-user/index.tsx:12
msgid "Activar usuario temporal"
msgstr "Activar usuario temporal"

#: src/features/metricsViews/components/forms/ConfiguredAlertsForm.tsx:28
msgid "Activas"
msgstr "Activas"

#: src/features/deviceProfile/components/DeviceProfileModal.tsx:72
#: src/features/homeAmaru/components/shared/ActivityPanel.tsx:14
#: src/features/homeAmaru/components/shared/PanelTabs.tsx:17
#: src/features/userProfile/components/UserProfileAuditLogs.tsx:51
#: src/features/userProfile/components/UserProfileAuditLogsSkeleton.tsx:12
msgid "Actividad reciente"
msgstr "Actividad reciente"

#: src/features/audit/utils/parseProperty.ts:147
msgid "activo"
msgstr "activo"

#: src/features/changeOperationalState/components/AfterUpdateTasksModal.tsx:96
#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:34
#: src/features/devices2/utils/featuresFilter.ts:61
#: src/features/reports2/components/ReportTemplatesTable.tsx:72
#: src/features/users/utils/filterOptions.ts:109
#: src/utils/attributes/deviceOperationalState.ts:58
msgid "Activo"
msgstr "Activo"

#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:97
#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:98
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:83
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:84
#: src/features/homeAmaru/components/shared/CollectionRow.tsx:61
msgid "Activos"
msgstr "Activos"

#: src/fsd/entities/dashboard-widget/model/gate-sensors-sample.ts:63
msgid "Activos mezclados"
msgstr "Activos mezclados"

#: src/features/gateAdministration/components/MoveGate.tsx:191
msgid "Actual"
msgstr "Actual"

#: src/features/deviceConfiguration/components/TriggerConfigUpdateModal.tsx:64
msgid "Actualización iniciada. Nombre de ejecución: {0}"
msgstr "Actualización iniciada. Nombre de ejecución: {0}"

#: src/components/Reload.tsx:39
#: src/features/controlCenter/components/window/Window.tsx:248
msgid "Actualizado"
msgstr "Actualizado"

#: src/fsd/pages/dashboards/ui/status-strip/status-strip.tsx:87
msgid "Actualizado {elapsed}"
msgstr "Actualizado {elapsed}"

#: src/features/changeTagsDevice/components/ChangeTagsDevice.tsx:43
msgid "Actualizado correctamente"
msgstr "Actualizado correctamente"

#: src/features/audit/utils/parseProperty.ts:152
msgid "actualizado el"
msgstr "actualizado el"

#: src/features/announcements/components/AnnouncementsViewModal.tsx:76
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:559
msgid "Actualizado el"
msgstr "Actualizado el"

#: src/features/api/components/dialogs/EditApiUserDialog.tsx:80
msgid "Actualizando permisos de la credencial con nombre de usuario <0>{0}</0>"
msgstr "Actualizando permisos de la credencial con nombre de usuario <0>{0}</0>"

#: src/fsd/pages/dashboards/ui/status-strip/status-strip.tsx:87
msgid "Actualizando…"
msgstr "Actualizando…"

#: src/features/api/components/dialogs/EditApiUserDialog.tsx:141
msgid "Actualizar"
msgstr "Actualizar"

#: src/features/audit/components/AuditLogDetailsRow.tsx:16
msgid "ACTUALIZAR"
msgstr "ACTUALIZAR"

#: src/features/audit/utils/getActionTypeOptions.ts:97
msgid "Actualizar Acceso de Dispositivo"
msgstr "Actualizar Acceso de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:136
msgid "Actualizar Acceso de Organización"
msgstr "Actualizar Acceso de Organización"

#: src/features/audit/utils/getActionTypeOptions.ts:169
msgid "Actualizar Acceso de Usuario"
msgstr "Actualizar Acceso de Usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:100
msgid "Actualizar Alarmas de Dispositivo"
msgstr "Actualizar Alarmas de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:172
msgid "Actualizar Alarmas de Usuario"
msgstr "Actualizar Alarmas de Usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:103
msgid "Actualizar Alertas de Dispositivo"
msgstr "Actualizar Alertas de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:175
msgid "Actualizar Alertas de Usuario"
msgstr "Actualizar Alertas de Usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:220
msgid "Actualizar Alias de Dispositivo"
msgstr "Actualizar Alias de Dispositivo"

#: src/features/deviceConfigurationModal/components/aliasModal/DeviceAliasModal.tsx:131
msgid "Actualizar alias de organizaciones asociadas al dispositivo <0>{0}</0> con ID <1>{1}</1>"
msgstr "Actualizar alias de organizaciones asociadas al dispositivo <0>{0}</0> con ID <1>{1}</1>"

#: src/features/audit/utils/getActionTypeOptions.ts:88
msgid "Actualizar API para Organización"
msgstr "Actualizar API para Organización"

#: src/features/deviceConfiguration/components/TriggerConfigUpdateModal.tsx:83
msgid "Actualizar archivo de configuración"
msgstr "Actualizar archivo de configuración"

#: src/features/audit/utils/getActionTypeOptions.ts:94
msgid "Actualizar Calibración"
msgstr "Actualizar Calibración"

#: src/features/audit/utils/getActionTypeOptions.ts:211
msgid "Actualizar Campos de Configuración de Soporte del Usuario"
msgstr "Actualizar Campos de Configuración de Soporte del Usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:130
msgid "Actualizar Canal de Irrigación"
msgstr "Actualizar Canal de Irrigación"

#: src/features/audit/utils/getActionTypeOptions.ts:148
msgid "Actualizar Clase de Canal de SIRA"
msgstr "Actualizar Clase de Canal de SIRA"

#: src/features/deviceCommands/components/calendar/UpdateCommandKeyDialog.tsx:65
msgid "Actualizar Comando Programado"
msgstr "Actualizar Comando Programado"

#: src/features/changeOperationalState/components/AfterUpdateTasksModal.tsx:186
msgid "Actualizar configuración de alertas"
msgstr "Actualizar configuración de alertas"

#: src/features/audit/utils/getActionTypeOptions.ts:112
msgid "Actualizar Configuración de Calendario para Dispositivo"
msgstr "Actualizar Configuración de Calendario para Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:256
msgid "Actualizar Configuración de DGA"
msgstr "Actualizar Configuración de DGA"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:176
#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:196
msgid "Actualizar configuración de hardware"
msgstr "Actualizar configuración de hardware"

#: src/features/audit/utils/getActionTypeOptions.ts:184
msgid "Actualizar Configuración de Hardware de Dispositivo"
msgstr "Actualizar Configuración de Hardware de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:274
msgid "Actualizar Configuración de Notificación de DGA"
msgstr "Actualizar Configuración de Notificación de DGA"

#: src/features/audit/utils/getActionTypeOptions.ts:139
msgid "Actualizar Configuración de Organización"
msgstr "Actualizar Configuración de Organización"

#: src/features/audit/utils/getActionTypeOptions.ts:262
msgid "Actualizar Configuración de Recurrencia de Envío de DGA"
msgstr "Actualizar Configuración de Recurrencia de Envío de DGA"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:231
#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:251
#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:268
msgid "Actualizar configuración DGA"
msgstr "Actualizar configuración DGA"

#: src/features/api/components/dialogs/SetApiUserPasswordDialog.tsx:77
msgid "Actualizar contraseña credencial API"
msgstr "Actualizar contraseña credencial API"

#: src/features/audit/utils/getActionTypeOptions.ts:91
msgid "Actualizar Contraseña de API para Organización"
msgstr "Actualizar Contraseña de API para Organización"

#: src/features/audit/utils/getActionTypeOptions.ts:145
msgid "Actualizar Curvas de Aforo"
msgstr "Actualizar Curvas de Aforo"

#. Análisis de estaciones - tooltip de botón para actualizar datos
#: src/components/Reload.tsx:23
#: src/features/controlCenter/components/window/Window.tsx:250
#: src/features/devicesAnalysis/components/LastData.tsx:113
#: src/features/gateAdministration/components/index.tsx:456
msgid "Actualizar datos"
msgstr "Actualizar datos"

#: src/features/audit/utils/getActionTypeOptions.ts:151
msgid "Actualizar Distribución de SIRA"
msgstr "Actualizar Distribución de SIRA"

#: src/features/audit/utils/getActionTypeOptions.ts:154
msgid "Actualizar Distribución de SIRA Maipo"
msgstr "Actualizar Distribución de SIRA Maipo"

#: src/features/audit/utils/getActionTypeOptions.ts:157
msgid "Actualizar Dotación Mínima de Distribución de SIRA Maipo"
msgstr "Actualizar Dotación Mínima de Distribución de SIRA Maipo"

#: src/features/deviceConfiguration/components/TriggerConfigUpdateModal.tsx:109
msgid "Actualizar estado"
msgstr "Actualizar estado"

#: src/features/audit/utils/getActionTypeOptions.ts:328
msgid "Actualizar estado de dispositivo"
msgstr "Actualizar estado de dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:118
msgid "Actualizar Estado de Dispositivo"
msgstr "Actualizar Estado de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:202
msgid "Actualizar Estado de Soporte del Dispositivo"
msgstr "Actualizar Estado de Soporte del Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:340
msgid "Actualizar etiquetas de dispositivo"
msgstr "Actualizar etiquetas de dispositivo"

#: src/features/devices2/components/DevicesHeader.tsx:216
#: src/features/updateMultipleDevicesTags/components/UpdateMultipleDevicesTagsModal.tsx:327
msgid "Actualizar etiquetas de dispositivos"
msgstr "Actualizar etiquetas de dispositivos"

#: src/features/audit/utils/getActionTypeOptions.ts:208
msgid "Actualizar Filtros de Configuración de Soporte del Usuario"
msgstr "Actualizar Filtros de Configuración de Soporte del Usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:115
msgid "Actualizar Filtros de Dispositivo"
msgstr "Actualizar Filtros de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:346
msgid "Actualizar flujo máximo DGA"
msgstr "Actualizar flujo máximo DGA"

#: src/features/audit/utils/getActionTypeOptions.ts:127
msgid "Actualizar Información"
msgstr "Actualizar Información"

#: src/features/audit/utils/getActionTypeOptions.ts:121
msgid "Actualizar Información de DGA (deprecado)"
msgstr "Actualizar Información de DGA (deprecado)"

#: src/features/audit/utils/getActionTypeOptions.ts:286
msgid "Actualizar información del pago"
msgstr "Actualizar información del pago"

#: src/features/audit/utils/getActionTypeOptions.ts:280
msgid "Actualizar la periodicidad del cobro"
msgstr "Actualizar la periodicidad del cobro"

#: src/features/audit/utils/getActionTypeOptions.ts:124
msgid "Actualizar Límites de Flujo"
msgstr "Actualizar Límites de Flujo"

#: src/features/audit/utils/getActionTypeOptions.ts:199
msgid "Actualizar Límites de Posición de Compuerta"
msgstr "Actualizar Límites de Posición de Compuerta"

#: src/features/changeOperationalState/components/AfterUpdateTasksModal.tsx:153
msgid "Actualizar los envíos periódicos a la DGA"
msgstr "Actualizar los envíos periódicos a la DGA"

#: src/features/audit/utils/getActionTypeOptions.ts:229
msgid "Actualizar Modelado Matemático"
msgstr "Actualizar Modelado Matemático"

#: src/features/audit/utils/getActionTypeOptions.ts:109
msgid "Actualizar Notificaciones de Alerta de Dispositivo"
msgstr "Actualizar Notificaciones de Alerta de Dispositivo"

#: src/features/deviceObservations/components/modals/DeleteObservationModal.tsx:114
#: src/features/deviceObservations/components/modals/UpdateObservationModal.tsx:72
#: src/features/deviceObservations/components/modals/UpdateObservationModal.tsx:99
msgid "Actualizar observación"
msgstr "Actualizar observación"

#: src/features/audit/utils/getActionTypeOptions.ts:133
msgid "Actualizar Organización"
msgstr "Actualizar Organización"

#: src/features/audit/utils/getActionTypeOptions.ts:142
msgid "Actualizar Parámetros de Radar"
msgstr "Actualizar Parámetros de Radar"

#: src/features/audit/utils/getActionTypeOptions.ts:160
msgid "Actualizar Participaciones de Distribución de SIRA Maipo"
msgstr "Actualizar Participaciones de Distribución de SIRA Maipo"

#: src/features/audit/utils/getActionTypeOptions.ts:250
msgid "Actualizar Preferencias de Usuario"
msgstr "Actualizar Preferencias de Usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:244
msgid "Actualizar Programación de Reporte"
msgstr "Actualizar Programación de Reporte"

#: src/pages/billing/UpdatePaymentView.tsx:11
msgid "Actualizar Registro de Pago"
msgstr "Actualizar Registro de Pago"

#: src/features/audit/utils/getActionTypeOptions.ts:235
msgid "Actualizar Reporte"
msgstr "Actualizar Reporte"

#: src/features/audit/utils/getActionTypeOptions.ts:304
msgid "Actualizar servicio de facturación"
msgstr "Actualizar servicio de facturación"

#: src/features/audit/utils/getActionTypeOptions.ts:295
msgid "Actualizar servicio de para proyecto de facturación"
msgstr "Actualizar servicio de para proyecto de facturación"

#: src/features/audit/utils/getActionTypeOptions.ts:205
msgid "Actualizar Tags de Soporte del Dispositivo"
msgstr "Actualizar Tags de Soporte del Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:277
msgid "Actualizar Ticket de DGA"
msgstr "Actualizar Ticket de DGA"

#: src/features/audit/utils/getActionTypeOptions.ts:166
msgid "Actualizar Usuario"
msgstr "Actualizar Usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:163
msgid "Actualizar Usuario de SIRA a Notificar"
msgstr "Actualizar Usuario de SIRA a Notificar"

#: src/features/audit/utils/getDisplayNameActionType.ts:273
msgid "actualizó el acceso a la organización"
msgstr "actualizó el acceso a la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:52
msgid "actualizó el acceso al dispositivo"
msgstr "actualizó el acceso al dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:173
msgid "actualizó el acceso del usuario"
msgstr "actualizó el acceso del usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:112
msgid "actualizó el alias del dispositivo"
msgstr "actualizó el alias del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:375
msgid "actualizó el cronograma del reporte"
msgstr "actualizó el cronograma del reporte"

#: src/features/audit/utils/getDisplayNameActionType.ts:100
msgid "actualizó el estado de soporte del dispositivo"
msgstr "actualizó el estado de soporte del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:40
msgid "actualizó el estado del dispositivo"
msgstr "actualizó el estado del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:462
msgid "actualizó el estado del ticket de DGA"
msgstr "actualizó el estado del ticket de DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:470
msgid "actualizó el flujo máximo DGA"
msgstr "actualizó el flujo máximo DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:32
msgid "actualizó el modelado matemático"
msgstr "actualizó el modelado matemático"

#: src/features/audit/utils/getDisplayNameActionType.ts:363
msgid "actualizó el reporte"
msgstr "actualizó el reporte"

#: src/features/audit/utils/getDisplayNameActionType.ts:153
msgid "actualizó el usuario"
msgstr "actualizó el usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:252
msgid "actualizó el usuario de SIRA para notificar"
msgstr "actualizó el usuario de SIRA para notificar"

#: src/features/audit/utils/getDisplayNameActionType.ts:289
msgid "actualizó la API para la organización"
msgstr "actualizó la API para la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:12
msgid "actualizó la calibración"
msgstr "actualizó la calibración"

#: src/features/audit/utils/getDisplayNameActionType.ts:240
msgid "actualizó la clase de canal de SIRA"
msgstr "actualizó la clase de canal de SIRA"

#: src/features/audit/utils/getDisplayNameActionType.ts:438
msgid "actualizó la configuración de DGA"
msgstr "actualizó la configuración de DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:277
msgid "actualizó la configuración de la organización"
msgstr "actualizó la configuración de la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:458
msgid "actualizó la configuración de notificación de DGA"
msgstr "actualizó la configuración de notificación de DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:454
msgid "actualizó la configuración de recurrencia de envío de DGA"
msgstr "actualizó la configuración de recurrencia de envío de DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:72
msgid "actualizó la configuración del calendario del dispositivo"
msgstr "actualizó la configuración del calendario del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:88
msgid "actualizó la configuración del hardware del dispositivo"
msgstr "actualizó la configuración del hardware del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:293
msgid "actualizó la contraseña de la API para la organización"
msgstr "actualizó la contraseña de la API para la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:227
msgid "actualizó la distribución de SIRA"
msgstr "actualizó la distribución de SIRA"

#: src/features/audit/utils/getDisplayNameActionType.ts:325
msgid "actualizó la distribución de SIRA Maipo"
msgstr "actualizó la distribución de SIRA Maipo"

#: src/features/audit/utils/getDisplayNameActionType.ts:333
msgid "actualizó la dotación mínima de la distribución de SIRA Maipo"
msgstr "actualizó la dotación mínima de la distribución de SIRA Maipo"

#: src/features/audit/utils/getDisplayNameActionType.ts:36
msgid "actualizó la información"
msgstr "actualizó la información"

#: src/features/audit/utils/getDisplayNameActionType.ts:425
msgid "actualizó la información de DGA"
msgstr "actualizó la información de DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:388
msgid "actualizó la información del pago de un proyecto."
msgstr "actualizó la información del pago de un proyecto."

#: src/features/audit/utils/getDisplayNameActionType.ts:222
msgid "actualizó la irrigación"
msgstr "actualizó la irrigación"

#: src/features/audit/utils/getDisplayNameActionType.ts:269
msgid "actualizó la organización"
msgstr "actualizó la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:380
msgid "actualizó la periodicidad del cobro recurrente del proyecto"
msgstr "actualizó la periodicidad del cobro recurrente del proyecto"

#: src/features/audit/utils/getDisplayNameActionType.ts:329
msgid "actualizó las acciones de la distribución de SIRA Maipo"
msgstr "actualizó las acciones de la distribución de SIRA Maipo"

#: src/features/audit/utils/getDisplayNameActionType.ts:64
msgid "actualizó las alarmas del dispositivo"
msgstr "actualizó las alarmas del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:181
msgid "actualizó las alarmas del usuario"
msgstr "actualizó las alarmas del usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:56
msgid "actualizó las alertas del dispositivo"
msgstr "actualizó las alertas del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:177
msgid "actualizó las alertas del usuario"
msgstr "actualizó las alertas del usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:28
msgid "actualizó las curvas de aforo"
msgstr "actualizó las curvas de aforo"

#: src/features/audit/utils/getDisplayNameActionType.ts:144
msgid "actualizó las etiquetas del dispositivo"
msgstr "actualizó las etiquetas del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:68
msgid "actualizó las notificaciones de alerta del dispositivo"
msgstr "actualizó las notificaciones de alerta del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:197
msgid "actualizó las preferencias del usuario"
msgstr "actualizó las preferencias del usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:189
msgid "actualizó los campos de configuración de soporte del usuario"
msgstr "actualizó los campos de configuración de soporte del usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:185
msgid "actualizó los filtros de configuración de soporte del usuario"
msgstr "actualizó los filtros de configuración de soporte del usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:20
msgid "actualizó los filtros del dispositivo"
msgstr "actualizó los filtros del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:16
msgid "actualizó los límites de caudal"
msgstr "actualizó los límites de caudal"

#: src/features/audit/utils/getDisplayNameActionType.ts:350
msgid "actualizó los límites de posición de la compuerta"
msgstr "actualizó los límites de posición de la compuerta"

#: src/features/audit/utils/getDisplayNameActionType.ts:24
msgid "actualizó los parámetros del radar"
msgstr "actualizó los parámetros del radar"

#: src/features/audit/utils/getDisplayNameActionType.ts:104
msgid "actualizó los tags de soporte del dispositivo"
msgstr "actualizó los tags de soporte del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:412
msgid "actualizó un nuevo servicio de facturación."
msgstr "actualizó un nuevo servicio de facturación."

#: src/features/audit/utils/getDisplayNameActionType.ts:400
msgid "actualizó un servicio del proyecto."
msgstr "actualizó un servicio del proyecto."

#: src/pages/collections/index.tsx:9
msgid "Administración de colecciones"
msgstr "Administración de colecciones"

#: src/pages/users/index.tsx:9
msgid "Administración de usuarios"
msgstr "Administración de usuarios"

#: src/features/audit/utils/parseProperty.ts:88
msgid "administrador"
msgstr "administrador"

#: src/features/deviceConfiguration/data/sectionFields.ts:389
#: src/features/deviceConfiguration/data/sectionInputs.ts:415
#: src/utils/roles.ts:19
msgid "Administrador"
msgstr "Administrador"

#: src/features/devicesAccessInputs/components/DevicesFiltersMenu.tsx:104
msgid "Administradores"
msgstr "Administradores"

#: src/features/collections/components/CollectionsTable.tsx:180
msgid "Administrar cuentas"
msgstr "Administrar cuentas"

#: src/features/collections/components/CollectionsTable.tsx:175
msgid "Administrar dispositivos"
msgstr "Administrar dispositivos"

#: src/features/integrations/utils/writeExecutionLogSeverityAttributes.ts:48
#: src/features/notifications/components/NotificationMessageViewModal.tsx:35
msgid "Advertencia"
msgstr "Advertencia"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:28
msgid "Agosto"
msgstr "Agosto"

#: src/features/metricsViews/components/forms/TableWidgetForm.tsx:125
msgid "Agrega una columna"
msgstr "Agrega una columna"

#: src/features/metricsViews/components/forms/TrendSummaryForm.tsx:191
msgid "Agrega una fila por cada dispositivo y métrica que quieras seguir."
msgstr "Agrega una fila por cada dispositivo y métrica que quieras seguir."

#: src/fsd/entities/dashboard-widget/ui/chart/chart-view.tsx:129
msgid "Agrega una serie para ver el gráfico"
msgstr "Agrega una serie para ver el gráfico"

#: src/fsd/app/locale/au-labels.ts:105
msgid "Agregación"
msgstr "Agregación"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:289
msgid "agregado"
msgstr "agregado"

#: src/features/alertsConfigurationV3/components/wizard/steps/MetricStep.tsx:142
#: src/features/billing/components/service/Administration.tsx:100
#: src/features/standardDesign/components/accessRelationManager/AccessRelationManagerModal.tsx:256
#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:86
msgid "Agregar"
msgstr "Agregar"

#: src/features/metricsViews/components/forms/ConfiguredAlertsForm.tsx:81
msgid "Agregar \"Inactivas\" sirve para auditar lo que está apagado."
msgstr "Agregar \"Inactivas\" sirve para auditar lo que está apagado."

#: src/features/metricsViews/components/SaveWidgetModal.tsx:301
msgid "Agregar al tablero"
msgstr "Agregar al tablero"

#: src/features/alertsConfigurationV3/components/ConfigureAlertGrid.tsx:75
msgid "Agregar alerta"
msgstr "Agregar alerta"

#: src/features/deviceConfigurationModal/components/aliasModal/DeviceAliasModal.tsx:190
msgid "Agregar alias"
msgstr "Agregar alias"

#: src/features/metricsViews/components/forms/TableWidgetForm.tsx:141
#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:136
msgid "Agregar columna"
msgstr "Agregar columna"

#: src/features/devices2/components/DevicesHeader.tsx:186
msgid "Agregar configuración DGA"
msgstr "Agregar configuración DGA"

#: src/features/devices2/components/DevicesHeader.tsx:198
msgid "Agregar Configuración SMA"
msgstr "Agregar Configuración SMA"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:289
msgid "Agregar curva"
msgstr "Agregar curva"

#: src/features/devices2/components/DevicesHeader.tsx:180
msgid "Agregar dispositivo"
msgstr "Agregar dispositivo"

#: src/features/collections/components/modals/ManageCollectionAccessModal.tsx:74
msgid "Agregar dispositivos"
msgstr "Agregar dispositivos"

#: src/features/deviceSupport/components/SupportTableBody.tsx:165
msgid "Agregar etiqueta"
msgstr "Agregar etiqueta"

#: src/features/metricsViews/components/forms/TrendSummaryForm.tsx:241
msgid "Agregar fila"
msgstr "Agregar fila"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:504
msgid "Agregar filtro"
msgstr "Agregar filtro"

#: src/features/access/components/usersTab/UsersTab.tsx:139
#: src/features/userConfigurationModal/components/deviceAccessTab/index.tsx:89
msgid "Agregar más dispositivos"
msgstr "Agregar más dispositivos"

#: src/features/access/components/devicesTab/DevicesTab.tsx:152
#: src/features/deviceAccessModal/components/deviceAccessTab/index.tsx:87
msgid "Agregar más usuarios"
msgstr "Agregar más usuarios"

#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:293
msgid "Agregar nueva relación"
msgstr "Agregar nueva relación"

#: src/features/reports2/components/createModal/steps/step3/3-FormatAndRecipients.tsx:295
msgid "Agregar nuevo contacto"
msgstr "Agregar nuevo contacto"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:162
msgid "Agregar nuevo widget"
msgstr "Agregar nuevo widget"

#: src/features/userSaveModal/components/UserSaveModal.tsx:595
msgid "Agregar organización"
msgstr "Agregar organización"

#: src/features/alertsConfigurationV3/components/wizard/steps/MetricStep.tsx:180
msgid "Agregar otra"
msgstr "Agregar otra"

#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:366
msgid "Agregar otro intervalo"
msgstr "Agregar otro intervalo"

#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:162
#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:305
msgid "Agregar relaciones dispositivo-usuario"
msgstr "Agregar relaciones dispositivo-usuario"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:182
#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:264
msgid "Agregar serie"
msgstr "Agregar serie"

#: src/features/billing/components/administration/Toolbar.tsx:113
#: src/features/billing/components/projectService/Create.tsx:112
msgid "Agregar servicio a proyecto"
msgstr "Agregar servicio a proyecto"

#: src/features/metricsViews/components/MetricsView.tsx:1055
msgid "Agregar un bloque"
msgstr "Agregar un bloque"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:80
msgid "Agregar un widget"
msgstr "Agregar un widget"

#: src/features/collections/components/modals/ManageCollectionAccessModal.tsx:146
#: src/features/users/components/UsersTableFilters.tsx:78
msgid "Agregar usuario"
msgstr "Agregar usuario"

#: src/fsd/pages/dashboards/ui/change-bar/add-widget.tsx:45
#: src/fsd/pages/dashboards/ui/change-bar/add-widget.tsx:48
msgid "Agregar widget"
msgstr "Agregar widget"

#: src/features/metricsViews/components/MetricsView.tsx:588
msgid "Agregar Widget"
msgstr "Agregar Widget"

#: src/features/events/components/EventsTable.tsx:97
msgid "Agrupados por tipo"
msgstr "Agrupados por tipo"

#: src/features/billing/components/administration/Filters.tsx:45
msgid "Agrupar por"
msgstr "Agrupar por"

#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:115
msgid "Aguas abajo"
msgstr "Aguas abajo"

#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:88
msgid "Aguas arriba"
msgstr "Aguas arriba"

#: src/features/devicesAnalysisV3/components/TimelineMinimap.tsx:320
#: src/features/devicesAnalysisV3/components/TimelineMinimap.tsx:451
#: src/fsd/app/locale/au-labels.ts:104
#: src/hooks/useFormatters.ts:139
#: src/hooks/useFormatters.ts:195
msgid "ahora"
msgstr "ahora"

#: src/features/deviceProfile/components/page/lifeHistory/FigureNode.tsx:163
msgid "Ahora"
msgstr "Ahora"

#: src/fsd/pages/dashboards/ui/layout-warnings/warning-text.ts:7
msgid "Ajustado solo para mostrar; lo guardado no cambió."
msgstr "Ajustado solo para mostrar; lo guardado no cambió."

#: src/fsd/entities/dashboard-widget/ui/image/image-editor.tsx:90
msgid "Ajuste"
msgstr "Ajuste"

#: src/features/metricsViews/components/forms/ImageWidgetForm.tsx:86
#: src/fsd/entities/dashboard-widget/ui/image/image-editor.tsx:94
msgid "Ajuste de la imagen"
msgstr "Ajuste de la imagen"

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:199
msgid "Ajustes de layout"
msgstr "Ajustes de layout"

#: src/features/metricsViews/components/AssociateCollectionModal.tsx:173
msgid "Al asociarla, la vista <0>{0}</0> pasa a tomar sus dispositivos de la colección: la lista deja de editarse a mano y sigue a la colección. Abajo se ve cómo queda antes de confirmar."
msgstr "Al asociarla, la vista <0>{0}</0> pasa a tomar sus dispositivos de la colección: la lista deja de editarse a mano y sigue a la colección. Abajo se ve cómo queda antes de confirmar."

#: src/features/controlCenter/components/window/DeviceListItem.tsx:121
#: src/features/controlCenter2/components/devicesList/ListItem.tsx:170
msgid "Al dispositivo no se le han configurado las alertas"
msgstr "Al dispositivo no se le han configurado las alertas"

#: src/fsd/pages/dashboards/ui/save-loss-dialog.tsx:60
msgid "Al guardar el layout nuevo también cambia parte del layout guardado que no editaste."
msgstr "Al guardar el layout nuevo también cambia parte del layout guardado que no editaste."

#: src/features/controlCenter/components/window/DeviceListItem.tsx:103
#: src/features/controlCenter2/components/devicesList/ListItem.tsx:127
msgid "Al no tener una ubicación asociada, el dispositivo no está visible en el mapa"
msgstr "Al no tener una ubicación asociada, el dispositivo no está visible en el mapa"

#: src/features/gates/components/AlarmSystem.tsx:79
msgid "Alarma activa"
msgstr "Alarma activa"

#: src/features/gates/components/AlarmSystem.tsx:56
msgid "Alarma activada"
msgstr "Alarma activada"

#: src/features/gates/components/AlarmSystem.tsx:58
msgid "Alarma desactivada por 30 minutos"
msgstr "Alarma desactivada por 30 minutos"

#: src/features/gates/components/AlarmSystem.tsx:79
msgid "Alarma inactiva"
msgstr "Alarma inactiva"

#: src/features/homeAmaru/components/shared/PanelTabs.tsx:14
#: src/features/homeAmaru/components/shared/WorkspaceHeader.tsx:33
#: src/features/metricsViews/utils/quickAccessCatalog.tsx:62
#: src/fsd/entities/dashboard-widget/ui/quick-access/destinations.ts:49
msgid "Alarmas y Alertas"
msgstr "Alarmas y Alertas"

#: src/features/api/components/CaptaApiUsersList.tsx:94
msgid "Alcance"
msgstr "Alcance"

#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:46
#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:188
#: src/features/metricsViews/components/widgets/configuredAlerts/Table.tsx:260
msgid "Alerta"
msgstr "Alerta"

#: src/features/notifications/utils/entitiesHandlers.tsx:47
msgid "Alerta {0} - dispositivo {1}: {2}"
msgstr "Alerta {0} - dispositivo {1}: {2}"

#: src/features/alertsConfigurationV3/hooks/useAlertLifecycleV3.ts:67
msgid "Alerta actualizada correctamente"
msgstr "Alerta actualizada correctamente"

#: src/features/alertsConfigurationV3/hooks/useAlertLifecycleV3.ts:37
msgid "Alerta creada correctamente"
msgstr "Alerta creada correctamente"

#: src/utils/alerts.ts:28
msgid "Alerta de intruso"
msgstr "Alerta de intruso"

#: src/features/alertsConfigurationV3/hooks/useAlertLifecycleV3.ts:51
msgid "Alerta desactivada"
msgstr "Alerta desactivada"

#: src/features/notifications/utils/entitiesHandlers.tsx:42
msgid "Alerta dispositivo {0}"
msgstr "Alerta dispositivo {0}"

#: src/features/alertsConfigurationV3/hooks/useAlertLifecycleV3.ts:44
msgid "Alerta eliminada correctamente"
msgstr "Alerta eliminada correctamente"

#: src/features/alertsConfigurationV3/hooks/useAlertLifecycleV3.ts:58
msgid "Alerta reactivada"
msgstr "Alerta reactivada"

#: src/features/alertsNotificationsHistory/components/histogram/HistogramTooltip.tsx:47
#: src/features/controlCenter/utils/viewModes.ts:17
#: src/features/controlCenter2/utils/viewModes.ts:19
#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:90
#: src/features/deviceProfile/components/page/Alerts.tsx:46
#: src/features/deviceProfile/components/page/Alerts.tsx:58
#: src/features/homeAmaru/components/HomeAmaru.tsx:260
#: src/features/homeAmaru/components/shared/HomeAmaruSkeleton.tsx:62
#: src/features/metricsViews/components/forms/DataWidgetForm.tsx:145
#: src/features/organizationAccess/data/sections.ts:5
#: src/fsd/entities/dashboard-widget/ui/type-groups.ts:25
msgid "Alertas"
msgstr "Alertas"

#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:125
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:111
msgid "ALERTAS"
msgstr "ALERTAS"

#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:128
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:114
msgid "alertas activas"
msgstr "alertas activas"

#: src/features/metricsViews/utils/genericWidgetTypes.ts:79
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:7
msgid "Alertas activas"
msgstr "Alertas activas"

#: src/features/controlCenter2/components/devicesList/ListItem.tsx:144
#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:131
#: src/features/devices2/components/list/itemPanel/deviceItemInfo/AlertsIndicator.tsx:36
#: src/features/metricsViews/utils/genericWidgetTypes.ts:81
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:12
msgid "Alertas configuradas"
msgstr "Alertas configuradas"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:137
msgid "Alertas configuradas para este dispositivo"
msgstr "Alertas configuradas para este dispositivo"

#: src/utils/attributes/metricField.ts:233
msgid "alertas de caudal"
msgstr "alertas de caudal"

#: src/features/echarts/utils/commonSeries.ts:61
#: src/features/echarts/utils/commonSeries.ts:61
msgid "Alertas de caudal"
msgstr "Alertas de caudal"

#: src/features/reports/utils/metricHelpers.ts:20
msgid "Alertas de Caudal"
msgstr "Alertas de Caudal"

#: src/utils/attributes/metricField.ts:185
msgid "alertas de distribución"
msgstr "alertas de distribución"

#: src/features/reports/utils/metricHelpers.ts:18
msgid "Alertas de Distribución"
msgstr "Alertas de Distribución"

#: src/utils/attributes/metricField.ts:263
msgid "alertas de nivel"
msgstr "alertas de nivel"

#: src/features/echarts/utils/commonSeries.ts:256
#: src/features/echarts/utils/commonSeries.ts:256
msgid "Alertas de nivel"
msgstr "Alertas de nivel"

#: src/features/reports/utils/metricHelpers.ts:23
msgid "Alertas de Nivel"
msgstr "Alertas de Nivel"

#: src/features/alertsConfigurationV2/hooks/useDeleteAlertConfigurations.ts:24
#: src/features/deviceAlertsModal/components/disableAlertsModal/index.tsx:19
msgid "Alertas desactivadas correctamente"
msgstr "Alertas desactivadas correctamente"

#: src/features/alertsConfigurationV3/components/TriggeredAlertsModal.tsx:169
msgid "Alertas emitidas"
msgstr "Alertas emitidas"

#: src/features/metricsViews/components/forms/AlertsTableForm.tsx:22
msgid "Alertas gatilladas"
msgstr "Alertas gatilladas"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:146
#: src/utils/attributes/metricAlertEvaluation.ts:21
msgid "Alertas no configuradas"
msgstr "Alertas no configuradas"

#: src/components/gates/StopMovementConfirmation.tsx:86
#: src/components/optionsMenu/dialogs/movementHistory/QueryComponent.tsx:22
msgid "Algo salió mal"
msgstr "Algo salió mal"

#: src/features/deviceCommands/components/custom/SendStandardCommandToDevices.tsx:31
msgid "Algo salió mal, por favor intente nuevamente."
msgstr "Algo salió mal, por favor intente nuevamente."

#: src/features/integrations/components/integrationsStatus/index.tsx:37
msgid "Algunas integraciones con problemas"
msgstr "Algunas integraciones con problemas"

#: src/features/integrations/components/integrationsStatus/index.tsx:39
msgid "Algunas integraciones fuera de línea"
msgstr "Algunas integraciones fuera de línea"

#: src/features/billing/components/modals/ServiceFileManager.tsx:63
msgid "Alguno de los dispositivos no pertenece al proyecto especificado."
msgstr "Alguno de los dispositivos no pertenece al proyecto especificado."

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:13
msgid "Algunos dispositivos del pedido no están en este tablero o no tienes acceso a ellos."
msgstr "Algunos dispositivos del pedido no están en este tablero o no tienes acceso a ellos."

#: src/fsd/entities/dashboard-widget/ui/format/device-warning.ts:23
msgid "Algunos dispositivos guardados ya no están entre los de este tablero."
msgstr "Algunos dispositivos guardados ya no están entre los de este tablero."

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:61
msgid "Algunos envíos a la DGA fallaron: revisa los reportes del dispositivo."
msgstr "Algunos envíos a la DGA fallaron: revisa los reportes del dispositivo."

#: src/features/metricsViews/hooks/useExportMetricsView.ts:125
msgid "Algunos widgets seguían cargando: la imagen puede quedar incompleta."
msgstr "Algunos widgets seguían cargando: la imagen puede quedar incompleta."

#: src/features/deviceConfigurationModal/components/aliasModal/DeviceAliasModal.tsx:168
#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:243
#: src/features/deviceProfile/components/page/General.tsx:38
msgid "Alias"
msgstr "Alias"

#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:263
msgid "Alias por organización"
msgstr "Alias por organización"

#: src/features/deviceConfigurationModal/components/aliasModal/DeviceAliasModal.tsx:209
#: src/features/deviceConfigurationModal/components/aliasModal/DeviceAliasModal.tsx:232
msgid "Alias por organización de dispositivo"
msgstr "Alias por organización de dispositivo"

#: src/fsd/entities/dashboard-widget/ui/text/text-editor.tsx:39
#: src/fsd/entities/dashboard-widget/ui/text/text-editor.tsx:41
msgid "Alineación"
msgstr "Alineación"

#: src/features/metricsViews/components/forms/ButtonWidgetForm.tsx:194
#: src/features/metricsViews/components/forms/TextWidgetForm.tsx:42
msgid "Alineación de texto"
msgstr "Alineación de texto"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:489
msgid "Alisado"
msgstr "Alisado"

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:126
#: src/features/controlCenter2/utils/alertStates.ts:21
#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:347
msgid "Alto"
msgstr "Alto"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleFormula.tsx:13
msgid "altura del pivote (en cm)"
msgstr "altura del pivote (en cm)"

#: src/components/ColorPicker/palettes.ts:41
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:39
msgid "Amarillo"
msgstr "Amarillo"

#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:102
#: src/features/alertsConfiguration/components/AlertTable.tsx:218
#: src/features/alertsConfiguration/components/DialogConfirmationNotifications.tsx:119
#: src/features/alertsConfiguration/components/DialogUsersNotifications.tsx:128
#: src/features/alertsConfigurationV2/components/AlertsConfigurationV2.tsx:110
#: src/features/alertsConfigurationV3/components/ChannelBadge.tsx:26
#: src/features/alertsConfigurationV3/components/FilterBar.tsx:48
#: src/features/alertsConfigurationV3/components/wizard/steps/NotificationsStep.tsx:30
#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:56
#: src/features/deviceAlertsModal/components/notificationConfigurationTab/TableForm.tsx:66
msgid "Amaru Lite"
msgstr "Amaru Lite"

#: src/components/ColorPicker/palettes.ts:42
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:40
#: src/fsd/pages/dashboards/ui/board-color/color-names.ts:10
msgid "Ámbar"
msgstr "Ámbar"

#: src/fsd/shared/ui/format/units.ts:196
#: src/utils/units.ts:253
msgid "amperio"
msgstr "amperio"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:110
msgid "Análisis"
msgstr "Análisis"

#: src/features/advancedDevicesAnalysis/components/AdvancedDevicesAnalysis.tsx:83
msgid "Análisis avanzado de dispositivo"
msgstr "Análisis avanzado de dispositivo"

#: src/pages/advanced-devices-analysis/index.tsx:10
msgid "Análisis avanzado de estaciones"
msgstr "Análisis avanzado de estaciones"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:120
msgid "Análisis Avanzado de Estaciones"
msgstr "Análisis Avanzado de Estaciones"

#: src/features/homeAmaru/components/shared/WorkspaceHeader.tsx:34
msgid "Análisis de datos"
msgstr "Análisis de datos"

#: src/features/metricsViews/utils/quickAccessCatalog.tsx:89
#: src/fsd/entities/dashboard-widget/ui/quick-access/destinations.ts:73
msgid "Análisis de Datos"
msgstr "Análisis de Datos"

#. Título de la página de análisis de estaciones
#: src/features/deviceSupport/components/SupportTableBody.tsx:268
#: src/features/organizationAccess/data/sections.ts:13
#: src/pages/devices-analysis/index.tsx:12
msgid "Análisis de estaciones"
msgstr "Análisis de estaciones"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:113
msgid "Análisis de Estaciones"
msgstr "Análisis de Estaciones"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:154
#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:159
msgid "Análisis estaciones"
msgstr "Análisis estaciones"

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:328
#: src/fsd/pages/widget-catalog/ui/preview.tsx:90
msgid "Ancho"
msgstr "Ancho"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:152
msgid "Ancho completo, en orden de lectura, con el alto elevado al mínimo de cada tipo. No se edita acá."
msgstr "Ancho completo, en orden de lectura, con el alto elevado al mínimo de cada tipo. No se edita acá."

#: src/features/deviceProfile/components/page/modularComponents/HousingTab.tsx:68
msgid "Anclaje en concreto/metal"
msgstr "Anclaje en concreto/metal"

#: src/features/userPreferences/components/RegionTab.tsx:276
msgid "Angosto"
msgstr "Angosto"

#: src/utils/attributes/metricField.ts:41
msgid "ángulo"
msgstr "ángulo"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/GCalculatedAngleModelInput.tsx:67
#: src/features/reports/utils/metricHelpers.ts:10
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:22
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:67
#: src/utils/i18n/getMetricDisplayName.ts:18
msgid "Ángulo"
msgstr "Ángulo"

#: src/utils/attributes/metricField.ts:83
msgid "ángulo calculado"
msgstr "ángulo calculado"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleFormula.tsx:8
msgid "ángulo calculado (en grados)"
msgstr "ángulo calculado (en grados)"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleFormula.tsx:10
msgid "ángulo medido por el inclinómetro (en grados) (sin calibrar)"
msgstr "ángulo medido por el inclinómetro (en grados) (sin calibrar)"

#: src/utils/attributes/metricField.ts:47
msgid "ángulo no calibrado"
msgstr "ángulo no calibrado"

#: src/utils/attributes/metricField.ts:53
msgid "ángulo no calibrado bruto"
msgstr "ángulo no calibrado bruto"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleFormula.tsx:7
msgid "ángulo respecto a la horizontal (en grados) (calibrado)"
msgstr "ángulo respecto a la horizontal (en grados) (calibrado)"

#: src/features/alertsNotificationsHistory/components/histogram/index.tsx:48
msgid "Año"
msgstr "Año"

#: src/features/audit/utils/parseProperty.ts:87
#: src/features/audit/utils/parseProperty.ts:167
msgid "antena"
msgstr "antena"

#: src/features/deviceConfiguration/data/sectionFields.ts:334
#: src/features/deviceConfiguration/data/sectionInputs.ts:345
msgid "Antena"
msgstr "Antena"

#: src/features/deviceCommands/components/calendar/StandardCommandsSelector.tsx:69
msgid "Antiguo"
msgstr "Antiguo"

#: src/features/billing/utils/translations.ts:13
#: src/features/billing/utils/translations.ts:33
msgid "Anual"
msgstr "Anual"

#: src/features/notifications/utils/getNotificationObjectEntityType.ts:12
#: src/pages/announcements/[announcementId].tsx:12
msgid "Anuncio"
msgstr "Anuncio"

#: src/features/notifications/utils/entitiesHandlers.tsx:36
msgid "Anuncio {0} - {1}: {2}"
msgstr "Anuncio {0} - {1}: {2}"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:83
msgid "Anuncio actualizado correctamente"
msgstr "Anuncio actualizado correctamente"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:104
msgid "Anuncio creado correctamente"
msgstr "Anuncio creado correctamente"

#: src/features/announcements/components/AnnouncementsDeleteModal.tsx:29
msgid "Anuncio eliminado correctamente"
msgstr "Anuncio eliminado correctamente"

#: src/features/announcements/components/AnnouncementsView.tsx:61
#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:170
#: src/pages/announcements/index.tsx:10
msgid "Anuncios"
msgstr "Anuncios"

#: src/features/changeSupportStatus/data/status.ts:26
#: src/features/deviceSupport/data/status.ts:29
#: src/features/deviceSupport/data/status.ts:42
msgid "Apagado"
msgstr "Apagado"

#: src/features/deviceCommands/components/standard/StandardCommandsInformation.tsx:120
msgid "APAGADO"
msgstr "APAGADO"

#: src/features/deviceCommands/components/standard/DebugModeInformation.tsx:58
msgid "Apagado (POWER_SECONDS_OFF): 10 segundos."
msgstr "Apagado (POWER_SECONDS_OFF): 10 segundos."

#: src/features/audit/utils/parseProperty.ts:125
msgid "apellidos"
msgstr "apellidos"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:142
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:304
#: src/features/users/components/modals/SaveUserModal.tsx:128
#: src/features/userSaveModal/components/UserSaveModal.tsx:357
msgid "Apellidos"
msgstr "Apellidos"

#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:33
msgid "Apertura"
msgstr "Apertura"

#: src/features/api/components/APIMainText.tsx:12
#: src/features/api/components/mainMenu/MainMenuApiCapta.tsx:22
#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:176
#: src/features/organizationAccess/data/sections.ts:17
msgid "API Capta"
msgstr "API Capta"

#: src/features/api/components/ApiKey.tsx:15
#: src/features/api/components/ApiKeysList.tsx:37
#: src/features/api/components/dialogs/GeneratedUserApiSummary.tsx:45
msgid "API Key"
msgstr "API Key"

#: src/features/organizationDelete/components/DeleteOrganization.tsx:42
msgid "API Key (API Gateway)"
msgstr "API Key (API Gateway)"

#: src/features/api/components/mainMenu/MainMenuApiCapta.tsx:30
#: src/features/api/components/mainMenu/MenuApiKeys.tsx:19
msgid "API Keys"
msgstr "API Keys"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:209
#: src/features/alertsNotificationsHistory/components/Filters.tsx:381
#: src/features/dateTimeRangePicker/components/DateTimeRangePicker.tsx:162
#: src/fsd/app/locale/au-labels.ts:102
#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:219
#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:248
msgid "Aplicar"
msgstr "Aplicar"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:301
msgid "Aplicar al tablero"
msgstr "Aplicar al tablero"

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:379
msgid "Aplicar filtros"
msgstr "Aplicar filtros"

#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:392
msgid "Aplicar nuevos intervalos"
msgstr "Aplicar nuevos intervalos"

#: src/features/standardDesign/components/DateTimeRangePicker/components/AbsoluteDatePicker.tsx:88
msgid "Aplicar rango"
msgstr "Aplicar rango"

#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-render.tsx:194
msgid "Aquí no se puede operar la compuerta."
msgstr "Aquí no se puede operar la compuerta."

#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-render.tsx:56
msgid "Aquí no se pueden abrir los movimientos."
msgstr "Aquí no se pueden abrir los movimientos."

#: src/features/api/components/ApiUsersList.tsx:40
msgid "Aquí se van a encontrar las credenciales de API que su organización haya creado. Por ahora no se ha creado ninguna credencial."
msgstr "Aquí se van a encontrar las credenciales de API que su organización haya creado. Por ahora no se ha creado ninguna credencial."

#: src/features/api/components/CaptaApiUsersList.tsx:66
msgid "Aquí se van a mostrar las credenciales de API de cada uno de nuestros clientes. Sin embargo, aún no se han creado credenciales."
msgstr "Aquí se van a mostrar las credenciales de API de cada uno de nuestros clientes. Sin embargo, aún no se han creado credenciales."

#: src/features/users/components/modals/DeleteUserModal.tsx:77
msgid "Archivar"
msgstr "Archivar"

#: src/features/users/components/modals/DeleteUserModal.tsx:77
msgid "Archivar ({countdown}s)"
msgstr "Archivar ({countdown}s)"

#: src/features/audit/utils/getActionTypeOptions.ts:76
msgid "Archivar Usuario"
msgstr "Archivar Usuario"

#: src/features/createDeviceConfiguration/components/common/PDFUploadField.tsx:174
msgid "Archivo cargado"
msgstr "Archivo cargado"

#: src/features/deviceConfiguration/data/sectionFields.ts:37
msgid "Archivo de configuración"
msgstr "Archivo de configuración"

#: src/fsd/entities/dashboard-widget/ui/image/image-editor.tsx:79
msgid "Archivo de imagen"
msgstr "Archivo de imagen"

#: src/features/audit/utils/getDisplayNameActionType.ts:157
msgid "archivó el usuario"
msgstr "archivó el usuario"

#: src/features/collections/components/modals/CreateCollectionModal.tsx:139
#: src/features/collections/components/modals/UpdateCollectionModal.tsx:165
msgid "Archivo KML"
msgstr "Archivo KML"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:369
#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:34
msgid "Área"
msgstr "Área"

#: src/features/announcements/components/AnnouncementView.tsx:60
msgid "Área de Software"
msgstr "Área de Software"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:391
msgid "Armando el tablero…"
msgstr "Armando el tablero…"

#: src/features/metricsViews/components/MetricsView.tsx:764
msgid "Armar con IA"
msgstr "Armar con IA"

#: src/features/publicOrganizationSettingsModal/components/PublicOrganizationSettingsForm.tsx:80
msgid "Arrastra los dispositivos para definir su orden en la vista pública y elige qué métricas muestra cada uno."
msgstr "Arrastra los dispositivos para definir su orden en la vista pública y elige qué métricas muestra cada uno."

#: src/features/devicesOrderModal/components/DevicesOrder.tsx:91
msgid "Arrastra los dispositivos para ordenarlos"
msgstr "Arrastra los dispositivos para ordenarlos"

#: src/components/FileInput.tsx:111
msgid "Arrastra un archivo o haz click para seleccionar uno"
msgstr "Arrastra un archivo o haz click para seleccionar uno"

#: src/components/ImageUploadField.tsx:214
msgid "Arrastra una imagen o haz click para seleccionarla"
msgstr "Arrastra una imagen o haz click para seleccionarla"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:65
msgid "Arrastrar en el vacío"
msgstr "Arrastrar en el vacío"

#: src/fsd/pages/dashboards/ui/size-fix-strip/size-fix-strip.tsx:52
msgid "Arreglar"
msgstr "Arreglar"

#: src/fsd/pages/dashboards/ui/size-fix-strip/size-fix-strip.tsx:49
msgid "Arreglar «{name}» a {size}"
msgstr "Arreglar «{name}» a {size}"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:399
#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:73
msgid "Arriba"
msgstr "Arriba"

#: src/components/filters/OrderDirection.tsx:16
msgid "Ascendente"
msgstr "Ascendente"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:149
#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:161
#: src/fsd/pages/dashboards/ui/panel/panel.tsx:68
#: src/fsd/pages/dashboards/ui/panel/panel.tsx:111
msgid "Asistente"
msgstr "Asistente"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:329
msgid "Asistente:"
msgstr "Asistente:"

#: src/features/metricsViews/components/AssociateCollectionModal.tsx:290
msgid "Asociar"
msgstr "Asociar"

#: src/features/metricsViews/components/MetricsViewList.tsx:234
msgid "Asociar colección"
msgstr "Asociar colección"

#: src/features/metricsViews/components/AssociateCollectionModal.tsx:169
msgid "Asociar una colección a la vista"
msgstr "Asociar una colección a la vista"

#: src/fsd/pages/dashboards/ui/change-bar/view-menu.tsx:63
#: src/fsd/pages/dashboards/ui/keyboard/shortcuts-help.tsx:33
msgid "Atajos de teclado"
msgstr "Atajos de teclado"

#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:66
msgid "Atención Temprana"
msgstr "Atención Temprana"

#: src/features/alertsConfigurationV3/components/wizard/AlertWizardModal.tsx:352
#: src/features/reports2/components/createModal/steps/common.tsx:124
msgid "Atrás"
msgstr "Atrás"

#: src/features/billing/utils/translations.ts:42
msgid "Atrasado"
msgstr "Atrasado"

#: src/features/billing/utils/list.ts:42
msgid "Atrasado (+14d)"
msgstr "Atrasado (+14d)"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:597
msgid "Atributos adicionales"
msgstr "Atributos adicionales"

#: src/features/audit/components/AuditLogsView.tsx:13
#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:183
#: src/pages/audit/index.tsx:10
msgid "Auditoría"
msgstr "Auditoría"

#: src/features/reports/components/ReportHistory.tsx:58
#: src/features/reports2/components/reportHistoryModal/ReportHistory.tsx:63
msgid "Aun no has creado ningún reporte."
msgstr "Aun no has creado ningún reporte."

#: src/features/reports/components/templateSection/ReportTemplateList.tsx:338
msgid "Aun no has creado ninguna plantilla."
msgstr "Aun no has creado ninguna plantilla."

#: src/features/gateOperationModal/components/PanelNotifications.tsx:204
#: src/features/gateOperationModal/components/PanelNotifications.tsx:223
#: src/fsd/features/gate-movements/ui/operation/feed/operation-feed.tsx:102
#: src/fsd/pages/gate-movements/ui/panel/events/movement-events.tsx:134
msgid "Aún no se han recibido mensajes de la compuerta"
msgstr "Aún no se han recibido mensajes de la compuerta"

#: src/features/api/components/ApiKey.tsx:21
msgid "Aún no tiene su API Key. Genere una nueva credencial para obtener su API Key"
msgstr "Aún no tiene su API Key. Genere una nueva credencial para obtener su API Key"

#: src/features/users/utils/filterOptions.ts:97
#: src/features/users/utils/filterOptions.ts:102
msgid "Autenticación en 2 pasos"
msgstr "Autenticación en 2 pasos"

#: src/features/users/components/tableCells/User2FACell.tsx:52
msgid "Autenticación en 2 pasos activada por organización"
msgstr "Autenticación en 2 pasos activada por organización"

#: src/features/users/components/UsersTable.tsx:87
#: src/pages/authentication/index.tsx:72
msgid "Autenticación en dos pasos"
msgstr "Autenticación en dos pasos"

#: src/features/userProfile/components/UserProfile.tsx:140
msgid "Autenticación en dos pasos <0>activada</0>"
msgstr "Autenticación en dos pasos <0>activada</0>"

#: src/features/userProfile/components/UserProfile.tsx:132
msgid "Autenticación en dos pasos <0>activada</0> (lo exige la organización)"
msgstr "Autenticación en dos pasos <0>activada</0> (lo exige la organización)"

#: src/features/userProfile/components/UserProfile.tsx:148
msgid "Autenticación en dos pasos <0>desactivada</0>"
msgstr "Autenticación en dos pasos <0>desactivada</0>"

#: src/fsd/app/locale/au-labels.ts:121
msgid "Automática"
msgstr "Automática"

#: src/components/ColorPicker/ColorPicker.tsx:157
#: src/components/ColorPicker/ColorPicker.tsx:164
#: src/components/ColorPicker/ColorPicker.tsx:165
#: src/components/ColorPicker/ColorPicker.tsx:220
#: src/fsd/entities/dashboard-widget/ui/color-field/color-field.tsx:63
msgid "Automático"
msgstr "Automático"

#: src/fsd/entities/dashboard-widget/ui/color-field/color-field.tsx:64
msgid "Automático: {autoName}"
msgstr "Automático: {autoName}"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:217
msgid "Autor"
msgstr "Autor"

#. Análisis de estaciones - Título de acordión
#: src/features/devicesAnalysis/components/panel/sidebar/index.tsx:132
#: src/features/reports2/components/createModal/steps/step1/MetricsInput.tsx:319
msgid "Avanzado"
msgstr "Avanzado"

#: src/fsd/features/gate-movements/ui/list/movement-list.tsx:13
msgid "Ayer"
msgstr "Ayer"

#: src/features/controlCenter2/components/versionSwitch/WelcomeDialog.tsx:134
#: src/features/reports2/components/versionSwitch/WelcomeDialog.tsx:134
msgid "Ayúdanos a mejorar enviando tus sugerencias y comentarios sobre el nuevo diseño."
msgstr "Ayúdanos a mejorar enviando tus sugerencias y comentarios sobre el nuevo diseño."

#: src/components/ColorPicker/palettes.ts:34
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:32
#: src/fsd/pages/dashboards/ui/board-color/color-names.ts:7
msgid "Azul"
msgstr "Azul"

#: src/fsd/entities/dashboard-widget/ui/device-select/device-multi-select.tsx:83
msgid "Bajar {name}"
msgstr "Bajar {name}"

#: src/fsd/pages/dashboards/ui/panel/multi-scope.tsx:47
msgid "Bajar a uno"
msgstr "Bajar a uno"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:228
msgid "Bajar la serie {n}"
msgstr "Bajar la serie {n}"

#. Centro de control - leyendas sobre el mapa
#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:301
#: src/features/controlCenter/components/ControlCenterLegend.tsx:120
#: src/features/controlCenter2/utils/alertStates.ts:20
msgid "Bajo"
msgstr "Bajo"

#: src/fsd/pages/widget-catalog/ui/preview-cell.tsx:102
msgid "bajo el mínimo sugerido"
msgstr "bajo el mínimo sugerido"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:113
#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:90
msgid "Bajo límite de caudal últimos 30d"
msgstr "Bajo límite de caudal últimos 30d"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:29
msgid "Balance bocatoma-entregas"
msgstr "Balance bocatoma-entregas"

#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:374
msgid "Balancear intervalos dentro del rango de observación"
msgstr "Balancear intervalos dentro del rango de observación"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:372
msgid "Barra"
msgstr "Barra"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:35
msgid "Barras"
msgstr "Barras"

#: src/fsd/pages/widget-catalog/model/examples.ts:244
msgid "Barras de volumen"
msgstr "Barras de volumen"

#: src/features/alertsNotificationsHistory/utils/alertTypes.ts:17
#: src/features/controlCenter/utils/minicharts.ts:387
#: src/features/deviceConfiguration/data/sectionFields.ts:70
#: src/features/deviceConfiguration/data/sectionInputs.ts:76
#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:77
#: src/features/devices2/components/list/itemPanel/DeviceItemMinichart.tsx:383
#: src/features/deviceSupport/data/column.ts:63
#: src/features/deviceSupport/data/column.ts:71
#: src/features/deviceSupport/data/column.ts:79
#: src/features/deviceSupport/data/column.ts:87
#: src/features/gateOperationModal/components/panelNotification/utils.tsx:212
#: src/features/gates/components/list/GateListItemMinichart.tsx:92
#: src/features/moveGateModal/components/LiveBattery.tsx:43
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:83
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:230
#: src/fsd/features/gate-movements/ui/panel/events/event-text.tsx:142
#: src/hooks/useMinichartOptions.ts:52
#: src/utils/attributes/deviceAlertMetricName.ts:32
msgid "Batería"
msgstr "Batería"

#: src/utils/i18n/getMetricDisplayName.ts:43
msgid "Batería (%)"
msgstr "Batería (%)"

#: src/features/devices2/utils/getOrderByOptions.ts:25
msgid "Batería (Asc)"
msgstr "Batería (Asc)"

#: src/features/devices2/utils/getOrderByOptions.ts:29
msgid "Batería (Desc)"
msgstr "Batería (Desc)"

#: src/features/deviceProfile/components/page/Support.tsx:111
msgid "Batería actual {0}"
msgstr "Batería actual {0}"

#: src/components/ColorPicker/palettes.ts:57
msgid "Blanco"
msgstr "Blanco"

#: src/features/moveGateModal/components/LiveBlocks.tsx:22
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:162
msgid "Bloqueo de apertura"
msgstr "Bloqueo de apertura"

#: src/features/moveGateModal/components/LiveBlocks.tsx:28
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:168
msgid "Bloqueo de cierre"
msgstr "Bloqueo de cierre"

#: src/features/moveGateModal/components/LiveBlocks.tsx:19
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:156
msgid "Bloqueo general"
msgstr "Bloqueo general"

#: src/features/metricsViews/components/widgets/allocationPerformance/Controls.tsx:71
#: src/features/metricsViews/components/widgets/allocationPerformance/Header.legacy.tsx:58
msgid "Bocatoma"
msgstr "Bocatoma"

#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:132
msgid "Bocatoma — Operación diaria"
msgstr "Bocatoma — Operación diaria"

#: src/features/metricsViews/components/forms/TextWidgetForm.tsx:68
msgid "Borde de acento a la izquierda"
msgstr "Borde de acento a la izquierda"

#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:117
#: src/features/deviceConfiguration/components/DeleteDeviceConfiguration.tsx:73
msgid "Borrar"
msgstr "Borrar"

#: src/features/deviceConfiguration/components/DeleteDeviceConfiguration.tsx:60
msgid "Borrar configuración del equipo {0}"
msgstr "Borrar configuración del equipo {0}"

#: src/features/metricsViews/utils/widgetTypeCatalog.ts:28
#: src/fsd/entities/dashboard-widget/ui/button/button-render.tsx:22
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:10
msgid "Botón"
msgstr "Botón"

#: src/features/access/components/devicesTab/DevicesList.tsx:64
#: src/features/access/components/devicesTab/DevicesList.tsx:115
#: src/features/access/components/organizationsTab/OrganizationsList.tsx:52
#: src/features/access/components/organizationsTab/OrganizationsList.tsx:95
#: src/features/access/components/usersTab/UsersList.tsx:63
#: src/features/access/components/usersTab/UsersList.tsx:125
#: src/features/collectionsAccessInputs/components/CollectionsAccessForUserInput.tsx:111
#: src/features/collectionsAccessInputs/components/DeviceCollectionsAccessInput.tsx:108
#: src/features/controlCenter/components/window/Window.tsx:313
#: src/features/deviceAccessModal/components/allAccessTab/index.tsx:70
#: src/features/devicesAccessInputs/components/DevicesAccessForUserInput.tsx:106
#: src/features/devicesAccessInputs/components/UsersAccessForDeviceInput.tsx:150
#: src/features/reports2/components/createModal/steps/step1/MetricsInput.tsx:288
#: src/features/reports2/components/createModal/steps/step1/MultipleCheckbox.tsx:82
#: src/features/standardDesign/components/listView/StandardListViewHeader.tsx:157
#: src/features/userConfigurationModal/components/allAccessTab/index.tsx:89
#: src/features/usersGraveyard/components/UsersGraveyard.tsx:93
msgid "Buscar"
msgstr "Buscar"

#: src/features/gates/components/Gates.tsx:69
msgid "Buscar Compuerta"
msgstr "Buscar Compuerta"

#: src/components/filters/SearchDevice.tsx:18
#: src/features/access/components/organizationsTab/OrganizationDevicesAndUsersList.tsx:74
#: src/features/access/components/organizationsTab/OrganizationDevicesAndUsersList.tsx:168
#: src/features/alertsConfigurationV3/components/FilterBar.tsx:57
#: src/features/deviceConfiguration/components/DeviceConfiguration.tsx:282
#: src/features/devices2/components/DevicesHeader.tsx:116
#: src/features/deviceSupport/data/filter.ts:7
#: src/features/reports/components/selectables/DeviceSelectDialog.tsx:127
#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:133
msgid "Buscar dispositivo"
msgstr "Buscar dispositivo"

#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:60
#: src/features/alertsConfigurationV2/components/AlertsConfigurationV2.tsx:64
msgid "Buscar Dispositivo"
msgstr "Buscar Dispositivo"

#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:166
msgid "Buscar dispositivo por nombre o código…"
msgstr "Buscar dispositivo por nombre o código…"

#: src/features/collections/components/modals/AddCollectionAccessModal.tsx:78
#: src/features/collections/components/modals/ManageCollectionAccessModal.tsx:81
#: src/features/homeAmaru/components/HomeAmaru.tsx:353
msgid "Buscar dispositivo..."
msgstr "Buscar dispositivo..."

#: src/features/organizationsManagement/components/OrganizationsTableFilters.tsx:32
msgid "Buscar organización"
msgstr "Buscar organización"

#: src/fsd/pages/dashboards/ui/board-header/board-switcher.tsx:117
msgid "Buscar por nombre"
msgstr "Buscar por nombre"

#: src/fsd/pages/dashboards/ui/board-header/board-switcher.tsx:117
msgid "Buscar por nombre o ID"
msgstr "Buscar por nombre o ID"

#: src/features/deviceConfiguration/components/DeviceConfiguration.tsx:293
msgid "Buscar proyecto"
msgstr "Buscar proyecto"

#: src/fsd/pages/dashboards/ui/board-header/board-switcher.tsx:121
msgid "Buscar tablero por nombre"
msgstr "Buscar tablero por nombre"

#: src/fsd/pages/dashboards/ui/board-header/board-switcher.tsx:120
msgid "Buscar tablero por nombre o ID"
msgstr "Buscar tablero por nombre o ID"

#: src/features/access/components/organizationsTab/OrganizationDevicesAndUsersList.tsx:115
#: src/features/access/components/organizationsTab/OrganizationDevicesAndUsersList.tsx:179
#: src/features/users/components/modals/SimulateUserShortcutModal.tsx:125
msgid "Buscar usuario"
msgstr "Buscar usuario"

#: src/features/collections/components/modals/ManageCollectionAccessModal.tsx:153
msgid "Buscar usuario..."
msgstr "Buscar usuario..."

#: src/features/collections/components/modals/AddCollectionAccessModal.tsx:152
msgid "Buscar usuarios..."
msgstr "Buscar usuarios..."

#: src/features/metricsViews/components/MetricsViewsHeader.tsx:41
msgid "Buscar visualización"
msgstr "Buscar visualización"

#: src/fsd/app/locale/au-labels.ts:37
msgid "Buscar…"
msgstr "Buscar…"

#: src/features/publicOrganizationSettingsModal/components/PublicOrganizationSettingsForm.tsx:128
msgid "Cada dispositivo debe mostrar al menos una métrica."
msgstr "Cada dispositivo debe mostrar al menos una métrica."

#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:123
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:211
#: src/fsd/entities/dashboard-widget/model/dga-frequency.ts:46
#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:38
#: src/utils/i18n/getDgaTranslations.ts:42
msgid "Cada hora"
msgstr "Cada hora"

#: src/features/metricsViews/components/forms/ActiveAlertsForm.tsx:94
msgid "Cada métrica se evalúa en cada dispositivo: agregar métricas agranda la consulta."
msgstr "Cada métrica se evalúa en cada dispositivo: agregar métricas agranda la consulta."

#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:52
msgid "Cada par (\"Tipo de Mensaje\", \"Variable\") debe ser único"
msgstr "Cada par (\"Tipo de Mensaje\", \"Variable\") debe ser único"

#: src/components/ColorPicker/palettes.ts:45
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:43
msgid "Café"
msgstr "Café"

#: src/pages/device-commands/calendar.tsx:9
msgid "Calendario"
msgstr "Calendario"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LGCalibrationDisplay.tsx:45
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LGCalibrationDisplay.tsx:76
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LGCalibrationDisplay.tsx:113
msgid "Calibración <0><1>{0}</1></0> <2>(sensor: {1})</2>"
msgstr "Calibración <0><1>{0}</1></0> <2>(sensor: {1})</2>"

#: src/features/audit/utils/parseProperty.ts:6
msgid "calibración de nivel"
msgstr "calibración de nivel"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LGCalibrationDisplay.tsx:34
msgid "Calibración dispositivos hijos"
msgstr "Calibración dispositivos hijos"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LevelCalibrationForm.tsx:94
msgid "Calibración nivel"
msgstr "Calibración nivel"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleCalibrationForm.tsx:105
msgid "Calibración posición"
msgstr "Calibración posición"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:25
msgid "Calidad de agua"
msgstr "Calidad de agua"

#: src/utils/attributes/metricField.ts:341
msgid "calidad de señal"
msgstr "calidad de señal"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:331
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:111
#: src/features/reports/utils/metricHelpers.ts:29
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:37
#: src/utils/i18n/getMetricDisplayName.ts:53
msgid "Calidad de señal"
msgstr "Calidad de señal"

#: src/features/controlCenter2/components/versionSwitch/FeedbackDialog.tsx:106
#: src/features/controlCenter2/components/versionSwitch/SuggestionFab.tsx:67
#: src/features/reports2/components/versionSwitch/FeedbackDialog.tsx:138
#: src/features/reports2/components/versionSwitch/SuggestionFab.tsx:78
msgid "Calificación"
msgstr "Calificación"

#: src/fsd/app/theme/theme-toggle.tsx:18
msgid "Cambiar a tema claro"
msgstr "Cambiar a tema claro"

#: src/fsd/app/theme/theme-toggle.tsx:18
msgid "Cambiar a tema oscuro"
msgstr "Cambiar a tema oscuro"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:233
msgid "Cambiar ancho o alto"
msgstr "Cambiar ancho o alto"

#: src/features/changePasswordByToken/components/ChangePasswordByToken.tsx:139
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:379
#: src/pages/change-password/index.tsx:19
#: src/pages/change-password/index.tsx:52
msgid "Cambiar contraseña"
msgstr "Cambiar contraseña"

#: src/features/api/components/CaptaApiUsersList.tsx:213
msgid "Cambiar Contraseña"
msgstr "Cambiar Contraseña"

#: src/components/modal/ConfirmationModal.tsx:42
msgid "Cambiar de pestaña"
msgstr "Cambiar de pestaña"

#: src/fsd/pages/dashboards/ui/board-header/board-switcher.tsx:95
msgid "Cambiar de tablero"
msgstr "Cambiar de tablero"

#: src/features/deviceConfigurationModal/components/statusTab/index.tsx:32
msgid "Cambiar estado"
msgstr "Cambiar estado"

#: src/fsd/entities/dashboard-widget/ui/image/image-editor.tsx:52
msgid "Cambiar imagen"
msgstr "Cambiar imagen"

#: src/features/createDeviceConfiguration/components/common/PDFUploadField.tsx:193
msgid "Cambiar PDF"
msgstr "Cambiar PDF"

#: src/features/standardDesign/components/accessRelationManager/AccessRelationManagerModal.tsx:279
msgid "Cambiar rol"
msgstr "Cambiar rol"

#: src/features/changeSupportStatus/components/ChangeSupportStatus.tsx:132
msgid "Cambio de Estado de Soporte"
msgstr "Cambio de Estado de Soporte"

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:123
msgid "Cambio deshecho."
msgstr "Cambio deshecho."

#: src/features/audit/utils/getDisplayNameActionType.ts:136
msgid "cambió el estado para el dispositivo"
msgstr "cambió el estado para el dispositivo"

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:125
msgid "Cambio rehecho."
msgstr "Cambio rehecho."

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:30
msgid "Cambios descartados."
msgstr "Cambios descartados."

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:183
msgid "Cambios sin guardar"
msgstr "Cambios sin guardar"

#: src/fsd/app/locale/au-labels.ts:46
msgid "Campo numérico"
msgstr "Campo numérico"

#: src/features/deviceSupport/components/FieldsConfig.tsx:40
msgid "Campos actualizados correctamente"
msgstr "Campos actualizados correctamente"

#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:253
msgid "Canal"
msgstr "Canal"

#: src/features/audit/utils/getDisplayNameEntity.ts:12
msgid "canal de SIRA"
msgstr "canal de SIRA"

#: src/features/metricsViews/components/widgets/configuredAlerts/Table.tsx:269
msgid "Canales"
msgstr "Canales"

#: src/features/alertsConfigurationV3/components/wizard/steps/NotificationsStep.tsx:150
msgid "Canales de notificación"
msgstr "Canales de notificación"

#: src/components/ActionButtons.tsx:34
#: src/components/gates/StopMovementConfirmation.tsx:106
#: src/components/modal/ConfirmationModal.tsx:37
#: src/features/alertsConfigurationV2/components/DeleteAlertConfirmationDialog.tsx:66
#: src/features/alertsConfigurationV3/components/AlertSummaryCard.tsx:214
#: src/features/announcements/components/AnnouncementsDeleteModal.tsx:81
#: src/features/announcements/components/AnnouncementsSaveModal.tsx:313
#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:332
#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:109
#: src/features/api/components/dialogs/DisableApiUserDialog.tsx:103
#: src/features/api/components/dialogs/EditApiUserDialog.tsx:124
#: src/features/api/components/dialogs/EnableApiUserDialog.tsx:106
#: src/features/api/components/dialogs/GenerateApiUserDialog.tsx:153
#: src/features/api/components/dialogs/ResendApiCredentialsDialog.tsx:147
#: src/features/api/components/dialogs/SetApiUserPasswordDialog.tsx:118
#: src/features/api/components/dialogs/SoftDeleteApiUserDialog.tsx:106
#: src/features/changeSupportStatus/components/ChangeSupportStatus.tsx:147
#: src/features/changeTagsDevice/components/ChangeTagsDevice.tsx:119
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/DeleteCurveModal.tsx:40
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:429
#: src/features/devicesAnalysis/components/DeviceOperationalStateMenu.tsx:136
#: src/features/deviceSupport/components/FieldsConfig.tsx:108
#: src/features/deviceSupport/components/FilterAdvance.tsx:221
#: src/features/deviceSupport/components/FilterConfig.tsx:117
#: src/features/dga/components/modals/DeleteDGAConfigurationModal.tsx:82
#: src/features/dga/components/modals/DisableDGAConfigurationModal.tsx:34
#: src/features/dga/components/modals/MassiveDGARetryModal.tsx:95
#: src/features/dgaTicket/components/DgaTicketModal.tsx:208
#: src/features/dgaTicket/components/DgaTicketModal.tsx:381
#: src/features/gateAdministration/components/DeleteRequestModal.tsx:36
#: src/features/gateAdministration/components/MoveGateValidate.tsx:33
#: src/features/metricsViews/components/MetricsView.tsx:601
#: src/features/moveGateModal/components/MoveGateModal.tsx:179
#: src/features/notifications/components/NotificationsDeleteModal.tsx:81
#: src/features/notifications/components/NotificationsSaveModal.tsx:241
#: src/features/reports/components/creationSection/CreateReportDataExtractionDialog.tsx:65
#: src/features/reports/components/creationSection/CreateReportDialog.tsx:141
#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:179
#: src/features/reports/components/creationSection/EditReportTemplateDialog.tsx:159
#: src/features/reports/components/selectables/DeviceSelectDialog.tsx:211
#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:331
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:392
#: src/features/reports/components/templateSection/DeleteReportTemplateDialog.tsx:63
#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:123
#: src/features/reports2/components/createModal/steps/common.tsx:127
#: src/features/reports2/components/DeleteReportTemplateModal.tsx:63
#: src/features/reports2/components/DownloadReportTemplateModal.tsx:65
#: src/features/standardDesign/components/accessRelationManager/AccessRelationManagerModal.tsx:246
#: src/features/standardDesign/components/accessRelationManager/AccessRelationManagerModal.tsx:268
#: src/features/standardDesign/components/accessRelationManager/AccessRelationManagerModal.tsx:295
#: src/features/userProfileUpdate/components/DisableUserModal.tsx:93
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:448
#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:119
#: src/features/users/components/modals/ExtendTemporaryUserModal.tsx:89
#: src/features/users/components/modals/ExtendTemporaryUserTokenModal.tsx:76
#: src/features/userSaveModal/components/UserSaveModal.tsx:616
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:309
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:451
#: src/fsd/pages/dashboards/ui/change-bar/view-menu.tsx:89
#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:216
#: src/fsd/pages/dashboards/ui/report-problem/report-problem-dialog.tsx:150
#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:169
#: src/fsd/pages/dga-reports/ui/report-problem-dialog.tsx:107
msgid "Cancelar"
msgstr "Cancelar"

#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:250
#: src/features/billing/components/administration/SpiderChart.tsx:64
#: src/features/billing/components/administration/SpiderChart.tsx:116
#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:61
#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:81
#: src/features/events/components/HeaderTable.tsx:20
msgid "Cantidad"
msgstr "Cantidad"

#: src/features/createDevice/components/form/index.tsx:141
#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:344
msgid "Cantidad de acciones"
msgstr "Cantidad de acciones"

#: src/features/audit/utils/parseProperty.ts:67
msgid "cantidad de baterías"
msgstr "cantidad de baterías"

#: src/features/deviceConfiguration/data/sectionFields.ts:82
#: src/features/deviceConfiguration/data/sectionInputs.ts:90
msgid "Cantidad de baterías"
msgstr "Cantidad de baterías"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:294
msgid "Cantidad de eventos"
msgstr "Cantidad de eventos"

#: src/features/audit/utils/parseProperty.ts:72
msgid "cantidad de paneles solares"
msgstr "cantidad de paneles solares"

#: src/features/deviceConfiguration/data/sectionFields.ts:130
#: src/features/deviceConfiguration/data/sectionInputs.ts:136
msgid "Cantidad de paneles solares"
msgstr "Cantidad de paneles solares"

#: src/features/metricsViews/components/forms/AllocationPerformanceWidgetForm.tsx:132
msgid "Cantidad fija"
msgstr "Cantidad fija"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:89
msgid "Capacidad"
msgstr "Capacidad"

#: src/features/audit/utils/parseProperty.ts:70
msgid "capacidad de batería"
msgstr "capacidad de batería"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:8
msgid "Capacidad de batería"
msgstr "Capacidad de batería"

#: src/features/audit/utils/parseProperty.ts:158
msgid "capacidad de la batería"
msgstr "capacidad de la batería"

#: src/features/deviceProfile/components/page/modularComponents/HousingTab.tsx:54
msgid "Capas acero blindado"
msgstr "Capas acero blindado"

#: src/utils/devices/formatSourceColor.ts:21
#: src/utils/formatSource.ts:12
msgid "Capta"
msgstr "Capta"

#: src/features/devices2/components/DevicesHeader.tsx:232
#: src/features/organizationsManagement/components/OrganizationsTableFilters.tsx:56
#: src/features/users/components/UsersTableFilters.tsx:103
msgid "Características"
msgstr "Características"

#: src/features/deviceProfile/components/page/modularComponents/HousingTab.tsx:36
#: src/features/deviceProfile/components/page/modularComponents/HousingTab.tsx:42
msgid "Carcasa acero"
msgstr "Carcasa acero"

#: src/features/deviceSupport/data/column.ts:69
msgid "Carga diaria (%/día)"
msgstr "Carga diaria (%/día)"

#: src/features/deviceProfile/components/page/Support.tsx:122
#: src/features/deviceSupport/data/fields.ts:14
msgid "Carga diaria de batería"
msgstr "Carga diaria de batería"

#: src/features/collections/components/modals/CreateCollectionModal.tsx:70
#: src/features/collections/components/modals/UpdateCollectionModal.tsx:94
#: src/features/homeAmaru/utils/myCollectionSchema.ts:39
#: src/features/homeAmaru/utils/myCollectionSchema.ts:56
msgid "Carga una imagen"
msgstr "Carga una imagen"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:293
msgid "Carga y Descarga de Pagos"
msgstr "Carga y Descarga de Pagos"

#: src/features/billing/components/modals/ServiceFileManager.tsx:299
msgid "Carga y descarga de servicios"
msgstr "Carga y descarga de servicios"

#: src/fsd/entities/dashboard-widget/model/chart-sample.ts:127
#: src/fsd/entities/dashboard-widget/model/data-sample.ts:117
#: src/fsd/entities/dashboard-widget/model/dga-chart-sample.ts:79
#: src/fsd/entities/dashboard-widget/model/dga-reports-sample.ts:78
#: src/fsd/entities/dashboard-widget/model/dga-tickets-sample.ts:51
#: src/fsd/entities/dashboard-widget/model/gate-movements-sample.ts:85
#: src/fsd/entities/dashboard-widget/model/gate-operate-sample.ts:93
#: src/fsd/entities/dashboard-widget/model/gate-sensors-sample.ts:67
#: src/fsd/entities/dashboard-widget/model/table-sample.ts:78
#: src/fsd/entities/dashboard-widget/ui/chart/chart-view.tsx:133
#: src/fsd/entities/dashboard-widget/ui/data/data-view.tsx:70
#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-view.tsx:79
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:251
#: src/fsd/entities/dashboard-widget/ui/dga-tickets/dga-tickets-view.tsx:139
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:333
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-view.tsx:142
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-view.tsx:170
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:313
#: src/fsd/entities/dashboard-widget/ui/table/table-view.tsx:93
msgid "Cargando"
msgstr "Cargando"

#: src/features/deviceCommands/components/custom/DevicesSelector.tsx:26
#: src/features/deviceCommands/components/custom/DevicesSelector.tsx:31
#: src/features/deviceCommands/components/DeviceSelector.tsx:47
msgid "Cargando dispositivos..."
msgstr "Cargando dispositivos..."

#: src/fsd/pages/gate-movements/ui/states/skeletons.tsx:18
msgid "Cargando el movimiento…"
msgstr "Cargando el movimiento…"

#: src/features/devices2/components/list/itemPanel/DeviceItemPicture.tsx:108
msgid "Cargando imagen..."
msgstr "Cargando imagen..."

#: src/fsd/features/gate-movements/ui/operation/gate-operation-modal.tsx:82
msgid "Cargando la operación…"
msgstr "Cargando la operación…"

#: src/fsd/features/gate-movements/ui/list/list-skeleton.tsx:12
msgid "Cargando los movimientos…"
msgstr "Cargando los movimientos…"

#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:242
msgid "Cargando previsualización..."
msgstr "Cargando previsualización..."

#: src/fsd/pages/dashboards/ui/states/skeletons.tsx:78
msgid "Cargando tablero…"
msgstr "Cargando tablero…"

#: src/fsd/pages/dashboards/ui/states/skeletons.tsx:45
msgid "Cargando tableros…"
msgstr "Cargando tableros…"

#: src/features/createMyCollectionModal/components/CreateMyCollectionModal.tsx:89
#: src/features/homeAmaru/components/shared/UpdateMyCollectionModal.tsx:97
msgid "Cargando usuarios..."
msgstr "Cargando usuarios..."

#: src/components/TableLoading.tsx:24
#: src/features/standardDesign/components/autocomplete/StandardAutocomplete.tsx:92
msgid "Cargando..."
msgstr "Cargando..."

#: src/fsd/features/gate-movements/ui/list/movement-list.tsx:73
msgid "Cargando…"
msgstr "Cargando…"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:303
#: src/features/billing/components/modals/ServiceFileManager.tsx:309
msgid "Cargar"
msgstr "Cargar"

#: src/features/deviceConfiguration/components/ConfigurationFileHistoryModal.tsx:171
#: src/features/notifications/components/popup/MenuList.tsx:175
#: src/fsd/features/gate-movements/ui/list/movement-list.tsx:73
msgid "Cargar más"
msgstr "Cargar más"

#: src/fsd/pages/widget-catalog/ui/widget-catalog-page.tsx:55
msgid "Catálogo de widgets"
msgstr "Catálogo de widgets"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:269
msgid "Categorías"
msgstr "Categorías"

#: src/utils/attributes/metricField.ts:227
msgid "caudal"
msgstr "caudal"

#: src/components/PicturePreview.tsx:150
#: src/components/PicturePreview.tsx:161
#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:88
#: src/features/alertsConfigurationV2/components/AlertsConfigurationV2.tsx:91
#: src/features/controlCenter/utils/minicharts.ts:223
#: src/features/deviceAlertsModal/components/basicConfigurationTab/FormComponent.tsx:59
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/CurvesPreview.tsx:88
#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:41
#: src/features/devices2/components/list/itemPanel/DeviceItemMinichart.tsx:326
#: src/features/devicesAnalysis/components/panel/Chart.tsx:310
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAlertLevelsCheckboxList.tsx:33
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarDGACheckboxList.tsx:26
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:39
#: src/features/dga/components/modals/reports/TableModal.tsx:231
#: src/features/publicOrganizationSettingsModal/components/PublicOrganizationSettingsForm.tsx:48
#: src/features/sma/components/TableModal.tsx:263
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:8
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:53
#: src/fsd/pages/widget-catalog/model/examples.ts:219
#: src/hooks/useMinichartOptions.ts:38
#: src/utils/attributes/deviceAlertMetricName.ts:17
#: src/utils/i18n/getMetricDisplayName.ts:7
msgid "Caudal"
msgstr "Caudal"

#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:131
#: src/fsd/pages/dga-reports/ui/latest-reports.tsx:163
msgid "Caudal ({FLOW_UNIT})"
msgstr "Caudal ({FLOW_UNIT})"

#: src/features/reports/utils/metricHelpers.ts:8
msgid "Caudal (Q)"
msgstr "Caudal (Q)"

#: src/utils/i18n/getMetricDisplayName.ts:8
msgid "Caudal (raw)"
msgstr "Caudal (raw)"

#: src/features/echarts/utils/commonSeries.ts:161
msgid "Caudal alto"
msgstr "Caudal alto"

#: src/features/echarts/utils/commonSeries.ts:160
msgid "Caudal bajo"
msgstr "Caudal bajo"

#: src/utils/attributes/metricField.ts:239
msgid "caudal bruto"
msgstr "caudal bruto"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:310
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:25
msgid "Caudal bruto"
msgstr "Caudal bruto"

#: src/features/audit/utils/parseProperty.ts:138
msgid "caudal de desborde"
msgstr "caudal de desborde"

#: src/features/audit/utils/parseProperty.ts:108
msgid "caudal de río"
msgstr "caudal de río"

#: src/features/echarts/utils/commonSeries.ts:162
msgid "Caudal desborde"
msgstr "Caudal desborde"

#: src/utils/attributes/metricField.ts:149
msgid "caudal dga"
msgstr "caudal dga"

#: src/features/reports/utils/metricHelpers.ts:14
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:19
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:64
#: src/utils/i18n/getMetricDisplayName.ts:9
msgid "Caudal DGA"
msgstr "Caudal DGA"

#: src/features/audit/utils/parseProperty.ts:137
msgid "caudal máximo"
msgstr "caudal máximo"

#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:142
#: src/features/dga/components/modals/UpdateDGAConfigurationModal.tsx:88
msgid "Caudal máximo"
msgstr "Caudal máximo"

#: src/features/dga/components/modals/tabs/MaxFlowTab.tsx:30
msgid "Caudal máximo actualizado correctamente"
msgstr "Caudal máximo actualizado correctamente"

#: src/features/echarts/utils/commonSeries.ts:175
#: src/features/echarts/utils/commonSeries.ts:176
msgid "Caudal máximo de reparto"
msgstr "Caudal máximo de reparto"

#: src/features/dga/components/modals/tabs/MaxFlowTab.tsx:81
msgid "Caudal máximo en L/s"
msgstr "Caudal máximo en L/s"

#: src/features/audit/utils/parseProperty.ts:136
msgid "caudal mínimo"
msgstr "caudal mínimo"

#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:126
msgid "Caudal mínimo"
msgstr "Caudal mínimo"

#: src/fsd/pages/widget-catalog/model/examples.ts:232
#: src/fsd/pages/widget-catalog/model/examples.ts:254
msgid "Caudal y nivel"
msgstr "Caudal y nivel"

#: src/fsd/pages/dga-reports/ui/reports-heatmap.tsx:245
msgid "Caudal: <0>{flow}</0>"
msgstr "Caudal: <0>{flow}</0>"

#: src/fsd/entities/dashboard-widget/model/table-sample.ts:74
msgid "Celdas faltantes"
msgstr "Celdas faltantes"

#: src/components/ColorPicker/palettes.ts:35
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:33
msgid "Celeste"
msgstr "Celeste"

#: src/fsd/shared/ui/format/units.ts:241
#: src/utils/units.ts:298
msgid "celsius"
msgstr "celsius"

#: src/features/devices2/components/DevicesHeader.tsx:209
#: src/features/users/components/UsersTableFilters.tsx:88
msgid "Cementerio"
msgstr "Cementerio"

#: src/features/devicesGraveyard/components/DevicesGraveyard.tsx:284
msgid "Cementerio de dispositivos"
msgstr "Cementerio de dispositivos"

#: src/features/usersGraveyard/components/UsersGraveyard.tsx:225
msgid "Cementerio de usuarios"
msgstr "Cementerio de usuarios"

#: src/fsd/shared/ui/format/units.ts:71
#: src/utils/units.ts:128
msgid "centímetro"
msgstr "centímetro"

#: src/fsd/shared/ui/format/units.ts:135
#: src/utils/units.ts:192
msgid "centímetro por segundo"
msgstr "centímetro por segundo"

#: src/fsd/pages/widget-catalog/model/examples.ts:373
msgid "Centrado"
msgstr "Centrado"

#: src/fsd/entities/dashboard-widget/ui/text/text-editor.tsx:15
msgid "Centro"
msgstr "Centro"

#: src/features/homeAmaru/components/shared/CollectionMap.tsx:255
msgid "Centro de control"
msgstr "Centro de control"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:64
#: src/features/homeAmaru/components/shared/WorkspaceHeader.tsx:32
#: src/features/metricsViews/utils/quickAccessCatalog.tsx:95
#: src/features/organizationAccess/data/sections.ts:21
#: src/fsd/entities/dashboard-widget/ui/quick-access/destinations.ts:79
#: src/pages/control-center/index.tsx:74
#: src/pages/control-center2/index.tsx:9
msgid "Centro de Control"
msgstr "Centro de Control"

#: src/features/audit/utils/parseProperty.ts:112
msgid "CENTRO LLANO activado"
msgstr "CENTRO LLANO activado"

#: src/features/deviceProfile/components/page/modularComponents/HousingTab.tsx:61
msgid "Cerradura caja fuerte"
msgstr "Cerradura caja fuerte"

#: src/components/modal/ModalActions.tsx:100
#: src/components/PicturePreview.tsx:80
#: src/components/telemetry/regis/SimplePicturePreview.tsx:42
#: src/features/alertsConfigurationV3/components/wizard/AlertWizardModal.tsx:241
#: src/features/announcements/components/AnnouncementsViewModal.tsx:97
#: src/features/controlCenter2/components/versionSwitch/FormPopup.tsx:57
#: src/features/debtsAlert/components/DebtsAlertModal.tsx:113
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LevelCalibrationForm.tsx:135
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LGCalibrationDisplay.tsx:145
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleCalibrationForm.tsx:158
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:542
#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:191
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:264
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:376
#: src/features/notifications/components/NotificationMessageViewModal.tsx:104
#: src/features/organizationAccess/components/OrganizationAccess.tsx:155
#: src/features/reports/components/CreatedReportNotification.tsx:118
#: src/features/reports2/components/versionSwitch/FormPopup.tsx:77
#: src/features/reports2/components/versionSwitch/FormPopup.tsx:103
#: src/fsd/app/locale/au-labels.ts:60
msgid "Cerrar"
msgstr "Cerrar"

#: src/components/modal/ConfirmationModal.tsx:48
msgid "Cerrar formulario"
msgstr "Cerrar formulario"

#: src/components/SectionTitleWithInfo.tsx:55
#: src/components/SectionTitleWithInfo.tsx:87
msgid "Cerrar información"
msgstr "Cerrar información"

#: src/features/controlCenter2/components/ControlCenter.tsx:119
msgid "Cerrar listado de dispositivos"
msgstr "Cerrar listado de dispositivos"

#: src/features/controlCenter/components/window/Window.tsx:266
msgid "Cerrar menú de opciones"
msgstr "Cerrar menú de opciones"

#: src/features/userMenu/components/UserMenu.tsx:143
msgid "Cerrar sesión"
msgstr "Cerrar sesión"

#: src/features/dgaTicket/components/DgaTicketModal.tsx:313
#: src/features/dgaTicket/components/DgaTicketModal.tsx:387
msgid "Cerrar ticket"
msgstr "Cerrar ticket"

#: src/features/controlCenter/components/window/Window.tsx:279
msgid "Cerrar ventana"
msgstr "Cerrar ventana"

#: src/features/createDeviceConfiguration/components/tabs/general/GeneralTabContent.tsx:223
msgid "Certificado y VPN"
msgstr "Certificado y VPN"

#: src/fsd/shared/ui/format/units.ts:48
#: src/utils/units.ts:105
msgid "CFM"
msgstr "CFM"

#: src/fsd/shared/ui/format/units.ts:53
#: src/utils/units.ts:110
msgid "CFS"
msgstr "CFS"

#: src/fsd/entities/dashboard-widget/ui/format/unit-symbol.ts:37
#: src/fsd/shared/ui/format/units.ts:173
#: src/utils/units.ts:230
msgid "CFS/acc"
msgstr "CFS/acc"

#: src/components/ColorPicker/palettes.ts:36
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:34
#: src/fsd/pages/dashboards/ui/board-color/color-names.ts:8
msgid "Cian"
msgstr "Cian"

#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:35
msgid "Cierre"
msgstr "Cierre"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:478
msgid "Círculo"
msgstr "Círculo"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:56
msgid "Click"
msgstr "Click"

#: src/fsd/pages/dashboards/ui/change-bar/add-widget.tsx:61
#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:91
msgid "Click o arrastra a una celda."
msgstr "Click o arrastra a una celda."

#: src/features/billing/components/table/DevicesTable.tsx:150
#: src/features/billing/components/table/OrganizationsTable.tsx:67
#: src/features/deviceSupport/data/column.ts:7
#: src/features/deviceSupport/data/fields.ts:6
msgid "Cliente"
msgstr "Cliente"

#: src/utils/devices/formatSourceColor.ts:22
#: src/utils/formatSource.ts:13
msgid "Clón"
msgstr "Clón"

#: src/utils/devices/formatSourceColor.ts:40
msgid "Clón de {sourceInfo}"
msgstr "Clón de {sourceInfo}"

#: src/features/deviceConfigurationModal/components/cloneDeviceModal/CloneDeviceModal.tsx:118
msgid "Clonar"
msgstr "Clonar"

#: src/features/deviceConfigurationModal/components/cloneDeviceModal/CloneDeviceModal.tsx:133
#: src/features/deviceConfigurationModal/components/cloneDeviceModal/CloneDeviceModal.tsx:156
#: src/features/deviceConfigurationModal/components/DeviceConfigurationModal.tsx:106
msgid "Clonar dispositivo"
msgstr "Clonar dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:226
msgid "Clonar Dispositivo"
msgstr "Clonar Dispositivo"

#: src/features/devices2/utils/getVisibleDeviceTypeOptions.ts:26
msgid "Clones"
msgstr "Clones"

#: src/features/audit/utils/getDisplayNameActionType.ts:120
msgid "clonó el dispositivo"
msgstr "clonó el dispositivo"

#: src/fsd/shared/ui/format/units.ts:70
#: src/utils/units.ts:127
msgid "cm"
msgstr "cm"

#: src/fsd/shared/ui/format/units.ts:134
#: src/utils/units.ts:191
msgid "cm/s"
msgstr "cm/s"

#: src/features/updateMultipleDevicesTags/components/UpdateMultipleDevicesTagsModal.tsx:169
msgid "Cobrabilidad"
msgstr "Cobrabilidad"

#: src/features/devices2/utils/featuresFilter.ts:27
#: src/features/devices2/utils/featuresFilter.ts:33
#: src/features/devices2/utils/featuresFilter.ts:39
#: src/features/updateMultipleDevicesTags/components/UpdateMultipleDevicesTagsModal.tsx:251
msgid "Cobrable"
msgstr "Cobrable"

#: src/features/updateMultipleDevicesTags/components/UpdateMultipleDevicesTagsModal.tsx:164
msgid "Cobrables"
msgstr "Cobrables"

#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:68
#: src/features/integrations/components/groupedIssuesModal/GroupedLogsTable.tsx:55
#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:117
msgid "Código"
msgstr "Código"

#: src/fsd/pages/widget-catalog/ui/config-code.tsx:43
msgid "Código de configuración"
msgstr "Código de configuración"

#: src/features/gateOperationModal/components/PanelSummary.tsx:44
#: src/fsd/features/gate-movements/ui/operation/operation-summary.tsx:55
msgid "Código de la operación"
msgstr "Código de la operación"

#: src/features/audit/utils/parseProperty.ts:120
msgid "código de llamada"
msgstr "código de llamada"

#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:40
msgid "Código de obra"
msgstr "Código de obra"

#: src/features/audit/utils/parseProperty.ts:7
msgid "codigo de obra DGA"
msgstr "codigo de obra DGA"

#: src/features/countryCallingAutocomplete/CallingCodeAutocomplete.tsx:34
#: src/features/countryCallingAutocomplete/index.tsx:41
msgid "Código de país"
msgstr "Código de país"

#: src/fsd/pages/dga-reports/ui/report-problem-dialog.tsx:118
msgid "Código de ticket DGA"
msgstr "Código de ticket DGA"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:40
#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:221
#: src/features/dga/components/modals/tabs/GeneralTab.tsx:145
msgid "Código DGA"
msgstr "Código DGA"

#: src/features/login/components/Login.tsx:90
msgid "Código no válido!"
msgstr "Código no válido!"

#: src/features/deviceConfiguration/data/sectionFields.ts:215
msgid "Código Widgetlord"
msgstr "Código Widgetlord"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:238
msgid "Coeficiente A"
msgstr "Coeficiente A"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:251
msgid "Coeficiente B"
msgstr "Coeficiente B"

#: src/features/deviceProfile/components/page/Permissions.tsx:84
msgid "Colapsar"
msgstr "Colapsar"

#: src/fsd/pages/dashboards/ui/panel/panel.tsx:124
msgid "Colapsar el panel"
msgstr "Colapsar el panel"

#: src/fsd/pages/widget-catalog/ui/side-panel.tsx:84
msgid "Colapsar el panel: {label}"
msgstr "Colapsar el panel: {label}"

#: src/features/devicesAnalysisV3/components/TimelineMinimap.tsx:406
msgid "Colapsar minimapa"
msgstr "Colapsar minimapa"

#: src/features/homeAmaru/components/HomeAmaru.tsx:256
#: src/features/homeAmaru/components/shared/HomeAmaruSkeleton.tsx:59
#: src/features/metricsViews/components/AssociateCollectionModal.tsx:193
#: src/features/metricsViews/components/MetricsViewList.tsx:144
#: src/features/metricsViews/components/MetricsViewsHeader.tsx:55
msgid "Colección"
msgstr "Colección"

#: src/features/collections/hooks/useUpdateCollectionForm.ts:52
msgid "Colección actualizada exitosamente"
msgstr "Colección actualizada exitosamente"

#: src/features/collections/hooks/useCreateCollectionForm.ts:26
#: src/features/createMyCollectionModal/hooks/useCreateMyCollectionForm.tsx:45
msgid "Colección creada exitosamente"
msgstr "Colección creada exitosamente"

#: src/features/homeAmaru/components/shared/CollectionActions.tsx:63
msgid "Colección creada por Amaru, no se puede editar"
msgstr "Colección creada por Amaru, no se puede editar"

#: src/features/homeAmaru/components/shared/CollectionActions.tsx:69
msgid "Colección creada por Amaru, no se puede eliminar"
msgstr "Colección creada por Amaru, no se puede eliminar"

#: src/features/collections/components/modals/DeleteCollectionModal.tsx:56
msgid "Colección eliminada correctamente"
msgstr "Colección eliminada correctamente"

#: src/features/homeAmaru/hooks/useDeleteMyCollection.tsx:22
msgid "Colección eliminada exitosamente"
msgstr "Colección eliminada exitosamente"

#: src/features/createDevice/components/form/index.tsx:129
#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:189
#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:333
msgid "Colecciones"
msgstr "Colecciones"

#: src/features/deviceAccessModal/components/collectionsAccessTab/index.tsx:90
msgid "Colecciones a las que pertenece el dispositivo"
msgstr "Colecciones a las que pertenece el dispositivo"

#: src/features/userConfigurationModal/components/collectionsAccessTab/index.tsx:90
msgid "Colecciones a las que tiene acceso el usuario"
msgstr "Colecciones a las que tiene acceso el usuario"

#: src/features/billing/components/modals/ServiceFileManager.tsx:191
msgid "Colocar la cantidad de columnas necesarias por dispositivo. Si la fila tiene un valor para la columna, se creará el servicio para el dispositivo."
msgstr "Colocar la cantidad de columnas necesarias por dispositivo. Si la fila tiene un valor para la columna, se creará el servicio para el dispositivo."

#: src/features/billing/components/modals/ServiceFileManager.tsx:200
msgid "Colocar la fecha de expiración para cada servicio con valor en la fila. Ejemplo: 4/2/2026"
msgstr "Colocar la fecha de expiración para cada servicio con valor en la fila. Ejemplo: 4/2/2026"

#: src/features/api/components/dialogs/SetApiUserPasswordDialog.tsx:89
msgid "Coloque la nueva contraseña para el usuario {0}:"
msgstr "Coloque la nueva contraseña para el usuario {0}:"

#: src/components/ColorPicker/ColorPicker.tsx:158
#: src/features/collections/components/CollectionVisualRepresentationFields.tsx:54
#: src/features/createMyCollectionModal/components/CreateMyCollectionModal.tsx:109
#: src/features/homeAmaru/components/shared/UpdateMyCollectionModal.tsx:117
#: src/features/metricsViews/components/forms/ButtonWidgetForm.tsx:64
#: src/features/metricsViews/components/forms/ButtonWidgetForm.tsx:170
#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:423
#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:198
msgid "Color"
msgstr "Color"

#: src/features/metricsViews/components/forms/TrendSummaryForm.tsx:223
msgid "Color de la fila {0}"
msgstr "Color de la fila {0}"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:429
msgid "Color de la serie {0}"
msgstr "Color de la serie {0}"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:200
msgid "Color de la serie {n}"
msgstr "Color de la serie {n}"

#: src/features/metricsViews/components/forms/DataWidgetForm.tsx:200
#: src/features/metricsViews/components/forms/DataWidgetForm.tsx:206
msgid "Color de la tendencia"
msgstr "Color de la tendencia"

#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:323
msgid "Color del intervalo {0}"
msgstr "Color del intervalo {0}"

#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:188
#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:194
msgid "Color del tablero"
msgstr "Color del tablero"

#: src/components/ColorPicker/ColorPicker.tsx:313
#: src/fsd/entities/dashboard-widget/ui/color-field/color-field.tsx:161
msgid "Color hexadecimal"
msgstr "Color hexadecimal"

#: src/components/ColorPicker/ColorPicker.tsx:311
#: src/fsd/entities/dashboard-widget/ui/color-field/color-field.tsx:162
msgid "Color inválido (usa #rrggbb)"
msgstr "Color inválido (usa #rrggbb)"

#: src/components/ColorPicker/ColorPicker.tsx:284
msgid "Color personalizado"
msgstr "Color personalizado"

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:312
msgid "Columna"
msgstr "Columna"

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:296
msgid "Columna {column}, fila {row}"
msgstr "Columna {column}, fila {row}"

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:12
msgid "columna {column}, fila {row}, de {w} por {h}"
msgstr "columna {column}, fila {row}, de {w} por {h}"

#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:81
msgid "Columna {n}"
msgstr "Columna {n}"

#: src/features/metricsViews/components/forms/TableWidgetForm.tsx:121
msgid "Columnas"
msgstr "Columnas"

#: src/features/deviceCommands/components/DeviceCommandsHistoryTable.tsx:33
msgid "Comando"
msgstr "Comando"

#: src/features/deviceCommands/components/calendar/UpdateCommandKeyDialog.tsx:36
msgid "Comando actualizado correctamente."
msgstr "Comando actualizado correctamente."

#: src/features/gateAdministration/components/MoveGate.tsx:91
msgid "Comando de movimiento enviado correctamente"
msgstr "Comando de movimiento enviado correctamente"

#: src/features/deviceCommands/components/calendar/DeleteScheduleCommandKeyDialog.tsx:33
msgid "Comando eliminado correctamente."
msgstr "Comando eliminado correctamente."

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:31
msgid "Comando enviado correctamente"
msgstr "Comando enviado correctamente"

#: src/features/deviceCommands/components/calendar/StandardCommandsSelector.tsx:58
#: src/features/deviceCommands/components/calendar/StandardCommandsSelector.tsx:63
msgid "Comando Estándar"
msgstr "Comando Estándar"

#: src/features/controlCenter2/components/versionSwitch/FeedbackDialog.tsx:95
#: src/features/reports2/components/versionSwitch/FeedbackDialog.tsx:118
msgid "Comentario opcional..."
msgstr "Comentario opcional..."

#: src/features/reports2/components/versionSwitch/FeedbackDialog.tsx:118
msgid "Comentario requerido..."
msgstr "Comentario requerido..."

#: src/features/metricsViews/components/MetricsView.tsx:714
msgid "Comienza con una sugerencia o pídele un tablero al asistente"
msgstr "Comienza con una sugerencia o pídele un tablero al asistente"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:222
msgid "como arrastrarlo: ↑ ↓ un puesto en su columna, ← → una columna; con el foco en una card seleccionada mueve todo el grupo"
msgstr "como arrastrarlo: ↑ ↓ un puesto en su columna, ← → una columna; con el foco en una card seleccionada mueve todo el grupo"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:212
msgid "como un click"
msgstr "como un click"

#: src/features/billing/components/modals/ServiceFileManager.tsx:195
msgid "Como valor para cada fila colocar primero la moneda y luego el número, utilizando un punto para separar los decimales. Ejemplos: USD11.40, UF2, CLP60000."
msgstr "Como valor para cada fila colocar primero la moneda y luego el número, utilizando un punto para separar los decimales. Ejemplos: USD11.40, UF2, CLP60000."

#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:146
#: src/fsd/pages/widget-catalog/model/examples.ts:258
msgid "Compacta"
msgstr "Compacta"

#: src/features/metricsViews/components/forms/TableWidgetForm.tsx:96
msgid "Compacto"
msgstr "Compacto"

#: src/features/metricsViews/components/forms/DataWidgetForm.tsx:175
#: src/features/metricsViews/components/widgets/trendSummary/index.tsx:206
msgid "Comparar con"
msgstr "Comparar con"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:33
msgid "Comparar estaciones"
msgstr "Comparar estaciones"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:32
msgid "Comparativas y cumplimiento"
msgstr "Comparativas y cumplimiento"

#: src/features/collectionsAccessInputs/components/CollectionsListItem.tsx:87
msgid "Compartida por otra organización — asignada por un administrador; no editable."
msgstr "Compartida por otra organización — asignada por un administrador; no editable."

#: src/features/gates/components/list/GateListItemLastMovement.tsx:75
msgid "COMPLETADO"
msgstr "COMPLETADO"

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-editor.tsx:12
#: src/fsd/pages/widget-catalog/model/examples.ts:274
msgid "Completo"
msgstr "Completo"

#: src/features/deviceProfile/components/DeviceProfile.tsx:83
msgid "Componentes modulares"
msgstr "Componentes modulares"

#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:132
#: src/fsd/pages/dga-reports/ui/latest-reports.tsx:171
msgid "Comprobante"
msgstr "Comprobante"

#: src/fsd/pages/dga-reports/ui/latest-reports.tsx:279
msgid "Comprobante copiado"
msgstr "Comprobante copiado"

#: src/features/dga/components/modals/reports/TableModal.tsx:270
#: src/features/sma/components/TableModal.tsx:279
msgid "Comprobante: {0}"
msgstr "Comprobante: {0}"

#: src/fsd/pages/gate-movements/ui/list/gate-select.tsx:24
#: src/pages/gates/administration/[gateId].tsx:23
msgid "Compuerta"
msgstr "Compuerta"

#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:19
#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:28
#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:38
msgid "Compuerta A"
msgstr "Compuerta A"

#: src/features/gateOperationModal/components/panelNotification/utils.tsx:231
#: src/fsd/features/gate-movements/ui/panel/events/event-text.tsx:153
msgid "Compuerta alcanzó el límite inferior"
msgstr "Compuerta alcanzó el límite inferior"

#: src/features/gateOperationModal/components/panelNotification/utils.tsx:234
#: src/fsd/features/gate-movements/ui/panel/events/event-text.tsx:155
msgid "Compuerta alcanzó el límite superior"
msgstr "Compuerta alcanzó el límite superior"

#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:29
#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:39
msgid "Compuerta B"
msgstr "Compuerta B"

#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:40
msgid "Compuerta C"
msgstr "Compuerta C"

#: src/features/gateOperationModal/components/panelNotification/utils.tsx:237
#: src/fsd/features/gate-movements/ui/panel/events/event-text.tsx:157
msgid "Compuerta en modo manual"
msgstr "Compuerta en modo manual"

#: src/features/gateAdministration/components/index.tsx:321
msgid "Compuerta en movimiento"
msgstr "Compuerta en movimiento"

#: src/features/gateCommon/utils/gateMovementState.tsx:232
msgid "Compuerta en<0/><1>movimiento</1>"
msgstr "Compuerta en<0/><1>movimiento</1>"

#: src/features/gateCommon/utils/gateCloseCode.ts:49
#: src/fsd/entities/gate/model/close-code.ts:34
msgid "Compuerta ya en la posición solicitada"
msgstr "Compuerta ya en la posición solicitada"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:101
#: src/features/organizationAccess/data/sections.ts:25
#: src/fsd/entities/dashboard-widget/ui/type-groups.ts:31
#: src/pages/gates/index.tsx:11
msgid "Compuertas"
msgstr "Compuertas"

#: src/features/devicesAccessInputs/components/DevicesFiltersMenu.tsx:88
msgid "Con acceso"
msgstr "Con acceso"

#: src/features/userConfigurationModal/components/allAccessTab/index.tsx:102
msgid "Con acceso a <0>{0}</0> dispositivos"
msgstr "Con acceso a <0>{0}</0> dispositivos"

#: src/features/devicesAccessInputs/components/DevicesAccessForUserInput.tsx:127
msgid "Con acceso a <0>{withAccessNumber}</0> dispositivos de <1>{totalNumber}</1>"
msgstr "Con acceso a <0>{withAccessNumber}</0> dispositivos de <1>{totalNumber}</1>"

#: src/features/users/utils/filterOptions.ts:99
msgid "Con autenticación en 2 pasos"
msgstr "Con autenticación en 2 pasos"

#: src/fsd/pages/widget-catalog/model/examples.ts:461
msgid "Con claves desconocidas"
msgstr "Con claves desconocidas"

#: src/features/metricsViews/utils/getMetricsViewsCollectionFilterOptions.ts:20
msgid "Con colección"
msgstr "Con colección"

#: src/fsd/pages/widget-catalog/model/examples.ts:248
#: src/fsd/pages/widget-catalog/model/examples.ts:263
msgid "Con conexión"
msgstr "Con conexión"

#: src/features/organizationsManagement/utils/filterOptions.ts:12
msgid "Con deuda activada"
msgstr "Con deuda activada"

#: src/features/deviceSupport/data/dga.ts:12
msgid "Con DGA"
msgstr "Con DGA"

#: src/fsd/pages/widget-catalog/model/examples.ts:324
#: src/fsd/pages/widget-catalog/model/examples.ts:355
msgid "Con dispositivo"
msgstr "Con dispositivo"

#: src/fsd/pages/widget-catalog/model/examples.ts:439
msgid "Con dispositivo preseleccionado"
msgstr "Con dispositivo preseleccionado"

#: src/features/controlCenter2/hooks/useLegendsForView.ts:101
msgid "Con dotación"
msgstr "Con dotación"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:98
#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:107
msgid "con el foco en una card"
msgstr "con el foco en una card"

#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-editor.tsx:46
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-editor.tsx:57
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-editor.tsx:46
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-editor.tsx:67
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-editor.tsx:47
msgid "Con el nombre del dispositivo, el título no se muestra."
msgstr "Con el nombre del dispositivo, el título no se muestra."

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:239
msgid "Con envío diario, semanal o mensual el período lo fija la frecuencia de envío DGA del dispositivo."
msgstr "Con envío diario, semanal o mensual el período lo fija la frecuencia de envío DGA del dispositivo."

#: src/fsd/pages/dga-reports/ui/device-row.tsx:157
msgid "Con envíos fallidos"
msgstr "Con envíos fallidos"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:363
msgid "Con esta configuración los próximos reportes se generarían en las siguientes fechas"
msgstr "Con esta configuración los próximos reportes se generarían en las siguientes fechas"

#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:297
msgid "Con esta configuración, los próximos reportes se generarían en las <0>siguientes fechas:</0>"
msgstr "Con esta configuración, los próximos reportes se generarían en las <0>siguientes fechas:</0>"

#: src/fsd/entities/dashboard-widget/model/dga-reports-sample.ts:73
msgid "Con fallas"
msgstr "Con fallas"

#: src/fsd/entities/dashboard-widget/model/dga-chart-sample.ts:76
#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-view.tsx:143
msgid "Con fallidos"
msgstr "Con fallidos"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:134
msgid "con la confirmación de pérdida si hace falta"
msgstr "con la confirmación de pérdida si hace falta"

#: src/fsd/pages/widget-catalog/model/examples.ts:289
#: src/fsd/pages/widget-catalog/model/examples.ts:305
#: src/fsd/pages/widget-catalog/model/examples.ts:330
#: src/fsd/pages/widget-catalog/model/examples.ts:349
msgid "Con nombre del dispositivo"
msgstr "Con nombre del dispositivo"

#: src/features/users/utils/filterOptions.ts:89
msgid "Con organizaciones compartidas"
msgstr "Con organizaciones compartidas"

#: src/features/integrations/components/devicesList/index.tsx:125
#: src/features/integrations/utils/monitoredTargetResponseStatusAttributes.ts:75
msgid "Con problemas"
msgstr "Con problemas"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:67
msgid "con Shift o Ctrl suma a la selección"
msgstr "con Shift o Ctrl suma a la selección"

#: src/fsd/pages/widget-catalog/model/examples.ts:317
msgid "Con subtítulo"
msgstr "Con subtítulo"

#: src/fsd/pages/widget-catalog/model/examples.ts:298
msgid "Con título"
msgstr "Con título"

#: src/fsd/pages/widget-catalog/model/examples.ts:402
msgid "Con tooltip"
msgstr "Con tooltip"

#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:85
msgid "Con zona horaria"
msgstr "Con zona horaria"

#: src/utils/attributes/metricField.ts:125
msgid "conductividad"
msgstr "conductividad"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:340
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:192
#: src/features/reports/utils/metricHelpers.ts:11
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:29
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:74
#: src/utils/attributes/deviceAlertMetricName.ts:47
#: src/utils/i18n/getMetricDisplayName.ts:33
msgid "Conductividad"
msgstr "Conductividad"

#: src/utils/attributes/metricField.ts:131
msgid "conductividad bruta"
msgstr "conductividad bruta"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:340
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:136
msgid "Conductividad bruta"
msgstr "Conductividad bruta"

#: src/features/echarts/utils/commonSeries.ts:461
#: src/features/gateOperationModal/components/ConnectionStatus.tsx:124
#: src/fsd/features/gate-movements/ui/operation/connection-status.tsx:62
msgid "conectado"
msgstr "conectado"

#: src/features/gateAdministration/components/index.tsx:594
#: src/features/metricsViews/components/widgets/DataWidget.tsx:492
#: src/fsd/entities/dashboard-widget/ui/data/data-view.tsx:100
#: src/fsd/entities/dashboard-widget/ui/table/table-view.tsx:73
msgid "Conectado"
msgstr "Conectado"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:109
msgid "Conectado recientemente"
msgstr "Conectado recientemente"

#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:114
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:100
msgid "conectados"
msgstr "conectados"

#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:113
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:99
#: src/features/homeAmaru/components/shared/CollectionRow.tsx:54
msgid "Conectados"
msgstr "Conectados"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:367
#: src/features/deviceConfiguration/data/sectionFields.ts:460
#: src/features/deviceConfiguration/data/sectionInputs.ts:454
#: src/features/deviceProfile/components/page/modularComponents/index.tsx:28
#: src/features/deviceSupport/data/column.ts:95
#: src/features/deviceSupport/data/column.ts:103
#: src/features/deviceSupport/data/column.ts:110
#: src/features/deviceSupport/data/column.ts:118
#: src/features/homeAmaru/components/HomeAmaru.tsx:257
#: src/features/homeAmaru/components/shared/HomeAmaruSkeleton.tsx:60
msgid "Conectividad"
msgstr "Conectividad"

#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:111
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:97
msgid "CONECTIVIDAD"
msgstr "CONECTIVIDAD"

#: src/features/deviceSupport/data/fields.ts:22
msgid "Conectividad 24 Horas"
msgstr "Conectividad 24 Horas"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-option.ts:34
#: src/fsd/entities/dashboard-widget/ui/chart/chart-option.ts:47
#: src/fsd/entities/dashboard-widget/ui/table/table-view.tsx:45
msgid "Conexión"
msgstr "Conexión"

#: src/features/audit/utils/parseProperty.ts:80
msgid "conexión a internet"
msgstr "conexión a internet"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:52
#: src/features/deviceConfiguration/data/sectionFields.ts:244
#: src/features/deviceConfiguration/data/sectionInputs.ts:260
msgid "Conexión a internet"
msgstr "Conexión a internet"

#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:71
msgid "Configura un rango de emergencia. Recibirás alertas persistentes cada 1 hora hasta que el valor salga de la zona definida."
msgstr "Configura un rango de emergencia. Recibirás alertas persistentes cada 1 hora hasta que el valor salga de la zona definida."

#: src/features/homeAmaru/components/fiveColumn/NewCollectionCardGrid.tsx:26
#: src/features/homeAmaru/components/shared/NewCollectionCard.tsx:26
msgid "Configura y agrega un nuevo conjunto de dispositivos según tus necesidades de monitoreo"
msgstr "Configura y agrega un nuevo conjunto de dispositivos según tus necesidades de monitoreo"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:167
#: src/fsd/pages/widget-catalog/ui/config-panel.tsx:31
#: src/fsd/pages/widget-catalog/ui/widget-catalog-page.tsx:113
msgid "Configuración"
msgstr "Configuración"

#: src/features/homeAmaru/hooks/useUpdateMyCollectionForm.tsx:46
msgid "Configuración actualizada exitosamente"
msgstr "Configuración actualizada exitosamente"

#: src/features/alertsConfiguration/components/AlertTable.tsx:199
msgid "Configuración alerta"
msgstr "Configuración alerta"

#: src/features/deviceProfile/components/page/Alerts.tsx:95
msgid "Configuración alertas de {0}"
msgstr "Configuración alertas de {0}"

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:35
msgid "Configuración aplicada al borrador. Se guarda con el resto de los cambios."
msgstr "Configuración aplicada al borrador. Se guarda con el resto de los cambios."

#: src/features/deviceAlertsModal/components/index.tsx:111
msgid "Configuración avanzada"
msgstr "Configuración avanzada"

#: src/features/deviceAlertsModal/components/index.tsx:105
#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:199
msgid "Configuración básica"
msgstr "Configuración básica"

#: src/features/organizationAccess/components/OrganizationAccess.tsx:111
msgid "Configuración de acceso por organización"
msgstr "Configuración de acceso por organización"

#: src/features/deviceMenu/components/DeviceMenu.tsx:113
#: src/features/users/components/tableCells/UserActionsCell.tsx:93
msgid "Configuración de accesos"
msgstr "Configuración de accesos"

#: src/features/alertsConfigurationV2/hooks/useCreateAlertConfiguration.ts:22
msgid "Configuración de alerta creada correctamente"
msgstr "Configuración de alerta creada correctamente"

#: src/features/alertsConfigurationV2/components/upsertModal/AlertsConfigurationModal.tsx:224
#: src/features/alertsConfigurationV3/components/AlertsConfigurationV3.tsx:75
#: src/features/deviceMenu/components/DeviceMenu.tsx:141
#: src/pages/alerts/index.tsx:15
#: src/pages/alerts/index.tsx:19
#: src/pages/alertsV2/index.tsx:22
#: src/pages/alertsV2/index.tsx:26
#: src/pages/alertsV3/index.tsx:12
msgid "Configuración de alertas"
msgstr "Configuración de alertas"

#: src/features/deviceAlertsModal/components/alertConfigurationTab/FormComponent.tsx:92
#: src/features/deviceAlertsModal/components/basicConfigurationTab/useUpdateForm.ts:57
#: src/features/deviceConfigurationModal/components/gateTab/useUpdateForm.ts:38
msgid "Configuración de alertas actualizada correctamente"
msgstr "Configuración de alertas actualizada correctamente"

#: src/features/metricsViews/utils/quickAccessCatalog.tsx:63
#: src/fsd/entities/dashboard-widget/ui/quick-access/destinations.ts:50
msgid "Configuración de alertas por dispositivo"
msgstr "Configuración de alertas por dispositivo"

#: src/features/audit/utils/parseProperty.ts:130
msgid "configuración de Amaru"
msgstr "configuración de Amaru"

#: src/features/homeAmaru/components/shared/UpdateMyCollectionModal.tsx:208
msgid "Configuración de colección"
msgstr "Configuración de colección"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:195
msgid "Configuración de curva"
msgstr "Configuración de curva"

#: src/features/deviceMenu/components/DeviceMenu.tsx:119
msgid "Configuración de datos"
msgstr "Configuración de datos"

#: src/features/deviceMenu/components/DeviceMenu.tsx:107
msgid "Configuración de dispositivo"
msgstr "Configuración de dispositivo"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:196
#: src/pages/device-configuration.tsx:10
msgid "Configuración de Equipos"
msgstr "Configuración de Equipos"

#: src/features/deviceCommands/components/standard/StandardButtons.tsx:127
msgid "Configuración de equipos estándar"
msgstr "Configuración de equipos estándar"

#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:218
msgid "Configuración de fecha"
msgstr "Configuración de fecha"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:355
msgid "Configuración de Filtros Activos"
msgstr "Configuración de Filtros Activos"

#: src/features/deviceMenu/components/DeviceMenu.tsx:130
#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:161
msgid "Configuración de hardware"
msgstr "Configuración de hardware"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:181
msgid "Configuración de hardware incompleta"
msgstr "Configuración de hardware incompleta"

#: src/features/audit/utils/parseProperty.ts:86
msgid "configuración de IP"
msgstr "configuración de IP"

#: src/features/homeAmaru/components/shared/CollectionActions.tsx:62
msgid "Configuración de la colección"
msgstr "Configuración de la colección"

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:207
msgid "Configuración de notificación"
msgstr "Configuración de notificación"

#: src/features/devicesOrderModal/components/DevicesOrder.tsx:77
msgid "Configuración de organización"
msgstr "Configuración de organización"

#: src/features/deviceSupport/components/SupportTableBody.tsx:274
msgid "Configuración del equipo"
msgstr "Configuración del equipo"

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:359
msgid "Configuración del Reporte"
msgstr "Configuración del Reporte"

#: src/features/deviceMenu/components/DeviceMenu.tsx:171
#: src/fsd/pages/dga-reports/ui/device-row.tsx:119
msgid "Configuración DGA"
msgstr "Configuración DGA"

#: src/features/dga/components/modals/tabs/GeneralTab.tsx:72
msgid "Configuración DGA actualizada correctamente"
msgstr "Configuración DGA actualizada correctamente"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:236
msgid "Configuración DGA con envíos activos"
msgstr "Configuración DGA con envíos activos"

#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:82
msgid "Configuración DGA creada correctamente"
msgstr "Configuración DGA creada correctamente"

#: src/features/dga/components/modals/DeleteDGAConfigurationModal.tsx:34
msgid "Configuración DGA eliminada correctamente"
msgstr "Configuración DGA eliminada correctamente"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:221
msgid "Configuración DGA incompleta"
msgstr "Configuración DGA incompleta"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:256
msgid "Configuración DGA sin envíos activos"
msgstr "Configuración DGA sin envíos activos"

#: src/features/deviceConfiguration/components/DeleteDeviceConfiguration.tsx:48
msgid "Configuración eliminada correctamente"
msgstr "Configuración eliminada correctamente"

#: src/features/deviceCommands/components/custom/SendStandardCommandToDevices.tsx:27
msgid "Configuración enviada con exito."
msgstr "Configuración enviada con exito."

#: src/features/deviceConfiguration/data/sectionFields.ts:377
#: src/features/deviceConfiguration/data/sectionInputs.ts:401
#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:61
#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:73
msgid "Configuración IP"
msgstr "Configuración IP"

#: src/features/devicesOrderModal/components/DevicesOrder.tsx:74
msgid "Configuración personal"
msgstr "Configuración personal"

#: src/features/changeOperationalState/components/AfterUpdateTasksModal.tsx:57
msgid "Configuraciones recomendadas:"
msgstr "Configuraciones recomendadas:"

#: src/features/deviceProfile/components/page/Alerts.tsx:100
msgid "Configurado {0}"
msgstr "Configurado {0}"

#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:64
#: src/features/alertsConfigurationV3/components/AlertSummaryCard.tsx:40
msgid "Configurado por"
msgstr "Configurado por"

#: src/features/alertsConfigurationV3/components/UnconfiguredDeviceCard.tsx:47
#: src/features/changeOperationalState/components/AfterUpdateTasksModal.tsx:112
msgid "Configurar"
msgstr "Configurar"

#: src/fsd/pages/dga-reports/ui/device-row.tsx:109
msgid "Configurar {name}"
msgstr "Configurar {name}"

#: src/features/organizationsManagement/components/OrganizationsTableFilters.tsx:39
msgid "Configurar accesos de organización"
msgstr "Configurar accesos de organización"

#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:137
msgid "Configurar alarma"
msgstr "Configurar alarma"

#: src/features/alertsConfigurationV3/components/ConfigureAlertGrid.tsx:40
#: src/features/alertsConfigurationV3/components/wizard/AlertWizardModal.tsx:246
msgid "Configurar alerta"
msgstr "Configurar alerta"

#: src/features/changeOperationalState/components/AfterUpdateTasksModal.tsx:188
msgid "Configurar alertas"
msgstr "Configurar alertas"

#: src/features/deviceSupport/components/SupportMenu.tsx:66
msgid "Configurar Campos"
msgstr "Configurar Campos"

#: src/features/changeOperationalState/components/AfterUpdateTasksModal.tsx:155
msgid "Configurar envíos DGA"
msgstr "Configurar envíos DGA"

#: src/features/deviceSupport/components/SupportMenu.tsx:63
msgid "Configurar Filtros"
msgstr "Configurar Filtros"

#: src/features/homeAmaru/components/mainMetricModal/DeviceMainMetricModal.tsx:82
msgid "Configurar la métrica principal de <0>{0}</0>"
msgstr "Configurar la métrica principal de <0>{0}</0>"

#: src/features/homeAmaru/components/shared/CollectionMap.tsx:107
msgid "Configurar métrica principal"
msgstr "Configurar métrica principal"

#: src/features/metricsViews/components/widgets/configuredAlerts/Table.tsx:525
msgid "Configurar nueva alerta"
msgstr "Configurar nueva alerta"

#: src/features/organizationPreferences/components/OrganizationPreferencesModal.tsx:57
msgid "Configurar otra organización"
msgstr "Configurar otra organización"

#: src/features/preferencesCommon/components/UpdatePreferredUnitsForm.tsx:242
msgid "Configurar otro tipo de dispositivo"
msgstr "Configurar otro tipo de dispositivo"

#: src/features/userPreferences/components/UserPreferencesModal.tsx:54
msgid "Configurar otro usuario"
msgstr "Configurar otro usuario"

#: src/fsd/pages/dashboards/ui/change-bar/view-menu.tsx:59
#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:48
msgid "Configurar tablero"
msgstr "Configurar tablero"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:185
#: src/features/dga/components/modals/UpdateDGAConfigurationModal.tsx:108
msgid "Configurar ticket"
msgstr "Configurar ticket"

#: src/features/dgaTicket/components/DgaTicketModal.tsx:446
msgid "Configurar ticket DGA"
msgstr "Configurar ticket DGA"

#: src/features/metricsViews/components/MetricsView.tsx:584
msgid "Configurar Vista"
msgstr "Configurar Vista"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:192
#: src/features/organizationsManagement/components/OrganizationsTable.tsx:195
#: src/features/publicOrganizationSettingsModal/components/PublicOrganizationSettingsModal.tsx:32
msgid "Configurar vista pública"
msgstr "Configurar vista pública"

#: src/features/gateAdministration/components/MoveGateValidate.tsx:18
msgid "Confirma que moverá la compuerta a"
msgstr "Confirma que moverá la compuerta a"

#: src/components/modal/ConfirmationModal.tsx:34
#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:112
msgid "Confirmación"
msgstr "Confirmación"

#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:98
#: src/features/api/components/dialogs/DisableApiUserDialog.tsx:92
#: src/features/api/components/dialogs/EnableApiUserDialog.tsx:95
#: src/features/api/components/dialogs/SoftDeleteApiUserDialog.tsx:95
msgid "confirmar"
msgstr "confirmar"

#: src/components/modal/ConfirmationModal.tsx:36
#: src/features/alertsConfiguration/components/DialogConfirmationNotifications.tsx:145
#: src/features/alertsConfigurationV3/components/wizard/AlertWizardModal.tsx:356
#: src/features/api/components/dialogs/SetApiUserPasswordDialog.tsx:126
#: src/features/deviceCommands/components/calendar/DeleteScheduleCommandKeyDialog.tsx:70
#: src/features/devicesAnalysis/components/DeviceOperationalStateMenu.tsx:144
#: src/features/dga/components/modals/DeleteDGAConfigurationModal.tsx:90
#: src/features/dga/components/modals/DGAReportsRetryModal.tsx:158
#: src/features/dga/components/modals/DisableDGAConfigurationModal.tsx:41
#: src/features/dgaTicket/components/DgaTicketModal.tsx:292
#: src/features/gateAdministration/components/MoveGateValidate.tsx:36
#: src/features/reports/components/creationSection/CreateReportDialog.tsx:144
#: src/features/reports/components/selectables/DeviceSelectDialog.tsx:214
#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:136
#: src/features/standardDesign/components/accessRelationManager/AccessRelationManagerModal.tsx:298
#: src/features/userProfileUpdate/components/DisableUserModal.tsx:102
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:454
msgid "Confirmar"
msgstr "Confirmar"

#: src/features/devicesAnalysis/components/DeviceOperationalStateMenu.tsx:66
msgid "Confirmar cambio de estado operacional"
msgstr "Confirmar cambio de estado operacional"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:146
#: src/features/api/components/dialogs/GenerateApiUserDialog.tsx:136
#: src/features/api/components/dialogs/SetApiUserPasswordDialog.tsx:102
#: src/features/changePasswordByToken/components/ChangePasswordByToken.tsx:126
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:419
#: src/features/userSaveModal/components/UserSaveModal.tsx:453
msgid "Confirmar contraseña"
msgstr "Confirmar contraseña"

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:315
msgid "Confirmar Contraseña"
msgstr "Confirmar Contraseña"

#: src/features/alertsConfigurationV2/components/DeleteAlertConfirmationDialog.tsx:48
msgid "Confirmar eliminación"
msgstr "Confirmar eliminación"

#: src/features/dga/components/modals/MassiveDGARetryModal.tsx:119
msgid "Confirmar y reintentar ahora"
msgstr "Confirmar y reintentar ahora"

#: src/features/usersGraveyard/components/HardDeleteUserModal.tsx:148
msgid "conservado"
msgstr "conservado"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:277
msgid "Constante (C)"
msgstr "Constante (C)"

#: src/fsd/app/locale/au-labels.ts:93
msgid "Consulta temporal"
msgstr "Consulta temporal"

#: src/features/deviceSupport/data/column.ts:116
msgid "Consumo actual mes"
msgstr "Consumo actual mes"

#: src/features/deviceProfile/components/page/Support.tsx:160
msgid "Consumo de datos"
msgstr "Consumo de datos"

#: src/features/deviceSupport/data/column.ts:108
msgid "Consumo último mes"
msgstr "Consumo último mes"

#: src/features/dga/components/modals/DgaOrganizationAccessWarning.tsx:108
msgid "Contacta a un administrador para habilitarla."
msgstr "Contacta a un administrador para habilitarla."

#: src/fsd/entities/dashboard-widget/ui/contact-support/contact-support-editor.tsx:54
#: src/fsd/entities/dashboard-widget/ui/contact-support/contact-support-render.tsx:22
msgid "Contactar equipo de soporte"
msgstr "Contactar equipo de soporte"

#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:13
msgid "Contacto de soporte"
msgstr "Contacto de soporte"

#: src/features/metricsViews/utils/genericWidgetTypes.ts:68
#: src/features/metricsViews/utils/widgetsResolver.ts:14
msgid "Contacto soporte"
msgstr "Contacto soporte"

#: src/features/metricsViews/utils/quickAccessCatalog.tsx:108
#: src/fsd/entities/dashboard-widget/ui/quick-access/destinations.ts:92
msgid "Contacto y ayuda"
msgstr "Contacto y ayuda"

#: src/features/reports2/components/createModal/steps/step3/3-FormatAndRecipients.tsx:380
msgid "Contactos guardados"
msgstr "Contactos guardados"

#: src/features/integrations/components/groupedIssuesModal/GroupedLogsTable.tsx:55
msgid "Contador"
msgstr "Contador"

#: src/features/metricsViews/components/forms/ImageWidgetForm.tsx:92
#: src/fsd/entities/dashboard-widget/ui/image/image-editor.tsx:28
msgid "Contener"
msgstr "Contener"

#: src/fsd/pages/widget-catalog/model/examples.ts:420
msgid "Contenida"
msgstr "Contenida"

#: src/features/deviceObservations/components/modals/CreateObservationModal.tsx:85
#: src/features/deviceObservations/components/modals/UpdateObservationModal.tsx:80
#: src/features/metricsViews/components/forms/ButtonWidgetForm.tsx:157
#: src/features/metricsViews/components/forms/TextWidgetForm.tsx:29
#: src/fsd/entities/dashboard-widget/ui/text/text-editor.tsx:25
#: src/fsd/entities/dashboard-widget/ui/type-groups.ts:15
#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:100
msgid "Contenido"
msgstr "Contenido"

#: src/fsd/entities/dashboard-widget/ui/button/button-editor.tsx:76
msgid "Contenido del tooltip"
msgstr "Contenido del tooltip"

#: src/features/audit/utils/parseProperty.ts:39
msgid "conteo de eventos"
msgstr "conteo de eventos"

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:79
msgid "Contexto del panel"
msgstr "Contexto del panel"

#: src/features/createMyCollectionModal/hooks/useCreateMyCollectionForm.tsx:99
#: src/features/homeAmaru/hooks/useUpdateMyCollectionForm.tsx:99
msgid "Continuar"
msgstr "Continuar"

#: src/features/audit/utils/parseProperty.ts:126
msgid "contraseña"
msgstr "contraseña"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:145
#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:300
#: src/features/api/components/dialogs/SetApiUserPasswordDialog.tsx:94
#: src/features/deviceProfile/components/page/DGAInfo.tsx:57
#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:248
#: src/features/dga/components/modals/tabs/GeneralTab.tsx:172
#: src/features/userProfileUpdate/components/DisableUserModal.tsx:71
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:394
#: src/features/userSaveModal/components/UserSaveModal.tsx:427
msgid "Contraseña"
msgstr "Contraseña"

#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:239
msgid "Contraseña actual"
msgstr "Contraseña actual"

#: src/features/audit/utils/parseProperty.ts:128
msgid "contraseña actualizada"
msgstr "contraseña actualizada"

#: src/features/api/components/dialogs/SetApiUserPasswordDialog.tsx:45
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:100
msgid "Contraseña actualizada correctamente"
msgstr "Contraseña actualizada correctamente"

#: src/features/changePasswordByToken/components/ChangePasswordByToken.tsx:57
msgid "Contraseña cambiada correctamente. Por favor, inicia sesión nuevamente."
msgstr "Contraseña cambiada correctamente. Por favor, inicia sesión nuevamente."

#: src/features/audit/utils/parseProperty.ts:9
msgid "contraseña de obra DGA"
msgstr "contraseña de obra DGA"

#: src/features/changePasswordByToken/components/ChangePasswordByToken.tsx:89
msgid "Contraseña requerida"
msgstr "Contraseña requerida"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:98
msgid "Control"
msgstr "Control"

#: src/features/advancedDevicesAnalysis/components/AdvancedDevicesAnalysis.tsx:147
msgid "Controles"
msgstr "Controles"

#: src/fsd/pages/widget-catalog/ui/config-code.tsx:54
msgid "Copiado"
msgstr "Copiado"

#: src/fsd/pages/widget-catalog/ui/config-code.tsx:57
msgid "Copiar"
msgstr "Copiar"

#: src/features/dga/components/modals/reports/TableModal.tsx:272
#: src/features/sma/components/TableModal.tsx:281
msgid "Copiar comprobante"
msgstr "Copiar comprobante"

#: src/fsd/pages/dga-reports/ui/latest-reports.tsx:282
msgid "Copiar comprobante del {date}"
msgstr "Copiar comprobante del {date}"

#: src/features/dga/components/modals/CopyDGAConfigSection.tsx:104
msgid "Copiar configuración"
msgstr "Copiar configuración"

#: src/features/dga/components/modals/CopyDGAConfigSection.tsx:71
msgid "Copiar desde otro dispositivo"
msgstr "Copiar desde otro dispositivo"

#: src/fsd/pages/gate-movements/ui/panel/copy-link-button.tsx:42
msgid "Copiar enlace"
msgstr "Copiar enlace"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:152
msgid "Copiar la selección"
msgstr "Copiar la selección"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:131
#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:94
msgid "Copiar link de activación"
msgstr "Copiar link de activación"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:88
msgid "Corr. carga"
msgstr "Corr. carga"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:70
msgid "Corr. sensor"
msgstr "Corr. sensor"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:86
msgid "Corr. solar"
msgstr "Corr. solar"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleFormula.tsx:9
msgid "correción ángulo (en grados)"
msgstr "correción ángulo (en grados)"

#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:99
#: src/features/alertsConfiguration/components/AlertTable.tsx:202
#: src/features/alertsConfiguration/components/DialogConfirmationNotifications.tsx:110
#: src/features/alertsConfiguration/components/DialogUsersNotifications.tsx:110
#: src/features/alertsConfigurationV2/components/AlertsConfigurationV2.tsx:107
#: src/features/alertsConfigurationV3/components/ChannelBadge.tsx:24
#: src/features/alertsConfigurationV3/components/FilterBar.tsx:46
#: src/features/alertsConfigurationV3/components/wizard/steps/NotificationsStep.tsx:29
#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:53
#: src/features/deviceAlertsModal/components/notificationConfigurationTab/TableForm.tsx:63
msgid "Correo"
msgstr "Correo"

#: src/features/api/components/dialogs/ResendApiCredentialsDialog.tsx:129
#: src/features/api/components/forms/FormSendCredentials.tsx:79
msgid "Correo del destinatario"
msgstr "Correo del destinatario"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:144
#: src/features/alertsNotificationsHistory/utils/notificationTypes.ts:40
#: src/features/recoveryPassword/components/RecoveryPassword.tsx:75
#: src/features/users/components/modals/SaveUserModal.tsx:129
#: src/features/userSaveModal/components/UserSaveModal.tsx:373
msgid "Correo electrónico"
msgstr "Correo electrónico"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:79
#: src/features/userSaveModal/utils/schema.ts:57
msgid "Correo electrónico inválido"
msgstr "Correo electrónico inválido"

#: src/features/reports2/components/createModal/steps/step3/3-FormatAndRecipients.tsx:140
#: src/features/reports2/components/createModal/steps/step3/3-FormatAndRecipients.tsx:279
msgid "Correo inválido"
msgstr "Correo inválido"

#: src/features/reports2/components/createModal/steps/step3/3-FormatAndRecipients.tsx:253
msgid "Correos de destino del reporte"
msgstr "Correos de destino del reporte"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarEnergyCheckboxList.tsx:47
msgid "Corriente carga"
msgstr "Corriente carga"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:334
msgid "Corriente Carga"
msgstr "Corriente Carga"

#: src/utils/attributes/metricField.ts:101
msgid "corriente de carga"
msgstr "corriente de carga"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:43
#: src/utils/i18n/getMetricDisplayName.ts:45
msgid "Corriente de carga"
msgstr "Corriente de carga"

#: src/utils/attributes/metricField.ts:107
msgid "corriente de carga bruta"
msgstr "corriente de carga bruta"

#: src/utils/attributes/metricField.ts:245
msgid "corriente del sensor de compuerta"
msgstr "corriente del sensor de compuerta"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:316
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:87
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:25
#: src/utils/i18n/getMetricDisplayName.ts:17
msgid "Corriente del sensor de compuerta"
msgstr "Corriente del sensor de compuerta"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarEnergyCheckboxList.tsx:63
msgid "Corriente Panel"
msgstr "Corriente Panel"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:336
msgid "Corriente Panel Solar"
msgstr "Corriente Panel Solar"

#: src/utils/attributes/metricField.ts:431
msgid "corriente solar"
msgstr "corriente solar"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:41
#: src/utils/i18n/getMetricDisplayName.ts:49
msgid "Corriente solar"
msgstr "Corriente solar"

#: src/utils/attributes/metricField.ts:437
msgid "corriente solar bruta"
msgstr "corriente solar bruta"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:161
msgid "Cortar la selección"
msgstr "Cortar la selección"

#: src/features/userPreferences/components/RegionTab.tsx:275
msgid "Corto"
msgstr "Corto"

#: src/features/billing/components/projectService/Create.tsx:241
msgid "Costo total"
msgstr "Costo total"

#: src/features/audit/utils/parseProperty.ts:75
#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:64
#: src/features/deviceConfiguration/data/sectionFields.ts:199
#: src/features/deviceConfiguration/data/sectionInputs.ts:221
msgid "CPU"
msgstr "CPU"

#: src/features/audit/utils/parseProperty.ts:154
msgid "cpu central"
msgstr "cpu central"

#: src/features/createMyCollectionModal/components/CreateMyCollectionModal.tsx:197
msgid "Crea tu propia colección y elige los dispositivos a incluir"
msgstr "Crea tu propia colección y elige los dispositivos a incluir"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:102
msgid "Creado"
msgstr "Creado"

#: src/features/deviceProfile/components/modal/Info.tsx:155
msgid "Creado <0>{relativeCreated}</0>"
msgstr "Creado <0>{relativeCreated}</0>"

#: src/features/audit/utils/parseProperty.ts:151
msgid "creado el"
msgstr "creado el"

#: src/features/billing/components/payments/PaymentsTable.tsx:50
msgid "Creador"
msgstr "Creador"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:320
#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:341
#: src/features/api/components/dialogs/GenerateApiUserDialog.tsx:162
#: src/features/collections/components/modals/CreateCollectionModal.tsx:178
#: src/features/createDevice/components/form/index.tsx:148
#: src/features/createMyCollectionModal/components/CreateMyCollectionModal.tsx:174
#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:159
#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:548
#: src/features/metricsViews/components/createViewModal/CreateViewForm.tsx:203
#: src/features/notifications/components/NotificationsSaveModal.tsx:244
#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:339
#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:121
#: src/features/userSaveModal/components/UserSaveModal.tsx:619
msgid "Crear"
msgstr "Crear"

#: src/features/audit/components/AuditLogDetailsRow.tsx:13
msgid "CREAR"
msgstr "CREAR"

#: src/features/audit/utils/getActionTypeOptions.ts:313
msgid "Crear accesos de dispositivo para un usuario"
msgstr "Crear accesos de dispositivo para un usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:319
msgid "Crear accesos de usuario para un dispositivo"
msgstr "Crear accesos de usuario para un dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:217
msgid "Crear Alias de Dispositivo"
msgstr "Crear Alias de Dispositivo"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:200
msgid "Crear Anuncio"
msgstr "Crear Anuncio"

#: src/features/audit/utils/getActionTypeOptions.ts:10
msgid "Crear API para Organización"
msgstr "Crear API para Organización"

#: src/features/audit/utils/getActionTypeOptions.ts:19
msgid "Crear Canal de Irrigación"
msgstr "Crear Canal de Irrigación"

#: src/features/createDeviceConfiguration/components/tabs/general/GeneralTabContent.tsx:247
msgid "Crear certificado VPN"
msgstr "Crear certificado VPN"

#: src/features/audit/utils/getActionTypeOptions.ts:31
msgid "Crear Clase de Canal de SIRA"
msgstr "Crear Clase de Canal de SIRA"

#: src/features/collections/components/CollectionsTableFilters.tsx:66
#: src/features/collections/components/modals/CreateCollectionModal.tsx:203
msgid "Crear colección"
msgstr "Crear colección"

#: src/features/gates/components/Gates.tsx:109
msgid "Crear Compuerta"
msgstr "Crear Compuerta"

#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:77
#: src/features/alertsConfigurationV2/components/AlertsConfigurationV2.tsx:81
#: src/features/alertsConfigurationV3/components/FilterBar.tsx:107
#: src/features/createDeviceAlerts/components/CreateDeviceAlerts.tsx:55
#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:156
msgid "Crear configuración de alertas"
msgstr "Crear configuración de alertas"

#: src/features/audit/utils/getActionTypeOptions.ts:16
msgid "Crear Configuración de Calendario para Dispositivo"
msgstr "Crear Configuración de Calendario para Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:253
msgid "Crear Configuración de DGA"
msgstr "Crear Configuración de DGA"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:216
msgid "Crear configuración de hardware"
msgstr "Crear configuración de hardware"

#: src/features/audit/utils/getActionTypeOptions.ts:187
msgid "Crear Configuración de Hardware de Dispositivo"
msgstr "Crear Configuración de Hardware de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:43
msgid "Crear Configuración de Org de Dispositivo de SIRA Maipo"
msgstr "Crear Configuración de Org de Dispositivo de SIRA Maipo"

#: src/features/audit/utils/getActionTypeOptions.ts:34
msgid "Crear Configuración de SIRA Maipo"
msgstr "Crear Configuración de SIRA Maipo"

#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:306
msgid "Crear configuración DGA"
msgstr "Crear configuración DGA"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:191
msgid "Crear curva de aforo"
msgstr "Crear curva de aforo"

#: src/features/deviceConfigurationModal/components/gateTab/CreateLinkedDeviceButton.tsx:66
#: src/features/deviceConfigurationModal/components/gateTab/CreateLinkedDeviceButton.tsx:73
msgid "Crear dispositivo"
msgstr "Crear dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:13
msgid "Crear Dispositivo"
msgstr "Crear Dispositivo"

#: src/features/deviceConfigurationModal/components/gateTab/CreateLinkedDeviceButton.tsx:36
msgid "Crear dispositivo aguas abajo"
msgstr "Crear dispositivo aguas abajo"

#: src/features/deviceConfigurationModal/components/gateTab/CreateLinkedDeviceButton.tsx:35
msgid "Crear dispositivo aguas arriba"
msgstr "Crear dispositivo aguas arriba"

#: src/features/audit/utils/getActionTypeOptions.ts:37
msgid "Crear Dispositivo de Configuración de SIRA Maipo"
msgstr "Crear Dispositivo de Configuración de SIRA Maipo"

#: src/features/audit/utils/getActionTypeOptions.ts:325
msgid "Crear estado de dispositivo"
msgstr "Crear estado de dispositivo"

#: src/features/notifications/components/Notifications.tsx:107
#: src/features/notifications/components/NotificationsSaveModal.tsx:151
msgid "Crear notificación"
msgstr "Crear notificación"

#: src/features/audit/utils/getActionTypeOptions.ts:22
msgid "Crear Nueva Distribución de SIRA"
msgstr "Crear Nueva Distribución de SIRA"

#: src/features/audit/utils/getActionTypeOptions.ts:25
msgid "Crear Nueva Distribución de SIRA Maipo"
msgstr "Crear Nueva Distribución de SIRA Maipo"

#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:99
msgid "Crear Nuevo Comando Programado"
msgstr "Crear Nuevo Comando Programado"

#: src/features/createDevice/components/CreateDeviceModal.tsx:20
msgid "Crear nuevo dispositivo"
msgstr "Crear nuevo dispositivo"

#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:518
#: src/features/deviceObservations/components/CreateObservationButton.tsx:30
#: src/features/deviceObservations/components/modals/CreateObservationModal.tsx:77
msgid "Crear observación"
msgstr "Crear observación"

#: src/features/audit/utils/getActionTypeOptions.ts:40
msgid "Crear Org de Configuración de SIRA Maipo"
msgstr "Crear Org de Configuración de SIRA Maipo"

#: src/features/audit/utils/getActionTypeOptions.ts:28
#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:185
#: src/features/organizationsManagement/components/OrganizationsTableFilters.tsx:45
msgid "Crear Organización"
msgstr "Crear Organización"

#: src/features/billing/components/payments/PaymentSummary.tsx:170
msgid "Crear pago"
msgstr "Crear pago"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:174
msgid "Crear Pagos Desde Archivo Excel"
msgstr "Crear Pagos Desde Archivo Excel"

#: src/features/reports/components/creationSection/CreateReportDataExtraction.tsx:41
#: src/features/reports/components/creationSection/CreateReportDataExtractionDialog.tsx:55
#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:159
#: src/features/reports/components/creationSection/EditReportTemplateDialog.tsx:139
msgid "Crear Plantilla"
msgstr "Crear Plantilla"

#: src/features/audit/utils/getActionTypeOptions.ts:343
msgid "Crear programación de envíos DGA"
msgstr "Crear programación de envíos DGA"

#: src/features/audit/utils/getActionTypeOptions.ts:241
msgid "Crear Programación de Reporte"
msgstr "Crear Programación de Reporte"

#: src/features/reports/components/creationSection/CreateReportDataExtractionDialog.tsx:27
msgid "Crear reporte"
msgstr "Crear reporte"

#: src/features/audit/utils/getActionTypeOptions.ts:232
#: src/features/reports/components/creationSection/CreateReportDataExtraction.tsx:28
#: src/features/reports/components/creationSection/CreateReportDataExtractionDialog.tsx:43
msgid "Crear Reporte"
msgstr "Crear Reporte"

#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:204
msgid "Crear reporte desde plantilla"
msgstr "Crear reporte desde plantilla"

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:407
#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:267
msgid "Crear reporte en formato(s):"
msgstr "Crear reporte en formato(s):"

#: src/features/reports/components/creationSection/CreateReportDialog.tsx:128
msgid "Crear Reporte Instantáneo"
msgstr "Crear Reporte Instantáneo"

#: src/features/audit/utils/getActionTypeOptions.ts:301
msgid "Crear servicio de facturación"
msgstr "Crear servicio de facturación"

#: src/features/audit/utils/getActionTypeOptions.ts:292
msgid "Crear servicio para proyecto de facturación"
msgstr "Crear servicio para proyecto de facturación"

#: src/features/billing/components/modals/ServiceFileManager.tsx:169
msgid "Crear Servicios Desde Archivo Excel"
msgstr "Crear Servicios Desde Archivo Excel"

#: src/features/collections/components/CollectionsTable.tsx:193
#: src/features/collections/components/modals/CreateMetricsViewFromCollectionModal.tsx:159
msgid "Crear tablero"
msgstr "Crear tablero"

#: src/features/collections/components/modals/CreateMetricsViewFromCollectionModal.tsx:177
msgid "Crear tablero de la colección"
msgstr "Crear tablero de la colección"

#: src/features/audit/utils/getActionTypeOptions.ts:283
msgid "Crear un pago"
msgstr "Crear un pago"

#: src/features/users/components/modals/SaveUserModal.tsx:171
msgid "Crear usuario"
msgstr "Crear usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:49
#: src/features/userSaveModal/components/UserSaveModal.tsx:328
msgid "Crear Usuario"
msgstr "Crear Usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:46
msgid "Crear Usuario de SIRA a Notificar"
msgstr "Crear Usuario de SIRA a Notificar"

#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:113
#: src/features/users/components/UsersTableFilters.tsx:73
msgid "Crear usuario temporal"
msgstr "Crear usuario temporal"

#: src/features/metricsViews/components/MetricsViewErrorBoundary.tsx:30
#: src/features/metricsViews/components/MetricsViews.tsx:41
msgid "Crear visualización"
msgstr "Crear visualización"

#: src/features/metricsViews/components/createViewModal/index.tsx:16
msgid "Crear visualización de métricas"
msgstr "Crear visualización de métricas"

#: src/features/api/components/dialogs/DisableApiUserDialog.tsx:39
msgid "Credencial deshabilitada exitosamente."
msgstr "Credencial deshabilitada exitosamente."

#: src/features/api/components/dialogs/SoftDeleteApiUserDialog.tsx:41
msgid "Credencial eliminada correctamente"
msgstr "Credencial eliminada correctamente"

#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:41
msgid "Credencial eliminada correctamente."
msgstr "Credencial eliminada correctamente."

#: src/features/api/components/dialogs/EnableApiUserDialog.tsx:41
msgid "Credencial habilitada exitosamente"
msgstr "Credencial habilitada exitosamente"

#: src/features/api/components/ApiUsers.tsx:15
#: src/features/api/components/CaptaApiUsersList.tsx:63
#: src/features/api/components/CaptaApiUsersList.tsx:76
msgid "Credenciales API"
msgstr "Credenciales API"

#: src/features/login/components/Login.tsx:58
msgid "Credenciales inválidas. Verifique el email y la contraseña."
msgstr "Credenciales inválidas. Verifique el email y la contraseña."

#: src/features/api/components/dialogs/ResendApiCredentialsDialog.tsx:62
msgid "Credenciales reenviadas correctamente"
msgstr "Credenciales reenviadas correctamente"

#: src/features/audit/utils/getDisplayNameActionType.ts:201
msgid "creó accesos de dispositivos al usuario"
msgstr "creó accesos de dispositivos al usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:124
msgid "creó accesos de usuario para el dispositivo"
msgstr "creó accesos de usuario para el dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:108
msgid "creó el alias del dispositivo"
msgstr "creó el alias del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:367
msgid "creó el cronograma del reporte"
msgstr "creó el cronograma del reporte"

#: src/features/audit/utils/getDisplayNameActionType.ts:48
msgid "creó el dispositivo"
msgstr "creó el dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:355
msgid "creó el reporte"
msgstr "creó el reporte"

#: src/features/audit/utils/getDisplayNameActionType.ts:149
msgid "creó el usuario"
msgstr "creó el usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:248
msgid "creó el usuario de SIRA para notificar"
msgstr "creó el usuario de SIRA para notificar"

#: src/features/audit/utils/getDisplayNameActionType.ts:281
msgid "creó la API para la organización"
msgstr "creó la API para la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:236
msgid "creó la clase de canal de SIRA"
msgstr "creó la clase de canal de SIRA"

#: src/features/audit/utils/getDisplayNameActionType.ts:429
msgid "creó la configuración de DGA"
msgstr "creó la configuración de DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:313
msgid "creó la configuración de la organización para SIRA Maipo"
msgstr "creó la configuración de la organización para SIRA Maipo"

#: src/features/audit/utils/getDisplayNameActionType.ts:301
msgid "creó la configuración de SIRA Maipo"
msgstr "creó la configuración de SIRA Maipo"

#: src/features/audit/utils/getDisplayNameActionType.ts:80
msgid "creó la configuración del calendario del dispositivo"
msgstr "creó la configuración del calendario del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:305
msgid "creó la configuración del dispositivo para SIRA Maipo"
msgstr "creó la configuración del dispositivo para SIRA Maipo"

#: src/features/audit/utils/getDisplayNameActionType.ts:309
msgid "creó la configuración del dispositivo u organización para SIRA Maipo"
msgstr "creó la configuración del dispositivo u organización para SIRA Maipo"

#: src/features/audit/utils/getDisplayNameActionType.ts:84
msgid "creó la configuración del hardware del dispositivo"
msgstr "creó la configuración del hardware del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:214
msgid "creó la irrigación"
msgstr "creó la irrigación"

#: src/features/audit/utils/getDisplayNameActionType.ts:261
msgid "creó la organización"
msgstr "creó la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:132
msgid "creó un estado para el dispositivo"
msgstr "creó un estado para el dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:384
msgid "creó un nuevo pago para un proyecto."
msgstr "creó un nuevo pago para un proyecto."

#: src/features/audit/utils/getDisplayNameActionType.ts:408
msgid "creó un nuevo servicio de facturación."
msgstr "creó un nuevo servicio de facturación."

#: src/features/audit/utils/getDisplayNameActionType.ts:396
msgid "creó un nuevo servicio para el proyecto."
msgstr "creó un nuevo servicio para el proyecto."

#: src/features/audit/utils/getDisplayNameActionType.ts:231
msgid "creó una nueva distribución de SIRA"
msgstr "creó una nueva distribución de SIRA"

#: src/features/audit/utils/getDisplayNameActionType.ts:317
msgid "creó una nueva distribución para SIRA Maipo"
msgstr "creó una nueva distribución para SIRA Maipo"

#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:391
#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:395
msgid "Criterio"
msgstr "Criterio"

#: src/features/notifications/components/NotificationMessageViewModal.tsx:30
msgid "Crítica"
msgstr "Crítica"

#: src/features/alertsConfigurationV3/components/TriggeredAlertsSummary.tsx:37
msgid "Critical"
msgstr "Critical"

#: src/features/changeSupportStatus/data/status.ts:16
#: src/features/deviceSupport/data/status.ts:25
#: src/features/deviceSupport/data/status.ts:40
#: src/features/integrations/utils/writeExecutionLogSeverityAttributes.ts:32
#: src/features/metricsViews/components/widgets/configuredAlerts/index.tsx:76
#: src/features/metricsViews/components/widgets/DataWidget.tsx:109
#: src/fsd/entities/dashboard-widget/model/data-sample.ts:113
#: src/fsd/entities/dashboard-widget/ui/data/data-view.tsx:41
#: src/utils/attributes/metricAlertEvaluation.ts:36
msgid "Crítico"
msgstr "Crítico"

#: src/fsd/features/gate-movements/ui/states/empty-gate.tsx:11
msgid "Cuando se opere, sus movimientos aparecerán acá."
msgstr "Cuando se opere, sus movimientos aparecerán acá."

#: src/features/gateOperationModal/components/PanelChart.tsx:311
#: src/fsd/features/gate-movements/ui/panel/position-chart.tsx:66
msgid "Cuando se reciban mensajes de posición se graficarán acá"
msgstr "Cuando se reciban mensajes de posición se graficarán acá"

#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:142
msgid "Cuántas lecturas recientes se muestran, hasta {MAX_LIMIT}."
msgstr "Cuántas lecturas recientes se muestran, hasta {MAX_LIMIT}."

#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-editor.tsx:60
msgid "Cuántos movimientos recientes se muestran."
msgstr "Cuántos movimientos recientes se muestran."

#: src/fsd/pages/widget-catalog/model/examples.ts:426
msgid "Cubriendo"
msgstr "Cubriendo"

#: src/features/metricsViews/components/forms/ImageWidgetForm.tsx:92
#: src/fsd/entities/dashboard-widget/ui/image/image-editor.tsx:29
msgid "Cubrir"
msgstr "Cubrir"

#: src/features/audit/utils/parseProperty.ts:104
msgid "cuenca"
msgstr "cuenca"

#: src/fsd/app/locale/au-labels.ts:111
msgid "cuenta"
msgstr "cuenta"

#: src/fsd/app/locale/au-labels.ts:118
msgid "Cuenta"
msgstr "Cuenta"

#: src/features/api/components/RowCaptaApiUser.tsx:19
msgid "Cuenta · {0} ({1})"
msgstr "Cuenta · {0} ({1})"

#: src/features/api/components/RowCaptaApiUser.tsx:23
msgid "Cuenta eliminada ({0})"
msgstr "Cuenta eliminada ({0})"

#: src/features/sma/components/forFutureUse/TableSmaUnit.tsx:46
msgid "Cuenta SMA"
msgstr "Cuenta SMA"

#: src/features/deviceConfiguration/data/sectionFields.ts:25
msgid "Cuenta usuario"
msgstr "Cuenta usuario"

#: src/features/metricsViews/utils/quickAccessCatalog.tsx:71
#: src/fsd/entities/dashboard-widget/ui/quick-access/destinations.ts:55
#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:33
msgid "Cumplimiento DGA"
msgstr "Cumplimiento DGA"

#: src/fsd/pages/dga-reports/ui/dga-reports-page.tsx:26
msgid "Cumplimiento normativo Dirección General de Aguas"
msgstr "Cumplimiento normativo Dirección General de Aguas"

#: src/features/deviceDataConfigurationModal/utils/ratingFactory.ts:41
msgid "Curva de aforo inválida"
msgstr "Curva de aforo inválida"

#: src/features/audit/utils/parseProperty.ts:140
msgid "curvas de aforo"
msgstr "curvas de aforo"

#: src/features/deviceDataConfigurationModal/components/DeviceDataConfigurationModal.tsx:88
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:200
msgid "Curvas de Aforo"
msgstr "Curvas de Aforo"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:212
msgid "Curvas de aforo creadas"
msgstr "Curvas de aforo creadas"

#: src/utils/attributes/metricField.ts:203
msgid "curvas de aforo habilitadas"
msgstr "curvas de aforo habilitadas"

#: src/features/devicesAnalysisV3/components/QuickRangeChips.tsx:86
msgid "Custom"
msgstr "Custom"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:357
#: src/features/deviceConfiguration/data/sectionFields.ts:238
#: src/features/deviceConfiguration/data/sectionInputs.ts:254
msgid "Data logger"
msgstr "Data logger"

#: src/features/deviceProfile/components/page/modularComponents/index.tsx:48
msgid "Datalogger"
msgstr "Datalogger"

#: src/features/metricsViews/utils/widgetTypeCatalog.ts:27
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:14
msgid "Dato"
msgstr "Dato"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:191
#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:75
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:55
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:104
msgid "Dato actualizado correctamente"
msgstr "Dato actualizado correctamente"

#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:40
#: src/features/metricsViews/components/MetricsViewToolbar.legacy.tsx:37
#: src/features/metricsViews/components/MetricsViewToolbar.tsx:97
#: src/features/reports/utils/meanWindowOptions.ts:7
#: src/features/reports2/utils/meanWindowOptions.ts:7
msgid "Dato bruto"
msgstr "Dato bruto"

#: src/fsd/entities/dashboard-widget/ui/type-groups.ts:20
#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:156
msgid "Datos"
msgstr "Datos"

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:461
msgid "Datos a Extraer de los Dispositivos"
msgstr "Datos a Extraer de los Dispositivos"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LevelCalibrationForm.tsx:57
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleCalibrationForm.tsx:66
msgid "Datos actualizados correctamente"
msgstr "Datos actualizados correctamente"

#: src/features/deviceAlertsModal/components/rawDataModal/index.tsx:57
msgid "Datos de alertas leídas desde el pipeline"
msgstr "Datos de alertas leídas desde el pipeline"

#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:396
msgid "Datos de ejemplo: mientras editas, el widget muestra movimientos inventados."
msgstr "Datos de ejemplo: mientras editas, el widget muestra movimientos inventados."

#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-view.tsx:106
msgid "Datos de ejemplo: mientras editas, el widget muestra sensores inventados."
msgstr "Datos de ejemplo: mientras editas, el widget muestra sensores inventados."

#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:372
msgid "Datos de ejemplo: mientras editas, el widget muestra una compuerta inventada."
msgstr "Datos de ejemplo: mientras editas, el widget muestra una compuerta inventada."

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:213
msgid "Datos del tablero"
msgstr "Datos del tablero"

#: src/features/devicesAnalysisV3/components/TimelineMinimap.tsx:413
msgid "Datos desde"
msgstr "Datos desde"

#: src/features/integrations/utils/writeExecutionLogCodeTranslations.ts:18
msgid "Datos escritos correctamente"
msgstr "Datos escritos correctamente"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-view.tsx:172
msgid "Datos incompletos en el período"
msgstr "Datos incompletos en el período"

#: src/features/alertsConfigurationV3/components/Pagination.tsx:31
#: src/features/homeAmaru/components/HomeAmaru.tsx:339
msgid "de"
msgstr "de"

#: src/features/billing/components/administration/Stats.tsx:69
msgid "de deuda"
msgstr "de deuda"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:214
#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:223
#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:226
#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:249
msgid "De ejemplo"
msgstr "De ejemplo"

#: src/features/billing/utils/validationSchema.ts:12
msgid "Debe agregar al menos un servicio."
msgstr "Debe agregar al menos un servicio."

#: src/features/metricsViews/components/widgets/common/DurationAutocomplete.tsx:97
msgid "Debe estar entre 1 minuto y 1 año"
msgstr "Debe estar entre 1 minuto y 1 año"

#: src/features/collections/components/modals/CreateCollectionModal.tsx:44
#: src/features/collections/components/modals/UpdateCollectionModal.tsx:64
msgid "Debe seleccionar un archivo con la extensión .kml"
msgstr "Debe seleccionar un archivo con la extensión .kml"

#: src/features/notifications/components/NotificationsSaveModal.tsx:85
msgid "Debe seleccionar una entidad"
msgstr "Debe seleccionar una entidad"

#: src/features/dga/utils/validationSchemas.ts:147
msgid "Debe seleccionar una fecha de finalización."
msgstr "Debe seleccionar una fecha de finalización."

#: src/features/dga/utils/validationSchemas.ts:154
msgid "Debe seleccionar una fecha de inicio."
msgstr "Debe seleccionar una fecha de inicio."

#: src/features/collectionCommon/utils/collectionImage.ts:15
msgid "Debe seleccionar una imagen JPG, PNG o WEBP"
msgstr "Debe seleccionar una imagen JPG, PNG o WEBP"

#: src/features/organizationAccess/components/OrganizationAccess.tsx:90
msgid "Debe seleccionar una organización"
msgstr "Debe seleccionar una organización"

#: src/features/billing/utils/validationSchema.ts:6
msgid "Debes agregar al menos 1 servicio."
msgstr "Debes agregar al menos 1 servicio."

#: src/features/reports2/components/createModal/validation.ts:91
msgid "Debes definir un horario si el envío está programado"
msgstr "Debes definir un horario si el envío está programado"

#: src/features/reports2/components/createModal/steps/step3/3-FormatAndRecipients.tsx:374
msgid "Debes indicar al menos 1 correo"
msgstr "Debes indicar al menos 1 correo"

#: src/features/dga/utils/validationSchemas.ts:38
msgid "Debes ingresar un número"
msgstr "Debes ingresar un número"

#: src/features/reports2/components/createModal/validation.ts:87
msgid "Debes proveer un nombre para guardar el reporte"
msgstr "Debes proveer un nombre para guardar el reporte"

#: src/features/reports2/components/createModal/validation.ts:24
msgid "Debes seleccionar al menos un día de la semana."
msgstr "Debes seleccionar al menos un día de la semana."

#: src/features/reports2/components/createModal/steps/step3/3-FormatAndRecipients.tsx:245
#: src/features/reports2/components/createModal/validation.ts:65
#: src/features/reports2/components/createModal/validation.ts:72
msgid "Debes seleccionar al menos un formato"
msgstr "Debes seleccionar al menos un formato"

#: src/features/reports2/components/createModal/validation.ts:32
msgid "Debes seleccionar un día de la semana."
msgstr "Debes seleccionar un día de la semana."

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:131
#: src/features/deviceCommands/components/standard/StandardButtons.tsx:195
msgid "Debug/Aforo"
msgstr "Debug/Aforo"

#: src/features/preferencesCommon/components/UpdatePreferredUnitsForm.tsx:334
msgid "Decimales de precisión"
msgstr "Decimales de precisión"

#: src/features/alertsConfigurationV3/components/wizard/steps/NotificationsStep.tsx:138
msgid "Define los usuarios y los medios por los que se les notificará."
msgstr "Define los usuarios y los medios por los que se les notificará."

#: src/features/moveGateModal/components/MoveGateModal.tsx:140
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:297
msgid "Definir operación"
msgstr "Definir operación"

#: src/features/dashboardLayout/components/navbar/index.tsx:82
msgid "Dejar de simular"
msgstr "Dejar de simular"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:329
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:351
msgid "del mes a las"
msgstr "del mes a las"

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:223
#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:247
msgid "Del tablero"
msgstr "Del tablero"

#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:295
msgid "Dentro"
msgstr "Dentro"

#: src/utils/alertConfiguration.ts:23
#: src/utils/alerts.ts:12
msgid "Dentro del rango {0}-{1} {2}"
msgstr "Dentro del rango {0}-{1} {2}"

#: src/features/metricsViews/components/widgets/configuredAlerts/index.tsx:66
msgid "Dentro del rango {min}-{max}"
msgstr "Dentro del rango {min}-{max}"

#: src/fsd/entities/dashboard-widget/model/alert-threshold.ts:31
msgid "Dentro del rango {min}-{max} {u}"
msgstr "Dentro del rango {min}-{max} {u}"

#: src/fsd/entities/dashboard-widget/ui/text/text-editor.tsx:16
msgid "Derecha"
msgstr "Derecha"

#: src/features/metricsViews/components/widgets/gateSensors/RenderSensor.tsx:134
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/sensors.ts:52
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/sensors.ts:64
msgid "Desacople"
msgstr "Desacople"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:485
msgid "Desactivada"
msgstr "Desactivada"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:74
msgid "Desactivados"
msgstr "Desactivados"

#: src/features/deviceAlertsModal/components/disableAlertsModal/index.tsx:47
msgid "Desactivar"
msgstr "Desactivar"

#: src/features/deviceAlertsModal/components/disableAlertsModal/index.tsx:40
#: src/features/deviceAlertsModal/components/index.tsx:155
msgid "Desactivar alertas"
msgstr "Desactivar alertas"

#: src/features/audit/utils/getActionTypeOptions.ts:106
msgid "Desactivar Alertas de Dispositivo"
msgstr "Desactivar Alertas de Dispositivo"

#: src/features/dga/components/modals/DisableDGAConfigurationModal.tsx:52
#: src/features/dga/components/modals/DisableDGAConfigurationModal.tsx:84
msgid "Desactivar envíos DGA"
msgstr "Desactivar envíos DGA"

#: src/features/gateCommon/utils/gateCloseCode.ts:62
#: src/features/gateCommon/utils/gateCloseCode.ts:96
#: src/fsd/entities/gate/model/close-code.ts:47
#: src/fsd/entities/gate/model/close-code.ts:81
msgid "desactivar la parada de emergencia en terreno"
msgstr "desactivar la parada de emergencia en terreno"

#: src/features/audit/utils/getActionTypeOptions.ts:85
msgid "Desactivar Usuario"
msgstr "Desactivar Usuario"

#: src/features/gateOperationModal/components/panelNotification/utils.tsx:224
#: src/fsd/features/gate-movements/ui/panel/events/event-text.tsx:149
msgid "desactivarla en terreno"
msgstr "desactivarla en terreno"

#: src/features/audit/utils/getDisplayNameActionType.ts:169
msgid "desactivó el usuario"
msgstr "desactivó el usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:60
msgid "desactivó las alertas del dispositivo"
msgstr "desactivó las alertas del dispositivo"

#: src/fsd/entities/dashboard-widget/model/chart-sample.ts:124
#: src/fsd/entities/dashboard-widget/model/data-sample.ts:114
#: src/fsd/entities/dashboard-widget/model/table-sample.ts:76
#: src/fsd/entities/dashboard-widget/ui/chart/chart-view.tsx:206
#: src/fsd/entities/dashboard-widget/ui/data/data-view.tsx:113
#: src/fsd/entities/dashboard-widget/ui/table/table-view.tsx:171
msgid "Desactualizado"
msgstr "Desactualizado"

#: src/features/devicesGraveyard/components/DevicesGraveyard.tsx:259
#: src/features/devicesGraveyard/components/RestoreDeviceModal.tsx:56
#: src/features/usersGraveyard/components/RestoreUserModal.tsx:67
#: src/features/usersGraveyard/components/UsersGraveyard.tsx:191
msgid "Desarchivar"
msgstr "Desarchivar"

#: src/features/devicesGraveyard/components/RestoreDeviceModal.tsx:45
msgid "Desarchivar dispositivo <0/>"
msgstr "Desarchivar dispositivo <0/>"

#: src/features/audit/utils/getActionTypeOptions.ts:82
msgid "Desarchivar Usuario"
msgstr "Desarchivar Usuario"

#: src/features/usersGraveyard/components/RestoreUserModal.tsx:54
msgid "Desarchivar usuario{0}"
msgstr "Desarchivar usuario{0}"

#: src/features/audit/utils/getDisplayNameActionType.ts:165
msgid "desarchivó el usuario"
msgstr "desarchivó el usuario"

#: src/features/metricsViews/components/DissociateCollectionDialog.tsx:83
#: src/features/metricsViews/components/MetricsViewList.tsx:230
msgid "Desasociar"
msgstr "Desasociar"

#: src/features/metricsViews/components/DissociateCollectionDialog.tsx:66
msgid "Desasociar la colección"
msgstr "Desasociar la colección"

#: src/features/deviceAlertsModal/components/basicConfigurationTab/FormComponent.tsx:91
msgid "Desborde"
msgstr "Desborde"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:344
msgid "Descarga compuertas"
msgstr "Descarga compuertas"

#: src/pages/report-download/index.tsx:15
msgid "Descarga de Reporte"
msgstr "Descarga de Reporte"

#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:254
msgid "Descarga parcial"
msgstr "Descarga parcial"

#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:189
msgid "Descarga rápida de datos"
msgstr "Descarga rápida de datos"

#: src/features/reportDownload/components/ReportDownload.tsx:50
msgid "Descargando Reporte"
msgstr "Descargando Reporte"

#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:179
msgid "Descargando…"
msgstr "Descargando…"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:311
#: src/features/billing/components/modals/ServiceFileManager.tsx:317
#: src/features/billing/components/payments/PaymentRow.tsx:212
#: src/features/deviceConfiguration/components/ConfigurationFileHistoryModal.tsx:131
#: src/features/dga/components/modals/reports/TableModal.tsx:293
#: src/features/downloadData/components/DownloadDataModal.tsx:166
#: src/features/sma/components/TableModal.tsx:304
#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:179
msgid "Descargar"
msgstr "Descargar"

#: src/features/deviceConfiguration/components/ConfigurationFileHistoryModal.tsx:143
msgid "Descargar archivo"
msgstr "Descargar archivo"

#: src/features/createDeviceConfiguration/components/tabs/general/GeneralTabContent.tsx:235
msgid "Descargar certificado VPN"
msgstr "Descargar certificado VPN"

#: src/features/downloadData/components/DownloadDataModal.tsx:20
msgid "Descargar datos"
msgstr "Descargar datos"

#: src/features/api/components/mainMenu/MainMenuApiCapta.tsx:41
#: src/features/api/components/mainMenu/MainMenuApiCustomer.tsx:18
msgid "Descargar documentación API"
msgstr "Descargar documentación API"

#: src/features/collections/components/modals/UpdateCollectionModal.tsx:206
msgid "Descargar el archivo .KML existente"
msgstr "Descargar el archivo .KML existente"

#: src/features/reports/components/CreatedReportNotification.tsx:100
msgid "Descargar Excel"
msgstr "Descargar Excel"

#: src/features/billing/components/payments/PaymentRow.tsx:202
msgid "Descargar factura"
msgstr "Descargar factura"

#: src/features/reports/components/CreatedReportNotification.tsx:112
msgid "Descargar PDF"
msgstr "Descargar PDF"

#: src/fsd/pages/dga-reports/ui/latest-reports.tsx:83
msgid "Descargar reportes"
msgstr "Descargar reportes"

#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:163
msgid "Descargar reportes — {name}"
msgstr "Descargar reportes — {name}"

#: src/features/dga/components/modals/reports/SendReportsByEmailModal.tsx:68
msgid "Descargar tabla de reportes DGA"
msgstr "Descargar tabla de reportes DGA"

#: src/features/sma/components/SendReportsByEmailModal.tsx:83
msgid "Descargar tabla de reportes SMA"
msgstr "Descargar tabla de reportes SMA"

#: src/features/reports/components/ReportHistory.tsx:86
#: src/features/reports2/components/reportHistoryModal/ReportHistory.tsx:91
msgid "Descargas"
msgstr "Descargas"

#: src/fsd/app/locale/au-labels.ts:75
#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:216
#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:228
msgid "Descartar"
msgstr "Descartar"

#: src/fsd/app/locale/au-labels.ts:72
msgid "Descartar aviso"
msgstr "Descartar aviso"

#: src/features/metricsViews/components/MetricsView.tsx:548
#: src/fsd/pages/dashboards/ui/discard-dialog.tsx:39
msgid "Descartar cambios"
msgstr "Descartar cambios"

#: src/components/filters/OrderDirection.tsx:20
msgid "Descendente"
msgstr "Descendente"

#: src/features/echarts/utils/commonSeries.ts:461
#: src/features/gateOperationModal/components/ConnectionStatus.tsx:126
#: src/fsd/features/gate-movements/ui/operation/connection-status.tsx:64
msgid "desconectado"
msgstr "desconectado"

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:134
#: src/features/controlCenter2/hooks/useLegendsForView.ts:79
#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:120
#: src/features/gateAdministration/components/index.tsx:613
#: src/features/metricsViews/components/widgets/DataWidget.tsx:492
#: src/features/moveGateModal/components/OperatingState.tsx:26
#: src/fsd/entities/dashboard-widget/ui/data/data-view.tsx:97
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:87
#: src/fsd/entities/dashboard-widget/ui/table/table-view.tsx:73
msgid "Desconectado"
msgstr "Desconectado"

#: src/features/organizationDelete/components/DeleteOrganization.tsx:202
msgid "Desconectar"
msgstr "Desconectar"

#: src/features/deviceConfiguration/components/TriggerConfigUpdateModal.tsx:31
msgid "Desconocida"
msgstr "Desconocida"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:287
#: src/features/notifications/utils/getNotificationObjectEntityType.ts:13
msgid "Desconocido"
msgstr "Desconocido"

#: src/utils/alertConfiguration.ts:39
#: src/utils/alerts.ts:20
msgid "Desconocido ({0})"
msgstr "Desconocido ({0})"

#: src/fsd/pages/dashboards/ui/report-problem/report-problem-dialog.tsx:130
msgid "Describe el evento."
msgstr "Describe el evento."

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:356
msgid "Describe el tablero que quieres armar."
msgstr "Describe el tablero que quieres armar."

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:406
msgid "Describe el tablero…"
msgstr "Describe el tablero…"

#: src/fsd/entities/dashboard-widget/ui/image/image-editor.tsx:100
msgid "Describe la imagen para quien no la ve."
msgstr "Describe la imagen para quien no la ve."

#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:55
#: src/features/announcements/components/AnnouncementsSaveModal.tsx:243
#: src/features/collections/components/CollectionsTable.tsx:56
#: src/features/collections/components/modals/CreateCollectionModal.tsx:121
#: src/features/collections/components/modals/UpdateCollectionModal.tsx:147
#: src/features/createMyCollectionModal/components/CreateMyCollectionModal.tsx:78
#: src/features/homeAmaru/components/shared/UpdateMyCollectionModal.tsx:86
#: src/features/notifications/components/Notifications.tsx:130
#: src/features/notifications/components/NotificationsSaveModal.tsx:230
#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:172
#: src/features/reports/components/creationSection/EditReportTemplateDialog.tsx:152
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:121
#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:194
msgid "Descripción"
msgstr "Descripción"

#: src/fsd/pages/dga-reports/ui/report-problem-dialog.tsx:166
msgid "Descripción (opcional)"
msgstr "Descripción (opcional)"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:199
msgid "Descripción de las columnas:"
msgstr "Descripción de las columnas:"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:221
msgid "Descuento aplicado al servicio en porcentaje."
msgstr "Descuento aplicado al servicio en porcentaje."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:223
msgid "Descuento aplicado al servicio en valor nominal."
msgstr "Descuento aplicado al servicio en valor nominal."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:207
msgid "Descuento aplicado globalmente a la factura en porcentaje."
msgstr "Descuento aplicado globalmente a la factura en porcentaje."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:209
msgid "Descuento aplicado globalmente a la factura en valor nominal."
msgstr "Descuento aplicado globalmente a la factura en valor nominal."

#: src/features/billing/components/payments/PaymentForm.tsx:126
#: src/features/billing/components/payments/PaymentsTable.tsx:47
msgid "Descuento global nominal"
msgstr "Descuento global nominal"

#: src/features/billing/components/payments/PaymentForm.tsx:113
#: src/features/billing/components/payments/PaymentsTable.tsx:46
msgid "Descuento global porcentual"
msgstr "Descuento global porcentual"

#: src/features/billing/components/payments/PaymentDetailsForm.tsx:135
#: src/features/billing/components/payments/PaymentRow.tsx:103
msgid "Descuento nominal"
msgstr "Descuento nominal"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:98
msgid "Descuento Nominal"
msgstr "Descuento Nominal"

#: src/features/billing/components/payments/PaymentDetailsForm.tsx:120
#: src/features/billing/components/payments/PaymentRow.tsx:102
msgid "Descuento porcentual"
msgstr "Descuento porcentual"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:97
msgid "Descuento Porcentual"
msgstr "Descuento Porcentual"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:226
#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:202
#: src/features/dateTimeRangePicker/components/DateTimeRangePicker.tsx:94
#: src/features/dga/components/modals/reports/SendReportsByEmailModal.tsx:80
#: src/features/sma/components/SendReportsByEmailModal.tsx:93
#: src/fsd/app/locale/au-labels.ts:97
msgid "Desde"
msgstr "Desde"

#: src/features/gateOperationModal/components/panelNotification/NotificationCard.tsx:222
#: src/features/gateOperationModal/components/panelNotification/NotificationCard.tsx:225
#: src/fsd/features/gate-movements/ui/operation/feed/feed-card.tsx:150
#: src/fsd/features/gate-movements/ui/operation/feed/feed-card.tsx:153
#: src/fsd/pages/gate-movements/ui/panel/events/event-card.tsx:161
#: src/fsd/pages/gate-movements/ui/panel/events/event-card.tsx:164
msgid "desde {since}"
msgstr "desde {since}"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:76
msgid "Deseleccionar"
msgstr "Deseleccionar"

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:294
#: src/features/reports/components/selectables/DeviceSelectDialog.tsx:157
msgid "Deseleccionar todos"
msgstr "Deseleccionar todos"

#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:9
msgid "Desempeño de asignación"
msgstr "Desempeño de asignación"

#: src/features/devices2/utils/getOrderByOptions.ts:41
msgid "Desfase (Asc)"
msgstr "Desfase (Asc)"

#: src/features/devices2/utils/getOrderByOptions.ts:44
msgid "Desfase (Desc)"
msgstr "Desfase (Desc)"

#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:134
msgid "Desfase configurado de {0} {1}"
msgstr "Desfase configurado de {0} {1}"

#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:97
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:184
msgid "Desfase de datos en horas"
msgstr "Desfase de datos en horas"

#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:108
msgid "Deshabilitada"
msgstr "Deshabilitada"

#: src/fsd/entities/dashboard-widget/model/dga-reports-sample.ts:75
msgid "Deshabilitado"
msgstr "Deshabilitado"

#: src/features/api/components/CaptaApiUsersList.tsx:174
#: src/features/api/components/dialogs/DisableApiUserDialog.tsx:111
msgid "Deshabilitar"
msgstr "Deshabilitar"

#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:102
#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:103
msgid "Deshabilitar alerta"
msgstr "Deshabilitar alerta"

#: src/features/api/components/dialogs/DisableApiUserDialog.tsx:67
msgid "Deshabilitar credencial API"
msgstr "Deshabilitar credencial API"

#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:444
msgid "Deshabilitar cuenta"
msgstr "Deshabilitar cuenta"

#: src/features/audit/utils/getActionTypeOptions.ts:268
msgid "Deshabilitar Envío de DGA"
msgstr "Deshabilitar Envío de DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:450
msgid "deshabilitó el envío de DGA"
msgstr "deshabilitó el envío de DGA"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:195
#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:196
#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:115
msgid "Deshacer"
msgstr "Deshacer"

#: src/fsd/pages/widget-catalog/ui/preview.tsx:119
msgid "Desktop"
msgstr "Desktop"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:221
msgid "Desplazar el widget o la selección"
msgstr "Desplazar el widget o la selección"

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:133
msgid "Despues de 4 horas el equipo cambiara a los valores a modo"
msgstr "Despues de 4 horas el equipo cambiara a los valores a modo"

#: src/features/alertsConfigurationV2/components/upsertModal/AlertsConfigurationModal.tsx:56
#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:229
#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:441
msgid "Destinatarios"
msgstr "Destinatarios"

#: src/features/moveGateModal/hooks/useMoveGate.ts:54
#: src/fsd/entities/gate/model/command-feedback.ts:94
msgid "destino {0}"
msgstr "destino {0}"

#: src/fsd/pages/gate-movements/ui/panel/result/movement-result.tsx:77
msgid "Destino {0}"
msgstr "Destino {0}"

#: src/features/dgaTicket/components/DgaTicketModal.tsx:190
#: src/features/dgaTicket/components/DgaTicketModal.tsx:360
msgid "Detalle"
msgstr "Detalle"

#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:313
msgid "Detalle datos informe"
msgstr "Detalle datos informe"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:470
msgid "Detalle de integración"
msgstr "Detalle de integración"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:509
msgid "Detalles"
msgstr "Detalles"

#: src/features/moveGateModal/components/LiveNotice.tsx:60
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:246
msgid "Detener"
msgstr "Detener"

#: src/components/gates/StopMovementConfirmation.tsx:39
msgid "Detener el movimiento de la compuerta {0}"
msgstr "Detener el movimiento de la compuerta {0}"

#: src/features/gateCommon/utils/gateMovementState.tsx:178
#: src/fsd/entities/gate/model/movement-state.ts:94
msgid "Detener la operación la cancela."
msgstr "Detener la operación la cancela."

#: src/components/gates/StopMovementConfirmation.tsx:116
#: src/features/gateAdministration/components/index.tsx:398
msgid "Detener movimiento"
msgstr "Detener movimiento"

#: src/features/gateOperationModal/components/PanelOperation.tsx:406
#: src/features/metricsViews/components/widgets/gateOperate/OperateButtons.tsx:206
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:219
#: src/fsd/features/gate-movements/ui/operation/stop-button.tsx:44
msgid "Detener operación"
msgstr "Detener operación"

#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:242
#: src/fsd/features/gate-movements/ui/operation/stop-button.tsx:44
msgid "Deteniendo…"
msgstr "Deteniendo…"

#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:160
msgid "Determinación de tipos y rangos de alerta"
msgstr "Determinación de tipos y rangos de alerta"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:111
#: src/features/organizationsManagement/utils/filterOptions.ts:10
#: src/features/organizationsManagement/utils/filterOptions.ts:15
msgid "Deuda"
msgstr "Deuda"

#: src/features/events/components/HeaderTable.tsx:29
msgid "Device Id"
msgstr "Device Id"

#: src/features/collections/utils/filterOptions.ts:30
#: src/features/deviceSupport/components/DevicesFilters.tsx:193
#: src/features/deviceSupport/components/FilterAdvance.tsx:189
#: src/features/deviceSupport/data/column.ts:145
#: src/features/deviceSupport/data/fields.ts:24
#: src/features/deviceSupport/data/filter.ts:14
#: src/fsd/entities/dashboard-widget/ui/type-groups.ts:28
msgid "DGA"
msgstr "DGA"

#: src/features/audit/utils/parseProperty.ts:36
msgid "DGA activado"
msgstr "DGA activado"

#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:171
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:259
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:324
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:346
#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:274
msgid "Día de la semana"
msgstr "Día de la semana"

#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:187
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:275
msgid "Día del mes"
msgstr "Día del mes"

#: src/features/deviceProfile/components/page/Support.tsx:197
msgid "Diagnóstico"
msgstr "Diagnóstico"

#: src/pages/support.tsx:9
msgid "Diagnóstico de dispositivos"
msgstr "Diagnóstico de dispositivos"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:83
msgid "Diagnóstico de Dispositivos"
msgstr "Diagnóstico de Dispositivos"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:490
msgid "Diamante"
msgstr "Diamante"

#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:39
msgid "Diaria"
msgstr "Diaria"

#: src/fsd/entities/dashboard-widget/model/dga-frequency.ts:48
msgid "Diaria ({hour})"
msgstr "Diaria ({hour})"

#: src/utils/i18n/getDgaTranslations.ts:36
msgid "Diaria ({hourString})"
msgstr "Diaria ({hourString})"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:95
#: src/features/reports2/utils/schedule.ts:10
msgid "Diariamente"
msgstr "Diariamente"

#: src/features/devices2/utils/getDgaFrequencyOptions.ts:8
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:120
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:208
msgid "Diario"
msgstr "Diario"

#: src/features/reports/utils/schedules.ts:44
#: src/features/reports2/utils/schedule.ts:77
msgid "Diario a las {hoursMinutesStr} horas."
msgstr "Diario a las {hoursMinutesStr} horas."

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:229
#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:255
#: src/features/users/components/modals/ExtendTemporaryUserModal.tsx:81
msgid "días"
msgstr "días"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:302
#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:250
msgid "Días de la semana"
msgstr "Días de la semana"

#: src/features/reports/utils/schedules.ts:46
#: src/features/reports2/utils/schedule.ts:79
msgid "Días de semana (lunes a viernes) a las {hoursMinutesStr} horas."
msgstr "Días de semana (lunes a viernes) a las {hoursMinutesStr} horas."

#: src/features/deviceSupport/data/column.ts:77
msgid "Dias restantes"
msgstr "Dias restantes"

#: src/features/deviceSupport/data/fields.ts:15
msgid "Dias restantes de batería"
msgstr "Dias restantes de batería"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:32
msgid "Diciembre"
msgstr "Diciembre"

#: src/features/audit/utils/parseProperty.ts:115
msgid "dirección"
msgstr "dirección"

#: src/components/filters/OrderDirection.tsx:26
#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:220
#: src/features/organizationsManagement/components/OrganizationsTable.tsx:93
msgid "Dirección"
msgstr "Dirección"

#: src/features/alertsConfigurationV3/components/wizard/steps/NotificationsStep.tsx:147
msgid "Dirección de correo"
msgstr "Dirección de correo"

#: src/features/audit/utils/parseProperty.ts:148
msgid "dirección ip"
msgstr "dirección ip"

#: src/features/audit/utils/parseProperty.ts:146
msgid "dirección mac"
msgstr "dirección mac"

#: src/features/deviceAccessModal/components/allAccessTab/AllUsersAccessListItem.tsx:111
#: src/features/userConfigurationModal/components/allAccessTab/AllAccessListItem.tsx:108
msgid "Directo"
msgstr "Directo"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:202
#: src/pages/standard-design/index.tsx:10
msgid "Diseño Amaru"
msgstr "Diseño Amaru"

#: src/features/deviceConfiguration/components/TriggerConfigUpdateModal.tsx:141
msgid "Disparar actualización"
msgstr "Disparar actualización"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:36
msgid "Dispersión"
msgstr "Dispersión"

#: src/fsd/pages/dga-reports/ui/dga-service-strip.tsx:49
msgid "Disponibilidad de la plataforma DGA"
msgstr "Disponibilidad de la plataforma DGA"

#: src/fsd/pages/dga-reports/ui/dga-service-strip.tsx:41
msgid "Disponibilidad por hora, últimos {STRIP_DAYS} días: {availableHours} de {STRIP_HOURS} horas disponibles; actual: {currentLabel}"
msgstr "Disponibilidad por hora, últimos {STRIP_DAYS} días: {availableHours} de {STRIP_HOURS} horas disponibles; actual: {currentLabel}"

#: src/features/dga/components/DgaServiceBarChart.tsx:37
#: src/features/dga/components/DgaServiceBarChart.tsx:62
#: src/features/gateCommon/utils/gateOperatingState.tsx:7
#: src/fsd/entities/dashboard-widget/model/gate-operate-sample.ts:88
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:322
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:88
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:89
#: src/fsd/pages/dga-reports/ui/dga-service-strip.tsx:35
msgid "Disponible"
msgstr "Disponible"

#: src/features/audit/utils/getDisplayNameEntity.ts:9
#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:261
msgid "dispositivo"
msgstr "dispositivo"

#: src/features/alertsConfigurationV2/components/upsertModal/AlertsConfigurationModal.tsx:41
#: src/features/alertsConfigurationV3/components/AlertSummaryCard.tsx:37
#: src/features/alertsConfigurationV3/components/UnconfiguredDeviceCard.tsx:17
#: src/features/alertsConfigurationV3/components/wizard/AlertWizardModal.tsx:70
#: src/features/alertsConfigurationV3/components/wizard/steps/DeviceStep.tsx:25
#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:136
#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:156
#: src/features/billing/components/payments/PaymentRow.tsx:99
#: src/features/billing/components/projectService/Delete.tsx:122
#: src/features/billing/utils/list.ts:17
#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:102
#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:226
#: src/features/deviceConfiguration/data/tableColumns.ts:5
#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:144
#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:293
#: src/features/metricsViews/components/forms/ContactSupportWidgetForm.tsx:26
#: src/features/metricsViews/components/forms/DataWidgetForm.tsx:80
#: src/features/metricsViews/components/forms/DgaReportsChartWidgetForm.tsx:34
#: src/features/metricsViews/components/forms/DgaReportsWidgetForm.tsx:56
#: src/features/metricsViews/components/forms/GateOperateWidgetForm.tsx:25
#: src/features/metricsViews/components/forms/GateSensorWidgetForm.tsx:42
#: src/features/metricsViews/components/forms/MovementsTableForm.tsx:34
#: src/features/metricsViews/components/forms/TableWidgetForm.tsx:59
#: src/features/metricsViews/components/forms/TrendSummaryForm.tsx:209
#: src/features/metricsViews/components/widgets/configuredAlerts/Table.tsx:263
#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:135
#: src/fsd/entities/dashboard-widget/ui/contact-support/contact-support-editor.tsx:63
#: src/fsd/entities/dashboard-widget/ui/contact-support/contact-support-editor.tsx:70
#: src/fsd/entities/dashboard-widget/ui/data/data-editor.tsx:49
#: src/fsd/entities/dashboard-widget/ui/data/data-editor.tsx:58
#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-editor.tsx:20
#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-editor.tsx:29
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-editor.tsx:31
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-editor.tsx:40
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-editor.tsx:20
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-editor.tsx:29
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-editor.tsx:41
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-editor.tsx:50
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-editor.tsx:21
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-editor.tsx:30
#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:56
#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:65
#: src/fsd/pages/dashboards/ui/report-problem/report-problem-dialog.tsx:118
#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:61
#: src/fsd/pages/dga-reports/ui/device-list-header.tsx:22
msgid "Dispositivo"
msgstr "Dispositivo"

#: src/features/createDevice/hooks/useCreateDeviceForm.ts:35
msgid "Dispositivo {0} con ID: {1} creado con éxito"
msgstr "Dispositivo {0} con ID: {1} creado con éxito"

#: src/features/metricsViews/components/widgets/allocationPerformance/Controls.tsx:150
#: src/features/metricsViews/components/widgets/allocationPerformance/Header.legacy.tsx:166
msgid "Dispositivo a comparar"
msgstr "Dispositivo a comparar"

#: src/features/changeOperationalState/hooks/useUpdateOperationalStateMutation.ts:38
#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:85
#: src/features/deviceConfigurationModal/components/publicTab/useUpdateForm.ts:42
msgid "Dispositivo actualizado correctamente"
msgstr "Dispositivo actualizado correctamente"

#: src/features/audit/components/AuditLogsSidebar.tsx:144
msgid "Dispositivo afectado"
msgstr "Dispositivo afectado"

#: src/features/sma/components/forFutureUse/DialogSmaUnitSummary.tsx:121
msgid "Dispositivo Amaru"
msgstr "Dispositivo Amaru"

#: src/features/controlCenter2/components/devicesList/Footer.tsx:114
msgid "Dispositivo anterior"
msgstr "Dispositivo anterior"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:273
msgid "Dispositivo cobrable"
msgstr "Dispositivo cobrable"

#: src/features/deviceSupport/components/SupportTableBody.tsx:243
msgid "Dispositivo con reporte DGA"
msgstr "Dispositivo con reporte DGA"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:146
msgid "Dispositivo de la serie {n}"
msgstr "Dispositivo de la serie {n}"

#: src/features/collections/components/modals/ManageCollectionAccessModal.tsx:42
msgid "Dispositivo eliminado de la colección exitosamente"
msgstr "Dispositivo eliminado de la colección exitosamente"

#: src/features/metricsViews/components/forms/AllocationPerformanceWidgetForm.tsx:54
#: src/features/metricsViews/components/forms/AllocationPerformanceWidgetForm.tsx:111
msgid "Dispositivo fijo"
msgstr "Dispositivo fijo"

#: src/features/metricsViews/components/createViewModal/CreateViewForm.tsx:110
msgid "Dispositivo maestro"
msgstr "Dispositivo maestro"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:279
msgid "Dispositivo no cobrable"
msgstr "Dispositivo no cobrable"

#: src/features/moveGateModal/components/LastPosition.tsx:25
#: src/features/moveGateModal/components/OperatingState.tsx:25
msgid "Dispositivo no seleccionado"
msgstr "Dispositivo no seleccionado"

#: src/features/dga/components/modals/CopyDGAConfigSection.tsx:83
msgid "Dispositivo origen"
msgstr "Dispositivo origen"

#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:16
#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:25
#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:35
msgid "Dispositivo principal"
msgstr "Dispositivo principal"

#: src/features/deviceConfigurationModal/components/publicTab/index.tsx:30
msgid "Dispositivo público"
msgstr "Dispositivo público"

#: src/features/changeOperationalState/components/AfterUpdateTasksModal.tsx:45
msgid "Dispositivo reactivado"
msgstr "Dispositivo reactivado"

#: src/features/controlCenter2/components/devicesList/Footer.tsx:132
msgid "Dispositivo siguiente"
msgstr "Dispositivo siguiente"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-view.tsx:212
#: src/fsd/entities/dashboard-widget/ui/table/table-view.tsx:177
msgid "Dispositivo sin conexión"
msgstr "Dispositivo sin conexión"

#: src/utils/attributes/metricAlertEvaluation.ts:24
msgid "Dispositivo sin datos"
msgstr "Dispositivo sin datos"

#: src/features/deviceSupport/components/SupportTableBody.tsx:245
msgid "Dispositivo sin reporte DGA"
msgstr "Dispositivo sin reporte DGA"

#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:74
#: src/features/homeAmaru/components/shared/CollectionMap.tsx:75
msgid "dispositivos"
msgstr "dispositivos"

#: src/features/access/components/AccessView.tsx:24
#: src/features/collections/components/CollectionsTable.tsx:57
#: src/features/collectionsAccessInputs/components/CollectionsListItem.tsx:114
#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:70
#: src/features/deviceCommands/components/custom/DevicesSelector.tsx:31
#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:86
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:73
#: src/features/homeAmaru/components/shared/WorkspaceHeader.tsx:36
#: src/features/metricsViews/components/createViewModal/CreateViewForm.tsx:162
#: src/features/metricsViews/components/ExportHeader.tsx:56
#: src/features/metricsViews/components/forms/ActiveAlertsForm.tsx:57
#: src/features/metricsViews/components/forms/AlertsTableForm.tsx:45
#: src/features/metricsViews/components/forms/ConfiguredAlertsForm.tsx:43
#: src/features/metricsViews/components/forms/DevicesListWidgetForm.tsx:53
#: src/features/metricsViews/components/forms/DgaTicketsWidgetForm.tsx:28
#: src/features/metricsViews/components/forms/MapWidgetForm.tsx:43
#: src/features/metricsViews/components/forms/OperationalStatesForm.tsx:57
#: src/features/metricsViews/components/MetricsViewList.tsx:147
#: src/features/metricsViews/utils/quickAccessCatalog.tsx:83
#: src/features/organizationAccess/data/sections.ts:29
#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:480
#: src/features/reports/components/DeviceMetricsSummary.tsx:21
#: src/features/reports/components/ReportHistory.tsx:80
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:304
#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:391
#: src/features/reports2/components/reportHistoryModal/ReportHistory.tsx:85
#: src/features/reports2/components/ReportTemplatesTable.tsx:69
#: src/features/reports2/components/TemplateSummary.tsx:62
#: src/fsd/entities/dashboard-widget/ui/dga-tickets/dga-tickets-editor.tsx:17
#: src/fsd/entities/dashboard-widget/ui/quick-access/destinations.ts:67
#: src/pages/devices2.tsx:9
msgid "Dispositivos"
msgstr "Dispositivos"

#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:87
msgid "DISPOSITIVOS"
msgstr "DISPOSITIVOS"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarComparisonDevices.tsx:20
#: src/features/metricsViews/components/forms/AllocationPerformanceWidgetForm.tsx:145
msgid "Dispositivos a comparar"
msgstr "Dispositivos a comparar"

#: src/features/userConfigurationModal/components/deviceAccessTab/index.tsx:107
msgid "Dispositivos a los que tiene acceso el usuario"
msgstr "Dispositivos a los que tiene acceso el usuario"

#: src/features/collections/components/modals/AddCollectionAccessModal.tsx:41
msgid "Dispositivos agregados exitosamente"
msgstr "Dispositivos agregados exitosamente"

#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:137
msgid "Dispositivos con acceso"
msgstr "Dispositivos con acceso"

#: src/features/alertsConfigurationV3/components/AlertsConfigurationV3.tsx:88
msgid "Dispositivos con alertas configuradas"
msgstr "Dispositivos con alertas configuradas"

#: src/fsd/pages/dga-reports/ui/device-list-header.tsx:13
msgid "Dispositivos con reportes DGA"
msgstr "Dispositivos con reportes DGA"

#: src/features/collections/components/modals/ManageCollectionAccessModal.tsx:78
msgid "Dispositivos de {0}"
msgstr "Dispositivos de {0}"

#: src/features/metricsViews/components/AssociateCollectionModal.tsx:214
msgid "Dispositivos del tablero"
msgstr "Dispositivos del tablero"

#: src/features/collections/components/modals/CreateMetricsViewFromCollectionModal.tsx:142
msgid "Dispositivos del tablero ({0})"
msgstr "Dispositivos del tablero ({0})"

#: src/features/metricsViews/components/createViewModal/CreateViewForm.tsx:145
msgid "Dispositivos permitidos"
msgstr "Dispositivos permitidos"

#: src/features/organizationAccess/data/sections.ts:33
msgid "Dispositivos Público"
msgstr "Dispositivos Público"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:105
#: src/features/organizationsManagement/components/OrganizationsTable.tsx:166
msgid "Dispositivos públicos"
msgstr "Dispositivos públicos"

#: src/features/deviceProfile/components/page/RelatedDevices.tsx:67
msgid "Dispositivos relacionados"
msgstr "Dispositivos relacionados"

#: src/features/reports/components/selectables/DeviceSelectDialog.tsx:239
msgid "Dispositivos seleccionados"
msgstr "Dispositivos seleccionados"

#: src/features/alertsConfigurationV3/components/AlertsConfigurationV3.tsx:138
msgid "Dispositivos sin configurar"
msgstr "Dispositivos sin configurar"

#: src/fsd/entities/dashboard-widget/ui/type-groups.ts:34
msgid "Dispositivos y mapa"
msgstr "Dispositivos y mapa"

#: src/features/reports2/components/createModal/steps/step1/1-DevicesAndMetrics.tsx:48
#: src/features/reports2/components/createModal/steps/step5/ReportSummary.tsx:57
#: src/features/reports2/utils/createModalStep.ts:21
msgid "Dispositivos y métricas"
msgstr "Dispositivos y métricas"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:69
msgid "Dist. sensor"
msgstr "Dist. sensor"

#: src/features/alertsNotificationsHistory/utils/alertTypes.ts:18
msgid "Distancia al sensor"
msgstr "Distancia al sensor"

#: src/utils/attributes/metricField.ts:251
msgid "distancia al sensor de compuerta"
msgstr "distancia al sensor de compuerta"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:315
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:74
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:24
#: src/utils/i18n/getMetricDisplayName.ts:16
msgid "Distancia al sensor de compuerta"
msgstr "Distancia al sensor de compuerta"

#: src/utils/attributes/deviceAlertMetricName.ts:37
msgid "Distancia de sensor"
msgstr "Distancia de sensor"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:330
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:101
#: src/utils/i18n/getMetricDisplayName.ts:19
msgid "Distancia del sensor"
msgstr "Distancia del sensor"

#: src/features/reports/utils/metricHelpers.ts:24
msgid "Distancia del Sensor"
msgstr "Distancia del Sensor"

#: src/utils/attributes/metricField.ts:275
msgid "distancia original"
msgstr "distancia original"

#: src/utils/attributes/metricField.ts:281
msgid "distancia original bruta"
msgstr "distancia original bruta"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:360
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:234
#: src/features/reports/utils/metricHelpers.ts:38
msgid "Distancia sensor"
msgstr "Distancia sensor"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:94
#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:98
msgid "Distribución"
msgstr "Distribución"

#: src/features/audit/utils/getDisplayNameEntity.ts:11
msgid "distribución de SIRA"
msgstr "distribución de SIRA"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:101
msgid "Doble"
msgstr "Doble"

#: src/features/metricsViews/components/ExportViewButton.tsx:52
#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:357
msgid "Documento PDF"
msgstr "Documento PDF"

#: src/features/reports/utils/schedules.ts:19
msgid "domingo"
msgstr "domingo"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:114
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:165
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:253
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:90
#: src/features/reports2/utils/schedule.ts:30
#: src/fsd/entities/dashboard-widget/model/dga-frequency.ts:19
#: src/utils/i18n/getDgaTranslations.ts:13
msgid "Domingo"
msgstr "Domingo"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:70
#: src/fsd/pages/widget-catalog/model/examples.ts:236
msgid "Dos paneles"
msgstr "Dos paneles"

#: src/utils/attributes/metricField.ts:35
msgid "dotación"
msgstr "dotación"

#: src/features/controlCenter/utils/minicharts.ts:187
#: src/features/controlCenter/utils/viewModes.ts:21
#: src/features/controlCenter2/utils/viewModes.ts:24
#: src/features/devicesAnalysis/components/panel/Chart.tsx:312
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:348
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:18
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:63
msgid "Dotación"
msgstr "Dotación"

#: src/fsd/pages/dashboards/ui/canvas/canvas.tsx:619
#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:97
msgid "Duplicar"
msgstr "Duplicar"

#: src/fsd/pages/dashboards/ui/canvas/canvas.tsx:616
msgid "Duplicar (Ctrl+D)"
msgstr "Duplicar (Ctrl+D)"

#: src/fsd/pages/dashboards/ui/panel/multi-scope.tsx:65
msgid "Duplicar todos"
msgstr "Duplicar todos"

#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:96
msgid "Duración"
msgstr "Duración"

#: src/features/metricsViews/components/widgets/common/DurationAutocomplete.tsx:98
msgid "Duración fuera del rango permitido"
msgstr "Duración fuera del rango permitido"

#: src/features/metricsViews/components/widgets/common/DurationAutocomplete.tsx:95
msgid "Duración inválida. Usa p.ej. 90m, 1h30m, 2w"
msgstr "Duración inválida. Usa p.ej. 90m, 1h30m, 2w"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:292
msgid "Ecuación curva polinomial"
msgstr "Ecuación curva polinomial"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:227
msgid "Ecuación curva potencial"
msgstr "Ecuación curva potencial"

#: src/pages/reports/edit.tsx:12
msgid "Edición de Reporte"
msgstr "Edición de Reporte"

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:28
msgid "Edición terminada."
msgstr "Edición terminada."

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:321
msgid "editado"
msgstr "editado"

#: src/features/deviceProfile/components/page/Observations.tsx:77
msgid "Editado el {0}"
msgstr "Editado el {0}"

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:26
msgid "Editando el tablero. Los cambios quedan en un borrador hasta guardar."
msgstr "Editando el tablero. Los cambios quedan en un borrador hasta guardar."

#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:141
#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:142
#: src/features/alertsConfigurationV3/components/wizard/steps/MetricStep.tsx:168
#: src/features/announcements/components/AnnouncementMenu.tsx:61
#: src/features/announcements/components/AnnouncementsSaveModal.tsx:320
#: src/features/billing/components/payments/Options.tsx:53
#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:531
#: src/features/deviceProfile/components/modal/ObservationMenu.tsx:28
#: src/features/devices2/components/list/itemPanel/SMAItemMenu.tsx:80
#: src/features/metricsViews/components/MetricsView.tsx:617
#: src/features/metricsViews/components/MetricsViewList.tsx:225
#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:283
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:272
#: src/features/users/components/tableCells/UserActionsCell.tsx:81
#: src/features/userSaveModal/components/UserSaveModal.tsx:619
#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:256
#: src/fsd/pages/dashboards/ui/panel/panel.tsx:68
#: src/fsd/pages/dashboards/ui/panel/panel.tsx:110
msgid "Editar"
msgstr "Editar"

#: src/features/alertsConfigurationV3/components/wizard/AlertWizardModal.tsx:246
msgid "Editar alerta"
msgstr "Editar alerta"

#: src/features/controlCenter/components/panel/Panel.tsx:73
msgid "Editar alertas"
msgstr "Editar alertas"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:198
msgid "Editar Anuncio {0}"
msgstr "Editar Anuncio {0}"

#: src/features/collections/components/CollectionsTable.tsx:170
#: src/features/collections/components/modals/UpdateCollectionModal.tsx:242
msgid "Editar colección"
msgstr "Editar colección"

#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:166
msgid "Editar configuración"
msgstr "Editar configuración"

#: src/features/alertsConfiguration/components/AlertTable.tsx:106
msgid "Editar configuración de alertas"
msgstr "Editar configuración de alertas"

#: src/features/alertsConfiguration/components/DialogUsersNotifications.tsx:97
msgid "Editar configuración de notificaciones del dispositivo {0}"
msgstr "Editar configuración de notificaciones del dispositivo {0}"

#: src/features/metricsViews/components/EditViewModal.tsx:99
msgid "Editar configuración de visualización de métricas"
msgstr "Editar configuración de visualización de métricas"

#: src/features/api/components/dialogs/EditApiUserDialog.tsx:68
msgid "Editar credencial API"
msgstr "Editar credencial API"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:191
msgid "Editar curva"
msgstr "Editar curva"

#: src/features/alertsConfiguration/components/AlertTable.tsx:122
msgid "Editar notificaciones de alertas"
msgstr "Editar notificaciones de alertas"

#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:185
msgid "Editar Organización"
msgstr "Editar Organización"

#: src/features/userProfile/components/UserProfile.tsx:98
#: src/features/userProfile/components/UserProfileSkeleton.tsx:36
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:268
msgid "Editar perfil"
msgstr "Editar perfil"

#: src/features/api/components/CaptaApiUsersList.tsx:161
msgid "Editar Permisos"
msgstr "Editar Permisos"

#: src/features/reports/components/creationSection/EditReportTemplate.tsx:63
msgid "Editar Reporte"
msgstr "Editar Reporte"

#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:237
msgid "Editar tablero"
msgstr "Editar tablero"

#: src/features/users/components/modals/SaveUserModal.tsx:171
msgid "Editar usuario"
msgstr "Editar usuario"

#: src/features/userSaveModal/components/UserSaveModal.tsx:328
msgid "Editar Usuario"
msgstr "Editar Usuario"

#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:144
#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:150
msgid "Editar usuarios a notificar"
msgstr "Editar usuarios a notificar"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:162
msgid "Editar widget"
msgstr "Editar widget"

#: src/features/metricsViews/utils/genericWidgetTypes.ts:72
msgid "Eficiencia de reparto"
msgstr "Eficiencia de reparto"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:96
msgid "Eje X"
msgstr "Eje X"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:96
msgid "Eje Y"
msgstr "Eje Y"

#: src/features/gateAdministration/components/RequestedPositionIcon.tsx:25
msgid "Ejecutada"
msgstr "Ejecutada"

#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:230
msgid "Ejecutar a las"
msgstr "Ejecutar a las"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:274
msgid "Ejecutar diariamente a las"
msgstr "Ejecutar diariamente a las"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:318
msgid "Ejecutar en el primer"
msgstr "Ejecutar en el primer"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:340
msgid "Ejecutar en el último"
msgstr "Ejecutar en el último"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:285
msgid "Ejecutar los días de semana (de lunes a viernes) a las"
msgstr "Ejecutar los días de semana (de lunes a viernes) a las"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:296
msgid "Ejecutar semanalmente los días"
msgstr "Ejecutar semanalmente los días"

#: src/fsd/entities/dashboard-widget/ui/format/sample-mark.tsx:16
msgid "Ejemplo"
msgstr "Ejemplo"

#: src/fsd/pages/widget-catalog/ui/widget-catalog-page.tsx:100
msgid "Ejemplos"
msgstr "Ejemplos"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:93
msgid "Ejes"
msgstr "Ejes"

#: src/utils/getAlertsState.ts:22
msgid "El {msgText} está por debajo del {msgText2} mínimo del canal."
msgstr "El {msgText} está por debajo del {msgText2} mínimo del canal."

#: src/utils/getAlertsState.ts:21
msgid "El {msgText} supera el {msgText2} máximo del canal."
msgstr "El {msgText} supera el {msgText2} máximo del canal."

#: src/utils/getAlertsState.ts:20
msgid "El {msgText} supera la capacidad del canal."
msgstr "El {msgText} supera la capacidad del canal."

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:78
msgid "El apellido debe tener por lo menos 1 caracter"
msgstr "El apellido debe tener por lo menos 1 caracter"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:194
msgid "El archivo debe estar en formato .xlsx (Excel) y debe seguir estrictamente la estructura de columnas que se detalla a continuación. Cada fila del archivo representa un servicio facturado dentro de un proyecto determinado."
msgstr "El archivo debe estar en formato .xlsx (Excel) y debe seguir estrictamente la estructura de columnas que se detalla a continuación. Cada fila del archivo representa un servicio facturado dentro de un proyecto determinado."

#: src/features/createDeviceConfiguration/components/common/PDFUploadField.tsx:58
msgid "El archivo debe ser un PDF"
msgstr "El archivo debe ser un PDF"

#: src/features/createDeviceConfiguration/components/common/PDFUploadField.tsx:64
msgid "El archivo no debe superar 20MB"
msgstr "El archivo no debe superar 20MB"

#: src/fsd/entities/dashboard-widget/api/image-upload.ts:59
msgid "El archivo supera los 20 MB que se pueden procesar. Elige una imagen más liviana"
msgstr "El archivo supera los 20 MB que se pueden procesar. Elige una imagen más liviana"

#: src/features/reportDownload/components/ReportDownload.tsx:67
msgid "El archivo ya se ha descargado en su computador. Para volver a descargar haga <0>click aquí</0>."
msgstr "El archivo ya se ha descargado en su computador. Para volver a descargar haga <0>click aquí</0>."

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:11
msgid "El asistente está saturado en este momento. Intenta de nuevo en unos segundos."
msgstr "El asistente está saturado en este momento. Intenta de nuevo en unos segundos."

#: src/fsd/pages/dashboards/ui/assistant/use-assistant-chat.ts:125
msgid "El asistente propone un tablero; revísalo y aplícalo desde el panel."
msgstr "El asistente propone un tablero; revísalo y aplícalo desde el panel."

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:27
msgid "El asistente rechazó el pedido: {message}"
msgstr "El asistente rechazó el pedido: {message}"

#: src/fsd/pages/dashboards/ui/assistant/use-assistant-chat.ts:126
msgid "El asistente respondió."
msgstr "El asistente respondió."

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:10
msgid "El asistente tardó demasiado en responder. Intenta de nuevo en unos segundos."
msgstr "El asistente tardó demasiado en responder. Intenta de nuevo en unos segundos."

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:55
msgid "El autor es requerido"
msgstr "El autor es requerido"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:207
msgid "El borrador cambió después de pedir esta propuesta: aplicarla también descarta esos cambios."
msgstr "El borrador cambió después de pedir esta propuesta: aplicarla también descarta esos cambios."

#: src/features/dga/utils/validationSchemas.ts:96
msgid "El campo 'code' no puede estar vacío"
msgstr "El campo 'code' no puede estar vacío"

#: src/features/dga/utils/validationSchemas.ts:91
#: src/features/dga/utils/validationSchemas.ts:118
#: src/features/dga/utils/validationSchemas.ts:127
#: src/features/dga/utils/validationSchemas.ts:139
msgid "El campo 'deviceId' no puede estar vacío"
msgstr "El campo 'deviceId' no puede estar vacío"

#: src/features/dga/utils/validationSchemas.ts:48
#: src/features/dga/utils/validationSchemas.ts:49
msgid "El campo 'Día' debe estar entre 1 y 27"
msgstr "El campo 'Día' debe estar entre 1 y 27"

#: src/features/dga/utils/validationSchemas.ts:46
msgid "El campo 'Día' debe ser un número entero"
msgstr "El campo 'Día' debe ser un número entero"

#: src/features/dga/utils/validationSchemas.ts:41
#: src/features/dga/utils/validationSchemas.ts:42
msgid "El campo 'Hora' debe estar entre 0 y 23"
msgstr "El campo 'Hora' debe estar entre 0 y 23"

#: src/features/dga/utils/validationSchemas.ts:39
msgid "El campo 'Hora' debe ser un número entero"
msgstr "El campo 'Hora' debe ser un número entero"

#: src/features/dga/utils/validationSchemas.ts:110
msgid "El campo 'password' no puede estar vacío"
msgstr "El campo 'password' no puede estar vacío"

#: src/utils/getAlertsState.ts:111
msgid "El caudal supera el máximo de {distributionMaxFlow} L/s permitido por el reparto para este canal."
msgstr "El caudal supera el máximo de {distributionMaxFlow} L/s permitido por el reparto para este canal."

#: src/fsd/pages/dashboards/ui/hidden-chip/hidden-chip.tsx:30
msgid "El cliente no ve este tablero."
msgstr "El cliente no ve este tablero."

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:82
msgid "El código de país debe ser válido"
msgstr "El código de país debe ser válido"

#: src/features/organizationCreateOrUpdate/utils/schema.ts:14
#: src/features/userSaveModal/utils/schema.ts:65
msgid "El código de país es requerido."
msgstr "El código de país es requerido."

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:204
msgid "el color de {metricName}"
msgstr "el color de {metricName}"

#: src/features/deviceObservations/components/modals/CreateObservationModal.tsx:26
#: src/features/deviceObservations/components/modals/UpdateObservationModal.tsx:29
msgid "El contenido debe tener al menos 2 caracteres"
msgstr "El contenido debe tener al menos 2 caracteres"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:67
msgid "El contenido es requerido"
msgstr "El contenido es requerido"

#: src/features/userSaveModal/utils/schema.ts:60
msgid "El correo electrónico es requerido."
msgstr "El correo electrónico es requerido."

#: src/features/usersGraveyard/components/HardDeleteUserModal.tsx:111
msgid "El correo electrónico quedará disponible para ser reutilizado."
msgstr "El correo electrónico quedará disponible para ser reutilizado."

#: src/features/dga/utils/validationSchemas.ts:32
msgid "El delay debe ser mayor a 0"
msgstr "El delay debe ser mayor a 0"

#: src/features/dga/utils/validationSchemas.ts:31
msgid "El delay debe ser menor a 168"
msgstr "El delay debe ser menor a 168"

#: src/features/billing/utils/validationSchema.ts:14
msgid "El descuento no puede ser mayor al 100 %."
msgstr "El descuento no puede ser mayor al 100 %."

#: src/features/dgaTicket/components/DgaTicketModal.tsx:322
msgid "El dispositivo <0><1/></0> tiene un ticket abierto. Puedes corregir sus datos o cerrarlo."
msgstr "El dispositivo <0><1/></0> tiene un ticket abierto. Puedes corregir sus datos o cerrarlo."

#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:337
msgid "El dispositivo elegido no tiene compuerta, así que no hay movimientos que mostrar. Elige otro en la configuración del widget."
msgstr "El dispositivo elegido no tiene compuerta, así que no hay movimientos que mostrar. Elige otro en la configuración del widget."

#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:299
msgid "El dispositivo elegido no tiene compuerta, así que no hay nada que operar. Elige otro en la configuración del widget."
msgstr "El dispositivo elegido no tiene compuerta, así que no hay nada que operar. Elige otro en la configuración del widget."

#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-view.tsx:200
msgid "El dispositivo elegido no tiene compuerta, así que no hay sensores que mostrar. Elige otro en la configuración del widget."
msgstr "El dispositivo elegido no tiene compuerta, así que no hay sensores que mostrar. Elige otro en la configuración del widget."

#: src/utils/getAlertsState.ts:98
msgid "El dispositivo está desconectado."
msgstr "El dispositivo está desconectado."

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:114
#: src/fsd/entities/dashboard-widget/ui/contact-support/contact-support-editor.tsx:40
#: src/fsd/entities/dashboard-widget/ui/data/data-editor.tsx:40
#: src/fsd/entities/dashboard-widget/ui/format/device-warning.ts:22
msgid "El dispositivo guardado ya no está entre los de este tablero."
msgstr "El dispositivo guardado ya no está entre los de este tablero."

#: src/features/changeOperationalState/components/AfterUpdateTasksModal.tsx:51
msgid "El dispositivo ha sido actualizado de mantenimiento a activo. Se recomienda revisar las siguientes configuraciones:"
msgstr "El dispositivo ha sido actualizado de mantenimiento a activo. Se recomienda revisar las siguientes configuraciones:"

#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:297
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-view.tsx:198
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:335
msgid "El dispositivo no es una compuerta"
msgstr "El dispositivo no es una compuerta"

#: src/features/billing/components/projectService/Create.tsx:72
msgid "El dispositivo no está asociado con el proyecto. Por favor, configure el proyecto desde el perfil del equipo y vuelva a intentarlo."
msgstr "El dispositivo no está asociado con el proyecto. Por favor, configure el proyecto desde el perfil del equipo y vuelva a intentarlo."

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:208
msgid "El dispositivo no tiene configuración de hardware configurada"
msgstr "El dispositivo no tiene configuración de hardware configurada"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:126
msgid "El dispositivo no tiene datos las últimas 24 horas"
msgstr "El dispositivo no tiene datos las últimas 24 horas"

#: src/fsd/pages/dga-reports/ui/latest-reports.tsx:179
msgid "El dispositivo no tiene reportes."
msgstr "El dispositivo no tiene reportes."

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/index.tsx:30
msgid "El dispositivo no tiene sensor configurado"
msgstr "El dispositivo no tiene sensor configurado"

#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:143
msgid "El dispositivo principal {masterId} siempre forma parte del tablero."
msgstr "El dispositivo principal {masterId} siempre forma parte del tablero."

#: src/features/deviceConfigurationModal/components/cloneDeviceModal/CloneDeviceModal.tsx:99
msgid "El dispositivo se clonará con el siguiente nombre"
msgstr "El dispositivo se clonará con el siguiente nombre"

#: src/features/dga/components/modals/CopyDGAConfigSection.tsx:89
msgid "El dispositivo seleccionado no tiene configuración DGA"
msgstr "El dispositivo seleccionado no tiene configuración DGA"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:168
msgid "El dispositivo tiene configuración de hardware completa"
msgstr "El dispositivo tiene configuración de hardware completa"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:188
msgid "El dispositivo tiene configuración de hardware incompleta"
msgstr "El dispositivo tiene configuración de hardware incompleta"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:227
msgid "El dispositivo tiene configuración DGA creada pero faltan datos"
msgstr "El dispositivo tiene configuración DGA creada pero faltan datos"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:115
msgid "El dispositivo tiene datos las últimas 24 horas"
msgstr "El dispositivo tiene datos las últimas 24 horas"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:262
msgid "El dispositivo tiene la configuración DGA completa pero no posee envíos activos"
msgstr "El dispositivo tiene la configuración DGA completa pero no posee envíos activos"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:243
msgid "El dispositivo tiene la configuración DGA completa y posee envíos activos"
msgstr "El dispositivo tiene la configuración DGA completa y posee envíos activos"

#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:162
msgid "El dispositivo ya tiene una configuración DGA"
msgstr "El dispositivo ya tiene una configuración DGA"

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:73
msgid "El envío a la DGA está deshabilitado para este dispositivo."
msgstr "El envío a la DGA está deshabilitado para este dispositivo."

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:322
msgid "El envío está deshabilitado: no hay reportes que contar."
msgstr "El envío está deshabilitado: no hay reportes que contar."

#: src/features/controlCenter/components/window/DeviceListItem.tsx:137
#: src/features/controlCenter2/components/devicesList/ListItem.tsx:187
msgid "El equipo posee {shares} acciones"
msgstr "El equipo posee {shares} acciones"

#: src/features/moveGateModal/components/LiveNotice.tsx:100
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:282
msgid "El equipo rechazó la consulta de estado (código {code}). Se usan la última posición y los límites registrados."
msgstr "El equipo rechazó la consulta de estado (código {code}). Se usan la última posición y los límites registrados."

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:77
msgid "el foco se queda en la card"
msgstr "el foco se queda en la card"

#: src/features/dga/utils/validationSchemas.ts:105
#: src/features/dga/utils/validationSchemas.ts:131
msgid "El formato del RUT no es válido, ej: 12345678-K"
msgstr "El formato del RUT no es válido, ej: 12345678-K"

#: src/fsd/entities/dashboard-widget/ui/contact-support/contact-support-render.tsx:31
msgid "El formulario de reporte no está disponible: este tablero no tiene dispositivos."
msgstr "El formulario de reporte no está disponible: este tablero no tiene dispositivos."

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:104
msgid "El gráfico no tiene series."
msgstr "El gráfico no tiene series."

#: src/features/sma/components/SmaUpsertModal.tsx:44
msgid "El ID de la unidad fiscalizable de la SMA es requerido"
msgstr "El ID de la unidad fiscalizable de la SMA es requerido"

#: src/features/billing/components/modals/ServiceFileManager.tsx:59
msgid "El ID de uno de los proyectos no existe."
msgstr "El ID de uno de los proyectos no existe."

#: src/features/sma/components/SmaUpsertModal.tsx:46
msgid "El ID del dispositivo en la SMA es requerido"
msgstr "El ID del dispositivo en la SMA es requerido"

#: src/features/sma/components/SmaUpsertModal.tsx:45
msgid "El ID del proceso de la SMA es requerido"
msgstr "El ID del proceso de la SMA es requerido"

#: src/fsd/pages/dashboards/ui/layout-warnings/warning-text.ts:41
msgid "El layout guardado no tiene el formato esperado; se ignora."
msgstr "El layout guardado no tiene el formato esperado; se ignora."

#: src/features/moveGateModal/components/MoveGateForm.tsx:240
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:400
msgid "El límite que reporta el equipo ({0} a {1}) no es compatible con el configurado en la plataforma ({2} a {3}): se usa sólo el del equipo y no hay un rango confirmado."
msgstr "El límite que reporta el equipo ({0} a {1}) no es compatible con el configurado en la plataforma ({2} a {3}): se usa sólo el del equipo y no hay un rango confirmado."

#: src/features/reportDownload/components/ReportDownload.tsx:89
msgid "El link de descarga ha expirado o es inválido"
msgstr "El link de descarga ha expirado o es inválido"

#: src/features/deviceAlertsModal/components/basicConfigurationTab/updateSchema.ts:16
#: src/features/deviceConfigurationModal/components/gateTab/updateSchema.ts:13
msgid "El máximo debe ser mayor al mínimo"
msgstr "El máximo debe ser mayor al mínimo"

#: src/features/deviceDataConfigurationModal/utils/flowLimitsSchema.ts:30
msgid "El máximo no puede ser menor a 0"
msgstr "El máximo no puede ser menor a 0"

#: src/features/deviceDataConfigurationModal/utils/flowLimitsSchema.ts:24
msgid "El mínimo no puede ser mayor o igual al máximo."
msgstr "El mínimo no puede ser mayor o igual al máximo."

#: src/features/deviceDataConfigurationModal/utils/flowLimitsSchema.ts:36
msgid "El mínimo no puede ser menor a 0"
msgstr "El mínimo no puede ser menor a 0"

#: src/features/collections/components/CollectionVisualRepresentationFields.tsx:101
#: src/features/createMyCollectionModal/components/CreateMyCollectionModal.tsx:162
#: src/features/homeAmaru/components/shared/UpdateMyCollectionModal.tsx:170
msgid "El mosaico mostrará un mapa con la ubicación y estado de los dispositivos de esta colección — no requiere configuración adicional."
msgstr "El mosaico mostrará un mapa con la ubicación y estado de los dispositivos de esta colección — no requiere configuración adicional."

#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:33
#: src/features/reports/components/creationSection/EditReportTemplateDialog.tsx:32
msgid "El nombre de la plantilla no puede estar vacío"
msgstr "El nombre de la plantilla no puede estar vacío"

#: src/features/sma/components/SmaUpsertModal.tsx:42
msgid "El nombre de usuario es requerido"
msgstr "El nombre de usuario es requerido"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:77
msgid "El nombre debe tener por lo menos 1 caracter"
msgstr "El nombre debe tener por lo menos 1 caracter"

#: src/features/deviceConfigurationModal/components/cloneDeviceModal/CloneDeviceModal.tsx:63
msgid "El nombre del dispositivo debe tener al menos 2 caracteres"
msgstr "El nombre del dispositivo debe tener al menos 2 caracteres"

#: src/features/collections/validators.ts:41
msgid "El nombre del tablero es requerido"
msgstr "El nombre del tablero es requerido"

#: src/features/collections/validators.ts:12
#: src/features/homeAmaru/utils/myCollectionSchema.ts:20
msgid "El nombre es requerido"
msgstr "El nombre es requerido"

#: src/features/organizationCreateOrUpdate/utils/schema.ts:8
#: src/features/userSaveModal/utils/schema.ts:48
msgid "El nombre es requerido."
msgstr "El nombre es requerido."

#: src/features/reportProblem/components/ReportProblemDialog.tsx:43
msgid "El nombre no puede estar vacío"
msgstr "El nombre no puede estar vacío"

#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:126
msgid "El nombre no puede quedar vacío."
msgstr "El nombre no puede quedar vacío."

#: src/features/collections/validators.ts:42
msgid "El nombre no puede tener más de 120 caracteres"
msgstr "El nombre no puede tener más de 120 caracteres"

#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:50
msgid "El nombre, el alcance y el color de este tablero, y si el cliente lo ve. Los cambios van al borrador y se guardan con el resto."
msgstr "El nombre, el alcance y el color de este tablero, y si el cliente lo ve. Los cambios van al borrador y se guardan con el resto."

#: src/features/users/components/modals/ExtendTemporaryUserTokenModal.tsx:69
msgid "El nuevo tiempo de expiración del token será en 2 semanas. ¿Deseas continuar?"
msgstr "El nuevo tiempo de expiración del token será en 2 semanas. ¿Deseas continuar?"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:100
msgid "El número de teléfono no es válido"
msgstr "El número de teléfono no es válido"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:83
msgid "El número de teléfono no puede estar vacío"
msgstr "El número de teléfono no puede estar vacío"

#: src/features/organizationCreateOrUpdate/utils/schema.ts:12
msgid "El número es requerido."
msgstr "El número es requerido."

#: src/features/metricsViews/components/forms/QuickAccessForm.tsx:36
#: src/fsd/entities/dashboard-widget/ui/quick-access/quick-access-editor.tsx:24
msgid "El orden de selección es el orden en que se muestran."
msgstr "El orden de selección es el orden en que se muestran."

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:15
msgid "El pedido no es válido. Revisa que no sea demasiado largo y reformúlalo."
msgstr "El pedido no es válido. Revisa que no sea demasiado largo y reformúlalo."

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:12
msgid "El pedido resultó demasiado complejo. Intenta simplificarlo o dividirlo en partes."
msgstr "El pedido resultó demasiado complejo. Intenta simplificarlo o dividirlo en partes."

#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-view.tsx:161
msgid "El período lo fija la frecuencia de envío DGA del dispositivo."
msgstr "El período lo fija la frecuencia de envío DGA del dispositivo."

#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:257
msgid "El período tiene más reportes de los que se descargan de una vez: el archivo trae los {0} más recientes. Elige un período más corto para el resto."
msgstr "El período tiene más reportes de los que se descargan de una vez: el archivo trae los {0} más recientes. Elige un período más corto para el resto."

#: src/features/billing/components/CreatePaymentView.tsx:78
#: src/features/billing/components/UpdatePaymentView.tsx:92
msgid "El proyecto no existe o el dispositivo no está asociado al proyecto."
msgstr "El proyecto no existe o el dispositivo no está asociado al proyecto."

#: src/features/dateTimeRangePicker/components/DateTimeRangePicker.tsx:124
msgid "El rango mínimo es de 15 minutos."
msgstr "El rango mínimo es de 15 minutos."

#: src/features/userSaveModal/utils/schema.ts:28
msgid "El rol es requerido."
msgstr "El rol es requerido."

#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-view.tsx:57
msgid "El sensor todavía no informa una lectura con fecha."
msgstr "El sensor todavía no informa una lectura con fecha."

#: src/features/metricsViews/components/AssociateCollectionModal.tsx:237
msgid "El tablero deja de mostrarlos."
msgstr "El tablero deja de mostrarlos."

#: src/features/collections/components/modals/CreateMetricsViewFromCollectionModal.tsx:118
msgid "El tablero queda anclado a la colección <0>{0}</0>: sus dispositivos son los del tablero, y agregar o quitar uno de la colección se refleja sin editar el tablero."
msgstr "El tablero queda anclado a la colección <0>{0}</0>: sus dispositivos son los del tablero, y agregar o quitar uno de la colección se refleja sin editar el tablero."

#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:210
msgid "El tablero se sigue editando, pero el cliente no lo ve."
msgstr "El tablero se sigue editando, pero el cliente no lo ve."

#: src/features/metricsViews/components/AssociateCollectionModal.tsx:228
msgid "El tablero va a mostrarlos."
msgstr "El tablero va a mostrarlos."

#: src/fsd/pages/dashboards/ui/change-bar/view-menu.tsx:69
msgid "El tablero ya está vacío"
msgstr "El tablero ya está vacío"

#: src/features/userSaveModal/utils/schema.ts:62
msgid "El teléfono debe ser un número válido."
msgstr "El teléfono debe ser un número válido."

#: src/features/organizationCreateOrUpdate/utils/schema.ts:13
msgid "El teléfono debe ser un número válido. Formato: XXXXXXXXX"
msgstr "El teléfono debe ser un número válido. Formato: XXXXXXXXX"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:149
msgid "El teléfono se deriva del escritorio"
msgstr "El teléfono se deriva del escritorio"

#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:15
msgid "El tipo de curva es obligatorio y debe ser function, interval o piecewise"
msgstr "El tipo de curva es obligatorio y debe ser function, interval o piecewise"

#: src/features/collections/validators.ts:14
msgid "El tipo es requerido"
msgstr "El tipo es requerido"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:59
msgid "El título es requerido"
msgstr "El título es requerido"

#: src/components/ClientHiddenChip.tsx:57
msgid "El usuario tiene acceso, pero aún no verá este dispositivo."
msgstr "El usuario tiene acceso, pero aún no verá este dispositivo."

#: src/features/deviceAlertsModal/components/basicConfigurationTab/updateSchema.ts:20
msgid "El valor de desborde debe ser mayor al máximo"
msgstr "El valor de desborde debe ser mayor al máximo"

#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:11
msgid "El valor debe ser mayor a {number}"
msgstr "El valor debe ser mayor a {number}"

#: src/features/billing/utils/validationSchema.ts:10
msgid "El valor debe ser mayor a 0."
msgstr "El valor debe ser mayor a 0."

#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:10
msgid "El valor debe ser mayor al del caudal mínimo"
msgstr "El valor debe ser mayor al del caudal mínimo"

#: src/utils/yupValidation.ts:6
msgid "El valor debe ser mayor o igual a {min}"
msgstr "El valor debe ser mayor o igual a {min}"

#: src/features/billing/utils/validationSchema.ts:9
msgid "El valor debe ser mayor o igual a 0."
msgstr "El valor debe ser mayor o igual a 0."

#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:9
msgid "El valor debe ser menor al del caudal máximo"
msgstr "El valor debe ser menor al del caudal máximo"

#: src/features/billing/utils/validationSchema.ts:8
#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:8
msgid "El valor debe ser un número"
msgstr "El valor debe ser un número"

#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:13
#: src/utils/yupValidation.ts:5
msgid "El valor debe ser uno de: {0}"
msgstr "El valor debe ser uno de: {0}"

#: src/features/metricsViews/components/forms/TrendSummaryForm.tsx:102
msgid "El widget permite elegir entre estas ventanas al verlo."
msgstr "El widget permite elegir entre estas ventanas al verlo."

#: src/fsd/pages/gate-movements/ui/list/gate-select.tsx:23
msgid "Elegir compuerta"
msgstr "Elegir compuerta"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:145
#: src/fsd/entities/dashboard-widget/ui/data/data-editor.tsx:57
#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-editor.tsx:28
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-editor.tsx:39
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-editor.tsx:28
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-editor.tsx:49
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-editor.tsx:29
#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:64
msgid "Elegir dispositivo"
msgstr "Elegir dispositivo"

#: src/fsd/app/locale/au-labels.ts:82
msgid "Elegir el año"
msgstr "Elegir el año"

#: src/fsd/app/locale/au-labels.ts:81
msgid "Elegir el mes"
msgstr "Elegir el mes"

#: src/fsd/pages/dga-reports/ui/report-problem-dialog.tsx:139
#: src/fsd/pages/dga-reports/ui/report-problem-dialog.tsx:148
msgid "Elegir fecha de apertura"
msgstr "Elegir fecha de apertura"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:157
#: src/fsd/entities/dashboard-widget/ui/data/data-editor.tsx:66
#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:89
msgid "Elegir métrica"
msgstr "Elegir métrica"

#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:201
#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:214
msgid "Elegir período"
msgstr "Elegir período"

#: src/fsd/pages/dga-reports/ui/reports-heatmap.tsx:86
#: src/fsd/pages/dga-reports/ui/reports-heatmap.tsx:97
msgid "Elegir semana"
msgstr "Elegir semana"

#: src/fsd/entities/dashboard-widget/ui/dga-tickets/dga-tickets-view.tsx:135
msgid "Elige dispositivos para ver sus tickets DGA"
msgstr "Elige dispositivos para ver sus tickets DGA"

#: src/fsd/pages/dashboards/ui/report-problem/report-problem-dialog.tsx:123
msgid "Elige el dispositivo del evento."
msgstr "Elige el dispositivo del evento."

#: src/features/reports2/components/createModal/steps/step3/3-FormatAndRecipients.tsx:199
msgid "Elige el formato de envío y los destinatarios que desees."
msgstr "Elige el formato de envío y los destinatarios que desees."

#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:276
msgid "Elige la compuerta en la configuración del widget para operarla."
msgstr "Elige la compuerta en la configuración del widget para operarla."

#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:307
msgid "Elige la compuerta en la configuración del widget para ver sus movimientos."
msgstr "Elige la compuerta en la configuración del widget para ver sus movimientos."

#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-view.tsx:156
msgid "Elige la compuerta en la configuración del widget para ver sus sensores."
msgstr "Elige la compuerta en la configuración del widget para ver sus sensores."

#: src/features/alertsConfigurationV3/components/wizard/steps/MetricStep.tsx:86
msgid "Elige la métrica a monitorear. Puedes tener más de una alerta por métrica."
msgstr "Elige la métrica a monitorear. Puedes tener más de una alerta por métrica."

#: src/features/metricsViews/components/widgets/common/DurationAutocomplete.tsx:216
msgid "Elige o escribe una duración (90m, 1h30m, 2w)"
msgstr "Elige o escribe una duración (90m, 1h30m, 2w)"

#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-view.tsx:163
msgid "Elige qué sensores mostrar en la configuración del widget."
msgstr "Elige qué sensores mostrar en la configuración del widget."

#: src/features/reports2/components/createModal/steps/step1/1-DevicesAndMetrics.tsx:49
msgid "Elige tu dispositivo y luego las métricas que deseas reportar."
msgstr "Elige tu dispositivo y luego las métricas que deseas reportar."

#: src/features/collections/validators.ts:25
#: src/features/homeAmaru/utils/myCollectionSchema.ts:35
#: src/features/homeAmaru/utils/myCollectionSchema.ts:52
msgid "Elige un color"
msgstr "Elige un color"

#: src/fsd/pages/dashboards/ui/report-problem/report-problem-dialog.tsx:119
msgid "Elige un dispositivo"
msgstr "Elige un dispositivo"

#: src/features/advancedDevicesAnalysis/components/AdvancedDevicesAnalysis.tsx:113
msgid "Elige un dispositivo desde los controles"
msgstr "Elige un dispositivo desde los controles"

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:247
msgid "Elige un dispositivo para ver sus envíos DGA"
msgstr "Elige un dispositivo para ver sus envíos DGA"

#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-view.tsx:74
msgid "Elige un dispositivo para ver sus reportes DGA"
msgstr "Elige un dispositivo para ver sus reportes DGA"

#: src/fsd/entities/dashboard-widget/ui/table/table-view.tsx:89
msgid "Elige un dispositivo y agrega columnas"
msgstr "Elige un dispositivo y agrega columnas"

#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:101
msgid "Elige un período"
msgstr "Elige un período"

#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:212
msgid "Elija la recurrencia con la cual quiere recibir sus reportes:"
msgstr "Elija la recurrencia con la cual quiere recibir sus reportes:"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:257
msgid "Elija la recurrencia en la cual quiere recibir sus reportes:"
msgstr "Elija la recurrencia en la cual quiere recibir sus reportes:"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:297
msgid "eliminado"
msgstr "eliminado"

#: src/features/users/utils/filterOptions.ts:119
msgid "Eliminado"
msgstr "Eliminado"

#: src/features/alertsConfigurationV2/components/DeleteAlertConfirmationDialog.tsx:76
msgid "Eliminando..."
msgstr "Eliminando..."

#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:337
#: src/features/alertsConfigurationV2/components/DeleteAlertConfirmationDialog.tsx:76
#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:151
#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:152
#: src/features/alertsConfigurationV3/components/AlertSummaryCard.tsx:217
#: src/features/announcements/components/AnnouncementMenu.tsx:64
#: src/features/announcements/components/AnnouncementsDeleteModal.tsx:84
#: src/features/api/components/CaptaApiUsersList.tsx:201
#: src/features/api/components/dialogs/SoftDeleteApiUserDialog.tsx:114
#: src/features/billing/components/payments/DeletePayment.tsx:65
#: src/features/billing/components/payments/Options.tsx:66
#: src/features/collections/components/modals/DeleteCollectionModal.tsx:108
#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:536
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:455
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/DeleteCurveModal.tsx:43
#: src/features/deviceObservations/components/modals/DeleteObservationModal.tsx:104
#: src/features/deviceProfile/components/modal/ObservationMenu.tsx:40
#: src/features/gateAdministration/components/DeleteRequestModal.tsx:62
#: src/features/homeAmaru/hooks/useDeleteMyCollection.tsx:49
#: src/features/notifications/components/NotificationsDeleteModal.tsx:84
#: src/features/organizationDelete/components/DeleteOrganization.tsx:185
#: src/features/organizationDelete/components/DeleteOrganization.tsx:258
#: src/features/reports/components/templateSection/DeleteReportTemplateDialog.tsx:76
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:282
#: src/features/reports2/components/DeleteReportTemplateModal.tsx:60
#: src/features/standardDesign/components/accessRelationManager/AccessRelationManagerModal.tsx:271
#: src/features/users/components/tableCells/UserActionsCell.tsx:115
#: src/fsd/pages/dashboards/ui/canvas/canvas.tsx:637
msgid "Eliminar"
msgstr "Eliminar"

#: src/features/audit/components/AuditLogDetailsRow.tsx:19
msgid "ELIMINAR"
msgstr "ELIMINAR"

#: src/features/collections/components/modals/DeleteCollectionModal.tsx:108
msgid "Eliminar ({countdown}s)"
msgstr "Eliminar ({countdown}s)"

#: src/fsd/pages/dashboards/ui/canvas/canvas.tsx:634
msgid "Eliminar (Supr)"
msgstr "Eliminar (Supr)"

#: src/features/access/components/globalModals/RemoveDeviceUserRelationsModal.tsx:230
msgid "Eliminar {count} registros"
msgstr "Eliminar {count} registros"

#: src/features/audit/utils/getActionTypeOptions.ts:316
msgid "Eliminar accesos de dispositivo para un usuario"
msgstr "Eliminar accesos de dispositivo para un usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:322
msgid "Eliminar accesos de usuario para un dispositivo"
msgstr "Eliminar accesos de usuario para un dispositivo"

#: src/features/alertsConfigurationV3/components/AlertSummaryCard.tsx:200
msgid "Eliminar alerta"
msgstr "Eliminar alerta"

#: src/features/audit/utils/getActionTypeOptions.ts:223
msgid "Eliminar Alias de Dispositivo"
msgstr "Eliminar Alias de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:52
msgid "Eliminar API para Organización"
msgstr "Eliminar API para Organización"

#: src/features/audit/utils/getActionTypeOptions.ts:61
msgid "Eliminar Canal de Irrigación"
msgstr "Eliminar Canal de Irrigación"

#: src/features/audit/utils/getActionTypeOptions.ts:67
msgid "Eliminar Clase de Canal de SIRA"
msgstr "Eliminar Clase de Canal de SIRA"

#: src/features/collections/components/CollectionsTable.tsx:207
#: src/features/collections/components/modals/DeleteCollectionModal.tsx:93
#: src/features/homeAmaru/components/shared/CollectionActions.tsx:68
#: src/features/homeAmaru/hooks/useDeleteMyCollection.tsx:42
msgid "Eliminar colección"
msgstr "Eliminar colección"

#: src/features/audit/utils/getActionTypeOptions.ts:58
msgid "Eliminar Configuración de Calendario para Dispositivo"
msgstr "Eliminar Configuración de Calendario para Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:259
msgid "Eliminar Configuración de DGA"
msgstr "Eliminar Configuración de DGA"

#: src/features/audit/utils/getActionTypeOptions.ts:190
msgid "Eliminar Configuración de Hardware de Dispositivo"
msgstr "Eliminar Configuración de Hardware de Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:271
msgid "Eliminar Configuración de Recurrencia de Envío de DGA"
msgstr "Eliminar Configuración de Recurrencia de Envío de DGA"

#: src/features/reports/components/templateSection/DeleteReportTemplateDialog.tsx:49
msgid "Eliminar Configuración de Reporte"
msgstr "Eliminar Configuración de Reporte"

#: src/features/dga/components/modals/DeleteDGAConfigurationModal.tsx:101
#: src/features/dga/components/modals/DeleteDGAConfigurationModal.tsx:124
#: src/features/dga/components/modals/UpdateDGAConfigurationModal.tsx:138
msgid "Eliminar configuración DGA"
msgstr "Eliminar configuración DGA"

#: src/features/api/components/dialogs/SoftDeleteApiUserDialog.tsx:70
msgid "Eliminar credenciales API"
msgstr "Eliminar credenciales API"

#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:70
msgid "Eliminar Credenciales API"
msgstr "Eliminar Credenciales API"

#: src/features/organizationDelete/components/DeleteOrganization.tsx:285
#: src/features/usersGraveyard/components/HardDeleteUserModal.tsx:168
#: src/features/usersGraveyard/components/UsersGraveyard.tsx:199
msgid "Eliminar definitivamente"
msgstr "Eliminar definitivamente"

#: src/features/organizationDelete/components/DeleteOrganization.tsx:284
#: src/features/usersGraveyard/components/HardDeleteUserModal.tsx:167
msgid "Eliminar definitivamente ({countdown}s)"
msgstr "Eliminar definitivamente ({countdown}s)"

#: src/features/audit/utils/getActionTypeOptions.ts:79
msgid "Eliminar Definitivamente Usuario"
msgstr "Eliminar Definitivamente Usuario"

#: src/features/usersGraveyard/components/HardDeleteUserModal.tsx:91
msgid "Eliminar definitivamente{0}"
msgstr "Eliminar definitivamente{0}"

#: src/features/audit/utils/getActionTypeOptions.ts:55
msgid "Eliminar Dispositivo"
msgstr "Eliminar Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:70
msgid "Eliminar Distribución de SIRA Maipo"
msgstr "Eliminar Distribución de SIRA Maipo"

#: src/features/audit/utils/getActionTypeOptions.ts:331
msgid "Eliminar estado de dispositivo"
msgstr "Eliminar estado de dispositivo"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:89
msgid "Eliminar la selección"
msgstr "Eliminar la selección"

#: src/features/deviceObservations/components/modals/DeleteObservationModal.tsx:77
msgid "Eliminar observación"
msgstr "Eliminar observación"

#: src/features/audit/utils/getActionTypeOptions.ts:64
msgid "Eliminar Organización"
msgstr "Eliminar Organización"

#: src/features/organizationDelete/components/DeleteOrganization.tsx:117
msgid "Eliminar organización <0>{0}</0>"
msgstr "Eliminar organización <0>{0}</0>"

#: src/features/billing/components/payments/DeletePayment.tsx:55
msgid "Eliminar Pago"
msgstr "Eliminar Pago"

#: src/features/audit/utils/getActionTypeOptions.ts:247
msgid "Eliminar Programación de Reporte"
msgstr "Eliminar Programación de Reporte"

#: src/features/access/components/devicesTab/DevicesTab.tsx:157
#: src/features/access/components/usersTab/UsersTab.tsx:144
#: src/features/deviceAccessModal/components/deviceAccessTab/index.tsx:94
#: src/features/userConfigurationModal/components/deviceAccessTab/index.tsx:96
msgid "Eliminar registros"
msgstr "Eliminar registros"

#: src/features/access/components/globalModals/RemoveDeviceUserRelationsModal.tsx:122
#: src/features/access/components/globalModals/RemoveDeviceUserRelationsModal.tsx:242
msgid "Eliminar relaciones dispositivo-usuario"
msgstr "Eliminar relaciones dispositivo-usuario"

#: src/features/reports2/components/DeleteReportTemplateModal.tsx:73
msgid "Eliminar reporte"
msgstr "Eliminar reporte"

#: src/features/audit/utils/getActionTypeOptions.ts:238
msgid "Eliminar Reporte"
msgstr "Eliminar Reporte"

#: src/features/audit/utils/getActionTypeOptions.ts:307
msgid "Eliminar servicio de facturación"
msgstr "Eliminar servicio de facturación"

#: src/features/billing/components/projectService/Delete.tsx:102
msgid "Eliminar servicio del proyecto"
msgstr "Eliminar servicio del proyecto"

#: src/features/audit/utils/getActionTypeOptions.ts:298
msgid "Eliminar servicio para proyecto de facturación"
msgstr "Eliminar servicio para proyecto de facturación"

#: src/features/gateAdministration/components/RequestedPositionIcon.tsx:63
msgid "Eliminar solicitud de movimiento"
msgstr "Eliminar solicitud de movimiento"

#: src/features/audit/utils/getActionTypeOptions.ts:196
msgid "Eliminar Solicitud de Movimiento en Cola de Compuerta"
msgstr "Eliminar Solicitud de Movimiento en Cola de Compuerta"

#: src/fsd/pages/dashboards/ui/panel/multi-scope.tsx:74
msgid "Eliminar todos"
msgstr "Eliminar todos"

#: src/features/audit/utils/getActionTypeOptions.ts:289
msgid "Eliminar un pago"
msgstr "Eliminar un pago"

#: src/features/users/components/modals/DeleteUserModal.tsx:100
msgid "Eliminar usuario"
msgstr "Eliminar usuario"

#: src/features/audit/utils/getActionTypeOptions.ts:73
msgid "Eliminar Usuario de SIRA a Notificar"
msgstr "Eliminar Usuario de SIRA a Notificar"

#: src/features/audit/utils/getDisplayNameActionType.ts:205
msgid "eliminó accesos de dispositivos al usuario"
msgstr "eliminó accesos de dispositivos al usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:128
msgid "eliminó accesos de usuario para el dispositivo"
msgstr "eliminó accesos de usuario para el dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:161
msgid "eliminó definitivamente el usuario"
msgstr "eliminó definitivamente el usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:116
msgid "eliminó el alias del dispositivo"
msgstr "eliminó el alias del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:371
msgid "eliminó el cronograma del reporte"
msgstr "eliminó el cronograma del reporte"

#: src/features/audit/utils/getDisplayNameActionType.ts:44
msgid "eliminó el dispositivo"
msgstr "eliminó el dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:359
msgid "eliminó el reporte"
msgstr "eliminó el reporte"

#: src/features/audit/utils/getDisplayNameActionType.ts:256
msgid "eliminó el usuario de SIRA para notificar"
msgstr "eliminó el usuario de SIRA para notificar"

#: src/features/audit/utils/getDisplayNameActionType.ts:285
msgid "eliminó la API para la organización"
msgstr "eliminó la API para la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:244
msgid "eliminó la clase de canal de SIRA"
msgstr "eliminó la clase de canal de SIRA"

#: src/features/audit/utils/getDisplayNameActionType.ts:434
msgid "eliminó la configuración de DGA"
msgstr "eliminó la configuración de DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:442
msgid "eliminó la configuración de la recurrencia de envío de DGA"
msgstr "eliminó la configuración de la recurrencia de envío de DGA"

#: src/features/audit/utils/getDisplayNameActionType.ts:76
msgid "eliminó la configuración del calendario del dispositivo"
msgstr "eliminó la configuración del calendario del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:92
msgid "eliminó la configuración del hardware del dispositivo"
msgstr "eliminó la configuración del hardware del dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:321
msgid "eliminó la distribución de SIRA Maipo"
msgstr "eliminó la distribución de SIRA Maipo"

#: src/features/audit/utils/getDisplayNameActionType.ts:218
msgid "eliminó la irrigación"
msgstr "eliminó la irrigación"

#: src/features/audit/utils/getDisplayNameActionType.ts:265
msgid "eliminó la organización"
msgstr "eliminó la organización"

#: src/features/audit/utils/getDisplayNameActionType.ts:346
msgid "eliminó la solicitud de movimiento en cola de la compuerta"
msgstr "eliminó la solicitud de movimiento en cola de la compuerta"

#: src/features/audit/utils/getDisplayNameActionType.ts:140
msgid "eliminó un estado para el dispositivo"
msgstr "eliminó un estado para el dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:416
msgid "eliminó un nuevo servicio de facturación."
msgstr "eliminó un nuevo servicio de facturación."

#: src/features/audit/utils/getDisplayNameActionType.ts:392
msgid "eliminó un pago del proyecto."
msgstr "eliminó un pago del proyecto."

#: src/features/audit/utils/getDisplayNameActionType.ts:404
msgid "eliminó un servicio del proyecto."
msgstr "eliminó un servicio del proyecto."

#: src/fsd/entities/dashboard-widget/ui/contact-support/contact-support-render.tsx:28
msgid "Email"
msgstr "Email"

#: src/features/gateAdministration/components/RequestedPositionIcon.tsx:59
#: src/features/gateCommon/utils/gateMovementState.tsx:22
#: src/features/gateOperationModal/components/panelNotification/utils.tsx:244
#: src/fsd/entities/dashboard-widget/model/gate-operate-sample.ts:90
#: src/fsd/entities/gate/model/movement-state.ts:35
#: src/fsd/features/gate-movements/ui/panel/events/event-text.tsx:162
msgid "En cola"
msgstr "En cola"

#: src/features/gateOperationModal/components/panelNotification/utils.tsx:250
#: src/fsd/features/gate-movements/ui/panel/events/event-text.tsx:167
msgid "En cola · vence el <0>{expiresOn}</0>"
msgstr "En cola · vence el <0>{expiresOn}</0>"

#: src/features/gateCommon/utils/gateOperatingState.tsx:8
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:322
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:88
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:89
#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:113
msgid "En curso"
msgstr "En curso"

#: src/fsd/entities/dashboard-widget/ui/contact-support/contact-support-render.tsx:39
msgid "En edición el botón no abre el correo."
msgstr "En edición el botón no abre el correo."

#: src/fsd/entities/dashboard-widget/ui/contact-support/contact-support-render.tsx:63
msgid "En edición el botón no abre el formulario."
msgstr "En edición el botón no abre el formulario."

#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-render.tsx:174
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-render.tsx:184
msgid "En edición la compuerta no se opera."
msgstr "En edición la compuerta no se opera."

#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-render.tsx:49
msgid "En edición los movimientos no se abren."
msgstr "En edición los movimientos no se abren."

#: src/features/deviceConfiguration/components/TriggerConfigUpdateModal.tsx:27
#: src/features/gateAdministration/components/RequestedPositionIcon.tsx:29
msgid "En ejecución"
msgstr "En ejecución"

#: src/features/billing/components/modals/ServiceFileManager.tsx:183
msgid "En el nombre de esta columna, reemplazar [NOMBRE_SERVICIO] por el nombre de los servicios existentes."
msgstr "En el nombre de esta columna, reemplazar [NOMBRE_SERVICIO] por el nombre de los servicios existentes."

#: src/pages/alertsV2/index.tsx:28
msgid "En esta sección se pueden definir las condiciones que activarán las alertas de la métrica, utilizando rangos o umbrales personalizados según el comportamiento esperado. Además, ofrece flexibilidad para enviar las notificaciones a distintos destinatarios, asegurando una supervisión oportuna y acorde a las necesidades operativas."
msgstr "En esta sección se pueden definir las condiciones que activarán las alertas de la métrica, utilizando rangos o umbrales personalizados según el comportamiento esperado. Además, ofrece flexibilidad para enviar las notificaciones a distintos destinatarios, asegurando una supervisión oportuna y acorde a las necesidades operativas."

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:100
#: src/features/reports2/utils/schedule.ts:13
msgid "En la primera semana del mes"
msgstr "En la primera semana del mes"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:102
#: src/features/reports2/utils/schedule.ts:14
msgid "En la última semana del mes"
msgstr "En la última semana del mes"

#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:101
#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:102
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:87
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:88
#: src/utils/attributes/deviceOperationalState.ts:71
msgid "En mantención"
msgstr "En mantención"

#: src/features/gateCommon/utils/gateMovementState.tsx:24
#: src/features/gateOperationModal/components/panelNotification/NotificationCard.tsx:209
#: src/features/gateOperationModal/components/panelNotification/utils.tsx:208
#: src/fsd/entities/dashboard-widget/model/gate-operate-sample.ts:89
#: src/fsd/entities/gate/model/movement-state.ts:37
#: src/fsd/features/gate-movements/ui/operation/feed/feed-card.tsx:136
#: src/fsd/features/gate-movements/ui/panel/events/event-text.tsx:140
#: src/fsd/features/gate-movements/ui/panel/events/feed-announcer.tsx:80
#: src/fsd/pages/gate-movements/ui/panel/events/event-card.tsx:146
msgid "En movimiento"
msgstr "En movimiento"

#: src/utils/attributes/deviceOperationalState.ts:32
msgid "En producción"
msgstr "En producción"

#: src/features/sma/utils/echartOptions.ts:28
msgid "En reintento"
msgstr "En reintento"

#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:70
msgid "En terreno"
msgstr "En terreno"

#: src/features/moveGateModal/components/LastPosition.tsx:31
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:130
msgid "en vivo"
msgstr "en vivo"

#: src/features/deviceCommands/components/standard/StandardCommandsInformation.tsx:116
msgid "ENCENDIDO"
msgstr "ENCENDIDO"

#: src/features/deviceCommands/components/standard/DebugModeInformation.tsx:55
msgid "Encendido (POWER_SECONDS_ON): 840 segundos."
msgstr "Encendido (POWER_SECONDS_ON): 840 segundos."

#: src/features/moveGateModal/components/MoveGateModal.tsx:134
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:454
msgid "Encolar"
msgstr "Encolar"

#: src/features/moveGateModal/components/MoveGateModal.tsx:178
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:312
msgid "Encolar operación"
msgstr "Encolar operación"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:549
msgid "End"
msgstr "End"

#: src/utils/attributes/metricField.ts:209
msgid "energía"
msgstr "energía"

#. Análisis de estaciones - Título de acordión
#: src/features/devicesAnalysis/components/panel/sidebar/index.tsx:116
#: src/features/reports/utils/metricHelpers.ts:19
#: src/utils/i18n/getMetricDisplayName.ts:50
msgid "Energía"
msgstr "Energía"

#: src/features/audit/utils/parseProperty.ts:59
msgid "energización"
msgstr "energización"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:347
#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:12
#: src/features/deviceConfiguration/data/sectionFields.ts:50
#: src/features/deviceConfiguration/data/sectionFields.ts:193
#: src/features/deviceConfiguration/data/sectionInputs.ts:47
#: src/features/deviceConfiguration/data/sectionInputs.ts:215
#: src/features/deviceProfile/components/page/modularComponents/index.tsx:38
msgid "Energización"
msgstr "Energización"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:21
msgid "Enero"
msgstr "Enero"

#: src/fsd/pages/gate-movements/ui/panel/copy-link-button.tsx:39
msgid "Enlace copiado"
msgstr "Enlace copiado"

#: src/features/controlCenter2/components/versionSwitch/WelcomeDialog.tsx:89
#: src/features/reports2/components/versionSwitch/WelcomeDialog.tsx:89
msgid "Entendido"
msgstr "Entendido"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:45
msgid "Enter"
msgstr "Enter"

#: src/features/notifications/components/Notifications.tsx:127
#: src/features/notifications/components/NotificationsSaveModal.tsx:171
msgid "Entidad"
msgstr "Entidad"

#: src/features/audit/utils/parseProperty.ts:111
msgid "entrada de excel"
msgstr "entrada de excel"

#: src/features/metricsViews/components/AssociateCollectionModal.tsx:226
msgid "Entran {0} dispositivos"
msgstr "Entran {0} dispositivos"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:182
msgid "Entrar al tablero"
msgstr "Entrar al tablero"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:171
msgid "entre tableros y pestañas"
msgstr "entre tableros y pestañas"

#: src/features/reports/components/ReportHistory.tsx:295
#: src/features/reports2/components/reportHistoryModal/ReportHistory.tsx:302
msgid "Enviado a los emails"
msgstr "Enviado a los emails"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:46
msgid "Enviado de ayer"
msgstr "Enviado de ayer"

#: src/features/notifications/components/Notifications.tsx:124
msgid "Enviado el"
msgstr "Enviado el"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:66
msgid "Enviado último año"
msgstr "Enviado último año"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:58
msgid "Enviado últimos 3 meses"
msgstr "Enviado últimos 3 meses"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:54
msgid "Enviado últimos 30 días"
msgstr "Enviado últimos 30 días"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:62
msgid "Enviado últimos 6 meses"
msgstr "Enviado últimos 6 meses"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:50
msgid "Enviado últimos 7 días"
msgstr "Enviado últimos 7 días"

#: src/features/gateAdministration/components/MoveGate.tsx:136
msgid "Enviando comando de movimiento a la compuerta..."
msgstr "Enviando comando de movimiento a la compuerta..."

#: src/components/gates/StopMovementConfirmation.tsx:100
msgid "Enviando comando para detener la compuerta..."
msgstr "Enviando comando para detener la compuerta..."

#: src/features/gateOperationModal/components/panelNotification/utils.tsx:201
#: src/fsd/features/gate-movements/ui/panel/events/event-text.tsx:136
msgid "Enviando la solicitud al equipo"
msgstr "Enviando la solicitud al equipo"

#: src/fsd/pages/dashboards/ui/report-problem/report-problem-dialog.tsx:153
msgid "Enviando…"
msgstr "Enviando…"

#: src/features/controlCenter2/components/versionSwitch/FormPopup.tsx:71
#: src/features/dga/components/modals/reports/SendReportsByEmailModal.tsx:100
#: src/features/recoveryPassword/components/RecoveryPassword.tsx:85
#: src/features/reportProblem/components/ReportProblemDialog.tsx:168
#: src/features/reportProblem/components/ReportProblemModal.tsx:154
#: src/features/reports2/components/versionSwitch/FormPopup.tsx:112
#: src/features/sma/components/SendReportsByEmailModal.tsx:114
#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:421
#: src/fsd/pages/dashboards/ui/report-problem/report-problem-dialog.tsx:153
msgid "Enviar"
msgstr "Enviar"

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:157
msgid "Enviar comando"
msgstr "Enviar comando"

#: src/features/audit/utils/getActionTypeOptions.ts:193
msgid "Enviar Comando de Configuración a Dispositivo"
msgstr "Enviar Comando de Configuración a Dispositivo"

#: src/features/audit/utils/getActionTypeOptions.ts:181
msgid "Enviar Comando de Detención de Movimiento a Compuerta"
msgstr "Enviar Comando de Detención de Movimiento a Compuerta"

#: src/features/audit/utils/getActionTypeOptions.ts:178
msgid "Enviar Comando de Movimiento a Compuerta"
msgstr "Enviar Comando de Movimiento a Compuerta"

#: src/features/userSaveModal/components/SendPasswordResetEmailButton.tsx:35
msgid "Enviar correo para restablecer contraseña"
msgstr "Enviar correo para restablecer contraseña"

#: src/features/api/components/CaptaApiUsersList.tsx:229
msgid "Enviar credenciales por correo"
msgstr "Enviar credenciales por correo"

#: src/features/api/components/forms/FormSendCredentials.tsx:70
msgid "Enviar credenciales por correo electrónico"
msgstr "Enviar credenciales por correo electrónico"

#: src/features/userSaveModal/components/UserSaveModal.tsx:606
msgid "Enviar datos de acceso por correo electrónico"
msgstr "Enviar datos de acceso por correo electrónico"

#: src/features/controlCenter2/components/devicesList/VersionSwitchFooter.tsx:44
#: src/features/controlCenter2/components/versionSwitch/SuggestionFab.tsx:45
#: src/features/reports2/components/versionSwitch/SuggestionFab.tsx:53
#: src/features/reports2/components/versionSwitch/VersionSwitchFab.tsx:45
#: src/features/reports2/components/versionSwitch/VersionSwitchFooter.tsx:58
msgid "Enviar sugerencia"
msgstr "Enviar sugerencia"

#: src/features/controlCenter2/components/versionSwitch/WelcomeDialog.tsx:132
#: src/features/reports2/components/versionSwitch/WelcomeDialog.tsx:132
msgid "Enviar sugerencias"
msgstr "Enviar sugerencias"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:208
#: src/pages/device-commands/advanced.tsx:9
#: src/pages/device-commands/calendar.tsx:9
#: src/pages/device-commands/index.tsx:9
msgid "Envío de Comandos"
msgstr "Envío de Comandos"

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:72
msgid "Envío deshabilitado"
msgstr "Envío deshabilitado"

#: src/features/alertsNotificationsHistory/utils/alertTypes.ts:15
msgid "Envío DGA"
msgstr "Envío DGA"

#: src/features/reports2/components/createModal/steps/step5/ReportSummary.tsx:104
msgid "Envío Excel"
msgstr "Envío Excel"

#: src/features/metricsViews/components/widgets/dgaReports/utils.ts:51
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:98
msgid "Envío fallido"
msgstr "Envío fallido"

#: src/features/devices2/components/list/itemPanel/DGAItemChart.tsx:174
msgid "Envio fallido a la DGA"
msgstr "Envio fallido a la DGA"

#: src/features/dga/utils/chartOptions.ts:84
#: src/features/metricsViews/components/widgets/dgaReports/utils.ts:50
#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-chart-option.ts:62
#: src/fsd/pages/dga-reports/ui/report-state-labels.ts:24
msgid "Envío fallido a la DGA"
msgstr "Envío fallido a la DGA"

#: src/features/metricsViews/components/widgets/dgaReports/index.legacy.tsx:53
#: src/features/metricsViews/components/widgets/dgaReports/index.tsx:60
msgid "envío no operativo"
msgstr "envío no operativo"

#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:93
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:65
#: src/fsd/pages/dga-reports/ui/device-row.tsx:63
msgid "Envío no operativo"
msgstr "Envío no operativo"

#: src/features/metricsViews/components/widgets/dgaReports/index.legacy.tsx:47
#: src/features/metricsViews/components/widgets/dgaReports/index.tsx:53
msgid "envío operativo"
msgstr "envío operativo"

#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:91
#: src/fsd/entities/dashboard-widget/model/dga-reports-sample.ts:72
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:55
#: src/fsd/pages/dga-reports/ui/device-row.tsx:63
msgid "Envío operativo"
msgstr "Envío operativo"

#: src/features/reports2/components/createModal/steps/step5/ReportSummary.tsx:95
msgid "Envío PDF"
msgstr "Envío PDF"

#: src/features/audit/utils/getDisplayNameActionType.ts:96
msgid "envió un comando al dispositivo"
msgstr "envió un comando al dispositivo"

#: src/features/audit/utils/getDisplayNameActionType.ts:342
msgid "envió un comando de detención de movimiento a la compuerta"
msgstr "envió un comando de detención de movimiento a la compuerta"

#: src/features/audit/utils/getDisplayNameActionType.ts:338
msgid "envió un comando de movimiento a la compuerta"
msgstr "envió un comando de movimiento a la compuerta"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:61
#: src/features/dga/components/modals/UpdateDGAConfigurationModal.tsx:82
msgid "Envíos"
msgstr "Envíos"

#: src/fsd/pages/dga-reports/ui/device-row.tsx:170
msgid "Envíos de los últimos {total} días: {validated} de {total} días validados"
msgstr "Envíos de los últimos {total} días: {validated} de {total} días validados"

#: src/features/metricsViews/components/widgets/dgaReports/index.legacy.tsx:134
#: src/features/metricsViews/components/widgets/dgaReports/index.legacy.tsx:192
#: src/features/metricsViews/components/widgets/dgaReports/index.tsx:114
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:287
msgid "Envíos MEE - DGA"
msgstr "Envíos MEE - DGA"

#: src/fsd/pages/dga-reports/ui/device-list-header.tsx:28
msgid "Envíos últimos 14 días"
msgstr "Envíos últimos 14 días"

#: src/features/metricsViews/utils/quickAccessCatalog.tsx:72
#: src/fsd/entities/dashboard-widget/ui/quick-access/destinations.ts:56
msgid "Envíos y estado normativo"
msgstr "Envíos y estado normativo"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:80
msgid "Eq. agua nieve"
msgstr "Eq. agua nieve"

#: src/features/debtsAlert/components/DebtsAlertModal.tsx:108
#: src/features/debtsAlert/components/DebtsAlertPopover.tsx:98
msgid "Equipo Capta Hydro"
msgstr "Equipo Capta Hydro"

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:141
#: src/features/controlCenter/components/window/DeviceListItem.tsx:134
#: src/features/controlCenter2/components/devicesList/ListItem.tsx:184
msgid "Equipo con dotación"
msgstr "Equipo con dotación"

#: src/features/controlCenter/components/window/DeviceListItem.tsx:149
#: src/features/controlCenter2/components/devicesList/ListItem.tsx:200
#: src/features/devices2/components/list/itemPanel/deviceItemInfo/index.tsx:194
msgid "Equipo conectado"
msgstr "Equipo conectado"

#: src/features/debtsAlert/components/DebtsAlertModal.tsx:80
#: src/features/debtsAlert/components/DebtsAlertPopover.tsx:70
msgid "Equipo Customer Success"
msgstr "Equipo Customer Success"

#: src/features/controlCenter/components/window/DeviceListItem.tsx:149
#: src/features/controlCenter2/components/devicesList/ListItem.tsx:202
#: src/features/devices2/components/list/itemPanel/deviceItemInfo/index.tsx:194
msgid "Equipo desconectado"
msgstr "Equipo desconectado"

#: src/features/moveGateModal/components/MoveGateModal.tsx:123
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:468
msgid "Equipo desconectado: la solicitud quedará en cola y se enviará si el equipo se conecta antes de que venza el plazo."
msgstr "Equipo desconectado: la solicitud quedará en cola y se enviará si el equipo se conecta antes de que venza el plazo."

#: src/features/moveGateModal/components/LiveNotice.tsx:82
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:265
msgid "Equipo desconectado: la solicitud quedará en cola y se enviará si el equipo se conecta antes de que venza el plazo. Se usan la última posición y los límites registrados."
msgstr "Equipo desconectado: la solicitud quedará en cola y se enviará si el equipo se conecta antes de que venza el plazo. Se usan la última posición y los límites registrados."

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:146
msgid "Equipo sin dotación"
msgstr "Equipo sin dotación"

#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:127
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:113
#: src/features/homeAmaru/components/shared/CollectionRow.tsx:77
msgid "Equipos con alertas activas"
msgstr "Equipos con alertas activas"

#: src/utils/i18n/getMetricDisplayName.ts:38
msgid "Equivalente agua nieve"
msgstr "Equivalente agua nieve"

#: src/utils/attributes/metricField.ts:395
msgid "equivalente de agua de nieve"
msgstr "equivalente de agua de nieve"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:365
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:307
#: src/features/reports/utils/metricHelpers.ts:33
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:35
msgid "Equivalente de agua de nieve"
msgstr "Equivalente de agua de nieve"

#: src/utils/attributes/metricField.ts:413
msgid "equivalente de agua de nieve bruto"
msgstr "equivalente de agua de nieve bruto"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:367
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:273
msgid "Equivalente de agua de nieve bruto"
msgstr "Equivalente de agua de nieve bruto"

#: src/utils/attributes/metricField.ts:401
msgid "equivalente de agua de nieve no calibrado"
msgstr "equivalente de agua de nieve no calibrado"

#: src/utils/attributes/metricField.ts:407
msgid "equivalente de agua de nieve no calibrado bruto"
msgstr "equivalente de agua de nieve no calibrado bruto"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:372
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:286
#: src/features/reports/utils/metricHelpers.ts:39
msgid "Equivalente de agua de nieve sin calibrar"
msgstr "Equivalente de agua de nieve sin calibrar"

#: src/features/integrations/utils/writeExecutionLogSeverityAttributes.ts:40
#: src/fsd/entities/dashboard-widget/model/chart-sample.ts:128
#: src/fsd/entities/dashboard-widget/model/data-sample.ts:118
#: src/fsd/entities/dashboard-widget/model/dga-chart-sample.ts:80
#: src/fsd/entities/dashboard-widget/model/dga-reports-sample.ts:79
#: src/fsd/entities/dashboard-widget/model/dga-tickets-sample.ts:52
#: src/fsd/entities/dashboard-widget/model/gate-movements-sample.ts:86
#: src/fsd/entities/dashboard-widget/model/gate-operate-sample.ts:94
#: src/fsd/entities/dashboard-widget/model/gate-sensors-sample.ts:68
#: src/fsd/entities/dashboard-widget/model/table-sample.ts:79
msgid "Error"
msgstr "Error"

#: src/features/gates/components/list/GateListItemLastMovement.tsx:75
msgid "ERROR"
msgstr "ERROR"

#: src/features/dgaTicket/components/DgaTicketModal.tsx:526
msgid "Error al abrir ticket"
msgstr "Error al abrir ticket"

#: src/features/collections/hooks/useUpdateCollectionForm.ts:56
msgid "Error al actualizar colección"
msgstr "Error al actualizar colección"

#: src/features/deviceConfigurationModal/components/publicTab/useUpdateForm.ts:50
msgid "Error al actualizar dispositivo: {0}"
msgstr "Error al actualizar dispositivo: {0}"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:200
#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:84
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:73
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:113
msgid "Error al actualizar el dato"
msgstr "Error al actualizar el dato"

#: src/features/changeOperationalState/hooks/useUpdateOperationalStateMutation.ts:45
#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:100
msgid "Error al actualizar el dispositivo: {0}"
msgstr "Error al actualizar el dispositivo: {0}"

#: src/features/changeSupportStatus/components/ChangeSupportStatus.tsx:57
#: src/features/changeSupportStatus/components/ChangeSupportStatus.tsx:67
#: src/features/changeSupportStatus/components/ChangeSupportStatus.tsx:99
#: src/features/changeTagsDevice/components/ChangeTagsDevice.tsx:39
#: src/features/changeTagsDevice/components/ChangeTagsDevice.tsx:48
msgid "Error al actualizar el estado de soporte"
msgstr "Error al actualizar el estado de soporte"

#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:137
msgid "Error al actualizar el perfil"
msgstr "Error al actualizar el perfil"

#: src/features/collections/components/modals/ManageCollectionAccessModal.tsx:120
msgid "Error al actualizar el rol"
msgstr "Error al actualizar el rol"

#: src/features/billing/components/service/Update.tsx:43
msgid "Error al actualizar el servicio."
msgstr "Error al actualizar el servicio."

#: src/features/dgaTicket/components/DgaTicketModal.tsx:490
msgid "Error al actualizar el ticket"
msgstr "Error al actualizar el ticket"

#: src/features/gates/components/AlarmSystem.tsx:46
#: src/features/gates/components/AlarmSystem.tsx:68
msgid "Error al actualizar la alarma"
msgstr "Error al actualizar la alarma"

#: src/features/gates/components/AlarmSystem.tsx:67
msgid "Error al actualizar la alarma: {errorMessage}"
msgstr "Error al actualizar la alarma: {errorMessage}"

#: src/features/homeAmaru/hooks/useUpdateMyCollectionForm.tsx:50
msgid "Error al actualizar la configuración"
msgstr "Error al actualizar la configuración"

#: src/features/deviceAlertsModal/components/alertConfigurationTab/FormComponent.tsx:97
#: src/features/deviceAlertsModal/components/basicConfigurationTab/useUpdateForm.ts:62
#: src/features/deviceConfigurationModal/components/gateTab/useUpdateForm.ts:43
msgid "Error al actualizar la configuración de alertas: {0}"
msgstr "Error al actualizar la configuración de alertas: {0}"

#: src/features/api/components/dialogs/SetApiUserPasswordDialog.tsx:48
msgid "Error al actualizar la contraseña"
msgstr "Error al actualizar la contraseña"

#: src/features/homeAmaru/components/mainMetricModal/DeviceMainMetricModal.tsx:46
msgid "Error al actualizar la métrica principal: {0}"
msgstr "Error al actualizar la métrica principal: {0}"

#: src/features/deviceAlertsModal/components/notificationConfigurationTab/useUpdateForm.ts:26
msgid "Error al actualizar las notificaciones: {0}"
msgstr "Error al actualizar las notificaciones: {0}"

#: src/features/deviceConfigurationModal/components/aliasModal/DeviceAliasModal.tsx:81
msgid "Error al actualizar los alias del dispositivo: {0}"
msgstr "Error al actualizar los alias del dispositivo: {0}"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LevelCalibrationForm.tsx:66
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleCalibrationForm.tsx:79
msgid "Error al actualizar los datos: {0}"
msgstr "Error al actualizar los datos: {0}"

#: src/features/collections/components/modals/AddCollectionAccessModal.tsx:45
msgid "Error al agregar dispositivos a la colección"
msgstr "Error al agregar dispositivos a la colección"

#: src/features/billing/components/projectService/Create.tsx:74
msgid "Error al agregar el servicio al proyecto."
msgstr "Error al agregar el servicio al proyecto."

#: src/features/collections/components/modals/AddCollectionAccessModal.tsx:116
msgid "Error al agregar usuarios a la colección"
msgstr "Error al agregar usuarios a la colección"

#: src/features/changePasswordByToken/components/ChangePasswordByToken.tsx:64
msgid "Error al cambiar la contraseña. Por favor, intenta nuevamente o comunícate con soporte@captahydro.com"
msgstr "Error al cambiar la contraseña. Por favor, intenta nuevamente o comunícate con soporte@captahydro.com"

#: src/features/organizationDelete/components/DeleteOrganization.tsx:137
msgid "Error al cargar la información de la organización. Intente nuevamente."
msgstr "Error al cargar la información de la organización. Intente nuevamente."

#: src/features/dgaTicket/components/DgaTicketModal.tsx:504
msgid "Error al cerrar ticket"
msgstr "Error al cerrar ticket"

#: src/features/integrations/utils/writeExecutionLogCodeTranslations.ts:19
msgid "Error al conectar con el servidor SFTP"
msgstr "Error al conectar con el servidor SFTP"

#: src/features/deviceProfile/components/modal/OdooTicketPreview.tsx:44
msgid "Error al conectarse a tickets de Odoo"
msgstr "Error al conectarse a tickets de Odoo"

#: src/features/collections/hooks/useCreateCollectionForm.ts:31
#: src/features/createMyCollectionModal/hooks/useCreateMyCollectionForm.tsx:59
msgid "Error al crear colección"
msgstr "Error al crear colección"

#: src/features/deviceConfigurationModal/components/gateTab/CreateLinkedDeviceButton.tsx:29
msgid "Error al crear dispositivo: {0}"
msgstr "Error al crear dispositivo: {0}"

#: src/features/billing/components/CreatePaymentView.tsx:80
#: src/features/billing/components/service/Administration.tsx:48
#: src/features/billing/components/service/Delete.tsx:36
msgid "Error al crear el pago."
msgstr "Error al crear el pago."

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:143
#: src/features/api/components/dialogs/GenerateApiUserDialog.tsx:91
msgid "Error al crear el usuario: {0}"
msgstr "Error al crear el usuario: {0}"

#: src/features/alertsConfigurationV2/hooks/useCreateAlertConfiguration.ts:26
msgid "Error al crear la configuración de alerta: {0}"
msgstr "Error al crear la configuración de alerta: {0}"

#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:94
msgid "Error al crear la plantilla"
msgstr "Error al crear la plantilla"

#: src/features/reportDownload/components/ReportDownload.tsx:85
msgid "Error al descargar el reporte"
msgstr "Error al descargar el reporte"

#: src/features/billing/components/payments/PaymentRow.tsx:164
msgid "Error al descargar la factura."
msgstr "Error al descargar la factura."

#: src/features/billing/components/UpdatePaymentView.tsx:96
msgid "Error al editar el pago."
msgstr "Error al editar el pago."

#: src/features/homeAmaru/hooks/useDeleteMyCollection.tsx:25
msgid "Error al eliminar colección"
msgstr "Error al eliminar colección"

#: src/features/collections/components/modals/ManageCollectionAccessModal.tsx:44
msgid "Error al eliminar dispositivo de la colección"
msgstr "Error al eliminar dispositivo de la colección"

#: src/features/billing/components/projectService/Delete.tsx:62
msgid "Error al eliminar el servicio."
msgstr "Error al eliminar el servicio."

#: src/features/billing/components/projectService/Delete.tsx:80
msgid "Error al eliminar el servicio. Faltan parametros."
msgstr "Error al eliminar el servicio. Faltan parametros."

#: src/features/deviceConfiguration/components/DeleteDeviceConfiguration.tsx:50
#: src/features/deviceConfiguration/components/DeleteDeviceConfiguration.tsx:53
msgid "Error al eliminar la configuración del equipo"
msgstr "Error al eliminar la configuración del equipo"

#: src/features/api/components/dialogs/SoftDeleteApiUserDialog.tsx:44
msgid "Error al eliminar la credencial"
msgstr "Error al eliminar la credencial"

#: src/features/organizationDelete/components/DeleteOrganization.tsx:98
msgid "Error al eliminar la organización."
msgstr "Error al eliminar la organización."

#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:50
msgid "Error al eliminar la programación"
msgstr "Error al eliminar la programación"

#: src/features/gateAdministration/components/DeleteRequestModal.tsx:50
#: src/features/gateAdministration/components/DeleteRequestModal.tsx:55
msgid "Error al eliminar la solicitud de movimiento"
msgstr "Error al eliminar la solicitud de movimiento"

#: src/features/collections/components/modals/ManageCollectionAccessModal.tsx:114
msgid "Error al eliminar usuario de la colección"
msgstr "Error al eliminar usuario de la colección"

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:51
msgid "Error al enviar el comando"
msgstr "Error al enviar el comando"

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:35
msgid "Error al enviar el comando. Por favor, intente nuevamente."
msgstr "Error al enviar el comando. Por favor, intente nuevamente."

#: src/features/reportProblem/components/ReportProblemDialog.tsx:70
#: src/features/reportProblem/components/ReportProblemModal.tsx:77
msgid "Error al enviar el reporte"
msgstr "Error al enviar el reporte"

#: src/features/reports/components/creationSection/CreateReportDialog.tsx:58
msgid "Error al generar reporte en Excel: El volumen de datos solicitado supera el límite permitido para la generación de reportes en formato Excel.Te recomendamos reducir el rango de fechas o la cantidad de métricas. Si necesitas un archivo más completo, puedes comunicarte con soporte para recibir asistencia."
msgstr "Error al generar reporte en Excel: El volumen de datos solicitado supera el límite permitido para la generación de reportes en formato Excel.Te recomendamos reducir el rango de fechas o la cantidad de métricas. Si necesitas un archivo más completo, puedes comunicarte con soporte para recibir asistencia."

#: src/features/reports/components/creationSection/CreateReportDialog.tsx:52
msgid "Error al generar reporte en PDF: El periodo de tiempo y la cantidad de métricas seleccionadas exceden el límite permitido para generar reportes en formato PDF. Si necesitas un reporte más extenso, por favor contacta al equipo de soporte para ayudarte con una solución personalizada."
msgstr "Error al generar reporte en PDF: El periodo de tiempo y la cantidad de métricas seleccionadas exceden el límite permitido para generar reportes en formato PDF. Si necesitas un reporte más extenso, por favor contacta al equipo de soporte para ayudarte con una solución personalizada."

#: src/features/integrations/utils/writeExecutionLogCodeTranslations.ts:9
msgid "Error al iniciar sesión"
msgstr "Error al iniciar sesión"

#: src/features/deviceCommands/components/calendar/UpdateCommandKeyDialog.tsx:38
msgid "Error al intentar actualizar el comando. Por favor, intente nuevamente."
msgstr "Error al intentar actualizar el comando. Por favor, intente nuevamente."

#: src/features/deviceCommands/components/calendar/DeleteScheduleCommandKeyDialog.tsx:36
msgid "Error al intentar eliminar el comando. Por favor, intente nuevamente."
msgstr "Error al intentar eliminar el comando. Por favor, intente nuevamente."

#: src/features/billing/components/DueDate.tsx:33
msgid "Error al modificar la fecha de pago."
msgstr "Error al modificar la fecha de pago."

#: src/features/billing/components/table/ProjectsTable.tsx:143
msgid "Error al modificar la periodicidad: {0}"
msgstr "Error al modificar la periodicidad: {0}"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:181
msgid "Error al programar el reporte"
msgstr "Error al programar el reporte"

#: src/features/deviceConfigurationModal/components/gateTab/RemoveLinkedDeviceButton.tsx:30
msgid "Error al quitar el sensor de nivel: {0}"
msgstr "Error al quitar el sensor de nivel: {0}"

#: src/features/api/components/dialogs/ResendApiCredentialsDialog.tsx:66
msgid "Error al reenviar las credenciales"
msgstr "Error al reenviar las credenciales"

#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:110
msgid "Error al solicitar el reporte. Intente nuevamente."
msgstr "Error al solicitar el reporte. Intente nuevamente."

#: src/features/integrations/utils/writeExecutionLogCodeTranslations.ts:15
msgid "Error al subir datos a la API de Captcha"
msgstr "Error al subir datos a la API de Captcha"

#: src/features/collections/components/modals/CreateCollectionModal.tsx:64
#: src/features/collections/components/modals/UpdateCollectionModal.tsx:84
msgid "Error al subir el archivo KML"
msgstr "Error al subir el archivo KML"

#: src/features/createDeviceConfiguration/components/common/PDFUploadField.tsx:98
msgid "Error al subir el archivo: {0}"
msgstr "Error al subir el archivo: {0}"

#: src/features/collectionCommon/hooks/useCollectionImageUpload.ts:51
#: src/features/metricsViews/hooks/useMetricsViewImageUpload.ts:43
#: src/fsd/entities/dashboard-widget/api/image-upload.ts:42
msgid "Error al subir la imagen"
msgstr "Error al subir la imagen"

#: src/features/integrations/utils/writeExecutionLogCodeTranslations.ts:17
msgid "Error desconocido"
msgstr "Error desconocido"

#: src/features/devices2/utils/featuresFilter.ts:29
msgid "Es cobrable"
msgstr "Es cobrable"

#: src/features/controlCenter2/components/versionSwitch/FeedbackDialog.tsx:49
#: src/features/reports2/components/versionSwitch/FeedbackDialog.tsx:52
msgid "Es confuso"
msgstr "Es confuso"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:164
msgid "Es distinto del que se derivaría del escritorio y se conserva. No se edita acá."
msgstr "Es distinto del que se derivaría del escritorio y se conserva. No se edita acá."

#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:247
msgid "Es el nombre que verán los miembros de tu organización"
msgstr "Es el nombre que verán los miembros de tu organización"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:123
msgid "Es el orden que recorren las flechas del teclado."
msgstr "Es el orden que recorren las flechas del teclado."

#: src/features/billing/components/modals/ServiceFileManager.tsx:187
msgid "Es importante que sea tal cual el nombre de los servicios existentes. Ejemplo \"Valor DGA\"."
msgstr "Es importante que sea tal cual el nombre de los servicios existentes. Ejemplo \"Valor DGA\"."

#: src/fsd/pages/dashboards/ui/layout-warnings/warning-text.ts:21
msgid "Es más chico que el tamaño sugerido para su tipo; se muestra con el tamaño guardado."
msgstr "Es más chico que el tamaño sugerido para su tipo; se muestra con el tamaño guardado."

#: src/fsd/pages/dashboards/ui/layout-warnings/warning-text.ts:22
msgid "Es más grande que el tamaño sugerido para su tipo; se muestra con el tamaño guardado."
msgstr "Es más grande que el tamaño sugerido para su tipo; se muestra con el tamaño guardado."

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:240
msgid "Es solo para componer: no se guarda ni cuenta como cambio, y al salir de la edición vuelven los datos reales. Cada widget puede tener su origen en su propio grupo «Datos»."
msgstr "Es solo para componer: no se guarda ni cuenta como cambio, y al salir de la edición vuelven los datos reales. Cada widget puede tener su origen en su propio grupo «Datos»."

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:44
msgid "Esc"
msgstr "Esc"

#: src/features/metricsViews/components/forms/DataWidgetForm.tsx:244
msgid "Escala"
msgstr "Escala"

#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:50
msgid "Escenario de compuerta"
msgstr "Escenario de compuerta"

#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:95
#: src/features/api/components/dialogs/SoftDeleteApiUserDialog.tsx:92
msgid "Escriba \"{0}\""
msgstr "Escriba \"{0}\""

#: src/features/api/components/dialogs/EnableApiUserDialog.tsx:92
msgid "Escriba {0}"
msgstr "Escriba {0}"

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:440
#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:252
msgid "Escriba los emails a enviar el reporte"
msgstr "Escriba los emails a enviar el reporte"

#: src/fsd/app/locale/au-labels.ts:96
msgid "Escriba una duración: 3h, 15m, 2w."
msgstr "Escriba una duración: 3h, 15m, 2w."

#: src/features/api/components/dialogs/DisableApiUserDialog.tsx:89
msgid "Escribe \"{0}\""
msgstr "Escribe \"{0}\""

#: src/features/users/components/modals/SimulateUserShortcutModal.tsx:113
msgid "Escribe al menos 2 caracteres"
msgstr "Escribe al menos 2 caracteres"

#: src/features/controlCenter2/components/versionSwitch/SuggestionFab.tsx:54
#: src/features/reports2/components/versionSwitch/SuggestionFab.tsx:65
msgid "Escribe tu sugerencia..."
msgstr "Escribe tu sugerencia..."

#: src/features/reports2/components/createModal/steps/step3/3-FormatAndRecipients.tsx:359
msgid "Escribe un correo y presiona Enter"
msgstr "Escribe un correo y presiona Enter"

#: src/fsd/entities/dashboard-widget/ui/text/text-render.tsx:16
msgid "Escribe un texto"
msgstr "Escribe un texto"

#: src/fsd/pages/dashboards/ui/layout-warnings/warning-text.ts:10
#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:129
#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:138
msgid "Escritorio"
msgstr "Escritorio"

#: src/features/api/components/ApiUsersList.tsx:64
#: src/features/api/components/CaptaApiUsersList.tsx:100
#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:237
#: src/features/api/components/dialogs/EditApiUserDialog.tsx:108
msgid "Escritura"
msgstr "Escritura"

#: src/features/audit/utils/parseProperty.ts:16
msgid "escritura de dispositivo"
msgstr "escritura de dispositivo"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:46
msgid "Espacio"
msgstr "Espacio"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:377
msgid "Especificaciones"
msgstr "Especificaciones"

#: src/fsd/pages/dga-reports/ui/report-state-labels.ts:16
msgid "Esperando"
msgstr "Esperando"

#: src/features/moveGateModal/components/AwaitingDevice.tsx:10
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:38
#: src/fsd/features/gate-movements/ui/operation/connection-status.tsx:85
msgid "Esperando al equipo…"
msgstr "Esperando al equipo…"

#: src/features/gateOperationModal/components/dataComponents/MovementSummaryAttribute.tsx:95
msgid "Esperando inicio movimiento"
msgstr "Esperando inicio movimiento"

#: src/components/gates/StopMovementConfirmation.tsx:97
msgid "Esperando la respuesta de la compuerta..."
msgstr "Esperando la respuesta de la compuerta..."

#: src/features/gates/components/AlarmSystem.tsx:104
msgid "Esperando nuevo estado de alarma"
msgstr "Esperando nuevo estado de alarma"

#: src/fsd/entities/dashboard-widget/model/dga-chart-sample.ts:77
#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-view.tsx:153
msgid "Esperando validación"
msgstr "Esperando validación"

#: src/features/devices2/components/list/itemPanel/DGAItemChart.tsx:172
#: src/features/dga/utils/chartOptions.ts:82
#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-chart-option.ts:50
#: src/fsd/pages/dga-reports/ui/report-state-labels.ts:22
msgid "Esperando validación de la DGA"
msgstr "Esperando validación de la DGA"

#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:156
msgid "Esquema"
msgstr "Esquema"

#: src/fsd/pages/dga-reports/ui/dga-service-strip.tsx:79
msgid "Esquema de {STRIP_DAYS} días — cada casilla es una hora"
msgstr "Esquema de {STRIP_DAYS} días — cada casilla es una hora"

#: src/features/billing/components/payments/PaymentRow.tsx:205
msgid "Está a punto de descargar la factura {number}. Desea continuar?"
msgstr "Está a punto de descargar la factura {number}. Desea continuar?"

#: src/features/organizationDelete/components/DeleteOrganization.tsx:127
#: src/features/usersGraveyard/components/HardDeleteUserModal.tsx:101
msgid "Esta acción es IRREVERSIBLE"
msgstr "Esta acción es IRREVERSIBLE"

#: src/features/dga/components/modals/MassiveDGARetryModal.tsx:75
msgid "Esta acción intentará reenviar todos los reportes que fallaron anteriormente. El proceso puede tardar varios minutos dependiendo de la cantidad de registros."
msgstr "Esta acción intentará reenviar todos los reportes que fallaron anteriormente. El proceso puede tardar varios minutos dependiendo de la cantidad de registros."

#: src/features/dga/components/modals/MassiveDGARetryModal.tsx:85
msgid "Esta acción no se puede deshacer y generará nuevos intentos de envío para todos los registros fallidos."
msgstr "Esta acción no se puede deshacer y generará nuevos intentos de envío para todos los registros fallidos."

#: src/features/collections/components/modals/CreateMetricsViewFromCollectionModal.tsx:134
msgid "Esta colección no tiene dispositivos, así que el tablero va a nacer vacío. Agregar dispositivos a la colección lo va a poblar sin tocar el tablero."
msgstr "Esta colección no tiene dispositivos, así que el tablero va a nacer vacío. Agregar dispositivos a la colección lo va a poblar sin tocar el tablero."

#: src/features/collections/components/modals/CreateMetricsViewFromCollectionModal.tsx:99
msgid "Esta colección ya tiene un tablero. Recarga el listado para ver el estado actual."
msgstr "Esta colección ya tiene un tablero. Recarga el listado para ver el estado actual."

#: src/fsd/features/gate-movements/ui/states/empty-gate.tsx:8
msgid "Esta compuerta no tiene movimientos"
msgstr "Esta compuerta no tiene movimientos"

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:307
msgid "Está fijo: libéralo para moverlo o cambiar su tamaño."
msgstr "Está fijo: libéralo para moverlo o cambiar su tamaño."

#: src/features/metricsViews/utils/dataTypes.ts:167
#: src/fsd/entities/dashboard-widget/ui/data/data-view.tsx:48
msgid "esta hora"
msgstr "esta hora"

#: src/features/billing/components/service/Delete.tsx:51
msgid "Está intentando eliminar el servicio"
msgstr "Está intentando eliminar el servicio"

#: src/features/organizationDelete/components/DeleteOrganization.tsx:226
msgid "Esta organización no tiene usuarios de API ni API Key asociados."
msgstr "Esta organización no tiene usuarios de API ni API Key asociados."

#: src/fsd/pages/dga-reports/ui/device-list.tsx:86
msgid "Esta página ya no tiene dispositivos"
msgstr "Esta página ya no tiene dispositivos"

#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:70
msgid "Esta plantilla aún no ha sido programada"
msgstr "Esta plantilla aún no ha sido programada"

#: src/features/collections/components/modals/ManageCollectionAccessModal.tsx:88
#: src/features/collections/components/modals/ManageCollectionAccessModal.tsx:163
msgid "Está seguro que desea eliminar {0} de la coleccion {1}?"
msgstr "Está seguro que desea eliminar {0} de la coleccion {1}?"

#: src/features/billing/components/service/Delete.tsx:54
msgid "Está seguro que quiere eliminar el servicio?"
msgstr "Está seguro que quiere eliminar el servicio?"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:133
msgid "Esta vista no tiene dispositivos, así que no se pueden agregar series"
msgstr "Esta vista no tiene dispositivos, así que no se pueden agregar series"

#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:163
msgid "Establece los rasgos correspondientes a la métrica seleccionada"
msgstr "Establece los rasgos correspondientes a la métrica seleccionada"

#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:67
msgid "Establece un rango de precaución. Recibirás una alerta cada 8 horas si la métrica requiere atención pero no es urgente."
msgstr "Establece un rango de precaución. Recibirás una alerta cada 8 horas si la métrica requiere atención pero no es urgente."

#: src/features/homeAmaru/components/HomeAmaru.tsx:369
#: src/features/homeAmaru/components/HomeAmaru.tsx:382
#: src/features/homeAmaru/components/HomeAmaru.tsx:395
msgid "Establecer como predeterminada"
msgstr "Establecer como predeterminada"

#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:78
msgid "Estaciones virtuales"
msgstr "Estaciones virtuales"

#: src/features/audit/utils/parseProperty.ts:34
msgid "estado"
msgstr "estado"

#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:92
#: src/features/billing/components/table/DevicesTable.tsx:157
#: src/features/billing/components/table/OrganizationsTable.tsx:70
#: src/features/billing/components/table/ProjectsTable.tsx:79
#: src/features/deviceCommands/components/DeviceCommandsHistoryTable.tsx:35
#: src/features/deviceConfiguration/components/TriggerConfigUpdateModal.tsx:98
#: src/features/deviceConfigurationModal/components/DeviceConfigurationModal.tsx:79
#: src/features/deviceProfile/components/page/General.tsx:46
#: src/features/devices2/components/DevicesHeader.tsx:174
#: src/features/deviceSupport/data/column.ts:47
#: src/features/deviceSupport/data/column.ts:55
#: src/features/deviceSupport/data/fields.ts:10
#: src/features/deviceSupport/data/filter.ts:11
#: src/features/gates/components/Gates.tsx:102
#: src/features/gates/components/list/GateListItemLastMovement.tsx:75
#: src/features/metricsViews/components/forms/ConfiguredAlertsForm.tsx:70
#: src/features/metricsViews/components/widgets/configuredAlerts/Table.tsx:275
#: src/features/users/components/UsersTable.tsx:112
#: src/features/users/utils/filterOptions.ts:107
#: src/features/users/utils/filterOptions.ts:112
#: src/features/users/utils/filterOptions.ts:117
#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:133
#: src/fsd/pages/dga-reports/ui/latest-reports.tsx:156
#: src/fsd/pages/widget-catalog/ui/preview.tsx:135
#: src/fsd/pages/widget-catalog/ui/preview.tsx:137
msgid "Estado"
msgstr "Estado"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:87
msgid "ESTADO"
msgstr "ESTADO"

#: src/features/deviceConfigurationModal/components/statusTab/index.tsx:44
msgid "Estado actual"
msgstr "Estado actual"

#: src/features/metricsViews/components/widgets/gateOperate/index.tsx:79
#: src/features/moveGateModal/components/OperatingState.tsx:46
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:318
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:91
msgid "Estado compuerta"
msgstr "Estado compuerta"

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-editor.tsx:63
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:229
msgid "Estado cumplimiento normativo"
msgstr "Estado cumplimiento normativo"

#: src/utils/attributes/metricField.ts:59
msgid "estado de carga de batería"
msgstr "estado de carga de batería"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:38
msgid "Estado de carga de batería"
msgstr "Estado de carga de batería"

#: src/utils/attributes/metricField.ts:65
msgid "estado de carga de batería bruto"
msgstr "estado de carga de batería bruto"

#: src/utils/attributes/metricField.ts:137
msgid "estado de conexión"
msgstr "estado de conexión"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:163
#: src/fsd/pages/widget-catalog/model/examples.ts:226
msgid "Estado de conexión"
msgstr "Estado de conexión"

#: src/features/reports/utils/metricHelpers.ts:12
msgid "Estado de Conexión"
msgstr "Estado de Conexión"

#: src/fsd/pages/dga-reports/ui/device-list-header.tsx:25
#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:34
msgid "Estado de envío"
msgstr "Estado de envío"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:162
#: src/features/alertsNotificationsHistory/utils/dataToTable.ts:16
msgid "Estado de notificaciones"
msgstr "Estado de notificaciones"

#: src/features/audit/utils/parseProperty.ts:37
msgid "estado de soporte"
msgstr "estado de soporte"

#: src/features/changeSupportStatus/components/ChangeSupportStatus.tsx:138
msgid "Estado de soporte"
msgstr "Estado de soporte"

#: src/features/deviceSupport/components/DevicesFilters.tsx:177
#: src/features/deviceSupport/components/FilterAdvance.tsx:177
#: src/features/deviceSupport/data/filter.ts:12
msgid "Estado de Soporte"
msgstr "Estado de Soporte"

#: src/features/changeSupportStatus/components/ChangeSupportStatus.tsx:61
msgid "Estado de soporte actualizado correctamente"
msgstr "Estado de soporte actualizado correctamente"

#: src/features/deviceConfiguration/components/TriggerConfigUpdateModal.tsx:90
msgid "Estado de última actualización"
msgstr "Estado de última actualización"

#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:158
#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:159
msgid "Estado del dispositivo"
msgstr "Estado del dispositivo"

#: src/features/dga/components/DgaServiceBarChart.tsx:27
msgid "Estado del servicio DGA"
msgstr "Estado del servicio DGA"

#: src/features/devices2/utils/featuresFilter.ts:59
#: src/features/devices2/utils/featuresFilter.ts:65
msgid "Estado DGA"
msgstr "Estado DGA"

#: src/features/moveGateModal/components/LiveNotice.tsx:91
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:273
msgid "Estado en vivo no disponible. Se usan la última posición y los límites registrados."
msgstr "Estado en vivo no disponible. Se usan la última posición y los límites registrados."

#: src/features/gateCommon/components/historyModal/index.tsx:246
#: src/features/gateOperationModal/components/PanelOperation.tsx:208
#: src/features/metricsViews/components/widgets/movementsTable/index.tsx:138
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:223
#: src/fsd/features/gate-movements/ui/history/history-table.tsx:172
#: src/fsd/features/gate-movements/ui/operation/operation-monitor.tsx:82
msgid "Estado movimiento"
msgstr "Estado movimiento"

#: src/components/DeviceOperationalStateDisplay.tsx:29
#: src/features/controlCenter/utils/viewModes.ts:13
#: src/features/controlCenter2/utils/viewModes.ts:14
#: src/features/homeAmaru/components/HomeAmaru.tsx:258
#: src/features/homeAmaru/components/shared/HomeAmaruSkeleton.tsx:61
msgid "Estado operacional"
msgstr "Estado operacional"

#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:94
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:80
msgid "ESTADO OPERACIONAL"
msgstr "ESTADO OPERACIONAL"

#: src/features/gateAdministration/components/MovementHistory.tsx:77
msgid "Estado solicitud"
msgstr "Estado solicitud"

#: src/features/deviceSupport/data/fields.ts:11
msgid "Estado soporte"
msgstr "Estado soporte"

#: src/features/metricsViews/utils/quickAccessCatalog.tsx:84
#: src/fsd/entities/dashboard-widget/ui/quick-access/destinations.ts:68
msgid "Estado y análisis de sensores"
msgstr "Estado y análisis de sensores"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:330
msgid "Estados de conexión"
msgstr "Estados de conexión"

#: src/features/metricsViews/utils/dataTypes.ts:175
msgid "estados operacionales"
msgstr "estados operacionales"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:339
#: src/features/metricsViews/components/widgets/OperationalStates.tsx:36
#: src/features/metricsViews/utils/genericWidgetTypes.ts:74
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:24
msgid "Estados operacionales"
msgstr "Estados operacionales"

#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:117
#: src/features/deviceCommands/components/calendar/StandardCommandsSelector.tsx:66
#: src/features/reports2/components/createModal/steps/step1/MetricsInput.tsx:304
msgid "Estándar"
msgstr "Estándar"

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:130
msgid "Estas activando el equipo en modo:"
msgstr "Estas activando el equipo en modo:"

#: src/features/metricsViews/components/EditViewModal.tsx:104
msgid "Estás editando la configuración de visualización de métricas de la colección <0>{0}</0>. Los dispositivos de esta visualización los define la colección: para agregar o quitar alguno, edita la colección."
msgstr "Estás editando la configuración de visualización de métricas de la colección <0>{0}</0>. Los dispositivos de esta visualización los define la colección: para agregar o quitar alguno, edita la colección."

#: src/features/metricsViews/components/EditViewModal.tsx:110
msgid "Estás editando la configuración de visualización de métricas del dispositivo <0>{id} - {0}</0>. En este formulario puedes seleccionar todos los dispositivos que quieras agregar a la visualización. Una vez guardada la configuración, podrás configurar los widgets para los dispositivos seleccionados."
msgstr "Estás editando la configuración de visualización de métricas del dispositivo <0>{id} - {0}</0>. En este formulario puedes seleccionar todos los dispositivos que quieras agregar a la visualización. Una vez guardada la configuración, podrás configurar los widgets para los dispositivos seleccionados."

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:137
msgid "Estás por configurar el equipo en modo:"
msgstr "Estás por configurar el equipo en modo:"

#: src/features/billing/utils/validationSchema.ts:5
#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:6
#: src/utils/yupValidation.ts:4
msgid "Este campo es obligatorio"
msgstr "Este campo es obligatorio"

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:83
#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:91
msgid "Este campo es requerido"
msgstr "Este campo es requerido"

#: src/features/dgaTicket/validation.ts:42
#: src/features/reportProblem/components/ReportProblemModal.tsx:35
#: src/fsd/pages/dga-reports/ui/report-problem-dialog.tsx:66
msgid "Este campo no puede estar vacío"
msgstr "Este campo no puede estar vacío"

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:270
msgid "Este dispositivo no tiene DGA configurado."
msgstr "Este dispositivo no tiene DGA configurado."

#: src/features/createDeviceConfiguration/components/tabs/general/GeneralTabContent.tsx:226
msgid "Este equipo no tiene certificado VPN disponible"
msgstr "Este equipo no tiene certificado VPN disponible"

#: src/features/metricsViews/utils/dataTypes.ts:169
#: src/fsd/entities/dashboard-widget/ui/data/data-view.tsx:50
msgid "este mes"
msgstr "este mes"

#: src/features/reports2/components/ReportTemplatesTable.tsx:332
msgid "Este reporte no tiene un período definido, así que no se puede generar. Edítalo y elige una ventana de tiempo."
msgstr "Este reporte no tiene un período definido, así que no se puede generar. Edítalo y elige una ventana de tiempo."

#: src/features/reports2/components/ReportTemplatesTable.tsx:352
msgid "este reporte se repite pero tiene un rango de fechas fijo, así que cada ejecución entrega siempre el mismo período. Edítalo y elige una ventana relativa."
msgstr "este reporte se repite pero tiene un rango de fechas fijo, así que cada ejecución entrega siempre el mismo período. Edítalo y elige una ventana relativa."

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:33
msgid "Este tablero es demasiado grande para que el asistente lo lea entero, y una propuesta sobre una parte quitaría el resto. Quita algunos widgets o haz los cambios en el modo Editar."
msgstr "Este tablero es demasiado grande para que el asistente lo lea entero, y una propuesta sobre una parte quitaría el resto. Quita algunos widgets o haz los cambios en el modo Editar."

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:377
msgid "Este tablero no tiene dispositivos: agrégalos en «Configurar tablero» para usar el asistente."
msgstr "Este tablero no tiene dispositivos: agrégalos en «Configurar tablero» para usar el asistente."

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:137
#: src/fsd/entities/dashboard-widget/ui/data/data-editor.tsx:50
#: src/fsd/entities/dashboard-widget/ui/device-select/device-multi-select.tsx:41
#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-editor.tsx:21
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-editor.tsx:32
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-editor.tsx:21
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-editor.tsx:42
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-editor.tsx:22
#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:57
msgid "Este tablero no tiene dispositivos."
msgstr "Este tablero no tiene dispositivos."

#: src/fsd/pages/dashboards/ui/canvas/canvas.tsx:241
msgid "Este tablero no tiene widgets."
msgstr "Este tablero no tiene widgets."

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:161
msgid "Este tablero tiene un layout de teléfono propio"
msgstr "Este tablero tiene un layout de teléfono propio"

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:145
msgid "Este tipo de widget todavía no se edita en este editor. Se conserva tal como está guardado."
msgstr "Este tipo de widget todavía no se edita en este editor. Se conserva tal como está guardado."

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:269
msgid "Este tipo de widget todavía no usa datos de ejemplo: sigue mostrando datos reales."
msgstr "Este tipo de widget todavía no usa datos de ejemplo: sigue mostrando datos reales."

#: src/fsd/pages/widget-catalog/ui/examples-panel.tsx:19
msgid "Este tipo no tiene ejemplos."
msgstr "Este tipo no tiene ejemplos."

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:116
msgid "Este widget no tiene celda en esta vista, así que no se puede editar acá. Se conserva tal como está guardado."
msgstr "Este widget no tiene celda en esta vista, así que no se puede editar acá. Se conserva tal como está guardado."

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:107
msgid "Este widget se muestra solo en escritorio, así que en esta vista no aparece. Se edita en Escritorio."
msgstr "Este widget se muestra solo en escritorio, así que en esta vista no aparece. Se edita en Escritorio."

#: src/fsd/entities/dashboard-widget/ui/image/image-render.tsx:59
msgid "Este widget todavía no tiene imagen. Súbela desde su configuración."
msgstr "Este widget todavía no tiene imagen. Súbela desde su configuración."

#: src/features/debtsAlert/components/DebtsAlertModal.tsx:69
#: src/features/debtsAlert/components/DebtsAlertPopover.tsx:59
msgid "Estimado cliente,"
msgstr "Estimado cliente,"

#: src/features/metricsViews/components/forms/ButtonWidgetForm.tsx:87
#: src/fsd/entities/dashboard-widget/ui/button/button-editor.tsx:59
#: src/fsd/pages/widget-catalog/model/examples.ts:389
msgid "Estirado"
msgstr "Estirado"

#: src/features/announcements/components/AnnouncementsDeleteModal.tsx:75
msgid "Esto eliminará el anuncio con el título: <0>{0}</0>"
msgstr "Esto eliminará el anuncio con el título: <0>{0}</0>"

#: src/features/notifications/components/NotificationsDeleteModal.tsx:74
msgid "Esto eliminará las notificaciones relacionadas con este objeto recibidas por los usuarios."
msgstr "Esto eliminará las notificaciones relacionadas con este objeto recibidas por los usuarios."

#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:57
msgid "Ethernet"
msgstr "Ethernet"

#: src/features/metricsViews/components/forms/ButtonWidgetForm.tsx:38
#: src/fsd/entities/dashboard-widget/ui/button/button-editor.tsx:31
msgid "Etiqueta"
msgstr "Etiqueta"

#: src/fsd/pages/widget-catalog/model/examples.ts:380
msgid "Etiqueta e ícono"
msgstr "Etiqueta e ícono"

#: src/features/deviceSupport/data/column.ts:53
#: src/features/deviceSupport/data/fields.ts:12
#: src/features/updateMultipleDevicesTags/components/UpdateMultipleDevicesTagsModal.tsx:179
msgid "Etiquetas"
msgstr "Etiquetas"

#: src/features/reportProblem/components/ReportProblemDialog.tsx:147
#: src/features/reportProblem/components/ReportProblemModal.tsx:126
#: src/fsd/pages/dashboards/ui/report-problem/report-problem-dialog.tsx:126
msgid "Evento a reportar"
msgstr "Evento a reportar"

#: src/utils/attributes/metricField.ts:215
msgid "eventos"
msgstr "eventos"

#: src/features/deviceProfile/components/page/events/index.tsx:152
#: src/features/devicesAnalysis/components/panel/Chart.tsx:255
#: src/features/deviceSupport/data/column.ts:153
#: src/features/deviceSupport/data/fields.ts:23
msgid "Eventos"
msgstr "Eventos"

#: src/features/deviceProfile/components/page/events/index.tsx:185
msgid "Eventos con mayor ocurrencia"
msgstr "Eventos con mayor ocurrencia"

#: src/fsd/pages/gate-movements/ui/panel/events/movement-events.tsx:119
msgid "Eventos del movimiento"
msgstr "Eventos del movimiento"

#: src/features/deviceProfile/components/page/events/index.tsx:165
msgid "Eventos en el tiempo"
msgstr "Eventos en el tiempo"

#: src/features/reports2/components/createModal/steps/step3/3-FormatAndRecipients.tsx:211
#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:358
#: src/features/reports2/components/ReportCreated.tsx:53
msgid "Excel"
msgstr "Excel"

#: src/features/gateAdministration/components/MoveGate.tsx:59
msgid "Existe una solicitud de movimiento que aún no se ha ejecutado. Si solicitas una nueva posición, la solicitud anterior será cancelada."
msgstr "Existe una solicitud de movimiento que aún no se ha ejecutado. Si solicitas una nueva posición, la solicitud anterior será cancelada."

#: src/features/alertsNotificationsHistory/utils/dataToTable.ts:23
#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:62
#: src/features/deviceConfiguration/components/TriggerConfigUpdateModal.tsx:28
#: src/utils/i18n/getAlertSuccessOptions.ts:19
msgid "Exitoso"
msgstr "Exitoso"

#: src/features/alertsConfigurationV3/components/AlertSummaryCard.tsx:159
msgid "Expandir detalle"
msgstr "Expandir detalle"

#: src/fsd/pages/dga-reports/ui/device-row.tsx:131
msgid "Expandir detalle de {name}"
msgstr "Expandir detalle de {name}"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:146
#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:151
msgid "Expandir gráfico"
msgstr "Expandir gráfico"

#: src/features/devicesAnalysisV3/components/TimelineMinimap.tsx:406
msgid "Expandir minimapa"
msgstr "Expandir minimapa"

#: src/features/billing/components/table/ServicesTable.tsx:63
msgid "Expiración del Servicio"
msgstr "Expiración del Servicio"

#: src/features/metricsViews/components/ExportViewButton.tsx:30
#: src/features/metricsViews/components/ExportViewButton.tsx:33
msgid "Exportar el tablero"
msgstr "Exportar el tablero"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/FlowModelInput.tsx:101
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/GCalculatedAngleModelInput.tsx:80
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/LGFlowModelInput.tsx:106
msgid "Expresión"
msgstr "Expresión"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/GCalculatedAngleModelInput.tsx:58
msgid "Expresión matemática para calcular el ángulo"
msgstr "Expresión matemática para calcular el ángulo"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/FlowModelInput.tsx:81
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/LGFlowModelInput.tsx:86
msgid "Expresión matemática para calcular el caudal"
msgstr "Expresión matemática para calcular el caudal"

#: src/features/users/components/modals/ExtendTemporaryUserModal.tsx:91
#: src/features/users/components/modals/ExtendTemporaryUserTokenModal.tsx:78
msgid "Extender"
msgstr "Extender"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:100
msgid "Extender duración de usuario (expira {0})"
msgstr "Extender duración de usuario (expira {0})"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:84
msgid "Extender duración de usuario (expiró {0})"
msgstr "Extender duración de usuario (expiró {0})"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:135
msgid "Extender duración del token (expira {0})"
msgstr "Extender duración del token (expira {0})"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:116
msgid "Extender duración del token (expiró {0})"
msgstr "Extender duración del token (expiró {0})"

#: src/features/users/components/modals/ExtendTemporaryUserTokenModal.tsx:66
msgid "Extender duración del token de activación"
msgstr "Extender duración del token de activación"

#: src/features/users/components/modals/ExtendTemporaryUserModal.tsx:70
msgid "Extender duración del usuario temporal"
msgstr "Extender duración del usuario temporal"

#: src/features/audit/utils/parseProperty.ts:150
msgid "extracción usb"
msgstr "extracción usb"

#: src/features/deviceConfiguration/data/sectionFields.ts:235
#: src/features/deviceConfiguration/data/sectionInputs.ts:251
msgid "Extracción USB"
msgstr "Extracción USB"

#: src/features/alertsNotificationsHistory/components/Filters.tsx:116
msgid "Extraer datos"
msgstr "Extraer datos"

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:130
#: src/features/controlCenter2/utils/alertStates.ts:22
msgid "Extremo"
msgstr "Extremo"

#: src/features/deviceProfile/components/page/modularComponents/HousingTab.tsx:48
#: src/features/deviceProfile/components/page/modularComponents/HousingTab.tsx:80
msgid "Fácil de instalar"
msgstr "Fácil de instalar"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:547
msgid "Factor M"
msgstr "Factor M"

#: src/features/billing/components/payments/PaymentsTable.tsx:49
msgid "Factura"
msgstr "Factura"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:214
#: src/pages/billing/AdministrationView.tsx:10
msgid "Facturación"
msgstr "Facturación"

#: src/fsd/shared/ui/format/units.ts:246
#: src/utils/units.ts:303
msgid "fahrenheit"
msgstr "fahrenheit"

#: src/features/gateAdministration/components/RequestedPositionIcon.tsx:37
msgid "Fallida"
msgstr "Fallida"

#: src/features/alertsNotificationsHistory/utils/dataToTable.ts:24
#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:63
#: src/features/deviceConfiguration/components/TriggerConfigUpdateModal.tsx:29
#: src/fsd/pages/dga-reports/ui/report-state-labels.ts:18
#: src/utils/i18n/getAlertSuccessOptions.ts:21
msgid "Fallido"
msgstr "Fallido"

#: src/features/metricsViews/components/widgets/dgaReports/index.legacy.tsx:59
#: src/features/metricsViews/components/widgets/dgaReports/index.tsx:67
msgid "fallo en el envío"
msgstr "fallo en el envío"

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:60
msgid "Fallo en el envío"
msgstr "Fallo en el envío"

#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:284
msgid "Falló la consulta de la compuerta. Prueba con «Refrescar» del tablero."
msgstr "Falló la consulta de la compuerta. Prueba con «Refrescar» del tablero."

#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:322
msgid "Falló la consulta de los movimientos. Prueba con «Refrescar» del tablero."
msgstr "Falló la consulta de los movimientos. Prueba con «Refrescar» del tablero."

#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-view.tsx:185
msgid "Falló la consulta de los sensores. Prueba con «Refrescar» del tablero."
msgstr "Falló la consulta de los sensores. Prueba con «Refrescar» del tablero."

#: src/features/controlCenter2/components/versionSwitch/FeedbackDialog.tsx:48
#: src/features/reports2/components/versionSwitch/FeedbackDialog.tsx:51
msgid "Falta alguna funcionalidad"
msgstr "Falta alguna funcionalidad"

#: src/features/reports2/components/createModal/useCreateForm.ts:187
msgid "Faltan datos para guardar el reporte: el nombre es obligatorio"
msgstr "Faltan datos para guardar el reporte: el nombre es obligatorio"

#: src/features/reports2/components/createModal/useCreateForm.ts:271
msgid "Faltan datos para programar el reporte: nombre, período y horario son obligatorios"
msgstr "Faltan datos para programar el reporte: nombre, período y horario son obligatorios"

#: src/features/billing/components/DueDate.tsx:48
msgid "Faltan valores para actualizar."
msgstr "Faltan valores para actualizar."

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:22
msgid "Febrero"
msgstr "Febrero"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:48
#: src/features/alertsNotificationsHistory/components/Filters.tsx:255
#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:153
#: src/features/alertsNotificationsHistory/utils/dataToTable.ts:13
#: src/features/audit/components/AuditLogsSidebar.tsx:91
#: src/features/billing/components/payments/PaymentsTable.tsx:51
#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:128
#: src/features/dga/components/modals/reports/TableModal.tsx:153
#: src/features/events/components/HeaderTable.tsx:26
#: src/features/gates/components/list/GateListItemLastMovement.tsx:68
#: src/features/metricsViews/components/widgets/TableWidget.tsx:155
#: src/features/sma/components/TableModal.tsx:186
#: src/fsd/entities/dashboard-widget/ui/table/table-view.tsx:115
#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:129
#: src/fsd/pages/dga-reports/ui/latest-reports.tsx:160
msgid "Fecha"
msgstr "Fecha"

#: src/features/audit/utils/parseProperty.ts:113
msgid "fecha actualizado"
msgstr "fecha actualizado"

#: src/features/audit/utils/parseProperty.ts:40
msgid "fecha creación"
msgstr "fecha creación"

#: src/features/audit/utils/parseProperty.ts:114
msgid "fecha creado"
msgstr "fecha creado"

#: src/features/audit/utils/parseProperty.ts:46
msgid "fecha de acción"
msgstr "fecha de acción"

#: src/features/deviceConfiguration/data/sectionFields.ts:21
#: src/features/deviceConfiguration/data/sectionInputs.ts:30
msgid "Fecha de activación"
msgstr "Fecha de activación"

#: src/fsd/pages/dga-reports/ui/report-problem-dialog.tsx:128
msgid "Fecha de apertura"
msgstr "Fecha de apertura"

#: src/features/devicesGraveyard/components/DevicesGraveyard.tsx:129
#: src/features/usersGraveyard/components/UsersGraveyard.tsx:112
msgid "Fecha de archivado"
msgstr "Fecha de archivado"

#: src/features/audit/utils/parseProperty.ts:12
msgid "fecha de creación"
msgstr "fecha de creación"

#: src/features/deviceConfiguration/components/ConfigurationFileHistoryModal.tsx:128
#: src/features/deviceProfile/components/page/General.tsx:55
#: src/features/reports/components/ReportHistory.tsx:74
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:137
#: src/features/reports2/components/reportHistoryModal/ReportHistory.tsx:79
#: src/features/reports2/components/TemplateSummary.tsx:87
msgid "Fecha de creación"
msgstr "Fecha de creación"

#: src/features/api/components/CaptaApiUsersList.tsx:103
msgid "Fecha de Creación"
msgstr "Fecha de Creación"

#: src/features/devices2/utils/getOrderByOptions.ts:33
msgid "Fecha de creación (Asc)"
msgstr "Fecha de creación (Asc)"

#: src/features/gates/components/Gates.tsx:54
#: src/features/users/utils/filterOptions.ts:50
msgid "Fecha de Creación (Asc)"
msgstr "Fecha de Creación (Asc)"

#: src/features/devices2/utils/getOrderByOptions.ts:37
msgid "Fecha de creación (Desc)"
msgstr "Fecha de creación (Desc)"

#: src/features/gates/components/Gates.tsx:55
#: src/features/users/utils/filterOptions.ts:57
msgid "Fecha de Creación (Desc)"
msgstr "Fecha de Creación (Desc)"

#: src/features/deviceProfile/components/page/Support.tsx:126
msgid "Fecha de descarga"
msgstr "Fecha de descarga"

#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:130
msgid "Fecha de ejecución"
msgstr "Fecha de ejecución"

#: src/fsd/pages/dga-reports/ui/reports-heatmap.tsx:239
msgid "Fecha de ejecución: {0}"
msgstr "Fecha de ejecución: {0}"

#: src/features/dgaTicket/components/DgaTicketModal.tsx:171
#: src/features/dgaTicket/components/DgaTicketModal.tsx:347
msgid "Fecha de ingreso en la DGA"
msgstr "Fecha de ingreso en la DGA"

#: src/features/audit/utils/parseProperty.ts:107
msgid "fecha de inicio"
msgstr "fecha de inicio"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:86
msgid "Fecha de Pago"
msgstr "Fecha de Pago"

#: src/features/billing/components/modals/ServiceFileManager.tsx:98
msgid "Fecha de Próximo Pago"
msgstr "Fecha de Próximo Pago"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:405
msgid "Fecha de realización"
msgstr "Fecha de realización"

#: src/features/audit/utils/parseProperty.ts:13
msgid "fecha de última modificación"
msgstr "fecha de última modificación"

#: src/features/api/components/CaptaApiUsersList.tsx:106
msgid "Fecha de Última Modificación"
msgstr "Fecha de Última Modificación"

#: src/features/billing/components/payments/PaymentForm.tsx:149
msgid "Fecha del pago"
msgstr "Fecha del pago"

#: src/features/reportProblem/components/ReportProblemDialog.tsx:155
#: src/features/reportProblem/components/ReportProblemModal.tsx:139
#: src/fsd/pages/dashboards/ui/report-problem/report-problem-dialog.tsx:134
msgid "Fecha del reporte"
msgstr "Fecha del reporte"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:225
msgid "Fecha en que comienza el servicio, en formato 'AAAA-MM-DD'."
msgstr "Fecha en que comienza el servicio, en formato 'AAAA-MM-DD'."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:211
msgid "Fecha en que debe realizarse el pago de la factura, en formato 'AAAA-MM-DD'."
msgstr "Fecha en que debe realizarse el pago de la factura, en formato 'AAAA-MM-DD'."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:227
msgid "Fecha en que finaliza el servicio, en formato 'AAAA-MM-DD'."
msgstr "Fecha en que finaliza el servicio, en formato 'AAAA-MM-DD'."

#: src/features/billing/components/payments/PaymentRow.tsx:106
#: src/features/gateAdministration/components/MovementHistory.tsx:83
#: src/features/gateCommon/components/historyModal/index.tsx:241
#: src/fsd/features/gate-movements/ui/history/history-table.tsx:169
msgid "Fecha finalización"
msgstr "Fecha finalización"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:66
msgid "Fecha Finalización"
msgstr "Fecha Finalización"

#: src/features/billing/components/payments/PaymentRow.tsx:105
msgid "Fecha inicio"
msgstr "Fecha inicio"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:63
msgid "Fecha Inicio"
msgstr "Fecha Inicio"

#: src/features/dgaTicket/validation.ts:48
#: src/features/reportProblem/components/ReportProblemModal.tsx:36
#: src/features/reportProblem/components/ReportProblemModal.tsx:84
msgid "Fecha inválida"
msgstr "Fecha inválida"

#: src/features/audit/utils/parseProperty.ts:41
msgid "fecha modificación"
msgstr "fecha modificación"

#: src/features/billing/components/DueDate.tsx:102
msgid "Fecha próximo pago"
msgstr "Fecha próximo pago"

#: src/features/gateAdministration/components/MovementHistory.tsx:80
#: src/features/gateCommon/components/historyModal/index.tsx:238
#: src/features/gateOperationModal/components/PanelSummary.tsx:39
#: src/fsd/features/gate-movements/ui/history/history-table.tsx:166
#: src/fsd/features/gate-movements/ui/operation/operation-summary.tsx:54
msgid "Fecha solicitud"
msgstr "Fecha solicitud"

#: src/features/deviceCommands/components/DeviceCommandsHistoryTable.tsx:37
msgid "Fecha y Hora"
msgstr "Fecha y Hora"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:264
msgid "fijado"
msgstr "fijado"

#: src/features/devicesAnalysisV3/components/TimelineMinimap.tsx:308
msgid "Fijado a ahora (live-capable)"
msgstr "Fijado a ahora (live-capable)"

#: src/fsd/pages/dashboards/ui/canvas/canvas.tsx:628
msgid "Fijar"
msgstr "Fijar"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:106
msgid "Fijar o liberar"
msgstr "Fijar o liberar"

#: src/fsd/pages/dashboards/ui/canvas/canvas.tsx:625
msgid "Fijar o liberar (F)"
msgstr "Fijar o liberar (F)"

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:320
msgid "Fila"
msgstr "Fila"

#: src/components/TablePaginationActions.tsx:92
#: src/components/TablePaginationActions.tsx:97
#: src/features/metricsViews/components/forms/TrendSummaryForm.tsx:186
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-editor.tsx:59
#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:141
#: src/fsd/pages/dga-reports/ui/list-pagination.tsx:31
msgid "Filas"
msgstr "Filas"

#: src/fsd/app/locale/au-labels.ts:64
msgid "Filas por página"
msgstr "Filas por página"

#: src/features/alertsNotificationsHistory/components/Filters.tsx:108
msgid "Filtrar"
msgstr "Filtrar"

#: src/features/announcements/components/AnnouncementsView.tsx:106
#: src/features/announcements/components/AnnouncementsView.tsx:136
msgid "Filtrar por categoría"
msgstr "Filtrar por categoría"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:363
msgid "Filtro de Velocidad Fuera de Rango"
msgstr "Filtro de Velocidad Fuera de Rango"

#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:165
#: src/features/audit/components/AuditLogsSidebar.tsx:86
#: src/features/billing/components/administration/Filters.tsx:39
#: src/features/deviceDataConfigurationModal/components/DeviceDataConfigurationModal.tsx:82
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:318
msgid "Filtros"
msgstr "Filtros"

#: src/features/deviceSupport/components/FilterConfig.tsx:52
msgid "Filtros actualizados correctamente"
msgstr "Filtros actualizados correctamente"

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:453
#: src/features/deviceConfiguration/components/DeviceConfiguration.tsx:306
msgid "Filtros avanzados"
msgstr "Filtros avanzados"

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:214
msgid "Filtros por 4G (ICCID / IMEI)"
msgstr "Filtros por 4G (ICCID / IMEI)"

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:246
msgid "Filtros por características"
msgstr "Filtros por características"

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:201
msgid "Filtros por números de lote"
msgstr "Filtros por números de lote"

#: src/features/reports/components/ReportHistory.tsx:283
#: src/features/reports2/components/reportHistoryModal/ReportHistory.tsx:290
#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:199
msgid "Fin"
msgstr "Fin"

#: src/features/gateCommon/utils/gateCloseCode.ts:45
#: src/fsd/entities/gate/model/close-code.ts:30
msgid "Fin de carrera alcanzado"
msgstr "Fin de carrera alcanzado"

#: src/features/dga/components/modals/DGAReportsRetryModal.tsx:130
msgid "Final"
msgstr "Final"

#: src/features/billing/components/payments/PaymentDetailsForm.tsx:198
msgid "Finalización"
msgstr "Finalización"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:100
msgid "Finalización del Servicio"
msgstr "Finalización del Servicio"

#: src/features/gateCommon/utils/gateMovementState.tsx:25
#: src/fsd/entities/gate/model/movement-state.ts:38
msgid "Finalizada"
msgstr "Finalizada"

#: src/features/gateCommon/utils/gateMovementState.tsx:26
#: src/fsd/entities/gate/model/movement-state.ts:39
msgid "Finalizada con error"
msgstr "Finalizada con error"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:496
msgid "Flecha"
msgstr "Flecha"

#: src/features/alertsNotificationsHistory/utils/alertTypes.ts:13
msgid "Flujo"
msgstr "Flujo"

#: src/features/controlCenter2/components/devicesList/ListItem.tsx:152
#: src/features/devices2/components/list/itemPanel/deviceItemInfo/AlertsIndicator.tsx:62
msgid "Flujo de desborde: {formattedValue}"
msgstr "Flujo de desborde: {formattedValue}"

#: src/features/devices2/components/list/itemPanel/deviceItemInfo/AlertsIndicator.tsx:72
msgid "Flujo máximo de distribución: {formattedValue}"
msgstr "Flujo máximo de distribución: {formattedValue}"

#: src/features/controlCenter2/components/devicesList/ListItem.tsx:151
#: src/features/devices2/components/list/itemPanel/deviceItemInfo/AlertsIndicator.tsx:60
msgid "Flujo máximo: {formattedValue}"
msgstr "Flujo máximo: {formattedValue}"

#: src/features/controlCenter2/components/devicesList/ListItem.tsx:150
#: src/features/devices2/components/list/itemPanel/deviceItemInfo/AlertsIndicator.tsx:58
msgid "Flujo mínimo: {formattedValue}"
msgstr "Flujo mínimo: {formattedValue}"

#: src/fsd/shared/ui/format/units.ts:236
#: src/utils/units.ts:293
msgid "fnu"
msgstr "fnu"

#: src/fsd/shared/ui/format/units.ts:235
#: src/utils/units.ts:292
msgid "FNU"
msgstr "FNU"

#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:476
msgid "Formato de envío"
msgstr "Formato de envío"

#: src/features/userPreferences/components/RegionTab.tsx:217
msgid "Formato de fecha"
msgstr "Formato de fecha"

#: src/features/userPreferences/components/RegionTab.tsx:256
msgid "Formato de hora"
msgstr "Formato de hora"

#: src/features/metricsViews/hooks/useMetricsViewImageUpload.ts:36
#: src/fsd/entities/dashboard-widget/api/image-upload.ts:50
msgid "Formato de imagen no soportado. Usa JPEG, PNG o WebP"
msgstr "Formato de imagen no soportado. Usa JPEG, PNG o WebP"

#: src/features/userPreferences/components/RegionTab.tsx:282
msgid "Formato de mes"
msgstr "Formato de mes"

#: src/features/userPreferences/components/RegionTab.tsx:175
msgid "Formato de números"
msgstr "Formato de números"

#: src/features/reports2/components/createModal/steps/step3/3-FormatAndRecipients.tsx:205
msgid "Formato para el reporte"
msgstr "Formato para el reporte"

#: src/features/reports2/components/createModal/steps/step3/3-FormatAndRecipients.tsx:198
#: src/features/reports2/components/createModal/steps/step5/ReportSummary.tsx:90
#: src/features/reports2/utils/createModalStep.ts:27
msgid "Formato y destinatarios"
msgstr "Formato y destinatarios"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:189
msgid "Formato y estructura del archivo Excel requerido"
msgstr "Formato y estructura del archivo Excel requerido"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:586
msgid "Fórmula"
msgstr "Fórmula"

#: src/features/metricsViews/components/widgets/ContactSupportWidget.tsx:79
#: src/fsd/entities/dashboard-widget/ui/contact-support/contact-support-render.tsx:29
msgid "Formulario"
msgstr "Formulario"

#: src/features/users/components/UsersTable.tsx:101
msgid "Forzar reautenticación al usuario"
msgstr "Forzar reautenticación al usuario"

#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:283
#: src/features/users/components/modals/SaveUserModal.tsx:126
#: src/features/userSaveModal/components/UserSaveModal.tsx:338
msgid "Foto de perfil"
msgstr "Foto de perfil"

#: src/features/devices2/components/list/itemPanel/DeviceItemPicture.tsx:115
msgid "Foto del dispositivo"
msgstr "Foto del dispositivo"

#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:99
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:129
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:217
#: src/features/metricsViews/components/widgets/dgaReports/Info.legacy.tsx:50
#: src/features/metricsViews/components/widgets/dgaReports/Info.tsx:103
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:335
msgid "Frecuencia"
msgstr "Frecuencia"

#: src/features/devices2/components/DevicesHeader.tsx:149
#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:85
msgid "Frecuencia de envío"
msgstr "Frecuencia de envío"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:246
msgid "Frecuencia de envíos"
msgstr "Frecuencia de envíos"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:103
#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:242
msgid "Frecuencia de notificaciones"
msgstr "Frecuencia de notificaciones"

#: src/features/dga/components/modals/reports/ChartContent.tsx:65
msgid "Frecuencia de reporte cada una hora"
msgstr "Frecuencia de reporte cada una hora"

#: src/features/dga/components/modals/reports/ChartContent.tsx:69
msgid "Frecuencia de reporte diaria"
msgstr "Frecuencia de reporte diaria"

#: src/features/dga/components/modals/reports/ChartContent.tsx:77
msgid "Frecuencia de reporte mensual"
msgstr "Frecuencia de reporte mensual"

#: src/features/dga/components/modals/reports/ChartContent.tsx:73
msgid "Frecuencia de reporte semanal"
msgstr "Frecuencia de reporte semanal"

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:250
msgid "Frecuencia para volver a enviar notificaciones"
msgstr "Frecuencia para volver a enviar notificaciones"

#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:86
msgid "Frecuencia: {0}"
msgstr "Frecuencia: {0}"

#: src/fsd/shared/ui/format/units.ts:85
#: src/utils/units.ts:142
msgid "ft"
msgstr "ft"

#: src/fsd/shared/ui/format/units.ts:139
#: src/utils/units.ts:196
msgid "ft/s"
msgstr "ft/s"

#: src/fsd/shared/ui/format/units.ts:112
#: src/utils/units.ts:169
msgid "ft³"
msgstr "ft³"

#: src/features/audit/utils/parseProperty.ts:27
msgid "fuente"
msgstr "fuente"

#. Origen de un evento en un dispositivo
#: src/features/devicesAnalysis/components/panel/Chart.tsx:282
msgctxt "source"
msgid "Fuente"
msgstr "Fuente"

#: src/features/events/components/HeaderTable.tsx:35
msgid "Fuente"
msgstr "Fuente"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:20
msgid "Fuente de alimentación"
msgstr "Fuente de alimentación"

#: src/features/events/components/EventsFilter.tsx:20
msgid "Fuente de evento"
msgstr "Fuente de evento"

#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:296
msgid "Fuera"
msgstr "Fuera"

#: src/utils/attributes/deviceOperationalState.ts:84
msgid "Fuera de servicio"
msgstr "Fuera de servicio"

#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:291
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-view.tsx:192
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:329
msgid "Fuera de un tablero no hay datos de la compuerta."
msgstr "Fuera de un tablero no hay datos de la compuerta."

#: src/utils/alertConfiguration.ts:28
#: src/utils/alerts.ts:14
msgid "Fuera del rango {0}-{1} {2}"
msgstr "Fuera del rango {0}-{1} {2}"

#: src/features/metricsViews/components/widgets/configuredAlerts/index.tsx:67
msgid "Fuera del rango {min}-{max}"
msgstr "Fuera del rango {min}-{max}"

#: src/fsd/entities/dashboard-widget/model/alert-threshold.ts:33
msgid "Fuera del rango {min}-{max} {u}"
msgstr "Fuera del rango {min}-{max} {u}"

#: src/fsd/pages/dashboards/ui/canvas/canvas.tsx:586
msgid "fuera del tamaño sugerido"
msgstr "fuera del tamaño sugerido"

#: src/fsd/app/locale/au-labels.ts:106
msgid "Función de agregación"
msgstr "Función de agregación"

#: src/fsd/shared/ui/format/units.ts:107
#: src/utils/units.ts:164
msgid "gal"
msgstr "gal"

#: src/fsd/shared/ui/format/units.ts:28
#: src/utils/units.ts:85
msgid "gal/s"
msgstr "gal/s"

#: src/fsd/shared/ui/format/units.ts:108
#: src/utils/units.ts:165
msgid "galón"
msgstr "galón"

#: src/fsd/shared/ui/format/units.ts:44
#: src/utils/units.ts:101
msgid "galón por día"
msgstr "galón por día"

#: src/fsd/shared/ui/format/units.ts:39
#: src/utils/units.ts:96
msgid "galón por hora"
msgstr "galón por hora"

#: src/fsd/shared/ui/format/units.ts:34
#: src/utils/units.ts:91
msgid "galón por minuto"
msgstr "galón por minuto"

#: src/fsd/shared/ui/format/units.ts:169
#: src/utils/units.ts:226
msgid "galón por minuto por acción"
msgstr "galón por minuto por acción"

#: src/fsd/shared/ui/format/units.ts:29
#: src/utils/units.ts:86
msgid "galón por segundo"
msgstr "galón por segundo"

#: src/features/reports2/components/HeaderButtons.tsx:22
msgid "Genera reportes de datos a partir de un dispositivo determinado o de todos los dispositivos (equipos capta o integraciones)."
msgstr "Genera reportes de datos a partir de un dispositivo determinado o de todos los dispositivos (equipos capta o integraciones)."

#: src/features/metricsViews/components/ExportHeader.tsx:61
msgid "Generado"
msgstr "Generado"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:328
#: src/features/deviceConfiguration/data/sectionFields.ts:40
#: src/features/deviceConfiguration/data/sectionInputs.ts:38
#: src/features/deviceConfigurationModal/components/DeviceConfigurationModal.tsx:67
#: src/features/deviceDataConfigurationModal/components/DeviceDataConfigurationModal.tsx:70
#: src/features/deviceProfile/components/DeviceProfile.tsx:60
#: src/features/dga/components/modals/UpdateDGAConfigurationModal.tsx:76
msgid "General"
msgstr "General"

#: src/features/metricsViews/components/MetricsView.tsx:691
msgid "Generando la imagen del tablero…"
msgstr "Generando la imagen del tablero…"

#: src/features/reports2/components/DownloadReportTemplateModal.tsx:62
#: src/features/userSaveModal/components/UserSaveModal.tsx:436
msgid "Generar"
msgstr "Generar"

#: src/features/api/components/ApiUsers.tsx:24
#: src/features/api/components/mainMenu/MainMenuApiCapta.tsx:27
msgid "Generar Credencial API"
msgstr "Generar Credencial API"

#: src/features/reports2/components/HeaderButtons.tsx:29
msgid "Generar nuevo reporte"
msgstr "Generar nuevo reporte"

#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:163
#: src/features/reports2/components/createModal/CreateReportModal.tsx:71
#: src/features/reports2/components/createModal/steps/common.tsx:138
#: src/features/reports2/components/DownloadReportTemplateModal.tsx:75
msgid "Generar reporte"
msgstr "Generar reporte"

#: src/features/reports2/components/HeaderButtons.tsx:20
msgid "Generar un nuevo reporte"
msgstr "Generar un nuevo reporte"

#: src/fsd/shared/ui/format/units.ts:43
#: src/utils/units.ts:100
msgid "GPD"
msgstr "GPD"

#: src/fsd/shared/ui/format/units.ts:38
#: src/utils/units.ts:95
msgid "GPH"
msgstr "GPH"

#: src/fsd/shared/ui/format/units.ts:33
#: src/utils/units.ts:90
msgid "GPM"
msgstr "GPM"

#: src/fsd/entities/dashboard-widget/ui/format/unit-symbol.ts:36
#: src/fsd/shared/ui/format/units.ts:168
#: src/utils/units.ts:225
msgid "GPM/acc"
msgstr "GPM/acc"

#: src/features/reports2/components/versionSwitch/FeedbackDialog.tsx:92
msgid "Gracias por tu comentario, nos ayuda a mejorar."
msgstr "Gracias por tu comentario, nos ayuda a mejorar."

#: src/features/reports2/components/versionSwitch/SuggestionFab.tsx:59
msgid "Gracias por tu sugerencia."
msgstr "Gracias por tu sugerencia."

#: src/fsd/shared/ui/format/units.ts:181
#: src/utils/units.ts:238
msgid "grado"
msgstr "grado"

#: src/features/metricsViews/utils/widgetTypeCatalog.ts:25
#: src/fsd/entities/dashboard-widget/ui/chart/chart-view.tsx:156
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:11
msgid "Gráfico"
msgstr "Gráfico"

#: src/features/devices2/components/list/DGAItem.tsx:97
#: src/features/devices2/components/list/itemPanel/SMAItemMenu.tsx:86
#: src/fsd/pages/dga-reports/ui/device-detail.tsx:32
msgid "Gráfico de reportes"
msgstr "Gráfico de reportes"

#: src/features/dga/components/modals/reports/ChartFallback.tsx:14
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:17
msgid "Gráfico de reportes DGA"
msgstr "Gráfico de reportes DGA"

#: src/features/dga/components/modals/reports/ChartContent.tsx:97
msgid "Gráfico de reportes DGA {0}"
msgstr "Gráfico de reportes DGA {0}"

#: src/features/sma/components/SmaSuccessTableModal.tsx:128
msgid "Gráfico de reportes SMA"
msgstr "Gráfico de reportes SMA"

#: src/features/sma/components/SmaSuccessTableModal.tsx:72
msgid "Gráfico de reportes SMA {0}"
msgstr "Gráfico de reportes SMA {0}"

#: src/features/metricsViews/utils/genericWidgetTypes.ts:70
msgid "Gráfico reportes DGA"
msgstr "Gráfico reportes DGA"

#: src/features/controlCenter/components/panel/CheckboxList.tsx:33
msgid "Gráficos de energía"
msgstr "Gráficos de energía"

#: src/fsd/entities/dashboard-widget/ui/button/button-editor.tsx:22
#: src/fsd/pages/widget-catalog/model/examples.ts:395
msgid "Grande"
msgstr "Grande"

#: src/components/ColorPicker/palettes.ts:46
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:44
msgid "Gris"
msgstr "Gris"

#: src/components/ColorPicker/palettes.ts:47
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:45
msgid "Gris azulado"
msgstr "Gris azulado"

#: src/features/standardDesign/components/accessRelationManager/AccessRelationManagerModal.tsx:255
msgid "Guardando..."
msgstr "Guardando..."

#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:224
#: src/fsd/pages/dga-reports/ui/report-problem-dialog.tsx:112
msgid "Guardando…"
msgstr "Guardando…"

#: src/components/modal/ModalActions.tsx:116
#: src/features/billing/components/DueDate.tsx:111
#: src/features/billing/components/modals/PaymentsFileManager.tsx:121
#: src/features/billing/components/modals/ServiceFileManager.tsx:117
#: src/features/billing/components/table/ProjectsTable.tsx:223
#: src/features/changeSupportStatus/components/ChangeSupportStatus.tsx:158
#: src/features/changeTagsDevice/components/ChangeTagsDevice.tsx:130
#: src/features/collections/components/modals/UpdateCollectionModal.tsx:217
#: src/features/deviceCommands/components/calendar/UpdateCommandKeyDialog.tsx:82
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LevelCalibrationForm.tsx:143
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleCalibrationForm.tsx:166
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:550
#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:199
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:272
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:385
#: src/features/deviceSupport/components/FieldsConfig.tsx:117
#: src/features/deviceSupport/components/FilterAdvance.tsx:229
#: src/features/deviceSupport/components/FilterConfig.tsx:126
#: src/features/homeAmaru/components/shared/UpdateMyCollectionModal.tsx:182
#: src/features/metricsViews/components/MetricsView.tsx:605
#: src/features/organizationAccess/components/OrganizationAccess.tsx:166
#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:283
#: src/features/organizationPreferences/components/InterfaceTab.tsx:123
#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:188
#: src/features/reports/components/creationSection/EditReportTemplateDialog.tsx:167
#: src/features/reports2/components/createModal/steps/common.tsx:138
#: src/features/userPreferences/components/InterfaceTab.tsx:121
#: src/features/userPreferences/components/RegionTab.tsx:322
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:460
#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:224
#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:133
msgid "Guardar"
msgstr "Guardar"

#: src/features/alertsConfiguration/components/DialogUsersNotifications.tsx:195
#: src/features/billing/components/payments/PaymentSummary.tsx:168
#: src/features/dgaTicket/components/DgaTicketModal.tsx:378
msgid "Guardar cambios"
msgstr "Guardar cambios"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:432
msgid "Guardar curva"
msgstr "Guardar curva"

#: src/fsd/pages/dashboards/ui/save-loss-dialog.tsx:70
msgid "Guardar igual"
msgstr "Guardar igual"

#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:196
msgid "Guardar y Crear Reporte"
msgstr "Guardar y Crear Reporte"

#: src/features/preferencesCommon/components/UpdatePreferredUnitsForm.tsx:104
#: src/features/preferencesCommon/components/UpdateVisibleUnitsForm.tsx:56
#: src/features/preferencesCommon/components/UpdateVisibleUnitsForm.tsx:66
msgid "Ha ocurrido un error al actualizar"
msgstr "Ha ocurrido un error al actualizar"

#: src/features/api/components/dialogs/EditApiUserDialog.tsx:38
msgid "Ha ocurrido un error al actualizar los permisos"
msgstr "Ha ocurrido un error al actualizar los permisos"

#: src/features/api/components/dialogs/DisableApiUserDialog.tsx:42
msgid "Ha ocurrido un error al deshabilitar la credencial."
msgstr "Ha ocurrido un error al deshabilitar la credencial."

#: src/features/reports2/components/createModal/useCreateForm.ts:174
msgid "Ha ocurrido un error al ejecutar el reporte"
msgstr "Ha ocurrido un error al ejecutar el reporte"

#: src/features/reports2/components/createModal/useCreateForm.ts:237
msgid "Ha ocurrido un error al guardar el reporte"
msgstr "Ha ocurrido un error al guardar el reporte"

#: src/features/api/components/dialogs/EnableApiUserDialog.tsx:44
msgid "Ha ocurrido un error al habilitar la credencial"
msgstr "Ha ocurrido un error al habilitar la credencial"

#: src/features/reports2/components/createModal/useCreateForm.ts:305
msgid "Ha ocurrido un error al procesar el reporte"
msgstr "Ha ocurrido un error al procesar el reporte"

#: src/features/gateAdministration/components/gateMovementBanner/LegacyMovementRow.tsx:40
msgid "ha sido detenida"
msgstr "ha sido detenida"

#: src/features/gateAdministration/components/gateMovementBanner/LegacyMovementRow.tsx:40
msgid "ha terminado de moverse"
msgstr "ha terminado de moverse"

#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:108
msgid "Habilitada"
msgstr "Habilitada"

#: src/features/audit/utils/parseProperty.ts:14
msgid "habilitado"
msgstr "habilitado"

#: src/features/metricsViews/components/EditViewModal.tsx:149
#: src/features/metricsViews/components/MetricsViewList.tsx:141
msgid "Habilitado"
msgstr "Habilitado"

#: src/features/api/components/CaptaApiUsersList.tsx:187
#: src/features/api/components/dialogs/EnableApiUserDialog.tsx:114
#: src/features/dga/components/modals/DgaOrganizationAccessWarning.tsx:96
#: src/features/organizationAccess/components/OrganizationAccessTable.tsx:36
msgid "Habilitar"
msgstr "Habilitar"

#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:102
#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:103
msgid "Habilitar alerta"
msgstr "Habilitar alerta"

#: src/features/deviceSupport/components/FieldsConfig.tsx:69
msgid "Habilitar Campos"
msgstr "Habilitar Campos"

#: src/features/api/components/dialogs/EnableApiUserDialog.tsx:70
msgid "Habilitar credencial API"
msgstr "Habilitar credencial API"

#: src/features/audit/utils/getActionTypeOptions.ts:265
msgid "Habilitar Envío de DGA"
msgstr "Habilitar Envío de DGA"

#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:68
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:153
msgid "Habilitar envíos DGA"
msgstr "Habilitar envíos DGA"

#: src/features/deviceSupport/components/FilterConfig.tsx:81
msgid "Habilitar Filtros"
msgstr "Habilitar Filtros"

#: src/features/audit/utils/getDisplayNameActionType.ts:446
msgid "habilitó el envío de DGA"
msgstr "habilitó el envío de DGA"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:43
msgid "Hace {parts}"
msgstr "Hace {parts}"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:20
msgid "Hace 24 horas"
msgstr "Hace 24 horas"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:19
msgid "Hace 6 horas"
msgstr "Hace 6 horas"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:21
msgid "Hace 7 días"
msgstr "Hace 7 días"

#: src/features/deviceConfiguration/data/sectionInputs.ts:278
msgid "hardwareConfiguration.IMEI"
msgstr "hardwareConfiguration.IMEI"

#: src/fsd/shared/ui/route-arrow/route-arrow.tsx:11
msgid "hasta"
msgstr "hasta"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:246
#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:219
#: src/features/dateTimeRangePicker/components/DateTimeRangePicker.tsx:105
#: src/features/dga/components/modals/reports/SendReportsByEmailModal.tsx:89
#: src/features/sma/components/SendReportsByEmailModal.tsx:102
#: src/fsd/app/locale/au-labels.ts:98
msgid "Hasta"
msgstr "Hasta"

#: src/features/standardDesign/components/DateTimeRangePicker/components/AbsoluteDatePicker.tsx:62
msgid "Hasta (vacío para 'ahora')"
msgstr "Hasta (vacío para 'ahora')"

#: src/features/alertsNotificationsHistory/components/Filters.tsx:129
msgid "Hasta {0}"
msgstr "Hasta {0}"

#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:99
msgid "Hasta el cierre"
msgstr "Hasta el cierre"

#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-view.tsx:150
msgid "Hay más reportes esperando la validación de la DGA que validados."
msgstr "Hay más reportes esperando la validación de la DGA que validados."

#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-view.tsx:140
msgid "Hay reportes que no llegaron a la DGA en 7 días."
msgstr "Hay reportes que no llegaron a la DGA en 7 días."

#: src/fsd/pages/dashboards/ui/layout-warnings/warning-text.ts:16
msgid "Hay una celda guardada de un widget que no está en el tablero; no se muestra."
msgstr "Hay una celda guardada de un widget que no está en el tablero; no se muestra."

#: src/features/deviceConfiguration/components/TriggerConfigUpdateModal.tsx:128
msgid "Hay una ejecución en curso. No es posible disparar una nueva actualización hasta que finalice."
msgstr "Hay una ejecución en curso. No es posible disparar una nueva actualización hasta que finalice."

#: src/features/controlCenter/components/UpgradeBanner.tsx:22
msgid "Hay una nueva versión del Centro de Control disponible"
msgstr "Hay una nueva versión del Centro de Control disponible"

#: src/fsd/shared/ui/format/units.ts:103
#: src/utils/units.ts:160
msgid "hectómetro cúbico"
msgstr "hectómetro cúbico"

#: src/features/debtsAlert/components/DebtsAlertModal.tsx:72
#: src/features/debtsAlert/components/DebtsAlertPopover.tsx:62
msgid "Hemos detectado que la cuenta de AMARU presenta un saldo pendiente. Favor contactar al servicio de post-venta de Capta Hydro:"
msgstr "Hemos detectado que la cuenta de AMARU presenta un saldo pendiente. Favor contactar al servicio de post-venta de Capta Hydro:"

#: src/features/alertsNotificationsHistory/components/AlertsNotificationsHistory.tsx:50
#: src/pages/alerts/history.tsx:9
msgid "Historial de alertas"
msgstr "Historial de alertas"

#: src/features/deviceConfiguration/components/ConfigurationFileHistoryModal.tsx:97
msgid "Historial de archivos de configuración"
msgstr "Historial de archivos de configuración"

#: src/components/optionsMenu/dialogs/movementHistory/GateMovementHistory.tsx:17
msgid "Historial de movimientos"
msgstr "Historial de movimientos"

#: src/pages/billing/PaymentsView.tsx:9
msgid "Historial de Pagos"
msgstr "Historial de Pagos"

#: src/features/gateOperationModal/components/PanelChart.tsx:32
#: src/fsd/features/gate-movements/ui/panel/position-chart.tsx:62
msgid "Histórico de posición"
msgstr "Histórico de posición"

#: src/fsd/shared/ui/format/units.ts:102
#: src/utils/units.ts:159
msgid "hm³"
msgstr "hm³"

#: src/pages/authentication/index.tsx:81
msgid "Hola {0} {1}, hemos enviado un correo a tu email con el código de Autenticación en dos pasos, debes ingresar el código para iniciar sesión de forma segura. En ocasiones los correos se encuentra en la capeta SPAM, no olvides revisarla."
msgstr "Hola {0} {1}, hemos enviado un correo a tu email con el código de Autenticación en dos pasos, debes ingresar el código para iniciar sesión de forma segura. En ocasiones los correos se encuentra en la capeta SPAM, no olvides revisarla."

#: src/pages/home-amaru/index.tsx:9
msgid "Home AMARU"
msgstr "Home AMARU"

#: src/features/audit/utils/parseProperty.ts:82
msgid "homologado"
msgstr "homologado"

#: src/features/deviceConfiguration/data/sectionFields.ts:278
#: src/features/deviceConfiguration/data/sectionInputs.ts:305
msgid "Homologado"
msgstr "Homologado"

#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:143
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:208
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:296
msgid "Hora"
msgstr "Hora"

#: src/features/dateTimeRangePicker/components/DateTimeRangePicker.tsx:139
msgid "Hora desde"
msgstr "Hora desde"

#: src/fsd/pages/dashboards/ui/report-problem/report-problem-dialog.tsx:136
msgid "Hora en {timeZone}."
msgstr "Hora en {timeZone}."

#: src/features/dateTimeRangePicker/components/DateTimeRangePicker.tsx:139
msgid "Hora hasta"
msgstr "Hora hasta"

#: src/features/deviceSupport/components/SupportTableBody.tsx:210
msgid "Horas"
msgstr "Horas"

#: src/features/deviceProfile/components/page/Support.tsx:170
#: src/features/deviceSupport/data/column.ts:101
msgid "Horas con datos"
msgstr "Horas con datos"

#: src/features/deviceProfile/components/page/modularComponents/index.tsx:33
msgid "Housing"
msgstr "Housing"

#: src/features/metricsViews/utils/dataTypes.ts:168
#: src/fsd/entities/dashboard-widget/ui/data/data-view.tsx:49
msgid "hoy"
msgstr "hoy"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:63
#: src/fsd/features/gate-movements/ui/list/movement-list.tsx:12
msgid "Hoy"
msgstr "Hoy"

#: src/fsd/app/locale/au-labels.ts:87
#: src/fsd/app/locale/au-labels.ts:90
msgid "Hoy, {dateText}"
msgstr "Hoy, {dateText}"

#: src/features/createDevice/hooks/useCreateDeviceForm.ts:40
msgid "Hubo en error al crear dispositivo"
msgstr "Hubo en error al crear dispositivo"

#: src/features/gateAdministration/components/MoveGate.tsx:146
msgid "Hubo un error"
msgstr "Hubo un error"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:70
msgid "Hubo un error al activar el usuario"
msgstr "Hubo un error al activar el usuario"

#: src/features/devicesOrderModal/components/DevicesOrder.tsx:211
#: src/features/devicesOrderModal/components/DevicesOrder.tsx:235
msgid "Hubo un error al actualizar el orden de los dispositivos"
msgstr "Hubo un error al actualizar el orden de los dispositivos"

#: src/features/publicOrganizationSettingsModal/components/PublicOrganizationSettingsModal.tsx:67
msgid "Hubo un error al actualizar la vista pública"
msgstr "Hubo un error al actualizar la vista pública"

#: src/features/deviceConfigurationModal/components/gateTab/alarm/UpdateAlarm.tsx:48
msgid "Hubo un error al actualizar: {0}"
msgstr "Hubo un error al actualizar: {0}"

#: src/features/api/components/ApiUsersList.tsx:31
#: src/features/api/components/CaptaApiUsersList.tsx:53
msgid "Hubo un error al cargar sus credenciales de API"
msgstr "Hubo un error al cargar sus credenciales de API"

#: src/features/alertsConfigurationV2/hooks/useDeleteAlertConfigurations.ts:27
msgid "Hubo un error al desactivar las alertas"
msgstr "Hubo un error al desactivar las alertas"

#: src/features/deviceAlertsModal/components/disableAlertsModal/index.tsx:23
msgid "Hubo un error al desactivar las alertas: {0}"
msgstr "Hubo un error al desactivar las alertas: {0}"

#: src/features/reports/components/creationSection/EditReportTemplateDialog.tsx:61
msgid "Hubo un error al editar la plantilla. Intente de nuevo."
msgstr "Hubo un error al editar la plantilla. Intente de nuevo."

#: src/features/api/components/dialogs/DeleteApiUserDialog.tsx:44
msgid "Hubo un error al eliminar la credencial."
msgstr "Hubo un error al eliminar la credencial."

#: src/features/reports2/components/DeleteReportTemplateModal.tsx:38
msgid "Hubo un error al eliminar la plantilla"
msgstr "Hubo un error al eliminar la plantilla"

#: src/features/reports2/components/DownloadReportTemplateModal.tsx:40
msgid "Hubo un error al generar el reporte"
msgstr "Hubo un error al generar el reporte"

#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:28
msgid "Hubo un error al generar la url de activación"
msgstr "Hubo un error al generar la url de activación"

#: src/features/login/components/Login.tsx:67
msgid "Hubo un error al iniciar sesión. Por favor, inténtelo de nuevo. Si el problema continúa, por favor contacte soporte."
msgstr "Hubo un error al iniciar sesión. Por favor, inténtelo de nuevo. Si el problema continúa, por favor contacte soporte."

#: src/features/resendCredentialsModal/components/ResendCredentialsModal.tsx:45
msgid "Hubo un error al reenviar las credenciales."
msgstr "Hubo un error al reenviar las credenciales."

#: src/features/dga/components/modals/DGAReportsRetryModal.tsx:46
msgid "Hubo un error al republicar los datos"
msgstr "Hubo un error al republicar los datos"

#: src/features/reports/components/creationSection/CreateReportDialog.tsx:47
msgid "Hubo un error en la solicitud del reporte, por favor intente nuevamente"
msgstr "Hubo un error en la solicitud del reporte, por favor intente nuevamente"

#: src/features/reports/components/ReportHistory.tsx:127
#: src/features/reports2/components/reportHistoryModal/ReportHistory.tsx:132
#: src/features/reports2/components/reportHistoryModal/ReportHistory.tsx:138
msgid "Hubo un error obteniendo el archivo"
msgstr "Hubo un error obteniendo el archivo"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:58
#: src/features/billing/components/modals/PaymentsFileManager.tsx:156
#: src/features/billing/components/modals/ServiceFileManager.tsx:66
#: src/features/billing/components/modals/ServiceFileManager.tsx:73
#: src/features/billing/components/modals/ServiceFileManager.tsx:152
#: src/features/billing/components/modals/ServiceFileManager.tsx:268
msgid "Hubo un problema al realizar la operación. Por favor, inténtelo nuevamente. Si el problema persiste, contacte al administrador."
msgstr "Hubo un problema al realizar la operación. Por favor, inténtelo nuevamente. Si el problema persiste, contacte al administrador."

#: src/features/audit/utils/parseProperty.ts:145
#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:223
#: src/features/deviceConfiguration/data/sectionFields.ts:343
#: src/features/deviceConfiguration/data/sectionInputs.ts:358
msgid "ICCID"
msgstr "ICCID"

#: src/features/collections/utils/filterOptions.ts:26
#: src/features/deviceSupport/data/filter.ts:9
msgid "ICN"
msgstr "ICN"

#: src/features/metricsViews/components/forms/ButtonWidgetForm.tsx:97
msgid "Icono"
msgstr "Icono"

#: src/features/alertsConfigurationV3/components/AlertSummaryCard.tsx:34
#: src/features/alertsConfigurationV3/components/UnconfiguredDeviceCard.tsx:14
#: src/features/audit/utils/parseProperty.ts:19
#: src/features/billing/components/table/DevicesTable.tsx:148
#: src/features/deviceConfiguration/data/tableColumns.ts:4
#: src/features/deviceSupport/data/column.ts:17
#: src/features/deviceSupport/data/fields.ts:7
#: src/features/gateCommon/components/historyModal/index.tsx:216
#: src/fsd/features/gate-movements/ui/history/history-table.tsx:149
msgid "ID"
msgstr "ID"

#: src/features/collections/utils/filterOptions.ts:10
#: src/features/devices2/utils/getOrderByOptions.ts:17
#: src/features/gates/components/Gates.tsx:52
#: src/features/metricsViews/utils/getMetricsViewsOrderByOptions.ts:9
#: src/features/users/utils/filterOptions.ts:22
msgid "ID (Asc)"
msgstr "ID (Asc)"

#: src/features/devices2/utils/getOrderByOptions.ts:21
#: src/features/gates/components/Gates.tsx:53
#: src/features/metricsViews/utils/getMetricsViewsOrderByOptions.ts:13
#: src/features/users/utils/filterOptions.ts:29
msgid "ID (Desc)"
msgstr "ID (Desc)"

#: src/fsd/pages/dashboards/ui/board-header/board-switcher.tsx:161
#: src/fsd/pages/dashboards/ui/dashboards-page.tsx:61
msgid "ID {0}"
msgstr "ID {0}"

#: src/features/audit/utils/parseProperty.ts:105
msgid "ID de configuración"
msgstr "ID de configuración"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:394
msgid "ID de confirmación: {confirmationId}"
msgstr "ID de confirmación: {confirmationId}"

#: src/features/audit/utils/parseProperty.ts:44
msgid "ID de dispositivo"
msgstr "ID de dispositivo"

#: src/features/audit/utils/parseProperty.ts:23
msgid "ID de dispositivo lógico"
msgstr "ID de dispositivo lógico"

#: src/features/audit/utils/parseProperty.ts:93
#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:48
msgid "ID de Emnify"
msgstr "ID de Emnify"

#: src/features/audit/utils/parseProperty.ts:31
msgid "ID de ICN"
msgstr "ID de ICN"

#: src/features/audit/utils/parseProperty.ts:142
msgid "id de la cuenta"
msgstr "id de la cuenta"

#: src/features/audit/utils/parseProperty.ts:57
msgid "ID de modbus de flujo"
msgstr "ID de modbus de flujo"

#: src/features/audit/utils/parseProperty.ts:49
msgid "ID de modbus de nivel"
msgstr "ID de modbus de nivel"

#: src/features/audit/utils/parseProperty.ts:53
msgid "ID de modbus de velocidad"
msgstr "ID de modbus de velocidad"

#: src/features/audit/utils/parseProperty.ts:17
#: src/features/audit/utils/parseProperty.ts:25
msgid "ID de organización"
msgstr "ID de organización"

#: src/features/audit/utils/parseProperty.ts:131
msgid "ID de rol"
msgstr "ID de rol"

#: src/features/dgaTicket/components/DgaTicketModal.tsx:158
#: src/features/dgaTicket/components/DgaTicketModal.tsx:334
msgid "Id de ticket"
msgstr "Id de ticket"

#: src/features/audit/utils/parseProperty.ts:106
msgid "ID de usuario"
msgstr "ID de usuario"

#: src/features/audit/utils/parseProperty.ts:24
msgid "ID del nodo"
msgstr "ID del nodo"

#: src/features/deviceCommands/components/DeviceCommandsHistoryTable.tsx:30
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/AccessorsTable.tsx:25
msgid "ID dispositivo"
msgstr "ID dispositivo"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:94
#: src/features/billing/components/modals/ServiceFileManager.tsx:94
#: src/features/billing/components/table/ServicesTable.tsx:60
msgid "ID Dispositivo"
msgstr "ID Dispositivo"

#: src/features/deviceConfiguration/data/sectionFields.ts:324
#: src/features/deviceConfiguration/data/sectionInputs.ts:331
msgid "ID Emnify"
msgstr "ID Emnify"

#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:120
msgid "ID en firmware {firmwareId}"
msgstr "ID en firmware {firmwareId}"

#: src/features/gateOperationModal/components/dataComponents/MovementSummaryAttribute.tsx:18
msgid "ID en firmware {id}"
msgstr "ID en firmware {id}"

#: src/features/billing/components/payments/PaymentsTable.tsx:42
msgid "ID proyecto"
msgstr "ID proyecto"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:84
#: src/features/billing/components/modals/ServiceFileManager.tsx:93
#: src/features/billing/components/table/DevicesTable.tsx:151
#: src/features/billing/components/table/ServicesTable.tsx:59
msgid "ID Proyecto"
msgstr "ID Proyecto"

#: src/features/deviceCommands/components/standard/DebugModeInformation.tsx:71
msgid "Ideal para analizar dispositivos en terreno."
msgstr "Ideal para analizar dispositivos en terreno."

#: src/features/organizationDelete/components/DeleteOrganization.tsx:238
msgid "Identificador"
msgstr "Identificador"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:205
msgid "Identificador único de la factura."
msgstr "Identificador único de la factura."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:215
#: src/features/billing/components/modals/ServiceFileManager.tsx:178
msgid "Identificador único del dispositivo asociado al servicio."
msgstr "Identificador único del dispositivo asociado al servicio."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:203
msgid "Identificador único del proyecto asociado a la factura."
msgstr "Identificador único del proyecto asociado a la factura."

#: src/features/billing/components/modals/ServiceFileManager.tsx:180
msgid "Identificador único del proyecto existente relacionado con cada servicio."
msgstr "Identificador único del proyecto existente relacionado con cada servicio."

#: src/features/userPreferences/components/RegionTab.tsx:137
msgid "Idioma"
msgstr "Idioma"

#: src/features/userPreferences/hooks/useTabs.tsx:21
msgid "Idioma y región"
msgstr "Idioma y región"

#: src/fsd/app/locale/language-select.tsx:39
msgid "Idioma: {current}"
msgstr "Idioma: {current}"

#: src/features/metricsViews/components/widgets/configuredAlerts/index.tsx:65
msgid "Igual a {value}"
msgstr "Igual a {value}"

#: src/features/audit/utils/parseProperty.ts:42
msgid "imagen"
msgstr "imagen"

#: src/features/collections/components/CollectionVisualRepresentationFields.tsx:55
#: src/features/createMyCollectionModal/components/CreateMyCollectionModal.tsx:110
#: src/features/homeAmaru/components/shared/UpdateMyCollectionModal.tsx:118
#: src/features/metricsViews/utils/widgetTypeCatalog.ts:30
#: src/fsd/entities/dashboard-widget/ui/image/image-editor.tsx:64
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:21
msgid "Imagen"
msgstr "Imagen"

#: src/components/ImageUploadField.tsx:174
msgid "Imagen actual"
msgstr "Imagen actual"

#: src/features/billing/components/modals/ServiceFileManager.tsx:205
msgid "Imagen con ejemplo"
msgstr "Imagen con ejemplo"

#: src/features/userProfile/components/UserProfile.tsx:168
#: src/features/userProfile/components/UserProfile.tsx:232
msgid "Imagen de organización"
msgstr "Imagen de organización"

#: src/components/ImagePreviewModal.tsx:25
#: src/features/deviceProfile/components/modal/Info.tsx:55
#: src/features/deviceProfile/components/modal/Info.tsx:70
#: src/features/deviceProfile/components/page/Header.tsx:44
#: src/features/userMenu/components/UserMenu.tsx:69
#: src/features/userMenu/components/UserMenu.tsx:94
#: src/features/userProfile/components/UserProfile.tsx:79
msgid "Imagen de perfil"
msgstr "Imagen de perfil"

#: src/components/OrganizationAvatar.tsx:54
#: src/components/UserAvatar.tsx:33
msgid "Imagen de perfil de usuario"
msgstr "Imagen de perfil de usuario"

#: src/features/collectionCommon/components/CollectionImageUploadField.tsx:26
msgid "Imagen de portada (vista Mosaico)"
msgstr "Imagen de portada (vista Mosaico)"

#: src/components/PicturePreview.tsx:95
msgid "Imagen de telemetría"
msgstr "Imagen de telemetría"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:397
msgid "Imagen del dispositivo"
msgstr "Imagen del dispositivo"

#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:52
#: src/features/metricsViews/components/widgets/ImageWidget.tsx:48
#: src/fsd/entities/dashboard-widget/ui/image/image-render.tsx:66
#: src/fsd/pages/widget-catalog/model/examples.ts:431
msgid "Imagen no disponible"
msgstr "Imagen no disponible"

#: src/features/metricsViews/components/ExportViewButton.tsx:47
msgid "Imagen PNG"
msgstr "Imagen PNG"

#: src/features/audit/utils/parseProperty.ts:144
msgid "imei"
msgstr "imei"

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:236
#: src/features/deviceConfiguration/data/sectionFields.ts:257
msgid "IMEI"
msgstr "IMEI"

#: src/fsd/shared/ui/format/units.ts:80
#: src/utils/units.ts:137
msgid "in"
msgstr "in"

#: src/features/metricsViews/components/widgets/configuredAlerts/index.tsx:142
msgid "Inactiva"
msgstr "Inactiva"

#: src/features/metricsViews/components/forms/ConfiguredAlertsForm.tsx:28
msgid "Inactivas"
msgstr "Inactivas"

#: src/features/changeOperationalState/components/AfterUpdateTasksModal.tsx:96
#: src/features/devices2/utils/featuresFilter.ts:67
#: src/features/users/utils/filterOptions.ts:114
msgid "Inactivo"
msgstr "Inactivo"

#: src/features/integrations/components/integrationBarChart/index.tsx:82
msgid "Incidencias"
msgstr "Incidencias"

#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:206
msgid "Indica las relaciones que deseas agregar"
msgstr "Indica las relaciones que deseas agregar"

#: src/fsd/pages/dashboards/ui/report-problem/report-problem-dialog.tsx:139
msgid "Indica una fecha y hora válidas."
msgstr "Indica una fecha y hora válidas."

#: src/components/ColorPicker/palettes.ts:33
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:31
msgid "Índigo"
msgstr "Índigo"

#: src/features/integrations/utils/writeExecutionLogSeverityAttributes.ts:56
#: src/features/metricsViews/components/widgets/configuredAlerts/index.tsx:78
#: src/features/metricsViews/components/widgets/DataWidget.tsx:105
#: src/utils/attributes/metricAlertEvaluation.ts:27
msgid "Info"
msgstr "Info"

#: src/features/notifications/components/NotificationMessageViewModal.tsx:40
#: src/features/users/components/UsersTable.tsx:78
#: src/fsd/entities/dashboard-widget/model/data-sample.ts:111
#: src/fsd/entities/dashboard-widget/ui/data/data-view.tsx:39
msgid "Información"
msgstr "Información"

#: src/features/audit/utils/parseProperty.ts:28
msgid "información de fuente"
msgstr "información de fuente"

#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:71
msgid "Información de la validación"
msgstr "Información de la validación"

#: src/features/deviceCommands/components/calendar/ScheduleDetailsDialog.tsx:64
msgid "Información del Comando Programado"
msgstr "Información del Comando Programado"

#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:38
msgid "Información del equipo"
msgstr "Información del equipo"

#: src/features/alertsConfiguration/components/DialogConfirmationNotifications.tsx:107
#: src/features/alertsConfiguration/components/DialogUsersNotifications.tsx:107
#: src/features/deviceAlertsModal/components/notificationConfigurationTab/TableForm.tsx:175
msgid "Información del usuario"
msgstr "Información del usuario"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:113
msgid "Información DGA"
msgstr "Información DGA"

#: src/features/deviceSupport/data/column.ts:9
#: src/features/deviceSupport/data/column.ts:19
#: src/features/deviceSupport/data/column.ts:29
#: src/features/deviceSupport/data/column.ts:39
msgid "Información dispositivo"
msgstr "Información dispositivo"

#: src/features/alertsConfiguration/components/AlertTable.tsx:177
#: src/features/userProfile/components/UserProfile.tsx:107
#: src/features/userProfile/components/UserProfileSkeleton.tsx:43
msgid "Información general"
msgstr "Información general"

#: src/fsd/pages/dga-reports/ui/report-problem-dialog.tsx:101
msgid "Ingresa el ticket que abriste en la plataforma de la DGA."
msgstr "Ingresa el ticket que abriste en la plataforma de la DGA."

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:430
msgid "Ingresa una lista de números de lote. No es necesario que sean exactos; por ejemplo, al escribir \"68\", se mostrarán dispositivos con números de lote que contengan esa secuencia, como \"236849\"."
msgstr "Ingresa una lista de números de lote. No es necesario que sean exactos; por ejemplo, al escribir \"68\", se mostrarán dispositivos con números de lote que contengan esa secuencia, como \"236849\"."

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:224
msgid "Ingresa uno o más ICCID. Puedes ingresar valores parciales."
msgstr "Ingresa uno o más ICCID. Puedes ingresar valores parciales."

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:237
msgid "Ingresa uno o más IMEI. Puedes ingresar valores parciales."
msgstr "Ingresa uno o más IMEI. Puedes ingresar valores parciales."

#: src/features/metricsViews/components/widgets/DgaTicketsWidget.tsx:140
#: src/fsd/entities/dashboard-widget/ui/dga-tickets/dga-tickets-view.tsx:168
#: src/fsd/entities/dashboard-widget/ui/dga-tickets/dga-tickets-view.tsx:190
msgid "Ingresar en AMARU"
msgstr "Ingresar en AMARU"

#: src/features/metricsViews/components/widgets/DgaTicketsWidget.tsx:144
#: src/fsd/entities/dashboard-widget/ui/dga-tickets/dga-tickets-view.tsx:178
#: src/fsd/entities/dashboard-widget/ui/dga-tickets/dga-tickets-view.tsx:201
msgid "Ingresar en DGA"
msgstr "Ingresar en DGA"

#: src/fsd/pages/dga-reports/ui/device-row.tsx:85
#: src/fsd/pages/dga-reports/ui/report-problem-dialog.tsx:112
msgid "Ingresar ticket"
msgstr "Ingresar ticket"

#: src/features/api/components/dialogs/ResendApiCredentialsDialog.tsx:132
#: src/features/api/components/forms/FormSendCredentials.tsx:88
msgid "Ingrese un correo para enviar las credenciales"
msgstr "Ingrese un correo para enviar las credenciales"

#: src/features/api/components/dialogs/ResendApiCredentialsDialog.tsx:135
#: src/features/api/components/forms/FormSendCredentials.tsx:90
msgid "Ingrese un correo válido"
msgstr "Ingrese un correo válido"

#: src/features/deviceMenu/components/DeviceMenu.tsx:151
msgid "Ingreso manual de datos"
msgstr "Ingreso manual de datos"

#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:101
msgid "Iniciada <0/>"
msgstr "Iniciada <0/>"

#: src/features/gateCommon/components/historyModal/index.tsx:231
#: src/features/metricsViews/components/widgets/movementsTable/index.tsx:127
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:219
#: src/fsd/features/gate-movements/ui/history/history-table.tsx:159
msgid "Inicial → Final"
msgstr "Inicial → Final"

#: src/features/gateCommon/utils/gateMovementState.tsx:23
#: src/fsd/entities/gate/model/movement-state.ts:36
msgid "Inicializando"
msgstr "Inicializando"

#: src/features/gateOperationModal/components/dataComponents/MovementSummaryAttribute.tsx:113
#: src/features/gateOperationModal/components/dataComponents/OperationPositionData.tsx:92
msgid "Iniciando comunicación"
msgstr "Iniciando comunicación"

#: src/features/gateOperationModal/components/PanelOperation.tsx:220
msgid "Iniciando operación"
msgstr "Iniciando operación"

#: src/features/metricsViews/components/widgets/gateOperate/OperateButtons.tsx:190
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:153
msgid "Iniciar operación"
msgstr "Iniciar operación"

#: src/features/dga/components/modals/MassiveDGARetryModal.tsx:103
msgid "Iniciar reintento masivo"
msgstr "Iniciar reintento masivo"

#: src/pages/authentication/index.tsx:39
#: src/pages/authentication/index.tsx:74
msgid "Iniciar sesión"
msgstr "Iniciar sesión"

#: src/features/billing/components/payments/PaymentDetailsForm.tsx:184
#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:50
#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:53
#: src/features/dga/components/modals/DGAReportsRetryModal.tsx:115
#: src/features/organizationAccess/data/sections.ts:37
#: src/features/reports/components/ReportHistory.tsx:279
#: src/features/reports2/components/reportHistoryModal/ReportHistory.tsx:286
#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:199
#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:80
msgid "Inicio"
msgstr "Inicio"

#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:78
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:164
msgid "Inicio de envíos"
msgstr "Inicio de envíos"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:99
msgid "Inicio del Servicio"
msgstr "Inicio del Servicio"

#: src/features/gateOperationModal/components/dataComponents/MovementSummaryAttribute.tsx:91
msgid "Inicio no registrado"
msgstr "Inicio no registrado"

#: src/features/billing/components/modals/ServiceFileManager.tsx:174
msgid "Instrucciones para las columnas del archivo Excel"
msgstr "Instrucciones para las columnas del archivo Excel"

#: src/fsd/app/locale/au-labels.ts:112
msgid "int"
msgstr "int"

#: src/utils/devices/formatSourceColor.ts:23
#: src/utils/formatSource.ts:14
msgid "Integración"
msgstr "Integración"

#: src/pages/sma/index.tsx:9
msgid "Integración con SMA"
msgstr "Integración con SMA"

#: src/pages/dga.tsx:9
msgid "Integración con Software MEE - DGA"
msgstr "Integración con Software MEE - DGA"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:76
#: src/features/devices2/utils/getVisibleDeviceTypeOptions.ts:23
#: src/features/organizationAccess/data/sections.ts:41
#: src/pages/integrations/index.tsx:10
msgid "Integraciones"
msgstr "Integraciones"

#: src/fsd/app/locale/au-labels.ts:119
msgid "Integral"
msgstr "Integral"

#: src/utils/attributes/metricField.ts:347
msgid "intensidad de señal"
msgstr "intensidad de señal"

#: src/utils/i18n/getMetricDisplayName.ts:52
msgid "Intensidad de señal"
msgstr "Intensidad de señal"

#: src/features/organizationPreferences/hooks/useTabs.tsx:31
#: src/features/userPreferences/hooks/useTabs.tsx:63
msgid "Interfaz"
msgstr "Interfaz"

#: src/features/audit/utils/parseProperty.ts:168
msgid "internet satelital"
msgstr "internet satelital"

#: src/features/controlCenter2/components/devicesList/Footer.tsx:141
#: src/features/gateAdministration/components/index.tsx:552
#: src/features/reports2/components/ReportTemplatesTable.tsx:71
msgid "Intervalo"
msgstr "Intervalo"

#: src/features/controlCenter/components/window/Window.tsx:402
msgid "Intervalo (segundos)"
msgstr "Intervalo (segundos)"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarPollingInterval.tsx:46
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarPollingInterval.tsx:49
msgid "Intervalo de actualización automática"
msgstr "Intervalo de actualización automática"

#: src/utils/attributes/metricField.ts:221
msgid "intruso"
msgstr "intruso"

#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:89
#: src/features/alertsNotificationsHistory/utils/alertTypes.ts:16
#: src/utils/attributes/deviceAlertMetricName.ts:27
msgid "Intruso"
msgstr "Intruso"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:312
msgid "Invasivo"
msgstr "Invasivo"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LevelCalibrationForm.tsx:119
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LGCalibrationDisplay.tsx:99
msgid "Invertido"
msgstr "Invertido"

#: src/features/deviceConfiguration/data/sectionFields.ts:355
#: src/features/deviceConfiguration/data/sectionInputs.ts:373
msgid "IP"
msgstr "IP"

#: src/features/gates/components/list/GateListItemMetrics.tsx:50
#: src/features/gates/components/list/GateListItemMetrics.tsx:117
msgid "Ir a análisis de estaciones"
msgstr "Ir a análisis de estaciones"

#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:51
msgid "Ir a DGA ({0})"
msgstr "Ir a DGA ({0})"

#: src/fsd/pages/dga-reports/ui/device-list.tsx:90
msgid "Ir a la primera página"
msgstr "Ir a la primera página"

#: src/features/controlCenter/components/window/DeviceListItem.tsx:191
#: src/features/controlCenter2/components/devicesList/ListItem.tsx:246
msgid "Ir a vista de métricas"
msgstr "Ir a vista de métricas"

#: src/fsd/app/locale/au-labels.ts:79
msgid "Ir al mes anterior"
msgstr "Ir al mes anterior"

#: src/fsd/app/locale/au-labels.ts:80
msgid "Ir al mes siguiente"
msgstr "Ir al mes siguiente"

#: src/features/audit/utils/getDisplayNameEntity.ts:10
msgid "irrigación"
msgstr "irrigación"

#: src/features/deviceProfile/components/modal/Info.tsx:128
msgid "Irrigación"
msgstr "Irrigación"

#: src/fsd/entities/dashboard-widget/ui/text/text-editor.tsx:14
msgid "Izquierda"
msgstr "Izquierda"

#: src/fsd/entities/dashboard-widget/ui/image/image-editor.tsx:68
msgid "JPEG, PNG o WebP, hasta 5 MB. Se reduce antes de subir."
msgstr "JPEG, PNG o WebP, hasta 5 MB. Se reduce antes de subir."

#: src/features/collectionCommon/components/CollectionImageUploadField.tsx:29
msgid "JPG, PNG o WEBP · máximo {MAX_COLLECTION_IMAGE_SIZE_MB}MB"
msgstr "JPG, PNG o WEBP · máximo {MAX_COLLECTION_IMAGE_SIZE_MB}MB"

#: src/features/reports/utils/schedules.ts:16
msgid "jueves"
msgstr "jueves"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:118
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:162
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:250
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:87
#: src/features/reports2/utils/schedule.ts:27
#: src/fsd/entities/dashboard-widget/model/dga-frequency.ts:16
#: src/utils/i18n/getDgaTranslations.ts:10
msgid "Jueves"
msgstr "Jueves"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:27
msgid "Julio"
msgstr "Julio"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:26
msgid "Junio"
msgstr "Junio"

#: src/fsd/shared/ui/format/units.ts:146
#: src/utils/units.ts:203
msgid "kg"
msgstr "kg"

#: src/fsd/shared/ui/format/units.ts:147
#: src/utils/units.ts:204
msgid "kilogramo"
msgstr "kilogramo"

#: src/features/audit/utils/parseProperty.ts:33
msgid "KML de ICN"
msgstr "KML de ICN"

#: src/fsd/shared/ui/format/units.ts:92
#: src/utils/units.ts:149
msgid "L"
msgstr "L"

#: src/fsd/shared/ui/format/units.ts:13
#: src/utils/units.ts:70
msgid "L/s"
msgstr "L/s"

#: src/fsd/entities/dashboard-widget/ui/format/unit-symbol.ts:34
#: src/fsd/shared/ui/format/units.ts:158
#: src/utils/units.ts:215
msgid "L/s/acc"
msgstr "L/s/acc"

#: src/features/collections/components/modals/DeleteCollectionModal.tsx:41
msgid "La colección no fue encontrada."
msgstr "La colección no fue encontrada."

#: src/features/metricsViews/components/AssociateCollectionModal.tsx:138
msgid "La colección quedó asociada a la vista de métricas"
msgstr "La colección quedó asociada a la vista de métricas"

#: src/features/metricsViews/components/DissociateCollectionDialog.tsx:55
msgid "La colección quedó desasociada de la vista de métricas"
msgstr "La colección quedó desasociada de la vista de métricas"

#: src/features/gateAdministration/components/gateMovementBanner/LegacyMovementRow.tsx:39
msgid "La compuerta"
msgstr "La compuerta"

#: src/features/gateAdministration/components/gateMovementBanner/LegacyMovementRow.tsx:32
msgid "La compuerta <0>{gateName}</0> se está moviendo"
msgstr "La compuerta <0>{gateName}</0> se está moviendo"

#: src/features/gateAdministration/components/gateMovementBanner/V2MovementRow.tsx:40
msgid "La compuerta <0>{gateName}</0>: {label}"
msgstr "La compuerta <0>{gateName}</0>: {label}"

#: src/features/deviceConfigurationModal/components/gateTab/RemoveLinkedDeviceButton.tsx:55
msgid "La compuerta debe tener al menos un sensor de nivel"
msgstr "La compuerta debe tener al menos un sensor de nivel"

#: src/features/moveGateModal/components/LiveNotice.tsx:65
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:252
msgid "La compuerta está en movimiento. Detenla o espera a que termine para pedir otro movimiento."
msgstr "La compuerta está en movimiento. Detenla o espera a que termine para pedir otro movimiento."

#: src/features/gateCommon/utils/gateCommandOutcome.ts:151
#: src/fsd/entities/gate/model/command-outcome.ts:152
msgid "La compuerta no se movió."
msgstr "La compuerta no se movió."

#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:345
msgid "La compuerta no tiene movimientos registrados."
msgstr "La compuerta no tiene movimientos registrados."

#: src/features/gateCommon/utils/gateCommandOutcome.ts:176
#: src/fsd/entities/gate/model/command-outcome.ts:177
msgid "La compuerta respondió con el código {code}."
msgstr "La compuerta respondió con el código {code}."

#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:77
msgid "La compuerta todavía no ha reportado su posición."
msgstr "La compuerta todavía no ha reportado su posición."

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:121
msgid "La configuración de notificaciones DGA ha sido actualizada"
msgstr "La configuración de notificaciones DGA ha sido actualizada"

#: src/features/metricsViews/components/EditViewModal.tsx:51
msgid "La configuración de visualización de métricas ha sido guardada correctamente"
msgstr "La configuración de visualización de métricas ha sido guardada correctamente"

#: src/features/userSaveModal/utils/schema.ts:71
msgid "La confirmación de contraseña es requerida."
msgstr "La confirmación de contraseña es requerida."

#: src/features/userSaveModal/utils/schema.ts:37
msgid "La contraseña debe tener al menos 10 caracteres, una mayúscula, una minúscula, un número y un caracter especial."
msgstr "La contraseña debe tener al menos 10 caracteres, una mayúscula, una minúscula, un número y un caracter especial."

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:80
msgid "La contraseña debe tener por lo menos 6 caracteres"
msgstr "La contraseña debe tener por lo menos 6 caracteres"

#: src/features/sma/components/SmaUpsertModal.tsx:43
msgid "La contraseña es requerida"
msgstr "La contraseña es requerida"

#: src/features/userSaveModal/utils/schema.ts:68
msgid "La contraseña es requerida."
msgstr "La contraseña es requerida."

#: src/fsd/entities/dashboard-widget/ui/data/data-editor.tsx:34
msgid "La del dato"
msgstr "La del dato"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:122
#: src/fsd/entities/dashboard-widget/ui/data/data-editor.tsx:30
#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:76
msgid "La del dispositivo"
msgstr "La del dispositivo"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:63
msgid "La descripción es requerida"
msgstr "La descripción es requerida"

#: src/features/gateCommon/utils/gateCommandOutcome.ts:150
#: src/fsd/entities/gate/model/command-outcome.ts:149
msgid "La detención no se aplicó: si la compuerta estaba en movimiento, sigue moviéndose."
msgstr "La detención no se aplicó: si la compuerta estaba en movimiento, sigue moviéndose."

#: src/features/organizationCreateOrUpdate/utils/schema.ts:9
msgid "La direccion es requerida."
msgstr "La direccion es requerida."

#: src/fsd/pages/dashboards/ui/layout-warnings/warning-text.ts:40
msgid "La distribución guardada no es una lista; se ignora."
msgstr "La distribución guardada no es una lista; se ignora."

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:123
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:138
msgid "La expresión matemática es inválida: {0}"
msgstr "La expresión matemática es inválida: {0}"

#: src/features/billing/utils/validationSchema.ts:16
msgid "La fecha de finalización no puede ser igual o anterior a la fecha de inicio."
msgstr "La fecha de finalización no puede ser igual o anterior a la fecha de inicio."

#: src/features/dga/utils/validationSchemas.ts:161
msgid "La fecha de inicio debe ser menor a la fecha finalización."
msgstr "La fecha de inicio debe ser menor a la fecha finalización."

#: src/features/dateTimeRangePicker/components/DateTimeRangePicker.tsx:119
msgid "La fecha inicial debe ser anterior o igual a la final."
msgstr "La fecha inicial debe ser anterior o igual a la final."

#: src/features/alertsNotificationsHistory/components/Filters.tsx:39
msgid "La fecha no puede ser mayor a la fecha actual."
msgstr "La fecha no puede ser mayor a la fecha actual."

#: src/features/organizationCreateOrUpdate/utils/schema.ts:18
#: src/features/userSaveModal/utils/schema.ts:77
msgid "La imagen debe pesar menos de 5MB."
msgstr "La imagen debe pesar menos de 5MB."

#: src/features/organizationCreateOrUpdate/utils/schema.ts:23
#: src/features/userSaveModal/utils/schema.ts:82
msgid "La imagen debe ser un archivo de tipo JPG, JPEG o PNG."
msgstr "La imagen debe ser un archivo de tipo JPG, JPEG o PNG."

#: src/fsd/entities/dashboard-widget/ui/image/image-render.tsx:68
msgid "La imagen guardada no se pudo cargar: el archivo ya no existe o el enlace venció. Recarga el tablero o sube otra."
msgstr "La imagen guardada no se pudo cargar: el archivo ya no existe o el enlace venció. Recarga el tablero o sube otra."

#: src/features/collectionCommon/utils/collectionImage.ts:18
msgid "La imagen no puede superar los {MAX_COLLECTION_IMAGE_SIZE_MB}MB"
msgstr "La imagen no puede superar los {MAX_COLLECTION_IMAGE_SIZE_MB}MB"

#: src/features/metricsViews/hooks/useMetricsViewImageUpload.ts:42
#: src/fsd/entities/dashboard-widget/api/image-upload.ts:56
#: src/fsd/entities/dashboard-widget/ui/image/image-editor.test.tsx:68
msgid "La imagen supera el tamaño máximo de 5 MB"
msgstr "La imagen supera el tamaño máximo de 5 MB"

#: src/features/integrations/components/devicesList/index.tsx:65
msgid "La integración no tiene dispositivos asociados"
msgstr "La integración no tiene dispositivos asociados"

#: src/fsd/entities/dashboard-widget/ui/dga-tickets/dga-tickets-view.tsx:222
msgid "La lista muestra los tickets DGA abiertos ahora, sin importar cuándo se abrieron."
msgstr "La lista muestra los tickets DGA abiertos ahora, sin importar cuándo se abrieron."

#: src/features/homeAmaru/components/mainMetricModal/DeviceMainMetricModal.tsx:42
msgid "La métrica principal se ha actualizado correctamente"
msgstr "La métrica principal se ha actualizado correctamente"

#: src/components/gates/StopMovementConfirmation.tsx:79
msgid "La operación compuerta {gateName} no pudo ser cancelada."
msgstr "La operación compuerta {gateName} no pudo ser cancelada."

#: src/features/dga/components/modals/DgaOrganizationAccessWarning.tsx:101
msgid "La organización <0>{0}</0> no tiene acceso a la sección Reportes DGA."
msgstr "La organización <0>{0}</0> no tiene acceso a la sección Reportes DGA."

#: src/features/collections/validators.ts:17
#: src/features/collections/validators.ts:18
msgid "La organización es requerida"
msgstr "La organización es requerida"

#: src/features/userSaveModal/utils/schema.ts:21
msgid "La organización es requerida."
msgstr "La organización es requerida."

#: src/features/organizationsManagement/components/Organizations.tsx:66
msgid "La organización ha sido actualizada correctamente"
msgstr "La organización ha sido actualizada correctamente"

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:264
msgid "La organización sigue siendo obligatoria: de ahí sale la API Key, aunque el acceso quede acotado al usuario elegido."
msgstr "La organización sigue siendo obligatoria: de ahí sale la API Key, aunque el acceso quede acotado al usuario elegido."

#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:83
msgid "La plantilla ha sido creada correctamente"
msgstr "La plantilla ha sido creada correctamente"

#: src/features/moveGateModal/components/MoveGateForm.tsx:120
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:192
msgid "La posición es mayor al máximo permitido"
msgstr "La posición es mayor al máximo permitido"

#: src/features/moveGateModal/components/MoveGateForm.tsx:118
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:191
msgid "La posición es menor al mínimo permitido"
msgstr "La posición es menor al mínimo permitido"

#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:189
msgid "La posición no es un número válido"
msgstr "La posición no es un número válido"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:174
msgid "La propuesta no trae widgets que se puedan agregar a este tablero."
msgstr "La propuesta no trae widgets que se puedan agregar a este tablero."

#: src/features/reports/components/creationSection/CreateReportDialog.tsx:38
msgid "La solicitud de reporte ha sido enviada correctamente. Pronto recibirá el reporte en los emails seleccionados."
msgstr "La solicitud de reporte ha sido enviada correctamente. Pronto recibirá el reporte en los emails seleccionados."

#: src/features/createDeviceConfiguration/components/tabs/general/GeneralTabContent.tsx:253
msgid "La solicitud fue enviada. La creación del certificado puede tardar unos momentos. Cierra y vuelve a abrir el modal para verificar si ya fue creado."
msgstr "La solicitud fue enviada. La creación del certificado puede tardar unos momentos. Cierra y vuelve a abrir el modal para verificar si ya fue creado."

#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:69
msgid "La tabla no tiene columnas."
msgstr "La tabla no tiene columnas."

#: src/fsd/entities/dashboard-widget/ui/data/data-editor.tsx:101
msgid "La tendencia de este dato se ve en metrics-views; aquí se muestra solo el valor."
msgstr "La tendencia de este dato se ve en metrics-views; aquí se muestra solo el valor."

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:302
msgid "La ubicación y el tamaño se editan en Escritorio."
msgstr "La ubicación y el tamaño se editan en Escritorio."

#: src/features/metricsViews/components/DissociateCollectionDialog.tsx:70
msgid "La vista <0>{viewName}</0> deja de seguir a la colección <1>{collectionName}</1> y vuelve a quedarse con la lista de dispositivos que tiene en este momento, editable a mano."
msgstr "La vista <0>{viewName}</0> deja de seguir a la colección <1>{collectionName}</1> y vuelve a quedarse con la lista de dispositivos que tiene en este momento, editable a mano."

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:381
msgid "La zona horaria utilizada para la programación, es la de su navegador que es"
msgstr "La zona horaria utilizada para la programación, es la de su navegador que es"

#: src/features/userPreferences/components/RegionTab.tsx:274
msgid "Largo"
msgstr "Largo"

#: src/features/userSaveModal/utils/schema.ts:41
msgid "Las contraseñas deben coincidir."
msgstr "Las contraseñas deben coincidir."

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:86
#: src/features/changePasswordByToken/components/ChangePasswordByToken.tsx:92
msgid "Las contraseñas no coinciden"
msgstr "Las contraseñas no coinciden"

#: src/features/audit/utils/parseProperty.ts:29
msgid "latitud"
msgstr "latitud"

#: src/features/createDevice/components/form/index.tsx:91
#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:366
msgid "Latitud"
msgstr "Latitud"

#: src/features/metricsViews/components/MetricsViewList.tsx:152
#: src/fsd/pages/dashboards/ui/layout-warnings/layout-warnings-banner.tsx:77
#: src/fsd/pages/dashboards/ui/save-loss-dialog.tsx:38
msgid "Layout"
msgstr "Layout"

#: src/fsd/shared/ui/format/units.ts:151
#: src/utils/units.ts:208
msgid "lb"
msgstr "lb"

#: src/features/api/components/ApiUsersList.tsx:61
#: src/features/api/components/CaptaApiUsersList.tsx:97
#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:224
#: src/features/api/components/dialogs/EditApiUserDialog.tsx:95
msgid "Lectura"
msgstr "Lectura"

#: src/features/audit/utils/parseProperty.ts:15
msgid "lectura de dispositivo"
msgstr "lectura de dispositivo"

#: src/features/notifications/components/popup/MenuList.tsx:231
msgid "Leídos"
msgstr "Leídos"

#: src/hooks/useI18n.ts:26
msgid "Lenguaje actualizado correctamente"
msgstr "Lenguaje actualizado correctamente"

#: src/features/userPreferences/components/RegionTab.tsx:237
msgid "Lenguaje de fecha"
msgstr "Lenguaje de fecha"

#: src/features/userPreferences/components/RegionTab.tsx:195
msgid "Lenguaje de números"
msgstr "Lenguaje de números"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-view.tsx:73
msgid "Leyenda del gráfico"
msgstr "Leyenda del gráfico"

#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:14
msgid "LG con 1 compuerta"
msgstr "LG con 1 compuerta"

#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:23
msgid "LG con 2 compuertas"
msgstr "LG con 2 compuertas"

#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:33
msgid "LG con 3 compuertas"
msgstr "LG con 3 compuertas"

#: src/fsd/pages/dashboards/ui/canvas/canvas.tsx:628
msgid "Liberar"
msgstr "Liberar"

#: src/fsd/shared/ui/format/units.ts:152
#: src/utils/units.ts:209
msgid "libra"
msgstr "libra"

#: src/components/ColorPicker/palettes.ts:40
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:38
msgid "Lima"
msgstr "Lima"

#: src/fsd/pages/widget-catalog/model/examples.ts:267
#: src/fsd/pages/widget-catalog/model/examples.ts:358
msgid "Límite de 5 filas"
msgstr "Límite de 5 filas"

#: src/features/metricsViews/components/forms/TableWidgetForm.tsx:81
msgid "Límite de filas"
msgstr "Límite de filas"

#: src/features/controlCenter/utils/minicharts.ts:237
msgid "Límite de reparto de caudal"
msgstr "Límite de reparto de caudal"

#: src/features/metricsViews/components/forms/MovementsTableForm.tsx:74
msgid "Límite filas"
msgstr "Límite filas"

#: src/features/metricsViews/components/widgets/gateSensors/RenderSensor.tsx:122
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/sensors.ts:51
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/sensors.ts:63
msgid "Límite inferior"
msgstr "Límite inferior"

#: src/features/echarts/utils/commonSeries.ts:403
#: src/features/echarts/utils/commonSeries.ts:404
msgid "Límite inferior de curvas de aforo"
msgstr "Límite inferior de curvas de aforo"

#: src/features/metricsViews/components/widgets/gateSensors/RenderSensor.tsx:126
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/sensors.ts:50
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/sensors.ts:62
msgid "Límite superior"
msgstr "Límite superior"

#: src/features/echarts/utils/commonSeries.ts:390
#: src/features/echarts/utils/commonSeries.ts:391
msgid "Límite superior de curvas de aforo"
msgstr "Límite superior de curvas de aforo"

#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:42
msgid "Límites de abertura"
msgstr "Límites de abertura"

#: src/features/deviceDataConfigurationModal/components/DeviceDataConfigurationModal.tsx:76
#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:116
msgid "Límites de Caudal"
msgstr "Límites de Caudal"

#: src/utils/attributes/metricField.ts:329
msgid "límites de curvas de aforo"
msgstr "límites de curvas de aforo"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:306
#: src/features/echarts/utils/commonSeries.ts:370
#: src/features/echarts/utils/commonSeries.ts:371
msgid "Límites de curvas de aforo"
msgstr "Límites de curvas de aforo"

#: src/features/reports/utils/metricHelpers.ts:28
msgid "Límites de Curvas de Calibración"
msgstr "Límites de Curvas de Calibración"

#: src/features/deviceConfigurationModal/components/DeviceConfigurationModal.tsx:73
msgid "Límites y alarma"
msgstr "Límites y alarma"

#: src/fsd/pages/dashboards/ui/change-bar/view-menu.tsx:92
msgid "Limpiar"
msgstr "Limpiar"

#: src/features/deviceSupport/components/FilterAdvance.tsx:206
msgid "Limpiar campos"
msgstr "Limpiar campos"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:339
msgid "Limpiar conversación"
msgstr "Limpiar conversación"

#: src/fsd/pages/dashboards/ui/change-bar/view-menu.tsx:78
msgid "Limpiar el tablero"
msgstr "Limpiar el tablero"

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:374
msgid "Limpiar filtros"
msgstr "Limpiar filtros"

#: src/fsd/app/locale/au-labels.ts:39
msgid "Limpiar selección"
msgstr "Limpiar selección"

#: src/features/metricsViews/components/MetricsView.tsx:597
msgid "Limpiar tablero"
msgstr "Limpiar tablero"

#: src/fsd/pages/dashboards/ui/change-bar/view-menu.tsx:69
msgid "Limpiar tablero ({n})"
msgstr "Limpiar tablero ({n})"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:366
#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:33
msgid "Línea"
msgstr "Línea"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:534
msgid "Línea escalonada"
msgstr "Línea escalonada"

#: src/features/homeAmaru/components/HomeAmaru.tsx:375
#: src/features/homeAmaru/components/HomeAmaru.tsx:376
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-editor.tsx:19
#: src/fsd/pages/widget-catalog/model/examples.ts:336
msgid "Lista"
msgstr "Lista"

#: src/pages/gates/administration/[gateId].tsx:34
msgid "Lista de compuertas"
msgstr "Lista de compuertas"

#: src/features/metricsViews/utils/genericWidgetTypes.ts:75
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:15
msgid "Lista de dispositivos"
msgstr "Lista de dispositivos"

#: src/features/billing/components/projectService/Create.tsx:151
msgid "Lista de servicios a agregar"
msgstr "Lista de servicios a agregar"

#: src/features/metricsViews/components/MetricsView.tsx:613
msgid "Lista de visualizaciones"
msgstr "Lista de visualizaciones"

#: src/features/metricsViews/components/MetricsViewListModal.tsx:18
msgid "Lista de visualizaciones configuradas"
msgstr "Lista de visualizaciones configuradas"

#: src/features/metricsViews/components/MetricsViews.tsx:38
#: src/pages/metrics-views/index.tsx:10
msgid "Lista de visualizaciones de métricas"
msgstr "Lista de visualizaciones de métricas"

#: src/features/events/components/EventsTable.tsx:96
msgid "Listado completo"
msgstr "Listado completo"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:392
msgid "Listado de Filtros"
msgstr "Listado de Filtros"

#: src/fsd/shared/ui/format/units.ts:93
#: src/utils/units.ts:150
msgid "litro"
msgstr "litro"

#: src/fsd/shared/ui/format/units.ts:14
#: src/utils/units.ts:71
msgid "litro por segundo"
msgstr "litro por segundo"

#: src/fsd/shared/ui/format/units.ts:159
#: src/utils/units.ts:216
msgid "litro por segundo por acción"
msgstr "litro por segundo por acción"

#: src/features/audit/components/AuditLogsTimeline.tsx:358
msgid "Llegaste al inicio de los tiempos"
msgstr "Llegaste al inicio de los tiempos"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:87
msgid "Logo"
msgstr "Logo"

#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:198
msgid "Logo de la organización (opcional)"
msgstr "Logo de la organización (opcional)"

#: src/features/audit/utils/parseProperty.ts:30
msgid "longitud"
msgstr "longitud"

#: src/features/createDevice/components/form/index.tsx:96
#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:378
msgid "Longitud"
msgstr "Longitud"

#: src/fsd/pages/widget-catalog/model/examples.ts:446
msgid "Los 5 por defecto"
msgstr "Los 5 por defecto"

#: src/fsd/pages/widget-catalog/model/examples.ts:447
msgid "Los 8"
msgstr "Los 8"

#: src/features/deviceConfigurationModal/components/aliasModal/DeviceAliasModal.tsx:70
msgid "Los alias del dispositivo se han actualizado correctamente"
msgstr "Los alias del dispositivo se han actualizado correctamente"

#: src/features/userSaveModal/utils/schema.ts:52
msgid "Los apellidos son requeridos."
msgstr "Los apellidos son requeridos."

#: src/fsd/pages/dashboards/ui/change-bar/add-widget.tsx:63
#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:93
msgid "Los atenuados aún no se editan acá."
msgstr "Los atenuados aún no se editan acá."

#: src/components/modal/ConfirmationModal.tsx:41
#: src/components/modal/ConfirmationModal.tsx:47
msgid "Los cambios que hayas realizado no se guardarán."
msgstr "Los cambios que hayas realizado no se guardarán."

#: src/features/metricsViews/components/MetricsView.tsx:534
#: src/features/metricsViews/components/MetricsView.tsx:546
msgid "Los cambios que hiciste en el tablero se van a perder."
msgstr "Los cambios que hiciste en el tablero se van a perder."

#: src/features/metricsViews/components/SaveWidgetModal.tsx:293
msgid "Los cambios se aplican al tablero. Para conservarlos, guarda la vista al terminar."
msgstr "Los cambios se aplican al tablero. Para conservarlos, guarda la vista al terminar."

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:96
#: src/features/reports2/utils/schedule.ts:11
msgid "Los días de semana"
msgstr "Los días de semana"

#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:141
msgid "Los dispositivos los define la colección de este tablero: para cambiarlos, edita la colección."
msgstr "Los dispositivos los define la colección de este tablero: para cambiarlos, edita la colección."

#: src/features/metricsViews/components/AssociateCollectionModal.tsx:219
msgid "Los dispositivos no cambian: la colección tiene exactamente los mismos."
msgstr "Los dispositivos no cambian: la colección tiene exactamente los mismos."

#: src/features/deviceDataConfigurationModal/utils/filtersSchema.ts:14
msgid "Los elementos de Piecewise deben tener un valor mínimo que coincida con el valor máximo del elemento anterior"
msgstr "Los elementos de Piecewise deben tener un valor mínimo que coincida con el valor máximo del elemento anterior"

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:56
msgid "Los envíos a la DGA funcionan con normalidad."
msgstr "Los envíos a la DGA funcionan con normalidad."

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:66
msgid "Los envíos a la DGA no están funcionando."
msgstr "Los envíos a la DGA no están funcionando."

#: src/features/changeOperationalState/components/AfterUpdateTasksModal.tsx:157
msgid "Los envíos están desactivados"
msgstr "Los envíos están desactivados"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-view.tsx:191
msgid "Los estados operacionales se ven en metrics-views."
msgstr "Los estados operacionales se ven en metrics-views."

#: src/features/moveGateModal/components/MoveGateForm.tsx:250
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:415
msgid "Los límites del equipo ({0} a {1}) difieren de los configurados en la plataforma ({2} a {3}). Se usan los que reportó el equipo."
msgstr "Los límites del equipo ({0} a {1}) difieren de los configurados en la plataforma ({2} a {3}). Se usan los que reportó el equipo."

#: src/features/deviceCommands/components/calendar/ScheduleDetailsDialog.tsx:69
msgid "Los siguientes comandos están programados para las {scheduleMomentTime} horas del día {scheduleMomentDate}"
msgstr "Los siguientes comandos están programados para las {scheduleMomentTime} horas del día {scheduleMomentDate}"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:74
msgid "Los valores finales serán calculados al crear cada pago."
msgstr "Los valores finales serán calculados al crear cada pago."

#: src/features/reports/utils/schedules.ts:13
msgid "lunes"
msgstr "lunes"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:115
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:159
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:247
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:84
#: src/features/reports2/utils/schedule.ts:24
#: src/fsd/entities/dashboard-widget/model/dga-frequency.ts:13
#: src/utils/i18n/getDgaTranslations.ts:7
msgid "Lunes"
msgstr "Lunes"

#: src/fsd/shared/ui/format/units.ts:65
#: src/utils/units.ts:122
msgid "m"
msgstr "m"

#: src/fsd/shared/ui/format/units.ts:97
#: src/utils/units.ts:154
msgid "m³"
msgstr "m³"

#: src/fsd/shared/ui/format/units.ts:23
#: src/utils/units.ts:80
msgid "m³/h"
msgstr "m³/h"

#: src/fsd/shared/ui/format/units.ts:18
#: src/utils/units.ts:75
msgid "m³/s"
msgstr "m³/s"

#: src/fsd/entities/dashboard-widget/ui/format/unit-symbol.ts:35
#: src/fsd/shared/ui/format/units.ts:163
#: src/utils/units.ts:220
msgid "m³/s/acc"
msgstr "m³/s/acc"

#: src/fsd/shared/ui/format/units.ts:200
#: src/utils/units.ts:257
msgid "mA"
msgstr "mA"

#: src/features/deviceConfiguration/data/sectionFields.ts:365
#: src/features/deviceConfiguration/data/sectionInputs.ts:387
msgid "MAC"
msgstr "MAC"

#: src/features/metricsViews/components/MetricsViewToolbar.tsx:87
msgid "maestro"
msgstr "maestro"

#: src/features/billing/components/administration/Toolbar.tsx:103
#: src/features/billing/components/service/Administration.tsx:64
msgid "Mantenedor de servicios"
msgstr "Mantenedor de servicios"

#: src/features/collections/components/CollectionVisualRepresentationFields.tsx:56
#: src/features/createMyCollectionModal/components/CreateMyCollectionModal.tsx:111
#: src/features/homeAmaru/components/HomeAmaru.tsx:388
#: src/features/homeAmaru/components/HomeAmaru.tsx:389
#: src/features/homeAmaru/components/shared/UpdateMyCollectionModal.tsx:119
#: src/features/metricsViews/utils/genericWidgetTypes.ts:71
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:22
msgid "Mapa"
msgstr "Mapa"

#: src/features/audit/utils/parseProperty.ts:63
msgid "marca de alimentación"
msgstr "marca de alimentación"

#: src/features/deviceConfiguration/data/sectionInputs.ts:208
msgid "Marca de alimentación"
msgstr "Marca de alimentación"

#: src/features/deviceConfiguration/data/sectionFields.ts:186
msgid "Marca fuente DC"
msgstr "Marca fuente DC"

#: src/features/reports/utils/schedules.ts:14
msgid "martes"
msgstr "martes"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:116
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:160
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:248
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:85
#: src/features/reports2/utils/schedule.ts:25
#: src/fsd/entities/dashboard-widget/model/dga-frequency.ts:14
#: src/utils/i18n/getDgaTranslations.ts:8
msgid "Martes"
msgstr "Martes"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:23
msgid "Marzo"
msgstr "Marzo"

#: src/features/devices2/components/DevicesHeader.tsx:204
msgid "Más acciones"
msgstr "Más acciones"

#: src/fsd/features/gate-movements/ui/list/movement-list.tsx:15
msgid "Más antiguos"
msgstr "Más antiguos"

#: src/fsd/pages/widget-catalog/ui/preview.tsx:153
msgid "Más chico que el mínimo sugerido ({0}×{1})"
msgstr "Más chico que el mínimo sugerido ({0}×{1})"

#: src/features/deviceSupport/components/SupportMenu.tsx:60
msgid "Más Filtros"
msgstr "Más Filtros"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:375
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:320
msgid "Masa de nieve"
msgstr "Masa de nieve"

#: src/features/reports/utils/metricHelpers.ts:42
msgid "Masa de Nieve"
msgstr "Masa de Nieve"

#: src/fsd/app/locale/au-labels.ts:109
msgid "máx"
msgstr "máx"

#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:459
#: src/features/deviceAlertsModal/components/basicConfigurationTab/FormComponent.tsx:79
#: src/fsd/app/locale/au-labels.ts:50
#: src/fsd/app/locale/au-labels.ts:116
msgid "Máximo"
msgstr "Máximo"

#: src/features/metricsViews/components/widgets/common/DurationAutocomplete.tsx:135
msgid "Máximo {maxItems} duraciones"
msgstr "Máximo {maxItems} duraciones"

#: src/features/dgaTicket/validation.ts:56
#: src/fsd/pages/dga-reports/ui/report-problem-dialog.tsx:68
msgid "Máximo {TICKET_DESCRIPTION_MAX_LENGTH} caracteres"
msgstr "Máximo {TICKET_DESCRIPTION_MAX_LENGTH} caracteres"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:25
msgid "Mayo"
msgstr "Mayo"

#: src/components/PicturePreview.tsx:175
msgid "Medido"
msgstr "Medido"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:60
#: src/features/dga/components/modals/reports/TableModal.tsx:159
#: src/features/events/components/HeaderTable.tsx:17
#: src/features/events/components/HeaderTable.tsx:32
#: src/features/sma/components/TableModal.tsx:192
msgid "Mensaje"
msgstr "Mensaje"

#: src/features/notifications/utils/entitiesHandlers.tsx:76
msgid "Mensaje {0} - {1}: {2}"
msgstr "Mensaje {0} - {1}: {2}"

#: src/features/gateOperationModal/components/panelNotification/utils.tsx:141
#: src/fsd/features/gate-movements/ui/panel/events/event-text.tsx:173
msgid "Mensaje de la compuerta"
msgstr "Mensaje de la compuerta"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:405
msgid "Mensaje para el asistente"
msgstr "Mensaje para el asistente"

#: src/features/billing/utils/translations.ts:10
#: src/features/billing/utils/translations.ts:21
#: src/features/devices2/utils/getDgaFrequencyOptions.ts:6
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:122
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:210
#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:41
msgid "Mensual"
msgstr "Mensual"

#: src/utils/i18n/getDgaTranslations.ts:40
msgid "Mensual (día {0} a las {hourString})"
msgstr "Mensual (día {0} a las {hourString})"

#: src/fsd/entities/dashboard-widget/model/dga-frequency.ts:52
msgid "Mensual (día {day} a las {hour})"
msgstr "Mensual (día {day} a las {hour})"

#: src/features/reports/utils/schedules.ts:50
#: src/features/reports2/utils/schedule.ts:83
msgid "Mensualmente el primer {dayOfWeek} del mes a las {hoursMinutesStr} horas."
msgstr "Mensualmente el primer {dayOfWeek} del mes a las {hoursMinutesStr} horas."

#: src/features/reports/utils/schedules.ts:52
#: src/features/reports2/utils/schedule.ts:85
msgid "Mensualmente el último {dayOfWeek} del mes a las {hoursMinutesStr} horas."
msgstr "Mensualmente el último {dayOfWeek} del mes a las {hoursMinutesStr} horas."

#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:156
msgid "Menú de dispositivo"
msgstr "Menú de dispositivo"

#: src/features/alertsNotificationsHistory/components/histogram/index.tsx:43
msgid "Mes"
msgstr "Mes"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:573
msgid "Método"
msgstr "Método"

#: src/features/audit/utils/parseProperty.ts:163
msgid "método de conexión a internet"
msgstr "método de conexión a internet"

#: src/features/audit/utils/parseProperty.ts:164
msgid "método de conexión de datos"
msgstr "método de conexión de datos"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:387
msgid "Método utilizado"
msgstr "Método utilizado"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:262
msgid "métrica"
msgstr "métrica"

#: src/features/alertsConfigurationV3/components/wizard/AlertWizardModal.tsx:75
#: src/features/alertsConfigurationV3/components/wizard/steps/MetricStep.tsx:85
#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:148
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/AccessorsTable.tsx:28
#: src/features/metricsViews/components/forms/TrendSummaryForm.tsx:217
#: src/features/sma/components/forFutureUse/DialogSmaUnitSummary.tsx:124
#: src/features/sma/components/TableModal.tsx:189
#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:151
#: src/fsd/entities/dashboard-widget/ui/data/data-editor.tsx:62
#: src/fsd/entities/dashboard-widget/ui/data/data-editor.tsx:67
#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:83
msgid "Métrica"
msgstr "Métrica"

#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:90
msgid "Métrica de la columna {n}"
msgstr "Métrica de la columna {n}"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:158
msgid "Métrica de la serie {n}"
msgstr "Métrica de la serie {n}"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:152
#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:84
msgid "Métrica no editable aquí: se conserva."
msgstr "Métrica no editable aquí: se conserva."

#: src/features/homeAmaru/components/mainMetricModal/DeviceMainMetricModal.tsx:97
msgid "Métrica principal"
msgstr "Métrica principal"

#: src/features/homeAmaru/components/mainMetricModal/DeviceMainMetricModal.tsx:118
#: src/features/homeAmaru/components/mainMetricModal/DeviceMainMetricModal.tsx:132
msgid "Métrica principal del dispositivo"
msgstr "Métrica principal del dispositivo"

#: src/features/alertsConfigurationV2/components/upsertModal/AlertsConfigurationModal.tsx:46
#: src/features/dga/components/modals/reports/TableModal.tsx:156
#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:519
#: src/features/reports/components/DeviceMetricsSummary.tsx:32
#: src/features/reports/components/ReportHistory.tsx:83
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:307
#: src/features/reports2/components/reportHistoryModal/ReportHistory.tsx:88
#: src/features/reports2/components/ReportTemplatesTable.tsx:70
#: src/features/reports2/components/TemplateSummary.tsx:70
msgid "Métricas"
msgstr "Métricas"

#: src/features/metricsViews/components/forms/ActiveAlertsForm.tsx:80
msgid "Métricas a evaluar"
msgstr "Métricas a evaluar"

#: src/features/deviceProfile/components/page/Metrics.tsx:205
msgid "Métricas disponibles"
msgstr "Métricas disponibles"

#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:411
msgid "Métricas seleccionadas"
msgstr "Métricas seleccionadas"

#: src/fsd/shared/ui/format/units.ts:66
#: src/utils/units.ts:123
msgid "metro"
msgstr "metro"

#: src/fsd/shared/ui/format/units.ts:98
#: src/utils/units.ts:155
msgid "metro cúbico"
msgstr "metro cúbico"

#: src/fsd/shared/ui/format/units.ts:24
#: src/utils/units.ts:81
msgid "metro cúbico por hora"
msgstr "metro cúbico por hora"

#: src/fsd/shared/ui/format/units.ts:19
#: src/utils/units.ts:76
msgid "metro cúbico por segundo"
msgstr "metro cúbico por segundo"

#: src/fsd/shared/ui/format/units.ts:164
#: src/utils/units.ts:221
msgid "metro cúbico por segundo por acción"
msgstr "metro cúbico por segundo por acción"

#: src/fsd/shared/ui/format/units.ts:260
#: src/utils/units.ts:317
msgid "mg/L"
msgstr "mg/L"

#: src/fsd/shared/ui/format/units.ts:256
#: src/utils/units.ts:313
msgid "microsiemens por centímetro"
msgstr "microsiemens por centímetro"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:546
msgid "Middle"
msgstr "Middle"

#: src/features/gateCommon/utils/gateCommandOutcome.ts:157
#: src/fsd/entities/gate/model/command-outcome.ts:158
msgid "Mientras siga en cola, la compuerta puede moverse más tarde sin otro aviso. Para cancelarla, detenga la operación."
msgstr "Mientras siga en cola, la compuerta puede moverse más tarde sin otro aviso. Para cancelarla, detenga la operación."

#: src/features/reports/utils/schedules.ts:15
msgid "miércoles"
msgstr "miércoles"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:117
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:161
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:249
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:86
#: src/features/reports2/utils/schedule.ts:26
#: src/fsd/entities/dashboard-widget/model/dga-frequency.ts:15
#: src/utils/i18n/getDgaTranslations.ts:9
msgid "Miércoles"
msgstr "Miércoles"

#: src/fsd/shared/ui/format/units.ts:201
#: src/utils/units.ts:258
msgid "miliamperio"
msgstr "miliamperio"

#: src/fsd/shared/ui/format/units.ts:261
#: src/utils/units.ts:318
msgid "miligramo por litro"
msgstr "miligramo por litro"

#: src/fsd/shared/ui/format/units.ts:76
#: src/utils/units.ts:133
msgid "milímetro"
msgstr "milímetro"

#: src/fsd/shared/ui/format/units.ts:130
#: src/utils/units.ts:187
msgid "milímetro por segundo"
msgstr "milímetro por segundo"

#: src/fsd/shared/ui/format/units.ts:266
#: src/utils/units.ts:323
msgid "milisegundo"
msgstr "milisegundo"

#: src/fsd/shared/ui/format/units.ts:251
#: src/utils/units.ts:308
msgid "milisiemens por centímetro"
msgstr "milisiemens por centímetro"

#: src/fsd/shared/ui/format/units.ts:226
#: src/utils/units.ts:283
msgid "milivoltio"
msgstr "milivoltio"

#: src/fsd/app/locale/au-labels.ts:110
msgid "mín"
msgstr "mín"

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-editor.tsx:14
#: src/fsd/pages/widget-catalog/model/examples.ts:282
msgid "Minimizado"
msgstr "Minimizado"

#: src/fsd/pages/dashboards/ui/controls/controls.tsx:122
msgid "mínimo"
msgstr "mínimo"

#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:439
#: src/features/deviceAlertsModal/components/basicConfigurationTab/FormComponent.tsx:67
#: src/fsd/app/locale/au-labels.ts:50
#: src/fsd/app/locale/au-labels.ts:117
#: src/fsd/pages/widget-catalog/ui/preview.tsx:88
msgid "Mínimo"
msgstr "Mínimo"

#: src/features/homeAmaru/components/HomeAmaru.tsx:336
msgid "Mis colecciones"
msgstr "Mis colecciones"

#: src/fsd/shared/ui/format/units.ts:75
#: src/utils/units.ts:132
msgid "mm"
msgstr "mm"

#: src/fsd/shared/ui/format/units.ts:129
#: src/utils/units.ts:186
msgid "mm/s"
msgstr "mm/s"

#: src/fsd/pages/widget-catalog/ui/preview.tsx:120
msgid "Mobile"
msgstr "Mobile"

#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:414
#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:417
msgid "Modalidad"
msgstr "Modalidad"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:528
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:199
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:215
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:234
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:250
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:269
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:285
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:304
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:320
msgid "Modbus ID"
msgstr "Modbus ID"

#: src/features/audit/utils/parseProperty.ts:139
msgid "modelado matemático"
msgstr "modelado matemático"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/GCalculatedAngleModelInput.tsx:55
msgid "Modelamiento de ángulo"
msgstr "Modelamiento de ángulo"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/FlowModelInput.tsx:78
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/LGFlowModelInput.tsx:83
msgid "Modelamiento de caudal"
msgstr "Modelamiento de caudal"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:205
msgid "Modelamientos matemáticos"
msgstr "Modelamientos matemáticos"

#: src/features/deviceDataConfigurationModal/components/DeviceDataConfigurationModal.tsx:100
msgid "Modelamientos Matemáticos"
msgstr "Modelamientos Matemáticos"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:450
#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:65
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:195
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:211
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:230
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:246
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:265
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:281
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:300
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:316
msgid "Modelo"
msgstr "Modelo"

#: src/features/audit/utils/parseProperty.ts:64
msgid "modelo controlador paneles"
msgstr "modelo controlador paneles"

#: src/features/audit/utils/parseProperty.ts:65
#: src/features/audit/utils/parseProperty.ts:169
msgid "modelo controlador solar"
msgstr "modelo controlador solar"

#: src/features/audit/utils/parseProperty.ts:61
msgid "modelo de alimentación"
msgstr "modelo de alimentación"

#: src/features/deviceConfiguration/data/sectionInputs.ts:192
msgid "Modelo de alimentación"
msgstr "Modelo de alimentación"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:24
msgid "Modelo de antena"
msgstr "Modelo de antena"

#: src/features/audit/utils/parseProperty.ts:68
msgid "modelo de batería"
msgstr "modelo de batería"

#: src/features/deviceConfiguration/data/sectionFields.ts:94
#: src/features/deviceConfiguration/data/sectionInputs.ts:104
msgid "Modelo de batería"
msgstr "Modelo de batería"

#: src/features/audit/utils/parseProperty.ts:81
#: src/features/audit/utils/parseProperty.ts:165
msgid "modelo de conexión"
msgstr "modelo de conexión"

#: src/features/deviceConfiguration/data/sectionFields.ts:248
#: src/features/deviceConfiguration/data/sectionInputs.ts:265
msgid "Modelo de conexión"
msgstr "Modelo de conexión"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:84
msgid "Modelo de controlador solar"
msgstr "Modelo de controlador solar"

#: src/features/deviceConfiguration/data/sectionFields.ts:138
#: src/features/deviceConfiguration/data/sectionInputs.ts:148
msgid "Modelo de paneles solares"
msgstr "Modelo de paneles solares"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:72
msgid "Modelo de SIM"
msgstr "Modelo de SIM"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:113
msgid "Modelo fuente"
msgstr "Modelo fuente"

#: src/features/deviceConfiguration/data/sectionFields.ts:170
msgid "Modelo fuente DC"
msgstr "Modelo fuente DC"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:92
msgid "Modelo TDI"
msgstr "Modelo TDI"

#: src/features/audit/utils/parseProperty.ts:73
msgid "modelos de paneles solares"
msgstr "modelos de paneles solares"

#: src/features/announcements/components/AnnouncementsGeneralSettings.tsx:49
msgid "Modificar categorías"
msgstr "Modificar categorías"

#: src/features/changeTagsDevice/components/ChangeTagsDevice.tsx:105
msgid "Modificar etiquetas de"
msgstr "Modificar etiquetas de"

#: src/features/reports2/components/createModal/CreateReportModal.tsx:71
msgid "Modificar reporte"
msgstr "Modificar reporte"

#: src/features/metricsViews/components/forms/AllocationPerformanceWidgetForm.tsx:93
msgid "Modo de comparación"
msgstr "Modo de comparación"

#: src/fsd/entities/dashboard-widget/ui/gate-sensors/sensors.ts:61
msgid "Modo de operación"
msgstr "Modo de operación"

#: src/fsd/pages/dashboards/ui/panel/panel.tsx:107
msgid "Modo del panel"
msgstr "Modo del panel"

#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:35
msgid "Modo mantenimiento"
msgstr "Modo mantenimiento"

#: src/features/devices2/components/list/itemPanel/deviceItemInfo/index.tsx:159
msgid "MODO MANTENIMIENTO"
msgstr "MODO MANTENIMIENTO"

#: src/features/metricsViews/components/widgets/gateSensors/RenderSensor.tsx:138
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/sensors.ts:48
msgid "Modo operación local"
msgstr "Modo operación local"

#: src/features/metricsViews/components/widgets/gateSensors/RenderSensor.tsx:138
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/sensors.ts:49
msgid "Modo operación telecomando"
msgstr "Modo operación telecomando"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:88
msgid "Módulo de señal"
msgstr "Módulo de señal"

#: src/pages/distribution/history.tsx:15
#: src/pages/distribution/index.tsx:14
msgid "Módulo reparto"
msgstr "Módulo reparto"

#: src/features/billing/components/modals/ServiceFileManager.tsx:96
msgid "Moneda"
msgstr "Moneda"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:61
msgid "Monitoreo"
msgstr "Monitoreo"

#: src/components/ColorPicker/palettes.ts:31
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:29
#: src/fsd/pages/dashboards/ui/board-color/color-names.ts:13
msgid "Morado"
msgstr "Morado"

#: src/components/ColorPicker/palettes.ts:32
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:30
msgid "Morado oscuro"
msgstr "Morado oscuro"

#: src/features/homeAmaru/components/HomeAmaru.tsx:362
#: src/features/homeAmaru/components/HomeAmaru.tsx:363
msgid "Mosaico"
msgstr "Mosaico"

#: src/features/collections/components/CollectionsTableFilters.tsx:30
msgid "Mostrando colecciones asignadas a este dispositivo o usuario — el filtro de organización no aplica mientras este esté activo, pero podés seguir acotando por búsqueda o tipo."
msgstr "Mostrando colecciones asignadas a este dispositivo o usuario — el filtro de organización no aplica mientras este esté activo, pero podés seguir acotando por búsqueda o tipo."

#: src/features/deviceProfile/components/page/Permissions.tsx:86
msgid "Mostrar {0} usuarios más"
msgstr "Mostrar {0} usuarios más"

#: src/fsd/entities/dashboard-widget/ui/data/data-editor.tsx:95
msgid "Mostrar alertas"
msgstr "Mostrar alertas"

#: src/features/deviceAlertsModal/components/index.tsx:147
msgid "Mostrar configuración leída por el pipeline"
msgstr "Mostrar configuración leída por el pipeline"

#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-editor.tsx:36
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-editor.tsx:47
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-editor.tsx:36
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-editor.tsx:57
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-editor.tsx:37
msgid "Mostrar el nombre del dispositivo"
msgstr "Mostrar el nombre del dispositivo"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:265
msgid "mostrar en"
msgstr "mostrar en"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:194
#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:177
#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:183
msgid "Mostrar en"
msgstr "Mostrar en"

#: src/features/audit/utils/parseProperty.ts:38
msgid "mostrar en lista DGA"
msgstr "mostrar en lista DGA"

#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:387
msgid "Mostrar mapa"
msgstr "Mostrar mapa"

#: src/features/metricsViews/components/forms/DgaReportsWidgetForm.tsx:77
msgid "Mostrar nombre de dispositivo"
msgstr "Mostrar nombre de dispositivo"

#: src/features/metricsViews/components/forms/DgaReportsChartWidgetForm.tsx:53
#: src/features/metricsViews/components/forms/GateOperateWidgetForm.tsx:44
#: src/features/metricsViews/components/forms/GateSensorWidgetForm.tsx:61
#: src/features/metricsViews/components/forms/MovementsTableForm.tsx:53
msgid "Mostrar nombre de dispositivo en lugar del título"
msgstr "Mostrar nombre de dispositivo en lugar del título"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:464
msgid "Mostrar símbolos"
msgstr "Mostrar símbolos"

#: src/features/gateAdministration/components/MoveGate.tsx:248
msgid "Mover"
msgstr "Mover"

#: src/features/gateAdministration/components/index.tsx:393
msgid "Mover compuerta"
msgstr "Mover compuerta"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:200
msgid "Mover el foco al primero o al último"
msgstr "Mover el foco al primero o al último"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:191
msgid "Mover el foco al widget de ese lado"
msgstr "Mover el foco al widget de ese lado"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:305
msgid "movido"
msgstr "movido"

#: src/fsd/pages/gate-movements/ui/panel/movement-panel.tsx:47
msgid "Movimiento {movementId}"
msgstr "Movimiento {movementId}"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:327
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:172
msgid "Movimiento radial"
msgstr "Movimiento radial"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:329
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:61
msgid "Movimiento radial calculado"
msgstr "Movimiento radial calculado"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:328
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:48
msgid "Movimiento radial sin calibrar"
msgstr "Movimiento radial sin calibrar"

#: src/features/gateOperationModal/components/panelNotification/utils.tsx:204
#: src/fsd/features/gate-movements/ui/panel/events/event-text.tsx:138
msgid "Movimiento validado por el equipo"
msgstr "Movimiento validado por el equipo"

#: src/features/gates/components/list/GateListItemInfo.tsx:49
#: src/fsd/entities/dashboard-widget/model/gate-movements-sample.ts:82
#: src/fsd/pages/gate-movements/ui/back-to-list.tsx:40
#: src/fsd/pages/gate-movements/ui/gate-movements-page.tsx:55
msgid "Movimientos"
msgstr "Movimientos"

#: src/features/gateCommon/components/historyModal/index.tsx:357
#: src/fsd/features/gate-movements/ui/history/history-table.tsx:146
msgid "Movimientos de la compuerta"
msgstr "Movimientos de la compuerta"

#: src/fsd/shared/ui/format/units.ts:265
#: src/utils/units.ts:322
msgid "ms"
msgstr "ms"

#: src/fsd/shared/ui/format/units.ts:250
#: src/utils/units.ts:307
msgid "mS/cm"
msgstr "mS/cm"

#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-editor.tsx:81
msgid "Muestra solo el primer sensor elegido, sin título."
msgstr "Muestra solo el primer sensor elegido, sin título."

#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:152
msgid "Muestra solo tipo, nombre y tamaño: mover y redimensionar es más liviano"
msgstr "Muestra solo tipo, nombre y tamaño: mover y redimensionar es más liviano"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-view.tsx:184
msgid "Muévelas al otro panel para verlas."
msgstr "Muévelas al otro panel para verlas."

#: src/fsd/shared/ui/format/units.ts:225
#: src/utils/units.ts:282
msgid "mV"
msgstr "mV"

#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:136
msgid "N/A"
msgstr "N/A"

#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:226
#: src/fsd/features/gate-movements/ui/operation/connection-status.tsx:60
#: src/fsd/features/gate-movements/ui/operation/connection-status.tsx:74
msgid "N/D"
msgstr "N/D"

#: src/components/ColorPicker/palettes.ts:43
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:41
#: src/fsd/pages/dashboards/ui/board-color/color-names.ts:11
msgid "Naranja"
msgstr "Naranja"

#: src/components/ColorPicker/palettes.ts:44
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:42
msgid "Naranja oscuro"
msgstr "Naranja oscuro"

#: src/fsd/app/locale/au-labels.ts:83
msgid "Navegación del calendario"
msgstr "Navegación del calendario"

#: src/fsd/pages/dashboards/ui/board-header/board-header.tsx:68
msgid "Navegar otros tableros"
msgstr "Navegar otros tableros"

#: src/components/ColorPicker/palettes.ts:56
msgid "Negro"
msgstr "Negro"

#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:167
msgid "Ningún dispositivo coincide con ese texto."
msgstr "Ningún dispositivo coincide con ese texto."

#: src/fsd/pages/dga-reports/ui/device-list.tsx:100
msgid "Ningún dispositivo con configuración DGA coincide con los filtros."
msgstr "Ningún dispositivo con configuración DGA coincide con los filtros."

#: src/fsd/pages/dashboards/ui/board-header/board-switcher.tsx:130
msgid "Ningún tablero coincide con la búsqueda."
msgstr "Ningún tablero coincide con la búsqueda."

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:248
msgid "Ningún tipo de widget de este tablero usa datos de ejemplo todavía: todos siguen mostrando datos reales."
msgstr "Ningún tipo de widget de este tablero usa datos de ejemplo todavía: todos siguen mostrando datos reales."

#: src/features/devicesAccessInputs/components/DevicesAccessForUserInput.tsx:137
#: src/features/devicesAccessInputs/components/UsersAccessForDeviceInput.tsx:180
#: src/features/reports2/components/createModal/steps/step1/MetricsInput.tsx:267
#: src/features/reports2/components/createModal/steps/step1/MultipleCheckbox.tsx:100
msgid "Ninguno"
msgstr "Ninguno"

#: src/fsd/entities/dashboard-widget/ui/dga-tickets/dga-tickets-view.tsx:100
msgid "Ninguno de los dispositivos elegidos tiene un ticket DGA abierto."
msgstr "Ninguno de los dispositivos elegidos tiene un ticket DGA abierto."

#: src/utils/attributes/metricField.ts:257
msgid "nivel"
msgstr "nivel"

#: src/components/PicturePreview.tsx:126
#: src/components/PicturePreview.tsx:137
#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:87
#: src/features/alertsConfigurationV2/components/AlertsConfigurationV2.tsx:92
#: src/features/alertsNotificationsHistory/utils/alertTypes.ts:14
#: src/features/controlCenter/utils/minicharts.ts:306
#: src/features/deviceAlertsModal/components/basicConfigurationTab/FormComponent.tsx:59
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LGCalibrationDisplay.tsx:62
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:342
#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:56
#: src/features/devices2/components/list/itemPanel/DeviceItemMinichart.tsx:345
#: src/features/devicesAnalysis/components/panel/Chart.tsx:311
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAlertLevelsCheckboxList.tsx:51
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarDGACheckboxList.tsx:37
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:73
#: src/features/dga/components/modals/reports/TableModal.tsx:242
#: src/features/publicOrganizationSettingsModal/components/PublicOrganizationSettingsForm.tsx:49
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:9
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:54
#: src/fsd/entities/dashboard-widget/ui/text/text-editor.tsx:31
#: src/fsd/entities/dashboard-widget/ui/text/text-editor.tsx:33
#: src/fsd/pages/dga-reports/ui/measure-labels.ts:35
#: src/hooks/useMinichartOptions.ts:45
#: src/utils/attributes/deviceAlertMetricName.ts:22
#: src/utils/i18n/getMetricDisplayName.ts:10
msgid "Nivel"
msgstr "Nivel"

#: src/features/reports/utils/metricHelpers.ts:21
msgid "Nivel (H)"
msgstr "Nivel (H)"

#: src/utils/i18n/getMetricDisplayName.ts:11
msgid "Nivel (raw)"
msgstr "Nivel (raw)"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:318
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:161
#: src/features/gateAdministration/components/GatePositionChart.tsx:163
#: src/features/gateAdministration/components/index.tsx:512
#: src/features/gateAdministration/components/index.tsx:524
#: src/features/gates/components/list/GateListItemMetrics.tsx:91
#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:18
#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:27
#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:37
msgid "Nivel aguas abajo"
msgstr "Nivel aguas abajo"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:317
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:153
#: src/features/gateAdministration/components/GatePositionChart.tsx:148
#: src/features/gateAdministration/components/index.tsx:483
#: src/features/gateAdministration/components/index.tsx:495
#: src/features/gates/components/list/GateListItemMetrics.tsx:73
#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:17
#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:26
#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:36
msgid "Nivel aguas arriba"
msgstr "Nivel aguas arriba"

#: src/features/echarts/utils/commonSeries.ts:356
msgid "Nivel alto"
msgstr "Nivel alto"

#: src/features/echarts/utils/commonSeries.ts:355
msgid "Nivel bajo"
msgstr "Nivel bajo"

#: src/utils/attributes/metricField.ts:269
msgid "nivel bruto"
msgstr "nivel bruto"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:311
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:35
#: src/features/reports/utils/metricHelpers.ts:22
msgid "Nivel bruto"
msgstr "Nivel bruto"

#: src/fsd/pages/widget-catalog/model/examples.ts:220
msgid "Nivel con 2 decimales"
msgstr "Nivel con 2 decimales"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LevelCalibrationForm.tsx:100
msgid "Nivel de calibración"
msgstr "Nivel de calibración"

#: src/features/audit/utils/parseProperty.ts:135
msgid "nivel de desborde"
msgstr "nivel de desborde"

#: src/features/controlCenter2/components/devicesList/ListItem.tsx:155
#: src/features/devices2/components/list/itemPanel/deviceItemInfo/AlertsIndicator.tsx:69
msgid "Nivel de desborde: {formattedValue}"
msgstr "Nivel de desborde: {formattedValue}"

#: src/utils/attributes/metricField.ts:353
msgid "nivel de nieve"
msgstr "nivel de nieve"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:359
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:268
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:34
#: src/utils/i18n/getMetricDisplayName.ts:37
msgid "Nivel de nieve"
msgstr "Nivel de nieve"

#: src/features/reports/utils/metricHelpers.ts:30
msgid "Nivel de Nieve"
msgstr "Nivel de Nieve"

#: src/utils/attributes/metricField.ts:365
msgid "nivel de nieve bruto"
msgstr "nivel de nieve bruto"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:359
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:221
msgid "Nivel de nieve bruto"
msgstr "Nivel de nieve bruto"

#: src/utils/attributes/metricField.ts:359
msgid "nivel de nieve no calibrado"
msgstr "nivel de nieve no calibrado"

#: src/features/echarts/utils/commonSeries.ts:357
msgid "Nivel desborde"
msgstr "Nivel desborde"

#: src/utils/attributes/metricField.ts:155
msgid "nivel dga"
msgstr "nivel dga"

#: src/features/reports/utils/metricHelpers.ts:15
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:20
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:65
#: src/utils/i18n/getMetricDisplayName.ts:12
msgid "Nivel DGA"
msgstr "Nivel DGA"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:61
msgid "Nivel freático"
msgstr "Nivel freático"

#: src/features/audit/utils/parseProperty.ts:134
msgid "nivel máximo"
msgstr "nivel máximo"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:553
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:365
msgid "Nivel máximo"
msgstr "Nivel máximo"

#: src/features/controlCenter2/components/devicesList/ListItem.tsx:154
#: src/features/devices2/components/list/itemPanel/deviceItemInfo/AlertsIndicator.tsx:67
msgid "Nivel máximo: {formattedValue}"
msgstr "Nivel máximo: {formattedValue}"

#: src/features/audit/utils/parseProperty.ts:133
msgid "nivel mínimo"
msgstr "nivel mínimo"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:547
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:349
msgid "Nivel mínimo"
msgstr "Nivel mínimo"

#: src/features/controlCenter2/components/devicesList/ListItem.tsx:153
#: src/features/devices2/components/list/itemPanel/deviceItemInfo/AlertsIndicator.tsx:65
msgid "Nivel mínimo: {formattedValue}"
msgstr "Nivel mínimo: {formattedValue}"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:79
msgid "Nivel nieve"
msgstr "Nivel nieve"

#: src/features/metricsViews/components/forms/ActiveAlertsForm.tsx:102
msgid "Niveles"
msgstr "Niveles"

#. Análisis de estaciones - Título de acordión
#: src/features/devicesAnalysis/components/panel/sidebar/index.tsx:95
msgid "Niveles de Alerta"
msgstr "Niveles de Alerta"

#: src/features/audit/components/AuditLogDetailsRow.tsx:27
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:102
#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:164
#: src/features/reports2/components/createModal/steps/step5/ReportSummary.tsx:127
#: src/features/reports2/components/ReportTemplatesTable.tsx:226
msgid "No"
msgstr "No"

#: src/features/deviceProfile/components/page/common/InformationGrid.tsx:32
#: src/features/deviceProfile/components/page/DGAInfo.tsx:157
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:417
msgid "No asignado"
msgstr "No asignado"

#: src/features/updateMultipleDevicesTags/components/UpdateMultipleDevicesTagsModal.tsx:253
msgid "No cobrable"
msgstr "No cobrable"

#: src/features/updateMultipleDevicesTags/components/UpdateMultipleDevicesTagsModal.tsx:165
msgid "No cobrables"
msgstr "No cobrables"

#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:117
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:103
msgid "no conectados"
msgstr "no conectados"

#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:116
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:102
#: src/features/homeAmaru/components/shared/CollectionRow.tsx:57
msgid "No conectados"
msgstr "No conectados"

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:117
#: src/features/controlCenter2/utils/alertStates.ts:17
#: src/features/metricsViews/components/widgets/dgaReports/Info.legacy.tsx:44
#: src/features/metricsViews/components/widgets/dgaReports/Info.tsx:90
#: src/fsd/entities/dashboard-widget/model/dga-frequency.ts:54
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:332
msgid "No configurado"
msgstr "No configurado"

#: src/features/dga/components/DgaServiceBarChart.tsx:37
#: src/features/dga/components/DgaServiceBarChart.tsx:62
#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:146
#: src/fsd/pages/dga-reports/ui/dga-service-strip.tsx:36
msgid "No disponible"
msgstr "No disponible"

#: src/fsd/features/gate-movements/ui/operation/gate-operation-modal.tsx:90
msgid "No encontramos esta operación"
msgstr "No encontramos esta operación"

#: src/fsd/pages/gate-movements/ui/states/movement-not-found.tsx:14
msgid "No encontramos este movimiento"
msgstr "No encontramos este movimiento"

#: src/fsd/pages/dashboards/ui/dashboard-editor-page.tsx:126
msgid "No encontramos este tablero"
msgstr "No encontramos este tablero"

#: src/features/devices2/utils/featuresFilter.ts:35
msgid "No es cobrable"
msgstr "No es cobrable"

#: src/fsd/entities/dashboard-widget/model/gate-movements-sample.ts:84
#: src/fsd/entities/dashboard-widget/model/gate-operate-sample.ts:92
#: src/fsd/entities/dashboard-widget/model/gate-sensors-sample.ts:66
msgid "No es compuerta"
msgstr "No es compuerta"

#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:70
msgid "No es posible activar porque faltan valores de configuración. Complete los valores en \"Editar configuración DGA\" y vuelva a intentarlo."
msgstr "No es posible activar porque faltan valores de configuración. Complete los valores en \"Editar configuración DGA\" y vuelva a intentarlo."

#: src/features/homeAmaru/hooks/useUpdateMyCollectionForm.tsx:94
msgid "No estás en la lista de usuarios con acceso. Si guardas así, no podrás ver ni administrar esta colección desde el listado de tu Home. ¿Quieres continuar igual?"
msgstr "No estás en la lista de usuarios con acceso. Si guardas así, no podrás ver ni administrar esta colección desde el listado de tu Home. ¿Quieres continuar igual?"

#: src/features/createMyCollectionModal/hooks/useCreateMyCollectionForm.tsx:94
msgid "No estás en la lista de usuarios con acceso. Vas a crear esta colección sin poder verla ni administrarla tú mismo. ¿Quieres continuar igual?"
msgstr "No estás en la lista de usuarios con acceso. Vas a crear esta colección sin poder verla ni administrarla tú mismo. ¿Quieres continuar igual?"

#: src/features/devices2/components/list/itemPanel/DeviceItemPicture.tsx:135
msgid "No existe imagen para mostrar."
msgstr "No existe imagen para mostrar."

#: src/features/reports/components/creationSection/EditReportTemplate.tsx:22
msgid "No existe una plantilla con ese identificador"
msgstr "No existe una plantilla con ese identificador"

#: src/features/deviceAlertsModal/components/rawDataModal/index.tsx:34
msgid "No existen configuraciones para este dispositivo"
msgstr "No existen configuraciones para este dispositivo"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:226
msgid "No existen curvas de aforo creadas."
msgstr "No existen curvas de aforo creadas."

#: src/features/gates/components/list/GateListItemLastMovement.tsx:24
msgid "No existen datos de movimientos"
msgstr "No existen datos de movimientos"

#: src/features/billing/components/payments/PaymentsTable.tsx:67
msgid "No existen pagos registrados."
msgstr "No existen pagos registrados."

#: src/features/deviceProfile/components/page/Audit.tsx:106
msgid "No existen registros"
msgstr "No existen registros"

#: src/features/billing/components/UpdatePaymentView.tsx:94
msgid "No fue posible actualizar. El periodo de facturación a finalizado para uno o más servicios."
msgstr "No fue posible actualizar. El periodo de facturación a finalizado para uno o más servicios."

#: src/features/billing/components/CreatePaymentView.tsx:189
#: src/features/billing/components/UpdatePaymentView.tsx:225
msgid "No fue posible almacenar la factura."
msgstr "No fue posible almacenar la factura."

#: src/features/deviceConfiguration/components/ConfigurationFileHistoryModal.tsx:109
msgid "No fue posible cargar el historial de archivos de configuración"
msgstr "No fue posible cargar el historial de archivos de configuración"

#: src/features/deviceConfiguration/components/ConfigurationFileHistoryModal.tsx:72
msgid "No fue posible cargar más archivos de configuración"
msgstr "No fue posible cargar más archivos de configuración"

#: src/features/deviceConfiguration/components/ConfigurationFileHistoryModal.tsx:86
#: src/features/deviceConfiguration/components/ConfigurationFileHistoryModal.tsx:89
msgid "No fue posible descargar el archivo de configuración"
msgstr "No fue posible descargar el archivo de configuración"

#: src/features/billing/components/payments/DeletePayment.tsx:36
msgid "No fue posible eliminar el pago. Intente nuevamente."
msgstr "No fue posible eliminar el pago. Intente nuevamente."

#: src/features/billing/components/payments/DeletePayment.tsx:34
msgid "No fue posible eliminar. El periodo de facturación a finalizado para uno o más servicios."
msgstr "No fue posible eliminar. El periodo de facturación a finalizado para uno o más servicios."

#: src/features/billing/components/payments/PaymentRow.tsx:180
msgid "No fue posible encontrar la dirección de la factura."
msgstr "No fue posible encontrar la dirección de la factura."

#: src/features/users/utils/filterOptions.ts:134
msgid "No ha accedido nunca"
msgstr "No ha accedido nunca"

#: src/features/standardDesign/components/StandardMenu.tsx:84
msgid "No hay acciones disponibles"
msgstr "No hay acciones disponibles"

#: src/features/deviceProfile/components/modal/RecentActivity.tsx:60
#: src/features/userProfile/components/UserProfileAuditLogs.tsx:56
msgid "No hay actividad reciente"
msgstr "No hay actividad reciente"

#: src/features/deviceProfile/components/page/Alerts.tsx:49
#: src/features/devices2/components/list/itemPanel/deviceItemInfo/AlertsIndicator.tsx:31
msgid "No hay alertas configuradas"
msgstr "No hay alertas configuradas"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:152
msgid "No hay alertas configuradas para este dispositivo"
msgstr "No hay alertas configuradas para este dispositivo"

#: src/features/deviceProfile/components/page/Alerts.tsx:149
msgid "No hay alertas gatilladas"
msgstr "No hay alertas gatilladas"

#: src/features/alertsConfigurationV2/components/AlertList.tsx:118
msgid "No hay alertas que coincidan con los criterios de búsqueda."
msgstr "No hay alertas que coincidan con los criterios de búsqueda."

#: src/features/deviceConfiguration/components/ConfigurationFileHistoryModal.tsx:115
msgid "No hay archivos de configuración históricos para este equipo"
msgstr "No hay archivos de configuración históricos para este equipo"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/index.tsx:68
msgid "No hay calibraciones para este dispositivo"
msgstr "No hay calibraciones para este dispositivo"

#: src/features/metricsViews/components/AssociateCollectionModal.tsx:191
msgid "No hay colecciones disponibles sin vista asociada"
msgstr "No hay colecciones disponibles sin vista asociada"

#: src/features/collections/components/CollectionsTable.tsx:240
msgid "No hay colecciones que coincidan con los criterios de búsqueda."
msgstr "No hay colecciones que coincidan con los criterios de búsqueda."

#: src/features/alertsConfiguration/components/AlertRow.tsx:95
msgid "No hay configuración activa"
msgstr "No hay configuración activa"

#: src/features/changeOperationalState/components/AfterUpdateTasksModal.tsx:196
msgid "No hay configuraciones activas"
msgstr "No hay configuraciones activas"

#: src/features/reports2/components/createModal/steps/step3/3-FormatAndRecipients.tsx:385
msgid "No hay contactos guardados disponibles"
msgstr "No hay contactos guardados disponibles"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:172
#: src/features/deviceProfile/components/page/Support.tsx:167
#: src/features/devices2/components/list/itemPanel/SMAItemChart.tsx:70
#: src/features/dga/components/modals/reports/TableModal.tsx:168
#: src/features/events/components/EventsTable.tsx:123
#: src/features/gateAdministration/components/index.tsx:164
#: src/features/gateAdministration/components/index.tsx:449
#: src/features/gateAdministration/components/index.tsx:488
#: src/features/gateAdministration/components/index.tsx:517
#: src/features/gateAdministration/components/MovementHistory.tsx:34
#: src/features/gates/components/list/GateListItemMetrics.tsx:130
#: src/features/metricsViews/components/widgets/DataWidget.tsx:472
#: src/features/metricsViews/components/widgets/TableWidget.tsx:93
#: src/features/sma/components/TableModal.tsx:201
#: src/fsd/entities/dashboard-widget/ui/data/data-view.tsx:83
msgid "No hay datos"
msgstr "No hay datos"

#: src/features/gates/components/list/GateListItemMinichart.tsx:118
msgid "No hay datos de energía en las últimas 6 horas"
msgstr "No hay datos de energía en las últimas 6 horas"

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:269
msgid "No hay datos de envíos DGA para mostrar."
msgstr "No hay datos de envíos DGA para mostrar."

#: src/features/deviceProfile/components/page/events/index.tsx:157
msgid "No hay datos de eventos los últimos 3 meses"
msgstr "No hay datos de eventos los últimos 3 meses"

#: src/features/metricsViews/components/widgets/movementsTable/index.tsx:211
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:344
msgid "No hay datos de movimientos los últimos 30 días"
msgstr "No hay datos de movimientos los últimos 30 días"

#: src/features/alertsConfigurationV2/components/AlertConfigurationPreview.tsx:188
#: src/features/alertsConfigurationV3/components/wizard/AlertConfigurationPreview.tsx:193
msgid "No hay datos disponibles para previsualizar"
msgstr "No hay datos disponibles para previsualizar"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-view.tsx:145
msgid "No hay datos en el período"
msgstr "No hay datos en el período"

#: src/features/controlCenter/components/panel/Minicharts.tsx:68
msgid "No hay datos en el rango de tiempo seleccionado"
msgstr "No hay datos en el rango de tiempo seleccionado"

#: src/features/devices2/components/list/itemPanel/DeviceItemMinichart.tsx:431
msgid "No hay datos en las últimas 6 horas"
msgstr "No hay datos en las últimas 6 horas"

#: src/features/gateAdministration/components/GatePositionChart.tsx:25
msgid "No hay datos para mostrar"
msgstr "No hay datos para mostrar"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:129
msgid "no hay datos registrados"
msgstr "no hay datos registrados"

#: src/features/gateAdministration/components/index.tsx:497
#: src/features/gateAdministration/components/index.tsx:526
msgid "No hay datos registrados"
msgstr "No hay datos registrados"

#: src/features/gateOperationModal/components/GateOperationModal.tsx:186
msgid "No hay dispositivo seleccionado"
msgstr "No hay dispositivo seleccionado"

#: src/features/integrations/components/devicesList/index.tsx:61
msgid "No hay dispositivos <0>con problemas</0>"
msgstr "No hay dispositivos <0>con problemas</0>"

#: src/features/alertsConfigurationV3/components/AlertsConfigurationV3.tsx:108
msgid "No hay dispositivos con alertas configuradas"
msgstr "No hay dispositivos con alertas configuradas"

#: src/fsd/pages/dga-reports/ui/device-list.tsx:97
msgid "No hay dispositivos para mostrar"
msgstr "No hay dispositivos para mostrar"

#: src/features/devices2/components/DeviceList.tsx:69
msgid "No hay dispositivos que coincidan con los criterios de búsqueda."
msgstr "No hay dispositivos que coincidan con los criterios de búsqueda."

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:486
msgid "No hay dispositivos seleccionados"
msgstr "No hay dispositivos seleccionados"

#: src/features/alertsConfigurationV3/components/AlertsConfigurationV3.tsx:159
msgid "No hay dispositivos sin configurar"
msgstr "No hay dispositivos sin configurar"

#: src/fsd/pages/dashboards/ui/layout-warnings/warning-text.ts:24
msgid "No hay distribución guardada para teléfono; se arma desde la de escritorio."
msgstr "No hay distribución guardada para teléfono; se arma desde la de escritorio."

#: src/features/billing/components/table/DevicesTable.tsx:110
msgid "No hay equipos configurados en este proyecto, dirígete a <0>configuración de equipos</0> para agregar proyectos a los dispositivos."
msgstr "No hay equipos configurados en este proyecto, dirígete a <0>configuración de equipos</0> para agregar proyectos a los dispositivos."

#: src/features/controlCenter/components/window/StationList.tsx:50
msgid "No hay estaciones para mostrar"
msgstr "No hay estaciones para mostrar"

#: src/features/deviceCommands/components/custom/DevicesSelector.tsx:26
msgid "No hay estaciones..."
msgstr "No hay estaciones..."

#: src/fsd/entities/dashboard-widget/ui/table/table-view.tsx:105
msgid "No hay filas en el período"
msgstr "No hay filas en el período"

#: src/features/deviceConfiguration/components/TriggerConfigUpdateModal.tsx:123
msgid "No hay información de estado disponible"
msgstr "No hay información de estado disponible"

#: src/features/integrations/components/groupedIssuesModal/GroupedLogsTable.tsx:79
msgid "No hay logs disponibles para esta entidad"
msgstr "No hay logs disponibles para esta entidad"

#: src/features/integrations/components/groupedIssuesModal/GroupedLogsTable.tsx:75
msgid "No hay logs disponibles para esta integracion"
msgstr "No hay logs disponibles para esta integracion"

#: src/features/integrations/components/groupedIssuesModal/GroupedLogsTable.tsx:77
msgid "No hay logs disponibles para este dispositivo"
msgstr "No hay logs disponibles para este dispositivo"

#: src/features/deviceProfile/components/page/Audit.tsx:217
msgid "No hay más registros para este dispositivo"
msgstr "No hay más registros para este dispositivo"

#: src/features/gateAdministration/components/MovementHistory.tsx:138
msgid "No hay movimientos registrados"
msgstr "No hay movimientos registrados"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:308
msgid "No hay notificaciones asociadas a este equipo"
msgstr "No hay notificaciones asociadas a este equipo"

#: src/features/notifications/components/popup/MenuList.tsx:218
msgid "No hay notificaciones nuevas"
msgstr "No hay notificaciones nuevas"

#: src/features/integrations/utils/writeExecutionLogCodeTranslations.ts:14
msgid "No hay nuevos datos del dispositivo"
msgstr "No hay nuevos datos del dispositivo"

#: src/features/deviceProfile/components/modal/Observations.tsx:90
#: src/features/deviceProfile/components/page/Observations.tsx:104
msgid "No hay observaciones"
msgstr "No hay observaciones"

#: src/features/billing/components/table/ProjectsTable.tsx:113
msgid "No hay recurrentes asociados al proyecto"
msgstr "No hay recurrentes asociados al proyecto"

#: src/features/audit/components/AuditLogsTimeline.tsx:147
msgid "No hay registros de auditoría con los filtros seleccionados"
msgstr "No hay registros de auditoría con los filtros seleccionados"

#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-view.tsx:93
msgid "No hay reportes DGA del dispositivo para graficar."
msgstr "No hay reportes DGA del dispositivo para graficar."

#: src/features/userProfile/components/UserProfile.tsx:117
msgid "No hay teléfono registrado"
msgstr "No hay teléfono registrado"

#: src/features/deviceProfile/components/page/Permissions.tsx:49
msgid "No hay usuarios con acceso al dispositivo"
msgstr "No hay usuarios con acceso al dispositivo"

#: src/features/alertsConfigurationV3/components/wizard/steps/NotificationsStep.tsx:129
msgid "No hay usuarios disponibles para notificar"
msgstr "No hay usuarios disponibles para notificar"

#: src/features/users/components/UsersTable.tsx:187
msgid "No hay usuarios que coincidan con los criterios de búsqueda."
msgstr "No hay usuarios que coincidan con los criterios de búsqueda."

#: src/features/metricsViews/components/MetricsView.tsx:709
msgid "No hay widgets configurados"
msgstr "No hay widgets configurados"

#: src/features/metricsViews/components/MetricsView.tsx:802
msgid "No hay widgets configurados para este tamaño de pantalla"
msgstr "No hay widgets configurados para este tamaño de pantalla"

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:372
msgid "No hubo reportes DGA del dispositivo en el período ({period}): no hay porcentajes que mostrar."
msgstr "No hubo reportes DGA del dispositivo en el período ({period}): no hay porcentajes que mostrar."

#: src/features/devices2/utils/featuresFilter.ts:41
msgid "No informado"
msgstr "No informado"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:296
msgid "No invasivo"
msgstr "No invasivo"

#: src/features/integrations/utils/monitoredTargetResponseStatusAttributes.ts:45
#: src/features/integrations/utils/monitoredTargetResponseStatusAttributes.ts:52
#: src/features/integrations/utils/monitoredTargetResponseStatusAttributes.ts:69
#: src/fsd/entities/dashboard-widget/model/dga-reports-sample.ts:74
msgid "No operativo"
msgstr "No operativo"

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:14
msgid "No pude interpretar el pedido. Intenta reformularlo con más detalle."
msgstr "No pude interpretar el pedido. Intenta reformularlo con más detalle."

#: src/features/alertsConfigurationV3/components/wizard/steps/MetricStep.tsx:97
msgid "No pudimos cargar las métricas de este dispositivo."
msgstr "No pudimos cargar las métricas de este dispositivo."

#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:122
msgid "No puedes crear una plantilla con periodo absoluto"
msgstr "No puedes crear una plantilla con periodo absoluto"

#: src/features/reports/components/creationSection/EditReportTemplateDialog.tsx:98
msgid "No puedes guardar una plantilla con periodo absoluto"
msgstr "No puedes guardar una plantilla con periodo absoluto"

#: src/features/billing/utils/translations.ts:43
#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:25
#: src/fsd/features/gate-movements/ui/operation/operation-summary.tsx:60
#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:90
msgid "No registrado"
msgstr "No registrado"

#: src/features/integrations/utils/writeExecutionLogCodeTranslations.ts:16
msgid "No se encontraron archivos"
msgstr "No se encontraron archivos"

#: src/features/homeAmaru/components/HomeAmaru.tsx:208
msgid "No se encontraron colecciones para la búsqueda."
msgstr "No se encontraron colecciones para la búsqueda."

#: src/features/integrations/utils/writeExecutionLogCodeTranslations.ts:20
msgid "No se encontraron datos de integración"
msgstr "No se encontraron datos de integración"

#: src/features/integrations/utils/writeExecutionLogCodeTranslations.ts:7
msgid "No se encontraron datos del dispositivo"
msgstr "No se encontraron datos del dispositivo"

#: src/features/integrations/utils/writeExecutionLogCodeTranslations.ts:21
msgid "No se encontraron datos del dispositivo en InfluxDB"
msgstr "No se encontraron datos del dispositivo en InfluxDB"

#: src/features/integrations/utils/writeExecutionLogCodeTranslations.ts:11
msgid "No se encontraron datos específicos del dispositivo"
msgstr "No se encontraron datos específicos del dispositivo"

#: src/features/collections/components/modals/AddCollectionAccessModal.tsx:79
#: src/features/collections/components/modals/ManageCollectionAccessModal.tsx:82
msgid "No se encontraron dispositivos"
msgstr "No se encontraron dispositivos"

#: src/features/collections/components/modals/AddCollectionAccessModal.tsx:153
#: src/features/collections/components/modals/ManageCollectionAccessModal.tsx:154
msgid "No se encontraron usuarios"
msgstr "No se encontraron usuarios"

#: src/features/announcements/components/AnnouncementView.tsx:34
msgid "No se encontró el anuncio"
msgstr "No se encontró el anuncio"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:405
msgid "No se envió la notificación correctamente"
msgstr "No se envió la notificación correctamente"

#: src/features/metricsViews/components/MetricsViewErrorBoundary.tsx:26
msgid "No se ha configurado la visualización de métricas para este dispositivo"
msgstr "No se ha configurado la visualización de métricas para este dispositivo"

#: src/components/tooltips/UserTooltip.tsx:101
msgid "No se ha encontrado al usuario con id {userId}"
msgstr "No se ha encontrado al usuario con id {userId}"

#: src/features/metricsViews/components/EditViewModal.tsx:94
msgid "No se ha encontrado el dispositivo {id}"
msgstr "No se ha encontrado el dispositivo {id}"

#: src/components/tooltips/DeviceTooltip.tsx:71
msgid "No se ha encontrado el dispositivo con id {deviceId}"
msgstr "No se ha encontrado el dispositivo con id {deviceId}"

#: src/features/billing/components/projectService/Create.tsx:68
msgid "No se ha encontrado ningún proyecto con el ID ingresado."
msgstr "No se ha encontrado ningún proyecto con el ID ingresado."

#: src/features/reports/components/CreatedReportNotification.tsx:46
msgid "No se ha podido completar la creación de reporte."
msgstr "No se ha podido completar la creación de reporte."

#: src/features/deviceProfile/components/page/Support.tsx:157
msgid "No se ha registrado un proveedor en configuración de equipos"
msgstr "No se ha registrado un proveedor en configuración de equipos"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:402
msgid "No se han configurado filtros."
msgstr "No se han configurado filtros."

#: src/features/gateCommon/utils/gateCommandOutcome.ts:147
#: src/fsd/entities/gate/model/command-outcome.ts:146
msgid "No se inició una operación porque no hacía falta mover la compuerta."
msgstr "No se inició una operación porque no hacía falta mover la compuerta."

#: src/fsd/pages/dashboards/ui/keyboard/use-clipboard.ts:125
msgid "No se pegó: a un widget le faltan datos obligatorios."
msgstr "No se pegó: a un widget le faltan datos obligatorios."

#: src/fsd/pages/dashboards/ui/keyboard/use-clipboard.ts:121
msgid "No se pegó: el contenido copiado no es seguro."
msgstr "No se pegó: el contenido copiado no es seguro."

#: src/fsd/pages/dashboards/ui/keyboard/use-clipboard.ts:117
msgid "No se pegó: el contenido del portapapeles es demasiado grande."
msgstr "No se pegó: el contenido del portapapeles es demasiado grande."

#: src/fsd/pages/dashboards/ui/keyboard/use-clipboard.ts:113
msgid "No se pegó: el portapapeles no trae widgets de este editor."
msgstr "No se pegó: el portapapeles no trae widgets de este editor."

#: src/fsd/pages/dashboards/ui/keyboard/use-clipboard.ts:123
msgid "No se pegó: hay widgets de un tipo que no existe."
msgstr "No se pegó: hay widgets de un tipo que no existe."

#: src/fsd/pages/dashboards/ui/keyboard/use-clipboard.ts:133
msgid "No se pegó: las imágenes solo se pueden pegar en el tablero de origen."
msgstr "No se pegó: las imágenes solo se pueden pegar en el tablero de origen."

#: src/fsd/pages/dashboards/ui/keyboard/use-clipboard.ts:127
msgid "No se pegó: las posiciones de los widgets no son válidas."
msgstr "No se pegó: las posiciones de los widgets no son válidas."

#: src/fsd/pages/dashboards/ui/keyboard/use-clipboard.ts:115
msgid "No se pegó: los widgets copiados tienen un formato de otra versión."
msgstr "No se pegó: los widgets copiados tienen un formato de otra versión."

#: src/fsd/pages/dashboards/ui/keyboard/use-clipboard.ts:119
msgid "No se pegó: son demasiados widgets de una vez."
msgstr "No se pegó: son demasiados widgets de una vez."

#: src/fsd/pages/dashboards/ui/keyboard/use-clipboard.ts:130
msgid "No se pegó: un widget usa un dispositivo que no está en la lista de este tablero."
msgstr "No se pegó: un widget usa un dispositivo que no está en la lista de este tablero."

#: src/features/dgaTicket/components/DgaTicketModal.tsx:115
msgid "No se podrá reabrir ni corregir."
msgstr "No se podrá reabrir ni corregir."

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:259
msgid "No se pudieron cargar los envíos DGA"
msgstr "No se pudieron cargar los envíos DGA"

#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:321
msgid "No se pudieron cargar los movimientos"
msgstr "No se pudieron cargar los movimientos"

#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-view.tsx:87
msgid "No se pudieron cargar los reportes DGA"
msgstr "No se pudieron cargar los reportes DGA"

#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-view.tsx:184
msgid "No se pudieron cargar los sensores"
msgstr "No se pudieron cargar los sensores"

#: src/fsd/entities/dashboard-widget/ui/dga-tickets/dga-tickets-view.tsx:147
msgid "No se pudieron cargar los tickets DGA"
msgstr "No se pudieron cargar los tickets DGA"

#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:244
msgid "No se pudieron descargar los reportes"
msgstr "No se pudieron descargar los reportes"

#: src/features/metricsViews/components/AssociateCollectionModal.tsx:202
msgid "No se pudieron leer los dispositivos de la colección"
msgstr "No se pudieron leer los dispositivos de la colección"

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:128
msgid "No se pudo abrir el editor de este widget."
msgstr "No se pudo abrir el editor de este widget."

#: src/features/dga/components/modals/tabs/MaxFlowTab.tsx:33
msgid "No se pudo actualizar el caudal máximo"
msgstr "No se pudo actualizar el caudal máximo"

#: src/features/alertsConfigurationV3/hooks/useAlertLifecycleV3.ts:68
msgid "No se pudo actualizar la alerta: {0}"
msgstr "No se pudo actualizar la alerta: {0}"

#: src/fsd/pages/dashboards/ui/status-strip/status-strip.tsx:91
msgid "No se pudo actualizar."
msgstr "No se pudo actualizar."

#: src/features/users/components/modals/SimulateUserShortcutModal.tsx:44
msgid "No se pudo buscar usuarios"
msgstr "No se pudo buscar usuarios"

#: src/fsd/entities/dashboard-widget/ui/data/data-view.tsx:79
msgid "No se pudo cargar el dato"
msgstr "No se pudo cargar el dato"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-view.tsx:141
msgid "No se pudo cargar el gráfico"
msgstr "No se pudo cargar el gráfico"

#: src/fsd/features/gate-movements/ui/list/gate-movements-modal.tsx:89
msgid "No se pudo cargar el historial de movimientos"
msgstr "No se pudo cargar el historial de movimientos"

#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:184
msgid "No se pudo cargar el listado de dispositivos."
msgstr "No se pudo cargar el listado de dispositivos."

#: src/fsd/pages/dashboards/ui/dashboard-editor-page.tsx:134
msgid "No se pudo cargar el tablero"
msgstr "No se pudo cargar el tablero"

#: src/fsd/pages/dga-reports/ui/page-error-boundary.tsx:30
#: src/fsd/pages/gate-movements/ui/page-error-boundary.tsx:21
msgid "No se pudo cargar esta sección"
msgstr "No se pudo cargar esta sección"

#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:283
msgid "No se pudo cargar la compuerta"
msgstr "No se pudo cargar la compuerta"

#: src/features/alertsConfigurationV3/components/ListPlaceholders.tsx:69
msgid "No se pudo cargar la lista de dispositivos"
msgstr "No se pudo cargar la lista de dispositivos"

#: src/fsd/pages/dashboards/ui/dashboards-page.tsx:27
msgid "No se pudo cargar la lista de tableros"
msgstr "No se pudo cargar la lista de tableros"

#: src/fsd/entities/dashboard-widget/ui/table/table-view.tsx:101
msgid "No se pudo cargar la tabla"
msgstr "No se pudo cargar la tabla"

#: src/pages/AuthorizationRequired.tsx:38
msgid "No se pudo cerrar sesión"
msgstr "No se pudo cerrar sesión"

#: src/features/gateCommon/utils/gateCommandOutcome.ts:153
#: src/fsd/entities/gate/model/command-outcome.ts:154
msgid "No se pudo confirmar el resultado: la compuerta podría estar moviéndose. Verifique su estado antes de reintentar."
msgstr "No se pudo confirmar el resultado: la compuerta podría estar moviéndose. Verifique su estado antes de reintentar."

#: src/features/gateCommon/hooks/useStopGateOperation.ts:35
#: src/fsd/entities/gate/model/command-feedback.ts:52
msgid "No se pudo confirmar si se canceló la solicitud en cola."
msgstr "No se pudo confirmar si se canceló la solicitud en cola."

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:30
msgid "No se pudo contactar al asistente. Revisa la conexión e intenta de nuevo."
msgstr "No se pudo contactar al asistente. Revisa la conexión e intenta de nuevo."

#: src/fsd/pages/widget-catalog/ui/config-code.tsx:56
msgid "No se pudo copiar"
msgstr "No se pudo copiar"

#: src/fsd/pages/dga-reports/ui/latest-reports.tsx:281
msgid "No se pudo copiar el comprobante"
msgstr "No se pudo copiar el comprobante"

#: src/fsd/pages/gate-movements/ui/panel/copy-link-button.tsx:41
msgid "No se pudo copiar el enlace"
msgstr "No se pudo copiar el enlace"

#: src/features/alertsConfigurationV3/hooks/useAlertLifecycleV3.ts:38
msgid "No se pudo crear la alerta: {0}"
msgstr "No se pudo crear la alerta: {0}"

#: src/features/alertsConfigurationV3/hooks/useAlertLifecycleV3.ts:52
msgid "No se pudo desactivar la alerta: {0}"
msgstr "No se pudo desactivar la alerta: {0}"

#: src/features/alertsConfigurationV3/hooks/useAlertLifecycleV3.ts:45
msgid "No se pudo eliminar la alerta: {0}"
msgstr "No se pudo eliminar la alerta: {0}"

#: src/features/collections/components/modals/DeleteCollectionModal.tsx:52
msgid "No se pudo eliminar la colección"
msgstr "No se pudo eliminar la colección"

#: src/features/collections/components/modals/DeleteCollectionModal.tsx:43
msgid "No se pudo eliminar la colección. Inténtalo de nuevo."
msgstr "No se pudo eliminar la colección. Inténtalo de nuevo."

#: src/components/gates/StopMovementConfirmation.tsx:92
msgid "No se pudo enviar el comando"
msgstr "No se pudo enviar el comando"

#: src/features/gateAdministration/components/MoveGate.tsx:94
msgid "No se pudo enviar el comando de movimiento a la compuerta"
msgstr "No se pudo enviar el comando de movimiento a la compuerta"

#: src/features/recoveryPassword/components/RecoveryPassword.tsx:42
msgid "No se pudo enviar el correo electrónico. Verifique que el correo sea el correcto"
msgstr "No se pudo enviar el correo electrónico. Verifique que el correo sea el correcto"

#: src/fsd/pages/dashboards/ui/report-problem/report-problem-dialog.tsx:145
msgid "No se pudo enviar el reporte. Inténtalo de nuevo."
msgstr "No se pudo enviar el reporte. Inténtalo de nuevo."

#: src/features/metricsViews/hooks/useExportMetricsView.ts:160
msgid "No se pudo exportar el tablero."
msgstr "No se pudo exportar el tablero."

#: src/fsd/app/locale/language-select.tsx:68
msgid "No se pudo guardar el idioma"
msgstr "No se pudo guardar el idioma"

#: src/features/homeAmaru/hooks/useHomeAmaruFavoriteView.ts:39
msgid "No se pudo guardar la vista favorita"
msgstr "No se pudo guardar la vista favorita"

#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:86
msgid "No se pudo guardar: «{name}» tiene un valor no válido. Tus cambios siguen en esta pantalla."
msgstr "No se pudo guardar: «{name}» tiene un valor no válido. Tus cambios siguen en esta pantalla."

#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:79
msgid "No se pudo guardar: «{name}» tiene una imagen que no pertenece a este tablero. Tus cambios siguen en esta pantalla."
msgstr "No se pudo guardar: «{name}» tiene una imagen que no pertenece a este tablero. Tus cambios siguen en esta pantalla."

#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:72
msgid "No se pudo guardar: «{name}» usa un dispositivo que no está en este tablero. Tus cambios siguen en esta pantalla."
msgstr "No se pudo guardar: «{name}» usa un dispositivo que no está en este tablero. Tus cambios siguen en esta pantalla."

#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:113
msgid "No se pudo guardar: {message}. Tus cambios siguen en esta pantalla."
msgstr "No se pudo guardar: {message}. Tus cambios siguen en esta pantalla."

#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:64
msgid "No se pudo guardar: un widget tiene un valor no válido. Tus cambios siguen en esta pantalla."
msgstr "No se pudo guardar: un widget tiene un valor no válido. Tus cambios siguen en esta pantalla."

#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:117
msgid "No se pudo guardar. Revisa la conexión e inténtalo de nuevo; tus cambios siguen en esta pantalla."
msgstr "No se pudo guardar. Revisa la conexión e inténtalo de nuevo; tus cambios siguen en esta pantalla."

#: src/fsd/pages/dga-reports/ui/report-problem-dialog.tsx:179
msgid "No se pudo ingresar el ticket"
msgstr "No se pudo ingresar el ticket"

#: src/fsd/pages/dashboards/ui/dashboard-editor-page.tsx:728
msgid "No se pudo mostrar el panel de edición"
msgstr "No se pudo mostrar el panel de edición"

#: src/fsd/pages/dashboards/ui/dashboard-editor-page.tsx:594
msgid "No se pudo mostrar el tablero"
msgstr "No se pudo mostrar el tablero"

#: src/fsd/pages/dashboards/ui/canvas/canvas.tsx:542
msgid "No se pudo mostrar este widget."
msgstr "No se pudo mostrar este widget."

#: src/features/alertsConfigurationV3/hooks/useAlertLifecycleV3.ts:59
msgid "No se pudo reactivar la alerta: {0}"
msgstr "No se pudo reactivar la alerta: {0}"

#: src/features/users/components/modals/SimulateUserModal.tsx:39
#: src/features/users/components/modals/SimulateUserModal.tsx:53
#: src/features/users/components/modals/SimulateUserShortcutModal.tsx:68
#: src/features/users/components/modals/SimulateUserShortcutModal.tsx:82
msgid "No se pudo simular al usuario"
msgstr "No se pudo simular al usuario"

#: src/features/dga/components/modals/DgaOrganizationAccessWarning.tsx:48
msgid "No se pudo verificar el acceso a la sección Reportes DGA de la organización."
msgstr "No se pudo verificar el acceso a la sección Reportes DGA de la organización."

#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:63
msgid "No se puede crear. Faltan valores importantes para la creación. Por favor, intente nuevamente."
msgstr "No se puede crear. Faltan valores importantes para la creación. Por favor, intente nuevamente."

#: src/features/collections/components/modals/DeleteCollectionModal.tsx:38
msgid "No se puede eliminar la colección porque tiene dispositivos o cuentas asociadas. Elimínalos primero."
msgstr "No se puede eliminar la colección porque tiene dispositivos o cuentas asociadas. Elimínalos primero."

#: src/features/deviceConfigurationModal/components/aliasModal/DeviceAliasModal.tsx:51
msgid "No se pueden repetir organizaciones"
msgstr "No se pueden repetir organizaciones"

#: src/features/gateCommon/hooks/useStopGateOperation.ts:78
#: src/fsd/entities/gate/model/command-feedback.ts:36
msgid "No se recibió respuesta al comando de detención."
msgstr "No se recibió respuesta al comando de detención."

#: src/features/moveGateModal/hooks/useMoveGate.ts:112
#: src/fsd/entities/gate/model/command-feedback.ts:117
msgid "No se recibió respuesta al comando de movimiento."
msgstr "No se recibió respuesta al comando de movimiento."

#: src/features/createMyCollectionModal/hooks/useCreateMyCollectionForm.tsx:92
msgid "No tendrás acceso a esta colección"
msgstr "No tendrás acceso a esta colección"

#: src/fsd/pages/dashboards/ui/layout-warnings/warning-text.ts:17
msgid "No tiene celda guardada; se muestra al final."
msgstr "No tiene celda guardada; se muestra al final."

#: src/components/ModalTabs.tsx:150
msgid "No tienes acceso a ninguna de las pestañas"
msgstr "No tienes acceso a ninguna de las pestañas"

#: src/fsd/features/gate-movements/ui/list/gate-movements-modal.tsx:70
msgid "No tienes acceso al historial de esta compuerta"
msgstr "No tienes acceso al historial de esta compuerta"

#: src/features/homeAmaru/components/HomeAmaru.tsx:206
msgid "No tienes colecciones asignadas."
msgstr "No tienes colecciones asignadas."

#: src/features/gates/components/AlarmSystem.tsx:85
msgid "No tienes permiso para cambiar la alarma de esta compuerta"
msgstr "No tienes permiso para cambiar la alarma de esta compuerta"

#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:106
msgid "No tienes permiso para guardar tableros: hace falta ser administrador de Capta. Tus cambios siguen en esta pantalla."
msgstr "No tienes permiso para guardar tableros: hace falta ser administrador de Capta. Tus cambios siguen en esta pantalla."

#: src/features/gateAdministration/components/index.tsx:399
#: src/features/gateAdministration/components/RequestedPositionIcon.tsx:64
#: src/features/gateOperationModal/components/PanelOperation.tsx:371
#: src/features/metricsViews/components/widgets/gateOperate/OperateButtons.tsx:164
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:191
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:248
#: src/fsd/features/gate-movements/ui/operation/stop-button.tsx:51
msgid "No tienes permiso para operar esta compuerta"
msgstr "No tienes permiso para operar esta compuerta"

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:24
msgid "No tienes permiso para usar el asistente."
msgstr "No tienes permiso para usar el asistente."

#: src/pages/AuthorizationRequired.tsx:59
msgid "No tienes permisos para acceder a esta página"
msgstr "No tienes permisos para acceder a esta página"

#: src/features/createMyCollectionModal/hooks/useCreateMyCollectionForm.tsx:56
msgid "No tienes permisos para crear colecciones"
msgstr "No tienes permisos para crear colecciones"

#: src/features/deviceConfigurationModal/components/gateTab/CreateLinkedDeviceButton.tsx:63
msgid "No tienes permisos para realizar esta acción"
msgstr "No tienes permisos para realizar esta acción"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:131
msgid "No tienes series agregadas"
msgstr "No tienes series agregadas"

#: src/components/ClientHiddenChip.tsx:49
msgid "No visible para clientes por su estado operacional."
msgstr "No visible para clientes por su estado operacional."

#: src/features/audit/utils/parseProperty.ts:20
msgid "nombre"
msgstr "nombre"

#: src/components/PicturePreview.tsx:117
#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:141
#: src/features/alertsConfiguration/components/AlertTable.tsx:192
#: src/features/alertsConfigurationV2/components/AlertList.tsx:156
#: src/features/alertsConfigurationV3/components/wizard/steps/NotificationsStep.tsx:144
#: src/features/billing/components/table/DevicesTable.tsx:149
#: src/features/collections/components/CollectionsTable.tsx:53
#: src/features/collections/components/modals/CreateCollectionModal.tsx:87
#: src/features/collections/components/modals/UpdateCollectionModal.tsx:113
#: src/features/createDevice/components/form/index.tsx:46
#: src/features/createMyCollectionModal/components/CreateMyCollectionModal.tsx:55
#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:221
#: src/features/deviceProfile/components/page/General.tsx:34
#: src/features/devicesGraveyard/components/DevicesGraveyard.tsx:128
#: src/features/deviceSupport/data/column.ts:27
#: src/features/deviceSupport/data/fields.ts:8
#: src/features/homeAmaru/components/shared/UpdateMyCollectionModal.tsx:63
#: src/features/metricsViews/components/MetricsViewList.tsx:138
#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:207
#: src/features/organizationsManagement/components/OrganizationsTable.tsx:90
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:301
#: src/features/reports2/components/ReportTemplatesTable.tsx:68
#: src/features/sma/components/forFutureUse/TableSmaUnit.tsx:37
#: src/features/updateMultipleDevicesTags/components/UpdateMultipleDevicesTagsModal.tsx:178
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:291
#: src/features/users/components/modals/SaveUserModal.tsx:127
#: src/features/userSaveModal/components/UserSaveModal.tsx:345
#: src/features/usersGraveyard/components/UsersGraveyard.tsx:111
#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:128
msgid "Nombre"
msgstr "Nombre"

#: src/features/devices2/utils/getOrderByOptions.ts:9
#: src/features/gates/components/Gates.tsx:50
#: src/features/metricsViews/utils/getMetricsViewsOrderByOptions.ts:17
#: src/features/users/utils/filterOptions.ts:36
#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:32
msgid "Nombre (A-Z)"
msgstr "Nombre (A-Z)"

#: src/features/devices2/utils/getOrderByOptions.ts:13
#: src/features/gates/components/Gates.tsx:51
#: src/features/metricsViews/utils/getMetricsViewsOrderByOptions.ts:21
#: src/features/users/utils/filterOptions.ts:43
#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:33
msgid "Nombre (Z-A)"
msgstr "Nombre (Z-A)"

#: src/features/alertsNotificationsHistory/utils/dataToTable.ts:14
msgid "Nombre de dispositivo"
msgstr "Nombre de dispositivo"

#: src/features/audit/utils/parseProperty.ts:97
msgid "nombre de hardware satelital"
msgstr "nombre de hardware satelital"

#: src/features/audit/utils/parseProperty.ts:32
msgid "nombre de ICN"
msgstr "nombre de ICN"

#: src/features/reports/components/creationSection/EditReportTemplateDialog.tsx:146
msgid "Nombre de la plantilla"
msgstr "Nombre de la plantilla"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:283
msgid "Nombre de la serie"
msgstr "Nombre de la serie"

#: src/features/metricsViews/components/EditViewModal.tsx:126
msgid "Nombre de la vista"
msgstr "Nombre de la vista"

#: src/features/audit/utils/parseProperty.ts:26
msgid "nombre de organización"
msgstr "nombre de organización"

#: src/features/reports/components/creationSection/CreateReportTemplateDialog.tsx:166
msgid "Nombre de plantilla"
msgstr "Nombre de plantilla"

#: src/features/audit/utils/parseProperty.ts:45
msgid "nombre de proyecto"
msgstr "nombre de proyecto"

#: src/features/audit/utils/parseProperty.ts:89
msgid "nombre de red"
msgstr "nombre de red"

#: src/features/deviceConfiguration/data/sectionFields.ts:401
#: src/features/deviceConfiguration/data/sectionInputs.ts:429
msgid "Nombre de red"
msgstr "Nombre de red"

#: src/features/audit/utils/parseProperty.ts:98
msgid "nombre de serie satelital"
msgstr "nombre de serie satelital"

#: src/features/audit/utils/parseProperty.ts:11
#: src/features/audit/utils/parseProperty.ts:124
msgid "nombre de usuario"
msgstr "nombre de usuario"

#: src/features/api/components/ApiUsersList.tsx:58
#: src/features/api/components/CaptaApiUsersList.tsx:91
#: src/features/api/components/dialogs/GeneratedUserApiSummary.tsx:31
msgid "Nombre de Usuario"
msgstr "Nombre de Usuario"

#: src/features/metricsViews/components/createViewModal/CreateViewForm.tsx:102
msgid "Nombre de visualización"
msgstr "Nombre de visualización"

#: src/features/deviceConfiguration/components/ConfigurationFileHistoryModal.tsx:125
msgid "Nombre del archivo"
msgstr "Nombre del archivo"

#: src/features/deviceConfiguration/data/sectionFields.ts:428
msgid "Nombre del Hardware"
msgstr "Nombre del Hardware"

#: src/features/deviceConfiguration/data/sectionFields.ts:13
#: src/features/deviceConfiguration/data/sectionInputs.ts:21
msgid "Nombre del proyecto"
msgstr "Nombre del proyecto"

#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:183
msgid "Nombre del reporte"
msgstr "Nombre del reporte"

#: src/features/billing/components/service/Update.tsx:68
msgid "Nombre del servicio"
msgstr "Nombre del servicio"

#: src/features/billing/components/service/Administration.tsx:90
msgid "Nombre del servicio a agregar"
msgstr "Nombre del servicio a agregar"

#: src/features/collections/components/modals/CreateMetricsViewFromCollectionModal.tsx:128
#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:124
msgid "Nombre del tablero"
msgstr "Nombre del tablero"

#: src/features/deviceCommands/components/DeviceCommandsHistoryTable.tsx:31
msgid "Nombre dispositivo"
msgstr "Nombre dispositivo"

#: src/features/sma/components/forFutureUse/DialogSmaUnitSummary.tsx:118
msgid "Nombre Parámetro SMA"
msgstr "Nombre Parámetro SMA"

#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:213
msgid "Nombre Plantilla"
msgstr "Nombre Plantilla"

#: src/features/deviceConfiguration/data/sectionFields.ts:29
msgid "Nombre usuario"
msgstr "Nombre usuario"

#. Centro de control - leyendas sobre el mapa
#: src/features/controlCenter/components/ControlCenterLegend.tsx:123
#: src/features/controlCenter2/utils/alertStates.ts:19
#: src/fsd/entities/dashboard-widget/model/chart-sample.ts:121
#: src/fsd/entities/dashboard-widget/model/data-sample.ts:110
#: src/fsd/entities/dashboard-widget/model/dga-chart-sample.ts:75
#: src/fsd/entities/dashboard-widget/model/dga-tickets-sample.ts:48
#: src/fsd/entities/dashboard-widget/model/table-sample.ts:73
#: src/fsd/entities/dashboard-widget/ui/button/button-editor.tsx:21
msgid "Normal"
msgstr "Normal"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:379
msgid "Nota"
msgstr "Nota"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:579
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:420
msgid "Notas"
msgstr "Notas"

#: src/features/notifications/components/NotificationsDeleteModal.tsx:28
msgid "Notificación eliminada correctamente"
msgstr "Notificación eliminada correctamente"

#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:105
#: src/features/alertsConfiguration/components/AlertTable.tsx:180
#: src/features/alertsConfigurationV2/components/AlertList.tsx:166
#: src/features/alertsConfigurationV2/components/AlertsConfigurationV2.tsx:113
#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:115
#: src/features/alertsConfigurationV3/components/FilterBar.tsx:100
#: src/features/alertsConfigurationV3/components/wizard/AlertWizardModal.tsx:85
#: src/features/alertsConfigurationV3/components/wizard/steps/NotificationsStep.tsx:137
#: src/features/alertsNotificationsHistory/components/histogram/HistogramTooltip.tsx:69
#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:220
#: src/features/deviceAlertsModal/components/index.tsx:117
#: src/features/dga/components/modals/UpdateDGAConfigurationModal.tsx:94
#: src/fsd/app/locale/au-labels.ts:76
#: src/pages/notifications/index.tsx:10
msgid "Notificaciones"
msgstr "Notificaciones"

#: src/features/deviceAlertsModal/components/notificationConfigurationTab/useUpdateForm.ts:22
msgid "Notificaciones actualizadas correctamente"
msgstr "Notificaciones actualizadas correctamente"

#: src/features/notifications/components/NotificationsSaveModal.tsx:212
msgid "Notificar a todos los usuarios"
msgstr "Notificar a todos los usuarios"

#: src/features/notifications/components/NotificationsSaveModal.tsx:218
msgid "Notificar sólo a clientes"
msgstr "Notificar sólo a clientes"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:31
msgid "Noviembre"
msgstr "Noviembre"

#: src/fsd/shared/ui/format/units.ts:231
#: src/utils/units.ts:288
msgid "ntu"
msgstr "ntu"

#: src/fsd/shared/ui/format/units.ts:230
#: src/utils/units.ts:287
msgid "NTU"
msgstr "NTU"

#: src/features/gateAdministration/components/MoveGate.tsx:163
msgid "Nueva abertura para la compuerta"
msgstr "Nueva abertura para la compuerta"

#: src/features/createMyCollectionModal/components/CreateMyCollectionModal.tsx:196
msgid "Nueva colección"
msgstr "Nueva colección"

#: src/features/homeAmaru/components/fiveColumn/NewCollectionCardGrid.tsx:24
#: src/features/homeAmaru/components/shared/NewCollectionCard.tsx:24
msgid "NUEVA COLECCIÓN"
msgstr "NUEVA COLECCIÓN"

#: src/features/api/components/dialogs/GenerateApiUserDialog.tsx:78
msgid "Nueva credencial API"
msgstr "Nueva credencial API"

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:121
msgid "Nueva Credencial API"
msgstr "Nueva Credencial API"

#: src/components/telemetry/regis/SimplePicturePreview.tsx:27
msgid "Nueva foto de medición para"
msgstr "Nueva foto de medición para"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:173
msgid "Nueva serie"
msgstr "Nueva serie"

#: src/features/reports/components/UpgradeBanner.tsx:27
msgid "Nueva versión de Reportes disponible"
msgstr "Nueva versión de Reportes disponible"

#: src/features/announcements/components/AnnouncementsView.tsx:163
msgid "Nuevo Anuncio"
msgstr "Nuevo Anuncio"

#: src/features/deviceConfigurationModal/components/statusTab/index.tsx:70
#: src/features/devicesAnalysis/components/DeviceOperationalStateMenu.tsx:107
msgid "Nuevo estado"
msgstr "Nuevo estado"

#: src/features/notifications/components/popup/MenuList.tsx:230
msgid "Nuevos"
msgstr "Nuevos"

#: src/features/billing/components/administration/Stats.tsx:47
msgid "nuevos proyectos este año"
msgstr "nuevos proyectos este año"

#: src/features/billing/components/administration/Stats.tsx:41
msgid "nuevos proyectos este mes"
msgstr "nuevos proyectos este mes"

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:134
#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:143
msgid "Nulo"
msgstr "Nulo"

#: src/features/userPreferences/components/RegionTab.tsx:277
msgid "Numérico"
msgstr "Numérico"

#: src/features/dga/components/modals/reports/TableModal.tsx:207
#: src/features/sma/components/TableModal.tsx:240
msgid "Número comprobante: {0}"
msgstr "Número comprobante: {0}"

#: src/features/audit/utils/parseProperty.ts:91
msgid "número de candado"
msgstr "número de candado"

#: src/features/deviceConfiguration/data/sectionFields.ts:17
#: src/features/deviceConfiguration/data/sectionInputs.ts:26
msgid "Número de chapa"
msgstr "Número de chapa"

#: src/features/audit/utils/parseProperty.ts:101
msgid "número de código de Widgetlord"
msgstr "número de código de Widgetlord"

#: src/features/audit/utils/parseProperty.ts:66
msgid "número de controladores de paneles solares"
msgstr "número de controladores de paneles solares"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:82
#: src/features/billing/components/payments/PaymentForm.tsx:100
msgid "Número de Factura"
msgstr "Número de Factura"

#: src/features/metricsViews/components/forms/AlertsTableForm.tsx:34
msgid "Número de filas (max: 100)"
msgstr "Número de filas (max: 100)"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:509
msgid "Número de lote"
msgstr "Número de lote"

#: src/features/deviceConfiguration/data/sectionFields.ts:203
#: src/features/deviceConfiguration/data/sectionInputs.ts:226
msgid "Número de lote CPU"
msgstr "Número de lote CPU"

#: src/features/audit/utils/parseProperty.ts:76
msgid "número de lote de CPU"
msgstr "número de lote de CPU"

#: src/features/audit/utils/parseProperty.ts:58
msgid "número de lote de sensor de flujo"
msgstr "número de lote de sensor de flujo"

#: src/features/audit/utils/parseProperty.ts:50
msgid "número de lote de sensor de nivel"
msgstr "número de lote de sensor de nivel"

#: src/features/audit/utils/parseProperty.ts:54
msgid "número de lote de sensor de velocidad"
msgstr "número de lote de sensor de velocidad"

#: src/features/audit/utils/parseProperty.ts:79
msgid "número de lote de Strato"
msgstr "número de lote de Strato"

#: src/features/audit/utils/parseProperty.ts:102
msgid "número de lote de tarjeta SIM"
msgstr "número de lote de tarjeta SIM"

#: src/features/audit/utils/parseProperty.ts:100
msgid "número de lote de Widgetlord"
msgstr "número de lote de Widgetlord"

#: src/features/deviceConfiguration/data/sectionInputs.ts:241
msgid "Número de lote placa"
msgstr "Número de lote placa"

#: src/features/deviceConfiguration/data/sectionFields.ts:227
msgid "Número de lote placa auxiliar"
msgstr "Número de lote placa auxiliar"

#: src/features/deviceConfiguration/data/sectionInputs.ts:292
msgid "Número de lote SIM"
msgstr "Número de lote SIM"

#: src/features/deviceConfiguration/data/sectionFields.ts:269
msgid "Número de lote SIM Card"
msgstr "Número de lote SIM Card"

#: src/features/deviceConfiguration/data/sectionFields.ts:211
msgid "Número de lote Widgetlord"
msgstr "Número de lote Widgetlord"

#: src/features/audit/utils/parseProperty.ts:74
msgid "número de paneles solares"
msgstr "número de paneles solares"

#: src/features/deviceProfile/components/page/General.tsx:94
msgid "Número de proyecto"
msgstr "Número de proyecto"

#: src/fsd/app/locale/au-labels.ts:84
msgid "Número de semana"
msgstr "Número de semana"

#: src/features/deviceConfiguration/data/sectionFields.ts:154
#: src/features/deviceConfiguration/data/sectionFields.ts:223
#: src/features/deviceConfiguration/data/sectionInputs.ts:64
#: src/features/deviceConfiguration/data/sectionInputs.ts:172
#: src/features/deviceConfiguration/data/sectionInputs.ts:236
msgid "Número de serie"
msgstr "Número de serie"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:490
msgid "Número de Serie"
msgstr "Número de Serie"

#: src/features/deviceConfiguration/data/sectionFields.ts:62
msgid "Número de serie controlador solar"
msgstr "Número de serie controlador solar"

#: src/features/audit/utils/parseProperty.ts:62
msgid "número de serie de alimentación"
msgstr "número de serie de alimentación"

#: src/features/deviceConfiguration/data/sectionInputs.ts:200
msgid "Número de serie de alimentación"
msgstr "Número de serie de alimentación"

#: src/features/audit/utils/parseProperty.ts:56
msgid "número de serie de flujo"
msgstr "número de serie de flujo"

#: src/features/audit/utils/parseProperty.ts:48
msgid "número de serie de nivel"
msgstr "número de serie de nivel"

#: src/features/audit/utils/parseProperty.ts:52
msgid "número de serie de velocidad"
msgstr "número de serie de velocidad"

#: src/features/audit/utils/parseProperty.ts:99
msgid "número de serie de Widgetlord"
msgstr "número de serie de Widgetlord"

#: src/features/deviceConfiguration/data/sectionFields.ts:178
msgid "Número de serie fuente DC"
msgstr "Número de serie fuente DC"

#: src/features/deviceConfiguration/data/sectionFields.ts:207
msgid "Número de serie Widgetlord"
msgstr "Número de serie Widgetlord"

#: src/features/audit/utils/parseProperty.ts:78
msgid "número de Strato"
msgstr "número de Strato"

#: src/features/audit/utils/parseProperty.ts:84
msgid "número de teléfono"
msgstr "número de teléfono"

#: src/features/deviceConfiguration/data/sectionFields.ts:296
#: src/features/users/components/modals/SaveUserModal.tsx:145
#: src/features/userSaveModal/components/UserSaveModal.tsx:403
msgid "Número de teléfono"
msgstr "Número de teléfono"

#: src/features/deviceConfiguration/data/sectionFields.ts:419
msgid "Número Serial del Hardware"
msgstr "Número Serial del Hardware"

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:418
msgid "Números de lote"
msgstr "Números de lote"

#: src/features/userActivityLogs/components/UserActivityLogsModal.tsx:50
msgid "Nunca"
msgstr "Nunca"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts-help.tsx:56
msgid "o"
msgstr "o"

#: src/features/audit/components/AuditLogDetailsRow.tsx:50
msgid "Objeto (?)"
msgstr "Objeto (?)"

#: src/features/audit/utils/parseProperty.ts:90
msgid "observación"
msgstr "observación"

#: src/features/deviceConfiguration/data/sectionFields.ts:33
#: src/features/deviceConfiguration/data/sectionInputs.ts:35
msgid "Observación"
msgstr "Observación"

#: src/features/deviceObservations/components/modals/UpdateObservationModal.tsx:44
msgid "Observación actualizada correctamente"
msgstr "Observación actualizada correctamente"

#: src/features/deviceObservations/components/modals/CreateObservationModal.tsx:36
msgid "Observación creada correctamente"
msgstr "Observación creada correctamente"

#: src/features/deviceObservations/components/modals/DeleteObservationModal.tsx:42
msgid "Observación eliminada correctamente"
msgstr "Observación eliminada correctamente"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:267
#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:376
#: src/features/deviceProfile/components/DeviceProfileModal.tsx:46
#: src/features/deviceProfile/components/page/Observations.tsx:56
msgid "Observaciones"
msgstr "Observaciones"

#: src/utils/roles.ts:21
msgid "Observador"
msgstr "Observador"

#: src/features/devicesAccessInputs/components/DevicesFiltersMenu.tsx:114
msgid "Observadores"
msgstr "Observadores"

#: src/features/gateOperationModal/components/PanelOperation.tsx:216
msgid "Obteniendo información"
msgstr "Obteniendo información"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:30
msgid "Octubre"
msgstr "Octubre"

#: src/fsd/pages/dashboards/ui/layout-warnings/layout-warnings-banner.tsx:67
msgid "Ocultar detalle"
msgstr "Ocultar detalle"

#: src/features/audit/components/AuditLogsTimeline.tsx:285
msgid "Ocultar detalles"
msgstr "Ocultar detalles"

#: src/fsd/pages/gate-movements/ui/panel/events/event-card.tsx:155
msgid "Ocultar los reportes"
msgstr "Ocultar los reportes"

#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:387
msgid "Ocultar mapa"
msgstr "Ocultar mapa"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:488
msgid "Ocultar usuarios"
msgstr "Ocultar usuarios"

#: src/fsd/pages/dashboards/ui/hidden-chip/hidden-chip.tsx:26
msgid "Oculto"
msgstr "Oculto"

#: src/components/ClientHiddenChip.tsx:54
msgid "Oculto manualmente para el cliente."
msgstr "Oculto manualmente para el cliente."

#: src/components/ClientHiddenChip.tsx:77
#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:209
msgid "Oculto para el cliente"
msgstr "Oculto para el cliente"

#: src/features/dga/components/modals/MassiveDGARetryModal.tsx:48
msgid "Ocurrió un error al intentar el reenvío masivo. Por favor intenta nuevamente."
msgstr "Ocurrió un error al intentar el reenvío masivo. Por favor intenta nuevamente."

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:16
msgid "Ocurrió un error al procesar el pedido. Intenta de nuevo."
msgstr "Ocurrió un error al procesar el pedido. Intenta de nuevo."

#: src/features/deviceProfile/components/modal/OdooTicketPreview.tsx:46
#: src/features/deviceProfile/components/modal/OdooTicketPreview.tsx:51
msgid "Odoo"
msgstr "Odoo"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:264
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:319
msgid "Offset (H0)"
msgstr "Offset (H0)"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:566
msgid "Offset N"
msgstr "Offset N"

#: src/features/metricsViews/components/widgets/DataWidget.tsx:103
#: src/utils/attributes/metricAlertEvaluation.ts:30
msgid "OK"
msgstr "OK"

#: src/features/dgaTicket/components/DgaTicketModal.tsx:98
msgid "Opcional. Información adicional del ticket."
msgstr "Opcional. Información adicional del ticket."

#: src/features/announcements/components/AnnouncementMenu.tsx:36
#: src/features/announcements/components/AnnouncementsGeneralSettings.tsx:27
msgid "Opciones"
msgstr "Opciones"

#: src/features/deviceCommands/components/custom/CustomCommandsButtons.tsx:20
msgid "Opciones avanzadas"
msgstr "Opciones avanzadas"

#: src/pages/device-commands/advanced.tsx:9
msgid "Opciones Avanzadas"
msgstr "Opciones Avanzadas"

#: src/features/audit/utils/parseProperty.ts:127
msgid "opciones de configuración"
msgstr "opciones de configuración"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:125
msgid "Opciones gráfico"
msgstr "Opciones gráfico"

#: src/fsd/features/gate-movements/ui/operation/gate-operation-modal.tsx:36
#: src/fsd/features/gate-movements/ui/operation/gate-operation-modal.tsx:55
#: src/fsd/features/gate-movements/ui/operation/operation-monitor.tsx:69
msgid "Operación"
msgstr "Operación"

#: src/features/gateCommon/utils/gateMovementState.tsx:258
msgid "Operación <0>finalizada con errores</0>"
msgstr "Operación <0>finalizada con errores</0>"

#: src/features/gateCommon/utils/gateCloseCode.ts:42
#: src/features/gateOperationModal/components/panelNotification/utils.tsx:216
#: src/fsd/entities/gate/model/close-code.ts:27
#: src/fsd/features/gate-movements/ui/panel/events/event-text.tsx:145
msgid "Operación completada"
msgstr "Operación completada"

#: src/features/gateOperationModal/components/PanelSummary.tsx:19
#: src/fsd/features/gate-movements/ui/operation/operation-summary.tsx:36
msgid "Operación compuerta"
msgstr "Operación compuerta"

#: src/components/gates/StopMovementConfirmation.tsx:74
msgid "Operación compuerta {gateName} cancelada con éxito"
msgstr "Operación compuerta {gateName} cancelada con éxito"

#: src/features/gateCommon/utils/gateCloseCode.ts:92
#: src/features/gateOperationModal/components/panelNotification/utils.tsx:219
#: src/fsd/entities/gate/model/close-code.ts:77
#: src/fsd/features/gate-movements/ui/panel/events/event-text.tsx:147
msgid "Operación detenida"
msgstr "Operación detenida"

#: src/features/gateCommon/utils/gateCloseCode.ts:132
#: src/fsd/entities/gate/model/close-code.ts:117
msgid "Operación detenida desde el equipo"
msgstr "Operación detenida desde el equipo"

#: src/features/gateCommon/utils/gateCloseCode.ts:102
#: src/fsd/entities/gate/model/close-code.ts:87
msgid "Operación detenida por atasco"
msgstr "Operación detenida por atasco"

#: src/features/gateCommon/utils/gateCloseCode.ts:129
#: src/fsd/entities/gate/model/close-code.ts:114
msgid "Operación detenida por entradas de seguridad ilegibles"
msgstr "Operación detenida por entradas de seguridad ilegibles"

#: src/features/gateCommon/utils/gateCloseCode.ts:106
#: src/fsd/entities/gate/model/close-code.ts:91
msgid "Operación detenida por error de lectura de posición"
msgstr "Operación detenida por error de lectura de posición"

#: src/features/gateCommon/utils/gateCloseCode.ts:125
#: src/fsd/entities/gate/model/close-code.ts:110
msgid "Operación detenida por falla del actuador"
msgstr "Operación detenida por falla del actuador"

#: src/features/gateCommon/utils/gateCloseCode.ts:112
#: src/fsd/entities/gate/model/close-code.ts:97
msgid "Operación detenida por movimiento en sentido inverso"
msgstr "Operación detenida por movimiento en sentido inverso"

#: src/features/gateCommon/utils/gateCloseCode.ts:95
#: src/fsd/entities/gate/model/close-code.ts:80
msgid "Operación detenida por parada de emergencia"
msgstr "Operación detenida por parada de emergencia"

#: src/features/gateCommon/utils/gateCloseCode.ts:109
#: src/fsd/entities/gate/model/close-code.ts:94
msgid "Operación detenida por tiempo máximo excedido"
msgstr "Operación detenida por tiempo máximo excedido"

#: src/features/gateOperationModal/components/PanelNotifications.tsx:190
#: src/fsd/features/gate-movements/ui/operation/feed/operation-feed.tsx:91
msgid "Operación en tiempo real"
msgstr "Operación en tiempo real"

#: src/features/gateOperationModal/components/panelNotification/utils.tsx:228
#: src/fsd/features/gate-movements/ui/panel/events/event-text.tsx:151
msgid "Operación finalizada con error"
msgstr "Operación finalizada con error"

#: src/features/gateCommon/utils/gateCloseCode.ts:186
#: src/fsd/entities/gate/model/close-code.ts:168
msgid "Operación finalizada con un código no reconocido"
msgstr "Operación finalizada con un código no reconocido"

#: src/features/gateCommon/utils/gateCloseCode.ts:117
#: src/fsd/entities/gate/model/close-code.ts:102
msgid "Operación finalizada por fin de carrera de seguridad"
msgstr "Operación finalizada por fin de carrera de seguridad"

#: src/features/gateCommon/utils/gateCloseCode.ts:147
#: src/fsd/entities/gate/model/close-code.ts:132
msgid "Operación finalizada por una causa desconocida"
msgstr "Operación finalizada por una causa desconocida"

#: src/fsd/features/gate-movements/ui/operation/operation-summary.tsx:56
msgid "Operación iniciada"
msgstr "Operación iniciada"

#: src/features/gateOperationModal/components/PanelSummary.tsx:49
msgid "Operación iniciada hace"
msgstr "Operación iniciada hace"

#: src/features/gateCommon/utils/gateCloseCode.ts:121
#: src/fsd/entities/gate/model/close-code.ts:106
msgid "Operación interrumpida por apagado o reinicio del equipo"
msgstr "Operación interrumpida por apagado o reinicio del equipo"

#: src/features/gateCommon/utils/gateCloseCode.ts:99
#: src/fsd/entities/gate/model/close-code.ts:84
msgid "Operación interrumpida por paso a modo manual"
msgstr "Operación interrumpida por paso a modo manual"

#: src/features/gateCommon/components/historyModal/index.tsx:281
#: src/features/gateOperationModal/components/dataComponents/MovementSummaryAttribute.tsx:59
#: src/features/metricsViews/components/widgets/movementsTable/index.tsx:164
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:140
#: src/fsd/features/gate-movements/ui/history/history-table.tsx:92
#: src/fsd/features/gate-movements/ui/list/movement-row.tsx:49
#: src/fsd/features/gate-movements/ui/operation/operation-summary.tsx:49
#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:77
msgid "Operación manual"
msgstr "Operación manual"

#: src/features/metricsViews/components/widgets/movementsTable/index.tsx:51
msgid "Operación últimos 30 días"
msgstr "Operación últimos 30 días"

#: src/features/metricsViews/components/widgets/gateOperate/AnimatedFigure.tsx:13
msgid "Operación<0/><1>en curso</1>"
msgstr "Operación<0/><1>en curso</1>"

#: src/features/gateCommon/utils/gateMovementState.tsx:245
msgid "Operación<0/><1>finalizada</1>"
msgstr "Operación<0/><1>finalizada</1>"

#: src/features/deviceSupport/data/column.ts:93
#: src/features/deviceSupport/data/fields.ts:21
#: src/utils/roles.ts:20
msgid "Operador"
msgstr "Operador"

#: src/features/audit/utils/parseProperty.ts:83
#: src/features/audit/utils/parseProperty.ts:166
msgid "operador móvil"
msgstr "operador móvil"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:36
#: src/features/deviceConfiguration/data/sectionFields.ts:287
#: src/features/deviceConfiguration/data/sectionInputs.ts:318
#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:44
msgid "Operador móvil"
msgstr "Operador móvil"

#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:85
msgid "Operador satelital"
msgstr "Operador satelital"

#: src/features/devicesAccessInputs/components/DevicesFiltersMenu.tsx:109
msgid "Operadores"
msgstr "Operadores"

#: src/features/gateAdministration/components/index.tsx:328
#: src/features/gateAdministration/components/MoveGate.tsx:51
#: src/features/metricsViews/utils/genericWidgetTypes.ts:69
#: src/features/metricsViews/utils/widgetsResolver.ts:20
#: src/features/moveGateModal/components/MoveGateModal.tsx:178
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-editor.tsx:52
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:360
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:312
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:19
msgid "Operar compuerta"
msgstr "Operar compuerta"

#: src/features/integrations/components/integrationBarChart/status.tsx:61
msgid "Operatividad hoy"
msgstr "Operatividad hoy"

#: src/features/changeSupportStatus/data/status.ts:6
#: src/features/deviceSupport/data/status.ts:13
#: src/features/deviceSupport/data/status.ts:38
#: src/features/integrations/components/integrationBarChart/index.tsx:82
#: src/features/integrations/utils/monitoredTargetResponseStatusAttributes.ts:38
#: src/features/integrations/utils/monitoredTargetResponseStatusAttributes.ts:63
msgid "Operativo"
msgstr "Operativo"

#: src/features/devicesOrderModal/components/DevicesOrder.tsx:203
#: src/features/devicesOrderModal/components/DevicesOrder.tsx:227
msgid "Orden de dispositivos actualizado exitosamente"
msgstr "Orden de dispositivos actualizado exitosamente"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:99
#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:104
msgid "Orden de lectura"
msgstr "Orden de lectura"

#: src/fsd/entities/dashboard-widget/ui/device-select/device-multi-select.tsx:62
msgid "Orden de los dispositivos elegidos"
msgstr "Orden de los dispositivos elegidos"

#: src/features/controlCenter/components/window/Window.tsx:306
msgid "Orden en alerta"
msgstr "Orden en alerta"

#: src/features/controlCenter/components/window/Window.tsx:303
msgid "Orden normal"
msgstr "Orden normal"

#: src/components/filters/OrderBy.tsx:19
#: src/features/standardDesign/components/listView/StandardListViewHeader.tsx:285
#: src/features/usersGraveyard/components/UsersGraveyard.tsx:116
#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:74
msgid "Ordenar"
msgstr "Ordenar"

#: src/features/controlCenter/components/window/Window.tsx:416
#: src/features/controlCenter2/components/devicesList/Footer.tsx:162
#: src/features/devicesOrderModal/components/DevicesOrder.tsx:61
msgid "Ordenar dispositivos"
msgstr "Ordenar dispositivos"

#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:75
msgid "Ordenar: {0}"
msgstr "Ordenar: {0}"

#: src/components/DeviceModalTitle.tsx:105
msgid "ORG"
msgstr "ORG"

#: src/components/DeviceModalTitle.tsx:157
msgid "ORG:"
msgstr "ORG:"

#: src/features/deviceSupport/data/filter.ts:8
msgid "Organizacion"
msgstr "Organizacion"

#: src/features/audit/utils/getDisplayNameEntity.ts:8
msgid "organización"
msgstr "organización"

#: src/features/alertsConfigurationV3/components/FilterBar.tsx:72
#: src/features/api/components/ApiKeysList.tsx:34
#: src/features/billing/utils/list.ts:9
#: src/features/collections/components/CollectionsTable.tsx:55
#: src/features/collections/utils/filterOptions.ts:38
#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:226
#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:243
#: src/features/deviceConfiguration/data/tableColumns.ts:9
#: src/features/deviceProfile/components/modal/Info.tsx:121
#: src/features/organizationAccess/components/OrganizationAccess.tsx:138
#: src/features/reportProblem/components/ReportProblemDialog.tsx:132
#: src/features/sma/components/forFutureUse/TableSmaUnit.tsx:42
#: src/features/userProfile/components/UserProfile.tsx:159
#: src/features/users/components/UsersTable.tsx:80
msgid "Organización"
msgstr "Organización"

#: src/features/api/components/RowCaptaApiUser.tsx:29
msgid "Organización · {0} ({1})"
msgstr "Organización · {0} ({1})"

#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:107
msgid "Organización actualizada correctamente."
msgstr "Organización actualizada correctamente."

#: src/features/audit/components/AuditLogsSidebar.tsx:178
msgid "Organización afectada"
msgstr "Organización afectada"

#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:95
msgid "Organización creada correctamente."
msgstr "Organización creada correctamente."

#: src/features/api/components/RowCaptaApiUser.tsx:33
msgid "Organización eliminada ({0})"
msgstr "Organización eliminada ({0})"

#: src/features/organizationDelete/components/DeleteOrganization.tsx:95
msgid "Organización eliminada con éxito."
msgstr "Organización eliminada con éxito."

#: src/features/deviceProfile/components/page/General.tsx:60
msgid "Organización principal"
msgstr "Organización principal"

#: src/features/access/components/AccessView.tsx:29
#: src/features/userProfile/components/UserProfileSkeleton.tsx:54
#: src/pages/organizations/index.tsx:9
msgid "Organizaciones"
msgstr "Organizaciones"

#: src/features/userProfile/components/UserProfile.tsx:184
msgid "Organizaciones adicionales"
msgstr "Organizaciones adicionales"

#: src/features/users/components/UsersTable.tsx:81
#: src/features/users/utils/filterOptions.ts:87
#: src/features/users/utils/filterOptions.ts:92
msgid "Organizaciones compartidas"
msgstr "Organizaciones compartidas"

#: src/features/userSaveModal/components/UserSaveModal.tsx:526
msgid "Organizaciones compartidas por el usuario"
msgstr "Organizaciones compartidas por el usuario"

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:244
msgid "Origen de los datos de este widget"
msgstr "Origen de los datos de este widget"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:219
msgid "Origen de los datos por defecto"
msgstr "Origen de los datos por defecto"

#: src/utils/attributes/metricField.ts:299
msgid "orp"
msgstr "orp"

#: src/utils/attributes/deviceAlertMetricName.ts:62
msgid "Orp"
msgstr "Orp"

#: src/features/reports/utils/metricHelpers.ts:25
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:28
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:73
#: src/utils/i18n/getMetricDisplayName.ts:29
msgid "ORP"
msgstr "ORP"

#: src/utils/attributes/metricField.ts:305
msgid "orp bruto"
msgstr "orp bruto"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:156
msgid "ORP bruto"
msgstr "ORP bruto"

#: src/features/metricsViews/components/AssociateCollectionModal.tsx:151
msgid "Otra colección tomó esta vista mientras el formulario estaba abierto. Recarga el listado para ver el estado actual."
msgstr "Otra colección tomó esta vista mientras el formulario estaba abierto. Recarga el listado para ver el estado actual."

#: src/features/controlCenter2/components/versionSwitch/FeedbackDialog.tsx:50
#: src/features/reports2/components/versionSwitch/FeedbackDialog.tsx:47
msgid "Otro"
msgstr "Otro"

#: src/features/deviceSupport/data/column.ts:126
#: src/features/deviceSupport/data/column.ts:133
#: src/features/deviceSupport/data/column.ts:140
#: src/features/deviceSupport/data/column.ts:147
#: src/features/deviceSupport/data/column.ts:155
msgid "Otros indicadores"
msgstr "Otros indicadores"

#: src/features/metricsViews/components/widgets/DataWidget.tsx:176
msgid "Otros umbrales"
msgstr "Otros umbrales"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:77
msgid "Oxígeno"
msgstr "Oxígeno"

#: src/utils/attributes/metricField.ts:161
msgid "oxígeno disuelto"
msgstr "oxígeno disuelto"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:351
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:32
#: src/utils/attributes/deviceAlertMetricName.ts:52
#: src/utils/i18n/getMetricDisplayName.ts:34
msgid "Oxígeno disuelto"
msgstr "Oxígeno disuelto"

#: src/features/reports/utils/metricHelpers.ts:16
msgid "Oxígeno Disuelto"
msgstr "Oxígeno Disuelto"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:225
msgid "Oxígeno disuelto (mg/L)"
msgstr "Oxígeno disuelto (mg/L)"

#: src/utils/attributes/metricField.ts:167
msgid "oxígeno disuelto bruto"
msgstr "oxígeno disuelto bruto"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:351
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:169
msgid "Oxígeno disuelto bruto"
msgstr "Oxígeno disuelto bruto"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:238
msgid "Oxígeno disuelto saturación (%)"
msgstr "Oxígeno disuelto saturación (%)"

#: src/features/billing/utils/list.ts:38
#: src/features/billing/utils/translations.ts:40
msgid "Pagado"
msgstr "Pagado"

#: src/components/TablePaginationActions.tsx:78
#: src/components/TablePaginationActions.tsx:124
msgid "Página {0} de {1}"
msgstr "Página {0} de {1}"

#: src/fsd/app/locale/au-labels.ts:69
msgid "Página {page} de {total}"
msgstr "Página {page} de {total}"

#: src/features/alertsConfigurationV3/components/Pagination.tsx:39
#: src/fsd/app/locale/au-labels.ts:66
msgid "Página anterior"
msgstr "Página anterior"

#: src/features/organizationPreferences/components/InterfaceTab.tsx:93
#: src/features/userPreferences/components/InterfaceTab.tsx:91
msgid "Página de inicio"
msgstr "Página de inicio"

#: src/features/alertsConfigurationV3/components/Pagination.tsx:48
#: src/fsd/app/locale/au-labels.ts:67
msgid "Página siguiente"
msgstr "Página siguiente"

#: src/fsd/app/locale/au-labels.ts:63
msgid "Paginación"
msgstr "Paginación"

#: src/fsd/pages/dga-reports/ui/list-pagination.tsx:33
msgid "Paginación de dispositivos"
msgstr "Paginación de dispositivos"

#: src/features/billing/components/UpdatePaymentView.tsx:87
msgid "Pago actualizado correctamente."
msgstr "Pago actualizado correctamente."

#: src/features/billing/components/payments/DeletePayment.tsx:30
msgid "Pago eliminado correctamente."
msgstr "Pago eliminado correctamente."

#: src/features/billing/components/CreatePaymentView.tsx:73
msgid "Pago registrado correctamente."
msgstr "Pago registrado correctamente."

#: src/features/billing/components/modals/PaymentsFileManager.tsx:61
msgid "Pagos creados correctamente!"
msgstr "Pagos creados correctamente!"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:187
msgid "Panel"
msgstr "Panel"

#: src/fsd/pages/dashboards/ui/panel/panel.tsx:76
#: src/fsd/pages/dashboards/ui/panel/panel.tsx:101
msgid "Panel de edición"
msgstr "Panel de edición"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:191
msgid "Panel de la serie {n}"
msgstr "Panel de la serie {n}"

#: src/features/gates/components/list/GateListItemInfo.tsx:65
#: src/features/gates/components/list/GateListItemInfo.tsx:75
#: src/features/gates/components/list/GateListItemInfo.tsx:88
#: src/pages/gates/administration/[gateId].tsx:23
#: src/pages/gates/administration/[gateId].tsx:37
msgid "Panel de operación"
msgstr "Panel de operación"

#: src/features/gates/components/list/GateListItemInfo.tsx:72
msgid "Panel no disponible"
msgstr "Panel no disponible"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:57
msgid "Panel solar"
msgstr "Panel solar"

#: src/features/deviceProfile/components/page/modularComponents/HousingTab.tsx:74
msgid "Panel solar encapsulado"
msgstr "Panel solar encapsulado"

#: src/features/deviceConfiguration/data/sectionFields.ts:54
#: src/features/deviceConfiguration/data/sectionInputs.ts:52
msgid "Paneles solares"
msgstr "Paneles solares"

#: src/fsd/pages/widget-catalog/ui/preview.tsx:114
#: src/fsd/pages/widget-catalog/ui/preview.tsx:116
msgid "Pantalla"
msgstr "Pantalla"

#: src/features/advancedDevicesAnalysis/components/AdvancedDevicesAnalysis.tsx:95
msgid "Pantalla completa"
msgstr "Pantalla completa"

#: src/features/api/components/ApiKey.tsx:28
msgid "Para acceder a la API tiene que ocupar, además de un nombre de usuario y contraseña, una <0>API Key</0>. Está es una por organización y se genera una única vez cuando crea su primera credencial de la API. En el siguiente bloque se encuentra su API Key creada:"
msgstr "Para acceder a la API tiene que ocupar, además de un nombre de usuario y contraseña, una <0>API Key</0>. Está es una por organización y se genera una única vez cuando crea su primera credencial de la API. En el siguiente bloque se encuentra su API Key creada:"

#: src/features/userProfileUpdate/components/DisableUserModal.tsx:66
msgid "Para confirmar la acción, ingresa tu contraseña y presiona \"Confirmar\""
msgstr "Para confirmar la acción, ingresa tu contraseña y presiona \"Confirmar\""

#: src/features/users/components/tableCells/User2FACell.tsx:54
msgid "Para desactivar tu autenticación en 2 pasos, hazlo desde tu perfil"
msgstr "Para desactivar tu autenticación en 2 pasos, hazlo desde tu perfil"

#: src/features/billing/components/payments/PaymentSummary.tsx:143
msgid "para el proyecto con ID"
msgstr "para el proyecto con ID"

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:149
#: src/features/api/components/dialogs/GenerateApiUserDialog.tsx:97
msgid "Para generar las credenciales de API coloque una contraseña. Al generarse la credencial, va a obtener el nombre de usuario y API Key para utilizar la API."
msgstr "Para generar las credenciales de API coloque una contraseña. Al generarse la credencial, va a obtener el nombre de usuario y API Key para utilizar la API."

#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:234
msgid "Para los envíos diarios, semanales o mensuales el servidor entrega siempre una ventana fija hasta hoy: {windowName}."
msgstr "Para los envíos diarios, semanales o mensuales el servidor entrega siempre una ventana fija hasta hoy: {windowName}."

#: src/fsd/pages/dashboards/ui/keyboard/use-board-keys.ts:142
msgid "Para mover un widget cambia a la vista de escritorio."
msgstr "Para mover un widget cambia a la vista de escritorio."

#: src/features/reports2/components/createModal/useCreateForm.ts:200
msgid "Para programar este reporte tienes que elegir un período relativo (por ejemplo, el último día o los últimos 7 días)"
msgstr "Para programar este reporte tienes que elegir un período relativo (por ejemplo, el último día o los últimos 7 días)"

#: src/fsd/pages/dashboards/ui/keyboard/use-board-keys.ts:143
msgid "Para redimensionar un widget cambia a la vista de escritorio."
msgstr "Para redimensionar un widget cambia a la vista de escritorio."

#: src/features/metricsViews/components/widgets/gateSensors/RenderSensor.tsx:130
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/sensors.ts:43
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/sensors.ts:60
msgid "Parada de emergencia"
msgstr "Parada de emergencia"

#: src/features/gateOperationModal/components/panelNotification/utils.tsx:223
#: src/fsd/features/gate-movements/ui/panel/events/event-text.tsx:149
msgid "Parada de emergencia activa"
msgstr "Parada de emergencia activa"

#: src/features/alertsConfigurationV3/components/AlertSummaryCard.tsx:43
msgid "Parámetros configurados"
msgstr "Parámetros configurados"

#: src/features/deviceDataConfigurationModal/components/DeviceDataConfigurationModal.tsx:94
msgid "Parámetros Radar"
msgstr "Parámetros Radar"

#: src/features/alertsNotificationsHistory/utils/dataToTable.ts:26
#: src/utils/i18n/getAlertSuccessOptions.ts:24
msgid "Parcialmente exitoso"
msgstr "Parcialmente exitoso"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-view.tsx:185
msgid "Pasa a «Dos paneles» para verlas."
msgstr "Pasa a «Dos paneles» para verlas."

#: src/features/deviceCommands/components/standard/DebugModeInformation.tsx:65
msgid "Pasado este tiempo de 4 horas, la configuración cambiará automáticamente al valor estándar seleccionado previamente (botones)."
msgstr "Pasado este tiempo de 4 horas, la configuración cambiará automáticamente al valor estándar seleccionado previamente (botones)."

#: src/features/alertsConfigurationV3/components/wizard/AlertWizardModal.tsx:250
msgid "Paso N°{0}"
msgstr "Paso N°{0}"

#: src/features/reports2/components/createModal/CreateReportModal.tsx:74
msgid "Paso Nº{0}"
msgstr "Paso Nº{0}"

#: src/features/controlCenter2/components/devicesList/Footer.tsx:123
msgid "Pausar selección automática de dispositivos"
msgstr "Pausar selección automática de dispositivos"

#: src/features/reports2/components/createModal/steps/step3/3-FormatAndRecipients.tsx:210
#: src/features/reports2/components/ReportCreated.tsx:52
msgid "PDF"
msgstr "PDF"

#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:356
msgid "PDF y Excel"
msgstr "PDF y Excel"

#: src/features/moveGateModal/hooks/useMoveGate.ts:57
#: src/fsd/entities/gate/model/command-feedback.ts:96
msgid "pedida el {0}"
msgstr "pedida el {0}"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:170
msgid "Pegar widgets copiados"
msgstr "Pegar widgets copiados"

#: src/features/billing/utils/list.ts:34
#: src/features/billing/utils/translations.ts:41
#: src/features/changeSupportStatus/data/status.ts:21
#: src/features/deviceSupport/data/status.ts:21
#: src/features/deviceSupport/data/status.ts:41
#: src/features/gateCommon/components/historyModal/index.tsx:162
#: src/features/gateCommon/components/movementsTable/MovementPosition.tsx:85
#: src/features/metricsViews/components/widgets/dgaReports/utils.ts:43
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:92
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:63
#: src/fsd/features/gate-movements/ui/history/history-table.tsx:71
#: src/fsd/features/gate-movements/ui/history/history-table.tsx:203
#: src/fsd/features/gate-movements/ui/list/movement-row.tsx:45
#: src/fsd/pages/dga-reports/ui/report-state-labels.ts:15
#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:62
msgid "Pendiente"
msgstr "Pendiente"

#: src/features/devices2/components/list/itemPanel/DGAItemChart.tsx:173
#: src/features/dga/utils/chartOptions.ts:81
#: src/features/metricsViews/components/widgets/dgaReports/utils.ts:42
#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-chart-option.ts:56
#: src/fsd/pages/dga-reports/ui/report-state-labels.ts:21
msgid "Pendiente de envío"
msgstr "Pendiente de envío"

#: src/features/devices2/components/list/itemPanel/deviceItemInfo/index.tsx:178
#: src/features/userMenu/components/UserMenu.tsx:109
msgid "Perfil"
msgstr "Perfil"

#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:102
msgid "Perfil actualizado correctamente"
msgstr "Perfil actualizado correctamente"

#: src/pages/devices/[id].tsx:15
msgid "Perfil de Dispositivo"
msgstr "Perfil de Dispositivo"

#: src/fsd/pages/dga-reports/ui/device-row.tsx:115
msgid "Perfil del dispositivo"
msgstr "Perfil del dispositivo"

#: src/features/billing/components/table/DevicesTable.tsx:156
#: src/features/billing/components/table/ProjectsTable.tsx:78
#: src/features/billing/components/table/ProjectsTable.tsx:214
msgid "Periodicidad"
msgstr "Periodicidad"

#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:169
msgid "Periodicidad activada"
msgstr "Periodicidad activada"

#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:126
msgid "Periodicidad del reporte"
msgstr "Periodicidad del reporte"

#. Label de selector general de rango de tiempos
#: src/features/standardDesign/components/DateTimeRangePicker/index.tsx:93
#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:186
msgid "Período"
msgstr "Período"

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:237
msgid "Período de los reportes DGA que se cuentan."
msgstr "Período de los reportes DGA que se cuentan."

#: src/features/reports2/components/createModal/steps/step2/2-TimePeriod.tsx:43
#: src/features/reports2/components/createModal/steps/step2/2-TimePeriod.tsx:48
msgid "Periodo de tiempo"
msgstr "Periodo de tiempo"

#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:231
msgid "Período fijo para esta frecuencia de envío"
msgstr "Período fijo para esta frecuencia de envío"

#: src/features/reports2/components/ReportTemplatesTable.tsx:342
msgid "período fijo: este reporte usa un rango de fechas puntual y no se repite. Al programarlo tendrás que elegir una ventana relativa."
msgstr "período fijo: este reporte usa un rango de fechas puntual y no se repite. Al programarlo tendrás que elegir una ventana relativa."

#: src/features/reports2/components/createModal/steps/step5/ReportSummary.tsx:71
#: src/features/reports2/utils/createModalStep.ts:24
msgid "Periodos de tiempo"
msgstr "Periodos de tiempo"

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:213
msgid "Permisos"
msgstr "Permisos"

#: src/features/api/components/dialogs/EditApiUserDialog.tsx:35
msgid "Permisos actualizados exitosamente"
msgstr "Permisos actualizados exitosamente"

#: src/features/organizationAccess/data/sections.ts:45
msgid "Permisos y accesos"
msgstr "Permisos y accesos"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:232
msgid "Permisos y Accesos"
msgstr "Permisos y Accesos"

#: src/components/ColorPicker/ColorPicker.tsx:278
#: src/constants/dateTimeRangePicker.constants.ts:4
#: src/features/collections/utils/filterOptions.ts:34
#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:116
#: src/fsd/entities/dashboard-widget/ui/color-field/color-field.tsx:159
msgid "Personalizado"
msgstr "Personalizado"

#: src/utils/attributes/metricField.ts:419
msgid "peso de nieve"
msgstr "peso de nieve"

#: src/utils/i18n/getMetricDisplayName.ts:40
msgid "Peso de nieve"
msgstr "Peso de nieve"

#: src/utils/attributes/metricField.ts:425
msgid "peso de nieve bruto"
msgstr "peso de nieve bruto"

#: src/fsd/shared/ui/format/units.ts:221
#: src/utils/attributes/metricField.ts:311
#: src/utils/units.ts:278
msgid "ph"
msgstr "ph"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:341
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:202
#: src/features/reports/utils/metricHelpers.ts:26
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:27
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:72
#: src/fsd/shared/ui/format/units.ts:220
#: src/utils/i18n/getMetricDisplayName.ts:28
#: src/utils/units.ts:277
msgid "pH"
msgstr "pH"

#: src/features/alertsConfigurationV2/components/AlertsConfigurationV2.tsx:94
#: src/utils/attributes/deviceAlertMetricName.ts:67
msgid "Ph"
msgstr "Ph"

#: src/utils/attributes/metricField.ts:317
msgid "ph bruto"
msgstr "ph bruto"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:341
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:146
msgid "pH bruto"
msgstr "pH bruto"

#: src/fsd/shared/ui/format/units.ts:86
#: src/utils/units.ts:143
msgid "pie"
msgstr "pie"

#: src/fsd/shared/ui/format/units.ts:113
#: src/utils/units.ts:170
msgid "pie cúbico"
msgstr "pie cúbico"

#: src/fsd/shared/ui/format/units.ts:49
#: src/utils/units.ts:106
msgid "pie cúbico por minuto"
msgstr "pie cúbico por minuto"

#: src/fsd/shared/ui/format/units.ts:54
#: src/utils/units.ts:111
msgid "pie cúbico por segundo"
msgstr "pie cúbico por segundo"

#: src/fsd/shared/ui/format/units.ts:174
#: src/utils/units.ts:231
msgid "pie cúbico por segundo por acción"
msgstr "pie cúbico por segundo por acción"

#: src/fsd/shared/ui/format/units.ts:140
#: src/utils/units.ts:197
msgid "pie por segundo"
msgstr "pie por segundo"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:207
msgid "Piezorresistivo"
msgstr "Piezorresistivo"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:493
msgid "Pin"
msgstr "Pin"

#: src/fsd/pages/dashboards/ui/board-color/color-names.ts:14
msgid "Pizarra"
msgstr "Pizarra"

#: src/features/audit/utils/parseProperty.ts:155
msgid "placa auxiliar"
msgstr "placa auxiliar"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:80
#: src/features/deviceConfiguration/data/sectionFields.ts:219
#: src/features/deviceConfiguration/data/sectionInputs.ts:231
msgid "Placa auxiliar"
msgstr "Placa auxiliar"

#: src/features/audit/utils/parseProperty.ts:170
msgid "plan de datos"
msgstr "plan de datos"

#: src/features/deviceConfiguration/data/sectionFields.ts:310
msgid "Plan de datos"
msgstr "Plan de datos"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:261
msgid "Planas"
msgstr "Planas"

#: src/features/reports/components/ReportHistory.tsx:77
#: src/features/reports2/components/reportHistoryModal/ReportHistory.tsx:82
msgid "Plantilla"
msgstr "Plantilla"

#: src/features/reports/components/creationSection/EditReportTemplateDialog.tsx:51
msgid "Plantilla editada con éxito"
msgstr "Plantilla editada con éxito"

#: src/features/reports/components/templateSection/DeleteReportTemplateDialog.tsx:32
#: src/features/reports2/components/DeleteReportTemplateModal.tsx:34
msgid "Plantilla eliminada de forma exitosa"
msgstr "Plantilla eliminada de forma exitosa"

#: src/features/reports/components/DataExtraction.tsx:33
msgid "Plantillas"
msgstr "Plantillas"

#: src/pages/playground/index.tsx:10
msgid "Playground"
msgstr "Playground"

#: src/fsd/entities/dashboard-widget/model/dga-tickets-sample.ts:49
msgid "Pocos abiertos"
msgstr "Pocos abiertos"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:67
msgid "Polinomial (hasta orden 4)"
msgstr "Polinomial (hasta orden 4)"

#: src/features/announcements/components/AnnouncementsViewModal.tsx:71
msgid "por {author}"
msgstr "por {author}"

#: src/features/deviceCommands/components/standard/DebugModeInformation.tsx:52
msgid "Por 4 horas el equipo se configura con los siguientes valores:"
msgstr "Por 4 horas el equipo se configura con los siguientes valores:"

#: src/utils/alertConfiguration.ts:33
#: src/utils/alerts.ts:16
msgid "Por debajo de {0} {1}"
msgstr "Por debajo de {0} {1}"

#: src/features/metricsViews/components/widgets/configuredAlerts/index.tsx:64
msgid "Por debajo de {value}"
msgstr "Por debajo de {value}"

#: src/fsd/entities/dashboard-widget/model/alert-threshold.ts:35
msgid "Por debajo de {value} {u}"
msgstr "Por debajo de {value} {u}"

#: src/features/preferencesCommon/components/UpdatePreferredUnitsForm.tsx:280
#: src/fsd/pages/widget-catalog/ui/preview.tsx:89
msgid "Por defecto"
msgstr "Por defecto"

#: src/utils/alertConfiguration.ts:36
#: src/utils/alerts.ts:18
msgid "Por encima de {0} {1}"
msgstr "Por encima de {0} {1}"

#: src/features/metricsViews/components/widgets/configuredAlerts/index.tsx:63
msgid "Por encima de {value}"
msgstr "Por encima de {value}"

#: src/fsd/entities/dashboard-widget/model/alert-threshold.ts:37
msgid "Por encima de {value} {u}"
msgstr "Por encima de {value} {u}"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:24
msgid "Por estación"
msgstr "Por estación"

#: src/features/recoveryPassword/components/RecoveryPassword.tsx:70
msgid "Por favor ingrese su correo electrónico para recuperar su contraseña"
msgstr "Por favor ingrese su correo electrónico para recuperar su contraseña"

#: src/features/devices2/utils/getDgaFrequencyOptions.ts:9
msgid "Por hora"
msgstr "Por hora"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:28
msgid "Por red"
msgstr "Por red"

#: src/fsd/shared/ui/format/units.ts:191
#: src/utils/units.ts:248
msgid "porcentaje"
msgstr "porcentaje"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarEnergyCheckboxList.tsx:23
msgid "Porcentaje batería"
msgstr "Porcentaje batería"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:332
msgid "Porcentaje Batería"
msgstr "Porcentaje Batería"

#: src/features/devices2/utils/getSmaChartOptions.ts:93
msgid "Porcentaje de éxito"
msgstr "Porcentaje de éxito"

#: src/features/integrations/components/monitoredTargetSection/Status.tsx:79
#: src/features/integrations/components/monitoredTargetSection/Status.tsx:118
msgid "Porcentaje de respuesta"
msgstr "Porcentaje de respuesta"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:257
msgid "Portapapeles"
msgstr "Portapapeles"

#: src/features/audit/utils/parseProperty.ts:132
#: src/utils/attributes/metricField.ts:323
msgid "posición"
msgstr "posición"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LGCalibrationDisplay.tsx:93
#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:66
#: src/features/devices2/components/list/itemPanel/DeviceItemMinichart.tsx:364
#: src/features/gateCommon/components/historyModal/index.tsx:228
#: src/features/metricsViews/components/widgets/movementsTable/index.tsx:124
#: src/features/reports/utils/metricHelpers.ts:27
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:23
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:68
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:218
#: src/fsd/features/gate-movements/ui/history/history-table.tsx:156
#: src/fsd/features/gate-movements/ui/panel/position-chart.tsx:136
#: src/utils/i18n/getMetricDisplayName.ts:15
msgid "Posición"
msgstr "Posición"

#: src/fsd/pages/gate-movements/ui/panel/events/event-card.tsx:223
msgid "Posición {0}"
msgstr "Posición {0}"

#: src/features/gateAdministration/components/index.tsx:340
#: src/features/gateAdministration/components/index.tsx:346
#: src/features/gateOperationModal/components/dataComponents/OperationPositionData.tsx:42
#: src/features/gateOperationModal/components/dataComponents/OperationPositionData.tsx:81
#: src/features/moveGateModal/components/LastPosition.tsx:61
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:146
#: src/fsd/features/gate-movements/ui/operation/position-box.tsx:19
#: src/fsd/pages/gate-movements/ui/panel/result/movement-result.tsx:67
msgid "Posición actual"
msgstr "Posición actual"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:145
msgid "Posición compuerta"
msgstr "Posición compuerta"

#: src/features/metricsViews/components/forms/ButtonWidgetForm.tsx:109
msgid "Posición de icono"
msgstr "Posición de icono"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:54
#: src/features/gateAdministration/components/MovementHistory.tsx:71
msgid "Posición de inicio"
msgstr "Posición de inicio"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:390
#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:395
msgid "Posición en grilla"
msgstr "Posición en grilla"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:57
#: src/features/gateAdministration/components/index.tsx:358
#: src/features/gateAdministration/components/MovementHistory.tsx:74
#: src/features/gateOperationModal/components/dataComponents/OperationPositionData.tsx:58
#: src/fsd/features/gate-movements/ui/operation/position-box.tsx:19
#: src/fsd/pages/gate-movements/ui/panel/result/movement-result.tsx:67
msgid "Posición final"
msgstr "Posición final"

#: src/features/gateAdministration/components/gateMovementBanner/LegacyMovementRow.tsx:46
#: src/features/gateAdministration/components/gateMovementBanner/V2MovementRow.tsx:61
msgid "Posición inicial"
msgstr "Posición inicial"

#: src/features/gateAdministration/components/gateMovementBanner/LegacyMovementRow.tsx:47
#: src/features/gateAdministration/components/gateMovementBanner/V2MovementRow.tsx:67
msgid "Posición objetivo"
msgstr "Posición objetivo"

#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:46
msgid "posición solicitada"
msgstr "posición solicitada"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:51
#: src/features/gateAdministration/components/MovementHistory.tsx:68
#: src/features/moveGateModal/components/MoveGateForm.tsx:167
#: src/features/moveGateModal/components/MoveGateForm.tsx:277
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:290
msgid "Posición solicitada"
msgstr "Posición solicitada"

#: src/features/gateCommon/components/movementsTable/MovementPosition.tsx:88
msgid "Posición solicitada — la operación aún no termina"
msgstr "Posición solicitada — la operación aún no termina"

#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:67
msgid "Posición solicitada: la operación aún no termina."
msgstr "Posición solicitada: la operación aún no termina."

#: src/features/metricsViews/components/forms/ButtonWidgetForm.tsx:182
msgid "Posicionamiento"
msgstr "Posicionamiento"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:89
msgid "Pot. carga"
msgstr "Pot. carga"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:87
msgid "Pot. solar"
msgstr "Pot. solar"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarEnergyCheckboxList.tsx:39
msgid "Potencia carga"
msgstr "Potencia carga"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:335
msgid "Potencia Carga"
msgstr "Potencia Carga"

#: src/utils/attributes/metricField.ts:113
msgid "potencia de carga"
msgstr "potencia de carga"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:44
#: src/utils/i18n/getMetricDisplayName.ts:46
msgid "Potencia de carga"
msgstr "Potencia de carga"

#: src/utils/attributes/metricField.ts:119
msgid "potencia de carga bruta"
msgstr "potencia de carga bruta"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarEnergyCheckboxList.tsx:71
msgid "Potencia Panel"
msgstr "Potencia Panel"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:337
msgid "Potencia Panel Solar"
msgstr "Potencia Panel Solar"

#: src/utils/attributes/metricField.ts:443
msgid "potencia solar"
msgstr "potencia solar"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:69
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:42
#: src/utils/i18n/getMetricDisplayName.ts:47
msgid "Potencia solar"
msgstr "Potencia solar"

#: src/utils/attributes/metricField.ts:449
msgid "potencia solar bruta"
msgstr "potencia solar bruta"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:63
msgid "Potencial"
msgstr "Potencial"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:344
msgid "Potencial de oxidación-reducción"
msgstr "Potencial de oxidación-reducción"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:346
msgid "Potencial de oxidación-reducción bruto"
msgstr "Potencial de oxidación-reducción bruto"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:212
msgid "Potencial reducción oxidación (ORP)"
msgstr "Potencial reducción oxidación (ORP)"

#: src/features/metricsViews/components/widgets/configuredAlerts/index.tsx:77
#: src/features/metricsViews/components/widgets/DataWidget.tsx:107
#: src/fsd/entities/dashboard-widget/model/data-sample.ts:112
#: src/fsd/entities/dashboard-widget/ui/data/data-view.tsx:40
#: src/utils/attributes/metricAlertEvaluation.ts:33
msgid "Precaución"
msgstr "Precaución"

#: src/features/metricsViews/components/forms/AllocationPerformanceWidgetForm.tsx:210
#: src/features/metricsViews/components/forms/DataWidgetForm.tsx:184
#: src/fsd/entities/dashboard-widget/ui/data/data-editor.tsx:83
#: src/fsd/entities/dashboard-widget/ui/data/data-editor.tsx:87
msgid "Precisión"
msgstr "Precisión"

#: src/features/organizationPreferences/components/InterfaceTab.tsx:33
#: src/features/userPreferences/components/InterfaceTab.tsx:31
#: src/features/userPreferences/components/RegionTab.tsx:37
msgid "Preferencias actualizadas correctamente"
msgstr "Preferencias actualizadas correctamente"

#: src/features/organizationPreferences/components/OrganizationPreferencesModal.tsx:38
#: src/features/userMenu/components/UserMenu.tsx:124
#: src/features/userMenu/components/UserMenu.tsx:134
msgid "Preferencias de organización"
msgstr "Preferencias de organización"

#: src/features/userMenu/components/UserMenu.tsx:115
#: src/features/userPreferences/components/UserPreferencesModal.tsx:38
msgid "Preferencias de usuario"
msgstr "Preferencias de usuario"

#: src/features/controlCenter2/components/versionSwitch/FeedbackDialog.tsx:47
#: src/features/reports2/components/versionSwitch/FeedbackDialog.tsx:50
msgid "Prefiero el diseño anterior"
msgstr "Prefiero el diseño anterior"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/ChartPreview.tsx:68
#: src/features/metricsViews/components/SaveWidgetModal.tsx:267
#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:128
msgid "Previsualización"
msgstr "Previsualización"

#: src/components/ImagePreviewModal.tsx:21
msgid "Previsualización de imagen"
msgstr "Previsualización de imagen"

#: src/components/FileInput.tsx:79
#: src/components/ImageUploadField.tsx:163
msgid "Previsualización de la imagen"
msgstr "Previsualización de la imagen"

#: src/features/alertsConfigurationV2/components/AlertConfigurationPreview.tsx:205
#: src/features/alertsConfigurationV3/components/wizard/AlertConfigurationPreview.tsx:209
msgid "Previsualización de las configuraciones"
msgstr "Previsualización de las configuraciones"

#: src/features/metricsViews/components/MetricsView.tsx:573
msgid "Previsualización responsiva"
msgstr "Previsualización responsiva"

#: src/features/announcements/components/AnnouncementMenu.tsx:58
msgid "Previsualizar"
msgstr "Previsualizar"

#: src/features/audit/utils/parseProperty.ts:109
msgid "primer caudal repartible"
msgstr "primer caudal repartible"

#: src/fsd/app/locale/au-labels.ts:65
msgid "Primera página"
msgstr "Primera página"

#: src/features/controlCenter/components/UpgradeBanner.tsx:18
#: src/features/reports/components/UpgradeBanner.tsx:43
msgid "Probar nueva versión"
msgstr "Probar nueva versión"

#: src/features/dga/components/modals/MassiveDGARetryModal.tsx:119
msgid "Procesando..."
msgstr "Procesando..."

#: src/features/reports2/components/createModal/steps/step5/ReportSummary.tsx:117
msgid "Programación"
msgstr "Programación"

#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:41
msgid "Programación eliminada correctamente"
msgstr "Programación eliminada correctamente"

#: src/features/reports/components/templateSection/ReportTemplateList.tsx:146
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:313
msgid "Programado"
msgstr "Programado"

#: src/features/reports/components/templateSection/ReportTemplateList.tsx:252
#: src/features/reports/components/templateSection/ScheduleReportDialog.tsx:65
msgid "Programados"
msgstr "Programados"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:400
msgid "Programar"
msgstr "Programar"

#: src/features/reports/components/templateSection/ReportTemplateList.tsx:262
msgid "Programar nuevo envío"
msgstr "Programar nuevo envío"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:251
msgid "Programar Plantilla"
msgstr "Programar Plantilla"

#: src/features/audit/utils/getDisplayNameActionType.ts:466
msgid "programó los envíos DGA"
msgstr "programó los envíos DGA"

#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:326
#: src/features/deviceConfiguration/data/tableColumns.ts:21
msgid "Progreso"
msgstr "Progreso"

#: src/features/gateOperationModal/components/PanelOperation.tsx:251
#: src/features/gateOperationModal/components/PanelOperation.tsx:263
#: src/features/gateOperationModal/components/PanelOperation.tsx:273
#: src/fsd/features/gate-movements/ui/operation/operation-monitor.tsx:98
msgid "Progreso de operación"
msgstr "Progreso de operación"

#: src/components/ImageUploadField.tsx:183
msgid "Progreso de subida"
msgstr "Progreso de subida"

#: src/fsd/app/locale/au-labels.ts:108
msgid "prom"
msgstr "prom"

#: src/features/reports2/components/createModal/steps/step2/2-TimePeriod.tsx:94
msgid "Promediar datos"
msgstr "Promediar datos"

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:385
#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:245
msgid "Promediar datos por período"
msgstr "Promediar datos por período"

#. Análisis de estaciones - etiqueta de campo de selección de ventana de promedio
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:133
#: src/features/metricsViews/components/MetricsViewToolbar.legacy.tsx:189
#: src/features/metricsViews/components/MetricsViewToolbar.tsx:276
msgid "Promediar por periodo"
msgstr "Promediar por periodo"

#: src/fsd/app/locale/au-labels.ts:115
msgid "Promedio"
msgstr "Promedio"

#: src/features/metricsViews/components/widgets/allocationPerformance/index.legacy.tsx:264
#: src/features/metricsViews/components/widgets/allocationPerformance/index.tsx:298
msgid "Promedio <0>{every}</0>"
msgstr "Promedio <0>{every}</0>"

#: src/features/reports/components/ReportHistory.tsx:289
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:130
#: src/features/reports2/components/reportHistoryModal/ReportHistory.tsx:296
#: src/features/reports2/components/TemplateSummary.tsx:83
msgid "Promedio de datos"
msgstr "Promedio de datos"

#: src/features/reports2/components/createModal/steps/step2/2-TimePeriod.tsx:70
msgid "Promedio y zona horaria"
msgstr "Promedio y zona horaria"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:537
msgid "Propiedad"
msgstr "Propiedad"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:179
msgid "Propuesta del asistente"
msgstr "Propuesta del asistente"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:265
msgid "Propuesta descartada: el borrador no cambió."
msgstr "Propuesta descartada: el borrador no cambió."

#: src/features/deviceConfiguration/components/AdvancedFiltersModal.tsx:342
msgid "Protocolo"
msgstr "Protocolo"

#: src/fsd/pages/dga-reports/ui/reports-heatmap.tsx:78
msgid "Próxima semana"
msgstr "Próxima semana"

#: src/features/dga/components/modals/reports/components/WeekSelector.tsx:44
#: src/features/sma/components/SmaSuccessTableModal.tsx:109
msgid "Próxima Semana"
msgstr "Próxima Semana"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:525
msgid "Próximamente"
msgstr "Próximamente"

#: src/features/billing/components/table/ServicesTableForTooltip.tsx:44
msgid "Próximo pago"
msgstr "Próximo pago"

#: src/features/billing/components/table/ProjectsTable.tsx:77
msgid "Próximo Pago"
msgstr "Próximo Pago"

#: src/features/billing/components/projectService/Delete.tsx:111
#: src/features/billing/components/table/ProjectsTable.tsx:74
#: src/features/billing/utils/list.ts:13
#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:209
#: src/features/deviceConfiguration/data/tableColumns.ts:15
#: src/features/deviceProfile/components/modal/Info.tsx:132
msgid "Proyecto"
msgstr "Proyecto"

#: src/features/billing/components/DueDate.tsx:94
#: src/features/billing/components/table/ProjectsTable.tsx:204
msgid "Proyecto {projectId}"
msgstr "Proyecto {projectId}"

#: src/features/advancedDevicesAnalysis/components/AdvancedDevicesAnalysis.tsx:87
msgid "Proyectos"
msgstr "Proyectos"

#: src/features/billing/components/administration/Stats.tsx:54
msgid "Proyectos con deuda"
msgstr "Proyectos con deuda"

#: src/features/billing/components/administration/Stats.tsx:29
msgid "Proyectos vendidos"
msgstr "Proyectos vendidos"

#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:205
msgid "Publicación"
msgstr "Publicación"

#: src/features/sma/utils/echartOptions.ts:27
msgid "Publicado"
msgstr "Publicado"

#: src/features/announcements/components/AnnouncementsViewModal.tsx:63
msgid "Publicado el"
msgstr "Publicado el"

#: src/features/audit/utils/parseProperty.ts:35
msgid "público"
msgstr "público"

#: src/features/deviceConfigurationModal/components/DeviceConfigurationModal.tsx:85
msgid "Público"
msgstr "Público"

#: src/fsd/pages/gate-movements/ui/states/movement-not-found.tsx:17
msgid "Puede que no exista o que no tengas acceso a él."
msgstr "Puede que no exista o que no tengas acceso a él."

#: src/fsd/features/gate-movements/ui/operation/gate-operation-modal.tsx:93
msgid "Puede que no exista o que no tengas acceso a ella."
msgstr "Puede que no exista o que no tengas acceso a ella."

#: src/fsd/pages/dashboards/ui/dashboard-editor-page.tsx:127
msgid "Puede que se haya eliminado o que el enlace esté incompleto."
msgstr "Puede que se haya eliminado o que el enlace esté incompleto."

#: src/features/dgaTicket/components/DgaTicketModal.tsx:118
msgid "Puedes abrir uno nuevo para el dispositivo."
msgstr "Puedes abrir uno nuevo para el dispositivo."

#: src/features/reports/components/CreatedReportNotification.tsx:72
msgid "Puedes descargar el reporte desde los siguientes enlaces"
msgstr "Puedes descargar el reporte desde los siguientes enlaces"

#: src/features/reports/components/creationSection/CreateReportsSection.tsx:20
msgid "Puedes solicitar un reporte de los datos de un dispositivo en específico o de todos los dispositivos de un canal."
msgstr "Puedes solicitar un reporte de los datos de un dispositivo en específico o de todos los dispositivos de un canal."

#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:104
#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:105
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:90
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:91
#: src/utils/attributes/deviceOperationalState.ts:45
msgid "Puesta en marcha"
msgstr "Puesta en marcha"

#: src/fsd/shared/ui/format/units.ts:81
#: src/utils/units.ts:138
msgid "pulgada"
msgstr "pulgada"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:375
msgid "Punto"
msgstr "Punto"

#: src/features/alertsNotificationsHistory/utils/notificationTypes.ts:42
msgid "Push"
msgstr "Push"

#: src/fsd/pages/dga-reports/ui/dga-service-strip.tsx:39
msgid "Qué mide esta tira"
msgstr "Qué mide esta tira"

#: src/fsd/entities/dashboard-widget/ui/contact-support/contact-support-editor.tsx:64
msgid "Queda elegido al abrir el formulario de reporte."
msgstr "Queda elegido al abrir el formulario de reporte."

#: src/features/collections/components/modals/CreateCollectionModal.tsx:168
#: src/features/collections/components/modals/UpdateCollectionModal.tsx:194
#: src/features/createDeviceConfiguration/components/common/PDFUploadField.tsx:213
#: src/fsd/app/locale/au-labels.ts:57
msgid "Quitar"
msgstr "Quitar"

#: src/fsd/app/locale/au-labels.ts:41
msgid "Quitar {label}"
msgstr "Quitar {label}"

#: src/features/metricsViews/components/forms/TrendSummaryForm.tsx:227
msgid "Quitar fila"
msgstr "Quitar fila"

#: src/components/ImageUploadField.tsx:195
msgid "Quitar imagen"
msgstr "Quitar imagen"

#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:114
msgid "Quitar la columna {n}"
msgstr "Quitar la columna {n}"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:239
msgid "Quitar la serie {n}"
msgstr "Quitar la serie {n}"

#: src/features/deviceConfigurationModal/components/gateTab/RemoveLinkedDeviceButton.tsx:58
#: src/features/deviceConfigurationModal/components/gateTab/RemoveLinkedDeviceButton.tsx:64
msgid "Quitar nivel"
msgstr "Quitar nivel"

#: src/features/deviceConfigurationModal/components/gateTab/RemoveLinkedDeviceButton.tsx:37
msgid "Quitar sensor de nivel aguas abajo"
msgstr "Quitar sensor de nivel aguas abajo"

#: src/features/deviceConfigurationModal/components/gateTab/RemoveLinkedDeviceButton.tsx:36
msgid "Quitar sensor de nivel aguas arriba"
msgstr "Quitar sensor de nivel aguas arriba"

#: src/fsd/shared/ui/format/units.ts:185
#: src/utils/units.ts:242
msgid "rad"
msgstr "rad"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:226
msgid "Radar sin contacto"
msgstr "Radar sin contacto"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:362
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:294
#: src/features/reports/utils/metricHelpers.ts:31
msgid "Radiación"
msgstr "Radiación"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:362
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:260
msgid "Radiación bruta"
msgstr "Radiación bruta"

#: src/utils/attributes/metricField.ts:371
msgid "radiación de nieve"
msgstr "radiación de nieve"

#: src/utils/attributes/metricField.ts:377
msgid "radiación de nieve bruta"
msgstr "radiación de nieve bruta"

#: src/utils/i18n/getMetricDisplayName.ts:41
msgid "Radiación nieve"
msgstr "Radiación nieve"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:277
msgid "Radiales"
msgstr "Radiales"

#: src/fsd/shared/ui/format/units.ts:186
#: src/utils/units.ts:243
msgid "radián"
msgstr "radián"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleFormula.tsx:12
msgid "radio de la compuerta (en cm)"
msgstr "radio de la compuerta (en cm)"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:236
msgid "Randomizar"
msgstr "Randomizar"

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:263
msgid "Randomizar solo este"
msgstr "Randomizar solo este"

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:259
msgid "Randomizar solo este: {name}"
msgstr "Randomizar solo este: {name}"

#. Centro de control - leyendas sobre el mapa
#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:402
#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:191
#: src/features/controlCenter/components/ControlCenterLegend.tsx:114
#: src/features/gateAdministration/components/MoveGate.tsx:186
#: src/features/metricsViews/components/ExportHeader.tsx:52
msgid "Rango"
msgstr "Rango"

#: src/features/controlCenter/utils/minicharts.ts:259
msgid "Rango de caudal alto"
msgstr "Rango de caudal alto"

#: src/features/controlCenter/utils/minicharts.ts:270
msgid "Rango de caudal bajo"
msgstr "Rango de caudal bajo"

#: src/features/controlCenter/utils/minicharts.ts:248
msgid "Rango de caudal extremo"
msgstr "Rango de caudal extremo"

#: src/features/reports/components/ReportHistory.tsx:274
#: src/features/reports2/components/reportHistoryModal/ReportHistory.tsx:281
msgid "Rango de datos"
msgstr "Rango de datos"

#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:191
msgid "Rango de intervalo"
msgstr "Rango de intervalo"

#: src/features/controlCenter/utils/minicharts.ts:331
msgid "Rango de nivel alto"
msgstr "Rango de nivel alto"

#: src/features/controlCenter/utils/minicharts.ts:342
msgid "Rango de nivel bajo"
msgstr "Rango de nivel bajo"

#: src/features/controlCenter/utils/minicharts.ts:320
msgid "Rango de nivel extremo"
msgstr "Rango de nivel extremo"

#: src/features/advancedDevicesAnalysis/components/GeneralChartConfiguration.tsx:182
msgid "Rango de observación"
msgstr "Rango de observación"

#: src/features/controlCenter/components/panel/TimeRangeSelect.tsx:79
msgid "Rango de tiempo"
msgstr "Rango de tiempo"

#: src/features/devicesAnalysisV3/components/QuickRangeChips.tsx:84
msgid "Rango exacto"
msgstr "Rango exacto"

#: src/fsd/app/locale/au-labels.ts:95
msgid "Rango personalizado"
msgstr "Rango personalizado"

#: src/fsd/app/locale/au-labels.ts:94
msgid "Rango personalizado: 3h, 3 horas, 3 m…"
msgstr "Rango personalizado: 3h, 3 horas, 3 m…"

#: src/features/alertsConfigurationV2/components/upsertModal/AlertsConfigurationModal.tsx:51
#: src/features/alertsConfigurationV3/components/wizard/AlertWizardModal.tsx:80
msgid "Rangos"
msgstr "Rangos"

#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:168
#: src/features/metricsViews/components/widgets/configuredAlerts/Table.tsx:266
msgid "Rangos configurados"
msgstr "Rangos configurados"

#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:80
msgid "Rangos definidos"
msgstr "Rangos definidos"

#: src/features/standardDesign/components/DateTimeRangePicker/components/AbsoluteDatePicker.tsx:80
msgid "Rangos recientes"
msgstr "Rangos recientes"

#: src/features/deviceSupport/data/column.ts:131
#: src/features/deviceSupport/data/fields.ts:17
msgid "Ratio Buffer"
msgstr "Ratio Buffer"

#: src/features/deviceSupport/data/column.ts:138
#: src/features/deviceSupport/data/fields.ts:18
msgid "Ratio Outlier"
msgstr "Ratio Outlier"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:214
#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:222
#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:225
#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:248
msgid "Reales"
msgstr "Reales"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:565
msgid "Realizado el"
msgstr "Realizado el"

#: src/features/controlCenter2/components/devicesList/Footer.tsx:124
msgid "Reanudar selección automática de dispositivos"
msgstr "Reanudar selección automática de dispositivos"

#: src/features/users/components/UsersTable.tsx:100
msgid "Reautenticar"
msgstr "Reautenticar"

#: src/features/metricsViews/components/widgets/dgaReports/utils.ts:35
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:86
msgid "Recibido"
msgstr "Recibido"

#: src/features/notifications/components/NotificationMessageViewModal.tsx:77
msgid "Recibido el"
msgstr "Recibido el"

#: src/features/metricsViews/components/widgets/dgaReports/utils.ts:34
msgid "Recibido por la DGA"
msgstr "Recibido por la DGA"

#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:41
msgid "Recorrido"
msgstr "Recorrido"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:481
msgid "Rectángulo"
msgstr "Rectángulo"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:484
msgid "Rectángulo redondeado"
msgstr "Rectángulo redondeado"

#: src/features/recoveryPassword/components/RecoveryPassword.tsx:64
msgid "Recuperar contraseña"
msgstr "Recuperar contraseña"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:263
#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:215
msgid "Recurrencia"
msgstr "Recurrencia"

#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:78
msgid "Recurrencia de envíos actualizada correctamente"
msgstr "Recurrencia de envíos actualizada correctamente"

#: src/features/organizationDelete/components/DeleteOrganization.tsx:235
msgid "Recurso"
msgstr "Recurso"

#: src/features/organizationDelete/components/DeleteOrganization.tsx:222
msgid "Recursos externos en AWS:"
msgstr "Recursos externos en AWS:"

#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:64
msgid "Red"
msgstr "Red"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:29
msgid "Red / cuenca"
msgstr "Red / cuenca"

#: src/features/deviceProfile/components/page/General.tsx:69
msgid "Red de canales"
msgstr "Red de canales"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:101
msgid "Red eléctrica"
msgstr "Red eléctrica"

#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:40
msgid "Red móvil"
msgstr "Red móvil"

#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:66
msgid "Redes de canales"
msgstr "Redes de canales"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:313
msgid "redimensionado"
msgstr "redimensionado"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:270
msgid "Reemplazada por la propuesta siguiente."
msgstr "Reemplazada por la propuesta siguiente."

#: src/components/ImageUploadField.tsx:193
msgid "Reemplazar"
msgstr "Reemplazar"

#: src/features/api/components/dialogs/ResendApiCredentialsDialog.tsx:158
msgid "Reenviar"
msgstr "Reenviar"

#: src/features/resendCredentialsModal/components/ResendCredentialsModal.tsx:120
msgid "Reenviar credenciales"
msgstr "Reenviar credenciales"

#: src/features/api/components/dialogs/ResendApiCredentialsDialog.tsx:102
msgid "Reenviar credenciales API"
msgstr "Reenviar credenciales API"

#: src/features/users/components/tableCells/UserActionsCell.tsx:105
msgid "Reenviar credenciales de acceso"
msgstr "Reenviar credenciales de acceso"

#: src/features/audit/utils/getActionTypeOptions.ts:337
msgid "Reenviar Credenciales de API"
msgstr "Reenviar Credenciales de API"

#: src/features/audit/utils/getActionTypeOptions.ts:334
msgid "Reenviar credenciales de usuario"
msgstr "Reenviar credenciales de usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:209
msgid "reenvió las credenciales al usuario"
msgstr "reenvió las credenciales al usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:297
msgid "reenvió por correo las credenciales de acceso a la API"
msgstr "reenvió por correo las credenciales de acceso a la API"

#: src/fsd/pages/dga-reports/ui/dga-service-strip.tsx:68
msgid "Refleja si la plataforma de la Dirección General de Aguas está disponible — no el estado de tus envíos ni el servicio de AMARU."
msgstr "Refleja si la plataforma de la Dirección General de Aguas está disponible — no el estado de tus envíos ni el servicio de AMARU."

#: src/fsd/pages/dashboards/ui/status-strip/status-strip.tsx:77
msgid "Refrescar"
msgstr "Refrescar"

#: src/utils/devices/formatSourceColor.ts:32
msgid "Regis"
msgstr "Regis"

#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:142
msgid "registrada {ago}"
msgstr "registrada {ago}"

#: src/features/moveGateModal/components/LastPosition.tsx:50
msgid "registrada <0/>"
msgstr "registrada <0/>"

#: src/pages/billing/CreatePaymentView.tsx:9
msgid "Registrar Nuevo Pago"
msgstr "Registrar Nuevo Pago"

#: src/features/billing/components/payments/Toolbar.tsx:67
msgid "Registrar pago"
msgstr "Registrar pago"

#: src/features/deviceProfile/components/page/Audit.tsx:53
msgid "Registro de cambios"
msgstr "Registro de cambios"

#: src/features/billing/components/administration/Toolbar.tsx:123
msgid "Registro de pagos"
msgstr "Registro de pagos"

#: src/features/organizationDelete/components/DeleteOrganization.tsx:169
#: src/features/organizationDelete/components/DeleteOrganization.tsx:241
#: src/features/usersGraveyard/components/HardDeleteUserModal.tsx:130
msgid "Registros"
msgstr "Registros"

#: src/features/organizationDelete/components/DeleteOrganization.tsx:160
msgid "Registros afectados:"
msgstr "Registros afectados:"

#: src/features/userActivityLogs/components/UserActivityLogsModal.tsx:126
#: src/features/users/components/tableCells/UserActionsCell.tsx:99
msgid "Registros de acceso"
msgstr "Registros de acceso"

#: src/features/integrations/components/integrationSection/index.tsx:66
msgid "Registros de la integración"
msgstr "Registros de la integración"

#: src/features/integrations/components/devicesList/index.tsx:115
msgid "Registros de los dispositivos"
msgstr "Registros de los dispositivos"

#: src/features/usersGraveyard/components/HardDeleteUserModal.tsx:121
msgid "Registros que se eliminarán:"
msgstr "Registros que se eliminarán:"

#: src/features/debtsAlert/components/DebtsAlertModal.tsx:105
#: src/features/debtsAlert/components/DebtsAlertPopover.tsx:95
msgid "Regularice ahora y evite limitaciones en el servicio."
msgstr "Regularice ahora y evite limitaciones en el servicio."

#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:207
#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:125
msgid "Rehacer"
msgstr "Rehacer"

#: src/features/integrations/utils/writeExecutionLogCodeTranslations.ts:8
msgid "Reintentando iniciar sesión en el sitio web"
msgstr "Reintentando iniciar sesión en el sitio web"

#: src/features/integrations/utils/writeExecutionLogCodeTranslations.ts:6
msgid "Reintentando obtener datos del dispositivo"
msgstr "Reintentando obtener datos del dispositivo"

#: src/features/alertsConfigurationV3/components/ListPlaceholders.tsx:63
#: src/fsd/pages/dashboards/ui/dashboard-editor-page.tsx:139
#: src/fsd/pages/dashboards/ui/dashboards-page.tsx:30
#: src/fsd/pages/dga-reports/ui/page-error-boundary.tsx:37
#: src/fsd/pages/gate-movements/ui/page-error-boundary.tsx:28
msgid "Reintentar"
msgstr "Reintentar"

#: src/features/dga/components/modals/UpdateDGAConfigurationModal.tsx:123
msgid "Reintentar envío de datos"
msgstr "Reintentar envío de datos"

#: src/features/dga/components/modals/DGAReportsRetryModal.tsx:85
#: src/features/dga/components/modals/DGAReportsRetryModal.tsx:169
msgid "Reintentar publicación de reportes fallidos"
msgstr "Reintentar publicación de reportes fallidos"

#: src/features/devices2/components/DevicesHeader.tsx:192
msgid "Reintento masivo"
msgstr "Reintento masivo"

#: src/features/dga/components/modals/MassiveDGARetryModal.tsx:58
msgid "Reintento masivo de datos DGA"
msgstr "Reintento masivo de datos DGA"

#: src/utils/attributes/metricField.ts:335
msgid "relación señal-ruido"
msgstr "relación señal-ruido"

#: src/utils/i18n/getMetricDisplayName.ts:54
msgid "Relación señal-ruido (SNR)"
msgstr "Relación señal-ruido (SNR)"

#: src/features/access/components/devicesTab/DevicesTab.tsx:41
#: src/features/access/components/usersTab/UsersTab.tsx:40
#: src/features/deviceAccessModal/components/collectionsAccessTab/index.tsx:60
#: src/features/deviceAccessModal/components/deviceAccessTab/index.tsx:36
#: src/features/userConfigurationModal/components/collectionsAccessTab/index.tsx:60
#: src/features/userConfigurationModal/components/deviceAccessTab/index.tsx:38
msgid "Relaciones actualizadas correctamente"
msgstr "Relaciones actualizadas correctamente"

#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:72
msgid "Relaciones creadas correctamente"
msgstr "Relaciones creadas correctamente"

#: src/features/access/components/globalModals/RemoveDeviceUserRelationsModal.tsx:75
msgid "Relaciones eliminadas correctamente"
msgstr "Relaciones eliminadas correctamente"

#: src/features/homeAmaru/components/HomeAmaru.tsx:369
#: src/features/homeAmaru/components/HomeAmaru.tsx:382
#: src/features/homeAmaru/components/HomeAmaru.tsx:395
msgid "Remover como predeterminada"
msgstr "Remover como predeterminada"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:133
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAlertLevelsCheckboxList.tsx:74
#: src/features/organizationAccess/data/sections.ts:49
#: src/pages/distribution/public.tsx:9
msgid "Reparto"
msgstr "Reparto"

#: src/features/organizationAccess/data/sections.ts:53
msgid "Reparto Maipo"
msgstr "Reparto Maipo"

#: src/features/deviceConfigurationModal/components/gateTab/index.tsx:46
msgid "Reportados por el equipo: se actualizan al consultar su estado."
msgstr "Reportados por el equipo: se actualizan al consultar su estado."

#: src/fsd/pages/dga-reports/ui/device-row.tsx:43
#: src/fsd/pages/dga-reports/ui/report-problem-dialog.tsx:100
msgid "Reportar problema"
msgstr "Reportar problema"

#. Análisis de estaciones - botón de reportar problema
#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:32
#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:193
#: src/features/devicesAnalysis/components/panel/Toolbar.tsx:150
#: src/features/metricsViews/components/Subheader.tsx:77
#: src/features/reportProblem/components/ReportProblemModal.tsx:100
#: src/fsd/pages/dashboards/ui/report-problem/report-problem-dialog.tsx:41
#: src/fsd/pages/dashboards/ui/status-strip/status-strip.tsx:105
#: src/fsd/pages/dashboards/ui/status-strip/status-strip.tsx:120
msgid "Reportar un problema"
msgstr "Reportar un problema"

#: src/features/reports/components/CreatedReportNotification.tsx:36
msgid "Reporte creado exitosamente"
msgstr "Reporte creado exitosamente"

#: src/features/reportDownload/components/ReportDownload.tsx:61
msgid "Reporte Descargado exitósamente"
msgstr "Reporte Descargado exitósamente"

#: src/features/reportProblem/components/ReportProblemDialog.tsx:65
#: src/features/reportProblem/components/ReportProblemModal.tsx:71
msgid "Reporte enviado correctamente. Espera unos minutos para poder visualizar el evento"
msgstr "Reporte enviado correctamente. Espera unos minutos para poder visualizar el evento"

#: src/fsd/pages/dashboards/ui/dashboard-editor-page.tsx:278
#: src/fsd/pages/dashboards/ui/status-strip/status-strip.tsx:98
#: src/fsd/pages/dashboards/ui/status-strip/status-strip.tsx:114
msgid "Reporte enviado. El evento puede tardar unos minutos en aparecer."
msgstr "Reporte enviado. El evento puede tardar unos minutos en aparecer."

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:190
msgid "Reporte programado correctamente"
msgstr "Reporte programado correctamente"

#: src/features/reports2/components/ReportCreated.tsx:42
msgid "Reporte recibido"
msgstr "Reporte recibido"

#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:99
msgid "Reporte solicitado con éxito. Este será enviado a los emails ingresados en breve."
msgstr "Reporte solicitado con éxito. Este será enviado a los emails ingresados en breve."

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:140
#: src/features/homeAmaru/components/shared/WorkspaceHeader.tsx:35
#: src/features/metricsViews/utils/quickAccessCatalog.tsx:77
#: src/features/organizationAccess/data/sections.ts:57
#: src/features/reports2/components/Reports.tsx:32
#: src/fsd/entities/dashboard-widget/ui/quick-access/destinations.ts:61
#: src/pages/reports/data-extraction2.tsx:9
#: src/pages/reports/index.tsx:58
#: src/pages/reports/index.tsx:79
#: src/pages/reports2/index.tsx:9
msgid "Reportes"
msgstr "Reportes"

#: src/fsd/pages/dga-reports/ui/latest-reports.tsx:117
msgid "Reportes {first}–{last}"
msgstr "Reportes {first}–{last}"

#: src/fsd/pages/dga-reports/ui/latest-reports.tsx:127
msgid "Reportes anteriores"
msgstr "Reportes anteriores"

#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-chart-option.ts:57
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:93
msgid "Reportes aún sin enviar. Si pasan 7 días sin llegar, cuentan como fallidos."
msgstr "Reportes aún sin enviar. Si pasan 7 días sin llegar, cuentan como fallidos."

#: src/fsd/pages/dga-reports/ui/reports-heatmap.tsx:132
msgid "Reportes de la semana del {from} al {to}"
msgstr "Reportes de la semana del {from} al {to}"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:146
#: src/features/metricsViews/components/widgets/dgaReports/index.tsx:98
#: src/features/metricsViews/components/widgets/DgaReportsChartWidget.tsx:41
#: src/features/metricsViews/utils/genericWidgetTypes.ts:66
#: src/features/organizationAccess/data/sections.ts:61
#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-view.tsx:107
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:16
msgid "Reportes DGA"
msgstr "Reportes DGA"

#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-view.tsx:100
msgid "Reportes DGA por etapa, en porcentaje"
msgstr "Reportes DGA por etapa, en porcentaje"

#: src/features/reports2/components/HeaderButtons.tsx:33
#: src/features/reports2/components/HeaderButtons.tsx:41
#: src/features/reports2/components/reportHistoryModal/ReportHistory.tsx:37
msgid "Reportes generados"
msgstr "Reportes generados"

#: src/features/reports/components/DataExtraction.tsx:18
#: src/features/reports/components/ReportHistory.tsx:33
msgid "Reportes Históricos"
msgstr "Reportes Históricos"

#: src/features/reports2/components/ReportTemplatesTable.tsx:32
msgid "Reportes periódicos"
msgstr "Reportes periódicos"

#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-chart-option.ts:51
msgid "Reportes que llegaron a la DGA y esperan su validación."
msgstr "Reportes que llegaron a la DGA y esperan su validación."

#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-chart-option.ts:45
msgid "Reportes que llegaron a la DGA y que la DGA ya validó."
msgstr "Reportes que llegaron a la DGA y que la DGA ya validó."

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:87
msgid "Reportes que llegaron a la DGA: validados o esperando validación."
msgstr "Reportes que llegaron a la DGA: validados o esperando validación."

#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-chart-option.ts:63
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:99
msgid "Reportes que no llegaron a la DGA en 7 días."
msgstr "Reportes que no llegaron a la DGA en 7 días."

#: src/fsd/pages/dga-reports/ui/latest-reports.tsx:137
msgid "Reportes siguientes"
msgstr "Reportes siguientes"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:152
#: src/features/organizationAccess/data/sections.ts:65
msgid "Reportes SMA"
msgstr "Reportes SMA"

#: src/features/metricsViews/utils/quickAccessCatalog.tsx:78
#: src/fsd/entities/dashboard-widget/ui/quick-access/destinations.ts:62
msgid "Reportes y exportaciones de datos"
msgstr "Reportes y exportaciones de datos"

#: src/features/deviceProfile/components/DeviceProfile.tsx:72
msgid "Representación gráfica"
msgstr "Representación gráfica"

#: src/features/collections/components/CollectionVisualRepresentationFields.tsx:46
#: src/features/createMyCollectionModal/components/CreateMyCollectionModal.tsx:102
#: src/features/homeAmaru/components/shared/UpdateMyCollectionModal.tsx:110
msgid "Representación visual en el mosaico"
msgstr "Representación visual en el mosaico"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:70
msgid "Request ID"
msgstr "Request ID"

#: src/features/gates/components/list/GateListItemLastMovement.tsx:72
msgid "Responsable"
msgstr "Responsable"

#: src/features/changeSupportStatus/data/status.ts:11
#: src/features/deviceSupport/data/status.ts:17
#: src/features/deviceSupport/data/status.ts:39
msgid "Responsable cliente"
msgstr "Responsable cliente"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:308
msgid "Respuesta no útil"
msgstr "Respuesta no útil"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:294
msgid "Respuesta útil"
msgstr "Respuesta útil"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:275
msgid "Respuestas rápidas"
msgstr "Respuestas rápidas"

#: src/features/moveGateModal/components/MoveGateForm.tsx:231
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:392
#: src/fsd/pages/widget-catalog/ui/config-panel.tsx:34
msgid "Restablecer"
msgstr "Restablecer"

#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:384
msgid "Restablecer configuración"
msgstr "Restablecer configuración"

#: src/components/modal/ModalActions.tsx:88
#: src/features/alertsConfiguration/components/DialogUsersNotifications.tsx:188
#: src/features/organizationPreferences/components/InterfaceTab.tsx:115
#: src/features/preferencesCommon/components/common/CustomModalActions.tsx:41
#: src/features/preferencesCommon/components/UpdateVisibleUnitsForm.tsx:216
#: src/features/userPreferences/components/InterfaceTab.tsx:113
#: src/features/userPreferences/components/RegionTab.tsx:314
msgid "Restablecer formulario"
msgstr "Restablecer formulario"

#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/LevelCalibrationForm.tsx:131
#: src/features/deviceDataConfigurationModal/components/tabs/calibrationTab/PositionFromAngleCalibrationForm.tsx:154
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:538
#: src/features/deviceDataConfigurationModal/components/tabs/flowLimitsTab/index.tsx:187
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/index.tsx:260
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:372
msgid "Restablecer Formulario"
msgstr "Restablecer Formulario"

#: src/features/organizationPreferences/components/InterfaceTab.tsx:106
#: src/features/preferencesCommon/components/common/CustomModalActions.tsx:34
#: src/features/preferencesCommon/components/UpdateVisibleUnitsForm.tsx:209
#: src/features/userPreferences/components/InterfaceTab.tsx:104
#: src/features/userPreferences/components/RegionTab.tsx:305
msgid "Restablecer valores por defecto"
msgstr "Restablecer valores por defecto"

#: src/features/moveGateModal/components/MoveGateForm.tsx:205
#: src/fsd/app/locale/au-labels.ts:44
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:358
msgid "Restar"
msgstr "Restar"

#: src/features/users/components/tableCells/UserActionsCell.tsx:75
msgid "Restaurar"
msgstr "Restaurar"

#: src/fsd/pages/gate-movements/ui/panel/result/movement-result.tsx:31
msgid "Resultado"
msgstr "Resultado"

#: src/features/gateOperationModal/components/PanelSummary.tsx:60
msgid "Resumen <0>de la operación</0>"
msgstr "Resumen <0>de la operación</0>"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:25
msgid "Resumen de estación"
msgstr "Resumen de estación"

#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:110
msgid "Resumen de la alerta"
msgstr "Resumen de la alerta"

#: src/fsd/features/gate-movements/ui/operation/operation-summary.tsx:31
msgid "Resumen de la operación"
msgstr "Resumen de la operación"

#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:28
msgid "Resumen de tendencia"
msgstr "Resumen de tendencia"

#: src/features/alertsConfigurationV2/components/upsertModal/AlertsConfigurationModal.tsx:61
#: src/features/alertsConfigurationV3/components/wizard/AlertWizardModal.tsx:90
#: src/features/reports2/utils/createModalStep.ts:30
msgid "Resumen general"
msgstr "Resumen general"

#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:383
msgid "Resumen General"
msgstr "Resumen General"

#: src/features/reports2/components/TemplateSummary.tsx:56
msgid "Resumen información configurada"
msgstr "Resumen información configurada"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:88
msgid "Retroceso"
msgstr "Retroceso"

#: src/features/reports2/components/HeaderButtons.tsx:35
msgid "Revisa el historial de reportes emitidos para mantener un seguimiento confiable de la información."
msgstr "Revisa el historial de reportes emitidos para mantener un seguimiento confiable de la información."

#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:111
msgid "Revisa la configuración antes de confirmar."
msgstr "Revisa la configuración antes de confirmar."

#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:247
#: src/fsd/pages/dga-reports/ui/page-error-boundary.tsx:33
#: src/fsd/pages/dga-reports/ui/report-problem-dialog.tsx:86
#: src/fsd/pages/gate-movements/ui/page-error-boundary.tsx:24
msgid "Revisa tu conexión e inténtalo de nuevo."
msgstr "Revisa tu conexión e inténtalo de nuevo."

#: src/features/gateCommon/utils/gateCloseCode.ts:126
#: src/fsd/entities/gate/model/close-code.ts:111
msgid "revisar el actuador en terreno"
msgstr "revisar el actuador en terreno"

#: src/features/gateCommon/utils/gateCloseCode.ts:113
#: src/fsd/entities/gate/model/close-code.ts:98
msgid "revisar el conexionado del actuador"
msgstr "revisar el conexionado del actuador"

#: src/features/gateCommon/utils/gateCloseCode.ts:118
#: src/fsd/entities/gate/model/close-code.ts:103
msgid "revisar el fin de carrera en terreno"
msgstr "revisar el fin de carrera en terreno"

#: src/features/gateCommon/utils/gateCloseCode.ts:103
#: src/fsd/entities/gate/model/close-code.ts:88
msgid "revisar obstrucciones en el mecanismo"
msgstr "revisar obstrucciones en el mecanismo"

#: src/components/ColorPicker/palettes.ts:29
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:27
msgid "Rojo"
msgstr "Rojo"

#: src/features/userSaveModal/components/UserSaveModal.tsx:515
#: src/features/userSaveModal/components/UserSaveModal.tsx:571
msgid "Rol"
msgstr "Rol"

#: src/features/collections/components/modals/ManageCollectionAccessModal.tsx:119
msgid "Rol actualizado exitosamente"
msgstr "Rol actualizado exitosamente"

#: src/utils/roles.ts:22
msgid "Rol desconocido"
msgstr "Rol desconocido"

#: src/fsd/pages/dashboards/ui/board-color/color-names.ts:12
msgid "Rosa"
msgstr "Rosa"

#: src/components/ColorPicker/palettes.ts:30
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:28
msgid "Rosado"
msgstr "Rosado"

#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:271
msgid "Rubro"
msgstr "Rubro"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:53
#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:234
#: src/features/dga/components/modals/tabs/GeneralTab.tsx:158
msgid "RUT"
msgstr "RUT"

#: src/fsd/shared/ui/format/units.ts:270
#: src/utils/units.ts:327
msgid "s"
msgstr "s"

#: src/features/gateOperationModal/components/dataComponents/MovementSummaryAttribute.tsx:49
#: src/fsd/features/gate-movements/ui/list/movement-row.tsx:40
#: src/fsd/features/gate-movements/ui/operation/operation-summary.tsx:37
#: src/fsd/features/gate-movements/ui/operation/operation-summary.tsx:44
#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:55
#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:109
msgid "S/D"
msgstr "S/D"

#: src/features/reports/utils/schedules.ts:18
msgid "sábado"
msgstr "sábado"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:120
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:164
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:252
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:89
#: src/features/reports2/utils/schedule.ts:29
#: src/fsd/entities/dashboard-widget/model/dga-frequency.ts:18
#: src/utils/i18n/getDgaTranslations.ts:12
msgid "Sábado"
msgstr "Sábado"

#: src/features/debtsAlert/components/DebtsAlertBanner.tsx:55
msgid "Saldo pendiente. <0>Detalles aquí.</0>"
msgstr "Saldo pendiente. <0>Detalles aquí.</0>"

#: src/features/metricsViews/components/AssociateCollectionModal.tsx:235
msgid "Salen {0} dispositivos"
msgstr "Salen {0} dispositivos"

#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:182
msgid "Salir de edición"
msgstr "Salir de edición"

#: src/features/metricsViews/components/MetricsView.tsx:536
#: src/fsd/pages/dashboards/ui/leave-dialog.tsx:41
msgid "Salir sin guardar"
msgstr "Salir sin guardar"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:78
msgid "Sat. oxígeno"
msgstr "Sat. oxígeno"

#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:81
msgid "Satelital"
msgstr "Satelital"

#: src/utils/attributes/metricField.ts:173
msgid "saturación de oxígeno disuelto"
msgstr "saturación de oxígeno disuelto"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:354
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:33
#: src/utils/attributes/deviceAlertMetricName.ts:57
msgid "Saturación de oxígeno disuelto"
msgstr "Saturación de oxígeno disuelto"

#: src/features/reports/utils/metricHelpers.ts:17
msgid "Saturación de Oxígeno Disuelto"
msgstr "Saturación de Oxígeno Disuelto"

#: src/utils/attributes/metricField.ts:179
msgid "saturación de oxígeno disuelto bruta"
msgstr "saturación de oxígeno disuelto bruta"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:356
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:182
msgid "Saturación de oxígeno disuelto bruto"
msgstr "Saturación de oxígeno disuelto bruto"

#: src/utils/i18n/getMetricDisplayName.ts:35
msgid "Saturación O₂"
msgstr "Saturación O₂"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:477
msgid "SD Threshold"
msgstr "SD Threshold"

#: src/features/gateCommon/hooks/useStopGateOperation.ts:31
#: src/fsd/entities/gate/model/command-feedback.ts:48
msgid "Se canceló la solicitud en cola. Si el equipo estaba recibiéndola en ese momento, la compuerta podría arrancar igual: verifique su estado."
msgstr "Se canceló la solicitud en cola. Si el equipo estaba recibiéndola en ese momento, la compuerta podría arrancar igual: verifique su estado."

#: src/features/createDeviceConfiguration/components/common/PDFUploadField.tsx:176
msgid "Se confirmará al guardar la configuración"
msgstr "Se confirmará al guardar la configuración"

#: src/features/billing/components/modals/ServiceFileManager.tsx:87
msgid "Se crearán los siguientes servicios. Para guardar los cambios, presione guardar."
msgstr "Se crearán los siguientes servicios. Para guardar los cambios, presione guardar."

#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:189
msgid "Se descargan los reportes de la ventana fija, en formato CSV."
msgstr "Se descargan los reportes de la ventana fija, en formato CSV."

#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:190
msgid "Se descargan los reportes emitidos dentro del período, en formato CSV."
msgstr "Se descargan los reportes emitidos dentro del período, en formato CSV."

#: src/features/organizationDelete/components/DeleteOrganization.tsx:152
msgid "Se eliminará permanentemente la organización y todos sus datos asociados. No podrá recuperarse esta información."
msgstr "Se eliminará permanentemente la organización y todos sus datos asociados. No podrá recuperarse esta información."

#: src/features/usersGraveyard/components/HardDeleteUserModal.tsx:105
msgid "Se eliminarán permanentemente el usuario y todos sus datos asociados. No podrá recuperarse esta información."
msgstr "Se eliminarán permanentemente el usuario y todos sus datos asociados. No podrá recuperarse esta información."

#: src/features/gateOperationModal/components/panelNotification/utils.tsx:245
#: src/fsd/features/gate-movements/ui/panel/events/event-text.tsx:163
msgid "se enviará cuando el equipo se conecte"
msgstr "se enviará cuando el equipo se conecte"

#: src/features/gateCommon/utils/gateMovementState.tsx:196
#: src/fsd/entities/gate/model/movement-state.ts:112
msgid "Se enviará cuando el equipo se conecte."
msgstr "Se enviará cuando el equipo se conecte."

#: src/features/dga/components/modals/reports/SendReportsByEmailModal.tsx:72
msgid "Se enviará la información solicitada en formato excel al correo <0>{0}</0>"
msgstr "Se enviará la información solicitada en formato excel al correo <0>{0}</0>"

#: src/features/api/components/dialogs/ResendApiCredentialsDialog.tsx:114
msgid "Se enviarán por correo el nombre de usuario, una contraseña nueva y la API Key de la credencial <0>{0}</0>."
msgstr "Se enviarán por correo el nombre de usuario, una contraseña nueva y la API Key de la credencial <0>{0}</0>."

#: src/features/userSaveModal/components/SendPasswordResetEmailButton.tsx:20
msgid "Se envió un correo al usuario para restablecer su contraseña."
msgstr "Se envió un correo al usuario para restablecer su contraseña."

#: src/features/gateCommon/utils/gateMovementState.tsx:181
#: src/fsd/entities/gate/model/movement-state.ts:97
msgid "Se está confirmando si alcanzó a enviarse justo antes del plazo."
msgstr "Se está confirmando si alcanzó a enviarse justo antes del plazo."

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:215
msgid "Se está guardando el tablero: espera para aplicar."
msgstr "Se está guardando el tablero: espera para aplicar."

#: src/fsd/pages/dashboards/ui/keyboard/use-clipboard.ts:54
msgid "Se está guardando el tablero: espera para cortar widgets."
msgstr "Se está guardando el tablero: espera para cortar widgets."

#: src/fsd/pages/dashboards/ui/dashboard-editor-page.tsx:459
#: src/fsd/pages/dashboards/ui/keyboard/use-board-keys.ts:117
msgid "Se está guardando el tablero: espera para mover widgets."
msgstr "Se está guardando el tablero: espera para mover widgets."

#: src/fsd/pages/dashboards/ui/keyboard/use-clipboard.ts:82
msgid "Se está guardando el tablero: espera para pegar widgets."
msgstr "Se está guardando el tablero: espera para pegar widgets."

#: src/features/changeOperationalState/components/AfterUpdateTasksModal.tsx:156
msgid "Se están enviando datos a la DGA"
msgstr "Se están enviando datos a la DGA"

#: src/fsd/pages/dashboards/ui/save-loss-dialog.tsx:86
msgid "Se guardan con el ajuste con que se muestran"
msgstr "Se guardan con el ajuste con que se muestran"

#: src/features/dgaTicket/components/DgaTicketModal.tsx:522
msgid "Se ha abierto un nuevo ticket."
msgstr "Se ha abierto un nuevo ticket."

#: src/features/organizationAccess/components/OrganizationAccess.tsx:50
msgid "Se ha actualizado el acceso a la organización"
msgstr "Se ha actualizado el acceso a la organización"

#: src/features/users/components/tableCells/UserStatusCell.tsx:16
msgid "Se ha actualizado el estado"
msgstr "Se ha actualizado el estado"

#: src/features/dgaTicket/components/DgaTicketModal.tsx:486
msgid "Se ha actualizado el ticket correctamente."
msgstr "Se ha actualizado el ticket correctamente."

#: src/features/users/components/tableCells/User2FACell.tsx:18
msgid "Se ha actualizado la autenticación en 2 pasos"
msgstr "Se ha actualizado la autenticación en 2 pasos"

#: src/features/users/components/tableCells/UserShouldAuthCell.tsx:15
msgid "Se ha actualizado la reautenticación del usuario"
msgstr "Se ha actualizado la reautenticación del usuario"

#: src/features/dgaTicket/components/DgaTicketModal.tsx:500
msgid "Se ha cerrado el ticket correctamente."
msgstr "Se ha cerrado el ticket correctamente."

#: src/features/deviceConfigurationModal/components/gateTab/CreateLinkedDeviceButton.tsx:25
msgid "Se ha creado el dispositivo correctamente"
msgstr "Se ha creado el dispositivo correctamente"

#: src/features/reports/components/CreatedReportNotification.tsx:38
msgid "Se ha creado el reporte con éxito y ha sido enviado a los correos electrónicos seleccionados. Por favor, revise su bandeja de entrada."
msgstr "Se ha creado el reporte con éxito y ha sido enviado a los correos electrónicos seleccionados. Por favor, revise su bandeja de entrada."

#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:79
msgid "Se ha creado el usuario temporal <0><1>{0}</1></0>"
msgstr "Se ha creado el usuario temporal <0><1>{0}</1></0>"

#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:35
msgid "Se ha creado el usuario temporal con id {id}"
msgstr "Se ha creado el usuario temporal con id {id}"

#: src/features/metricsViews/components/createViewModal/CreateViewForm.tsx:42
msgid "Se ha creado la visualización correctamente"
msgstr "Se ha creado la visualización correctamente"

#: src/features/deviceConfigurationModal/components/cloneDeviceModal/CloneDeviceModal.tsx:39
msgid "Se ha creado un dispositivo clonado con id {0}"
msgstr "Se ha creado un dispositivo clonado con id {0}"

#: src/features/reports2/components/createModal/useCreateForm.ts:169
#: src/features/reports2/components/DownloadReportTemplateModal.tsx:35
msgid "Se ha encolado la generación del reporte, lo recibirás en unos momentos"
msgstr "Se ha encolado la generación del reporte, lo recibirás en unos momentos"

#: src/features/sma/components/SendReportsByEmailModal.tsx:53
msgid "Se ha enviado el reporte a tu correo"
msgstr "Se ha enviado el reporte a tu correo"

#: src/features/dga/components/modals/reports/SendReportsByEmailModal.tsx:36
msgid "Se ha enviado el reporte al correo {0}"
msgstr "Se ha enviado el reporte al correo {0}"

#: src/features/users/components/modals/ExtendTemporaryUserTokenModal.tsx:23
msgid "Se ha extendido el tiempo de expiración del token"
msgstr "Se ha extendido el tiempo de expiración del token"

#: src/features/users/components/modals/ExtendTemporaryUserModal.tsx:26
msgid "Se ha extendido el tiempo de expiración del usuario"
msgstr "Se ha extendido el tiempo de expiración del usuario"

#: src/features/reports2/components/ReportCreated.tsx:47
msgid "Se ha generado el reporte correctamente, puedes descargarlos a continuación:"
msgstr "Se ha generado el reporte correctamente, puedes descargarlos a continuación:"

#: src/features/reports2/components/createModal/useCreateForm.ts:233
msgid "Se ha guardado el reporte correctamente"
msgstr "Se ha guardado el reporte correctamente"

#: src/features/deviceConfigurationModal/components/gateTab/RemoveLinkedDeviceButton.tsx:26
msgid "Se ha quitado el sensor de nivel correctamente"
msgstr "Se ha quitado el sensor de nivel correctamente"

#: src/features/preferencesCommon/components/UpdatePreferredUnitsForm.tsx:100
#: src/features/preferencesCommon/components/UpdateVisibleUnitsForm.tsx:52
#: src/features/preferencesCommon/components/UpdateVisibleUnitsForm.tsx:62
msgid "Se han actualizado las preferencias"
msgstr "Se han actualizado las preferencias"

#: src/features/resendCredentialsModal/components/ResendCredentialsModal.tsx:41
msgid "Se han reenviado las credenciales correctamente."
msgstr "Se han reenviado las credenciales correctamente."

#: src/features/dga/components/modals/MassiveDGARetryModal.tsx:42
msgid "Se inició el proceso de reintento masivo exitosamente."
msgstr "Se inició el proceso de reintento masivo exitosamente."

#: src/features/recoveryPassword/components/RecoveryPassword.tsx:36
msgid "Se le ha enviado un correo electrónico para cambiar la contraseña. (revisar correos de spam)"
msgstr "Se le ha enviado un correo electrónico para cambiar la contraseña. (revisar correos de spam)"

#: src/features/metricsViews/components/AssociateCollectionModal.tsx:248
msgid "Se mantienen {0} dispositivos"
msgstr "Se mantienen {0} dispositivos"

#: src/features/billing/components/DueDate.tsx:30
msgid "Se modificó la fecha de próximo pago para todos los servicios del proyecto."
msgstr "Se modificó la fecha de próximo pago para todos los servicios del proyecto."

#: src/features/billing/components/table/ProjectsTable.tsx:140
msgid "Se modificó la periodicidad correctamente"
msgstr "Se modificó la periodicidad correctamente"

#: src/features/gateOperationModal/components/panelNotification/NotificationCard.tsx:213
#: src/fsd/features/gate-movements/ui/operation/feed/feed-card.tsx:140
#: src/fsd/pages/gate-movements/ui/panel/events/event-card.tsx:150
msgid "Se movió"
msgstr "Se movió"

#: src/fsd/features/gate-movements/ui/panel/events/feed-announcer.tsx:82
msgid "Se movió {0} hasta {1}"
msgstr "Se movió {0} hasta {1}"

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:52
msgid "Se omitió «{name}»: le falta lo mínimo para guardarse."
msgstr "Se omitió «{name}»: le falta lo mínimo para guardarse."

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:56
msgid "Se omitió «{name}»: usa un dispositivo que no está en este tablero."
msgstr "Se omitió «{name}»: usa un dispositivo que no está en este tablero."

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:51
msgid "Se omitió la tabla «{name}»: le faltan el dispositivo o las columnas."
msgstr "Se omitió la tabla «{name}»: le faltan el dispositivo o las columnas."

#: src/fsd/pages/dashboards/ui/assistant/assistant-text.ts:46
msgid "Se omitió un widget de tipo «{type}», que este editor no conoce."
msgstr "Se omitió un widget de tipo «{type}», que este editor no conoce."

#: src/features/dgaTicket/components/DgaTicketModal.tsx:122
msgid "Se perderán los cambios sin guardar."
msgstr "Se perderán los cambios sin guardar."

#: src/fsd/pages/dashboards/ui/save-loss-dialog.tsx:78
msgid "Se pierden (este editor no puede representarlas)"
msgstr "Se pierden (este editor no puede representarlas)"

#: src/features/reports2/components/Reports.tsx:34
msgid "Se pueden revisar tanto los reportes programados (que se envían automáticamente en fechas definidas) como los no programados (generados manualmente). Además, la sección permite crear nuevos reportes en el momento y guardar plantillas personalizadas para automatizar futuros envíos de manera recurrente."
msgstr "Se pueden revisar tanto los reportes programados (que se envían automáticamente en fechas definidas) como los no programados (generados manualmente). Además, la sección permite crear nuevos reportes en el momento y guardar plantillas personalizadas para automatizar futuros envíos de manera recurrente."

#: src/features/dga/components/modals/DGAReportsRetryModal.tsx:42
msgid "Se realizará un nuevo intento de envío de los datos. Se sugiere verificar el estado de los envíos nuevamente pasadas las dos horas desde el reintento."
msgstr "Se realizará un nuevo intento de envío de los datos. Se sugiere verificar el estado de los envíos nuevamente pasadas las dos horas desde el reintento."

#: src/fsd/pages/dashboards/ui/layout-warnings/warning-text.ts:35
msgid "Se superpone con «{other}»; en edición se separan."
msgstr "Se superpone con «{other}»; en edición se separan."

#: src/features/metricsViews/components/forms/ActiveAlertsForm.tsx:71
#: src/features/metricsViews/components/forms/ConfiguredAlertsForm.tsx:61
msgid "Se usan todos los dispositivos del tablero, incluidos los que se agreguen después."
msgstr "Se usan todos los dispositivos del tablero, incluidos los que se agreguen después."

#: src/features/alertsConfiguration/components/DialogConfirmationNotifications.tsx:97
msgid "Se van a realizar los siguientes cambios:"
msgstr "Se van a realizar los siguientes cambios:"

#: src/features/organizationAccess/components/OrganizationAccessTable.tsx:33
#: src/fsd/entities/dashboard-widget/ui/text/text-editor.tsx:19
msgid "Sección"
msgstr "Sección"

#: src/fsd/pages/widget-catalog/model/examples.ts:370
msgid "Sección corta"
msgstr "Sección corta"

#: src/fsd/pages/widget-catalog/model/examples.ts:371
msgid "Sección larga (se trunca)"
msgstr "Sección larga (se trunca)"

#: src/features/metricsViews/components/MetricsView.tsx:540
#: src/features/metricsViews/components/MetricsView.tsx:552
#: src/fsd/pages/dashboards/ui/discard-dialog.tsx:36
#: src/fsd/pages/dashboards/ui/leave-dialog.tsx:38
#: src/fsd/pages/dashboards/ui/save-loss-dialog.tsx:67
msgid "Seguir editando"
msgstr "Seguir editando"

#: src/features/announcements/components/AnnouncementsView.tsx:289
msgid "Seguir leyendo"
msgstr "Seguir leyendo"

#: src/features/moveGateModal/components/LiveNotice.tsx:70
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:255
msgid "Según la última lectura del equipo, la compuerta está en movimiento. Detenla o espera a que termine para pedir otro movimiento."
msgstr "Según la última lectura del equipo, la compuerta está en movimiento. Detenla o espera a que termine para pedir otro movimiento."

#: src/fsd/shared/ui/format/units.ts:271
#: src/utils/units.ts:328
msgid "segundo"
msgstr "segundo"

#: src/features/audit/utils/parseProperty.ts:110
msgid "segundo caudal repartible"
msgstr "segundo caudal repartible"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:255
#: src/fsd/pages/dashboards/ui/panel/multi-scope.tsx:39
msgid "Selección"
msgstr "Selección"

#: src/features/reports2/components/createModal/steps/step3/3-FormatAndRecipients.tsx:256
msgid "Selecciona contactos guardados o agrega correos nuevos"
msgstr "Selecciona contactos guardados o agrega correos nuevos"

#: src/features/dga/components/modals/CopyDGAConfigSection.tsx:76
msgid "Selecciona el dispositivo del que quieres copiar la configuración DGA. Los campos se llenarán con los datos del dispositivo seleccionado."
msgstr "Selecciona el dispositivo del que quieres copiar la configuración DGA. Los campos se llenarán con los datos del dispositivo seleccionado."

#: src/features/alertsConfigurationV3/components/wizard/steps/DeviceStep.tsx:26
msgid "Selecciona el dispositivo para el que quieres configurar la alerta."
msgstr "Selecciona el dispositivo para el que quieres configurar la alerta."

#: src/features/sma/components/SendReportsByEmailModal.tsx:87
msgid "Selecciona el rango de fechas para generar el excel"
msgstr "Selecciona el rango de fechas para generar el excel"

#: src/features/metricsViews/components/widgets/gateOperate/CurrentPosition.tsx:17
#: src/features/metricsViews/components/widgets/gateOperate/CurrentStatus.tsx:17
#: src/features/metricsViews/components/widgets/gateOperate/index.tsx:54
#: src/features/metricsViews/components/widgets/map/DevicesControls.legacy.tsx:105
#: src/features/metricsViews/components/widgets/map/DevicesControls.tsx:145
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:275
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-view.tsx:155
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:306
msgid "Selecciona un dispositivo"
msgstr "Selecciona un dispositivo"

#: src/features/reports2/components/createModal/steps/step1/MultipleCheckbox.tsx:52
msgid "Selecciona un dispositivo para mostrar sus métricas"
msgstr "Selecciona un dispositivo para mostrar sus métricas"

#: src/features/alertsConfigurationV3/components/wizard/steps/MetricStep.tsx:91
msgid "Seleccioná un dispositivo para ver sus métricas configurables."
msgstr "Seleccioná un dispositivo para ver sus métricas configurables."

#: src/features/alertsConfigurationV3/components/wizard/steps/NotificationsStep.tsx:119
msgid "Seleccioná un dispositivo para ver sus usuarios."
msgstr "Seleccioná un dispositivo para ver sus usuarios."

#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:153
msgid "Seleccioná una métrica en el paso anterior para configurar condiciones."
msgstr "Seleccioná una métrica en el paso anterior para configurar condiciones."

#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:172
msgid "Selecciona una organización para filtrar dispositivos"
msgstr "Selecciona una organización para filtrar dispositivos"

#: src/features/access/components/globalModals/AddDeviceUserRelationsModal.tsx:185
msgid "Selecciona una organización para filtrar usuarios"
msgstr "Selecciona una organización para filtrar usuarios"

#: src/features/reports2/components/createModal/steps/step2/2-TimePeriod.tsx:44
msgid "Selecciona y define los periodos de tiempo para tu reporte."
msgstr "Selecciona y define los periodos de tiempo para tu reporte."

#: src/features/standardDesign/components/accessRelationManager/AccessRelationManagerModal.tsx:150
msgid "seleccionado(s) de"
msgstr "seleccionado(s) de"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:238
#: src/features/billing/components/modals/ServiceFileManager.tsx:238
msgid "Seleccionar Archivo"
msgstr "Seleccionar Archivo"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:66
msgid "Seleccionar con un cuadro"
msgstr "Seleccionar con un cuadro"

#: src/features/deviceCommands/components/DeviceSelector.tsx:52
#: src/features/deviceCommands/components/DeviceSelector.tsx:56
#: src/features/reports2/components/createModal/steps/step1/DevicesInput.tsx:44
msgid "Seleccionar dispositivos"
msgstr "Seleccionar dispositivos"

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:498
msgid "Seleccionar Dispositivos"
msgstr "Seleccionar Dispositivos"

#: src/features/collections/components/modals/AddCollectionAccessModal.tsx:75
msgid "Seleccionar dispositivos para {0}"
msgstr "Seleccionar dispositivos para {0}"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:211
msgid "Seleccionar el widget"
msgstr "Seleccionar el widget"

#: src/components/ImageUploadField.tsx:131
msgid "Seleccionar imagen"
msgstr "Seleccionar imagen"

#: src/features/reports2/components/createModal/steps/step1/MetricsInput.tsx:278
msgid "Seleccionar métricas"
msgstr "Seleccionar métricas"

#: src/features/devicesAccessInputs/components/DevicesAccessForUserInput.tsx:136
#: src/features/devicesAccessInputs/components/UsersAccessForDeviceInput.tsx:179
msgid "Seleccionar ninguno"
msgstr "Seleccionar ninguno"

#: src/features/createDeviceConfiguration/components/common/PDFUploadField.tsx:194
msgid "Seleccionar PDF"
msgstr "Seleccionar PDF"

#: src/features/devicesAccessInputs/components/DevicesAccessForUserInput.tsx:133
#: src/features/devicesAccessInputs/components/UsersAccessForDeviceInput.tsx:176
#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:286
#: src/features/reports/components/selectables/DeviceSelectDialog.tsx:149
msgid "Seleccionar todos"
msgstr "Seleccionar todos"

#: src/features/billing/components/payments/PaymentForm.tsx:171
msgid "Seleccionar un archivo"
msgstr "Seleccionar un archivo"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:57
msgid "Seleccionar un widget"
msgstr "Seleccionar un widget"

#: src/features/userActivityLogs/components/UserActivityLogsModal.tsx:136
msgid "Seleccionar usuario"
msgstr "Seleccionar usuario"

#: src/features/collections/components/modals/AddCollectionAccessModal.tsx:149
msgid "Seleccionar usuarios para {0}"
msgstr "Seleccionar usuarios para {0}"

#: src/fsd/app/locale/au-labels.ts:34
msgid "Seleccionar…"
msgstr "Seleccionar…"

#: src/features/reports/components/selectables/DeviceSelectDialog.tsx:110
msgid "Seleccione los dispositivos para el reporte"
msgstr "Seleccione los dispositivos para el reporte"

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:524
msgid "Seleccione un dispositivo para ver sus métricas disponibles."
msgstr "Seleccione un dispositivo para ver sus métricas disponibles."

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:281
#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:290
msgid "Seleccione un usuario"
msgstr "Seleccione un usuario"

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:256
msgid "Seleccione una organización"
msgstr "Seleccione una organización"

#: src/features/alertsNotificationsHistory/components/histogram/index.tsx:37
#: src/fsd/pages/dga-reports/ui/reports-heatmap.tsx:59
msgid "Semana"
msgstr "Semana"

#: src/fsd/app/locale/au-labels.ts:85
msgid "Semana {weekNumber}"
msgstr "Semana {weekNumber}"

#: src/fsd/pages/dga-reports/ui/reports-heatmap.tsx:69
msgid "Semana anterior"
msgstr "Semana anterior"

#: src/features/dga/components/modals/reports/components/WeekSelector.tsx:37
#: src/features/sma/components/SmaSuccessTableModal.tsx:95
msgid "Semana Anterior"
msgstr "Semana Anterior"

#: src/features/sma/components/SmaSuccessTableModal.tsx:78
msgid "Semana del <0>{0}</0> al <1>{1}</1>"
msgstr "Semana del <0>{0}</0> al <1>{1}</1>"

#: src/features/devices2/utils/getDgaFrequencyOptions.ts:7
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:121
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:209
#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:40
msgid "Semanal"
msgstr "Semanal"

#: src/fsd/entities/dashboard-widget/model/dga-frequency.ts:50
msgid "Semanal ({weekday} {hour})"
msgstr "Semanal ({weekday} {hour})"

#: src/utils/i18n/getDgaTranslations.ts:38
msgid "Semanal ({weekday} {hourString})"
msgstr "Semanal ({weekday} {hourString})"

#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:97
#: src/features/reports2/utils/schedule.ts:12
msgid "Semanalmente"
msgstr "Semanalmente"

#: src/features/reports/utils/schedules.ts:48
#: src/features/reports2/utils/schedule.ts:81
msgid "Semanalmente los días {daysOfWeekStr} a las {hoursMinutesStr} horas."
msgstr "Semanalmente los días {daysOfWeekStr} a las {hoursMinutesStr} horas."

#: src/features/billing/utils/translations.ts:12
#: src/features/billing/utils/translations.ts:29
msgid "Semestral"
msgstr "Semestral"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:82
msgid "Señal"
msgstr "Señal"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:441
msgid "Sensor"
msgstr "Sensor"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:48
msgid "Sensor de ángulo"
msgstr "Sensor de ángulo"

#: src/features/audit/utils/parseProperty.ts:162
msgid "sensor de caudal"
msgstr "sensor de caudal"

#: src/features/audit/utils/parseProperty.ts:55
msgid "sensor de flujo"
msgstr "sensor de flujo"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:40
msgid "Sensor de flujo"
msgstr "Sensor de flujo"

#: src/features/audit/utils/parseProperty.ts:47
#: src/features/audit/utils/parseProperty.ts:153
msgid "sensor de nivel"
msgstr "sensor de nivel"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:32
msgid "Sensor de nivel"
msgstr "Sensor de nivel"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:96
msgid "Sensor de potenciómetro"
msgstr "Sensor de potenciómetro"

#: src/features/audit/utils/parseProperty.ts:51
#: src/features/audit/utils/parseProperty.ts:161
msgid "sensor de velocidad"
msgstr "sensor de velocidad"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:44
msgid "Sensor de velocidad"
msgstr "Sensor de velocidad"

#: src/features/audit/utils/parseProperty.ts:103
msgid "sensores"
msgstr "sensores"

#: src/features/metricsViews/components/forms/GateSensorWidgetForm.tsx:92
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-editor.tsx:94
msgid "Sensores"
msgstr "Sensores"

#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-editor.tsx:73
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-view.tsx:227
msgid "Sensores activos"
msgstr "Sensores activos"

#: src/features/metricsViews/utils/genericWidgetTypes.ts:77
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:20
msgid "Sensores de compuerta"
msgstr "Sensores de compuerta"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:337
#: src/features/deviceConfiguration/data/sectionFields.ts:44
#: src/features/deviceConfiguration/data/sectionInputs.ts:41
#: src/features/deviceProfile/components/page/modularComponents/index.tsx:43
msgid "Sensorización"
msgstr "Sensorización"

#: src/features/deviceCommands/components/calendar/CalendarHeader.tsx:29
msgid "Septiembre"
msgstr "Septiembre"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:127
msgid "Serie {n}"
msgstr "Serie {n}"

#: src/fsd/entities/dashboard-widget/model/chart-sample.ts:123
msgid "Serie parcial"
msgstr "Serie parcial"

#: src/fsd/entities/dashboard-widget/model/chart-sample.ts:122
msgid "Serie vacía"
msgstr "Serie vacía"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:119
msgid "Series"
msgstr "Series"

#: src/features/billing/components/payments/PaymentRow.tsx:100
#: src/features/billing/components/table/ServicesTableForTooltip.tsx:42
#: src/features/billing/utils/list.ts:21
msgid "Servicio"
msgstr "Servicio"

#: src/features/billing/components/projectService/Delete.tsx:138
msgid "Servicio a eliminar"
msgstr "Servicio a eliminar"

#: src/features/billing/components/service/Update.tsx:39
msgid "Servicio actualizado correctamente."
msgstr "Servicio actualizado correctamente."

#: src/features/billing/components/projectService/Create.tsx:63
msgid "Servicio agregado al proyecto."
msgstr "Servicio agregado al proyecto."

#: src/features/billing/components/service/Administration.tsx:45
#: src/features/billing/components/service/Delete.tsx:32
msgid "Servicio creado correctamente."
msgstr "Servicio creado correctamente."

#: src/features/billing/components/projectService/Delete.tsx:52
msgid "Servicio eliminado correctamente"
msgstr "Servicio eliminado correctamente"

#: src/features/billing/components/projectService/Create.tsx:70
msgid "Servicio existente para el proyecto ingresado. El servicio debe ser único."
msgstr "Servicio existente para el proyecto ingresado. El servicio debe ser único."

#: src/features/billing/components/payments/PaymentDetailsForm.tsx:44
#: src/features/billing/components/table/DevicesTable.tsx:152
#: src/features/billing/components/table/ProjectsTable.tsx:75
msgid "Servicios"
msgstr "Servicios"

#: src/features/billing/components/table/OrganizationsTable.tsx:68
msgid "Servicios activos"
msgstr "Servicios activos"

#: src/features/billing/components/modals/ServiceFileManager.tsx:52
msgid "Servicios creados correctamente!"
msgstr "Servicios creados correctamente!"

#: src/features/audit/components/AuditLogDetailsRow.tsx:26
#: src/features/reports/components/templateSection/ReportTemplateList.tsx:102
#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:147
#: src/features/reports2/components/createModal/steps/step5/ReportSummary.tsx:127
#: src/features/reports2/components/ReportTemplatesTable.tsx:226
msgid "Sí"
msgstr "Sí"

#: src/features/dgaTicket/components/DgaTicketModal.tsx:181
msgid "Si aún no has creado el ticket en la DGA, puedes crearlo desde <0>este enlace.</0>"
msgstr "Si aún no has creado el ticket en la DGA, puedes crearlo desde <0>este enlace.</0>"

#: src/features/alertsConfigurationV3/components/ListPlaceholders.tsx:71
msgid "Si el problema persiste comuníquese con soporte"
msgstr "Si el problema persiste comuníquese con soporte"

#: src/pages/AuthorizationRequired.tsx:62
msgid "Si necesitas acceder a esta página, ponte en contacto con dev@captahydro.com para habilitar tu cuenta"
msgstr "Si necesitas acceder a esta página, ponte en contacto con dev@captahydro.com para habilitar tu cuenta"

#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:98
msgid "Si pierdes el link de activación puedes volver a consultarlo en el perfil del usuario"
msgstr "Si pierdes el link de activación puedes volver a consultarlo en el perfil del usuario"

#: src/features/reports2/components/versionSwitch/WelcomeDialog.tsx:122
msgid "Si prefieres la versión anterior de Reportes, puedes volver desde aquí."
msgstr "Si prefieres la versión anterior de Reportes, puedes volver desde aquí."

#: src/features/controlCenter2/components/versionSwitch/WelcomeDialog.tsx:122
msgid "Si prefieres la versión anterior del Centro de Control, puedes volver desde aquí."
msgstr "Si prefieres la versión anterior del Centro de Control, puedes volver desde aquí."

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/DeleteCurveModal.tsx:34
msgid "Si quieres deshacer esta acción, presiona <0>Restablecer Formulario</0>"
msgstr "Si quieres deshacer esta acción, presiona <0>Restablecer Formulario</0>"

#: src/features/resendCredentialsModal/components/ResendCredentialsModal.tsx:100
msgid "Sí, reenviar"
msgstr "Sí, reenviar"

#: src/features/resendCredentialsModal/components/ResendCredentialsModal.tsx:100
msgid "Sí, reenviar ({countdown}s)"
msgstr "Sí, reenviar ({countdown}s)"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:109
#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:219
msgid "Siempre"
msgstr "Siempre"

#: src/features/alertsConfigurationV3/components/wizard/AlertWizardModal.tsx:360
#: src/features/controlCenter2/components/versionSwitch/WelcomeDialog.tsx:89
#: src/features/reports2/components/createModal/steps/common.tsx:142
#: src/features/reports2/components/versionSwitch/WelcomeDialog.tsx:89
msgid "Siguiente"
msgstr "Siguiente"

#: src/features/deviceSupport/data/fields.ts:20
msgid "SIM Megas"
msgstr "SIM Megas"

#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:256
#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:470
msgid "Símbolo"
msgstr "Símbolo"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:100
msgid "Simple"
msgstr "Simple"

#: src/features/users/components/modals/SimulateUserModal.tsx:79
#: src/features/users/components/modals/SimulateUserShortcutModal.tsx:144
#: src/features/users/components/tableCells/UserActionsCell.tsx:87
msgid "Simular"
msgstr "Simular"

#: src/features/users/components/modals/SimulateUserModal.tsx:100
#: src/features/users/components/modals/SimulateUserShortcutModal.tsx:170
msgid "Simular usuario"
msgstr "Simular usuario"

#: src/features/devicesAccessInputs/components/DevicesFiltersMenu.tsx:93
msgid "Sin acceso"
msgstr "Sin acceso"

#: src/features/metricsViews/components/widgets/quickAccess/index.tsx:150
#: src/fsd/entities/dashboard-widget/ui/quick-access/quick-access-render.tsx:58
msgid "Sin accesos configurados"
msgstr "Sin accesos configurados"

#: src/features/homeAmaru/components/shared/ActivityPanel.tsx:18
msgid "Sin actividad reciente."
msgstr "Sin actividad reciente."

#: src/fsd/app/locale/au-labels.ts:123
msgid "sin agregar"
msgstr "sin agregar"

#: src/fsd/app/locale/au-labels.ts:122
msgid "Sin agregar"
msgstr "Sin agregar"

#: src/features/metricsViews/components/widgets/activeAlerts/index.tsx:133
msgid "Sin alertas activas"
msgstr "Sin alertas activas"

#: src/features/controlCenter/components/window/DeviceListItem.tsx:118
#: src/features/controlCenter2/components/devicesList/ListItem.tsx:167
#: src/features/metricsViews/components/widgets/configuredAlerts/index.tsx:155
msgid "Sin alertas configuradas"
msgstr "Sin alertas configuradas"

#: src/features/alertsConfigurationV3/components/TriggeredAlertsModal.tsx:209
msgid "Sin alertas emitidas recientemente."
msgstr "Sin alertas emitidas recientemente."

#: src/features/homeAmaru/components/shared/AlertsPanel.tsx:22
msgid "Sin alertas recientes."
msgstr "Sin alertas recientes."

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:41
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:53
msgid "Sin asignar"
msgstr "Sin asignar"

#: src/features/users/utils/filterOptions.ts:104
msgid "Sin autenticación en 2 pasos"
msgstr "Sin autenticación en 2 pasos"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:192
msgid "sin cambiar la selección"
msgstr "sin cambiar la selección"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:72
msgid "sin cambios"
msgstr "sin cambios"

#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:173
msgid "Sin cambios"
msgstr "Sin cambios"

#: src/features/metricsViews/utils/getMetricsViewsCollectionFilterOptions.ts:24
msgid "Sin colección"
msgstr "Sin colección"

#: src/components/ColorPicker/ColorPicker.tsx:166
#: src/fsd/entities/dashboard-widget/ui/color-field/color-field.tsx:72
#: src/fsd/entities/dashboard-widget/ui/color-field/color-field.tsx:73
#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:197
msgid "Sin color"
msgstr "Sin color"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:106
msgid "sin comparación"
msgstr "sin comparación"

#: src/features/moveGateModal/components/MoveGateModal.tsx:148
msgid "Sin compuerta seleccionada"
msgstr "Sin compuerta seleccionada"

#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:181
msgid "Sin condiciones configuradas"
msgstr "Sin condiciones configuradas"

#: src/fsd/entities/dashboard-widget/model/chart-sample.ts:126
#: src/fsd/entities/dashboard-widget/model/data-sample.ts:116
#: src/fsd/entities/dashboard-widget/model/table-sample.ts:77
#: src/fsd/entities/dashboard-widget/ui/chart/chart-option.ts:441
msgid "Sin conexión"
msgstr "Sin conexión"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:201
msgid "Sin configuración de hardware"
msgstr "Sin configuración de hardware"

#: src/features/metricsViews/components/widgets/configuredAlerts/index.tsx:69
#: src/fsd/pages/widget-catalog/model/examples.ts:295
#: src/fsd/pages/widget-catalog/model/examples.ts:311
#: src/fsd/pages/widget-catalog/model/examples.ts:321
#: src/fsd/pages/widget-catalog/model/examples.ts:333
#: src/fsd/pages/widget-catalog/model/examples.ts:352
#: src/fsd/pages/widget-catalog/model/examples.ts:365
msgid "Sin configurar"
msgstr "Sin configurar"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:191
msgid "Sin contacto"
msgstr "Sin contacto"

#: src/fsd/entities/dashboard-widget/model/data-sample.ts:115
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:80
#: src/fsd/entities/dashboard-widget/ui/table/table-view.tsx:139
msgid "Sin dato"
msgstr "Sin dato"

#: src/features/homeAmaru/components/shared/CollectionMap.tsx:92
msgid "sin datos"
msgstr "sin datos"

#: src/features/audit/components/AuditLogParagraphDetails.tsx:280
#: src/features/controlCenter/components/window/DeviceListItem.tsx:184
#: src/features/controlCenter2/components/devicesList/ListItem.tsx:239
#: src/features/controlCenter2/utils/alertStates.ts:18
#: src/features/deviceProfile/components/page/Support.tsx:179
#: src/features/deviceProfile/components/page/Support.tsx:184
#: src/features/devices2/components/list/itemPanel/DGAItemChart.tsx:268
#: src/features/devicesAnalysis/components/LastData.tsx:72
#: src/features/gateOperationModal/components/dataComponents/MovementSummaryAttribute.tsx:61
#: src/features/gateOperationModal/components/dataComponents/OperationPositionData.tsx:69
#: src/features/gateOperationModal/components/dataComponents/OperationPositionData.tsx:74
#: src/features/homeAmaru/components/shared/CollectionRow.tsx:73
#: src/features/homeAmaru/components/shared/DgaComplianceSection.tsx:24
#: src/features/integrations/components/monitoredTargetSection/Status.tsx:38
#: src/features/metricsViews/components/widgets/devicesList/List.tsx:137
#: src/features/metricsViews/components/widgets/dgaReports/Chart.legacy.tsx:115
#: src/features/metricsViews/components/widgets/dgaReports/Chart.legacy.tsx:116
#: src/features/metricsViews/components/widgets/dgaReports/Chart.tsx:61
#: src/features/metricsViews/components/widgets/dgaReports/Chart.tsx:62
#: src/features/metricsViews/components/widgets/dgaReports/index.tsx:101
#: src/features/metricsViews/components/widgets/gateOperate/CurrentPosition.tsx:27
#: src/features/metricsViews/components/widgets/trendSummary/index.tsx:135
#: src/features/moveGateModal/components/LastPosition.tsx:43
#: src/fsd/entities/dashboard-widget/model/chart-sample.ts:125
#: src/fsd/entities/dashboard-widget/model/dga-chart-sample.ts:78
#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-view.tsx:94
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:273
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:321
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:78
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:290
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:133
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-view.tsx:191
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:328
#: src/fsd/features/gate-movements/ui/list/movement-row.tsx:50
#: src/fsd/features/gate-movements/ui/operation/operation-summary.tsx:51
#: src/fsd/features/gate-movements/ui/operation/position-box.tsx:30
#: src/fsd/features/gate-movements/ui/operation/position-box.tsx:34
#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:72
#: src/fsd/pages/gate-movements/ui/panel/result/movement-result.tsx:70
#: src/fsd/pages/gate-movements/ui/panel/result/movement-result.tsx:73
msgid "Sin datos"
msgstr "Sin datos"

#: src/features/metricsViews/components/widgets/allocationPerformance/index.tsx:273
msgid "Sin datos de flujo en el periodo {every} y/o acciones de alguno de los dispositivos"
msgstr "Sin datos de flujo en el periodo {every} y/o acciones de alguno de los dispositivos"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-view.tsx:167
msgid "Sin datos en el período: {0}"
msgstr "Sin datos en el período: {0}"

#: src/features/metricsViews/components/widgets/trendSummary/index.tsx:160
msgid "Sin datos en la ventana seleccionada"
msgstr "Sin datos en la ventana seleccionada"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:105
msgid "Sin datos hace más de un día"
msgstr "Sin datos hace más de un día"

#: src/features/metricsViews/components/widgets/configuredAlerts/index.tsx:68
msgid "Sin datos por más de {minutes} min"
msgstr "Sin datos por más de {minutes} min"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:104
msgid "Sin datos registrados"
msgstr "Sin datos registrados"

#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:243
msgid "Sin destinatarios seleccionados"
msgstr "Sin destinatarios seleccionados"

#: src/features/gateCommon/components/historyModal/index.tsx:309
#: src/features/gateOperationModal/components/dataComponents/MovementSummaryAttribute.tsx:47
#: src/fsd/features/gate-movements/ui/history/history-table.tsx:191
msgid "Sin destino"
msgstr "Sin destino"

#: src/features/organizationsManagement/utils/filterOptions.ts:17
msgid "Sin deuda activada"
msgstr "Sin deuda activada"

#: src/features/deviceSupport/data/dga.ts:16
#: src/fsd/entities/dashboard-widget/model/dga-reports-sample.ts:77
msgid "Sin DGA"
msgstr "Sin DGA"

#: src/fsd/entities/dashboard-widget/ui/contact-support/contact-support-editor.tsx:34
msgid "Sin dispositivo"
msgstr "Sin dispositivo"

#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:142
msgid "Sin dispositivo seleccionado"
msgstr "Sin dispositivo seleccionado"

#: src/features/collectionsAccessInputs/components/CollectionsListItem.tsx:119
#: src/features/homeAmaru/components/shared/CollectionRow.tsx:63
msgid "Sin dispositivos"
msgstr "Sin dispositivos"

#: src/features/metricsViews/components/widgets/activeAlerts/index.tsx:131
#: src/features/metricsViews/components/widgets/configuredAlerts/index.tsx:153
msgid "Sin dispositivos configurados"
msgstr "Sin dispositivos configurados"

#: src/features/controlCenter/components/window/DeviceListItem.tsx:182
#: src/features/controlCenter2/components/devicesList/ListItem.tsx:237
#: src/features/controlCenter2/hooks/useLegendsForView.ts:106
msgid "Sin dotación"
msgstr "Sin dotación"

#: src/features/metricsViews/components/AssociateCollectionModal.tsx:204
msgid "Sin ellos no se puede mostrar qué cambia en el tablero. Vuelve a elegir la colección para reintentar."
msgstr "Sin ellos no se puede mostrar qué cambia en el tablero. Vuelve a elegir la colección para reintentar."

#: src/features/alertsNotificationsHistory/utils/dataToTable.ts:22
#: src/fsd/pages/dga-reports/ui/device-row.tsx:158
#: src/utils/i18n/getAlertSuccessOptions.ts:17
msgid "Sin envíos"
msgstr "Sin envíos"

#: src/fsd/entities/dashboard-widget/model/gate-sensors-sample.ts:65
msgid "Sin fecha"
msgstr "Sin fecha"

#: src/fsd/entities/dashboard-widget/model/table-sample.ts:75
msgid "Sin filas"
msgstr "Sin filas"

#: src/features/metricsViews/components/widgets/trendSummary/index.tsx:158
msgid "Sin filas configuradas"
msgstr "Sin filas configuradas"

#: src/fsd/entities/dashboard-widget/ui/image/image-render.tsx:58
#: src/fsd/pages/widget-catalog/model/examples.ts:430
msgid "Sin imagen"
msgstr "Sin imagen"

#: src/features/deviceProfile/components/modal/Info.tsx:74
msgid "Sin imagen de perfil"
msgstr "Sin imagen de perfil"

#: src/features/deviceSupport/components/SupportTableBody.tsx:50
#: src/features/updateMultipleDevicesTags/components/UpdateMultipleDevicesTagsModal.tsx:166
#: src/features/users/components/tableCells/UserLastAccessCell.tsx:14
#: src/features/usersGraveyard/components/UsersGraveyard.tsx:173
#: src/fsd/pages/dga-reports/ui/dga-service-strip.tsx:37
msgid "Sin información"
msgstr "Sin información"

#: src/features/deviceProfile/components/page/Support.tsx:112
msgid "Sin información reciente de batería"
msgstr "Sin información reciente de batería"

#: src/fsd/features/gate-movements/ui/operation/operation-summary.tsx:62
#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:92
msgid "Sin iniciar"
msgstr "Sin iniciar"

#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:157
msgid "Sin métrica seleccionada"
msgstr "Sin métrica seleccionada"

#: src/features/alertsConfigurationV3/components/wizard/steps/MetricStep.tsx:102
msgid "Sin métricas configurables para este dispositivo."
msgstr "Sin métricas configurables para este dispositivo."

#: src/features/gateCommon/components/movementsTable/MovementPosition.tsx:78
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:62
#: src/fsd/features/gate-movements/ui/history/history-table.tsx:65
#: src/fsd/features/gate-movements/ui/list/movement-row.tsx:44
#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:62
msgid "Sin movimiento"
msgstr "Sin movimiento"

#: src/fsd/entities/dashboard-widget/model/gate-movements-sample.ts:83
msgid "Sin movimientos"
msgstr "Sin movimientos"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:264
msgid "Sin nombre"
msgstr "Sin nombre"

#: src/features/alertsNotificationsHistory/utils/dataToTable.ts:25
#: src/utils/i18n/getAlertSuccessOptions.ts:23
msgid "Sin notificaciones configuradas"
msgstr "Sin notificaciones configuradas"

#: src/features/deviceAlertsModal/components/notificationConfigurationTab/TableForm.tsx:220
msgid "Sin número de teléfono"
msgstr "Sin número de teléfono"

#: src/features/standardDesign/components/listView/StandardListViewHeader.tsx:283
msgid "Sin opciones"
msgstr "Sin opciones"

#: src/components/DeviceModalTitle.tsx:107
#: src/components/tooltips/DeviceTooltip.tsx:45
#: src/features/access/components/devicesTab/DevicesListItem.tsx:87
#: src/features/access/components/usersTab/UsersListItem.tsx:111
#: src/features/deviceAccessModal/components/allAccessTab/AllUsersAccessListItem.tsx:98
#: src/features/userConfigurationModal/components/allAccessTab/AllAccessListItem.tsx:87
#: src/features/users/components/tableCells/OrganizationCellDisplay.tsx:29
msgid "Sin organización"
msgstr "Sin organización"

#: src/features/users/components/tableCells/UserSharedOrganizationsCell.tsx:19
msgid "Sin organizaciones adicionales"
msgstr "Sin organizaciones adicionales"

#: src/features/users/utils/filterOptions.ts:94
msgid "Sin organizaciones compartidas"
msgstr "Sin organizaciones compartidas"

#: src/features/reports2/components/ReportTemplatesTable.tsx:301
msgid "Sin período"
msgstr "Sin período"

#: src/fsd/entities/dashboard-widget/model/gate-operate-sample.ts:91
#: src/fsd/pages/gate-movements/ui/panel/events/event-card.tsx:223
msgid "Sin posición"
msgstr "Sin posición"

#: src/features/gateOperationModal/components/panelNotification/NotificationCard.tsx:216
#: src/fsd/features/gate-movements/ui/operation/feed/feed-card.tsx:143
#: src/fsd/features/gate-movements/ui/panel/events/feed-announcer.tsx:83
#: src/fsd/pages/gate-movements/ui/panel/events/event-card.tsx:153
msgid "Sin recorrido"
msgstr "Sin recorrido"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:36
msgid "Sin registrar"
msgstr "Sin registrar"

#: src/features/dgaTicket/components/TicketDisplay.tsx:39
msgid "Sin registros"
msgstr "Sin registros"

#: src/features/metricsViews/components/widgets/gateSensors/RenderSensor.tsx:102
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-view.tsx:58
msgid "Sin registros de fecha"
msgstr "Sin registros de fecha"

#: src/fsd/entities/dashboard-widget/model/dga-reports-sample.ts:76
#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-chart-option.ts:196
#: src/fsd/pages/dga-reports/ui/latest-reports.tsx:115
msgid "Sin reportes"
msgstr "Sin reportes"

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:375
msgid "Sin reportes en el período"
msgstr "Sin reportes en el período"

#: src/features/users/components/modals/SimulateUserShortcutModal.tsx:114
msgid "Sin resultados"
msgstr "Sin resultados"

#: src/fsd/app/locale/au-labels.ts:38
msgid "Sin resultados."
msgstr "Sin resultados."

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:39
msgid "Sin selección."
msgstr "Sin selección."

#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-view.tsx:162
msgid "Sin sensores seleccionados"
msgstr "Sin sensores seleccionados"

#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:96
msgid "Sin tickets"
msgstr "Sin tickets"

#: src/fsd/entities/dashboard-widget/model/dga-tickets-sample.ts:50
#: src/fsd/entities/dashboard-widget/ui/dga-tickets/dga-tickets-view.tsx:102
msgid "Sin tickets abiertos"
msgstr "Sin tickets abiertos"

#: src/features/controlCenter/components/window/DeviceListItem.tsx:100
#: src/features/controlCenter2/components/devicesList/ListItem.tsx:124
#: src/features/deviceProfile/components/modal/Info.tsx:149
msgid "Sin ubicación"
msgstr "Sin ubicación"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-view.tsx:176
msgid "sin unidad"
msgstr "sin unidad"

#: src/features/preferencesCommon/components/UpdateVisibleUnitsForm.tsx:178
msgid "Sin unidades no visibles"
msgstr "Sin unidades no visibles"

#: src/features/preferencesCommon/components/UpdateVisibleUnitsForm.tsx:155
msgid "Sin unidades visibles"
msgstr "Sin unidades visibles"

#: src/features/metricsViews/components/widgets/common/useTrendLabel.ts:107
msgid "sin variación"
msgstr "sin variación"

#: src/fsd/pages/dashboards/ui/canvas/widget-placeholder.tsx:17
msgid "Sin vista previa en este editor"
msgstr "Sin vista previa en este editor"

#: src/fsd/pages/dashboards/ui/keyboard/use-board-keys.ts:123
msgid "Sin widget hacia ese lado."
msgstr "Sin widget hacia ese lado."

#: src/pages/distribution/maipo.tsx:9
msgid "Sistema de Reparto JV Río Maipo 1° sección"
msgstr "Sistema de Reparto JV Río Maipo 1° sección"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:127
msgid "Sistema Reparte Maipo"
msgstr "Sistema Reparte Maipo"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:157
msgid "Sitio"
msgstr "Sitio"

#: src/features/deviceConfigurationModal/components/publicTab/index.tsx:62
msgid "Sitio público"
msgstr "Sitio público"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:96
msgid "Sitio web"
msgstr "Sitio web"

#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:263
msgid "Sitio web (opcional)"
msgstr "Sitio web (opcional)"

#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:100
#: src/features/alertsConfiguration/components/AlertTable.tsx:206
#: src/features/alertsConfiguration/components/DialogConfirmationNotifications.tsx:113
#: src/features/alertsConfiguration/components/DialogUsersNotifications.tsx:116
#: src/features/alertsConfigurationV2/components/AlertsConfigurationV2.tsx:108
#: src/features/alertsConfigurationV3/components/ChannelBadge.tsx:27
#: src/features/alertsConfigurationV3/components/wizard/steps/NotificationsStep.tsx:28
#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:55
#: src/features/alertsNotificationsHistory/utils/notificationTypes.ts:41
#: src/features/deviceAlertsModal/components/notificationConfigurationTab/TableForm.tsx:64
msgid "SMS"
msgstr "SMS"

#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:300
msgid "Sobre"
msgstr "Sobre"

#: src/features/deviceSupport/data/column.ts:61
msgid "SOC mínimo"
msgstr "SOC mínimo"

#: src/features/deviceProfile/components/page/Support.tsx:115
#: src/features/deviceSupport/data/fields.ts:13
msgid "SOC mínimo de batería"
msgstr "SOC mínimo de batería"

#: src/features/gateCommon/components/historyModal/index.tsx:235
#: src/fsd/features/gate-movements/ui/history/history-table.tsx:163
msgid "Solicitada"
msgstr "Solicitada"

#: src/fsd/features/gate-movements/ui/panel/position-chart.tsx:183
msgid "solicitada {0}"
msgstr "solicitada {0}"

#: src/features/gateOperationModal/components/PanelChart.tsx:271
msgid "solicitada {requestedValue}"
msgstr "solicitada {requestedValue}"

#: src/components/optionsMenu/dialogs/movementHistory/Table.tsx:45
#: src/features/gateAdministration/components/MovementHistory.tsx:65
#: src/features/gateCommon/components/historyModal/index.tsx:219
#: src/features/gateOperationModal/components/PanelSummary.tsx:34
#: src/features/metricsViews/components/widgets/movementsTable/index.tsx:117
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:215
#: src/fsd/features/gate-movements/ui/history/history-table.tsx:152
#: src/fsd/features/gate-movements/ui/operation/operation-summary.tsx:47
msgid "Solicitado por"
msgstr "Solicitado por"

#: src/features/audit/utils/getActionTypeOptions.ts:310
msgid "Solicitar reporte de pagos."
msgstr "Solicitar reporte de pagos."

#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:153
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:154
#: src/features/homeAmaru/components/shared/CollectionRow.tsx:93
msgid "Solicitar tablero"
msgstr "Solicitar tablero"

#: src/features/reports/components/creationSection/CreateReportsSection.tsx:16
msgid "Solicitar un nuevo reporte"
msgstr "Solicitar un nuevo reporte"

#: src/features/audit/utils/getDisplayNameActionType.ts:420
msgid "solicitó un reporte de pagos."
msgstr "solicitó un reporte de pagos."

#: src/fsd/pages/gate-movements/ui/panel/movement-summary.tsx:67
msgid "Solicitud"
msgstr "Solicitud"

#: src/features/gateCommon/utils/gateMovementState.tsx:209
msgid "Solicitud <0>en cola</0><1/>a la espera del equipo"
msgstr "Solicitud <0>en cola</0><1/>a la espera del equipo"

#: src/features/gateAdministration/components/DeleteRequestModal.tsx:47
msgid "Solicitud de movimiento eliminada correctamente"
msgstr "Solicitud de movimiento eliminada correctamente"

#: src/pages/reports/create.tsx:8
msgid "Solicitud de Nuevo Reporte"
msgstr "Solicitud de Nuevo Reporte"

#: src/features/gateCommon/utils/gateCloseCode.ts:138
#: src/fsd/entities/gate/model/close-code.ts:123
msgid "Solicitud en cola cancelada"
msgstr "Solicitud en cola cancelada"

#: src/features/gateCommon/utils/gateCloseCode.ts:144
#: src/fsd/entities/gate/model/close-code.ts:129
msgid "Solicitud en cola entregada"
msgstr "Solicitud en cola entregada"

#: src/features/gateCommon/utils/gateCloseCode.ts:141
#: src/fsd/entities/gate/model/close-code.ts:126
msgid "Solicitud en cola vencida"
msgstr "Solicitud en cola vencida"

#: src/features/homeAmaru/components/HomeAmaru.tsx:166
msgid "Solicitud enviada"
msgstr "Solicitud enviada"

#: src/features/moveGateModal/hooks/useMoveGate.ts:62
#: src/fsd/entities/gate/model/command-feedback.ts:100
msgid "Solicitud pendiente: {0}."
msgstr "Solicitud pendiente: {0}."

#: src/features/gateCommon/utils/gateCloseCode.ts:52
#: src/fsd/entities/gate/model/close-code.ts:37
msgid "Solicitud rechazada por vencida"
msgstr "Solicitud rechazada por vencida"

#: src/features/gateCommon/utils/gateCloseCode.ts:58
#: src/fsd/entities/gate/model/close-code.ts:43
msgid "Solicitud rechazada: automatizador en modo manual"
msgstr "Solicitud rechazada: automatizador en modo manual"

#: src/features/gateCommon/utils/gateCloseCode.ts:84
#: src/fsd/entities/gate/model/close-code.ts:69
msgid "Solicitud rechazada: automatizador no configurado"
msgstr "Solicitud rechazada: automatizador no configurado"

#: src/features/gateCommon/utils/gateCloseCode.ts:81
#: src/fsd/entities/gate/model/close-code.ts:66
msgid "Solicitud rechazada: compuerta no reconocida por el equipo"
msgstr "Solicitud rechazada: compuerta no reconocida por el equipo"

#: src/features/gateCommon/utils/gateCloseCode.ts:68
#: src/fsd/entities/gate/model/close-code.ts:53
msgid "Solicitud rechazada: compuerta ocupada"
msgstr "Solicitud rechazada: compuerta ocupada"

#: src/features/gateCommon/utils/gateCloseCode.ts:75
#: src/fsd/entities/gate/model/close-code.ts:60
msgid "Solicitud rechazada: entradas de seguridad ilegibles"
msgstr "Solicitud rechazada: entradas de seguridad ilegibles"

#: src/features/gateCommon/utils/gateCloseCode.ts:65
#: src/fsd/entities/gate/model/close-code.ts:50
msgid "Solicitud rechazada: fin de carrera en el sentido solicitado"
msgstr "Solicitud rechazada: fin de carrera en el sentido solicitado"

#: src/features/gateCommon/utils/gateCloseCode.ts:71
#: src/fsd/entities/gate/model/close-code.ts:56
msgid "Solicitud rechazada: la posición de la compuerta cambió"
msgstr "Solicitud rechazada: la posición de la compuerta cambió"

#: src/features/gateCommon/utils/gateCloseCode.ts:61
#: src/fsd/entities/gate/model/close-code.ts:46
msgid "Solicitud rechazada: parada de emergencia activa"
msgstr "Solicitud rechazada: parada de emergencia activa"

#: src/features/gateCommon/utils/gateCloseCode.ts:78
#: src/fsd/entities/gate/model/close-code.ts:63
msgid "Solicitud rechazada: parámetros inválidos"
msgstr "Solicitud rechazada: parámetros inválidos"

#: src/features/gateCommon/utils/gateCloseCode.ts:87
#: src/fsd/entities/gate/model/close-code.ts:72
msgid "Solicitud rechazada: posición actual desconocida"
msgstr "Solicitud rechazada: posición actual desconocida"

#: src/features/gateCommon/utils/gateCloseCode.ts:55
#: src/fsd/entities/gate/model/close-code.ts:40
msgid "Solicitud rechazada: posición fuera de rango"
msgstr "Solicitud rechazada: posición fuera de rango"

#: src/features/metricsViews/components/MetricsView.tsx:990
#: src/features/metricsViews/components/SaveWidgetModal.tsx:110
msgid "Solo desktop"
msgstr "Solo desktop"

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:195
msgid "Solo disponible para roles administrativos de Capta"
msgstr "Solo disponible para roles administrativos de Capta"

#: src/features/dgaTicket/components/DgaTicketModal.tsx:83
msgid "Solo el número que devuelve la plataforma de la DGA: 4 a 12 dígitos. Si se pega con #, se quita automáticamente."
msgstr "Solo el número que devuelve la plataforma de la DGA: 4 a 12 dígitos. Si se pega con #, se quita automáticamente."

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:219
msgid "Solo escritorio"
msgstr "Solo escritorio"

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-editor.tsx:13
#: src/fsd/pages/widget-catalog/model/examples.ts:278
msgid "Solo estado"
msgstr "Solo estado"

#: src/fsd/pages/widget-catalog/model/examples.ts:385
msgid "Solo ícono"
msgstr "Solo ícono"

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:308
#: src/features/api/components/dialogs/GenerateApiUserDialog.tsx:129
msgid "Solo letras y numeros, sin simbolos ni espacios"
msgstr "Solo letras y numeros, sin simbolos ni espacios"

#: src/features/metricsViews/components/MetricsView.tsx:990
msgid "Solo mobile"
msgstr "Solo mobile"

#: src/features/dgaTicket/validation.ts:46
#: src/fsd/pages/dga-reports/ui/report-problem-dialog.tsx:67
msgid "Solo números, entre 4 y 12 dígitos, sin texto ni fechas"
msgstr "Solo números, entre 4 y 12 dígitos, sin texto ni fechas"

#: src/fsd/entities/dashboard-widget/ui/image/image-editor.tsx:26
msgid "Solo se puede subir una imagen dentro de un tablero."
msgstr "Solo se puede subir una imagen dentro de un tablero."

#: src/features/metricsViews/components/forms/trendDisplayLabels.ts:11
msgid "Solo tendencia"
msgstr "Solo tendencia"

#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-render.tsx:175
msgid "Son datos de ejemplo: no hay compuerta que operar."
msgstr "Son datos de ejemplo: no hay compuerta que operar."

#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-render.tsx:53
msgid "Son datos de ejemplo: no hay movimientos que abrir."
msgstr "Son datos de ejemplo: no hay movimientos que abrir."

#: src/features/deviceSupport/data/column.ts:45
#: src/features/metricsViews/utils/quickAccessCatalog.tsx:107
#: src/fsd/entities/dashboard-widget/ui/quick-access/destinations.ts:91
msgid "Soporte"
msgstr "Soporte"

#: src/features/metricsViews/components/forms/TrendSummaryForm.tsx:161
msgid "Sparkline"
msgstr "Sparkline"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:543
msgid "Start"
msgstr "Start"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:539
msgid "Step"
msgstr "Step"

#: src/features/audit/utils/parseProperty.ts:77
msgid "Strato"
msgstr "Strato"

#: src/fsd/pages/dashboards/ui/layout-warnings/warning-text.ts:38
msgid "Su celda guardada está incompleta; no se muestra."
msgstr "Su celda guardada está incompleta; no se muestra."

#: src/fsd/pages/dashboards/ui/layout-warnings/warning-text.ts:19
msgid "Su celda guardada no es de valores enteros; se muestra redondeada."
msgstr "Su celda guardada no es de valores enteros; se muestra redondeada."

#: src/fsd/pages/dashboards/ui/layout-warnings/warning-text.ts:18
msgid "Su celda guardada se sale de la grilla; se muestra dentro."
msgstr "Su celda guardada se sale de la grilla; se muestra dentro."

#: src/fsd/pages/dashboards/ui/layout-warnings/warning-text.ts:20
msgid "Su celda guardada tiene tamaño cero o negativo; se muestra con una celda."
msgstr "Su celda guardada tiene tamaño cero o negativo; se muestra con una celda."

#: src/features/reportDownload/components/ReportDownload.tsx:54
msgid "Su descarga debería comenzar en breve..."
msgstr "Su descarga debería comenzar en breve..."

#: src/components/ClientHiddenChip.tsx:47
msgid "Su estado operacional ({stateLabel}) no está entre los visibles para clientes."
msgstr "Su estado operacional ({stateLabel}) no está entre los visibles para clientes."

#: src/features/login/components/Login.tsx:62
msgid "Su usuario está desactivado. Comunicate con el administrador de tu organización o contacta a soporte."
msgstr "Su usuario está desactivado. Comunicate con el administrador de tu organización o contacta a soporte."

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:209
msgid "Suavizado"
msgstr "Suavizado"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:443
msgid "Suavizar curva"
msgstr "Suavizar curva"

#: src/features/metricsViews/components/forms/ImageWidgetForm.tsx:70
msgid "Sube una imagen para continuar"
msgstr "Sube una imagen para continuar"

#: src/fsd/entities/dashboard-widget/ui/image/image-editor.tsx:67
msgid "Subiendo imagen…"
msgstr "Subiendo imagen…"

#: src/components/ImageUploadField.tsx:185
msgid "Subiendo imagen… {progress}%"
msgstr "Subiendo imagen… {progress}%"

#: src/features/createDeviceConfiguration/components/common/PDFUploadField.tsx:191
msgid "Subiendo..."
msgstr "Subiendo..."

#: src/fsd/entities/dashboard-widget/ui/device-select/device-multi-select.tsx:73
msgid "Subir {name}"
msgstr "Subir {name}"

#: src/features/metricsViews/components/forms/ImageWidgetForm.tsx:57
#: src/fsd/entities/dashboard-widget/ui/image/image-editor.tsx:52
msgid "Subir imagen"
msgstr "Subir imagen"

#: src/features/collectionCommon/hooks/useCollectionImageUpload.ts:50
#: src/features/metricsViews/hooks/useMetricsViewImageUpload.ts:39
#: src/fsd/entities/dashboard-widget/api/image-upload.ts:53
msgid "Subir imágenes está deshabilitado en ambientes locales — solo lectura"
msgstr "Subir imágenes está deshabilitado en ambientes locales — solo lectura"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:218
msgid "Subir la serie {n}"
msgstr "Subir la serie {n}"

#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:200
#: src/features/dga/components/modals/tabs/GeneralTab.tsx:124
#: src/fsd/entities/dashboard-widget/model/dga-frequency.ts:25
#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:29
#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:46
#: src/utils/i18n/getDgaTranslations.ts:55
msgid "Subterránea"
msgstr "Subterránea"

#: src/features/metricsViews/components/forms/DgaTicketsWidgetForm.tsx:61
#: src/fsd/entities/dashboard-widget/ui/dga-tickets/dga-tickets-editor.tsx:29
msgid "Subtítulo"
msgstr "Subtítulo"

#: src/components/ImageUploadField.tsx:214
msgid "Suelta la imagen aquí"
msgstr "Suelta la imagen aquí"

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:338
msgid "Sugerido para este tipo: {0}–{1} col."
msgstr "Sugerido para este tipo: {0}–{1} col."

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:356
msgid "Sugerido para este tipo: {0}–{1} fil."
msgstr "Sugerido para este tipo: {0}–{1} fil."

#: src/features/moveGateModal/components/MoveGateForm.tsx:218
#: src/fsd/app/locale/au-labels.ts:45
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog.tsx:380
msgid "Sumar"
msgstr "Sumar"

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:242
msgid "Sumergido"
msgstr "Sumergido"

#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:198
#: src/features/dga/components/modals/tabs/GeneralTab.tsx:122
#: src/fsd/entities/dashboard-widget/model/dga-frequency.ts:23
#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:28
#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:45
#: src/utils/i18n/getDgaTranslations.ts:51
msgid "Superficial"
msgstr "Superficial"

#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:199
#: src/features/dga/components/modals/tabs/GeneralTab.tsx:123
#: src/fsd/entities/dashboard-widget/model/dga-frequency.ts:24
#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:30
#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:47
#: src/utils/i18n/getDgaTranslations.ts:53
msgid "Superficial con flujómetro"
msgstr "Superficial con flujómetro"

#: src/features/audit/utils/getActionTypeOptions.ts:214
msgid "Suplantar Usuario"
msgstr "Suplantar Usuario"

#: src/features/audit/utils/getDisplayNameActionType.ts:193
msgid "suplantó al usuario"
msgstr "suplantó al usuario"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:87
msgid "Supr"
msgstr "Supr"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:181
msgid "Tab"
msgstr "Tab"

#: src/features/metricsViews/utils/widgetTypeCatalog.ts:26
#: src/features/organizationDelete/components/DeleteOrganization.tsx:166
#: src/features/usersGraveyard/components/HardDeleteUserModal.tsx:127
#: src/fsd/entities/dashboard-widget/ui/table/table-view.tsx:111
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:26
msgid "Tabla"
msgstr "Tabla"

#: src/features/metricsViews/utils/genericWidgetTypes.ts:73
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:8
msgid "Tabla de alertas"
msgstr "Tabla de alertas"

#: src/features/events/components/EventsTable.tsx:89
msgid "Tabla de eventos"
msgstr "Tabla de eventos"

#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-editor.tsx:53
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:374
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:23
msgid "Tabla de movimientos"
msgstr "Tabla de movimientos"

#: src/features/metricsViews/utils/genericWidgetTypes.ts:76
msgid "Tabla de movimientos de compuerta"
msgstr "Tabla de movimientos de compuerta"

#: src/features/devices2/components/list/DGAItem.tsx:88
msgid "Tabla de reportes"
msgstr "Tabla de reportes"

#: src/features/dga/components/modals/reports/TableModal.tsx:135
#: src/features/dga/components/modals/reports/TableModal.tsx:313
msgid "Tabla de reportes DGA"
msgstr "Tabla de reportes DGA"

#: src/features/devices2/components/list/itemPanel/SMAItemMenu.tsx:89
msgid "Tabla de reportes históricos"
msgstr "Tabla de reportes históricos"

#: src/features/sma/components/TableModal.tsx:168
#: src/features/sma/components/TableModal.tsx:324
msgid "Tabla de reportes SMA"
msgstr "Tabla de reportes SMA"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:63
#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:82
msgid "Tablero"
msgstr "Tablero"

#: src/fsd/pages/dashboards/ui/canvas/canvas.tsx:264
msgid "Tablero {boardName}"
msgstr "Tablero {boardName}"

#: src/fsd/pages/dashboards/ui/canvas/canvas.tsx:263
msgid "Tablero {boardName}, en edición"
msgstr "Tablero {boardName}, en edición"

#: src/fsd/pages/dashboards/ui/change-bar/summarize-diff.ts:22
msgid "tablero configurado"
msgstr "tablero configurado"

#: src/features/collections/components/modals/CreateMetricsViewFromCollectionModal.tsx:91
msgid "Tablero creado correctamente"
msgstr "Tablero creado correctamente"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:25
msgid "Tablero de compuerta"
msgstr "Tablero de compuerta"

#: src/features/metricsViews/components/MetricsView.tsx:388
msgid "Tablero guardado"
msgstr "Tablero guardado"

#: src/fsd/pages/dashboards/ui/announcer/announcement-text.ts:32
msgid "Tablero guardado."
msgstr "Tablero guardado."

#: src/fsd/pages/dashboards/ui/board-header/board-switcher.tsx:157
#: src/fsd/pages/dashboards/ui/dashboard-editor-page.tsx:354
#: src/fsd/pages/dashboards/ui/dashboards-page.tsx:58
msgid "Tablero sin nombre"
msgstr "Tablero sin nombre"

#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:149
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:145
#: src/features/homeAmaru/components/shared/CollectionRow.tsx:89
msgid "Tablero solicitado"
msgstr "Tablero solicitado"

#: src/features/metricsViews/utils/quickAccessCatalog.tsx:101
#: src/fsd/app/locale/language-select.test.tsx:42
#: src/fsd/app/locale/user-locale-provider.test.tsx:39
#: src/fsd/entities/dashboard-widget/ui/quick-access/destinations.ts:85
#: src/fsd/pages/dashboards/ui/dashboards-page.tsx:20
msgid "Tableros"
msgstr "Tableros"

#: src/features/metricsViews/utils/quickAccessCatalog.tsx:102
#: src/fsd/entities/dashboard-widget/ui/quick-access/destinations.ts:86
msgid "Tableros de métricas configurados"
msgstr "Tableros de métricas configurados"

#: src/features/deviceSupport/data/filter.ts:13
msgid "Tags"
msgstr "Tags"

#: src/features/metricsViews/components/forms/ButtonWidgetForm.tsx:76
#: src/features/metricsViews/components/forms/TextWidgetForm.tsx:54
#: src/fsd/entities/dashboard-widget/ui/button/button-editor.tsx:50
#: src/fsd/entities/dashboard-widget/ui/button/button-editor.tsx:52
#: src/fsd/pages/widget-catalog/ui/preview.tsx:125
#: src/fsd/pages/widget-catalog/ui/preview.tsx:127
msgid "Tamaño"
msgstr "Tamaño"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:133
#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:135
msgid "Tamaño de pantalla"
msgstr "Tamaño de pantalla"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:464
msgid "Tamaño de ventana"
msgstr "Tamaño de ventana"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:504
msgid "Tamaño del símbolo"
msgstr "Tamaño del símbolo"

#: src/fsd/pages/dashboards/ui/size-fix-strip/size-fix-strip.tsx:25
msgid "Tamaños para arreglar"
msgstr "Tamaños para arreglar"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:258
msgid "Teclado sobre la grilla"
msgstr "Teclado sobre la grilla"

#: src/features/audit/utils/parseProperty.ts:157
msgid "tecnología"
msgstr "tecnología"

#: src/features/deviceConfiguration/data/sectionFields.ts:106
#: src/features/deviceConfiguration/data/sectionInputs.ts:108
#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:85
msgid "Tecnología"
msgstr "Tecnología"

#: src/features/audit/utils/parseProperty.ts:69
msgid "tecnología de batería"
msgstr "tecnología de batería"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:28
msgid "Tecnología de batería"
msgstr "Tecnología de batería"

#: src/features/audit/utils/parseProperty.ts:119
msgid "teléfono"
msgstr "teléfono"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:149
#: src/features/organizationCreateOrUpdate/components/CreateOrUpdateOrganization.tsx:253
#: src/features/organizationsManagement/components/OrganizationsTable.tsx:99
#: src/features/userProfileUpdate/components/UserProfileUpdateModal.tsx:352
#: src/fsd/pages/dashboards/ui/layout-warnings/warning-text.ts:11
#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:129
#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:139
msgid "Teléfono"
msgstr "Teléfono"

#: src/features/audit/utils/parseProperty.ts:116
msgid "teléfono completo"
msgstr "teléfono completo"

#. Análisis de estaciones - Título de acordión
#: src/features/devicesAnalysis/components/panel/sidebar/index.tsx:54
#: src/features/gateAdministration/components/index.tsx:537
#: src/pages/organization-charts/[name].tsx:13
msgid "Telemetría"
msgstr "Telemetría"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:81
msgid "Temp. nieve"
msgstr "Temp. nieve"

#: src/utils/attributes/metricField.ts:473
msgid "temperatura"
msgstr "temperatura"

#: src/features/alertsConfigurationV2/components/AlertsConfigurationV2.tsx:95
#: src/features/devicesAnalysis/components/panel/Chart.tsx:339
#: src/features/devicesAnalysis/components/panel/Chart.tsx:361
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:182
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:281
#: src/features/reports/utils/metricHelpers.ts:34
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:26
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:71
#: src/utils/attributes/deviceAlertMetricName.ts:42
#: src/utils/i18n/getMetricDisplayName.ts:32
msgid "Temperatura"
msgstr "Temperatura"

#: src/utils/attributes/metricField.ts:479
msgid "temperatura bruta"
msgstr "temperatura bruta"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:339
#: src/features/devicesAnalysis/components/panel/Chart.tsx:361
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:123
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:247
msgid "Temperatura bruta"
msgstr "Temperatura bruta"

#: src/utils/attributes/metricField.ts:383
msgid "temperatura de nieve"
msgstr "temperatura de nieve"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:36
msgid "Temperatura de nieve"
msgstr "Temperatura de nieve"

#: src/features/reports/utils/metricHelpers.ts:32
msgid "Temperatura de Nieve"
msgstr "Temperatura de Nieve"

#: src/utils/attributes/metricField.ts:389
msgid "temperatura de nieve bruta"
msgstr "temperatura de nieve bruta"

#: src/utils/i18n/getMetricDisplayName.ts:39
msgid "Temperatura nieve"
msgstr "Temperatura nieve"

#: src/features/metricsViews/components/createViewModal/CreateViewForm.tsx:124
msgid "Template"
msgstr "Template"

#: src/features/metricsViews/components/forms/TrendSummaryForm.tsx:146
#: src/features/metricsViews/utils/genericWidgetTypes.ts:80
msgid "Tendencia de datos"
msgstr "Tendencia de datos"

#: src/features/metricsViews/utils/quickAccessCatalog.tsx:90
#: src/fsd/entities/dashboard-widget/ui/quick-access/destinations.ts:74
msgid "Tendencias y comparativas"
msgstr "Tendencias y comparativas"

#: src/features/metricsViews/utils/widgetTypeCatalog.ts:29
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:27
msgid "Texto"
msgstr "Texto"

#: src/features/metricsViews/components/forms/ImageWidgetForm.tsx:101
#: src/fsd/entities/dashboard-widget/ui/image/image-editor.tsx:99
msgid "Texto alternativo"
msgstr "Texto alternativo"

#: src/fsd/entities/dashboard-widget/ui/contact-support/contact-support-editor.tsx:48
msgid "Texto plano; cada línea se ve en su renglón. Vacío, usa el título por defecto."
msgstr "Texto plano; cada línea se ve en su renglón. Vacío, usa el título por defecto."

#: src/features/metricsViews/components/forms/AllocationPerformanceWidgetForm.tsx:76
msgid "Texto punto A"
msgstr "Texto punto A"

#: src/fsd/pages/dga-reports/ui/device-list-header.tsx:31
msgid "Ticket"
msgstr "Ticket"

#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:96
#: src/fsd/pages/dga-reports/ui/device-row.tsx:75
msgid "Ticket {0}"
msgstr "Ticket {0}"

#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:125
msgid "Ticket DGA - ID"
msgstr "Ticket DGA - ID"

#: src/features/metricsViews/utils/genericWidgetTypes.ts:67
#: src/fsd/entities/dashboard-widget/ui/type-labels.ts:18
msgid "Tickets DGA"
msgstr "Tickets DGA"

#: src/fsd/entities/dashboard-widget/ui/dga-tickets/dga-tickets-view.tsx:93
msgid "Tickets DGA abiertos"
msgstr "Tickets DGA abiertos"

#: src/features/integrations/utils/writeExecutionLogCodeTranslations.ts:10
msgid "Tiempo de espera agotado en la automatización web"
msgstr "Tiempo de espera agotado en la automatización web"

#: src/features/controlCenter2/components/devicesList/Footer.tsx:138
msgid "Tiempo de espera en segundos entre cada cambio de dispositivo"
msgstr "Tiempo de espera en segundos entre cada cambio de dispositivo"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:96
#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:216
msgid "Tiempo para comenzar a notificar"
msgstr "Tiempo para comenzar a notificar"

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:224
msgid "Tiempo para enviar la primera notificación en caso de falla"
msgstr "Tiempo para enviar la primera notificación en caso de falla"

#: src/features/integrations/components/monitoredTargetSection/index.tsx:19
#: src/features/integrations/components/monitoredTargetSection/index.tsx:37
msgid "Tiempos de respuesta"
msgstr "Tiempos de respuesta"

#: src/features/audit/utils/parseProperty.ts:123
msgid "tiene deuda"
msgstr "tiene deuda"

#: src/fsd/pages/dashboards/ui/layout-warnings/warning-text.ts:23
msgid "Tiene espacio libre arriba; en edición se muestra subido."
msgstr "Tiene espacio libre arriba; en edición se muestra subido."

#: src/fsd/pages/dashboards/ui/layout-warnings/warning-text.ts:15
msgid "Tiene otra celda guardada; se muestra solo la primera."
msgstr "Tiene otra celda guardada; se muestra solo la primera."

#: src/fsd/pages/dashboards/ui/configure-board/configure-board-dialog.tsx:190
msgid "Tiñe el encabezado y el borde del tablero, y lo marca en la lista."
msgstr "Tiñe el encabezado y el borde del tablero, y lo marca en la lista."

#: src/features/audit/utils/parseProperty.ts:21
msgid "tipo"
msgstr "tipo"

#: src/components/DeviceModalTitle.tsx:102
#: src/components/filters/TypeFilter.tsx:19
#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:276
#: src/features/billing/components/modals/ServiceFileManager.tsx:95
#: src/features/collections/components/CollectionsTable.tsx:54
#: src/features/collections/components/modals/CreateCollectionModal.tsx:93
#: src/features/collections/components/modals/UpdateCollectionModal.tsx:119
#: src/features/createDevice/components/form/index.tsx:60
#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:108
#: src/features/deviceCommands/components/calendar/CreateScheduleDialog.tsx:113
#: src/features/deviceCommands/components/DeviceCommandsHistoryTable.tsx:36
#: src/features/deviceConfiguration/data/tableColumns.ts:6
#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:287
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:599
#: src/features/deviceProfile/components/modal/Info.tsx:113
#: src/features/deviceProfile/components/page/General.tsx:42
#: src/features/devices2/components/DevicesHeader.tsx:158
#: src/features/deviceSupport/data/column.ts:37
#: src/features/deviceSupport/data/fields.ts:9
#: src/features/deviceSupport/data/filter.ts:10
#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:176
#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:94
msgid "Tipo"
msgstr "Tipo"

#: src/features/api/components/dialogs/CaptaGenerateApiUserDialog.tsx:170
msgid "Tipo de acceso"
msgstr "Tipo de acceso"

#: src/features/alertsConfiguration/components/AlertTable.tsx:196
#: src/features/alertsConfigurationV2/components/AlertList.tsx:161
#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:159
#: src/features/alertsNotificationsHistory/utils/dataToTable.ts:15
#: src/features/deviceAlertsModal/components/basicConfigurationTab/FormComponent.tsx:54
msgid "Tipo de alerta"
msgstr "Tipo de alerta"

#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:92
#: src/features/alertsConfigurationV2/components/AlertsConfigurationV2.tsx:100
#: src/features/alertsConfigurationV3/components/FilterBar.tsx:94
msgid "Tipo de Alerta"
msgstr "Tipo de Alerta"

#: src/components/ImageUploadField.tsx:60
msgid "Tipo de archivo no permitido"
msgstr "Tipo de archivo no permitido"

#: src/features/audit/utils/parseProperty.ts:149
msgid "tipo de conexión de datos"
msgstr "tipo de conexión de datos"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:56
msgid "Tipo de conexión de datos"
msgstr "Tipo de conexión de datos"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:207
msgid "Tipo de curva"
msgstr "Tipo de curva"

#: src/features/metricsViews/components/forms/AllocationPerformanceWidgetForm.tsx:180
#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:326
#: src/features/metricsViews/components/forms/DataWidgetForm.tsx:117
#: src/features/metricsViews/components/forms/TableWidgetForm.tsx:181
msgid "Tipo de dato"
msgstr "Tipo de dato"

#: src/features/deviceConfiguration/components/DeviceConfiguration.tsx:300
#: src/features/preferencesCommon/components/UpdatePreferredUnitsForm.tsx:301
msgid "Tipo de dispositivo"
msgstr "Tipo de dispositivo"

#: src/features/audit/utils/parseProperty.ts:156
msgid "tipo de energía"
msgstr "tipo de energía"

#: src/features/deviceSupport/data/column.ts:85
#: src/features/deviceSupport/data/fields.ts:19
msgid "Tipo de energización"
msgstr "Tipo de energización"

#: src/features/notifications/components/NotificationsSaveModal.tsx:95
msgid "Tipo de entidad no soportado"
msgstr "Tipo de entidad no soportado"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:36
#: src/features/dga/components/modals/CreateDGAConfigurationModal.tsx:206
#: src/features/dga/components/modals/tabs/GeneralTab.tsx:130
msgid "Tipo de extracción"
msgstr "Tipo de extracción"

#: src/features/audit/utils/parseProperty.ts:10
msgid "tipo de extracción DGA"
msgstr "tipo de extracción DGA"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/SaveCurveModal.tsx:203
msgid "Tipo de fórmula"
msgstr "Tipo de fórmula"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:180
msgid "Tipo de la serie {n}"
msgstr "Tipo de la serie {n}"

#: src/features/metricsViews/components/widgets/dgaReports/Info.legacy.tsx:49
#: src/features/metricsViews/components/widgets/dgaReports/Info.tsx:97
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:331
#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:58
msgid "Tipo de medición"
msgstr "Tipo de medición"

#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-view.tsx:387
msgid "Tipo de medición y frecuencia"
msgstr "Tipo de medición y frecuencia"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:414
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:418
msgid "Tipo de mensaje"
msgstr "Tipo de mensaje"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:89
msgid "Tipo de Moneda"
msgstr "Tipo de Moneda"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:213
msgid "Tipo de moneda en la que se realiza el pago. Los valores aceptados son CLP, USD, UF, BTC."
msgstr "Tipo de moneda en la que se realiza el pago. Los valores aceptados son CLP, USD, UF, BTC."

#: src/features/audit/utils/parseProperty.ts:85
msgid "tipo de plan de datos"
msgstr "tipo de plan de datos"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:60
msgid "Tipo de plan de datos"
msgstr "Tipo de plan de datos"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:358
#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:362
msgid "Tipo de serie"
msgstr "Tipo de serie"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:95
#: src/features/billing/components/table/ServicesTable.tsx:61
msgid "Tipo de Servicio"
msgstr "Tipo de Servicio"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:217
msgid "Tipo de servicio proporcionado. Los valores aceptados incluyen DGA, RENTAL, INTEGRATION, entre otros."
msgstr "Tipo de servicio proporcionado. Los valores aceptados incluyen DGA, RENTAL, INTEGRATION, entre otros."

#: src/features/audit/utils/parseProperty.ts:18
msgid "tipo de usuario"
msgstr "tipo de usuario"

#: src/features/metricsViews/components/SaveWidgetModal.tsx:171
#: src/fsd/pages/widget-catalog/ui/type-list.tsx:28
msgid "Tipo de widget"
msgstr "Tipo de widget"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:105
msgid "Tipo energía"
msgstr "Tipo energía"

#: src/features/audit/utils/parseProperty.ts:94
msgid "tipo satelital"
msgstr "tipo satelital"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:68
#: src/features/deviceConfiguration/data/sectionFields.ts:410
msgid "Tipo satelital"
msgstr "Tipo satelital"

#: src/features/deviceConfiguration/data/sectionInputs.ts:442
msgid "Tipo Satelital"
msgstr "Tipo Satelital"

#: src/components/DeviceModalTitle.tsx:149
msgid "Tipo:"
msgstr "Tipo:"

#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:95
msgid "Tipo: {0}"
msgstr "Tipo: {0}"

#: src/features/collections/components/CollectionsTableFilters.tsx:79
#: src/fsd/pages/widget-catalog/ui/widget-catalog-page.tsx:66
msgid "Tipos"
msgstr "Tipos"

#: src/features/alertsNotificationsHistory/components/Filters.tsx:198
#: src/features/alertsNotificationsHistory/components/Filters.tsx:350
msgid "Tipos de alerta"
msgstr "Tipos de alerta"

#: src/features/alertsNotificationsHistory/components/Filters.tsx:210
#: src/features/alertsNotificationsHistory/components/Filters.tsx:374
msgid "Tipos de notificación"
msgstr "Tipos de notificación"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:260
msgid "título"
msgstr "título"

#: src/features/announcements/components/AnnouncementsSaveModal.tsx:230
#: src/features/metricsViews/components/forms/AlertsTableForm.tsx:21
#: src/features/metricsViews/components/forms/AllocationPerformanceWidgetForm.tsx:64
#: src/features/metricsViews/components/forms/ButtonWidgetForm.tsx:145
#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:84
#: src/features/metricsViews/components/forms/ContactSupportWidgetForm.tsx:44
#: src/features/metricsViews/components/forms/DataWidgetForm.tsx:69
#: src/features/metricsViews/components/forms/DevicesListWidgetForm.tsx:23
#: src/features/metricsViews/components/forms/DgaReportsChartWidgetForm.tsx:59
#: src/features/metricsViews/components/forms/DgaReportsWidgetForm.tsx:83
#: src/features/metricsViews/components/forms/DgaTicketsWidgetForm.tsx:49
#: src/features/metricsViews/components/forms/GateOperateWidgetForm.tsx:50
#: src/features/metricsViews/components/forms/GateSensorWidgetForm.tsx:68
#: src/features/metricsViews/components/forms/MovementsTableForm.tsx:60
#: src/features/metricsViews/components/forms/TableWidgetForm.tsx:48
#: src/features/metricsViews/components/forms/TrendSummaryForm.tsx:145
#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:91
#: src/fsd/entities/dashboard-widget/ui/contact-support/contact-support-editor.tsx:46
#: src/fsd/entities/dashboard-widget/ui/data/data-editor.tsx:45
#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-reports-chart-editor.tsx:43
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-editor.tsx:54
#: src/fsd/entities/dashboard-widget/ui/dga-tickets/dga-tickets-editor.tsx:22
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-editor.tsx:43
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-editor.tsx:64
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-editor.tsx:44
#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:52
#: src/fsd/entities/dashboard-widget/ui/text/text-editor.tsx:20
#: src/fsd/pages/widget-catalog/model/examples.ts:372
msgid "Título"
msgstr "Título"

#: src/features/metricsViews/components/forms/ActiveAlertsForm.tsx:38
msgid "Título (opcional)"
msgstr "Título (opcional)"

#: src/fsd/entities/dashboard-widget/ui/button/button-editor.tsx:70
msgid "Título del tooltip"
msgstr "Título del tooltip"

#: src/fsd/pages/widget-catalog/model/examples.ts:436
msgid "Título guardado en varias líneas"
msgstr "Título guardado en varias líneas"

#: src/fsd/pages/widget-catalog/model/examples.ts:443
msgid "Título largo (se trunca)"
msgstr "Título largo (se trunca)"

#: src/fsd/pages/widget-catalog/model/examples.ts:434
msgid "Título por defecto"
msgstr "Título por defecto"

#: src/fsd/pages/widget-catalog/model/examples.ts:435
msgid "Título propio"
msgstr "Título propio"

#: src/features/deviceCommands/components/calendar/StandardCommandsSelector.tsx:68
msgid "Tnano Invierno"
msgstr "Tnano Invierno"

#: src/features/deviceCommands/components/calendar/StandardCommandsSelector.tsx:67
msgid "Tnano Verano"
msgstr "Tnano Verano"

#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:37
msgid "Todas"
msgstr "Todas"

#: src/features/alertsConfigurationV3/components/TriggeredAlertsModal.tsx:194
msgid "Todas las alertas"
msgstr "Todas las alertas"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:338
msgid "Todas las curvas activadas"
msgstr "Todas las curvas activadas"

#: src/features/integrations/components/integrationsStatus/index.tsx:35
msgid "Todas las integraciones en línea"
msgstr "Todas las integraciones en línea"

#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:26
msgid "Todas las redes"
msgstr "Todas las redes"

#: src/fsd/pages/widget-catalog/ui/type-list.tsx:51
msgid "Todavía no está en el catálogo"
msgstr "Todavía no está en el catálogo"

#: src/fsd/pages/dashboards/ui/dashboards-page.tsx:50
msgid "Todavía no hay tableros"
msgstr "Todavía no hay tableros"

#: src/features/reports2/components/ReportTemplatesTable.tsx:122
msgid "Todavía no tienes reportes recurrentes configurados."
msgstr "Todavía no tienes reportes recurrentes configurados."

#: src/fsd/pages/dga-reports/ui/device-row.tsx:156
msgid "Todo validado"
msgstr "Todo validado"

#: src/components/filters/NamingFilter.tsx:30
#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:86
#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:98
#: src/features/alertsConfigurationV2/components/AlertsConfigurationV2.tsx:90
#: src/features/alertsConfigurationV2/components/AlertsConfigurationV2.tsx:106
#: src/features/billing/utils/list.ts:30
#: src/features/deviceProfile/components/page/Audit.tsx:60
#: src/features/devicesAccessInputs/components/DevicesAccessForUserInput.tsx:134
#: src/features/devicesAccessInputs/components/DevicesFiltersMenu.tsx:83
#: src/features/devicesAccessInputs/components/UsersAccessForDeviceInput.tsx:177
#: src/features/deviceSupport/data/dga.ts:8
#: src/features/deviceSupport/data/status.ts:9
#: src/features/integrations/components/devicesList/index.tsx:121
#: src/features/reports2/components/createModal/steps/step1/MetricsInput.tsx:257
#: src/features/reports2/components/createModal/steps/step1/MultipleCheckbox.tsx:92
#: src/features/updateMultipleDevicesTags/components/UpdateMultipleDevicesTagsModal.tsx:163
#: src/fsd/pages/dga-reports/ui/filter-bar.tsx:44
msgid "Todos"
msgstr "Todos"

#: src/fsd/entities/dashboard-widget/model/gate-sensors-sample.ts:64
msgid "Todos activos"
msgstr "Todos activos"

#: src/fsd/entities/dashboard-widget/model/gate-sensors-sample.ts:62
msgid "Todos en reposo"
msgstr "Todos en reposo"

#: src/features/deviceAccessModal/components/index.tsx:97
#: src/features/userConfigurationModal/components/index.tsx:96
msgid "Todos los accesos"
msgstr "Todos los accesos"

#: src/features/userConfigurationModal/components/allAccessTab/index.tsx:82
msgid "Todos los dispositivos a los que tiene acceso el usuario"
msgstr "Todos los dispositivos a los que tiene acceso el usuario"

#: src/features/metricsViews/components/forms/ActiveAlertsForm.tsx:52
#: src/features/metricsViews/components/forms/ConfiguredAlertsForm.tsx:38
msgid "Todos los dispositivos del tablero"
msgstr "Todos los dispositivos del tablero"

#: src/features/devicesAccessInputs/components/DevicesFiltersMenu.tsx:99
msgid "Todos los roles"
msgstr "Todos los roles"

#: src/features/deviceAccessModal/components/allAccessTab/index.tsx:63
msgid "Todos los usuarios con acceso al dispositivo"
msgstr "Todos los usuarios con acceso al dispositivo"

#: src/features/metricsViews/components/forms/ButtonWidgetForm.tsx:137
#: src/fsd/entities/dashboard-widget/ui/button/button-editor.tsx:64
msgid "Tooltip"
msgstr "Tooltip"

#: src/features/createMyCollectionModal/hooks/useCreateMyCollectionForm.tsx:52
#: src/features/homeAmaru/hooks/useNewCollectionEligibility.ts:24
msgid "Tope de colecciones, contactarse a soporte para ampliar"
msgstr "Tope de colecciones, contactarse a soporte para ampliar"

#: src/features/alertsNotificationsHistory/components/histogram/HistogramTooltip.tsx:62
#: src/features/alertsNotificationsHistory/components/histogram/HistogramTooltip.tsx:86
#: src/features/billing/components/payments/PaymentRow.tsx:104
#: src/features/billing/components/payments/PaymentSummary.tsx:118
msgid "Total"
msgstr "Total"

#: src/features/billing/components/payments/PaymentsTable.tsx:48
#: src/features/billing/components/payments/PaymentSummary.tsx:123
msgid "Total con descuento"
msgstr "Total con descuento"

#: src/features/billing/components/payments/PaymentsTable.tsx:45
msgid "Total de servicios"
msgstr "Total de servicios"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:219
msgid "Total del servicio antes de aplicar el descuento, en la moneda indicada."
msgstr "Total del servicio antes de aplicar el descuento, en la moneda indicada."

#: src/features/billing/components/payments/PaymentsTable.tsx:44
#: src/features/billing/components/payments/PaymentSummary.tsx:128
msgid "Total descuento de servicios"
msgstr "Total descuento de servicios"

#: src/features/billing/components/payments/PaymentDetailsForm.tsx:105
#: src/features/billing/components/payments/PaymentRow.tsx:101
msgid "Total estimado"
msgstr "Total estimado"

#: src/features/billing/components/table/DevicesTable.tsx:153
#: src/features/billing/components/table/ProjectsTable.tsx:76
msgid "Total Servicios"
msgstr "Total Servicios"

#: src/features/billing/components/payments/PaymentsTable.tsx:43
msgid "Total sin descuento"
msgstr "Total sin descuento"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:71
#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:124
msgid "Totalizador caudalímetro"
msgstr "Totalizador caudalímetro"

#: src/fsd/pages/dashboards/ui/panel/assist-mode.tsx:29
msgid "Tramo de canal"
msgstr "Tramo de canal"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:487
msgid "Triángulo"
msgstr "Triángulo"

#: src/features/billing/utils/translations.ts:11
#: src/features/billing/utils/translations.ts:25
msgid "Trimestral"
msgstr "Trimestral"

#: src/features/homeAmaru/components/shared/WorkspaceHeader.tsx:54
msgid "Tu acceso central a tus secciones y herramientas para gestionar tu operación."
msgstr "Tu acceso central a tus secciones y herramientas para gestionar tu operación."

#: src/features/reports2/components/versionSwitch/FormPopup.tsx:69
msgid "Tu feedback ayuda a mejorar AMARU."
msgstr "Tu feedback ayuda a mejorar AMARU."

#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:345
msgid "Tuberías (flujómetro)"
msgstr "Tuberías (flujómetro)"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:76
msgid "Turb. FNU"
msgstr "Turb. FNU"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:75
msgid "Turb. NTU"
msgstr "Turb. NTU"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:258
#: src/utils/i18n/getMetricDisplayName.ts:30
msgid "Turbidez (FNU)"
msgstr "Turbidez (FNU)"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:248
#: src/utils/i18n/getMetricDisplayName.ts:31
msgid "Turbidez (NTU)"
msgstr "Turbidez (NTU)"

#: src/utils/attributes/metricField.ts:485
msgid "turbidez fnu"
msgstr "turbidez fnu"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:350
#: src/features/reports/utils/metricHelpers.ts:35
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:31
msgid "Turbidez FNU"
msgstr "Turbidez FNU"

#: src/utils/attributes/metricField.ts:491
msgid "turbidez fnu bruta"
msgstr "turbidez fnu bruta"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:350
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:208
msgid "Turbidez FNU bruta"
msgstr "Turbidez FNU bruta"

#: src/utils/attributes/metricField.ts:497
msgid "turbidez ntu"
msgstr "turbidez ntu"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:349
#: src/features/reports/utils/metricHelpers.ts:36
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:30
msgid "Turbidez NTU"
msgstr "Turbidez NTU"

#: src/utils/attributes/metricField.ts:503
msgid "turbidez ntu bruta"
msgstr "turbidez ntu bruta"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:349
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:195
msgid "Turbidez NTU bruta"
msgstr "Turbidez NTU bruta"

#: src/utils/attributes/deviceAlertMetricName.ts:82
msgid "Turbiedad"
msgstr "Turbiedad"

#: src/utils/attributes/deviceAlertMetricName.ts:77
msgid "Turbiedad fnu"
msgstr "Turbiedad fnu"

#: src/features/alertsConfigurationV2/components/AlertsConfigurationV2.tsx:96
msgid "Turbiedad NTU"
msgstr "Turbiedad NTU"

#: src/features/deviceConfigurationModal/components/generalTab/GeneralTab.tsx:348
#: src/features/deviceProfile/components/modal/Info.tsx:135
#: src/features/deviceProfile/components/page/General.tsx:79
msgid "Ubicación"
msgstr "Ubicación"

#: src/fsd/pages/dashboards/ui/panel/widget-scope.tsx:167
msgid "Ubicación y tamaño"
msgstr "Ubicación y tamaño"

#: src/fsd/app/locale/au-labels.ts:130
msgid "Última {unit}"
msgstr "Última {unit}"

#: src/utils/attributes/metricField.ts:234
msgid "última alerta de caudal"
msgstr "última alerta de caudal"

#: src/utils/attributes/metricField.ts:186
msgid "última alerta de distribución"
msgstr "última alerta de distribución"

#: src/utils/attributes/metricField.ts:264
msgid "última alerta de nivel"
msgstr "última alerta de nivel"

#: src/utils/attributes/metricField.ts:342
msgid "última calidad de señal"
msgstr "última calidad de señal"

#: src/utils/attributes/metricField.ts:126
msgid "última conductividad"
msgstr "última conductividad"

#: src/utils/attributes/metricField.ts:132
msgid "última conductividad bruta"
msgstr "última conductividad bruta"

#: src/features/deviceProfile/components/page/Support.tsx:174
msgid "Última conexión"
msgstr "Última conexión"

#: src/utils/attributes/metricField.ts:102
msgid "última corriente de carga"
msgstr "última corriente de carga"

#: src/utils/attributes/metricField.ts:108
msgid "última corriente de carga bruta"
msgstr "última corriente de carga bruta"

#: src/utils/attributes/metricField.ts:246
msgid "última corriente del sensor de compuerta"
msgstr "última corriente del sensor de compuerta"

#: src/utils/attributes/metricField.ts:432
msgid "última corriente solar"
msgstr "última corriente solar"

#: src/utils/attributes/metricField.ts:438
msgid "última corriente solar bruta"
msgstr "última corriente solar bruta"

#: src/utils/attributes/metricField.ts:204
msgid "última curva de aforo habilitada"
msgstr "última curva de aforo habilitada"

#: src/utils/attributes/metricField.ts:252
msgid "última distancia al sensor de compuerta"
msgstr "última distancia al sensor de compuerta"

#: src/utils/attributes/metricField.ts:276
msgid "última distancia original"
msgstr "última distancia original"

#: src/utils/attributes/metricField.ts:282
msgid "última distancia original bruta"
msgstr "última distancia original bruta"

#: src/utils/attributes/metricField.ts:36
msgid "última dotación"
msgstr "última dotación"

#: src/utils/attributes/metricField.ts:210
msgid "última energía"
msgstr "última energía"

#: src/features/devices2/components/list/itemPanel/DeviceItemPicture.tsx:83
msgid "Última foto de {name}"
msgstr "Última foto de {name}"

#: src/constants/dateTimeRangePicker.constants.ts:6
#: src/features/gateAdministration/components/index.tsx:62
msgid "Última hora"
msgstr "Última hora"

#: src/utils/attributes/metricField.ts:348
msgid "última intensidad de señal"
msgstr "última intensidad de señal"

#: src/features/metricsViews/components/widgets/activeAlerts/AlertCard.tsx:120
msgid "Última lectura"
msgstr "Última lectura"

#. El placeholder es tiempo relativo, e.g. 'hace 1 hora', 'hace 3 días'
#. El placeholder es tiempo relativo, e.g. 'hace 1 hora', 'hace 3 días'
#: src/features/gates/components/list/GateListItemMetrics.tsx:61
#: src/features/gates/components/list/GateListItemMetrics.tsx:125
msgid "Última medición <0/>"
msgstr "Última medición <0/>"

#: src/fsd/app/locale/au-labels.ts:68
msgid "Última página"
msgstr "Última página"

#: src/utils/attributes/metricField.ts:324
msgid "última posición"
msgstr "última posición"

#: src/features/metricsViews/components/widgets/gateOperate/index.tsx:72
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:311
msgid "Última posición"
msgstr "Última posición"

#: src/utils/attributes/metricField.ts:114
msgid "última potencia de carga"
msgstr "última potencia de carga"

#: src/utils/attributes/metricField.ts:120
msgid "última potencia de carga bruta"
msgstr "última potencia de carga bruta"

#: src/utils/attributes/metricField.ts:444
msgid "última potencia solar"
msgstr "última potencia solar"

#: src/utils/attributes/metricField.ts:450
msgid "última potencia solar bruta"
msgstr "última potencia solar bruta"

#: src/utils/attributes/metricField.ts:372
msgid "última radiación de nieve"
msgstr "última radiación de nieve"

#: src/utils/attributes/metricField.ts:378
msgid "última radiación de nieve bruta"
msgstr "última radiación de nieve bruta"

#: src/utils/attributes/metricField.ts:336
msgid "última relación señal-ruido"
msgstr "última relación señal-ruido"

#: src/utils/attributes/metricField.ts:174
msgid "última saturación de oxígeno disuelto"
msgstr "última saturación de oxígeno disuelto"

#: src/utils/attributes/metricField.ts:180
msgid "última saturación de oxígeno disuelto bruta"
msgstr "última saturación de oxígeno disuelto bruta"

#: src/utils/attributes/metricField.ts:474
msgid "última temperatura"
msgstr "última temperatura"

#: src/utils/attributes/metricField.ts:480
msgid "última temperatura bruta"
msgstr "última temperatura bruta"

#: src/utils/attributes/metricField.ts:384
msgid "última temperatura de nieve"
msgstr "última temperatura de nieve"

#: src/utils/attributes/metricField.ts:390
msgid "última temperatura de nieve bruta"
msgstr "última temperatura de nieve bruta"

#: src/utils/attributes/metricField.ts:486
msgid "última turbidez fnu"
msgstr "última turbidez fnu"

#: src/utils/attributes/metricField.ts:492
msgid "última turbidez fnu bruta"
msgstr "última turbidez fnu bruta"

#: src/utils/attributes/metricField.ts:498
msgid "última turbidez ntu"
msgstr "última turbidez ntu"

#: src/utils/attributes/metricField.ts:504
msgid "última turbidez ntu bruta"
msgstr "última turbidez ntu bruta"

#: src/utils/attributes/metricField.ts:510
msgid "última velocidad"
msgstr "última velocidad"

#: src/utils/attributes/metricField.ts:516
msgid "última velocidad bruta"
msgstr "última velocidad bruta"

#: src/utils/attributes/metricField.ts:192
msgid "última velocidad doppler"
msgstr "última velocidad doppler"

#: src/utils/attributes/metricField.ts:198
msgid "última velocidad doppler bruta"
msgstr "última velocidad doppler bruta"

#: src/fsd/app/locale/au-labels.ts:132
msgid "Últimas {text}"
msgstr "Últimas {text}"

#: src/constants/dateTimeRangePicker.constants.ts:9
#: src/features/gateAdministration/components/index.tsx:72
msgid "Últimas 12 horas"
msgstr "Últimas 12 horas"

#: src/features/alertsConfigurationV3/components/TriggeredAlertsSummary.tsx:9
msgid "Últimas 24 h"
msgstr "Últimas 24 h"

#: src/features/gateAdministration/components/index.tsx:77
msgid "Últimas 24 horas"
msgstr "Últimas 24 horas"

#: src/constants/dateTimeRangePicker.constants.ts:7
msgid "Últimas 4 horas"
msgstr "Últimas 4 horas"

#: src/features/gateAdministration/components/index.tsx:67
msgid "Últimas 6 horas"
msgstr "Últimas 6 horas"

#: src/constants/dateTimeRangePicker.constants.ts:8
msgid "Últimas 8 horas"
msgstr "Últimas 8 horas"

#: src/features/homeAmaru/components/shared/AlertsPanel.tsx:18
msgid "ÚLTIMAS ALERTAS"
msgstr "ÚLTIMAS ALERTAS"

#: src/features/deviceProfile/components/page/Alerts.tsx:115
msgid "Últimas alertas de {0} gatilladas"
msgstr "Últimas alertas de {0} gatilladas"

#: src/fsd/app/locale/au-labels.ts:130
msgid "Último {unit}"
msgstr "Último {unit}"

#: src/features/userActivityLogs/components/UserActivityLogsModal.tsx:59
#: src/features/users/components/UsersTable.tsx:79
#: src/features/users/utils/filterOptions.ts:122
#: src/features/users/utils/filterOptions.ts:127
#: src/features/users/utils/filterOptions.ts:132
msgid "Último acceso"
msgstr "Último acceso"

#: src/features/users/utils/filterOptions.ts:64
msgid "Último acceso (Asc)"
msgstr "Último acceso (Asc)"

#: src/features/users/utils/filterOptions.ts:71
msgid "Último acceso (Desc)"
msgstr "Último acceso (Desc)"

#: src/utils/attributes/metricField.ts:42
msgid "último ángulo"
msgstr "último ángulo"

#: src/utils/attributes/metricField.ts:84
msgid "último ángulo calculado"
msgstr "último ángulo calculado"

#: src/utils/attributes/metricField.ts:48
msgid "último ángulo no calibrado"
msgstr "último ángulo no calibrado"

#: src/utils/attributes/metricField.ts:54
msgid "último ángulo no calibrado bruto"
msgstr "último ángulo no calibrado bruto"

#: src/utils/attributes/metricField.ts:228
msgid "último caudal"
msgstr "último caudal"

#: src/utils/attributes/metricField.ts:240
msgid "último caudal bruto"
msgstr "último caudal bruto"

#: src/utils/attributes/metricField.ts:150
msgid "último caudal dga"
msgstr "último caudal dga"

#. Análisis de estaciones - texto en widget de último dato
#: src/features/devicesAnalysis/components/LastData.tsx:58
#: src/features/deviceSupport/data/column.ts:124
#: src/features/deviceSupport/data/fields.ts:16
#: src/features/gateAdministration/components/index.tsx:428
#: src/features/metricsViews/components/forms/trendDisplayLabels.ts:10
msgid "Último dato"
msgstr "Último dato"

#: src/features/metricsViews/components/forms/trendDisplayLabels.ts:13
msgid "Último dato + tendencia (apilados)"
msgstr "Último dato + tendencia (apilados)"

#: src/features/metricsViews/components/forms/trendDisplayLabels.ts:12
msgid "Último dato + tendencia (lado a lado)"
msgstr "Último dato + tendencia (lado a lado)"

#: src/constants/dateTimeRangePicker.constants.ts:10
msgid "Último día"
msgstr "Último día"

#: src/utils/attributes/metricField.ts:396
msgid "último equivalente de agua de nieve"
msgstr "último equivalente de agua de nieve"

#: src/utils/attributes/metricField.ts:414
msgid "último equivalente de agua de nieve bruto"
msgstr "último equivalente de agua de nieve bruto"

#: src/utils/attributes/metricField.ts:402
msgid "último equivalente de agua de nieve no calibrado"
msgstr "último equivalente de agua de nieve no calibrado"

#: src/utils/attributes/metricField.ts:408
msgid "último equivalente de agua de nieve no calibrado bruto"
msgstr "último equivalente de agua de nieve no calibrado bruto"

#: src/utils/attributes/metricField.ts:60
msgid "último estado de carga de batería"
msgstr "último estado de carga de batería"

#: src/utils/attributes/metricField.ts:66
msgid "último estado de carga de batería bruto"
msgstr "último estado de carga de batería bruto"

#: src/utils/attributes/metricField.ts:138
msgid "último estado de conexión"
msgstr "último estado de conexión"

#: src/utils/attributes/metricField.ts:216
msgid "último evento"
msgstr "último evento"

#: src/utils/attributes/metricField.ts:222
msgid "último intruso"
msgstr "último intruso"

#: src/utils/attributes/metricField.ts:330
msgid "último límite de curva de aforo"
msgstr "último límite de curva de aforo"

#: src/features/alertsConfigurationV3/components/TriggeredAlertsSummary.tsx:11
msgid "Último mes"
msgstr "Último mes"

#: src/features/gates/components/list/GateListItemLastMovement.tsx:42
msgid "Último movimiento"
msgstr "Último movimiento"

#: src/utils/attributes/metricField.ts:258
msgid "último nivel"
msgstr "último nivel"

#: src/utils/attributes/metricField.ts:270
msgid "último nivel bruto"
msgstr "último nivel bruto"

#: src/utils/attributes/metricField.ts:354
msgid "último nivel de nieve"
msgstr "último nivel de nieve"

#: src/utils/attributes/metricField.ts:366
msgid "último nivel de nieve bruto"
msgstr "último nivel de nieve bruto"

#: src/utils/attributes/metricField.ts:360
msgid "último nivel de nieve no calibrado"
msgstr "último nivel de nieve no calibrado"

#: src/utils/attributes/metricField.ts:156
msgid "último nivel dga"
msgstr "último nivel dga"

#: src/utils/attributes/metricField.ts:300
msgid "último orp"
msgstr "último orp"

#: src/utils/attributes/metricField.ts:306
msgid "último orp bruto"
msgstr "último orp bruto"

#: src/utils/attributes/metricField.ts:162
msgid "último oxígeno disuelto"
msgstr "último oxígeno disuelto"

#: src/utils/attributes/metricField.ts:168
msgid "último oxígeno disuelto bruto"
msgstr "último oxígeno disuelto bruto"

#: src/utils/attributes/metricField.ts:420
msgid "último peso de nieve"
msgstr "último peso de nieve"

#: src/utils/attributes/metricField.ts:426
msgid "último peso de nieve bruto"
msgstr "último peso de nieve bruto"

#: src/utils/attributes/metricField.ts:312
msgid "último ph"
msgstr "último ph"

#: src/utils/attributes/metricField.ts:318
msgid "último ph bruto"
msgstr "último ph bruto"

#: src/features/integrations/components/groupedIssuesModal/GroupedLogsTable.tsx:55
msgid "Último registro"
msgstr "Último registro"

#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:95
msgid "Último ticket"
msgstr "Último ticket"

#: src/utils/attributes/metricField.ts:72
msgid "último voltaje de batería"
msgstr "último voltaje de batería"

#: src/utils/attributes/metricField.ts:78
msgid "último voltaje de batería bruto"
msgstr "último voltaje de batería bruto"

#: src/utils/attributes/metricField.ts:456
msgid "último voltaje solar"
msgstr "último voltaje solar"

#: src/utils/attributes/metricField.ts:462
msgid "último voltaje solar bruto"
msgstr "último voltaje solar bruto"

#: src/utils/attributes/metricField.ts:534
msgid "último volumen"
msgstr "último volumen"

#: src/utils/attributes/metricField.ts:18
#: src/utils/attributes/metricField.ts:24
msgid "último volumen acumulado"
msgstr "último volumen acumulado"

#: src/utils/attributes/metricField.ts:30
msgid "último volumen acumulado bruto"
msgstr "último volumen acumulado bruto"

#: src/utils/attributes/metricField.ts:144
msgid "último volumen acumulado dga"
msgstr "último volumen acumulado dga"

#: src/utils/attributes/metricField.ts:468
msgid "último volumen almacenado"
msgstr "último volumen almacenado"

#: src/utils/attributes/metricField.ts:96
msgid "último volumen calculado"
msgstr "último volumen calculado"

#: src/utils/attributes/metricField.ts:522
msgid "último volumen diario"
msgstr "último volumen diario"

#: src/utils/attributes/metricField.ts:528
msgid "último volumen horario"
msgstr "último volumen horario"

#: src/utils/attributes/metricField.ts:540
msgid "último volumen mensual"
msgstr "último volumen mensual"

#: src/utils/attributes/metricField.ts:288
msgid "último volumen original"
msgstr "último volumen original"

#: src/utils/attributes/metricField.ts:294
msgid "último volumen original bruto"
msgstr "último volumen original bruto"

#: src/utils/attributes/metricField.ts:90
msgid "último volumen total calculado"
msgstr "último volumen total calculado"

#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:92
msgid "Últimos {0} días"
msgstr "Últimos {0} días"

#: src/fsd/pages/dga-reports/ui/download-reports-dialog.tsx:93
msgid "Últimos {0} meses"
msgstr "Últimos {0} meses"

#: src/fsd/app/locale/au-labels.ts:132
msgid "Últimos {text}"
msgstr "Últimos {text}"

#: src/constants/dateTimeRangePicker.constants.ts:13
msgid "Últimos 10 días"
msgstr "Últimos 10 días"

#: src/constants/dateTimeRangePicker.constants.ts:14
msgid "Últimos 15 días"
msgstr "Últimos 15 días"

#: src/constants/dateTimeRangePicker.constants.ts:5
msgid "Últimos 15 minutos"
msgstr "Últimos 15 minutos"

#: src/constants/dateTimeRangePicker.constants.ts:11
#: src/features/gateAdministration/components/index.tsx:82
msgid "Últimos 3 días"
msgstr "Últimos 3 días"

#: src/constants/dateTimeRangePicker.constants.ts:15
#: src/features/userActivityLogs/components/UserActivityLogsModal.tsx:67
msgid "Últimos 30 días"
msgstr "Últimos 30 días"

#: src/features/gateAdministration/components/index.tsx:57
msgid "Últimos 30 minutos"
msgstr "Últimos 30 minutos"

#: src/features/gateAdministration/components/index.tsx:52
msgid "Últimos 5 minutos"
msgstr "Últimos 5 minutos"

#: src/constants/dateTimeRangePicker.constants.ts:16
msgid "Últimos 60 días"
msgstr "Últimos 60 días"

#: src/constants/dateTimeRangePicker.constants.ts:12
#: src/features/alertsConfigurationV3/components/TriggeredAlertsSummary.tsx:10
#: src/fsd/features/gate-movements/ui/list/movement-list.tsx:14
msgid "Últimos 7 días"
msgstr "Últimos 7 días"

#: src/constants/dateTimeRangePicker.constants.ts:17
msgid "Últimos 90 días"
msgstr "Últimos 90 días"

#: src/features/devicesGraveyard/components/DevicesGraveyard.tsx:244
msgid "Últimos datos"
msgstr "Últimos datos"

#: src/features/deviceProfile/components/page/events/index.tsx:177
msgid "Últimos eventos"
msgstr "Últimos eventos"

#: src/features/gateAdministration/components/MovementHistory.tsx:41
msgid "Últimos movimientos"
msgstr "Últimos movimientos"

#: src/features/metricsViews/components/widgets/movementsTable/index.tsx:218
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:357
msgid "Últimos movimientos de la compuerta"
msgstr "Últimos movimientos de la compuerta"

#: src/fsd/pages/dga-reports/ui/latest-reports.tsx:59
msgid "Últimos reportes"
msgstr "Últimos reportes"

#: src/fsd/entities/dashboard-widget/ui/dga-tickets/dga-tickets-editor.tsx:25
#: src/fsd/entities/dashboard-widget/ui/dga-tickets/dga-tickets-view.tsx:130
msgid "Últimos tickets DGA"
msgstr "Últimos tickets DGA"

#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:403
#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:484
msgid "Umbral"
msgstr "Umbral"

#: src/features/audit/components/AuditLogsTimeline.tsx:233
#: src/features/deviceProfile/components/modal/RecentActivity.tsx:36
#: src/features/deviceProfile/components/page/Audit.tsx:164
msgid "Un captiano"
msgstr "Un captiano"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:69
msgid "Un panel"
msgstr "Un panel"

#: src/fsd/pages/dashboards/ui/keyboard/shortcuts.ts:183
msgid "una sola parada para toda la grilla"
msgstr "una sola parada para toda la grilla"

#: src/fsd/pages/dashboards/ui/panel/board-scope.tsx:263
msgid "unidad"
msgstr "unidad"

#: src/components/UnitsAutocomplete.tsx:68
#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:172
#: src/features/alertsConfigurationV3/components/wizard/steps/ConditionsStep.tsx:179
#: src/features/metricsViews/components/forms/AllocationPerformanceWidgetForm.tsx:191
#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:337
#: src/features/metricsViews/components/forms/DataWidgetForm.tsx:128
#: src/features/metricsViews/components/forms/TableWidgetForm.tsx:191
#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:165
#: src/fsd/entities/dashboard-widget/ui/data/data-editor.tsx:72
#: src/fsd/entities/dashboard-widget/ui/data/data-editor.tsx:76
#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:97
msgid "Unidad"
msgstr "Unidad"

#: src/features/sma/components/forFutureUse/DialogSmaUnitSummary.tsx:127
msgid "Unidad a reportar"
msgstr "Unidad a reportar"

#: src/fsd/entities/dashboard-widget/ui/table/table-editor.tsx:101
msgid "Unidad de la columna {n}"
msgstr "Unidad de la columna {n}"

#: src/fsd/entities/dashboard-widget/ui/chart/chart-editor.tsx:169
msgid "Unidad de la serie {n}"
msgstr "Unidad de la serie {n}"

#: src/features/preferencesCommon/components/UpdatePreferredUnitsForm.tsx:326
msgid "Unidad de medida"
msgstr "Unidad de medida"

#: src/features/preferencesCommon/components/UpdatePreferredUnitsForm.tsx:161
msgid "Unidad de medida y precisión"
msgstr "Unidad de medida y precisión"

#: src/features/preferencesCommon/components/UpdateVisibleUnitsForm.tsx:149
msgid "Unidades no visibles"
msgstr "Unidades no visibles"

#: src/features/userPreferences/hooks/useTabs.tsx:35
msgid "Unidades preferidas"
msgstr "Unidades preferidas"

#: src/features/organizationPreferences/hooks/useTabs.tsx:17
#: src/features/preferencesCommon/components/UpdateVisibleUnitsForm.tsx:145
#: src/features/userPreferences/hooks/useTabs.tsx:49
msgid "Unidades visibles"
msgstr "Unidades visibles"

#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-editor.tsx:20
#: src/fsd/pages/widget-catalog/model/examples.ts:341
msgid "Uno"
msgstr "Uno"

#: src/fsd/pages/widget-catalog/model/examples.ts:459
msgid "Uno solo"
msgstr "Uno solo"

#: src/features/metricsViews/components/forms/ButtonWidgetForm.tsx:50
msgid "Url"
msgstr "Url"

#: src/fsd/entities/dashboard-widget/ui/button/button-editor.tsx:38
msgid "URL"
msgstr "URL"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:147
#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:64
msgid "URL copiada correctamente"
msgstr "URL copiada correctamente"

#: src/features/audit/utils/parseProperty.ts:43
msgid "URL de Google Drive"
msgstr "URL de Google Drive"

#: src/features/deviceConfiguration/data/sectionFields.ts:9
#: src/features/deviceConfiguration/data/sectionInputs.ts:17
msgid "URL Google Drive"
msgstr "URL Google Drive"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:24
#: src/fsd/pages/widget-catalog/model/examples.ts:411
msgid "URL inválida"
msgstr "URL inválida"

#: src/fsd/entities/dashboard-widget/ui/button/button-editor.tsx:41
msgid "Usa una dirección http, https, mailto o una ruta que empiece con /."
msgstr "Usa una dirección http, https, mailto o una ruta que empiece con /."

#: src/features/metricsViews/components/AssociateCollectionModal.tsx:262
msgid "Usan dispositivos que salen, así que no van a poder mostrar datos y la vista no se va a poder guardar hasta que se saquen o el dispositivo vuelva a la colección."
msgstr "Usan dispositivos que salen, así que no van a poder mostrar datos y la vista no se va a poder guardar hasta que se saquen o el dispositivo vuelva a la colección."

#: src/features/metricsViews/components/forms/OperationalStatesForm.tsx:31
msgid "Usar todos los dispositivos"
msgstr "Usar todos los dispositivos"

#: src/features/audit/utils/getDisplayNameEntity.ts:7
msgid "usuario"
msgstr "usuario"

#: src/features/deviceCommands/components/DeviceCommandsHistoryTable.tsx:32
#: src/features/events/components/HeaderTable.tsx:38
#: src/features/userActivityLogs/components/UserActivityLogsModal.tsx:144
msgid "Usuario"
msgstr "Usuario"

#: src/features/activateTemporaryUser/components/ActivateTemporaryUser.tsx:63
msgid "Usuario activado correctamente"
msgstr "Usuario activado correctamente"

#: src/features/userSaveModal/components/UserSaveModal.tsx:164
msgid "Usuario actualizado correctamente."
msgstr "Usuario actualizado correctamente."

#: src/features/audit/components/AuditLogsSidebar.tsx:161
msgid "Usuario afectado"
msgstr "Usuario afectado"

#: src/features/userSaveModal/components/UserSaveModal.tsx:148
msgid "Usuario creado correctamente."
msgstr "Usuario creado correctamente."

#: src/features/userProfile/components/UserProfile.tsx:124
msgid "Usuario creado el {0}"
msgstr "Usuario creado el {0}"

#: src/features/audit/utils/parseProperty.ts:8
msgid "usuario de obra DGA"
msgstr "usuario de obra DGA"

#: src/features/usersGraveyard/components/RestoreUserModal.tsx:41
msgid "Usuario desarchivado correctamente."
msgstr "Usuario desarchivado correctamente."

#: src/features/gateCommon/components/historyModal/index.tsx:283
#: src/features/metricsViews/components/widgets/movementsTable/index.tsx:166
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:140
#: src/fsd/features/gate-movements/ui/history/history-table.tsx:92
msgid "Usuario desconocido"
msgstr "Usuario desconocido"

#: src/features/userProfileUpdate/components/DisableUserModal.tsx:31
msgid "Usuario deshabilitado correctamente"
msgstr "Usuario deshabilitado correctamente"

#: src/components/tooltips/UserTooltip.tsx:82
#: src/features/metricsViews/components/widgets/configuredAlerts/index.tsx:138
msgid "Usuario eliminado"
msgstr "Usuario eliminado"

#: src/features/users/components/modals/DeleteUserModal.tsx:50
msgid "Usuario eliminado correctamente"
msgstr "Usuario eliminado correctamente"

#: src/features/collections/components/modals/ManageCollectionAccessModal.tsx:112
msgid "Usuario eliminado de la colección exitosamente"
msgstr "Usuario eliminado de la colección exitosamente"

#: src/features/usersGraveyard/components/HardDeleteUserModal.tsx:74
msgid "Usuario eliminado definitivamente."
msgstr "Usuario eliminado definitivamente."

#: src/features/api/components/RowCaptaApiUser.tsx:82
msgid "Usuario inhabilitado"
msgstr "Usuario inhabilitado"

#: src/components/userNameSpan/index.tsx:44
msgid "Usuario no disponible"
msgstr "Usuario no disponible"

#: src/features/users/utils/filterOptions.ts:144
msgid "Usuario no temporal"
msgstr "Usuario no temporal"

#: src/features/audit/components/AuditLogsSidebar.tsx:127
msgid "Usuario responsable"
msgstr "Usuario responsable"

#: src/features/users/utils/filterOptions.ts:137
#: src/features/users/utils/filterOptions.ts:139
#: src/features/users/utils/filterOptions.ts:142
msgid "Usuario temporal"
msgstr "Usuario temporal"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:95
msgid "Usuario temporal <0>activo</0>"
msgstr "Usuario temporal <0>activo</0>"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:79
msgid "Usuario temporal <0>expirado</0>"
msgstr "Usuario temporal <0>expirado</0>"

#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:111
#: src/features/userProfile/components/UserProfileTemporaryUser.tsx:127
msgid "Usuario temporal <0>sin activar</0>"
msgstr "Usuario temporal <0>sin activar</0>"

#: src/features/users/components/modals/CreateTemporaryUserModal.tsx:75
msgid "Usuario temporal creado con éxito"
msgstr "Usuario temporal creado con éxito"

#: src/features/access/components/AccessView.tsx:19
#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:238
#: src/features/metricsViews/components/widgets/configuredAlerts/Table.tsx:272
#: src/features/organizationAccess/data/sections.ts:69
msgid "Usuarios"
msgstr "Usuarios"

#: src/features/deviceProfile/components/page/DGAInfo.tsx:77
msgid "Usuarios a notificar"
msgstr "Usuarios a notificar"

#: src/features/deviceConfigurationModal/components/gateTab/alarm/UpdateAlarm.tsx:44
msgid "Usuarios a notificar actualizados correctamente"
msgstr "Usuarios a notificar actualizados correctamente"

#: src/features/collections/components/modals/AddCollectionAccessModal.tsx:112
msgid "Usuarios agregados exitosamente"
msgstr "Usuarios agregados exitosamente"

#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:139
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:123
msgid "usuarios con acceso"
msgstr "usuarios con acceso"

#: src/features/deviceProfile/components/page/Permissions.tsx:46
#: src/features/homeAmaru/components/shared/UserPicker.tsx:61
msgid "Usuarios con acceso"
msgstr "Usuarios con acceso"

#: src/features/deviceAccessModal/components/deviceAccessTab/index.tsx:105
msgid "Usuarios con acceso directo al dispositivo"
msgstr "Usuarios con acceso directo al dispositivo"

#: src/features/collections/components/modals/ManageCollectionAccessModal.tsx:150
msgid "Usuarios de {0}"
msgstr "Usuarios de {0}"

#: src/features/organizationDelete/components/DeleteOrganization.tsx:40
msgid "Usuarios de API (Cognito)"
msgstr "Usuarios de API (Cognito)"

#: src/features/notifications/components/Notifications.tsx:133
msgid "Usuarios notificados"
msgstr "Usuarios notificados"

#: src/features/notifications/components/NotificationsSaveModal.tsx:68
msgid "Usuarios notificados correctamente"
msgstr "Usuarios notificados correctamente"

#: src/features/dga/components/modals/tabs/NotificationsTab.tsx:264
msgid "Usuarios notificados por correo electrónico"
msgstr "Usuarios notificados por correo electrónico"

#: src/features/homeAmaru/components/fiveColumn/CollectionCardR2.tsx:138
#: src/features/homeAmaru/components/oneColumn/CollectionCardHorizontal.tsx:122
msgid "USUARIOS Y ACCESOS"
msgstr "USUARIOS Y ACCESOS"

#: src/features/api/components/dialogs/GeneratedUserApiSummary.tsx:19
msgid "Utilice los siguientes valores junto con su contraseña para acceder a la API:"
msgstr "Utilice los siguientes valores junto con su contraseña para acceder a la API:"

#: src/fsd/shared/ui/format/units.ts:215
#: src/utils/units.ts:272
msgid "V"
msgstr "V"

#: src/features/metricsViews/components/createViewModal/templateIdsMappers.ts:44
#: src/fsd/pages/widget-catalog/model/examples.ts:460
msgid "Vacío"
msgstr "Vacío"

#: src/fsd/pages/dga-reports/ui/report-state-labels.ts:17
msgid "Validado"
msgstr "Validado"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:44
#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:74
msgid "Validado de ayer"
msgstr "Validado de ayer"

#: src/features/devices2/components/list/itemPanel/DGAItemChart.tsx:171
#: src/features/dga/utils/chartOptions.ts:83
#: src/fsd/entities/dashboard-widget/ui/dga-reports-chart/dga-chart-option.ts:44
#: src/fsd/pages/dga-reports/ui/report-state-labels.ts:23
msgid "Validado por la DGA"
msgstr "Validado por la DGA"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:64
msgid "Validado último año"
msgstr "Validado último año"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:56
msgid "Validado últimos 3 meses"
msgstr "Validado últimos 3 meses"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:52
#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:84
msgid "Validado últimos 30 días"
msgstr "Validado últimos 30 días"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:60
msgid "Validado últimos 6 meses"
msgstr "Validado últimos 6 meses"

#: src/features/devices2/components/list/itemPanel/DGAItemStats.tsx:48
#: src/fsd/pages/dga-reports/ui/device-info-cards.tsx:79
msgid "Validado últimos 7 días"
msgstr "Validado últimos 7 días"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:96
#: src/features/billing/components/modals/ServiceFileManager.tsx:97
#: src/features/billing/components/table/ServicesTable.tsx:62
#: src/features/billing/components/table/ServicesTableForTooltip.tsx:43
#: src/features/deviceCommands/components/calendar/CustomCommandsSelector.tsx:39
#: src/features/deviceCommands/components/DeviceCommandsHistoryTable.tsx:34
#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:540
msgid "Valor"
msgstr "Valor"

#: src/fsd/app/locale/au-labels.ts:52
msgid "Valor {position}"
msgstr "Valor {position}"

#: src/features/audit/components/AuditLogDetails.tsx:87
msgid "Valor antiguo"
msgstr "Valor antiguo"

#: src/features/deviceCommands/components/custom/SendStandardCommandToDevices.tsx:57
msgid "Valor de configuración"
msgstr "Valor de configuración"

#: src/features/metricsViews/components/forms/AllocationPerformanceWidgetForm.tsx:55
msgid "Valor fijo"
msgstr "Valor fijo"

#: src/features/deviceDataConfigurationModal/utils/ratingFactory.ts:36
msgid "Valor fuera de rango"
msgstr "Valor fuera de rango"

#: src/features/billing/components/administration/SpiderChart.tsx:64
#: src/features/billing/components/administration/SpiderChart.tsx:132
msgid "Valor medio"
msgstr "Valor medio"

#: src/features/audit/components/AuditLogDetails.tsx:90
msgid "Valor nuevo"
msgstr "Valor nuevo"

#: src/features/billing/components/table/OrganizationsTable.tsx:69
msgid "Valor recurrencias"
msgstr "Valor recurrencias"

#: src/features/billing/components/administration/SpiderChart.tsx:64
#: src/features/billing/components/administration/SpiderChart.tsx:149
msgid "Valor total"
msgstr "Valor total"

#: src/features/metricsViews/components/forms/AllocationPerformanceWidgetForm.tsx:56
msgid "Valor variable"
msgstr "Valor variable"

#: src/features/audit/components/AuditLogDetails.tsx:81
#: src/features/deviceCommands/components/calendar/CustomCommandsSelector.tsx:23
#: src/features/deviceCommands/components/calendar/CustomCommandsSelector.tsx:27
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:437
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:441
msgid "Variable"
msgstr "Variable"

#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/FlowModelInput.tsx:84
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/GCalculatedAngleModelInput.tsx:61
#: src/features/deviceDataConfigurationModal/components/tabs/mathModelingTab/LGFlowModelInput.tsx:89
msgid "Variables disponibles:"
msgstr "Variables disponibles:"

#: src/features/metricsViews/components/forms/DgaReportsWidgetForm.tsx:97
#: src/features/metricsViews/components/forms/GateSensorWidgetForm.tsx:84
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-editor.tsx:67
#: src/fsd/entities/dashboard-widget/ui/dga-reports/dga-reports-editor.tsx:71
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-editor.tsx:78
#: src/fsd/entities/dashboard-widget/ui/gate-sensors/gate-sensors-editor.tsx:88
msgid "Variante"
msgstr "Variante"

#: src/features/metricsViews/components/forms/ChartWidgetForm.tsx:96
msgid "Variante de grilla"
msgstr "Variante de grilla"

#: src/fsd/pages/widget-catalog/model/examples.ts:314
msgid "Varios dispositivos"
msgstr "Varios dispositivos"

#: src/features/homeAmaru/hooks/useUpdateMyCollectionForm.tsx:92
msgid "Vas a perder tu acceso a esta colección"
msgstr "Vas a perder tu acceso a esta colección"

#: src/fsd/shared/ui/format/units.ts:206
#: src/utils/units.ts:263
msgid "vatio"
msgstr "vatio"

#: src/fsd/shared/ui/format/units.ts:211
#: src/utils/units.ts:268
msgid "vatio por metro cuadrado"
msgstr "vatio por metro cuadrado"

#: src/features/audit/utils/parseProperty.ts:143
msgid "vatios"
msgstr "vatios"

#: src/utils/attributes/metricField.ts:509
msgid "velocidad"
msgstr "velocidad"

#: src/features/alertsConfigurationV2/components/AlertsConfigurationV2.tsx:97
#: src/features/deviceProfile/components/page/modularComponents/SensorizationTab.tsx:343
#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:51
#: src/features/devicesAnalysis/components/panel/Chart.tsx:326
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:134
#: src/features/reports/utils/metricHelpers.ts:37
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:10
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:55
#: src/utils/attributes/deviceAlertMetricName.ts:72
#: src/utils/i18n/getMetricDisplayName.ts:13
msgid "Velocidad"
msgstr "Velocidad"

#: src/utils/attributes/metricField.ts:515
msgid "velocidad bruta"
msgstr "velocidad bruta"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:326
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:110
msgid "Velocidad bruta"
msgstr "Velocidad bruta"

#: src/utils/attributes/metricField.ts:191
msgid "velocidad doppler"
msgstr "velocidad doppler"

#: src/utils/i18n/getMetricDisplayName.ts:14
msgid "Velocidad Doppler"
msgstr "Velocidad Doppler"

#: src/utils/attributes/metricField.ts:197
msgid "velocidad doppler bruta"
msgstr "velocidad doppler bruta"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:46
#: src/features/devicesAnalysis/components/panel/Chart.tsx:321
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarTelemetryCheckboxList.tsx:121
msgid "Velocidad superficial"
msgstr "Velocidad superficial"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:323
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarAdvancedCheckboxList.tsx:97
msgid "Velocidad superficial bruta"
msgstr "Velocidad superficial bruta"

#: src/features/moveGateModal/hooks/useMoveGate.ts:59
#: src/fsd/entities/gate/model/command-feedback.ts:97
msgid "vence el {0}"
msgstr "vence el {0}"

#: src/features/gateCommon/utils/gateMovementState.tsx:195
#: src/fsd/entities/gate/model/movement-state.ts:111
msgid "Vence el {expiresOn}."
msgstr "Vence el {expiresOn}."

#: src/features/advancedDevicesAnalysis/components/IntervalsConfiguration.tsx:244
msgid "Ventana de agregación"
msgstr "Ventana de agregación"

#: src/features/metricsViews/components/forms/TrendSummaryForm.tsx:108
msgid "Ventana de comparación por defecto"
msgstr "Ventana de comparación por defecto"

#: src/features/metricsViews/components/forms/AllocationPerformanceWidgetForm.tsx:230
msgid "Ventanas de agregación"
msgstr "Ventanas de agregación"

#: src/features/metricsViews/components/forms/TrendSummaryForm.tsx:101
msgid "Ventanas de comparación"
msgstr "Ventanas de comparación"

#: src/features/deviceConfiguration/components/DeviceConfigurationTable.tsx:541
#: src/features/metricsViews/components/MetricsViewList.tsx:238
msgid "Ver"
msgstr "Ver"

#: src/features/alertsConfigurationV3/components/TriggeredAlertsButton.tsx:24
#: src/features/alertsConfigurationV3/components/TriggeredAlertsButton.tsx:25
msgid "Ver alertas emitidas"
msgstr "Ver alertas emitidas"

#: src/features/createDeviceConfiguration/components/common/PDFUploadField.tsx:166
msgid "Ver archivo actual"
msgstr "Ver archivo actual"

#: src/features/deviceProfile/components/modal/DeviceProfileStatus.tsx:141
msgid "Ver configuración de alertas"
msgstr "Ver configuración de alertas"

#: src/fsd/pages/dashboards/ui/layout-warnings/layout-warnings-banner.tsx:67
msgid "Ver detalle"
msgstr "Ver detalle"

#: src/features/audit/components/AuditLogsTimeline.tsx:287
msgid "Ver detalles"
msgstr "Ver detalles"

#: src/features/alertsNotificationsHistory/components/HistoryTable.tsx:423
msgid "Ver detalles de todos los usuarios"
msgstr "Ver detalles de todos los usuarios"

#: src/fsd/pages/gate-movements/ui/states/movement-not-found.tsx:27
msgid "Ver el más reciente"
msgstr "Ver el más reciente"

#: src/features/metricsViews/components/widgets/alertsTable/Table.tsx:80
msgid "Ver en alertas"
msgstr "Ver en alertas"

#: src/features/controlCenter2/components/map/index.tsx:118
msgid "Ver en análisis de estaciones"
msgstr "Ver en análisis de estaciones"

#: src/features/billing/components/administration/Filters.tsx:63
msgid "Ver en CLP"
msgstr "Ver en CLP"

#: src/features/metricsViews/components/widgets/map/GMapsButton.tsx:51
msgid "Ver en Google Maps"
msgstr "Ver en Google Maps"

#: src/features/deviceProfile/components/modal/Info.tsx:145
msgid "Ver en mapa"
msgstr "Ver en mapa"

#: src/features/metricsViews/components/MetricsView.tsx:161
msgid "Ver estilo clásico"
msgstr "Ver estilo clásico"

#: src/features/metricsViews/components/MetricsView.tsx:161
msgid "Ver estilo nuevo"
msgstr "Ver estilo nuevo"

#: src/features/devicesAnalysis/components/panel/index.tsx:69
msgid "Ver Eventos"
msgstr "Ver Eventos"

#: src/features/devicesAccessInputs/components/UsersAccessForDeviceInput.tsx:138
msgid "Ver filtros"
msgstr "Ver filtros"

#: src/features/gates/components/list/GateListItemMetrics.tsx:149
msgid "Ver gráfico aquí"
msgstr "Ver gráfico aquí"

#: src/features/deviceConfiguration/components/SummarySheetConfiguration.tsx:146
msgid "Ver historial"
msgstr "Ver historial"

#: src/features/gateCommon/components/historyModal/index.tsx:438
#: src/fsd/features/gate-movements/ui/list/gate-movements-modal.tsx:37
msgid "Ver historial de movimientos"
msgstr "Ver historial de movimientos"

#: src/features/alertsConfigurationV3/components/AlertsConfigurationV3.tsx:79
#: src/pages/alerts/index.tsx:23
#: src/pages/alertsV2/index.tsx:15
msgid "Ver histórico"
msgstr "Ver histórico"

#: src/features/deviceProfile/components/modal/Info.tsx:68
msgid "Ver imagen completa"
msgstr "Ver imagen completa"

#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:148
msgid "Ver la operación de {who}: {label}"
msgstr "Ver la operación de {who}: {label}"

#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:447
msgid "Ver lista completa"
msgstr "Ver lista completa"

#: src/fsd/pages/gate-movements/ui/panel/events/event-card.tsx:155
msgid "Ver los reportes"
msgstr "Ver los reportes"

#: src/features/deviceProfile/components/DeviceProfileModal.tsx:82
#: src/features/gateAdministration/components/gateMovementBanner/LegacyMovementRow.tsx:79
#: src/features/gateAdministration/components/gateMovementBanner/V2MovementRow.tsx:79
msgid "Ver más"
msgstr "Ver más"

#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:132
#: src/features/alertsConfigurationV3/components/AlertDetailRow.tsx:133
msgid "Ver más detalle"
msgstr "Ver más detalle"

#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:397
msgid "Ver más dispositivos"
msgstr "Ver más dispositivos"

#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:417
msgid "Ver más métricas"
msgstr "Ver más métricas"

#: src/features/deviceProfile/components/page/Audit.tsx:199
msgid "Ver más registros en auditoría"
msgstr "Ver más registros en auditoría"

#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:397
#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:417
#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:447
msgid "Ver menos"
msgstr "Ver menos"

#: src/features/metricsViews/components/widgets/gateOperate/OperateButtons.tsx:188
#: src/fsd/entities/dashboard-widget/ui/gate-operate/gate-operate-view.tsx:154
#: src/fsd/features/gate-movements/ui/operation/operation-dialog.tsx:79
msgid "Ver operación"
msgstr "Ver operación"

#: src/features/deviceMenu/components/DeviceMenu.tsx:161
msgid "Ver tabla de datos"
msgstr "Ver tabla de datos"

#: src/features/homeAmaru/components/shared/AlertsPanel.tsx:48
msgid "Ver todas las alertas"
msgstr "Ver todas las alertas"

#: src/features/gates/components/list/GateListItemLastMovement.tsx:44
#: src/features/metricsViews/components/widgets/movementsTable/index.tsx:68
#: src/fsd/entities/dashboard-widget/ui/movements-table/movements-table-view.tsx:186
msgid "Ver todos los movimientos"
msgstr "Ver todos los movimientos"

#: src/components/ColorPicker/palettes.ts:38
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:36
#: src/fsd/pages/dashboards/ui/board-color/color-names.ts:9
msgid "Verde"
msgstr "Verde"

#: src/components/ColorPicker/palettes.ts:37
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:35
msgid "Verde azulado"
msgstr "Verde azulado"

#: src/components/ColorPicker/palettes.ts:39
#: src/fsd/entities/dashboard-widget/model/color-palette.ts:37
msgid "Verde claro"
msgstr "Verde claro"

#: src/features/organizationsManagement/components/OrganizationsTable.tsx:108
msgid "Verificación de autenticación"
msgstr "Verificación de autenticación"

#: src/features/audit/utils/parseProperty.ts:122
#: src/features/audit/utils/parseProperty.ts:129
msgid "verificar autentificación"
msgstr "verificar autentificación"

#: src/features/gateCommon/utils/gateCloseCode.ts:122
#: src/fsd/entities/gate/model/close-code.ts:107
msgid "verificar la posición antes de volver a operar"
msgstr "verificar la posición antes de volver a operar"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:46
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:58
msgid "Versión 1"
msgstr "Versión 1"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:47
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:59
msgid "Versión 2"
msgstr "Versión 2"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:60
msgid "Versión 3"
msgstr "Versión 3"

#: src/features/audit/utils/parseProperty.ts:96
msgid "versión de hardware satelital"
msgstr "versión de hardware satelital"

#: src/features/audit/utils/parseProperty.ts:92
msgid "versión de imagen"
msgstr "versión de imagen"

#: src/features/deviceConfiguration/data/sectionFields.ts:231
#: src/features/deviceConfiguration/data/sectionInputs.ts:246
msgid "Versión de imagen"
msgstr "Versión de imagen"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:76
msgid "Versión de la imagen"
msgstr "Versión de la imagen"

#: src/features/audit/utils/parseProperty.ts:95
msgid "versión de software satelital"
msgstr "versión de software satelital"

#: src/features/audit/utils/parseProperty.ts:22
msgid "versión de tipo"
msgstr "versión de tipo"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:373
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:378
msgid "Versión del Filtro de Outliers"
msgstr "Versión del Filtro de Outliers"

#: src/features/deviceConfiguration/data/sectionFields.ts:437
msgid "Versión del Hardware"
msgstr "Versión del Hardware"

#: src/features/audit/utils/parseProperty.ts:141
msgid "versión del sensor"
msgstr "versión del sensor"

#: src/features/deviceConfiguration/data/sectionFields.ts:449
msgid "Versión del Software"
msgstr "Versión del Software"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:327
#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:332
msgid "Versión del Tópico"
msgstr "Versión del Tópico"

#: src/features/deviceAccessModal/components/allAccessTab/AllUsersAccessListItem.tsx:115
#: src/features/userConfigurationModal/components/allAccessTab/AllAccessListItem.tsx:112
msgid "Vía colección ({0})"
msgstr "Vía colección ({0})"

#: src/features/reports/utils/schedules.ts:17
msgid "viernes"
msgstr "viernes"

#: src/features/deviceCommands/components/calendar/DayInCalendar.tsx:119
#: src/features/dga/components/modals/controllers/DgaScheduleController.tsx:163
#: src/features/dga/components/modals/tabs/SubmissionsTab.tsx:251
#: src/features/reports/components/templateSection/CreateScheduleReportTemplateDialog.tsx:88
#: src/features/reports2/utils/schedule.ts:28
#: src/fsd/entities/dashboard-widget/model/dga-frequency.ts:17
#: src/utils/i18n/getDgaTranslations.ts:11
msgid "Viernes"
msgstr "Viernes"

#: src/utils/devices/formatSourceColor.ts:20
#: src/utils/formatSource.ts:11
msgid "Virtual"
msgstr "Virtual"

#: src/features/deviceConfigurationModal/components/publicTab/index.tsx:73
msgid "Visibilidad para el cliente"
msgstr "Visibilidad para el cliente"

#: src/features/deviceConfigurationModal/components/publicTab/index.tsx:85
msgid "Visible para el cliente"
msgstr "Visible para el cliente"

#: src/features/dashboardLayout/hooks/useSidebarItemGroups.tsx:158
msgid "Vista de Métricas"
msgstr "Vista de Métricas"

#: src/features/metricsViews/utils/quickAccessCatalog.tsx:96
#: src/fsd/entities/dashboard-widget/ui/quick-access/destinations.ts:80
msgid "Vista general de la operación"
msgstr "Vista general de la operación"

#: src/fsd/pages/widget-catalog/ui/widget-catalog-page.tsx:85
msgid "Vista previa"
msgstr "Vista previa"

#: src/features/metricsViews/components/forms/ImageWidgetForm.tsx:77
msgid "Vista previa de la imagen"
msgstr "Vista previa de la imagen"

#: src/features/billing/components/modals/PaymentsFileManager.tsx:69
msgid "Vista Previa de Pagos a Crear."
msgstr "Vista Previa de Pagos a Crear."

#: src/features/billing/components/modals/ServiceFileManager.tsx:82
msgid "Vista Previa de Servicios a Crear."
msgstr "Vista Previa de Servicios a Crear."

#: src/fsd/pages/widget-catalog/ui/preview-cell.tsx:80
msgid "Vista previa, {0} columnas por {1} filas. + y − cambian el ancho; Shift con flechas, el alto"
msgstr "Vista previa, {0} columnas por {1} filas. + y − cambian el ancho; Shift con flechas, el alto"

#: src/features/publicOrganizationSettingsModal/components/PublicOrganizationSettingsModal.tsx:62
msgid "Vista pública actualizada"
msgstr "Vista pública actualizada"

#: src/features/deviceProfile/components/page/MetricsViews.tsx:28
msgid "Vistas de métricas"
msgstr "Vistas de métricas"

#: src/features/reports2/components/createModal/steps/step5/5-Summary.tsx:384
msgid "Visualiza el resumen de los parámetros antes configurados."
msgstr "Visualiza el resumen de los parámetros antes configurados."

#: src/features/metricsViews/components/forms/DataWidgetForm.tsx:154
#: src/features/metricsViews/components/MetricsViewToolbar.tsx:207
msgid "Visualización"
msgstr "Visualización"

#: src/features/deviceDataConfigurationModal/components/tabs/ratingCurvesTab/index.tsx:296
msgid "Visualización de curvas de aforo"
msgstr "Visualización de curvas de aforo"

#: src/features/deviceDataConfigurationModal/components/tabs/filtersTab/index.tsx:511
msgid "Visualización de Filtros"
msgstr "Visualización de Filtros"

#: src/pages/metrics-views/[id].tsx:18
msgid "Visualización de métricas"
msgstr "Visualización de métricas"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:140
#: src/features/devices2/components/list/itemPanel/DGAItemInfo.tsx:145
#: src/features/organizationAccess/data/sections.ts:73
msgid "Visualización métricas"
msgstr "Visualización métricas"

#: src/features/organizationAccess/data/sections.ts:77
msgid "Visualizar dotación"
msgstr "Visualizar dotación"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:66
msgid "Vol. acum. DGA"
msgstr "Vol. acum. DGA"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:56
msgid "Vol. acumulado"
msgstr "Vol. acumulado"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:57
msgid "Vol. almacenado"
msgstr "Vol. almacenado"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:58
msgid "Vol. calculado"
msgstr "Vol. calculado"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:61
msgid "Vol. día"
msgstr "Vol. día"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:60
msgid "Vol. hora"
msgstr "Vol. hora"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:62
msgid "Vol. mes"
msgstr "Vol. mes"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:59
msgid "Vol. total calc."
msgstr "Vol. total calc."

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:84
msgid "Volt. batería"
msgstr "Volt. batería"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:85
msgid "Volt. solar"
msgstr "Volt. solar"

#: src/features/audit/utils/parseProperty.ts:160
msgid "voltaje"
msgstr "voltaje"

#: src/features/deviceConfiguration/data/sectionFields.ts:118
#: src/features/deviceConfiguration/data/sectionInputs.ts:122
msgid "Voltaje"
msgstr "Voltaje"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarEnergyCheckboxList.tsx:31
#: src/utils/i18n/getMetricDisplayName.ts:44
msgid "Voltaje batería"
msgstr "Voltaje batería"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:333
msgid "Voltaje Batería"
msgstr "Voltaje Batería"

#: src/features/audit/utils/parseProperty.ts:60
msgid "voltaje de alimentación"
msgstr "voltaje de alimentación"

#: src/features/deviceConfiguration/data/sectionInputs.ts:184
msgid "Voltaje de alimentación"
msgstr "Voltaje de alimentación"

#: src/features/audit/utils/parseProperty.ts:71
#: src/utils/attributes/metricField.ts:71
msgid "voltaje de batería"
msgstr "voltaje de batería"

#: src/features/deviceConfiguration/data/hardwareOptionsTranslations.ts:16
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:39
msgid "Voltaje de batería"
msgstr "Voltaje de batería"

#: src/utils/attributes/metricField.ts:77
msgid "voltaje de batería bruto"
msgstr "voltaje de batería bruto"

#: src/features/audit/utils/parseProperty.ts:159
msgid "voltaje del sistema"
msgstr "voltaje del sistema"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:109
msgid "Voltaje fuente"
msgstr "Voltaje fuente"

#: src/features/deviceConfiguration/data/sectionFields.ts:162
msgid "Voltaje fuente DC"
msgstr "Voltaje fuente DC"

#: src/features/devicesAnalysis/components/panel/sidebar/SidebarEnergyCheckboxList.tsx:55
msgid "Voltaje Panel"
msgstr "Voltaje Panel"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:338
msgid "Voltaje Panel Solar"
msgstr "Voltaje Panel Solar"

#: src/features/deviceProfile/components/page/modularComponents/EnergizationTab.tsx:93
msgid "Voltaje sistema"
msgstr "Voltaje sistema"

#: src/utils/attributes/metricField.ts:455
msgid "voltaje solar"
msgstr "voltaje solar"

#: src/features/controlCenter/utils/minicharts.ts:383
#: src/features/devices2/components/list/itemPanel/DeviceItemMinichart.tsx:402
#: src/features/gates/components/list/GateListItemMinichart.tsx:102
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:40
#: src/utils/i18n/getMetricDisplayName.ts:48
msgid "Voltaje solar"
msgstr "Voltaje solar"

#: src/utils/attributes/metricField.ts:461
msgid "voltaje solar bruto"
msgstr "voltaje solar bruto"

#: src/fsd/shared/ui/format/units.ts:216
#: src/utils/units.ts:273
msgid "voltio"
msgstr "voltio"

#: src/utils/attributes/metricField.ts:533
msgid "volumen"
msgstr "volumen"

#. Análisis de estaciones - Título de acordión
#: src/features/devicesAnalysis/components/panel/sidebar/index.tsx:74
msgid "Volumen"
msgstr "Volumen"

#: src/features/dga/components/modals/reports/TableModal.tsx:253
msgid "Volumen ac."
msgstr "Volumen ac."

#: src/utils/attributes/metricField.ts:17
#: src/utils/attributes/metricField.ts:23
msgid "volumen acumulado"
msgstr "volumen acumulado"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:313
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarDGACheckboxList.tsx:53
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarVolumeCheckboxList.tsx:59
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:11
#: src/fsd/pages/dga-reports/ui/measure-labels.ts:34
#: src/utils/i18n/getMetricDisplayName.ts:21
msgid "Volumen acumulado"
msgstr "Volumen acumulado"

#: src/features/reports/utils/metricHelpers.ts:9
msgid "Volumen Acumulado"
msgstr "Volumen Acumulado"

#: src/utils/attributes/metricField.ts:29
msgid "volumen acumulado bruto"
msgstr "volumen acumulado bruto"

#: src/features/metricsViews/utils/dataTypes.ts:174
msgid "volumen acumulado calculado"
msgstr "volumen acumulado calculado"

#: src/utils/attributes/metricField.ts:143
msgid "volumen acumulado dga"
msgstr "volumen acumulado dga"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:21
#: src/utils/i18n/getMetricDisplayName.ts:22
msgid "Volumen acumulado DGA"
msgstr "Volumen acumulado DGA"

#: src/features/reports/utils/metricHelpers.ts:13
msgid "Volumen Acumulado DGA"
msgstr "Volumen Acumulado DGA"

#: src/utils/attributes/metricField.ts:467
msgid "volumen almacenado"
msgstr "volumen almacenado"

#: src/features/devices2/components/list/itemPanel/DeviceItemMetrics.tsx:76
#: src/features/devicesAnalysis/components/panel/Chart.tsx:376
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarVolumeCheckboxList.tsx:31
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:12
#: src/utils/i18n/getMetricDisplayName.ts:26
msgid "Volumen almacenado"
msgstr "Volumen almacenado"

#: src/utils/attributes/metricField.ts:95
msgid "volumen calculado"
msgstr "volumen calculado"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:13
msgid "Volumen calculado"
msgstr "Volumen calculado"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:229
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarVolumeCheckboxList.tsx:109
#: src/utils/i18n/getMetricDisplayName.ts:23
msgid "Volumen día"
msgstr "Volumen día"

#: src/utils/attributes/metricField.ts:521
msgid "volumen diario"
msgstr "volumen diario"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:216
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarVolumeCheckboxList.tsx:84
#: src/utils/i18n/getMetricDisplayName.ts:24
msgid "Volumen hora"
msgstr "Volumen hora"

#: src/utils/attributes/metricField.ts:527
msgid "volumen horario"
msgstr "volumen horario"

#: src/utils/attributes/metricField.ts:539
msgid "volumen mensual"
msgstr "volumen mensual"

#: src/features/devicesAnalysis/components/panel/Chart.tsx:242
#: src/features/devicesAnalysis/components/panel/sidebar/SidebarVolumeCheckboxList.tsx:134
#: src/utils/i18n/getMetricDisplayName.ts:25
msgid "Volumen mes"
msgstr "Volumen mes"

#: src/utils/attributes/metricField.ts:287
msgid "volumen original"
msgstr "volumen original"

#: src/utils/attributes/metricField.ts:293
msgid "volumen original bruto"
msgstr "volumen original bruto"

#: src/features/reports/utils/metricHelpers.ts:44
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:16
msgid "Volumen por día"
msgstr "Volumen por día"

#: src/features/reports/utils/metricHelpers.ts:43
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:15
msgid "Volumen por hora"
msgstr "Volumen por hora"

#: src/features/reports/utils/metricHelpers.ts:45
#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:17
msgid "Volumen por mes"
msgstr "Volumen por mes"

#: src/utils/attributes/metricField.ts:89
msgid "volumen total calculado"
msgstr "volumen total calculado"

#: src/fsd/entities/dashboard-widget/ui/data/metric-labels.ts:14
msgid "Volumen total calculado"
msgstr "Volumen total calculado"

#: src/features/dga/components/modals/MassiveDGARetryModal.tsx:109
#: src/pages/gates/administration/[gateId].tsx:42
msgid "Volver"
msgstr "Volver"

#: src/features/announcements/components/AnnouncementSkeleton.tsx:13
#: src/features/announcements/components/AnnouncementView.tsx:31
#: src/features/announcements/components/AnnouncementView.tsx:42
msgid "Volver a anuncios"
msgstr "Volver a anuncios"

#: src/features/alertsNotificationsHistory/components/AlertsNotificationsHistory.tsx:55
msgid "Volver a configuraciones"
msgstr "Volver a configuraciones"

#: src/features/moveGateModal/components/OperatingState.tsx:52
#: src/fsd/entities/dashboard-widget/ui/gate-operate/move-dialog-live.tsx:100
msgid "Volver a consultar al equipo"
msgstr "Volver a consultar al equipo"

#: src/features/controlCenter2/components/devicesList/VersionSwitchFooter.tsx:42
#: src/features/controlCenter2/components/versionSwitch/WelcomeDialog.tsx:120
#: src/features/reports2/components/versionSwitch/VersionSwitchFab.tsx:57
#: src/features/reports2/components/versionSwitch/VersionSwitchFooter.tsx:40
#: src/features/reports2/components/versionSwitch/WelcomeDialog.tsx:120
msgid "Volver a la versión anterior"
msgstr "Volver a la versión anterior"

#: src/pages/AuthorizationRequired.tsx:75
msgid "Volver a Login"
msgstr "Volver a Login"

#: src/features/gateCommon/utils/gateCloseCode.ts:72
#: src/fsd/entities/gate/model/close-code.ts:57
msgid "volver a solicitar la operación"
msgstr "volver a solicitar la operación"

#: src/fsd/pages/dashboards/ui/change-bar/change-bar.tsx:233
#: src/fsd/pages/dashboards/ui/dashboard-editor-page.tsx:121
msgid "Volver a tableros"
msgstr "Volver a tableros"

#: src/features/deviceCommands/components/standard/SendStandardCommandToDevice.tsx:149
msgid "Volver atrás"
msgstr "Volver atrás"

#: src/fsd/shared/ui/format/units.ts:205
#: src/utils/units.ts:262
msgid "W"
msgstr "W"

#: src/fsd/shared/ui/format/units.ts:210
#: src/utils/units.ts:267
msgid "W/m²"
msgstr "W/m²"

#: src/features/alertsConfigurationV3/components/TriggeredAlertsSummary.tsx:45
msgid "Warning"
msgstr "Warning"

#: src/features/deviceConfiguration/data/sectionFields.ts:146
#: src/features/deviceConfiguration/data/sectionInputs.ts:160
msgid "Watts"
msgstr "Watts"

#: src/features/alertsConfiguration/components/AlertsConfiguration.tsx:101
#: src/features/alertsConfiguration/components/AlertTable.tsx:210
#: src/features/alertsConfiguration/components/DialogConfirmationNotifications.tsx:116
#: src/features/alertsConfiguration/components/DialogUsersNotifications.tsx:122
#: src/features/alertsConfigurationV2/components/AlertsConfigurationV2.tsx:109
#: src/features/alertsConfigurationV3/components/ChannelBadge.tsx:25
#: src/features/alertsConfigurationV3/components/FilterBar.tsx:47
#: src/features/alertsConfigurationV3/components/wizard/steps/NotificationsStep.tsx:27
#: src/features/alertsConfigurationV3/components/wizard/steps/SummaryStep.tsx:54
#: src/features/deviceAlertsModal/components/notificationConfigurationTab/TableForm.tsx:65
msgid "Whatsapp"
msgstr "Whatsapp"

#: src/features/alertsNotificationsHistory/utils/notificationTypes.ts:43
msgid "WhatsApp"
msgstr "WhatsApp"

#: src/features/metricsViews/components/widgetTemplates/index.tsx:182
msgid "Widgets favoritos"
msgstr "Widgets favoritos"

#: src/features/deviceProfile/components/page/modularComponents/ConnectivityTab.tsx:69
msgid "Wifi"
msgstr "Wifi"

#: src/features/homeAmaru/components/shared/WorkspaceHeader.tsx:50
msgid "Workspace AMARU"
msgstr "Workspace AMARU"

#: src/features/reports/utils/schedules.ts:38
#: src/features/reports2/utils/schedule.ts:71
msgid "y"
msgstr "y"

#: src/features/homeAmaru/components/shared/TooltipEntityList.tsx:53
msgid "y {rest} más"
msgstr "y {rest} más"

#: src/features/metricsViews/components/ExportHeader.tsx:54
#: src/features/reports2/components/createModal/steps/step2/2-TimePeriod.tsx:105
#: src/features/userPreferences/components/RegionTab.tsx:168
msgid "Zona horaria"
msgstr "Zona horaria"

#: src/features/reports/components/creationSection/FormFirstStepReportCreation.tsx:400
#: src/features/reports/components/templateSection/CreateReportFromTemplateDialog.tsx:235
msgid "Zona Horaria"
msgstr "Zona Horaria"

#: src/components/PicturePreview.tsx:70
msgid "Zoom por defecto"
msgstr "Zoom por defecto"

#: src/fsd/shared/ui/format/units.ts:255
#: src/utils/units.ts:312
msgid "µS/cm"
msgstr "µS/cm"
